import {
  Duration__minus_impl_q5cfm715b1yelrxm0ir as Duration__minus_impl_q5cfm7,
  Duration__plus_impl_yu9v8f24i74j9g7b01u as Duration__plus_impl_yu9v8f,
  Duration__compareTo_impl_pchp0f86u5y5kbz283 as Duration__compareTo_impl_pchp0f,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  Unit_instanceat14thlj150z as Unit_instance,
  Comparable198qfk8pnblz0 as Comparable,
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  VOID7hggqo3abtya as VOID,
  Duration__toString_impl_8d916b13ohvvi8wucz4 as Duration__toString_impl_8d916b,
  ValueTimeMark__elapsedNow_impl_eonqvs3jczd809bixyd as ValueTimeMark__elapsedNow_impl_eonqvs,
  Duration5ynfiptaqcrg as Duration,
  printStackTrace18lnx7a39cni as printStackTrace,
  Monotonic_instance29u86ypunv10 as Monotonic_instance,
  ArrayDeque2dzc9uld4xi7n as ArrayDeque,
  maxOfnpw4mt1rg0hl as maxOf,
  KMutableProperty025txtn5b59pq1 as KMutableProperty0,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  protoOf180f3jzyo7rfj as protoOf,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  createThis2j2avj17cvnv2 as createThis,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  Enum3alwj03lh1n41 as Enum,
  _Char___init__impl__6a9atx367vrx0avsvbg as _Char___init__impl__6a9atx,
  Companion_getInstance148flmv2wtrla as Companion_getInstance,
  toString14fd7g605f91p as toString_0,
  Char__hashCode_impl_otmys1ewos5t0dm35g as Char__hashCode_impl_otmys,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  equals2au1ep9vhcato as equals,
  toString30pk9tzaqopn as toString_1,
  hashCodeq5arwsb9dgti as hashCode,
  Exceptiondt2hlxn7j7vw as Exception,
  captureStack1fzi4aczwc4hg as captureStack,
  fillArrayVali8eppxapiek4 as fillArrayVal,
  joinToString1cxrrlmo0chqs as joinToString,
  booleanArray2jdug9b51huk7 as booleanArray,
  StringBuildermazzzhj6kkai as StringBuilder,
  ArrayList3it5z8td81qkl as ArrayList,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  emptySetcxexqki71qfa as emptySet,
  Long2qws0ah9gnpki as Long,
  isInterface3d6p8outrmvmk as isInterface,
  distinct10qe1scfdvu5k as distinct,
  compareTo3ankvs086tmwq as compareTo,
  Companion_getInstance1krakgr3yg44t as Companion_getInstance_0,
  toLongw1zpgk99d84b as toLong,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  KProperty1ca4yb4wlo496 as KProperty1,
  RuntimeException1r3t0zl97011n as RuntimeException,
  toList3jhuyej2anx2q as toList,
  listOfvhqybd2zx248 as listOf,
  LinkedHashSet2tkztfx86kyx2 as LinkedHashSet,
  HashMap1a0ld5kgwhmhv as HashMap,
  lazy2hsh8ze7j6ikd as lazy,
  numberToLong1a4cndvg6c52s as numberToLong,
  println2shhhgwwt4c61 as println,
  isByteArray4nnzfn1x4o3w as isByteArray,
  isFloatArrayjjscnqphw92j as isFloatArray,
  isIntArrayeijsubfngq38 as isIntArray,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  listOf1jh22dvmctj1r as listOf_0,
  Triple1vhi3d0dgpnjb as Triple,
  stackTraceToString2670q6lbhdojj as stackTraceToString,
  last1vo29oleiqj36 as last,
  Regexxgw0gjiagf4z as Regex,
  replace3le3ie7l9k8aq as replace,
  isCharSequence1ju9jr1w86plq as isCharSequence,
  trim11nh7r46at6sx as trim,
  toIntOrNull3w2d066r9pvwm as toIntOrNull,
  getKClassFromExpression3vpejubogshaw as getKClassFromExpression,
  getOrNull1go7ef9ldk0df as getOrNull,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  Comparator2b3maoeh98xtg as Comparator,
  compareValues1n2ayl87ihzfk as compareValues,
  sortedWith2csnbbb21k0lg as sortedWith,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  emptyList1g2z5xcrvp2zy as emptyList,
  reversed22y3au42jl32b as reversed,
  HashSet2dzve9y63nf0v as HashSet,
  plus310ted5e4i90h as plus,
  joinToStringxqcavsxcmh4q as joinToString_0,
  contains2el4s70rdq4ld as contains,
  maxOrNull2e5ok5wkly1cp as maxOrNull,
  Iterable1y3qizuf89iou as Iterable,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
  contentEqualsaf55p28mnw74 as contentEquals,
  contentHashCode2i020q5tbeh2s as contentHashCode,
  toList383f556t1dixk as toList_0,
  to2cs3ny02qtbcb as to,
  boxApply1qmzdb3dh90hg as boxApply,
  plus1ogy4liedzq5j as plus_0,
  withIndex37cl61h9v5txo as withIndex,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  Char__toInt_impl_vasixd17daqndsyg0ov as Char__toInt_impl_vasixd,
  toByte4i43936u611k as toByte,
  numberToChar93r9buh19yek as numberToChar,
  until1jbpn0z3f8lbg as until,
  toSet2orjxp16sotqu as toSet,
  split2bvyvnrlcifjv as split,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  numberToDouble210hrknaofnhf as numberToDouble,
  get_indicesc04v40g017hw as get_indices,
  anyToString3ho3k49fc56mj as anyToString,
  DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm as DurationUnit_MILLISECONDS_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
  copyToArray2j022khrow2yi as copyToArray,
  startsWith1bgirhbedtv2y as startsWith,
  isBlank1dvkhjjvox3p0 as isBlank,
  charArrayOf27f4r3dozbrk1 as charArrayOf,
  split3d3yeauc4rm2n as split_0,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  toShort36kaw0zjdq3ex as toShort,
  contains1tccixv8iwdcq as contains_0,
  EmptyCoroutineContext_getInstance7yleecrz3jzr as EmptyCoroutineContext_getInstance,
  round2mrvepag8eey0 as round,
  coerceAtLeastklytehohcpeq as coerceAtLeast_0,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  mapOf1xd03cq9cnmy8 as mapOf,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  ObservableProperty3aw08lidjfpjm as ObservableProperty,
  Delegates_instance3jf2rsvdhmxzn as Delegates_instance,
  DurationUnit_MICROSECONDS_getInstance3qb7b7owxf6lo as DurationUnit_MICROSECONDS_getInstance,
  Duration__times_impl_sfuzvp2zkq9ykxbil7d as Duration__times_impl_sfuzvp,
  get6d5x931vk0s as get,
  fold36i9psb7d5v48 as fold,
  minusKeyyqanvso9aovh as minusKey,
  plusolev77jfy5r9 as plus_1,
  Element2gr7ezmxqaln7 as Element,
  Companion_instance144r68bk89en4 as Companion_instance,
  _Result___init__impl__xyqfz8oelep8i0cbta as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance,
  toDurationba1nlt78o6vu as toDuration_0,
  PrimitiveClasses_getInstanceeand5azd2sul as PrimitiveClasses_getInstance,
  arrayOf1akklvh2at202 as arrayOf,
  createKType1lgox3mzhchp5 as createKType,
  createInvariantKTypeProjection3sfd0u0y62ozd as createInvariantKTypeProjection,
  getKClass1s3j9wy1cofik as getKClass,
  Unitkvevlwgzwiuc as Unit,
  encodeToByteArray1onwao0uakjfh as encodeToByteArray,
  KProperty02ce7r476m8633 as KProperty0,
  toSet1glep2u1u9tcb as toSet_0,
  reversednxqwdkac9dn0 as reversed_0,
  toMutableListoiy7juhbnlr7 as toMutableList,
  removeSuffix3d61x5lsuvuho as removeSuffix,
  isInfinite12nl8hpz1hbp2 as isInfinite,
  isNaNymqb93xtq8w8 as isNaN_0,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Console_getInstance8lqb2pbph5yn as Console_getInstance,
  Companion_getInstance3qvmjlq9y5ia6 as Companion_getInstance_1,
  Level_INFO_getInstance3huxkjtm54h8u as Level_INFO_getInstance,
  Level_ERROR_getInstance18552yzhsfztk as Level_ERROR_getInstance,
  Level_TRACE_getInstance1ni95vo21pald as Level_TRACE_getInstance,
  Level_DEBUG_getInstancewzibhbcrmy7h as Level_DEBUG_getInstance,
  valueOf3aj0dpb8xpu5n as valueOf,
  Level_WARN_getInstance2cg04z8rod8ga as Level_WARN_getInstance,
} from './korlibs-logger-root-korlibs-logger.mjs';
import {
  SyncPauseable20rt0nt3umu2s as SyncPauseable,
  Companion_instance2r8kc48nhvjcq as Companion_instance_0,
  FastIdentityMap17d14y8i3m5g7 as FastIdentityMap,
  get2pw1zlgv5zypd as get_0,
  set2vuztm9k7ubgo as set,
  FastIntMapl0pzyavg6uw5 as FastIntMap,
  IntArrayList3liuagbdnwmna as IntArrayList,
  Ref11k43t82thcp3 as Ref,
  FastStringMap1l1uzdhsfbatm as FastStringMap,
  linkedHashMapOf2w2uhgrq4khrk as linkedHashMapOf,
  toIntMapp1jij98esrcm as toIntMap,
  IntMap2d9g6f5pyaoc2 as IntMap,
  Pool1zbsw0zhvh8ca as Pool,
  containsrsn76oa0puwr as contains_1,
  clear3idbm40uzyume as clear,
  get_size2tttv7g2u748n as get_size,
  FastSmallSet2og2j8v2pz4c7 as FastSmallSet,
  getAndRemove1ksxnnren48mb as getAndRemove,
  get_keyswqddktl7cnu2 as get_keys,
  ReturnablePool3rkgvxsckx2u2 as ReturnablePool,
  TGenQueue2v9j3ju90xgpv as TGenQueue,
} from './korlibs-datastructure-root-korlibs-datastructure.mjs';
import {
  Lock5n7hh3dgcidl as Lock,
  Signal3nnez3346azzf as Signal,
  invoke2sf88d1xeuyqh as invoke,
  NonRecursiveLock2vf7fkhp857q as NonRecursiveLock,
} from './korlibs-concurrent-root-korlibs-concurrent.mjs';
import {
  cancel1amaozv14ic7s as cancel,
  CloseableCancellable3mxnqaxyfppmn as CloseableCancellable,
  CancellableGroup3e8z70ga3djg as CancellableGroup,
  get_unreachable2fi7msfg0vgzd as get_unreachable,
  unsupported198cz39rr1ztw as unsupported,
  Companion_instance1mbrm9vk5fsmd as Companion_instance_1,
  get_portableSimpleName6o7s8nc63i85 as get_portableSimpleName,
  Companion_getInstance39o54489czp6d as Companion_getInstance_2,
  Os_UNKNOWN_getInstancecnx3cm3i6e2g as Os_UNKNOWN_getInstance,
  invalidOp1stebxh2m3n07 as invalidOp,
  get_invalidOp31x7cztl0dv9m as get_invalidOp,
  Companion_getInstancegk7jn4e7je7g as Companion_getInstance_3,
  DenoPointerpb0vypijx63v as DenoPointer,
  get_pointerlkbwhoqlhapz as get_pointer,
  get_jsGlobalThis3odmbn60utci as get_jsGlobalThis,
} from './korlibs-platform-root-korlibs-platform.mjs';
import {
  FastArrayListw5fr1wlp4slq as FastArrayList,
  toFastList1btvvxvv57pw as toFastList,
  Mixin3lmkm5hum2vdj as Mixin,
  fastArrayListOf1rdodhrpn0q8y as fastArrayListOf,
  setExtra314k0z6q35eku as setExtra,
  getExtraTyped8zexqxz5xxli as getExtraTyped,
  PropertyThis2r0hbk1cs09wj as PropertyThis,
  toFastListzo2jtkrx0z5y as toFastList_0,
} from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
import {
  Companion_getInstancewdpvtc2ehxkt as Companion_getInstance_4,
  RectangleInt3lmu13ytuf5lk as RectangleInt,
  Companion_getInstance1bdwtq6rroayu as Companion_getInstance_5,
  Vector2D378fe5rov8fgw as Vector2D,
  BoundsBuilder__plus_impl_cz7f7xocbq7jeozma3 as BoundsBuilder__plus_impl_cz7f7x,
  Size2Dum5ayuyhhau7 as Size2D,
  Companion_getInstance3qti4zygy7usz as Companion_getInstance_6,
  Companion_getInstance1zxby1ngivg0d as Companion_getInstance_7,
  MatrixTransform1wlsrhxt7473v as MatrixTransform,
  get_scale17gmsnxnqj6j9 as get_scale,
  Matrix43neeu8v4zk4i7 as Matrix4,
  orthow9c0o91bw54n as ortho,
  SizeInte6w85oa6mz6v as SizeInt,
  Companion_instanceu31qrc8c1r0r as Companion_instance_2,
  get_degrees3czcd4ojw4i as get_degrees,
  Angle__times_impl_v3s9y21yznxo5bj1uj7 as Angle__times_impl_v3s9y2,
  Angle2itorpob18n08 as Angle,
} from './korlibs-math-vector-root-korlibs-math-vector.mjs';
import {
  Companion_getInstance36wz4kh9aujgq as Companion_getInstance_8,
  DateTime__hashCode_impl_yf0bc92s64omsn0fynv as DateTime__hashCode_impl_yf0bc9,
  _FastDuration___get_fastNanoseconds__impl__9kjwbr3nvm3csqkttdd as _FastDuration___get_fastNanoseconds__impl__9kjwbr,
  get_fastNanosecondsibv7lnrlu50o as get_fastNanoseconds,
  _FastDuration___get_fastMilliseconds__impl__pe68va81p5t8ucvnk8 as _FastDuration___get_fastMilliseconds__impl__pe68va,
  get_fastMillisecondsfxaeyfzoedsj as get_fastMilliseconds,
  FastDuration__minus_impl_evs237rhg84spop2c8 as FastDuration__minus_impl_evs237,
  FastDuration__compareTo_impl_4fhnj72c084ut3ho50d as FastDuration__compareTo_impl_4fhnj7,
  Companion_instance293l0r179rei7 as Companion_instance_3,
  get_fastNanoseconds1laeiegsk8vcx as get_fastNanoseconds_0,
  FastDuration__plus_impl_q1enab1plpz0e6mgxzj as FastDuration__plus_impl_q1enab,
  toDuration15w5sljvx2ut2 as toDuration_1,
  FastDuration__hashCode_impl_y13la6nym0c1xbwjaa as FastDuration__hashCode_impl_y13la6,
  get_fastMicroseconds3xewe49ldi5s as get_fastMicroseconds,
  FastDuration__minus_impl_evs237bt7zqxxnwet as FastDuration__minus_impl_evs237_0,
  FastDuration3d3pupg2e5ora as FastDuration,
  minus2npwq73u0d9yx as minus,
  max1q2oylvn6uire as max,
  get_fastMilliseconds2pmoifl74b2oz as get_fastMilliseconds_0,
  FastDuration__plus_impl_q1enab30y5opwsu5po5 as FastDuration__plus_impl_q1enab_0,
  get_fast37cu8s8qwnuyi as get_fast,
  roundMilliseconds3bd2pntxev66o as roundMilliseconds,
  FastDuration__toString_impl_c9xohb3u75ye94mx1dw as FastDuration__toString_impl_c9xohb,
  get_milliseconds20vru1dkca6bq as get_milliseconds,
} from './korlibs-time-root-korlibs-time-core.mjs';
import {
  arraycopy52dxe7vhzf14 as arraycopy,
  clonelcrqoxe4ne5i as clone,
  Companion_instancejzamqjlqqs4y as Companion_instance_4,
  _Int8Buffer___init__impl__e20lvcp4p2uvfo996c as _Int8Buffer___init__impl__e20lvc,
  _Int8Buffer___get_buffer__impl__q0gulbq12sgwh1jcvh as _Int8Buffer___get_buffer__impl__q0gulb,
  sliceWithSize2i7i6olf26byj as sliceWithSize,
  Companion_getInstance35xii7iw9kdg2 as Companion_getInstance_9,
  ByteUnits__toString_impl_ox2ku22zb4xrvk9phl9 as ByteUnits__toString_impl_ox2ku2,
  arraycopy3uxsqjlixmnz3 as arraycopy_0,
  Buffer25z94vsj0kb1s as Buffer,
  get_i323p4hlz6j3xys8 as get_i32,
  arraycopy1hsh296f5d0xg as arraycopy_1,
  get_f3218rglfhpgbhzp as get_f32,
  arraycopy3fi6tr79d693r as arraycopy_2,
  get_i83qhdj74rhdyeg as get_i8,
  arraycopyphzg5lpa6gvz as arraycopy_3,
  get_size13scmefs6mbfn as get_size_0,
  allocDirecttfrgytwudkpf as allocDirect,
  sliceBufferpiate0wictoq as sliceBuffer,
  arrayequal25g4om83vd8w1 as arrayequal,
  getS8Array37elyr0qhrpi8 as getS8Array,
  getF32Array3bpq574bgh35w as getF32Array,
  getS32Array38egwts6rsd12 as getS32Array,
  copyOfnqvdm0sc8lk as copyOf,
  setArrayLEwil75hzlfusu as setArrayLE,
  setInt32178h074gei71f as setInt32,
  getInt32gmg3zyw00v1v as getInt32,
  arraycopy9a0yzbjqwnvw as arraycopy_4,
  Uint16Buffer__set_impl_g0kliu1ltqm2yo4vfb6 as Uint16Buffer__set_impl_g0kliu,
  Float32Buffer__get_impl_659lhu2fcy7ilfo0o6g as Float32Buffer__get_impl_659lhu,
  Float32Buffer__set_impl_34sznedf8x821xo8e0 as Float32Buffer__set_impl_34szne,
  get_u163bxpdbbave1v5 as get_u16,
  setFloat323e0ukqyly1ufv as setFloat32,
  asUShortArrayInt2gfk0h9rafip5 as asUShortArrayInt,
  arraycopy28e1us87mwypg as arraycopy_5,
  arrayadd3erpr00t9k8j as arrayadd,
  arraycopyqmyo4vjwforw as arraycopy_6,
  arrayfill1njpugsfcm512 as arrayfill,
  arrayfill2iqmyqqqfwuaf as arrayfill_0,
  allocNoDirect3dykranmovqsj as allocNoDirect,
  get_arrayUByte9swx7ogt2hf2 as get_arrayUByte,
  get_arrayInt3v8kuk47rixtz as get_arrayInt,
  get_arrayFloat1r0vk858s9phl as get_arrayFloat,
} from './korlibs-memory-root-korlibs-memory.mjs';
import {
  get_niceStr1tlwtz2l2j4my as get_niceStr,
  get_isPowerOfTwoeb2yxu9ww0f7 as get_isPowerOfTwo,
  extract2vhru1ihy4ogl as extract,
  insert52qor1kqho1lpj as insert5,
  insert22yqrzxcpmo55e as insert2,
  insert2fz5125p2hdyd as insert,
  insert42sy0xc4ax89g9 as insert4,
  toShortClampedqjuvod9w2qhj as toShortClamped,
  toIntRound1mv0y8x9hh1p4 as toIntRound,
  toIntRoundjnzmk86x1qp5 as toIntRound_0,
  get_low2kdkn3173rx8r as get_low,
  get_high3vl4k4kkorqlu as get_high,
  insert141hi307uxchfzk as insert14,
  ilog23dbvpk38jf7rc as ilog2,
  insert8f3zk23r8x9da as insert8,
  insert32d422lnha9g5r as insert3,
  extractScaledf013fj6eqsu4szwo as extractScaledf01,
  insertScaledf01oj6k04gavkch as insertScaledf01,
  insertm9bp9ll4cml3 as insert_0,
  min1z074tc6jeruz as min,
  max1izmzj76cv5b4 as max_0,
  nextMultipleOf14oge7vxqp9sy as nextMultipleOf,
  nextAlignedTo2788hp7lcoqp as nextAlignedTo,
  setBitsqsmqq5kc486j as setBits,
  Companion_getInstance2tun2u13u8fzr as Companion_getInstance_10,
  _Ratio___init__impl__9mwvn224skkn3fz6cfs as _Ratio___init__impl__9mwvn2,
  Ratio136tf4z2t0p2d as Ratio,
  interpolate2g7wzskc23f1q as interpolate,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
import {
  NullBitmap15b22oyta4usb as NullBitmap,
  MultiBitmapk0zsv2zy1mpk as MultiBitmap,
  ForcedTexId3ivekmtdm8t3u as ForcedTexId,
  RGBA__toString_impl_4lw6dp2tumn1mea41fm as RGBA__toString_impl_4lw6dp,
  RGBA__hashCode_impl_h59qf629uhw1oxrapg6 as RGBA__hashCode_impl_h59qf6,
  FloatBitmap321fufbxi3ys0iu as FloatBitmap32,
  Bitmap82ekc5d8xpcfp2 as Bitmap8,
  NativeImagebqxh3nwkmck as NativeImage,
  _RGBA___get_rf__impl__kvz75k2enjmg3zrtnq3 as _RGBA___get_rf__impl__kvz75k,
  _RGBA___get_gf__impl__5gcu1f1tcfjj6a92jd8 as _RGBA___get_gf__impl__5gcu1f,
  _RGBA___get_bf__impl__1xz5yg37iolmxbb8ro0 as _RGBA___get_bf__impl__1xz5yg,
  _RGBA___get_af__impl__vu36qv3fdqajvftucv7 as _RGBA___get_af__impl__vu36qv,
  Bitmap321klycakvwgb5w as Bitmap32,
  _RgbaArray___init__impl__oib4y4249bb2a5xbrxx as _RgbaArray___init__impl__oib4y4,
  _RGBAPremultiplied___get_rf__impl__pt0c4yud4u7tot9j6v as _RGBAPremultiplied___get_rf__impl__pt0c4y,
  _RGBAPremultiplied___get_gf__impl__ivron7124n55fu7nftq as _RGBAPremultiplied___get_gf__impl__ivron7,
  _RGBAPremultiplied___get_bf__impl__qa3on231tqs9tgl21ni as _RGBAPremultiplied___get_bf__impl__qa3on2,
  _RGBAPremultiplied___get_af__impl__euwcjn2miyh1t3zubgx as _RGBAPremultiplied___get_af__impl__euwcjn,
  Colors_getInstance2cnv7p5d6jz4u as Colors_getInstance,
  Companion_instance1sgltfeqg9bxt as Companion_instance_5,
  ImageDecodingProps12g4gdsvb3zm5 as ImageDecodingProps,
  readBitmap1yhww5yoq3a9l as readBitmap,
  slice2pfxfvku0ybgy as slice,
  Companion_instance1zw3l6m7tnvps as Companion_instance_6,
  Glyphdz1l7rusab9h as Glyph,
  BitmapFontImpljoxrxbqjo5ee as BitmapFontImpl,
  get_baseMipmapLevel1ty2cgb5p9xw4 as get_baseMipmapLevel,
  get_maxMipmapLevel13juf70j6ney9 as get_maxMipmapLevel,
  _RGBA___get_value__impl__hhco8vehpblbe3f2y8 as _RGBA___get_value__impl__hhco8v,
  RGBA34obx2i62wcl3 as RGBA,
  HtmlNativeImagenz79853f60h as HtmlNativeImage,
  toHtmlNative1zcg9na83p2te as toHtmlNative,
} from './korlibs-image-root-korlibs-image.mjs';
import {
  get_hex32p4ssq0y1xxx as get_hex,
  fromBase6434uveajlhn2ar as fromBase64,
} from './korlibs-encoding-root-korlibs-encoding.mjs';
import {
  atomic$int$11d5swdyn6j0pu as atomic$int$1,
  atomic$ref$130aurmcwdfdf1 as atomic$ref$1,
} from './kotlinx-atomicfu.mjs';
import {
  Companion_getInstance2vt0vokm4ixbh as Companion_getInstance_11,
  Indenterdf10c5coibyi as Indenter,
  MountableVfs3mmbka3zq5l6i as MountableVfs,
  get_resourcesVfs3qrvup7jpy9uc as get_resourcesVfs,
  launchImmediatelylnv8lnistpdy as launchImmediately,
  delay2vwv568c245r8 as delay,
  toVfsr7ir4p66g1my as toVfs,
  launchImmediately11za8mkid9pxu as launchImmediately_0,
} from './korlibs-io-root-korlibs-io.mjs';
import {
  DisposableHandle1uzxt8frdchxn as DisposableHandle,
  delay1blitpytzu6gr as delay_0,
  CoroutineName2g5zosw74tf0f as CoroutineName,
  cancelChildrennwartoz0yn6c as cancelChildren,
  CoroutineDispatcherizb7p9bijexj as CoroutineDispatcher,
  Delay9umexudtwyie as Delay,
  cancelAndJoin2j6ktsickm6hy as cancelAndJoin,
  MainScope1gi1r4abhrtmm as MainScope,
} from './kotlinx-coroutines-core.mjs';
import {
  get_immutablepxpdoj6e54ll as get_immutable,
  Companion_instance2i0t7ux7bzoqc as Companion_instance_7,
  RectSlicec5msorw5q4el as RectSlice,
  Companion_getInstance154uzbkgf0e3s as Companion_getInstance_12,
  toMatrix42ci5k1es0x1v1 as toMatrix4,
  MMatrix1y71lv7vv6y8t as MMatrix,
} from './korlibs-math-root-korlibs-math.mjs';
import { openAsync37anb1e84urmo as openAsync } from './korlibs-io-stream-root-korlibs-io-stream.mjs';
import { InjectorDependency2f8dsqe1kn3nn as InjectorDependency } from './korlibs-inject-root-korlibs-inject.mjs';
import {
  IntTimedCache39ymx9abjz88x as IntTimedCache,
  PerformanceCounter_getInstance3b8d94s1bsc37 as PerformanceCounter_getInstance,
  Stopwatch1guqi4xl0rpfb as Stopwatch,
} from './korlibs-time-root-korlibs-time.mjs';
import {
  FFILiby83bova0zjfy as FFILib,
  Companion_getInstance2ww1whxsubyyu as Companion_getInstance_13,
  FuncInfocud0a7bce10z as FuncInfo,
  CreateFFIPointernsr7ilwulbub as CreateFFIPointer,
  get_pointer2afz2rc14joly as get_pointer_0,
  CreateFFIMemoryv82e6jbfcdze as CreateFFIMemory,
  set3216gyp8r69gas8 as set32,
  CreateFFIMemory2iekizxdvtyvt as CreateFFIMemory_0,
  setFFIPointerjzarmbova4sm as setFFIPointer,
  getS32284qh8a5ldxzn as getS32,
} from './korlibs-ffi-root-korlibs-ffi-legacy.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
class TimedTask {
  constructor(eventLoop, now, time, interval, callback) {
    this.x6j_1 = eventLoop;
    this.y6j_1 = now;
    this.z6j_1 = time;
    this.a6k_1 = interval;
    this.b6k_1 = callback;
  }
  c6k(value) {
    this.y6j_1 = Duration__minus_impl_q5cfm7(value, this.z6j_1);
  }
  d6k() {
    return Duration__plus_impl_yu9v8f(this.y6j_1, this.z6j_1);
  }
  e6k(other) {
    return Duration__compareTo_impl_pchp0f(this.d6k(), other.d6k());
  }
  d(other) {
    return this.e6k(other instanceof TimedTask ? other : THROW_CCE());
  }
  t6() {
    this.a6k_1 = false;
    this.x6j_1.o6k_1.k2u(this);
  }
}
class BaseEventLoop {
  constructor() {
    this.x6k_1 = new Lock();
  }
}
class SyncEventLoop extends BaseEventLoop {
  constructor(immediateRun) {
    immediateRun = immediateRun === VOID ? false : immediateRun;
    super();
    this.g6k_1 = immediateRun;
    this.h6k_1 = new SyncPauseable();
    this.i6k_1 = paused$factory(this.h6k_1);
    this.j6k_1 = new Lock();
    this.k6k_1 = true;
    this.l6k_1 = Monotonic_instance.rj();
    var tmp = this;
    tmp.m6k_1 = SyncEventLoop$nowProvider$lambda(this);
    this.n6k_1 = ArrayDeque.wk();
    var tmp_0 = this;
    var tmp_1 = Companion_instance_0;
    tmp_0.o6k_1 = tmp_1.n2y(VOID, SyncEventLoop$timedTasks$lambda);
    var tmp_2 = this;
    tmp_2.p6k_1 = SyncEventLoop$uncatchedExceptionHandler$lambda;
    this.q6k_1 = null;
  }
  r6k(task) {
    // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
    var this_0 = this.j6k_1;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
      this_0.b20();
      try {
        this.n6k_1.al(task);
        this.j6k_1.f20();
        break $l$block;
      }finally {
        this_0.d20();
      }
    }
  }
  s6k(time, task) {
    return _queueAfter(this, time, false, task);
  }
  t6() {
    var oldImmediateRun = this.g6k_1;
    try {
      this.g6k_1 = true;
      this.t6k();
      this.k6k_1 = false;
    }finally {
      this.g6k_1 = oldImmediateRun;
    }
  }
  u6k(task) {
    if (this.g6k_1)
      return true;
    return Duration__compareTo_impl_pchp0f(_get_now__e6dlkr(this), this.o6k_1.t2y().d6k()) >= 0;
  }
  v6k(runTimers) {
    var count = 0;
    while (this.w6k(runTimers)) {
      count = count + 1 | 0;
    }
    return count;
  }
  t6k(runTimers, $super) {
    runTimers = runTimers === VOID ? true : runTimers;
    return $super === VOID ? this.v6k(runTimers) : $super.v6k.call(this, runTimers);
  }
  w6k(runTimers) {
    // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
    var this_0 = this.j6k_1;
    var tmp$ret$2;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
      this_0.b20();
      try {
        // Inline function 'korlibs.datastructure.event.SyncEventLoop.runAvailableNextTask.<anonymous>' call
        var tmp;
        if (runTimers) {
          var tmp_0;
          var tmp_1;
          // Inline function 'kotlin.collections.isNotEmpty' call
          if (!this.o6k_1.g1()) {
            tmp_1 = this.u6k(this.o6k_1.t2y());
          } else {
            tmp_1 = false;
          }
          if (tmp_1) {
            tmp_0 = this.o6k_1.u2y();
          } else {
            tmp_0 = null;
          }
          tmp = tmp_0;
        } else {
          tmp = null;
        }
        tmp$ret$2 = tmp;
        break $l$block;
      }finally {
        this_0.d20();
      }
    }
    var timedTask = tmp$ret$2;
    if (!(timedTask == null)) {
      // Inline function 'korlibs.datastructure.event.SyncEventLoop.runCatchingExceptions' call
      try {
        // Inline function 'kotlin.run' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.datastructure.event.SyncEventLoop.runAvailableNextTask.<anonymous>' call
        timedTask.b6k_1();
      } catch ($p) {
        if ($p instanceof Error) {
          var e = $p;
          this.p6k_1(e);
        } else {
          throw $p;
        }
      }
      if (timedTask.a6k_1 && !this.g6k_1) {
        timedTask.c6k(maxOf(new Duration(Duration__plus_impl_yu9v8f(timedTask.d6k(), timedTask.z6j_1)), new Duration(_get_now__e6dlkr(this))).xj_1);
        this.o6k_1.j2u(timedTask);
      }
    }
    // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
    var this_1 = this.j6k_1;
    var tmp$ret$7;
    $l$block_0: {
      // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
      this_1.b20();
      try {
        // Inline function 'korlibs.datastructure.event.SyncEventLoop.runAvailableNextTask.<anonymous>' call
        var tmp_2;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.n6k_1.g1()) {
          tmp_2 = this.n6k_1.bl();
        } else {
          tmp_2 = null;
        }
        tmp$ret$7 = tmp_2;
        break $l$block_0;
      }finally {
        this_1.d20();
      }
    }
    var task = tmp$ret$7;
    // Inline function 'korlibs.datastructure.event.SyncEventLoop.runCatchingExceptions' call
    try {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      if (task == null)
        null;
      else
        task();
    } catch ($p) {
      if ($p instanceof Error) {
        var e_0 = $p;
        this.p6k_1(e_0);
      } else {
        throw $p;
      }
    }
    return !(task == null) || !(timedTask == null);
  }
}
class Listener {
  constructor(func, node, base) {
    this.y6k_1 = func;
    this.z6k_1 = node;
    this.a6l_1 = base;
  }
  t6() {
    if (this.z6k_1.c6l_1.o3(this)) {
      __updateChildListenerCount(this.a6l_1, this.z6k_1.b6l_1, -1);
    }
  }
  e6l() {
    this.z6k_1.c6l_1.h(this);
    __updateChildListenerCount(this.a6l_1, this.z6k_1.b6l_1, 1);
  }
}
class ListenerNode {
  constructor(type) {
    this.b6l_1 = type;
    this.c6l_1 = FastArrayList.j11();
    this.d6l_1 = FastArrayList.j11();
  }
}
class EventListener {}
function onEvents(etypes, handler) {
  // Inline function 'kotlin.collections.isEmpty' call
  if (etypes.length === 0) {
    // Inline function 'kotlin.error' call
    var message = 'Must have at least one event type';
    throw IllegalStateException.l5(toString(message));
  }
  var closeable = new CancellableGroup();
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var n = 0;
  while (n < etypes.length) {
    // Inline function 'korlibs.event.EventListener.onEvents.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    var it = etypes[_unary__edvuaz];
    closeable.uu(this.l6l(it, handler));
  }
  return closeable;
}
function dispatch(type, event, result) {
  return this.n6l(type, event, result, true, true);
}
function dispatch$default(type, event, result, $super) {
  result = result === VOID ? null : result;
  return $super === VOID ? this.u6l(type, event, result) : dispatch(type, event, result);
}
function dispatchDown(type, event, result) {
  return this.n6l(type, event, result, false, true);
}
function dispatchUp(type, event, result) {
  return this.n6l(type, event, result, true, false);
}
function dispatch_0(event) {
  // Inline function 'korlibs.datastructure.fastCastTo' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return this.v6l(event.i2h(), event);
}
class BaseEventListener {
  static j6l() {
    var $this = createThis(this);
    $this.f6l_1 = null;
    $this.g6l_1 = null;
    $this.h6l_1 = null;
    $this.i6l_1 = null;
    return $this;
  }
  r10(_set____db54di) {
    this.f6l_1 = _set____db54di;
  }
  s10() {
    return this.f6l_1;
  }
  k6l(other) {
    var tmp0_safe_receiver = this.g6l_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      __updateChildListenerCount_0(tmp0_safe_receiver, this, false);
    }
    this.g6l_1 = other;
    var tmp1_safe_receiver = this.g6l_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      __updateChildListenerCount_0(tmp1_safe_receiver, this, true);
    }
  }
  l6l(type, handler) {
    if (this.h6l_1 == null)
      this.h6l_1 = FastIdentityMap();
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var this_0 = ensureNotNull(this.h6l_1);
      var res = get_0(this_0, type);
      if (!(res == null)) {
        tmp$ret$0 = res;
        break $l$block;
      }
      // Inline function 'korlibs.event.BaseEventListener.onEvent.<anonymous>' call
      var out = new ListenerNode(type);
      set(this_0, type, out);
      tmp$ret$0 = out;
    }
    var tmp = tmp$ret$0;
    var lists = tmp instanceof ListenerNode ? tmp : THROW_CCE();
    // Inline function 'kotlin.also' call
    var this_1 = new Listener(handler, lists, this);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.event.BaseEventListener.onEvent.<anonymous>' call
    this_1.e6l();
    return this_1;
  }
  m6l(type) {
    var tmp0_safe_receiver = this.h6l_1;
    var tmp = tmp0_safe_receiver == null ? null : get_0(tmp0_safe_receiver, type);
    return tmp instanceof ListenerNode ? tmp : null;
  }
  n6l(type, event, result, up, down) {
    var eventListenerCount = this.o6l(type);
    if (eventListenerCount <= 0)
      return false;
    if (down) {
      this.p6l(type, event, result);
    }
    var listeners = this.m6l(type);
    var tmp1_safe_receiver = listeners == null ? null : listeners.c6l_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.datastructure.iterators.fastForEachWithTemp' call
      var temp = listeners.d6l_1;
      toFastList(tmp1_safe_receiver, temp);
      try {
        // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
        // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var array = temp.h11_1;
        var n = 0;
        while (n < array.length) {
          // Inline function 'korlibs.event.BaseEventListener.dispatch.<anonymous>' call
          // Inline function 'kotlin.js.unsafeCast' call
          // Inline function 'korlibs.datastructure.get' call
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          // Inline function 'kotlin.js.asDynamic' call
          // Inline function 'kotlin.js.asDynamic' call
          array[_unary__edvuaz].y6k_1(event);
          if (result == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            // Inline function 'kotlin.contracts.contract' call
            result.r6l_1 = result.r6l_1 + 1 | 0;
          }
        }
      }finally {
        temp.m3();
      }
    }
    if (up) {
      this.s6l(type, event, result);
    }
    if (result == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.event.BaseEventListener.dispatch.<anonymous>' call
      result.q6l_1 = result.q6l_1 + 1 | 0;
    }
    return event.t6l();
  }
  u6l(type, event, result) {
    return dispatch.call(this, type, event, result);
  }
  w6l(event) {
    return dispatch_0.call(this, event);
  }
  s6l(type, event, result) {
  }
  p6l(type, event, result) {
  }
  o6l(type) {
    var tmp0_safe_receiver = this.i6l_1;
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.getNull' call
      tmp = type == null ? null : get_0(tmp0_safe_receiver, type);
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  }
}
class EventResult {
  constructor(iterationCount, resultCount) {
    iterationCount = iterationCount === VOID ? 0 : iterationCount;
    resultCount = resultCount === VOID ? 0 : resultCount;
    this.q6l_1 = iterationCount;
    this.r6l_1 = resultCount;
  }
  j2y() {
    this.q6l_1 = 0;
    this.r6l_1 = 0;
  }
  toString() {
    return 'EventResult(iterationCount=' + this.q6l_1 + ', resultCount=' + this.r6l_1 + ')';
  }
  hashCode() {
    var result = this.q6l_1;
    result = imul(result, 31) + this.r6l_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof EventResult))
      return false;
    var tmp0_other_with_cast = other instanceof EventResult ? other : THROW_CCE();
    if (!(this.q6l_1 === tmp0_other_with_cast.q6l_1))
      return false;
    if (!(this.r6l_1 === tmp0_other_with_cast.r6l_1))
      return false;
    return true;
  }
}
class Companion {}
class Event {
  constructor() {
    this.d6m_1 = null;
    this.e6m_1 = false;
  }
  f6m(_set____db54di) {
    this.d6m_1 = _set____db54di;
  }
  o6o(reason) {
    throw StopPropagatingException.e6p(reason);
  }
  g6m(_set____db54di) {
    this.e6m_1 = _set____db54di;
  }
  t6l() {
    return this.e6m_1;
  }
  h6m(reason) {
    this.e6m_1 = true;
  }
  i6m(reason, $super) {
    reason = reason === VOID ? null : reason;
    var tmp;
    if ($super === VOID) {
      this.h6m(reason);
      tmp = Unit_instance;
    } else {
      tmp = $super.h6m.call(this, reason);
    }
    return tmp;
  }
}
class TypedEvent extends Event {
  constructor(type) {
    super();
    this.c6m_1 = type;
  }
  i2h() {
    return this.c6m_1;
  }
}
class PauseEvent extends TypedEvent {
  constructor() {
    super(Companion_instance_8);
  }
}
class Companion_0 {}
class ResumeEvent extends TypedEvent {
  constructor() {
    super(Companion_instance_9);
  }
}
class Companion_1 {}
class StopEvent extends TypedEvent {
  constructor() {
    super(Companion_instance_10);
  }
}
class Companion_2 {}
class DestroyEvent extends TypedEvent {
  constructor() {
    super(Companion_instance_11);
  }
}
class RenderEvent extends TypedEvent {
  constructor() {
    Companion_getInstance_18();
    super(Companion_getInstance_18());
    this.m6m_1 = true;
    this.n6m_1 = true;
  }
  toString() {
    return 'RenderEvent(update=' + this.m6m_1 + ', render=' + this.n6m_1 + ')';
  }
}
class Companion_3 extends RenderEvent {
  constructor() {
    Companion_instance_12 = null;
    super();
    Companion_instance_12 = this;
  }
}
class InitEvent extends TypedEvent {
  constructor() {
    Companion_getInstance_19();
    super(Companion_getInstance_19());
  }
}
class Companion_4 extends InitEvent {
  constructor() {
    Companion_instance_13 = null;
    super();
    Companion_instance_13 = this;
  }
}
class Companion_5 {}
class DisposeEvent extends TypedEvent {
  constructor() {
    super(Companion_instance_14);
  }
}
class Companion_6 {}
class FullScreenEvent extends TypedEvent {
  constructor(fullscreen) {
    fullscreen = fullscreen === VOID ? false : fullscreen;
    super(Companion_instance_15);
    this.r6m_1 = fullscreen;
  }
  toString() {
    return 'FullScreenEvent(fullscreen=' + this.r6m_1 + ')';
  }
  hashCode() {
    return getBooleanHashCode(this.r6m_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FullScreenEvent))
      return false;
    var tmp0_other_with_cast = other instanceof FullScreenEvent ? other : THROW_CCE();
    if (!(this.r6m_1 === tmp0_other_with_cast.r6m_1))
      return false;
    return true;
  }
}
class Companion_7 {}
class ReshapeEvent extends TypedEvent {
  constructor(x, y, width, height, setPos) {
    x = x === VOID ? 0 : x;
    y = y === VOID ? 0 : y;
    width = width === VOID ? 0 : width;
    height = height === VOID ? 0 : height;
    setPos = setPos === VOID ? true : setPos;
    super(Companion_instance_16);
    this.v6m_1 = x;
    this.w6m_1 = y;
    this.x6m_1 = width;
    this.y6m_1 = height;
    this.z6m_1 = setPos;
  }
  toString() {
    return 'ReshapeEvent(x=' + this.v6m_1 + ', y=' + this.w6m_1 + ', width=' + this.x6m_1 + ', height=' + this.y6m_1 + ', setPos=' + this.z6m_1 + ')';
  }
  hashCode() {
    var result = this.v6m_1;
    result = imul(result, 31) + this.w6m_1 | 0;
    result = imul(result, 31) + this.x6m_1 | 0;
    result = imul(result, 31) + this.y6m_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.z6m_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ReshapeEvent))
      return false;
    var tmp0_other_with_cast = other instanceof ReshapeEvent ? other : THROW_CCE();
    if (!(this.v6m_1 === tmp0_other_with_cast.v6m_1))
      return false;
    if (!(this.w6m_1 === tmp0_other_with_cast.w6m_1))
      return false;
    if (!(this.x6m_1 === tmp0_other_with_cast.x6m_1))
      return false;
    if (!(this.y6m_1 === tmp0_other_with_cast.y6m_1))
      return false;
    if (!(this.z6m_1 === tmp0_other_with_cast.z6m_1))
      return false;
    return true;
  }
}
class Companion_8 {
  constructor() {
    Companion_instance_17 = this;
    this.a6n_1 = values();
  }
}
class Type extends Enum {}
class KeyEvent extends Event {
  constructor(type, id, key, keyCode, character, shift, ctrl, alt, meta, str) {
    type = type === VOID ? Type_UP_getInstance() : type;
    id = id === VOID ? 0 : id;
    key = key === VOID ? Key_UP_getInstance() : key;
    keyCode = keyCode === VOID ? 0 : keyCode;
    character = character === VOID ? _Char___init__impl__6a9atx(0) : character;
    shift = shift === VOID ? false : shift;
    ctrl = ctrl === VOID ? false : ctrl;
    alt = alt === VOID ? false : alt;
    meta = meta === VOID ? false : meta;
    str = str === VOID ? null : str;
    super();
    this.d6n_1 = type;
    this.e6n_1 = id;
    this.f6n_1 = key;
    this.g6n_1 = keyCode;
    this.h6n_1 = character;
    this.i6n_1 = shift;
    this.j6n_1 = ctrl;
    this.k6n_1 = alt;
    this.l6n_1 = meta;
    this.m6n_1 = str;
    this.n6n_1 = Companion_getInstance().yj_1;
  }
  i2h() {
    return this.d6n_1;
  }
  toString() {
    return 'KeyEvent(type=' + toString(this.d6n_1) + ', id=' + this.e6n_1 + ', key=' + this.f6n_1.toString() + ', keyCode=' + this.g6n_1 + ', character=' + toString_0(this.h6n_1) + ', shift=' + this.i6n_1 + ', ctrl=' + this.j6n_1 + ', alt=' + this.k6n_1 + ', meta=' + this.l6n_1 + ', str=' + this.m6n_1 + ')';
  }
  hashCode() {
    var result = this.d6n_1.hashCode();
    result = imul(result, 31) + this.e6n_1 | 0;
    result = imul(result, 31) + this.f6n_1.hashCode() | 0;
    result = imul(result, 31) + this.g6n_1 | 0;
    result = imul(result, 31) + Char__hashCode_impl_otmys(this.h6n_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.i6n_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.j6n_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.k6n_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.l6n_1) | 0;
    result = imul(result, 31) + (this.m6n_1 == null ? 0 : getStringHashCode(this.m6n_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof KeyEvent))
      return false;
    var tmp0_other_with_cast = other instanceof KeyEvent ? other : THROW_CCE();
    if (!this.d6n_1.equals(tmp0_other_with_cast.d6n_1))
      return false;
    if (!(this.e6n_1 === tmp0_other_with_cast.e6n_1))
      return false;
    if (!this.f6n_1.equals(tmp0_other_with_cast.f6n_1))
      return false;
    if (!(this.g6n_1 === tmp0_other_with_cast.g6n_1))
      return false;
    if (!(this.h6n_1 === tmp0_other_with_cast.h6n_1))
      return false;
    if (!(this.i6n_1 === tmp0_other_with_cast.i6n_1))
      return false;
    if (!(this.j6n_1 === tmp0_other_with_cast.j6n_1))
      return false;
    if (!(this.k6n_1 === tmp0_other_with_cast.k6n_1))
      return false;
    if (!(this.l6n_1 === tmp0_other_with_cast.l6n_1))
      return false;
    if (!(this.m6n_1 == tmp0_other_with_cast.m6n_1))
      return false;
    return true;
  }
}
class Companion_9 {
  constructor() {
    Companion_instance_18 = this;
    this.o6n_1 = values_0();
  }
}
class Type_0 extends Enum {}
class ScrollDeltaMode extends Enum {
  constructor(name, ordinal, scale) {
    super(name, ordinal);
    this.r6n_1 = scale;
  }
}
class MouseEvent extends Event {
  constructor(type, id, x, y, button, buttons, scrollDeltaX, scrollDeltaY, scrollDeltaZ, isShiftDown, isCtrlDown, isAltDown, isMetaDown, scaleCoords, emulated, scrollDeltaMode) {
    type = type === VOID ? Type_MOVE_getInstance() : type;
    id = id === VOID ? 0 : id;
    x = x === VOID ? 0 : x;
    y = y === VOID ? 0 : y;
    button = button === VOID ? MouseButton_NONE_getInstance() : button;
    buttons = buttons === VOID ? 0 : buttons;
    scrollDeltaX = scrollDeltaX === VOID ? 0.0 : scrollDeltaX;
    scrollDeltaY = scrollDeltaY === VOID ? 0.0 : scrollDeltaY;
    scrollDeltaZ = scrollDeltaZ === VOID ? 0.0 : scrollDeltaZ;
    isShiftDown = isShiftDown === VOID ? false : isShiftDown;
    isCtrlDown = isCtrlDown === VOID ? false : isCtrlDown;
    isAltDown = isAltDown === VOID ? false : isAltDown;
    isMetaDown = isMetaDown === VOID ? false : isMetaDown;
    scaleCoords = scaleCoords === VOID ? true : scaleCoords;
    emulated = emulated === VOID ? false : emulated;
    scrollDeltaMode = scrollDeltaMode === VOID ? ScrollDeltaMode_LINE_getInstance() : scrollDeltaMode;
    super();
    this.u6n_1 = type;
    this.v6n_1 = id;
    this.w6n_1 = x;
    this.x6n_1 = y;
    this.y6n_1 = button;
    this.z6n_1 = buttons;
    this.a6o_1 = scrollDeltaX;
    this.b6o_1 = scrollDeltaY;
    this.c6o_1 = scrollDeltaZ;
    this.d6o_1 = isShiftDown;
    this.e6o_1 = isCtrlDown;
    this.f6o_1 = isAltDown;
    this.g6o_1 = isMetaDown;
    this.h6o_1 = scaleCoords;
    this.i6o_1 = emulated;
    this.j6o_1 = scrollDeltaMode;
    this.k6o_1 = null;
    var tmp = this;
    tmp.l6o_1 = MouseEvent$requestLock$lambda;
  }
  i2h() {
    return this.u6n_1;
  }
  m6o(other) {
    this.u6n_1 = other.u6n_1;
    this.v6n_1 = other.v6n_1;
    this.w6n_1 = other.w6n_1;
    this.x6n_1 = other.x6n_1;
    this.y6n_1 = other.y6n_1;
    this.z6n_1 = other.z6n_1;
    this.a6o_1 = other.a6o_1;
    this.b6o_1 = other.b6o_1;
    this.c6o_1 = other.c6o_1;
    this.d6o_1 = other.d6o_1;
    this.e6o_1 = other.e6o_1;
    this.f6o_1 = other.f6o_1;
    this.g6o_1 = other.g6o_1;
    this.h6o_1 = other.h6o_1;
    this.i6o_1 = other.i6o_1;
    this.j6o_1 = other.j6o_1;
  }
  n6o(mode, x, y, z) {
    this.j6o_1 = mode;
    this.a6o_1 = x;
    this.b6o_1 = y;
    this.c6o_1 = z;
  }
  toString() {
    return 'MouseEvent(type=' + toString(this.u6n_1) + ', id=' + this.v6n_1 + ', x=' + this.w6n_1 + ', y=' + this.x6n_1 + ', button=' + this.y6n_1.toString() + ', buttons=' + this.z6n_1 + ', scrollDeltaX=' + this.a6o_1 + ', scrollDeltaY=' + this.b6o_1 + ', scrollDeltaZ=' + this.c6o_1 + ', isShiftDown=' + this.d6o_1 + ', isCtrlDown=' + this.e6o_1 + ', isAltDown=' + this.f6o_1 + ', isMetaDown=' + this.g6o_1 + ', scaleCoords=' + this.h6o_1 + ', emulated=' + this.i6o_1 + ', scrollDeltaMode=' + this.j6o_1.toString() + ')';
  }
  hashCode() {
    var result = this.u6n_1.hashCode();
    result = imul(result, 31) + this.v6n_1 | 0;
    result = imul(result, 31) + this.w6n_1 | 0;
    result = imul(result, 31) + this.x6n_1 | 0;
    result = imul(result, 31) + this.y6n_1.hashCode() | 0;
    result = imul(result, 31) + this.z6n_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.a6o_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.b6o_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.c6o_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.d6o_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.e6o_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.f6o_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.g6o_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.h6o_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.i6o_1) | 0;
    result = imul(result, 31) + this.j6o_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MouseEvent))
      return false;
    var tmp0_other_with_cast = other instanceof MouseEvent ? other : THROW_CCE();
    if (!this.u6n_1.equals(tmp0_other_with_cast.u6n_1))
      return false;
    if (!(this.v6n_1 === tmp0_other_with_cast.v6n_1))
      return false;
    if (!(this.w6n_1 === tmp0_other_with_cast.w6n_1))
      return false;
    if (!(this.x6n_1 === tmp0_other_with_cast.x6n_1))
      return false;
    if (!this.y6n_1.equals(tmp0_other_with_cast.y6n_1))
      return false;
    if (!(this.z6n_1 === tmp0_other_with_cast.z6n_1))
      return false;
    if (!equals(this.a6o_1, tmp0_other_with_cast.a6o_1))
      return false;
    if (!equals(this.b6o_1, tmp0_other_with_cast.b6o_1))
      return false;
    if (!equals(this.c6o_1, tmp0_other_with_cast.c6o_1))
      return false;
    if (!(this.d6o_1 === tmp0_other_with_cast.d6o_1))
      return false;
    if (!(this.e6o_1 === tmp0_other_with_cast.e6o_1))
      return false;
    if (!(this.f6o_1 === tmp0_other_with_cast.f6o_1))
      return false;
    if (!(this.g6o_1 === tmp0_other_with_cast.g6o_1))
      return false;
    if (!(this.h6o_1 === tmp0_other_with_cast.h6o_1))
      return false;
    if (!(this.i6o_1 === tmp0_other_with_cast.i6o_1))
      return false;
    if (!this.j6o_1.equals(tmp0_other_with_cast.j6o_1))
      return false;
    return true;
  }
}
class Companion_10 {
  constructor() {
    Companion_instance_19 = this;
    this.p6o_1 = values_1();
  }
}
class Type_1 extends Enum {}
class GestureEvent extends Event {
  constructor(type, id, amountX, amountY) {
    type = type === VOID ? Type_MAGNIFY_getInstance() : type;
    id = id === VOID ? 0 : id;
    amountX = amountX === VOID ? 0.0 : amountX;
    amountY = amountY === VOID ? 0.0 : amountY;
    super();
    this.s6o_1 = type;
    this.t6o_1 = id;
    this.u6o_1 = amountX;
    this.v6o_1 = amountY;
  }
  i2h() {
    return this.s6o_1;
  }
  toString() {
    return 'GestureEvent(type=' + toString(this.s6o_1) + ', id=' + this.t6o_1 + ', amountX=' + this.u6o_1 + ', amountY=' + this.v6o_1 + ')';
  }
  hashCode() {
    var result = this.s6o_1.hashCode();
    result = imul(result, 31) + this.t6o_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.u6o_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.v6o_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GestureEvent))
      return false;
    var tmp0_other_with_cast = other instanceof GestureEvent ? other : THROW_CCE();
    if (!this.s6o_1.equals(tmp0_other_with_cast.s6o_1))
      return false;
    if (!(this.t6o_1 === tmp0_other_with_cast.t6o_1))
      return false;
    if (!equals(this.u6o_1, tmp0_other_with_cast.u6o_1))
      return false;
    if (!equals(this.v6o_1, tmp0_other_with_cast.v6o_1))
      return false;
    return true;
  }
}
class Companion_11 {
  constructor() {
    Companion_instance_20 = this;
    this.w6o_1 = values_2();
  }
}
class Type_2 extends Enum {}
class DropFileEvent extends Event {
  constructor(type, files) {
    type = type === VOID ? Type_START_getInstance() : type;
    files = files === VOID ? null : files;
    super();
    this.z6o_1 = type;
    this.a6p_1 = files;
  }
  i2h() {
    return this.z6o_1;
  }
  toString() {
    return 'DropFileEvent(type=' + toString(this.z6o_1) + ', files=' + toString_1(this.a6p_1) + ')';
  }
  hashCode() {
    var result = this.z6o_1.hashCode();
    result = imul(result, 31) + (this.a6p_1 == null ? 0 : hashCode(this.a6p_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof DropFileEvent))
      return false;
    var tmp0_other_with_cast = other instanceof DropFileEvent ? other : THROW_CCE();
    if (!this.z6o_1.equals(tmp0_other_with_cast.z6o_1))
      return false;
    if (!equals(this.a6p_1, tmp0_other_with_cast.a6p_1))
      return false;
    return true;
  }
}
class StopPropagatingException extends Exception {
  static e6p(reason) {
    reason = reason === VOID ? null : reason;
    var $this = this.je();
    captureStack($this, $this.d6p_1);
    $this.c6p_1 = reason;
    return $this;
  }
}
class Status extends Enum {}
class Kind extends Enum {}
class Companion_12 {
  constructor() {
    Companion_instance_21 = this;
    this.f6p_1 = new Touch(-1);
  }
}
class Touch {
  constructor(index, id, p, force, status, kind, button) {
    Companion_getInstance_27();
    index = index === VOID ? -1 : index;
    id = id === VOID ? -1 : id;
    p = p === VOID ? Companion_getInstance_4().j2d_1 : p;
    force = force === VOID ? 1.0 : force;
    status = status === VOID ? Status_KEEP_getInstance() : status;
    kind = kind === VOID ? Kind_FINGER_getInstance() : kind;
    button = button === VOID ? MouseButton_LEFT_getInstance() : button;
    this.g6p_1 = new Mixin();
    this.h6p_1 = index;
    this.i6p_1 = id;
    this.j6p_1 = p;
    this.k6p_1 = force;
    this.l6p_1 = status;
    this.m6p_1 = kind;
    this.n6p_1 = button;
  }
  o6p() {
    return this.j6p_1.h2d_1;
  }
  p6p() {
    return this.j6p_1.i2d_1;
  }
  t17() {
    return !this.l6p_1.equals(Status_REMOVE_getInstance());
  }
  q6p(other) {
    this.i6p_1 = other.i6p_1;
    this.j6p_1 = other.j6p_1;
    this.k6p_1 = other.k6p_1;
    this.l6p_1 = other.l6p_1;
    this.m6p_1 = other.m6p_1;
    this.n6p_1 = other.n6p_1;
  }
  hashCode() {
    return this.h6p_1;
  }
  equals(other) {
    var tmp;
    if (other instanceof Touch) {
      tmp = this.h6p_1 === other.h6p_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  toString() {
    return 'Touch(index=' + this.h6p_1 + ', id=' + this.i6p_1 + ', p=' + this.j6p_1.toString() + ', force=' + this.k6p_1 + ', status=' + this.l6p_1.toString() + ', kind=' + this.m6p_1.toString() + ', button=' + this.n6p_1.toString() + ')';
  }
  r10(value) {
    this.g6p_1.r10(value);
  }
  s10() {
    return this.g6p_1.s10();
  }
}
class Companion_13 {
  constructor() {
    Companion_instance_22 = this;
    this.r6p_1 = values_3();
  }
}
class Type_3 extends Enum {}
class Companion_14 {
  constructor() {
    this.s6p_1 = 10;
  }
}
class TouchEvent extends Event {
  constructor(type, screen, currentTime, scaleCoords, emulated) {
    type = type === VOID ? Type_START_getInstance_0() : type;
    screen = screen === VOID ? 0 : screen;
    currentTime = currentTime === VOID ? Companion_getInstance_8().e1y_1 : currentTime;
    scaleCoords = scaleCoords === VOID ? true : scaleCoords;
    emulated = emulated === VOID ? false : emulated;
    super();
    this.v6p_1 = type;
    this.w6p_1 = screen;
    this.x6p_1 = currentTime;
    this.y6p_1 = scaleCoords;
    this.z6p_1 = emulated;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = Companion_instance_23.s6p_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = new Touch(tmp_3);
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.a6q_1 = tmp_2;
    this.b6q_1 = FastArrayList.j11();
    this.c6q_1 = FastArrayList.j11();
    this.d6q_1 = FastIntMap();
  }
  i2h() {
    return this.v6p_1;
  }
  e6q() {
    return this.b6q_1;
  }
  f6q() {
    return this.e6q().e1();
  }
  g6q(id) {
    // Inline function 'korlibs.datastructure.get' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.d6q_1.get(id);
  }
  toString() {
    var tmp = toString(this.v6p_1);
    var tmp_0 = this.f6q();
    var tmp_1 = this.e6q();
    return 'TouchEvent[' + tmp + '][' + tmp_0 + '](' + joinToString(tmp_1, ', ', VOID, VOID, VOID, VOID, TouchEvent$toString$lambda) + ')';
  }
  h6q(type) {
    this.v6p_1 = type;
    this.x6p_1 = Companion_getInstance_8().i1y();
    this.b6q_1.m3();
    // Inline function 'korlibs.datastructure.clear' call
    // Inline function 'kotlin.js.asDynamic' call
    this.d6q_1.clear();
  }
  i6q() {
    this.c6q_1.m3();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.e6q();
    var n = 0;
    while (n < this_0.e1()) {
      // Inline function 'korlibs.event.TouchEvent.endFrame.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var it = this_0.d1(_unary__edvuaz);
      if (it.t17()) {
        this.c6q_1.h(it);
      }
    }
  }
  j6q(id) {
    // Inline function 'korlibs.datastructure.get' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp0_elvis_lhs = this.d6q_1.get(id);
    return tmp0_elvis_lhs == null ? this.k6q(id) : tmp0_elvis_lhs;
  }
  k6q(id) {
    var touch = this.a6q_1[this.b6q_1.e1()];
    touch.i6p_1 = id;
    this.b6q_1.h(touch);
    // Inline function 'korlibs.datastructure.set' call
    var this_0 = this.d6q_1;
    var key = touch.i6p_1;
    // Inline function 'kotlin.js.asDynamic' call
    this_0.set(key, touch);
    return touch;
  }
  l6q(id, p, status, force, kind, button) {
    var touch = this.j6q(id);
    touch.j6p_1 = p;
    touch.l6p_1 = status;
    touch.k6p_1 = force;
    touch.m6p_1 = kind;
    touch.n6p_1 = button;
  }
  m6q(id, p, status, force, kind, button, $super) {
    status = status === VOID ? Status_KEEP_getInstance() : status;
    force = force === VOID ? 1.0 : force;
    kind = kind === VOID ? Kind_FINGER_getInstance() : kind;
    button = button === VOID ? MouseButton_LEFT_getInstance() : button;
    var tmp;
    if ($super === VOID) {
      this.l6q(id, p, status, force, kind, button);
      tmp = Unit_instance;
    } else {
      tmp = $super.l6q.call(this, id, p, status, force, kind, button);
    }
    return tmp;
  }
  n6q(touch) {
    this.l6q(touch.i6p_1, touch.j6p_1, touch.l6p_1, touch.k6p_1, touch.m6p_1, touch.n6p_1);
  }
  o6q(other) {
    this.v6p_1 = other.v6p_1;
    this.w6p_1 = other.w6p_1;
    this.x6p_1 = other.x6p_1;
    this.y6p_1 = other.y6p_1;
    this.z6p_1 = other.z6p_1;
    var inductionVariable = 0;
    var last = Companion_instance_23.s6p_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.a6q_1[n].q6p(other.a6q_1[n]);
      }
       while (inductionVariable < last);
    this.b6q_1.m3();
    this.c6q_1.m3();
    // Inline function 'korlibs.datastructure.clear' call
    // Inline function 'kotlin.js.asDynamic' call
    this.d6q_1.clear();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = other.e6q();
    var n_0 = 0;
    while (n_0 < this_0.e1()) {
      // Inline function 'korlibs.event.TouchEvent.copyFrom.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      var otherTouch = this_0.d1(_unary__edvuaz);
      var touch = this.a6q_1[otherTouch.h6p_1];
      this.b6q_1.h(touch);
      if (touch.t17()) {
        this.c6q_1.h(touch);
      }
      // Inline function 'korlibs.datastructure.set' call
      var this_1 = this.d6q_1;
      var key = touch.i6p_1;
      // Inline function 'kotlin.js.asDynamic' call
      this_1.set(key, touch);
    }
  }
  p6q() {
    return this.v6p_1.equals(Type_START_getInstance_0());
  }
  q6q() {
    return this.v6p_1.equals(Type_END_getInstance_0());
  }
  hashCode() {
    var result = this.v6p_1.hashCode();
    result = imul(result, 31) + this.w6p_1 | 0;
    result = imul(result, 31) + DateTime__hashCode_impl_yf0bc9(this.x6p_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.y6p_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.z6p_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TouchEvent))
      return false;
    var tmp0_other_with_cast = other instanceof TouchEvent ? other : THROW_CCE();
    if (!this.v6p_1.equals(tmp0_other_with_cast.v6p_1))
      return false;
    if (!(this.w6p_1 === tmp0_other_with_cast.w6p_1))
      return false;
    if (!equals(this.x6p_1, tmp0_other_with_cast.x6p_1))
      return false;
    if (!(this.y6p_1 === tmp0_other_with_cast.y6p_1))
      return false;
    if (!(this.z6p_1 === tmp0_other_with_cast.z6p_1))
      return false;
    return true;
  }
}
class Mode extends Enum {}
class TouchBuilder {
  constructor() {
    this.r6q_1 = new TouchEvent();
    this.s6q_1 = new TouchEvent();
    this.t6q_1 = Mode_JS_getInstance();
  }
  u6q(type, scaleCoords) {
    this.s6q_1.y6p_1 = scaleCoords;
    this.s6q_1.h6q(type);
    if (this.t6q_1.t3_1 === 2) {
      this.s6q_1.o6q(this.r6q_1);
      this.s6q_1.v6p_1 = type;
      // Inline function 'korlibs.datastructure.iterators.fastIterateRemove' call
      var this_0 = this.s6q_1.b6q_1;
      var n = 0;
      var m = 0;
      while (n < this_0.e1()) {
        if (m >= 0 && !(m === n)) {
          this_0.p3(m, this_0.d1(n));
        }
        // Inline function 'korlibs.event.TouchBuilder.startFrame.<anonymous>' call
        var it = this_0.d1(n);
        var tmp;
        if (it.t17()) {
          it.l6p_1 = Status_KEEP_getInstance();
          tmp = false;
        } else {
          // Inline function 'korlibs.datastructure.remove' call
          var this_1 = this.s6q_1.d6q_1;
          var key = it.i6p_1;
          // Inline function 'kotlin.js.asDynamic' call
          this_1.delete(key);
          tmp = true;
        }
        if (tmp) {
          m = m - 1 | 0;
        }
        n = n + 1 | 0;
        m = m + 1 | 0;
      }
      while (this_0.e1() > m) {
        this_0.r3(this_0.e1() - 1 | 0);
      }
    }
  }
  v6q() {
    switch (this.t6q_1.t3_1) {
      case 0:
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call

        var this_0 = this.r6q_1.e6q();
        var n = 0;
        while (n < this_0.e1()) {
          // Inline function 'korlibs.event.TouchBuilder.endFrame.<anonymous>' call
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          var oldTouch = this_0.d1(_unary__edvuaz);
          if (this.s6q_1.g6q(oldTouch.i6p_1) == null) {
            if (oldTouch.t17()) {
              oldTouch.l6p_1 = Status_REMOVE_getInstance();
              this.s6q_1.n6q(oldTouch);
            }
          }
        }

        break;
      case 2:
        break;
      default:
        break;
    }
    this.s6q_1.i6q();
    this.r6q_1.o6q(this.s6q_1);
    return this.s6q_1;
  }
  w6q(id, p, force, kind, button) {
    var touch = this.s6q_1.j6q(id);
    touch.j6p_1 = p;
    touch.k6p_1 = force;
    touch.m6p_1 = kind;
    touch.n6p_1 = button;
    if (this.t6q_1.t3_1 === 2) {
      var tmp = touch;
      switch (this.s6q_1.v6p_1.t3_1) {
        case 0:
          tmp.l6p_1 = Status_ADD_getInstance();
          break;
        case 1:
          tmp.l6p_1 = Status_REMOVE_getInstance();
          break;
        default:
          tmp.l6p_1 = Status_KEEP_getInstance();
          break;
      }
    } else {
      var oldTouch = this.r6q_1.g6q(id);
      touch.l6p_1 = oldTouch == null ? Status_ADD_getInstance() : Status_KEEP_getInstance();
    }
  }
  x6q(id, p, force, kind, button, $super) {
    force = force === VOID ? 1.0 : force;
    kind = kind === VOID ? Kind_FINGER_getInstance() : kind;
    button = button === VOID ? MouseButton_LEFT_getInstance() : button;
    var tmp;
    if ($super === VOID) {
      this.w6q(id, p, force, kind, button);
      tmp = Unit_instance;
    } else {
      tmp = $super.w6q.call(this, id, p, force, kind, button);
    }
    return tmp;
  }
}
class GamepadInfoEmitter {
  constructor(dispatcher) {
    this.y6q_1 = dispatcher;
    this.z6q_1 = booleanArray(4);
    this.a6r_1 = new GamePadUpdateEvent();
    this.b6r_1 = new GamePadConnectionEvent();
    this.c6r_1 = IntArrayList.g2s();
  }
  d6r() {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.a6r_1.h6r_1;
    var n = 0;
    while (n < this_0.length) {
      // Inline function 'korlibs.event.GamepadInfoEmitter.dispatchGamepadUpdateStart.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      this_0[_unary__edvuaz].j6r_1 = false;
    }
    this.a6r_1.g6r_1 = 0;
  }
  p6r(info) {
    var _receiver__tnumb7 = this.a6r_1;
    var _unary__edvuaz = _receiver__tnumb7.g6r_1;
    _receiver__tnumb7.g6r_1 = _unary__edvuaz + 1 | 0;
    var index = _unary__edvuaz;
    var pad = this.a6r_1.h6r_1[index];
    pad.q6r(info);
    pad.j6r_1 = true;
    pad.i6r_1 = index;
  }
  r6r(out) {
    out.m3();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.a6r_1.h6r_1;
    var n = 0;
    while (n < this_0.length) {
      // Inline function 'korlibs.event.GamepadInfoEmitter.dispatchGamepadUpdateEnd.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var it = this_0[_unary__edvuaz];
      if (!(this.z6q_1[it.i6r_1] === it.j6r_1)) {
        this.z6q_1[it.i6r_1] = it.j6r_1;
        out.m2s(it.i6r_1);
        if (!it.j6r_1) {
          it.k6r_1 = null;
        }
        // Inline function 'kotlin.apply' call
        var this_1 = this.b6r_1;
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.event.GamepadInfoEmitter.dispatchGamepadUpdateEnd.<anonymous>.<anonymous>' call
        this_1.u6r_1 = Companion_getInstance_32().x6r(it.j6r_1);
        this_1.v6r_1 = it.i6r_1;
        this.y6q_1.w6l(this_1);
      }
    }
    this.y6q_1.w6l(this.a6r_1);
    return out;
  }
}
class BatteryStatus extends Enum {}
class Companion_15 {
  constructor() {
    this.y6r_1 = 'Wireless Controller';
    this.z6r_1 = 4;
    this.a6s_1 = 0.075;
  }
  b6s(value, margin, apply) {
    var tmp;
    if (apply) {
      // Inline function 'kotlin.math.absoluteValue' call
      tmp = Math.abs(value) < margin;
    } else {
      tmp = false;
    }
    if (tmp)
      return 0.0;
    return value;
  }
  c6s(value, margin, apply, $super) {
    margin = margin === VOID ? 0.075 : margin;
    apply = apply === VOID ? true : apply;
    return $super === VOID ? this.b6s(value, margin, apply) : $super.b6s.call(this, value, margin, apply);
  }
}
class GamepadInfo {
  constructor(index, connected, name, rawButtons, batteryLevel, name2, batteryStatus) {
    index = index === VOID ? 0 : index;
    connected = connected === VOID ? false : connected;
    name = name === VOID ? null : name;
    rawButtons = rawButtons === VOID ? new Float32Array(32) : rawButtons;
    batteryLevel = batteryLevel === VOID ? 1.0 : batteryLevel;
    name2 = name2 === VOID ? Companion_instance_24.y6r_1 : name2;
    batteryStatus = batteryStatus === VOID ? BatteryStatus_UNKNOWN_getInstance() : batteryStatus;
    this.i6r_1 = index;
    this.j6r_1 = connected;
    this.k6r_1 = name;
    this.l6r_1 = rawButtons;
    this.m6r_1 = batteryLevel;
    this.n6r_1 = name2;
    this.o6r_1 = batteryStatus;
  }
  d6s() {
    var tmp0_elvis_lhs = this.k6r_1;
    return (tmp0_elvis_lhs == null ? 'unknown' : tmp0_elvis_lhs) + ' - ' + this.n6r_1;
  }
  q6r(that) {
    this.i6r_1 = that.i6r_1;
    this.k6r_1 = that.k6r_1;
    this.n6r_1 = that.n6r_1;
    this.j6r_1 = that.j6r_1;
    this.m6r_1 = that.m6r_1;
    this.o6r_1 = that.o6r_1;
    var tmp = that.l6r_1;
    var tmp_0 = this.l6r_1;
    // Inline function 'kotlin.math.min' call
    var a = this.l6r_1.length;
    var b = that.l6r_1.length;
    var tmp$ret$0 = Math.min(a, b);
    arraycopy(tmp, 0, tmp_0, 0, tmp$ret$0);
  }
  e6s(button) {
    return this.l6r_1[button.h6s()];
  }
  i6s(includeButtons) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.event.GamepadInfo.toStringEx.<anonymous>' call
    this_0.ec('Gamepad[' + this.i6r_1 + '][' + this.d6s() + ']');
    if (includeButtons) {
      this_0.ec('[');
      var count = 0;
      var indexedObject = values_5();
      var inductionVariable = 0;
      var last = indexedObject.length;
      while (inductionVariable < last) {
        var button = indexedObject[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        var value = this.e6s(button);
        if (!(value === 0.0)) {
          if (count > 0) {
            this_0.ec(',');
          }
          this_0.ec(button.toString() + '=' + get_niceStr(value));
          count = count + 1 | 0;
        }
      }
      this_0.ec(']');
    }
    return this_0.toString();
  }
  j6s(includeButtons, $super) {
    includeButtons = includeButtons === VOID ? true : includeButtons;
    return $super === VOID ? this.i6s(includeButtons) : $super.i6s.call(this, includeButtons);
  }
  toString() {
    return this.i6s(false);
  }
}
class Companion_16 {}
class GamePadUpdateEvent extends Event {
  constructor(gamepadsLength, gamepads) {
    gamepadsLength = gamepadsLength === VOID ? 0 : gamepadsLength;
    var tmp;
    if (gamepads === VOID) {
      var tmp_0 = 0;
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_1 = fillArrayVal(Array(4), null);
      while (tmp_0 < 4) {
        var tmp_2 = tmp_0;
        tmp_1[tmp_2] = new GamepadInfo(tmp_2);
        tmp_0 = tmp_0 + 1 | 0;
      }
      tmp = tmp_1;
    } else {
      tmp = gamepads;
    }
    gamepads = tmp;
    super();
    this.g6r_1 = gamepadsLength;
    this.h6r_1 = gamepads;
  }
  i2h() {
    return Companion_instance_25;
  }
  toString() {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this.h6r_1;
    var destination = ArrayList.i1();
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.event.GamePadUpdateEvent.toString.<anonymous>' call
      if (element.j6r_1) {
        destination.h(element);
      }
    }
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.w(collectionSizeOrDefault(destination, 10));
    var tmp0_iterator = destination.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.event.GamePadUpdateEvent.toString.<anonymous>' call
      var tmp$ret$3 = item.j6s();
      destination_0.h(tmp$ret$3);
    }
    return 'GamePadUpdateEvent(' + toString(destination_0) + ')';
  }
  hashCode() {
    var result = this.g6r_1;
    result = imul(result, 31) + hashCode(this.h6r_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GamePadUpdateEvent))
      return false;
    var tmp0_other_with_cast = other instanceof GamePadUpdateEvent ? other : THROW_CCE();
    if (!(this.g6r_1 === tmp0_other_with_cast.g6r_1))
      return false;
    if (!equals(this.h6r_1, tmp0_other_with_cast.h6r_1))
      return false;
    return true;
  }
}
class Companion_17 {
  constructor() {
    Companion_instance_26 = this;
    this.w6r_1 = values_4();
  }
  x6r(connected) {
    return connected ? Type_CONNECTED_getInstance() : Type_DISCONNECTED_getInstance();
  }
}
class Type_4 extends Enum {}
class GamePadConnectionEvent extends Event {
  constructor(type, gamepad) {
    type = type === VOID ? Type_CONNECTED_getInstance() : type;
    gamepad = gamepad === VOID ? 0 : gamepad;
    super();
    this.u6r_1 = type;
    this.v6r_1 = gamepad;
  }
  i2h() {
    return this.u6r_1;
  }
  toString() {
    return 'GamePadConnectionEvent(type=' + toString(this.u6r_1) + ', gamepad=' + this.v6r_1 + ')';
  }
  hashCode() {
    var result = this.u6r_1.hashCode();
    result = imul(result, 31) + this.v6r_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GamePadConnectionEvent))
      return false;
    var tmp0_other_with_cast = other instanceof GamePadConnectionEvent ? other : THROW_CCE();
    if (!this.u6r_1.equals(tmp0_other_with_cast.u6r_1))
      return false;
    if (!(this.v6r_1 === tmp0_other_with_cast.v6r_1))
      return false;
    return true;
  }
}
class Companion_18 {
  constructor() {
    Companion_instance_27 = this;
    this.k6s_1 = values_5();
    this.l6s_1 = 32;
  }
}
class GameButton extends Enum {
  h6s() {
    return this.t3_1;
  }
}
class Companion_19 {
  constructor() {
    Companion_instance_28 = this;
    this.m6s_1 = Key_UNKNOWN_getInstance().t3_1 + 1 | 0;
    this.n6s_1 = Key_ENTER_getInstance();
    this.o6s_1 = Key_N0_getInstance();
    this.p6s_1 = Key_N1_getInstance();
    this.q6s_1 = Key_N2_getInstance();
    this.r6s_1 = Key_N3_getInstance();
    this.s6s_1 = Key_N4_getInstance();
    this.t6s_1 = Key_N5_getInstance();
    this.u6s_1 = Key_N6_getInstance();
    this.v6s_1 = Key_N7_getInstance();
    this.w6s_1 = Key_N8_getInstance();
    this.x6s_1 = Key_N9_getInstance();
  }
  y6s() {
    return Key_CONTROL_getInstance();
  }
  z6s() {
    return Key_CONTROL_getInstance();
  }
  a6t() {
    return Key_SHIFT_getInstance();
  }
  b6t() {
    return Key_SHIFT_getInstance();
  }
  c6t() {
    return Key_ALT_getInstance();
  }
  d6t() {
    return Key_ALT_getInstance();
  }
  e6t() {
    return Key_SUPER_getInstance();
  }
  f6t() {
    return Key_SUPER_getInstance();
  }
}
class Key extends Enum {
  i6t() {
    switch (this.t3_1) {
      case 81:
      case 82:
      case 83:
      case 84:
      case 85:
      case 86:
      case 87:
      case 88:
      case 89:
      case 90:
      case 91:
      case 92:
      case 93:
      case 94:
      case 95:
      case 96:
      case 97:
      case 98:
      case 99:
      case 100:
      case 101:
      case 102:
      case 103:
      case 104:
      case 105:
        return true;
      default:
        return false;
    }
  }
}
class Companion_20 {
  constructor() {
    Companion_instance_29 = this;
    this.j6t_1 = MouseButton_NONE_getInstance().t3_1 + 1 | 0;
    this.k6t_1 = values_6();
  }
  d1(id) {
    // Inline function 'kotlin.collections.getOrElse' call
    var this_0 = this.k6t_1;
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    if (0 <= id ? id <= (this_0.length - 1 | 0) : false) {
      tmp = this_0[id];
    } else {
      // Inline function 'korlibs.event.Companion.get.<anonymous>' call
      tmp = MouseButton_BUTTON_UNKNOWN_getInstance();
    }
    return tmp;
  }
}
class MouseButton extends Enum {
  constructor(name, ordinal, id, bits) {
    bits = bits === VOID ? 1 << id : bits;
    super(name, ordinal);
    this.n6t_1 = id;
    this.o6t_1 = bits;
  }
}
class Companion_21 {
  constructor() {
    Companion_instance_30 = this;
    this.p6t_1 = Companion_getInstance_1().iz('AG');
    this.q6t_1 = 96.0;
  }
}
class AGFeatures {}
function get_parentFeatures() {
  return null;
}
function get_isUniformBuffersSupported() {
  var tmp0_safe_receiver = this.s6u();
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.t6u();
  return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
}
function get_isVertexArraysSupported() {
  var tmp0_safe_receiver = this.s6u();
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.u6u();
  return tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
}
class AG {
  static v6t() {
    Companion_getInstance_36();
    var $this = createThis(this);
    $this.r6t_1 = new Mixin();
    $this.s6t_1 = AGFrameBuffer.j6u(true);
    $this.t6t_1 = 0;
    $this.u6t_1 = new AGStats();
    return $this;
  }
  k6u() {
    return this.s6t_1;
  }
  l6u() {
    // Inline function 'korlibs.logger.Logger.info' call
    var this_0 = Companion_getInstance_36().p6t_1;
    var level = Level_INFO_getInstance();
    var tmp;
    if (this_0.q31(level)) {
      // Inline function 'korlibs.graphics.AG.contextLost.<anonymous>' call
      this_0.r31(level, this);
      tmp = Unit_instance;
    }
    // Inline function 'korlibs.logger.Logger.info' call
    var this_1 = Companion_getInstance_36().p6t_1;
    var level_0 = Level_INFO_getInstance();
    var tmp_0;
    if (this_1.q31(level_0)) {
      // Inline function 'korlibs.graphics.AG.contextLost.<anonymous>' call
      var tmp$ret$2 = 'AG.contextLost()';
      this_1.r31(level_0, tmp$ret$2);
      tmp_0 = Unit_instance;
    }
    this.t6t_1 = this.t6t_1 + 1 | 0;
  }
  m6u() {
    return this.n6u(AGFinish_instance);
  }
  o6u() {
    return Unit_instance;
  }
  i6q() {
    return Unit_instance;
  }
  n6u(command) {
    return Unit_instance;
  }
  p6u(frameBuffer, frameBufferInfo, color, depth, stencil, clearColor, clearDepth, clearStencil, scissor) {
    return this.n6u(new AGClear(frameBuffer, frameBufferInfo, color, depth, stencil, clearColor, clearDepth, clearStencil));
  }
  q6u(frameBuffer, frameBufferInfo, vertexData, program, drawType, vertexCount, indices, indexType, drawOffset, blending, uniformBlocks, textureUnits, stencilRef, stencilOpFunc, colorMask, depthAndFrontFace, scissor, cullFace, instances) {
    return this.n6u(new AGBatch(frameBuffer, frameBufferInfo, vertexData, indices, indexType, program, uniformBlocks, textureUnits, blending, stencilOpFunc, stencilRef, colorMask, depthAndFrontFace, scissor, cullFace, drawType, drawOffset, vertexCount, instances));
  }
  r6u(frameBuffer, frameBufferInfo, x, y, width, height, data, kind) {
    return Unit_instance;
  }
  r10(value) {
    this.r6t_1.r10(value);
  }
  s10() {
    return this.r6t_1.s10();
  }
}
class Immutable {
  constructor(parentFeatures, graphicExtensions, isInstancedSupported, isUniformBuffersSupported, isVertexArraysSupported, isStorageMultisampleSupported, isFloatTextureSupported) {
    parentFeatures = parentFeatures === VOID ? null : parentFeatures;
    graphicExtensions = graphicExtensions === VOID ? emptySet() : graphicExtensions;
    isInstancedSupported = isInstancedSupported === VOID ? false : isInstancedSupported;
    isUniformBuffersSupported = isUniformBuffersSupported === VOID ? false : isUniformBuffersSupported;
    isVertexArraysSupported = isVertexArraysSupported === VOID ? false : isVertexArraysSupported;
    isStorageMultisampleSupported = isStorageMultisampleSupported === VOID ? false : isStorageMultisampleSupported;
    isFloatTextureSupported = isFloatTextureSupported === VOID ? false : isFloatTextureSupported;
    this.e6w_1 = parentFeatures;
    this.f6w_1 = graphicExtensions;
    this.g6w_1 = isInstancedSupported;
    this.h6w_1 = isUniformBuffersSupported;
    this.i6w_1 = isVertexArraysSupported;
    this.j6w_1 = isStorageMultisampleSupported;
    this.k6w_1 = isFloatTextureSupported;
  }
  s6u() {
    return this.e6w_1;
  }
  t6u() {
    return this.h6w_1;
  }
  u6u() {
    return this.i6w_1;
  }
  toString() {
    return 'Immutable(parentFeatures=' + toString_1(this.e6w_1) + ', graphicExtensions=' + toString(this.f6w_1) + ', isInstancedSupported=' + this.g6w_1 + ', isUniformBuffersSupported=' + this.h6w_1 + ', isVertexArraysSupported=' + this.i6w_1 + ', isStorageMultisampleSupported=' + this.j6w_1 + ', isFloatTextureSupported=' + this.k6w_1 + ')';
  }
  hashCode() {
    var result = this.e6w_1 == null ? 0 : hashCode(this.e6w_1);
    result = imul(result, 31) + hashCode(this.f6w_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.g6w_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.h6w_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.i6w_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.j6w_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.k6w_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Immutable))
      return false;
    var tmp0_other_with_cast = other instanceof Immutable ? other : THROW_CCE();
    if (!equals(this.e6w_1, tmp0_other_with_cast.e6w_1))
      return false;
    if (!equals(this.f6w_1, tmp0_other_with_cast.f6w_1))
      return false;
    if (!(this.g6w_1 === tmp0_other_with_cast.g6w_1))
      return false;
    if (!(this.h6w_1 === tmp0_other_with_cast.h6w_1))
      return false;
    if (!(this.i6w_1 === tmp0_other_with_cast.i6w_1))
      return false;
    if (!(this.j6w_1 === tmp0_other_with_cast.j6w_1))
      return false;
    if (!(this.k6w_1 === tmp0_other_with_cast.k6w_1))
      return false;
    return true;
  }
}
class AGObject {
  constructor() {
    this.o6x_1 = null;
    this.p6x_1 = -1;
    this.q6x_1 = -2;
    this.r6x_1 = -1;
  }
  w6x() {
    this.s6x();
    this.q6x_1 = this.r6x_1 - 1 | 0;
  }
  s6x() {
    this.r6x_1 = this.r6x_1 + 1 | 0;
  }
  t6() {
    var tmp0_safe_receiver = this.o6x_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.x70();
    }
    this.o6x_1 = null;
  }
}
class AGBuffer extends AGObject {
  constructor() {
    super();
    this.n6x_1 = null;
  }
  t6x(data, offset, length) {
    return upload(this, _Int8Buffer___get_buffer__impl__q0gulb(_Int8Buffer___init__impl__e20lvc(data, offset, length)), false);
  }
  u6x(data, offset, length) {
    return upload(this, sliceWithSize(data, offset, length), true);
  }
  v6x(data) {
    return upload(this, data, true);
  }
  toString() {
    var tmp0_safe_receiver = this.n6x_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.g15();
    return 'AGBuffer(' + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) + ')';
  }
}
class Companion_22 {
  constructor() {
    this.g6v_1 = 8;
  }
  h6v() {
    return AGTextureUnits.z6x();
  }
}
class AGTextureUnits {
  static a6y(textures, infos) {
    var $this = createThis(this);
    $this.x6x_1 = textures;
    $this.y6x_1 = infos;
    return $this;
  }
  static z6x(size) {
    size = size === VOID ? Companion_instance_31.g6v_1 : size;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp$ret$0 = fillArrayVal(Array(size), null);
    return this.a6y(tmp$ret$0, _AGTextureUnitInfoArray___init__impl__c77rdb_0(size));
  }
  e1() {
    return this.x6x_1.length;
  }
  b6y(index, texture, info) {
    this.x6x_1[index] = texture;
    AGTextureUnitInfoArray__set_impl_s95rfh(this.y6x_1, index, info);
  }
  c6y(sampler, texture, info) {
    this.b6y(sampler.o6y_1, texture, info);
  }
  q6y(sampler, texture, info, $super) {
    info = info === VOID ? Companion_getInstance_39().s6y_1 : info;
    var tmp;
    if ($super === VOID) {
      this.c6y(sampler, texture, info);
      tmp = Unit_instance;
    } else {
      tmp = $super.c6y.call(this, sampler, texture, new AGTextureUnitInfo(info));
    }
    return tmp;
  }
  m3() {
    var inductionVariable = 0;
    var last = this.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.b6y(n, null, Companion_getInstance_39().s6y_1);
      }
       while (inductionVariable < last);
  }
  o10() {
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this.x6x_1.slice();
    return AGTextureUnits.a6y(tmp$ret$1, AGTextureUnitInfoArray__copyOf_impl_z2w8z3(this.y6x_1));
  }
  toString() {
    return 'AGTextureUnits(textures=' + toString(this.x6x_1) + ', infos=' + AGTextureUnitInfoArray__toString_impl_kr9cgh(this.y6x_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.x6x_1);
    result = imul(result, 31) + AGTextureUnitInfoArray__hashCode_impl_siosps(this.y6x_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGTextureUnits))
      return false;
    var tmp0_other_with_cast = other instanceof AGTextureUnits ? other : THROW_CCE();
    if (!equals(this.x6x_1, tmp0_other_with_cast.x6x_1))
      return false;
    if (!equals(this.y6x_1, tmp0_other_with_cast.y6x_1))
      return false;
    return true;
  }
}
class Companion_23 {
  constructor() {
    this.t6y_1 = 128;
    this.u6y_1 = 128;
  }
}
class AGFrameBuffer {
  static v6y(base, id) {
    id = id === VOID ? -1 : id;
    var $this = createThis(this);
    $this.w6t_1 = base;
    $this.x6t_1 = id;
    $this.y6t_1 = 1;
    $this.z6t_1 = true;
    $this.a6u_1 = true;
    $this.b6u_1 = 0;
    $this.c6u_1 = 0;
    $this.d6u_1 = 128;
    $this.e6u_1 = 128;
    $this.f6u_1 = 128;
    $this.g6u_1 = 128;
    $this.h6u_1 = RectangleInt.a2n();
    $this.i6u_1 = null;
    return $this;
  }
  static j6u(isMain, id) {
    isMain = isMain === VOID ? false : isMain;
    id = id === VOID ? -1 : id;
    return this.v6y(new AGFrameBufferBase(isMain), id);
  }
  w6y() {
    return this.w6t_1.w6y();
  }
  e6z() {
    return this.w6t_1.b6z_1;
  }
  f6z() {
    return this.w6t_1.c6z_1;
  }
  d6w() {
    return AGFrameBufferInfo__withHasStencil_impl_nbaemo(AGFrameBufferInfo__withHasDepth_impl_fjgbiv(AGFrameBufferInfo__withSamples_impl_83818f(AGFrameBufferInfo__withBounds_impl_sg0n3x(_AGFrameBufferInfo___init__impl__dbxiro(new Long(0, 0)), this.b6u_1, this.c6u_1, this.d6u_1, this.e6u_1), this.y6t_1), this.a6u_1), this.z6t_1);
  }
  g6z(width, height) {
    return this.h6z(0, 0, width, height);
  }
  i6z(x, y, width, height, fullWidth, fullHeight) {
    if (this.b6u_1 === x && this.c6u_1 === y && this.d6u_1 === width && this.e6u_1 === height && this.f6u_1 === fullWidth && this.g6u_1 === fullHeight)
      return true;
    this.f6z().x6z(NullBitmap.a4j(width, height));
    this.w6t_1.d6z_1 = Companion_getInstance_9().h17(imul(imul(fullWidth, fullHeight), 8));
    this.b6u_1 = x;
    this.c6u_1 = y;
    this.d6u_1 = width;
    this.e6u_1 = height;
    this.f6u_1 = fullWidth;
    this.g6u_1 = fullHeight;
    markAsDirty(this);
    return false;
  }
  h6z(x, y, width, height, fullWidth, fullHeight, $super) {
    fullWidth = fullWidth === VOID ? width : fullWidth;
    fullHeight = fullHeight === VOID ? height : fullHeight;
    return $super === VOID ? this.i6z(x, y, width, height, fullWidth, fullHeight) : $super.i6z.call(this, x, y, width, height, fullWidth, fullHeight);
  }
  t6() {
    this.w6t_1.t6();
  }
  y6z(samples) {
    if (this.y6t_1 === samples)
      return Unit_instance;
    this.y6t_1 = samples;
    markAsDirty(this);
  }
  z6z(hasDepth, hasStencil) {
    if (this.a6u_1 === hasDepth && this.z6t_1 === hasStencil)
      return Unit_instance;
    this.a6u_1 = hasDepth;
    this.z6t_1 = hasStencil;
    markAsDirty(this);
  }
  toString() {
    return 'AGFrameBuffer(' + (this.e6z() ? 'main' : '' + this.x6t_1) + ', ' + this.d6u_1 + ', ' + this.e6u_1 + ')';
  }
}
class AGTexture extends AGObject {
  constructor(targetKind) {
    targetKind = targetKind === VOID ? Companion_getInstance_51().a70_1 : targetKind;
    super();
    this.n6z_1 = targetKind;
    this.o6z_1 = Companion_getInstance_1().iz('AGTexture');
    this.p6z_1 = false;
    this.q6z_1 = false;
    this.r6z_1 = null;
    this.s6z_1 = null;
    this.t6z_1 = null;
    this.u6z_1 = false;
    this.v6z_1 = null;
    this.w6z_1 = Companion_getInstance_9().i17(new Long(0, 0));
  }
  e70() {
    var tmp0_safe_receiver = this.v6z_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.y4h();
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.graphics.AGTexture.<get-implForcedTexTarget>.<anonymous>' call
      tmp = fromGl(Companion_getInstance_51(), tmp1_safe_receiver);
    }
    var tmp2_elvis_lhs = tmp;
    var tmp_0;
    var tmp_1 = tmp2_elvis_lhs;
    if ((tmp_1 == null ? null : new AGTextureTargetKind(tmp_1)) == null) {
      tmp_0 = this.n6z_1;
    } else {
      tmp_0 = tmp2_elvis_lhs;
    }
    return tmp_0;
  }
  x2p() {
    var tmp0_safe_receiver = this.t6z_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r43_1;
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  }
  y2p() {
    var tmp0_safe_receiver = this.t6z_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.s43_1;
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  }
  g70() {
    var tmp = this.t6z_1;
    var tmp0_safe_receiver = (tmp == null ? true : tmp instanceof MultiBitmap) ? tmp : null;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.u70_1;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.e1();
    return tmp2_elvis_lhs == null ? 1 : tmp2_elvis_lhs;
  }
  v70(bmp, mipmaps, baseMipmapLevel, maxMipmapLevel) {
    if (bmp == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      checkBitmaps(this, bmp);
    }
    var tmp = this;
    tmp.v6z_1 = (bmp == null ? true : isInterface(bmp, ForcedTexId)) ? bmp : null;
    this.t6z_1 = bmp;
    this.w6z_1 = Companion_getInstance_9().h17(imul(imul(imul(this.x2p(), this.y2p()), this.g70()), 4));
    this.s6x();
    this.q6z_1 = mipmaps;
    this.r6z_1 = baseMipmapLevel;
    this.s6z_1 = maxMipmapLevel;
    return this;
  }
  x6z(bmp, mipmaps, baseMipmapLevel, maxMipmapLevel, $super) {
    mipmaps = mipmaps === VOID ? false : mipmaps;
    baseMipmapLevel = baseMipmapLevel === VOID ? null : baseMipmapLevel;
    maxMipmapLevel = maxMipmapLevel === VOID ? null : maxMipmapLevel;
    return $super === VOID ? this.v70(bmp, mipmaps, baseMipmapLevel, maxMipmapLevel) : $super.v70.call(this, bmp, mipmaps, baseMipmapLevel, maxMipmapLevel);
  }
  w70(bitmap, requestMipmaps) {
    var tmp1_elvis_lhs = bitmap == null ? null : bitmap.r43_1;
    var width = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var tmp3_elvis_lhs = bitmap == null ? null : bitmap.s43_1;
    var height = tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs;
    return requestMipmaps && get_isPowerOfTwo(width) && get_isPowerOfTwo(height);
  }
  toString() {
    return 'AGTexture(size=' + this.x2p() + ',' + this.y2p() + ')';
  }
}
class AGFrameBufferBase extends AGObject {
  constructor(isMain) {
    super();
    this.b6z_1 = isMain;
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = new AGTexture();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.AGFrameBufferBase.tex.<anonymous>' call
    this_0.p6z_1 = true;
    tmp.c6z_1 = this_0;
    this.d6z_1 = Companion_getInstance_9().h17(0);
  }
  w6y() {
    return !this.b6z_1;
  }
  t6() {
    this.c6z_1.t6();
  }
  toString() {
    return 'AGFrameBufferBase(isMain=' + this.b6z_1 + ')';
  }
}
class Companion_24 {
  constructor() {
    Companion_instance_33 = this;
    this.r6y_1 = _AGTextureUnitInfo___init__impl__s1tthu(-1);
    this.s6y_1 = AGTextureUnitInfo__withKind_impl_aa0b04(AGTextureUnitInfo__withWrap_impl_akwb6y(AGTextureUnitInfo__withLinearTrilinear_impl_aactvz(_AGTextureUnitInfo___init__impl__s1tthu(0), true, true), Companion_getInstance_52().z70_1), Companion_getInstance_51().a70_1);
  }
  y70(data) {
    return _AGTextureUnitInfo___init__impl__s1tthu(data);
  }
  c71(wrap, linear, trilinear) {
    return AGTextureUnitInfo__withLinearTrilinear_impl_aactvz(AGTextureUnitInfo__withWrap_impl_akwb6y(_AGTextureUnitInfo___init__impl__s1tthu(0), wrap), linear, trilinear);
  }
  d71(wrap, linear, trilinear, $super) {
    wrap = wrap === VOID ? Companion_getInstance_52().z70_1 : wrap;
    linear = linear === VOID ? true : linear;
    trilinear = trilinear === VOID ? linear : trilinear;
    return $super === VOID ? this.c71(wrap, linear, trilinear) : $super.c71.call(this, new AGWrapMode(wrap), linear, trilinear).e71_1;
  }
}
class AGTextureUnitInfo {
  constructor(data) {
    Companion_getInstance_39();
    this.e71_1 = data;
  }
  toString() {
    return AGTextureUnitInfo__toString_impl_7im6je(this.e71_1);
  }
  hashCode() {
    return AGTextureUnitInfo__hashCode_impl_e8jq9h(this.e71_1);
  }
  equals(other) {
    return AGTextureUnitInfo__equals_impl_j2jlgn(this.e71_1, other);
  }
}
class AGNativeObject {}
class BufferCache {
  constructor() {
    this.f71_1 = FastIdentityMap();
  }
  j2y() {
    // Inline function 'korlibs.datastructure.fastForEach' call
    var this_0 = this.f71_1;
    // Inline function 'korlibs.datastructure.fastKeyForEach' call
    // Inline function 'kotlin.js.asDynamic' call
    var mapIterator = this_0.keys();
    $l$loop: while (true) {
      var v = mapIterator.next();
      if (v.done)
        break $l$loop;
      // Inline function 'korlibs.datastructure.fastForEach.<anonymous>' call
      var it = v.value;
      // Inline function 'korlibs.graphics.BufferCache.reset.<anonymous>' call
      ensureNotNull(get_0(this_0, it)).j2y();
    }
  }
  o71() {
    // Inline function 'korlibs.datastructure.fastForEach' call
    var this_0 = this.f71_1;
    // Inline function 'korlibs.datastructure.fastKeyForEach' call
    // Inline function 'kotlin.js.asDynamic' call
    var mapIterator = this_0.keys();
    $l$loop: while (true) {
      var v = mapIterator.next();
      if (v.done)
        break $l$loop;
      // Inline function 'korlibs.datastructure.fastForEach.<anonymous>' call
      var it = v.value;
      // Inline function 'korlibs.graphics.BufferCache.uploadUpdatedBuffers.<anonymous>' call
      ensureNotNull(get_0(this_0, it)).p71();
    }
  }
  q71(block) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var this_0 = this.f71_1;
      var res = get_0(this_0, block);
      if (!(res == null)) {
        tmp$ret$0 = res;
        break $l$block;
      }
      // Inline function 'korlibs.graphics.BufferCache.get.<anonymous>' call
      var out = new UniformBlockBuffer(block);
      set(this_0, block, out);
      tmp$ret$0 = out;
    }
    var tmp = tmp$ret$0;
    return tmp instanceof UniformBlockBuffer ? tmp : THROW_CCE();
  }
}
class AGProgramWithUniforms {
  constructor(program, bufferCache) {
    bufferCache = bufferCache === VOID ? new BufferCache() : bufferCache;
    this.r71_1 = program;
    this.s71_1 = bufferCache;
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.r71_1.e72_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.graphics.AGProgramWithUniforms.uniformLayouts.<anonymous>' call
      var tmp$ret$0 = item.y72_1;
      destination.h(tmp$ret$0);
    }
    tmp.t71_1 = distinct(destination);
    var tmp_0 = this;
    var tmp$ret$3;
    $l$block: {
      // Inline function 'kotlin.collections.maxOfOrNull' call
      var iterator = this.t71_1.a1();
      if (!iterator.b1()) {
        tmp$ret$3 = null;
        break $l$block;
      }
      // Inline function 'korlibs.graphics.AGProgramWithUniforms.maxLocation.<anonymous>' call
      var maxValue = iterator.c1().a73_1 + 1 | 0;
      while (iterator.b1()) {
        // Inline function 'korlibs.graphics.AGProgramWithUniforms.maxLocation.<anonymous>' call
        var v = iterator.c1().a73_1 + 1 | 0;
        if (compareTo(maxValue, v) < 0) {
          maxValue = v;
        }
      }
      tmp$ret$3 = maxValue;
    }
    var tmp0_elvis_lhs = tmp$ret$3;
    tmp_0.u71_1 = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    var tmp_1 = this;
    // Inline function 'kotlin.also' call
    var tmp_2 = 0;
    var tmp_3 = this.u71_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_4 = fillArrayVal(Array(tmp_3), null);
    while (tmp_2 < tmp_3) {
      tmp_4[tmp_2] = null;
      tmp_2 = tmp_2 + 1 | 0;
    }
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.AGProgramWithUniforms.uniformsBlocks.<anonymous>' call
    var _iterator__ex2g4s = this.t71_1.a1();
    while (_iterator__ex2g4s.b1()) {
      var layout = _iterator__ex2g4s.c1();
      tmp_4[layout.a73_1] = layout;
    }
    tmp_1.v71_1 = tmp_4;
    var tmp_5 = this;
    var tmp_6 = 0;
    var tmp_7 = this.v71_1.length;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_8 = fillArrayVal(Array(tmp_7), null);
    while (tmp_6 < tmp_7) {
      var tmp_9 = tmp_6;
      var tmp0_safe_receiver = this.v71_1[tmp_9];
      var tmp_10;
      if (tmp0_safe_receiver == null) {
        tmp_10 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.graphics.AGProgramWithUniforms.uniformsBlocksData.<anonymous>' call
        tmp_10 = this.s71_1.q71(tmp0_safe_receiver);
      }
      tmp_8[tmp_9] = tmp_10;
      tmp_6 = tmp_6 + 1 | 0;
    }
    tmp_5.w71_1 = tmp_8;
    var tmp_11 = this;
    var tmp_12 = 0;
    var tmp_13 = this.v71_1.length;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_14 = fillArrayVal(Array(tmp_13), null);
    while (tmp_12 < tmp_13) {
      var tmp_15 = tmp_12;
      var tmp0_safe_receiver_0 = this.w71_1[tmp_15];
      var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.g71_1;
      var tmp_16;
      if (tmp1_safe_receiver == null) {
        tmp_16 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.graphics.AGProgramWithUniforms.agUniformBlockDatas.<anonymous>' call
        tmp_16 = new UniformBlockBuffer(tmp1_safe_receiver);
      }
      tmp_14[tmp_15] = tmp_16;
      tmp_12 = tmp_12 + 1 | 0;
    }
    tmp_11.x71_1 = tmp_14;
    var tmp_17 = this;
    var tmp_18 = 0;
    var tmp_19 = this.v71_1.length;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_20 = fillArrayVal(Array(tmp_19), null);
    while (tmp_18 < tmp_19) {
      var tmp_21 = tmp_18;
      var tmp0_safe_receiver_1 = this.w71_1[tmp_21];
      tmp_20[tmp_21] = tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.h71_1;
      tmp_18 = tmp_18 + 1 | 0;
    }
    tmp_17.y71_1 = tmp_20;
    var tmp_22 = this;
    var tmp_23 = 0;
    var tmp_24 = this.v71_1.length;
    var tmp_25 = new Int32Array(tmp_24);
    while (tmp_23 < tmp_24) {
      tmp_25[tmp_23] = 0;
      tmp_23 = tmp_23 + 1 | 0;
    }
    tmp_22.z71_1 = tmp_25;
  }
  e73() {
    var inductionVariable = 0;
    var last = this.z71_1.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_safe_receiver = this.w71_1[n];
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.f73();
        this.z71_1[n] = tmp1_elvis_lhs == null ? -1 : tmp1_elvis_lhs;
      }
       while (inductionVariable <= last);
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this.z71_1.slice();
    return new UniformBlocksBuffersRef(this.x71_1, this.y71_1, tmp$ret$1);
  }
}
class AGVertexArrayObject {
  static j73(list, isDynamic) {
    isDynamic = isDynamic === VOID ? true : isDynamic;
    var $this = createThis(this);
    $this.g73_1 = new Mixin();
    $this.h73_1 = list;
    $this.i73_1 = isDynamic;
    return $this;
  }
  static k73(datas, isDynamic) {
    isDynamic = isDynamic === VOID ? true : isDynamic;
    return this.j73(fastArrayListOf(datas.slice()), isDynamic);
  }
  toString() {
    return 'AGVertexArrayObject(list=' + this.h73_1.toString() + ', isDynamic=' + this.i73_1 + ')';
  }
  hashCode() {
    var result = this.h73_1.hashCode();
    result = imul(result, 31) + getBooleanHashCode(this.i73_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGVertexArrayObject))
      return false;
    var tmp0_other_with_cast = other instanceof AGVertexArrayObject ? other : THROW_CCE();
    if (!this.h73_1.equals(tmp0_other_with_cast.h73_1))
      return false;
    if (!(this.i73_1 === tmp0_other_with_cast.i73_1))
      return false;
    return true;
  }
  r10(value) {
    this.g73_1.r10(value);
  }
  s10() {
    return this.g73_1.s10();
  }
}
class AGVertexData {
  constructor(layout, buffer, baseOffset) {
    layout = layout === VOID ? ProgramLayout.t73([]) : layout;
    buffer = buffer === VOID ? new AGBuffer() : buffer;
    baseOffset = baseOffset === VOID ? 0 : baseOffset;
    this.u73_1 = layout;
    this.v73_1 = buffer;
    this.w73_1 = baseOffset;
  }
  toString() {
    return 'AGVertexData(layout=' + this.u73_1.toString() + ', buffer=' + this.v73_1.toString() + ', baseOffset=' + this.w73_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.u73_1);
    result = imul(result, 31) + hashCode(this.v73_1) | 0;
    result = imul(result, 31) + this.w73_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGVertexData))
      return false;
    var tmp0_other_with_cast = other instanceof AGVertexData ? other : THROW_CCE();
    if (!equals(this.u73_1, tmp0_other_with_cast.u73_1))
      return false;
    if (!equals(this.v73_1, tmp0_other_with_cast.v73_1))
      return false;
    if (!(this.w73_1 === tmp0_other_with_cast.w73_1))
      return false;
    return true;
  }
}
class Companion_25 {
  constructor() {
    Companion_instance_34 = this;
    this.x73_1 = _AGDrawType___init__impl__emm6mb(0);
    this.y73_1 = _AGDrawType___init__impl__emm6mb(1);
    this.z73_1 = _AGDrawType___init__impl__emm6mb(2);
    this.a74_1 = _AGDrawType___init__impl__emm6mb(3);
    this.b74_1 = _AGDrawType___init__impl__emm6mb(4);
    this.c74_1 = _AGDrawType___init__impl__emm6mb(5);
    this.d74_1 = _AGDrawType___init__impl__emm6mb(6);
  }
}
class AGDrawType {
  constructor(ordinal) {
    Companion_getInstance_40();
    this.e74_1 = ordinal;
  }
  toString() {
    return AGDrawType__toString_impl_eonaeb(this.e74_1);
  }
  hashCode() {
    return AGDrawType__hashCode_impl_ylaury(this.e74_1);
  }
  equals(other) {
    return AGDrawType__equals_impl_rtafo6(this.e74_1, other);
  }
}
class Companion_26 {
  constructor() {
    Companion_instance_35 = this;
    this.v6u_1 = _AGIndexType___init__impl__yqnmb7(0);
    this.w6u_1 = _AGIndexType___init__impl__yqnmb7(1);
    this.x6u_1 = _AGIndexType___init__impl__yqnmb7(2);
    this.y6u_1 = _AGIndexType___init__impl__yqnmb7(3);
  }
}
class Companion_27 {
  constructor() {
    Companion_instance_36 = this;
    this.z6u_1 = _AGBlending___init__impl__upt3bq(-1);
    this.a6v_1 = Companion_getInstance_42().t74(Companion_getInstance_53().l74_1, Companion_getInstance_53().s74_1, Companion_getInstance_53().l74_1, Companion_getInstance_53().s74_1);
    this.b6v_1 = Companion_getInstance_42().t74(Companion_getInstance_53().q74_1, Companion_getInstance_53().o74_1, Companion_getInstance_53().l74_1, Companion_getInstance_53().o74_1);
    this.c6v_1 = Companion_getInstance_42().u74(Companion_getInstance_53().l74_1, Companion_getInstance_53().o74_1);
    this.d6v_1 = Companion_getInstance_42().t74(Companion_getInstance_53().q74_1, Companion_getInstance_53().j74_1, Companion_getInstance_53().l74_1, Companion_getInstance_53().l74_1);
    this.e6v_1 = Companion_getInstance_42().t74(Companion_getInstance_53().l74_1, Companion_getInstance_53().l74_1, Companion_getInstance_53().l74_1, Companion_getInstance_53().l74_1);
  }
  v74(srcRGB, dstRGB, srcA, dstA, eqRGB, eqA) {
    return AGBlending__withEQ_impl_e9gm04(AGBlending__withDST_impl_y1hpet(AGBlending__withSRC_impl_hh0mjq(_AGBlending___init__impl__upt3bq(0), srcRGB, srcA), dstRGB, dstA), eqRGB, eqA);
  }
  t74(srcRGB, dstRGB, srcA, dstA, eqRGB, eqA, $super) {
    srcA = srcA === VOID ? srcRGB : srcA;
    dstA = dstA === VOID ? dstRGB : dstA;
    eqRGB = eqRGB === VOID ? Companion_getInstance_54().w74_1 : eqRGB;
    eqA = eqA === VOID ? eqRGB : eqA;
    return $super === VOID ? this.v74(srcRGB, dstRGB, srcA, dstA, eqRGB, eqA) : $super.v74.call(this, new AGBlendFactor(srcRGB), new AGBlendFactor(dstRGB), new AGBlendFactor(srcA), new AGBlendFactor(dstA), new AGBlendEquation(eqRGB), new AGBlendEquation(eqA)).f74_1;
  }
  z74(src, dst, eq) {
    return AGBlending__withEQ$default_impl_iltiw7(AGBlending__withDST$default_impl_leu6qg(AGBlending__withSRC$default_impl_uuu5hz(_AGBlending___init__impl__upt3bq(0), src), dst), eq);
  }
  u74(src, dst, eq, $super) {
    eq = eq === VOID ? Companion_getInstance_54().w74_1 : eq;
    return $super === VOID ? this.z74(src, dst, eq) : $super.z74.call(this, new AGBlendFactor(src), new AGBlendFactor(dst), new AGBlendEquation(eq)).f74_1;
  }
}
class AGBlending {
  constructor(data) {
    Companion_getInstance_42();
    this.f74_1 = data;
  }
  toString() {
    return AGBlending__toString_impl_d5hic6(this.f74_1);
  }
  hashCode() {
    return AGBlending__hashCode_impl_ywnf51(this.f74_1);
  }
  equals(other) {
    return AGBlending__equals_impl_rp3dmf(this.f74_1, other);
  }
}
class Companion_28 {
  constructor() {
    Companion_instance_37 = this;
    this.u6v_1 = AGScissor.e75(0, 0, 0, 0);
    this.v6v_1 = Companion_getInstance_43().s2l(-2147483648, -2147483648, 2147483647, 2147483647);
    this.w6v_1 = Companion_getInstance_43().s2l(-32766, -32766, 2147483647, 2147483647);
    this.x6v_1 = Companion_getInstance_43().s2l(-32767, -32767, 2147483647, 2147483647);
  }
  s2l(left, top, right, bottom) {
    return AGScissor.e75(left, top, right - left | 0, bottom - top | 0);
  }
  f75(left, top, right, bottom) {
    return AGScissor.g75(left, top, right - left, bottom - top);
  }
  h75(rect) {
    if (rect == null)
      return this.x6v_1;
    if (rect.w2d())
      return this.x6v_1;
    return AGScissor.i75(rect.r2d_1, rect.s2d_1, rect.t2d_1, rect.u2d_1);
  }
  j75(prev, next) {
    if (prev.equals(this.x6v_1))
      return next;
    if (next.equals(this.x6v_1))
      return prev;
    var intersectsX = prev.y2d() <= next.z2d() && prev.z2d() >= next.y2d();
    var intersectsY = prev.a2e() <= next.b2e() && prev.b2e() >= next.a2e();
    if (!intersectsX || !intersectsY)
      return this.u6v_1;
    // Inline function 'kotlin.math.max' call
    var a = prev.y2d();
    var b = next.y2d();
    var left = Math.max(a, b);
    // Inline function 'kotlin.math.max' call
    var a_0 = prev.a2e();
    var b_0 = next.a2e();
    var top = Math.max(a_0, b_0);
    // Inline function 'kotlin.math.min' call
    var a_1 = prev.z2d();
    var b_1 = next.z2d();
    var right = Math.min(a_1, b_1);
    // Inline function 'kotlin.math.min' call
    var a_2 = prev.b2e();
    var b_2 = next.b2e();
    var bottom = Math.min(a_2, b_2);
    return this.s2l(left, top, right, bottom);
  }
}
class AGScissor {
  static k75(_left, _top, _right, _bottom) {
    Companion_getInstance_43();
    var $this = createThis(this);
    $this.a75_1 = _left;
    $this.b75_1 = _top;
    $this.c75_1 = _right;
    $this.d75_1 = _bottom;
    return $this;
  }
  w2d() {
    return this.equals(Companion_getInstance_43().x6v_1);
  }
  static e75(x, y, width, height) {
    Companion_getInstance_43();
    return this.k75(toShortClamped(x), toShortClamped(y), toShortClamped(x + width | 0), toShortClamped(y + height | 0));
  }
  static g75(x, y, width, height) {
    Companion_getInstance_43();
    return this.e75(toIntRound(x), toIntRound(y), toIntRound(width), toIntRound(height));
  }
  static i75(x, y, width, height) {
    Companion_getInstance_43();
    return this.e75(toIntRound_0(x), toIntRound_0(y), toIntRound_0(width), toIntRound_0(height));
  }
  y2d() {
    return this.a75_1;
  }
  a2e() {
    return this.b75_1;
  }
  z2d() {
    return this.c75_1;
  }
  b2e() {
    return this.d75_1;
  }
  o6p() {
    return this.y2d();
  }
  p6p() {
    return this.a2e();
  }
  x2p() {
    return this.z2d() - this.y2d() | 0;
  }
  y2p() {
    return this.b2e() - this.a2e() | 0;
  }
  toString() {
    if (this.equals(Companion_getInstance_43().x6v_1))
      return 'null';
    return 'Scissor(x=' + this.o6p() + ', y=' + this.p6p() + ', width=' + this.x2p() + ', height=' + this.y2p() + ')';
  }
  l75() {
    return this.w2d() ? Companion_getInstance_5().g2e() : Companion_getInstance_5().o2l(this.o6p(), this.p6p(), this.x2p(), this.y2p());
  }
  m75() {
    // Inline function 'kotlin.takeIf' call
    var this_0 = this.l75();
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    // Inline function 'korlibs.graphics.AGScissor.toRectOrNull.<anonymous>' call
    if (this_0.x2d()) {
      tmp = this_0;
    } else {
      tmp = null;
    }
    return tmp;
  }
  hashCode() {
    var result = this.a75_1;
    result = imul(result, 31) + this.b75_1 | 0;
    result = imul(result, 31) + this.c75_1 | 0;
    result = imul(result, 31) + this.d75_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGScissor))
      return false;
    var tmp0_other_with_cast = other instanceof AGScissor ? other : THROW_CCE();
    if (!(this.a75_1 === tmp0_other_with_cast.a75_1))
      return false;
    if (!(this.b75_1 === tmp0_other_with_cast.b75_1))
      return false;
    if (!(this.c75_1 === tmp0_other_with_cast.c75_1))
      return false;
    if (!(this.d75_1 === tmp0_other_with_cast.d75_1))
      return false;
    return true;
  }
}
class Companion_29 {
  constructor() {
    Companion_instance_38 = this;
    this.o75_1 = _AGFrameBufferInfo___init__impl__dbxiro_0(0, 0);
    this.p75_1 = _AGFrameBufferInfo___init__impl__dbxiro_0(-1, 0);
  }
}
class AGFinish {}
class AGClear {
  constructor(frameBuffer, frameBufferInfo, color, depth, stencil, clearColor, clearDepth, clearStencil) {
    this.q75_1 = frameBuffer;
    this.r75_1 = frameBufferInfo;
    this.s75_1 = color;
    this.t75_1 = depth;
    this.u75_1 = stencil;
    this.v75_1 = clearColor;
    this.w75_1 = clearDepth;
    this.x75_1 = clearStencil;
  }
  toString() {
    return 'AGClear(frameBuffer=' + this.q75_1.toString() + ', frameBufferInfo=' + AGFrameBufferInfo__toString_impl_xecyr8(this.r75_1) + ', color=' + RGBA__toString_impl_4lw6dp(this.s75_1) + ', depth=' + this.t75_1 + ', stencil=' + this.u75_1 + ', clearColor=' + this.v75_1 + ', clearDepth=' + this.w75_1 + ', clearStencil=' + this.x75_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.q75_1);
    result = imul(result, 31) + AGFrameBufferInfo__hashCode_impl_fvl6f1(this.r75_1) | 0;
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.s75_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.t75_1) | 0;
    result = imul(result, 31) + this.u75_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.v75_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.w75_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.x75_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGClear))
      return false;
    var tmp0_other_with_cast = other instanceof AGClear ? other : THROW_CCE();
    if (!equals(this.q75_1, tmp0_other_with_cast.q75_1))
      return false;
    if (!equals(this.r75_1, tmp0_other_with_cast.r75_1))
      return false;
    if (!(this.s75_1 === tmp0_other_with_cast.s75_1))
      return false;
    if (!equals(this.t75_1, tmp0_other_with_cast.t75_1))
      return false;
    if (!(this.u75_1 === tmp0_other_with_cast.u75_1))
      return false;
    if (!(this.v75_1 === tmp0_other_with_cast.v75_1))
      return false;
    if (!(this.w75_1 === tmp0_other_with_cast.w75_1))
      return false;
    if (!(this.x75_1 === tmp0_other_with_cast.x75_1))
      return false;
    return true;
  }
}
class Companion_30 {
  constructor() {
    Companion_instance_39 = this;
    this.i6v_1 = _AGStencilReference___init__impl__rta8vg(new Long(-1, -1));
    this.j6v_1 = AGStencilReference__withWriteMask$default_impl_b7j7b4(AGStencilReference__withReadMask$default_impl_7mdffx(AGStencilReference__withReferenceValue$default_impl_2trj0v(_AGStencilReference___init__impl__rta8vg(new Long(0, 0)), 0), 255), 255);
  }
}
class AGStencilReference {
  constructor(data) {
    Companion_getInstance_45();
    this.y75_1 = data;
  }
  toString() {
    return AGStencilReference__toString_impl_qu5r8s(this.y75_1);
  }
  hashCode() {
    return AGStencilReference__hashCode_impl_52zufx(this.y75_1);
  }
  equals(other) {
    return AGStencilReference__equals_impl_kj05j(this.y75_1, other);
  }
}
class Companion_31 {
  constructor() {
    Companion_instance_40 = this;
    this.k6v_1 = _AGStencilOpFunc___init__impl__t3f62q(-1);
    this.l6v_1 = AGStencilOpFunc__withAction$default_impl_jx9cm1(AGStencilOpFunc__withCompareMode$default_impl_rzbauv(AGStencilOpFunc__withEnabled_impl_mpcwmr(_AGStencilOpFunc___init__impl__t3f62q(0), false), Companion_getInstance_57().c76_1), Companion_getInstance_56().p76_1, Companion_getInstance_56().p76_1, Companion_getInstance_56().p76_1);
  }
}
class AGStencilOpFunc {
  constructor(data) {
    Companion_getInstance_46();
    this.s76_1 = data;
  }
  toString() {
    return AGStencilOpFunc__toString_impl_pl8quy(this.s76_1);
  }
  hashCode() {
    return AGStencilOpFunc__hashCode_impl_nopebb(this.s76_1);
  }
  equals(other) {
    return AGStencilOpFunc__equals_impl_y44i4z(this.s76_1, other);
  }
}
class Companion_32 {
  constructor() {
    Companion_instance_41 = this;
    this.m6v_1 = _AGColorMask___init__impl__j38ai8(-1);
    this.n6v_1 = _AGColorMask___init__impl__j38ai8_1();
    this.o6v_1 = _AGColorMask___init__impl__j38ai8_1(true);
    this.p6v_1 = _AGColorMask___init__impl__j38ai8_1(true);
    this.q6v_1 = _AGColorMask___init__impl__j38ai8_0(true, true, true, false);
    this.r6v_1 = _AGColorMask___init__impl__j38ai8_1(false);
  }
}
class AGColorMask {
  constructor(data) {
    Companion_getInstance_47();
    this.w76_1 = data;
  }
  toString() {
    return AGColorMask__toString_impl_5i5oqg(this.w76_1);
  }
  hashCode() {
    return AGColorMask__hashCode_impl_g9082f(this.w76_1);
  }
  equals(other) {
    return AGColorMask__equals_impl_mrih8l(this.w76_1, other);
  }
}
class Companion_33 {
  constructor() {
    Companion_instance_42 = this;
    this.s6v_1 = _AGDepthAndFrontFace___init__impl__ra8x65(-2);
    this.t6v_1 = AGDepthAndFrontFace__withFrontFace_impl_mwk87t(AGDepthAndFrontFace__withDepthFunc_impl_7t7yrs(AGDepthAndFrontFace__withDepthMask_impl_610nhs(AGDepthAndFrontFace__withDepth_impl_wsx82k(_AGDepthAndFrontFace___init__impl__ra8x65(0), 0.0, 1.0), true), Companion_getInstance_57().c76_1), Companion_getInstance_58().x76_1);
  }
}
class Companion_34 {
  constructor() {
    Companion_instance_43 = this;
    this.y6v_1 = _AGCullFace___init__impl__ckmjdg(-1);
    this.z6v_1 = _AGCullFace___init__impl__ckmjdg(0);
    this.a6w_1 = _AGCullFace___init__impl__ckmjdg(1);
    this.b6w_1 = _AGCullFace___init__impl__ckmjdg(2);
    this.c6w_1 = _AGCullFace___init__impl__ckmjdg(3);
  }
}
class AGCullFace {
  constructor(ordinal) {
    Companion_getInstance_49();
    this.a77_1 = ordinal;
  }
  toString() {
    return AGCullFace__toString_impl_7d891w(this.a77_1);
  }
  hashCode() {
    return AGCullFace__hashCode_impl_t4e5ur(this.a77_1);
  }
  equals(other) {
    return AGCullFace__equals_impl_wgngjr(this.a77_1, other);
  }
}
class AGBatch {
  constructor(frameBuffer, frameBufferInfo, vertexData, indices, indexType, program, uniformBlocks, textureUnits, blending, stencilOpFunc, stencilRef, colorMask, depthAndFrontFace, scissor, cullFace, drawType, drawOffset, vertexCount, instances) {
    vertexData = vertexData === VOID ? AGVertexArrayObject.k73([new AGVertexData()], true) : vertexData;
    indices = indices === VOID ? null : indices;
    indexType = indexType === VOID ? Companion_getInstance_41().x6u_1 : indexType;
    program = program === VOID ? DefaultShaders_getInstance().u77_1 : program;
    uniformBlocks = uniformBlocks === VOID ? Companion_getInstance_59().f6v_1 : uniformBlocks;
    textureUnits = textureUnits === VOID ? Companion_instance_31.h6v() : textureUnits;
    blending = blending === VOID ? Companion_getInstance_42().b6v_1 : blending;
    stencilOpFunc = stencilOpFunc === VOID ? Companion_getInstance_46().l6v_1 : stencilOpFunc;
    stencilRef = stencilRef === VOID ? Companion_getInstance_45().j6v_1 : stencilRef;
    colorMask = colorMask === VOID ? Companion_getInstance_47().o6v_1 : colorMask;
    depthAndFrontFace = depthAndFrontFace === VOID ? Companion_getInstance_48().t6v_1 : depthAndFrontFace;
    scissor = scissor === VOID ? Companion_getInstance_43().x6v_1 : scissor;
    cullFace = cullFace === VOID ? Companion_getInstance_49().z6v_1 : cullFace;
    drawType = drawType === VOID ? Companion_getInstance_40().b74_1 : drawType;
    drawOffset = drawOffset === VOID ? 0 : drawOffset;
    vertexCount = vertexCount === VOID ? 0 : vertexCount;
    instances = instances === VOID ? 1 : instances;
    this.q6w_1 = frameBuffer;
    this.r6w_1 = frameBufferInfo;
    this.s6w_1 = vertexData;
    this.t6w_1 = indices;
    this.u6w_1 = indexType;
    this.v6w_1 = program;
    this.w6w_1 = uniformBlocks;
    this.x6w_1 = textureUnits;
    this.y6w_1 = blending;
    this.z6w_1 = stencilOpFunc;
    this.a6x_1 = stencilRef;
    this.b6x_1 = colorMask;
    this.c6x_1 = depthAndFrontFace;
    this.d6x_1 = scissor;
    this.e6x_1 = cullFace;
    this.f6x_1 = drawType;
    this.g6x_1 = drawOffset;
    this.h6x_1 = vertexCount;
    this.i6x_1 = instances;
  }
  p6w(ag) {
    ag.q6u(this.q6w_1, this.r6w_1, this.s6w_1, this.v6w_1, this.f6x_1, this.h6x_1, this.t6w_1, this.u6w_1, this.g6x_1, this.y6w_1, this.w6w_1, this.x6w_1, this.a6x_1, this.z6w_1, this.b6x_1, this.c6x_1, this.d6x_1, this.e6x_1, this.i6x_1);
  }
  toString() {
    return 'AGBatch(frameBuffer=' + this.q6w_1.toString() + ', frameBufferInfo=' + AGFrameBufferInfo__toString_impl_xecyr8(this.r6w_1) + ', vertexData=' + this.s6w_1.toString() + ', indices=' + toString_1(this.t6w_1) + ', indexType=' + AGIndexType__toString_impl_hjqwm3(this.u6w_1) + ', program=' + this.v6w_1.toString() + ', uniformBlocks=' + toString(this.w6w_1) + ', textureUnits=' + this.x6w_1.toString() + ', blending=' + AGBlending__toString_impl_d5hic6(this.y6w_1) + ', stencilOpFunc=' + AGStencilOpFunc__toString_impl_pl8quy(this.z6w_1) + ', stencilRef=' + AGStencilReference__toString_impl_qu5r8s(this.a6x_1) + ', colorMask=' + AGColorMask__toString_impl_5i5oqg(this.b6x_1) + ', depthAndFrontFace=' + AGDepthAndFrontFace__toString_impl_c305m3(this.c6x_1) + ', scissor=' + this.d6x_1.toString() + ', cullFace=' + AGCullFace__toString_impl_7d891w(this.e6x_1) + ', drawType=' + AGDrawType__toString_impl_eonaeb(this.f6x_1) + ', drawOffset=' + this.g6x_1 + ', vertexCount=' + this.h6x_1 + ', instances=' + this.i6x_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.q6w_1);
    result = imul(result, 31) + AGFrameBufferInfo__hashCode_impl_fvl6f1(this.r6w_1) | 0;
    result = imul(result, 31) + this.s6w_1.hashCode() | 0;
    result = imul(result, 31) + (this.t6w_1 == null ? 0 : hashCode(this.t6w_1)) | 0;
    result = imul(result, 31) + AGIndexType__hashCode_impl_47f06s(this.u6w_1) | 0;
    result = imul(result, 31) + this.v6w_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.w6w_1) | 0;
    result = imul(result, 31) + this.x6w_1.hashCode() | 0;
    result = imul(result, 31) + AGBlending__hashCode_impl_ywnf51(this.y6w_1) | 0;
    result = imul(result, 31) + AGStencilOpFunc__hashCode_impl_nopebb(this.z6w_1) | 0;
    result = imul(result, 31) + AGStencilReference__hashCode_impl_52zufx(this.a6x_1) | 0;
    result = imul(result, 31) + AGColorMask__hashCode_impl_g9082f(this.b6x_1) | 0;
    result = imul(result, 31) + AGDepthAndFrontFace__hashCode_impl_xu62ey(this.c6x_1) | 0;
    result = imul(result, 31) + this.d6x_1.hashCode() | 0;
    result = imul(result, 31) + AGCullFace__hashCode_impl_t4e5ur(this.e6x_1) | 0;
    result = imul(result, 31) + AGDrawType__hashCode_impl_ylaury(this.f6x_1) | 0;
    result = imul(result, 31) + this.g6x_1 | 0;
    result = imul(result, 31) + this.h6x_1 | 0;
    result = imul(result, 31) + this.i6x_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGBatch))
      return false;
    var tmp0_other_with_cast = other instanceof AGBatch ? other : THROW_CCE();
    if (!equals(this.q6w_1, tmp0_other_with_cast.q6w_1))
      return false;
    if (!equals(this.r6w_1, tmp0_other_with_cast.r6w_1))
      return false;
    if (!this.s6w_1.equals(tmp0_other_with_cast.s6w_1))
      return false;
    if (!equals(this.t6w_1, tmp0_other_with_cast.t6w_1))
      return false;
    if (!(this.u6w_1 === tmp0_other_with_cast.u6w_1))
      return false;
    if (!this.v6w_1.equals(tmp0_other_with_cast.v6w_1))
      return false;
    if (!equals(this.w6w_1, tmp0_other_with_cast.w6w_1))
      return false;
    if (!this.x6w_1.equals(tmp0_other_with_cast.x6w_1))
      return false;
    if (!(this.y6w_1 === tmp0_other_with_cast.y6w_1))
      return false;
    if (!(this.z6w_1 === tmp0_other_with_cast.z6w_1))
      return false;
    if (!equals(this.a6x_1, tmp0_other_with_cast.a6x_1))
      return false;
    if (!(this.b6x_1 === tmp0_other_with_cast.b6x_1))
      return false;
    if (!(this.c6x_1 === tmp0_other_with_cast.c6x_1))
      return false;
    if (!this.d6x_1.equals(tmp0_other_with_cast.d6x_1))
      return false;
    if (!(this.e6x_1 === tmp0_other_with_cast.e6x_1))
      return false;
    if (!(this.f6x_1 === tmp0_other_with_cast.f6x_1))
      return false;
    if (!(this.g6x_1 === tmp0_other_with_cast.g6x_1))
      return false;
    if (!(this.h6x_1 === tmp0_other_with_cast.h6x_1))
      return false;
    if (!(this.i6x_1 === tmp0_other_with_cast.i6x_1))
      return false;
    return true;
  }
}
class Companion_35 {
  constructor() {
    Companion_instance_44 = this;
    this.l6w_1 = _AGReadKind___init__impl__sw15xt(0);
    this.m6w_1 = _AGReadKind___init__impl__sw15xt(1);
    this.n6w_1 = _AGReadKind___init__impl__sw15xt(2);
  }
}
class Companion_36 {
  constructor() {
    Companion_instance_45 = this;
    this.a70_1 = _AGTextureTargetKind___init__impl__4zdmch(0);
    this.b70_1 = _AGTextureTargetKind___init__impl__4zdmch(1);
    this.c70_1 = _AGTextureTargetKind___init__impl__4zdmch(2);
    this.d70_1 = _AGTextureTargetKind___init__impl__4zdmch(3);
  }
}
class AGTextureTargetKind {
  constructor(ordinal) {
    Companion_getInstance_51();
    this.f70_1 = ordinal;
  }
  toString() {
    return AGTextureTargetKind__toString_impl_68648p(this.f70_1);
  }
  hashCode() {
    return AGTextureTargetKind__hashCode_impl_rzc11k(this.f70_1);
  }
  equals(other) {
    return AGTextureTargetKind__equals_impl_q2tams(this.f70_1, other);
  }
}
class Companion_37 {
  constructor() {
    Companion_instance_46 = this;
    this.z70_1 = _AGWrapMode___init__impl__x5wmya(0);
    this.a71_1 = _AGWrapMode___init__impl__x5wmya(1);
    this.b71_1 = _AGWrapMode___init__impl__x5wmya(2);
  }
}
class AGWrapMode {
  constructor(ordinal) {
    Companion_getInstance_52();
    this.w77_1 = ordinal;
  }
  toString() {
    return AGWrapMode__toString_impl_8bjnw2(this.w77_1);
  }
  hashCode() {
    return AGWrapMode__hashCode_impl_u2pkox(this.w77_1);
  }
  equals(other) {
    return AGWrapMode__equals_impl_4aw0kl(this.w77_1, other);
  }
}
class Companion_38 {
  constructor() {
    Companion_instance_47 = this;
    this.j74_1 = _AGBlendFactor___init__impl__iqtmxr(0);
    this.k74_1 = _AGBlendFactor___init__impl__iqtmxr(1);
    this.l74_1 = _AGBlendFactor___init__impl__iqtmxr(2);
    this.m74_1 = _AGBlendFactor___init__impl__iqtmxr(3);
    this.n74_1 = _AGBlendFactor___init__impl__iqtmxr(4);
    this.o74_1 = _AGBlendFactor___init__impl__iqtmxr(5);
    this.p74_1 = _AGBlendFactor___init__impl__iqtmxr(6);
    this.q74_1 = _AGBlendFactor___init__impl__iqtmxr(7);
    this.r74_1 = _AGBlendFactor___init__impl__iqtmxr(8);
    this.s74_1 = _AGBlendFactor___init__impl__iqtmxr(9);
  }
}
class AGBlendFactor {
  constructor(ordinal) {
    Companion_getInstance_53();
    this.x77_1 = ordinal;
  }
  toString() {
    return AGBlendFactor__toString_impl_1hr6m1(this.x77_1);
  }
  hashCode() {
    return AGBlendFactor__hashCode_impl_n8x3ew(this.x77_1);
  }
  equals(other) {
    return AGBlendFactor__equals_impl_dlauac(this.x77_1, other);
  }
}
class Companion_39 {
  constructor() {
    Companion_instance_48 = this;
    this.w74_1 = _AGBlendEquation___init__impl__fpv7c2(0);
    this.x74_1 = _AGBlendEquation___init__impl__fpv7c2(1);
    this.y74_1 = _AGBlendEquation___init__impl__fpv7c2(2);
  }
}
class AGBlendEquation {
  constructor(ordinal) {
    Companion_getInstance_54();
    this.y77_1 = ordinal;
  }
  toString() {
    return AGBlendEquation__toString_impl_5t2sx6(this.y77_1);
  }
  hashCode() {
    return AGBlendEquation__hashCode_impl_fy33vp(this.y77_1);
  }
  equals(other) {
    return AGBlendEquation__equals_impl_yykk3b(this.y77_1, other);
  }
}
class Companion_40 {
  z77() {
    return _AGSize___init__impl__h9blcq(-2);
  }
  n75(width, height) {
    return AGSize__with_impl_qn6qww(_AGSize___init__impl__h9blcq(0), width, height);
  }
}
class Companion_41 {
  constructor() {
    Companion_instance_50 = this;
    this.k76_1 = _AGStencilOp___init__impl__llpkv6(0);
    this.l76_1 = _AGStencilOp___init__impl__llpkv6(1);
    this.m76_1 = _AGStencilOp___init__impl__llpkv6(2);
    this.n76_1 = _AGStencilOp___init__impl__llpkv6(3);
    this.o76_1 = _AGStencilOp___init__impl__llpkv6(4);
    this.p76_1 = _AGStencilOp___init__impl__llpkv6(5);
    this.q76_1 = _AGStencilOp___init__impl__llpkv6(6);
    this.r76_1 = _AGStencilOp___init__impl__llpkv6(7);
  }
}
class AGStencilOp {
  constructor(ordinal) {
    Companion_getInstance_56();
    this.a78_1 = ordinal;
  }
  toString() {
    return AGStencilOp__toString_impl_1dm6fq(this.a78_1);
  }
  hashCode() {
    return AGStencilOp__hashCode_impl_n4s38l(this.a78_1);
  }
  equals(other) {
    return AGStencilOp__equals_impl_rq4p55(this.a78_1, other);
  }
}
class Companion_42 {
  constructor() {
    Companion_instance_51 = this;
    this.c76_1 = _AGCompareMode___init__impl__j8kqbb(0);
    this.d76_1 = _AGCompareMode___init__impl__j8kqbb(1);
    this.e76_1 = _AGCompareMode___init__impl__j8kqbb(2);
    this.f76_1 = _AGCompareMode___init__impl__j8kqbb(3);
    this.g76_1 = _AGCompareMode___init__impl__j8kqbb(4);
    this.h76_1 = _AGCompareMode___init__impl__j8kqbb(5);
    this.i76_1 = _AGCompareMode___init__impl__j8kqbb(6);
    this.j76_1 = _AGCompareMode___init__impl__j8kqbb(7);
  }
}
class AGCompareMode {
  constructor(ordinal) {
    Companion_getInstance_57();
    this.b78_1 = ordinal;
  }
  toString() {
    return AGCompareMode__toString_impl_gs33a9(this.b78_1);
  }
  hashCode() {
    return AGCompareMode__hashCode_impl_whv1w0(this.b78_1);
  }
  equals(other) {
    return AGCompareMode__equals_impl_rbniy4(this.b78_1, other);
  }
}
class Companion_43 {
  constructor() {
    Companion_instance_52 = this;
    this.x76_1 = _AGFrontFace___init__impl__vsm7rb(0);
    this.y76_1 = _AGFrontFace___init__impl__vsm7rb(1);
    this.z76_1 = _AGFrontFace___init__impl__vsm7rb(2);
  }
}
class AGMultiBatch {
  constructor(list) {
    this.o6w_1 = list;
  }
  p6w(ag) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.o6w_1;
    var n = 0;
    while (n < this_0.e1()) {
      // Inline function 'korlibs.graphics.AGMultiBatch.execute.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      this_0.d1(_unary__edvuaz).p6w(ag);
    }
  }
  toString() {
    return 'AGMultiBatch(list=' + toString(this.o6w_1) + ')';
  }
  hashCode() {
    return hashCode(this.o6w_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGMultiBatch))
      return false;
    var tmp0_other_with_cast = other instanceof AGMultiBatch ? other : THROW_CCE();
    if (!equals(this.o6w_1, tmp0_other_with_cast.o6w_1))
      return false;
    return true;
  }
}
class AGConfig {
  constructor(antialiasHint) {
    antialiasHint = antialiasHint === VOID ? true : antialiasHint;
    this.c78_1 = antialiasHint;
  }
  toString() {
    return 'AGConfig(antialiasHint=' + this.c78_1 + ')';
  }
  hashCode() {
    return getBooleanHashCode(this.c78_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AGConfig))
      return false;
    var tmp0_other_with_cast = other instanceof AGConfig ? other : THROW_CCE();
    if (!(this.c78_1 === tmp0_other_with_cast.c78_1))
      return false;
    return true;
  }
}
class AGBufferKind extends Enum {}
class AGStats {
  constructor(texturesCount, texturesMemory, buffersCount, buffersMemory, frameBuffersCount, frameBuffersMemory, texturesCreated, texturesDeleted, programCount) {
    texturesCount = texturesCount === VOID ? 0 : texturesCount;
    texturesMemory = texturesMemory === VOID ? Companion_getInstance_9().h17(0) : texturesMemory;
    buffersCount = buffersCount === VOID ? 0 : buffersCount;
    buffersMemory = buffersMemory === VOID ? Companion_getInstance_9().h17(0) : buffersMemory;
    frameBuffersCount = frameBuffersCount === VOID ? 0 : frameBuffersCount;
    frameBuffersMemory = frameBuffersMemory === VOID ? Companion_getInstance_9().h17(0) : frameBuffersMemory;
    texturesCreated = texturesCreated === VOID ? 0 : texturesCreated;
    texturesDeleted = texturesDeleted === VOID ? 0 : texturesDeleted;
    programCount = programCount === VOID ? 0 : programCount;
    this.d78_1 = texturesCount;
    this.e78_1 = texturesMemory;
    this.f78_1 = buffersCount;
    this.g78_1 = buffersMemory;
    this.h78_1 = frameBuffersCount;
    this.i78_1 = frameBuffersMemory;
    this.j78_1 = texturesCreated;
    this.k78_1 = texturesDeleted;
    this.l78_1 = programCount;
  }
  toString() {
    return 'AGStats(textures[' + this.d78_1 + '] = ' + ByteUnits__toString_impl_ox2ku2(this.e78_1) + ', buffers[' + this.f78_1 + '] = ' + ByteUnits__toString_impl_ox2ku2(this.g78_1) + ', frameBuffers[' + this.h78_1 + '] = ' + ByteUnits__toString_impl_ox2ku2(this.i78_1) + ', programs[' + this.l78_1 + '])';
  }
}
class UniformBlock {
  constructor(fixedLocation) {
    this.a73_1 = fixedLocation;
    this.b73_1 = new UBLayoutBuilder();
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.c73_1 = ArrayList.i1();
    this.d73_1 = 0;
  }
  u3() {
    return get_portableSimpleName(getKClassFromExpression(this));
  }
  f79() {
    return this.c73_1;
  }
  g79() {
    return this.b73_1.e1();
  }
  h79() {
    return nextMultipleOf(this.g79(), 256);
  }
  i79() {
    return this.f79().e1();
  }
  j79(name) {
    return this.o79(name, VarType_Float1_getInstance(), 4, 4);
  }
  k79(name, $super) {
    name = name === VOID ? null : name;
    return $super === VOID ? this.j79(name) : $super.j79.call(this, name);
  }
  l79(name) {
    return this.o79(name, VarType_Float4_getInstance(), 16, 16);
  }
  m79(name, $super) {
    name = name === VOID ? null : name;
    return $super === VOID ? this.l79(name) : $super.l79.call(this, name);
  }
  n79(name) {
    return this.o79(name, VarType_Mat4_getInstance(), 64, 16);
  }
  s78(name, $super) {
    name = name === VOID ? null : name;
    return $super === VOID ? this.n79(name) : $super.n79.call(this, name);
  }
  o79(name, type, size, align) {
    var tmp = this.b73_1.u7o(size, align);
    var _unary__edvuaz = this.d73_1;
    this.d73_1 = _unary__edvuaz + 1 | 0;
    return new Gen(this, name, tmp, _unary__edvuaz, type, 1, size, align);
  }
  toString() {
    return 'UniformBlock[' + get_portableSimpleName(getKClassFromExpression(this)) + '][' + joinToString(this.f79(), ', ') + ', fixedLocation=' + this.a73_1 + ']';
  }
}
class ProjViewUB extends UniformBlock {
  constructor() {
    ProjViewUB_instance = null;
    super(0);
    ProjViewUB_instance = this;
    this.q78_1 = this.s78().c79(this, u_ProjMat$factory());
    this.r78_1 = this.s78().c79(this, u_ViewMat$factory());
  }
  d79() {
    return this.q78_1.wo(this, u_ProjMat$factory_0());
  }
  e79() {
    return this.r78_1.wo(this, u_ViewMat$factory_0());
  }
}
class DefaultShaders {
  constructor() {
    DefaultShaders_instance = this;
    this.b77_1 = Sampler_0(1, SamplerVarType_Sampler2D_getInstance()).r79(this, u_Tex$factory());
    this.c77_1 = Sampler_0(2, SamplerVarType_Sampler2D_getInstance()).r79(this, u_TexEx$factory());
    this.d77_1 = Attribute.i7a('a_Pos', VarType_Float2_getInstance(), false, Precision_HIGH_getInstance(), 0);
    this.e77_1 = Attribute.i7a('a_Tex', VarType_Float2_getInstance(), false, Precision_MEDIUM_getInstance(), 1);
    this.f77_1 = Attribute.i7a('a_Col', VarType_UByte4_getInstance(), true, Precision_LOW_getInstance(), 2);
    this.g77_1 = Varying.u7a('v_Tex', VarType_Float2_getInstance(), Precision_MEDIUM_getInstance());
    this.h77_1 = Varying.u7a('v_Col', VarType_Float4_getInstance());
    this.i77_1 = Temp.g7b(0, VarType_Float4_getInstance());
    this.j77_1 = Temp.g7b(1, VarType_Float4_getInstance());
    this.k77_1 = Temp.g7b(2, VarType_Mat2_getInstance());
    this.l77_1 = ProgramLayout.t73([this.d77_1, this.e77_1, this.f77_1]);
    var tmp = this;
    // Inline function 'korlibs.graphics.shader.VertexShader' call
    var builder = ProgramBuilderDefault.j7b();
    // Inline function 'korlibs.graphics.DefaultShaders.VERTEX_DEFAULT.<anonymous>' call
    builder.o7b(builder.k7b(), builder.l7b());
    builder.o7b(builder.p7b(), builder.q7b());
    builder.o7b(builder.r7b(), builder.s7b(builder.s7b(builder.d79(), builder.e79()), builder.v7b([builder.t7b(), builder.u7b(0.0), builder.u7b(1.0)])));
    tmp.m77_1 = VertexShader(builder.w7b());
    var tmp_0 = this;
    // Inline function 'korlibs.graphics.FragmentShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_0 = ProgramBuilderDefault.j7b();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.DefaultShaders.MERGE_ALPHA_PROGRAM.<anonymous>' call
    var coords = this_0.x7b(this_0.k7b(), 'xy');
    this_0.o7b(this_0.r7b(), this_0.s7b(this_0.z7b(this_0.y7b(), coords), this_0.b7c(this_0.z7b(DefaultShaders_getInstance().a7c(), coords))));
    var tmp$ret$2 = FragmentShader(this_0.w7b());
    tmp_0.n77_1 = new Program(this.m77_1, tmp$ret$2);
    var tmp_1 = this;
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_0 = ProgramBuilderDefault.j7b();
    // Inline function 'korlibs.graphics.DefaultShaders.FRAGMENT_DEBUG.<anonymous>' call
    builder_0.o7b(builder_0.r7b(), builder_0.v7b([builder_0.u7b(1.0), builder_0.u7b(1.0), builder_0.u7b(0.0), builder_0.u7b(1.0)]));
    tmp_1.o77_1 = FragmentShader(builder_0.w7b());
    var tmp_2 = this;
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_1 = ProgramBuilderDefault.j7b();
    // Inline function 'korlibs.graphics.DefaultShaders.FRAGMENT_SOLID_COLOR.<anonymous>' call
    builder_1.o7b(builder_1.r7b(), builder_1.p7b());
    tmp_2.p77_1 = FragmentShader(builder_1.w7b());
    var tmp_3 = this;
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_2 = ProgramBuilderDefault.j7b();
    // Inline function 'korlibs.graphics.DefaultShaders.PROGRAM_TINTED_TEXTURE.<anonymous>' call
    builder_2.o7b(builder_2.r7b(), builder_2.s7b(builder_2.x7b(builder_2.z7b(builder_2.y7b(), builder_2.x7b(builder_2.k7b(), 'xy')), 'rgba'), builder_2.p7b()));
    var tmp$ret$5 = FragmentShader(builder_2.w7b());
    tmp_3.q77_1 = new Program(this.m77_1, tmp$ret$5, 'PROGRAM_TINTED_TEXTURE');
    var tmp_4 = this;
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_3 = ProgramBuilderDefault.j7b();
    // Inline function 'korlibs.graphics.DefaultShaders.PROGRAM_TINTED_TEXTURE_PREMULT.<anonymous>' call
    builder_3.o7b(builder_3.c7c(), builder_3.z7b(builder_3.y7b(), builder_3.x7b(builder_3.k7b(), 'xy')));
    builder_3.o7b(builder_3.x7b(builder_3.c7c(), 'rgb'), builder_3.d7c(builder_3.x7b(builder_3.c7c(), 'rgb'), builder_3.x7b(builder_3.c7c(), 'a')));
    builder_3.o7b(builder_3.r7b(), builder_3.s7b(builder_3.x7b(builder_3.c7c(), 'rgba'), builder_3.p7b()));
    var tmp$ret$6 = FragmentShader(builder_3.w7b());
    tmp_4.r77_1 = new Program(this.m77_1, tmp$ret$6, 'PROGRAM_TINTED_TEXTURE');
    this.s77_1 = new Program(this.m77_1, this.p77_1, 'PROGRAM_SOLID_COLOR');
    this.t77_1 = ProgramLayout.t73([this.d77_1]);
    var tmp_5 = this;
    // Inline function 'korlibs.graphics.shader.VertexShader' call
    var builder_4 = ProgramBuilderDefault.j7b();
    // Inline function 'korlibs.graphics.DefaultShaders.PROGRAM_DEBUG.<anonymous>' call
    builder_4.o7b(builder_4.r7b(), builder_4.v7b([builder_4.t7b(), builder_4.u7b(0.0), builder_4.u7b(1.0)]));
    var tmp_6 = VertexShader(builder_4.w7b());
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_5 = ProgramBuilderDefault.j7b();
    // Inline function 'korlibs.graphics.DefaultShaders.PROGRAM_DEBUG.<anonymous>' call
    builder_5.o7b(builder_5.r7b(), builder_5.v7b([builder_5.u7b(1.0), builder_5.u7b(0.0), builder_5.u7b(0.0), builder_5.u7b(1.0)]));
    var tmp$ret$8 = FragmentShader(builder_5.w7b());
    tmp_5.u77_1 = new Program(tmp_6, tmp$ret$8, 'PROGRAM_DEBUG');
    var tmp_7 = this;
    // Inline function 'korlibs.graphics.shader.VertexShader' call
    var builder_6 = ProgramBuilderDefault.j7b();
    // Inline function 'korlibs.graphics.DefaultShaders.PROGRAM_DEBUG_WITH_PROJ.<anonymous>' call
    builder_6.o7b(builder_6.r7b(), builder_6.s7b(builder_6.s7b(builder_6.d79(), builder_6.e79()), builder_6.v7b([builder_6.t7b(), builder_6.u7b(0.0), builder_6.u7b(1.0)])));
    var tmp_8 = VertexShader(builder_6.w7b());
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_7 = ProgramBuilderDefault.j7b();
    // Inline function 'korlibs.graphics.DefaultShaders.PROGRAM_DEBUG_WITH_PROJ.<anonymous>' call
    builder_7.o7b(builder_7.r7b(), builder_7.v7b([builder_7.u7b(1.0), builder_7.u7b(0.0), builder_7.u7b(0.0), builder_7.u7b(1.0)]));
    var tmp$ret$10 = FragmentShader(builder_7.w7b());
    tmp_7.v77_1 = new Program(tmp_8, tmp$ret$10, 'PROGRAM_DEBUG_WITH_PROJ');
  }
  y7b() {
    return this.b77_1.wo(this, u_Tex$factory_0());
  }
  a7c() {
    return this.c77_1.wo(this, u_TexEx$factory_0());
  }
  d79() {
    return ProjViewUB_getInstance().d79().z72_1;
  }
  e79() {
    return ProjViewUB_getInstance().e79().z72_1;
  }
}
class VarTypeAccessor {}
function get_Float1() {
  return VarType_Float1_getInstance();
}
function get_Float2() {
  return VarType_Float2_getInstance();
}
function get_Float4() {
  return VarType_Float4_getInstance();
}
class ExpressionBuilder {}
function get_out() {
  return Output_getInstance();
}
function atan(y, x) {
  return Func.m7y('atan', [y, x], y.i2h());
}
function texture2D(sampler, coord) {
  return Func.m7y('texture2D', [sampler, coord], VarType_Float4_getInstance());
}
function TERNARY(cond, otrue, ofalse) {
  return Ternary.y7x(cond, otrue, ofalse);
}
function pow(b, e) {
  return Func.m7y('pow', [b, e], b.i2h());
}
function sqrt(v) {
  return Func.m7y('sqrt', [v], v.i2h());
}
function abs(v) {
  return Func.m7y('abs', [v], v.i2h());
}
function fract(v) {
  return Func.m7y('fract', [v], v.i2h());
}
function clamp(v, min, max) {
  return Func.m7y('clamp', [v, min, max], v.i2h());
}
function min_0(a, b) {
  return Func.m7y('min', [a, b], a.i2h());
}
function max_1(a, b) {
  return Func.m7y('max', [a, b], a.i2h());
}
function fwidth(a) {
  return Func.m7y('fwidth', [a], a.i2h());
}
function mix(a, b, step) {
  return Func.m7y('mix', [a, b, step], a.i2h());
}
function smoothstep(a, b, c) {
  return Func.m7y('smoothstep', [a, b, c], a.i2h());
}
function length(a) {
  return Func.m7y('length', [a], VarType_Float1_getInstance());
}
function get_lit(_this__u8e3s4) {
  return FloatLiteral.c7y(_this__u8e3s4);
}
function vec2(ops) {
  return Vector.d7y(VarType_Float2_getInstance(), ops);
}
function vec4(ops) {
  return Vector.d7y(VarType_Float4_getInstance(), ops);
}
function get_1(_this__u8e3s4, swizzle) {
  return Swizzle.e7y(_this__u8e3s4, swizzle);
}
function get_x(_this__u8e3s4) {
  return this.x7b(_this__u8e3s4, 'x');
}
function get_y(_this__u8e3s4) {
  return this.x7b(_this__u8e3s4, 'y');
}
function get_z(_this__u8e3s4) {
  return this.x7b(_this__u8e3s4, 'z');
}
function get_w(_this__u8e3s4) {
  return this.x7b(_this__u8e3s4, 'w');
}
function get_a(_this__u8e3s4) {
  return this.x7b(_this__u8e3s4, 'w');
}
function unaryMinus(_this__u8e3s4) {
  return Unop.a7y('-', _this__u8e3s4);
}
function minus_0(_this__u8e3s4, that) {
  return Binop.b7y(_this__u8e3s4, '-', that);
}
function plus_2(_this__u8e3s4, that) {
  return Binop.b7y(_this__u8e3s4, '+', that);
}
function times(_this__u8e3s4, that) {
  return Binop.b7y(_this__u8e3s4, '*', that);
}
function div(_this__u8e3s4, that) {
  return Binop.b7y(_this__u8e3s4, '/', that);
}
function eq(_this__u8e3s4, that) {
  return Binop.b7y(_this__u8e3s4, '==', that);
}
function lt(_this__u8e3s4, that) {
  return Binop.b7y(_this__u8e3s4, '<', that);
}
function le(_this__u8e3s4, that) {
  return Binop.b7y(_this__u8e3s4, '<=', that);
}
function gt(_this__u8e3s4, that) {
  return Binop.b7y(_this__u8e3s4, '>', that);
}
function minus_1(_this__u8e3s4, that) {
  return this.n7d(this.u7b(_this__u8e3s4), that);
}
function plus_3(_this__u8e3s4, that) {
  return this.o7d(this.u7b(_this__u8e3s4), that);
}
function times_0(_this__u8e3s4, that) {
  return this.s7b(this.u7b(_this__u8e3s4), that);
}
function plus_4(_this__u8e3s4, that) {
  return this.o7d(_this__u8e3s4, this.u7b(that));
}
function gt_0(_this__u8e3s4, that) {
  return this.s7d(_this__u8e3s4, this.u7b(that));
}
class Builder {
  static e7c(context) {
    context = context === VOID ? new BuilderContext() : context;
    var $this = createThis(this);
    $this.m7b_1 = context;
    var tmp = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.n7b_1 = ArrayList.i1();
    return $this;
  }
  static u7w(parent) {
    return this.e7c(parent.m7b_1);
  }
  f7c() {
    return Builder.u7w(this);
  }
  g7c() {
    return FuncBuilder.t7w(this);
  }
  h7c() {
    return new Stms(toList(this.n7b_1));
  }
  i7c() {
    var funcs = LinkedHashMap.rc();
    (new Program$Builder$_funcs$1(funcs)).x7x(this.n7b_1);
    var _iterator__ex2g4s = this.m7b_1.p7y_1.a1();
    while (_iterator__ex2g4s.b1()) {
      var func = _iterator__ex2g4s.c1();
      // Inline function 'kotlin.collections.set' call
      var key = func.y7t_1;
      funcs.j3(key, func);
    }
    return toList(funcs.n3());
  }
  w7b() {
    return to(this.h7c(), this.i7c());
  }
  j7c(name, rettype, block) {
    // Inline function 'kotlin.apply' call
    var this_0 = this.g7c();
    // Inline function 'kotlin.contracts.contract' call
    block(this_0);
    var funcBuild = this_0;
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.collections.map' call
    var this_1 = funcBuild.r7w_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_1, 10));
    var tmp0_iterator = this_1.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.graphics.shader.Builder.FUNC.<anonymous>' call
      var tmp$ret$1 = to(item.u7g_1, item.i2h());
      destination.h(tmp$ret$1);
    }
    var this_2 = new FuncDecl(name, rettype, destination, funcBuild.h7c());
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.Builder.FUNC.<anonymous>' call
    // Inline function 'kotlin.collections.plusAssign' call
    this.m7b_1.p7y_1.h(this_2);
    return this_2;
  }
  k7c(p0, dummy, returns, block) {
    var tmp = listOf(p0);
    return new FuncProvider(returns, tmp, this, Program$Builder$FUNC$lambda(block));
  }
  l7c(p0, dummy, returns, block, $super) {
    dummy = dummy === VOID ? Unit_instance : dummy;
    var tmp;
    if ($super === VOID) {
      tmp = this.k7c(p0, dummy, returns, block);
    } else {
      var tmp_0 = $super.k7c;
      tmp = tmp_0.call(this, p0, Unit_instance, returns, block);
    }
    return tmp;
  }
  m7c(p0, p1, dummy, returns, block) {
    var tmp = listOf_0([p0, p1]);
    return new FuncProvider(returns, tmp, this, Program$Builder$FUNC$lambda_0(block));
  }
  n7c(p0, p1, dummy, returns, block, $super) {
    dummy = dummy === VOID ? Unit_instance : dummy;
    var tmp;
    if ($super === VOID) {
      tmp = this.m7c(p0, p1, dummy, returns, block);
    } else {
      var tmp_0 = $super.m7c;
      tmp = tmp_0.call(this, p0, p1, Unit_instance, returns, block);
    }
    return tmp;
  }
  o7c(p0, p1, p2, dummy, returns, block) {
    var tmp = listOf_0([p0, p1, p2]);
    return new FuncProvider(returns, tmp, this, Program$Builder$FUNC$lambda_1(block));
  }
  p7c(p0, p1, p2, dummy, returns, block, $super) {
    dummy = dummy === VOID ? Unit_instance : dummy;
    var tmp;
    if ($super === VOID) {
      tmp = this.o7c(p0, p1, p2, dummy, returns, block);
    } else {
      var tmp_0 = $super.o7c;
      tmp = tmp_0.call(this, p0, p1, p2, Unit_instance, returns, block);
    }
    return tmp;
  }
  q7c(type) {
    var _receiver__tnumb7 = this.m7b_1;
    var _unary__edvuaz = _receiver__tnumb7.q7y_1;
    _receiver__tnumb7.q7y_1 = _unary__edvuaz + 1 | 0;
    return Temp.g7b(_unary__edvuaz, type);
  }
  h7x(initialValue) {
    var temp = this.q7c(initialValue.i2h());
    this.o7b(temp, initialValue);
    return temp;
  }
  r7c(_this__u8e3s4, p0) {
    return CustomFunc.n7y(_this__u8e3s4, listOf(p0));
  }
  s7c(_this__u8e3s4, p0, p1, p2) {
    return CustomFunc.n7y(_this__u8e3s4, listOf_0([p0, p1, p2]));
  }
  t7c(_this__u8e3s4, callback) {
    var body = this.f7c();
    callback(body);
    _this__u8e3s4.l7v_1 = body.h7c();
  }
  u7c(ref, min, max, block) {
    if (min >= max) {
      block(this, min);
    } else if ((max - min | 0) <= 1) {
      // Inline function 'korlibs.graphics.shader.Builder.IF' call
      var cond = this.p7d(ref, this.u7b(min));
      var body = this.f7c();
      // Inline function 'korlibs.graphics.shader.Builder.IF_ELSE_BINARY_LOOKUP.<anonymous>' call
      block(body, min);
      var stmIf = new If(cond, body.h7c());
      // Inline function 'kotlin.collections.plusAssign' call
      this.n7b_1.h(stmIf);
      var tmp = stmIf;
      this.t7c(tmp, Program$Builder$IF_ELSE_BINARY_LOOKUP$lambda(block, max));
    } else {
      var middle = (min + max | 0) / 2 | 0;
      // Inline function 'korlibs.graphics.shader.Builder.IF' call
      var cond_0 = this.r7d(ref, this.u7b(middle));
      var body_0 = this.f7c();
      // Inline function 'korlibs.graphics.shader.Builder.IF_ELSE_BINARY_LOOKUP.<anonymous>' call
      body_0.u7c(ref, min, middle, block);
      var stmIf_0 = new If(cond_0, body_0.h7c());
      // Inline function 'kotlin.collections.plusAssign' call
      this.n7b_1.h(stmIf_0);
      var tmp_0 = stmIf_0;
      this.t7c(tmp_0, Program$Builder$IF_ELSE_BINARY_LOOKUP$lambda_0(ref, middle, max, block));
    }
  }
  v7c(ref, min, max, block) {
    if (min >= max) {
      block(this, min);
    } else {
      // Inline function 'korlibs.graphics.shader.Builder.IF' call
      var cond = this.p7d(ref, this.u7b(min));
      var body = this.f7c();
      // Inline function 'korlibs.graphics.shader.Builder.IF_ELSE_LIST.<anonymous>' call
      block(body, min);
      var stmIf = new If(cond, body.h7c());
      // Inline function 'kotlin.collections.plusAssign' call
      this.n7b_1.h(stmIf);
      var tmp = stmIf;
      this.t7c(tmp, Program$Builder$IF_ELSE_LIST$lambda(ref, min, max, block));
    }
  }
  o7b(target, expr) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.n7b_1;
    var element = new Set(target, expr);
    this_0.h(element);
  }
  w7c() {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.n7b_1;
    var element = Discard_getInstance();
    this_0.h(element);
  }
  x7c(operand) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.n7b_1;
    var element = new Return(operand);
    this_0.h(element);
  }
  y7c(operand, $super) {
    operand = operand === VOID ? null : operand;
    var tmp;
    if ($super === VOID) {
      this.x7c(operand);
      tmp = Unit_instance;
    } else {
      tmp = $super.x7c.call(this, operand);
    }
    return tmp;
  }
  z7c(type) {
    var _receiver__tnumb7 = this.m7b_1;
    var _unary__edvuaz = _receiver__tnumb7.q7y_1;
    _receiver__tnumb7.q7y_1 = _unary__edvuaz + 1 | 0;
    return Temp.r7y(_unary__edvuaz, type, 1);
  }
}
class IDefaultShaders {}
function get_u_Tex() {
  return DefaultShaders_getInstance().y7b();
}
function get_u_ProjMat() {
  return DefaultShaders_getInstance().d79();
}
function get_u_ViewMat() {
  return DefaultShaders_getInstance().e79();
}
function get_a_Pos() {
  return DefaultShaders_getInstance().d77_1;
}
function get_a_Tex() {
  return DefaultShaders_getInstance().e77_1;
}
function get_a_Col() {
  return DefaultShaders_getInstance().f77_1;
}
function get_v_Tex() {
  return DefaultShaders_getInstance().g77_1;
}
function get_v_Col() {
  return DefaultShaders_getInstance().h77_1;
}
function get_t_Temp0() {
  return DefaultShaders_getInstance().i77_1;
}
function get_t_Temp1() {
  return DefaultShaders_getInstance().j77_1;
}
class ProgramBuilderDefault extends Builder {
  static j7b() {
    return this.e7c();
  }
}
class GLVAO {
  constructor(vao, glId, contextVersion) {
    glId = glId === VOID ? -1 : glId;
    contextVersion = contextVersion === VOID ? -1 : contextVersion;
    this.u7d_1 = vao;
    this.v7d_1 = glId;
    this.w7d_1 = contextVersion;
  }
}
class ShaderException extends RuntimeException {
  static h7e(str, error, errorInt, gl, debugName, type, shaderReturnInt) {
    var $this = this.za('Error Compiling Shader : ' + debugName + ' type=' + type + ' : ' + get_hex(errorInt) + " : '" + error + "' : source='" + str + "', shaderReturnInt=" + shaderReturnInt + ', gl.versionInt=' + get_versionInt(gl) + ", gl.versionString='" + get_versionString(gl) + "', gl=" + toString(gl));
    captureStack($this, $this.g7e_1);
    $this.z7d_1 = str;
    $this.a7e_1 = error;
    $this.b7e_1 = errorInt;
    $this.c7e_1 = gl;
    $this.d7e_1 = debugName;
    $this.e7e_1 = type;
    $this.f7e_1 = shaderReturnInt;
    return $this;
  }
}
class TextureUnitParams {
  constructor(index) {
    this.i7h_1 = index;
    this.j7h_1 = _AGWrapMode___init__impl__x5wmya(-1);
    this.k7h_1 = -1;
    this.l7h_1 = -1;
    this.m7h_1 = -1;
    this.n7h_1 = -1;
  }
  j2y() {
    this.j7h_1 = _AGWrapMode___init__impl__x5wmya(-1);
    this.k7h_1 = -1;
    this.l7h_1 = -1;
    this.m7h_1 = -1;
    this.n7h_1 = -1;
  }
}
class AGOpengl extends AG {
  static w7j(gl, context) {
    context = context === VOID ? null : context;
    var $this = this.v6t();
    $this.m7e_1 = gl;
    $this.n7e_1 = context;
    var tmp = $this;
    // Inline function 'kotlin.collections.linkedSetOf' call
    tmp.o7e_1 = LinkedHashSet.h1();
    $this.p7e_1 = new GLGlobalState($this.m7e_1, $this);
    $this.q7e_1 = HashMap.y8();
    $this.r7e_1 = null;
    var tmp_0 = $this;
    tmp_0.s7e_1 = lazy(AGOpengl$glslConfig$delegate$lambda($this));
    $this.t7e_1 = null;
    $this.u7e_1 = Companion_getInstance_42().z6u_1;
    $this.v7e_1 = Companion_getInstance_49().y6v_1;
    $this.w7e_1 = Companion_getInstance_46().k6v_1;
    $this.x7e_1 = Companion_getInstance_45().i6v_1;
    $this.y7e_1 = Companion_getInstance_47().m6v_1;
    $this.z7e_1 = Companion_getInstance_48().s6v_1;
    $this.a7f_1 = null;
    $this.b7f_1 = AGTextureUnits.z6x();
    $this.c7f_1 = new Int32Array($this.b7f_1.e1());
    $this.d7f_1 = 0;
    $this.e7f_1 = Companion_getInstance_43().w6v_1;
    $this.f7f_1 = -1;
    $this.g7f_1 = -1;
    $this.h7f_1 = get_ENABLE_VERTEX_ARRAY_OBJECTS();
    $this.i7f_1 = Ref();
    $this.j7f_1 = Buffer.b15(36);
    var tmp_1 = $this;
    var tmp_2 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_3 = fillArrayVal(Array(32), null);
    while (tmp_2 < 32) {
      var tmp_4 = tmp_2;
      tmp_3[tmp_4] = new TextureUnitParams(tmp_4);
      tmp_2 = tmp_2 + 1 | 0;
    }
    tmp_1.k7f_1 = tmp_3;
    $this.l7f_1 = allocDirect(Companion_instance_4, 0);
    $this.m7f_1 = 7;
    $this.n7f_1 = 0;
    $this.o7f_1 = Companion_instance_49.z77();
    $this.p7f_1 = -1;
    $this.q7f_1 = new Long(-1, -1);
    $this.r7f_1 = null;
    return $this;
  }
  static x7j(context) {
    return this.w7j(context.z7j_1, context);
  }
  s6u() {
    return this.m7e_1;
  }
  l6u() {
    var gl = this.m7e_1;
    super.l6u();
    gl.b7k();
    gl.c7k();
    this.q7e_1.m3();
    resetObjects(this);
    this.f7f_1 = -1;
    this.g7f_1 = -1;
    this.h7f_1 = true;
  }
  p6u(frameBuffer, frameBufferInfo, color, depth, stencil, clearColor, clearDepth, clearStencil, scissor) {
    var gl = this.m7e_1;
    this.d7k(frameBuffer, frameBufferInfo);
    this.e7k(scissor, frameBuffer, frameBufferInfo);
    var mask = 0;
    if (clearColor) {
      this.f7k(Companion_getInstance_47().p6v_1);
      gl.g7k(_RGBA___get_rf__impl__kvz75k(color), _RGBA___get_gf__impl__5gcu1f(color), _RGBA___get_bf__impl__1xz5yg(color), _RGBA___get_af__impl__vu36qv(color));
      mask = mask | 16384;
    }
    if (clearDepth) {
      gl.h7k(true);
      gl.i7k(depth);
      mask = mask | 256;
    }
    if (clearStencil) {
      this.w7e_1 = Companion_getInstance_46().k6v_1;
      gl.j7k(-1);
      gl.k7k(stencil);
      mask = mask | 1024;
    }
    gl.l7k(mask);
  }
  q6u(frameBuffer, frameBufferInfo, vertexData, program, drawType, vertexCount, indices, indexType, drawOffset, blending, uniformBlocks, textureUnits, stencilRef, stencilOpFunc, colorMask, depthAndFrontFace, scissor, cullFace, instances) {
    var gl = this.m7e_1;
    this.d7k(frameBuffer, frameBufferInfo);
    this.e7k(scissor, frameBuffer, frameBufferInfo);
    var tmp1_safe_receiver = this.t7e_1;
    if (!equals(tmp1_safe_receiver == null ? null : tmp1_safe_receiver.h73_1, vertexData.h73_1)) {
      var tmp0_safe_receiver = this.t7e_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        this.m7k(tmp0_safe_receiver);
      }
      this.t7e_1 = vertexData;
      this.n7k(vertexData);
    } else {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = vertexData.h73_1.h11_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.graphics.gl.AGOpengl.draw.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        var entry = array[_unary__edvuaz];
        bindBuffer$default(this, entry.v73_1, AGBufferKind_VERTEX_getInstance(), true);
      }
    }
    useProgram(this, program);
    this.o7k(uniformBlocks, textureUnits, program, frameBuffer);
    if (!(this.u7e_1 === blending)) {
      this.u7e_1 = blending;
      // Inline function 'korlibs.kgl.KmlGl.enableDisable' call
      var enable = _AGBlending___get_enabled__impl__s7igz6(blending);
      if (gl.r7k(3042, enable)) {
        // Inline function 'korlibs.graphics.gl.AGOpengl.draw.<anonymous>' call
        gl.p7k(toGl(_AGBlending___get_eqRGB__impl__7pv8oi(blending)), toGl(_AGBlending___get_eqA__impl__2j4ray(blending)));
        gl.q7k(toGl_0(_AGBlending___get_srcRGB__impl__jvh03e(blending)), toGl_0(_AGBlending___get_dstRGB__impl__nz9ogp(blending)), toGl_0(_AGBlending___get_srcA__impl__ftmwxe(blending)), toGl_0(_AGBlending___get_dstA__impl__l7q6tv(blending)));
      }
    }
    this.s7k(depthAndFrontFace);
    this.f7k(colorMask);
    if (!(this.v7e_1 === cullFace)) {
      this.v7e_1 = cullFace;
      this.t7k(cullFace);
    }
    if (!(this.w7e_1 === stencilOpFunc) || !equals(this.x7e_1, stencilRef)) {
      this.w7e_1 = stencilOpFunc;
      this.x7e_1 = stencilRef;
      if (_AGStencilOpFunc___get_enabled__impl__hxq8wy(stencilOpFunc)) {
        gl.v7k(2960);
        if (_AGStencilOpFunc___get_compareModeFront__impl__uctsey(stencilOpFunc) === _AGStencilOpFunc___get_compareModeBack__impl__2rklx0(stencilOpFunc) && _AGStencilReference___get_referenceValueFront__impl__p7smsu(stencilRef) === _AGStencilReference___get_referenceValueBack__impl__mlrbhc(stencilRef) && _AGStencilReference___get_readMaskFront__impl__oc0s46(stencilRef) === _AGStencilReference___get_readMaskBack__impl__lwtaqk(stencilRef)) {
          gl.x7k(toGl_1(_AGStencilOpFunc___get_compareModeFront__impl__uctsey(stencilOpFunc)), _AGStencilReference___get_referenceValueFront__impl__p7smsu(stencilRef), _AGStencilReference___get_readMaskFront__impl__oc0s46(stencilRef));
        } else {
          gl.w7k(1028, toGl_1(_AGStencilOpFunc___get_compareModeFront__impl__uctsey(stencilOpFunc)), _AGStencilReference___get_referenceValueFront__impl__p7smsu(stencilRef), _AGStencilReference___get_readMaskFront__impl__oc0s46(stencilRef));
          gl.w7k(1029, toGl_1(_AGStencilOpFunc___get_compareModeBack__impl__2rklx0(stencilOpFunc)), _AGStencilReference___get_referenceValueBack__impl__mlrbhc(stencilRef), _AGStencilReference___get_readMaskBack__impl__lwtaqk(stencilRef));
        }
        if (_AGStencilOpFunc___get_actionOnDepthFailFront__impl__vuqmyq(stencilOpFunc) === _AGStencilOpFunc___get_actionOnDepthFailBack__impl__3tna28(stencilOpFunc) && _AGStencilOpFunc___get_actionOnDepthPassStencilFailFront__impl__kl5ndh(stencilOpFunc) === _AGStencilOpFunc___get_actionOnDepthPassStencilFailBack__impl__4qprmh(stencilOpFunc) && _AGStencilOpFunc___get_actionOnBothPassFront__impl__aehsgx(stencilOpFunc) === _AGStencilOpFunc___get_actionOnBothPassBack__impl__i5t9l9(stencilOpFunc)) {
          gl.z7k(toGl_2(_AGStencilOpFunc___get_actionOnDepthFailFront__impl__vuqmyq(stencilOpFunc)), toGl_2(_AGStencilOpFunc___get_actionOnDepthPassStencilFailFront__impl__kl5ndh(stencilOpFunc)), toGl_2(_AGStencilOpFunc___get_actionOnBothPassFront__impl__aehsgx(stencilOpFunc)));
        } else {
          gl.y7k(1028, toGl_2(_AGStencilOpFunc___get_actionOnDepthFailFront__impl__vuqmyq(stencilOpFunc)), toGl_2(_AGStencilOpFunc___get_actionOnDepthPassStencilFailFront__impl__kl5ndh(stencilOpFunc)), toGl_2(_AGStencilOpFunc___get_actionOnBothPassFront__impl__aehsgx(stencilOpFunc)));
          gl.y7k(1029, toGl_2(_AGStencilOpFunc___get_actionOnDepthFailBack__impl__3tna28(stencilOpFunc)), toGl_2(_AGStencilOpFunc___get_actionOnDepthPassStencilFailBack__impl__4qprmh(stencilOpFunc)), toGl_2(_AGStencilOpFunc___get_actionOnBothPassBack__impl__i5t9l9(stencilOpFunc)));
        }
        if (_AGStencilReference___get_writeMaskFront__impl__cqdpbj(stencilRef) === _AGStencilReference___get_writeMaskBack__impl__mths73(stencilRef)) {
          gl.j7k(_AGStencilReference___get_writeMaskFront__impl__cqdpbj(stencilRef));
        } else {
          gl.a7l(1028, _AGStencilReference___get_writeMaskFront__impl__cqdpbj(stencilRef));
          gl.a7l(1029, _AGStencilReference___get_writeMaskBack__impl__mths73(stencilRef));
        }
      } else {
        gl.u7k(2960);
        gl.j7k(0);
      }
    }
    if (indices == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.graphics.gl.AGOpengl.draw.<anonymous>' call
      bindBuffer$default(this, indices, AGBufferKind_INDEX_getInstance());
    }
    var indexType_0 = !(indices == null) ? indexType : Companion_getInstance_41().v6u_1;
    if (!(indexType_0 === Companion_getInstance_41().v6u_1))
      if (!(instances === 1)) {
        gl.e7l(toGl_3(drawType), vertexCount, toGl_4(indexType_0), drawOffset, instances);
      } else {
        gl.d7l(toGl_3(drawType), vertexCount, toGl_4(indexType_0), drawOffset);
      }
     else if (!(instances === 1)) {
      gl.c7l(toGl_3(drawType), drawOffset, vertexCount, instances);
    } else {
      gl.b7l(toGl_3(drawType), drawOffset, vertexCount);
    }
  }
  x7f() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.s7e_1;
    glslConfig$factory();
    return this_0.u1();
  }
  o6u() {
    var gl = this.m7e_1;
    var tmp0_safe_receiver = this.n7e_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.f7l();
    }
    gl.g7l(this.t6t_1);
    resetObjects(this);
    this.d7f_1 = getIntegerv(gl, 36006);
    gl.h7j(33984);
    if (_GLVariant___get_supportTextureLevel__impl__3yeu62(gl.i7j())) {
      // Inline function 'korlibs.kgl.KmlGl.TEXTURE_2D' call
      gl.g7j(3553, 33084, 0);
      // Inline function 'korlibs.kgl.KmlGl.TEXTURE_2D' call
      gl.g7j(3553, 33085, 0);
    }
  }
  i6q() {
    var tmp0_safe_receiver = this.t7e_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      this.m7k(tmp0_safe_receiver);
    }
    this.t7e_1 = null;
    this.d7k(this.k6u().w6t_1, this.k6u().d6w());
    var tmp1_safe_receiver = this.n7e_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.h7l();
    }
  }
  m6u() {
    var tmp0_safe_receiver = this.t7e_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      this.m7k(tmp0_safe_receiver);
    }
    this.t7e_1 = null;
    this.m7e_1.bd();
    deletePendingObjects(this);
  }
  t7k(face) {
    if (this.m7e_1.r7k(2884, _AGCullFace___get_ordinal__impl__jd1wps(face) > _AGCullFace___get_ordinal__impl__jd1wps(Companion_getInstance_49().z6v_1))) {
      this.m7e_1.i7l(toGl_5(face));
    }
  }
  h7i(_this__u8e3s4, block) {
    if (!(_this__u8e3s4.q6x_1 === _this__u8e3s4.r6x_1)) {
      _this__u8e3s4.q6x_1 = _this__u8e3s4.r6x_1;
      block(_this__u8e3s4);
    }
  }
  m7k(vao) {
    if (this.h7f_1 && this.m7e_1.u6u()) {
      this.m7e_1.l7l(0);
    } else {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = vao.h73_1.h11_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.graphics.gl.AGOpengl.vaoUnuse.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call
        // Inline function 'korlibs.graphics.shader.attributes' call
        var this_0 = array[_unary__edvuaz].u73_1.l73_1;
        var n_0 = 0;
        while (n_0 < this_0.e1()) {
          // Inline function 'korlibs.graphics.gl.AGOpengl.vaoUnuse.<anonymous>.<anonymous>' call
          var _unary__edvuaz_0 = n_0;
          n_0 = _unary__edvuaz_0 + 1 | 0;
          var att = this_0.d1(_unary__edvuaz_0);
          if (att.f7a_1) {
            var loc = att.h7a_1;
            if (loc >= 0) {
              if (!(att.g7a_1 === 0)) {
                this.m7e_1.j7l(loc, 0);
              }
              this.m7e_1.k7l(loc);
            }
          }
        }
      }
    }
  }
  n7k(vao) {
    var gl = this.m7e_1;
    if (this.h7f_1 && gl.u6u()) {
      var vaoGl = get_gl(vao);
      if (vao.i73_1) {
        if (!(this.g7f_1 === this.t6t_1)) {
          this.f7f_1 = genVertexArray(gl);
          this.g7f_1 = this.t6t_1;
          if (this.f7f_1 <= 0)
            this.h7f_1 = false;
        }
        gl.l7l(this.f7f_1);
        this.m7l(vao);
      } else {
        if (!(vaoGl.w7d_1 === this.t6t_1)) {
          vaoGl.w7d_1 = this.t6t_1;
          vaoGl.v7d_1 = genVertexArray(gl);
          if (vaoGl.v7d_1 <= 0)
            this.h7f_1 = false;
          gl.l7l(vaoGl.v7d_1);
          this.m7l(vao);
        }
        gl.l7l(vaoGl.v7d_1);
        this.n7l(vao, this.h7f_1);
      }
    } else {
      this.m7l(vao);
    }
  }
  n7l(vao, updateBuffersOnly) {
    var gl = this.m7e_1;
    if (updateBuffersOnly) {
      // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
      // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var array = vao.h73_1.h11_1;
      var n = 0;
      while (n < array.length) {
        // Inline function 'korlibs.graphics.gl.AGOpengl._vaoUse.<anonymous>' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'korlibs.datastructure.get' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        var entry = array[_unary__edvuaz];
        bindBuffer$default(this, entry.v73_1, AGBufferKind_VERTEX_getInstance(), VOID, VOID, this.i7f_1);
      }
      return Unit_instance;
    }
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array_0 = vao.h73_1.h11_1;
    var n_0 = 0;
    while (n_0 < array_0.length) {
      // Inline function 'korlibs.graphics.gl.AGOpengl._vaoUse.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      var entry_0 = array_0[_unary__edvuaz_0];
      var vertices = entry_0.v73_1;
      var vertexLayout = entry_0.u73_1;
      // Inline function 'korlibs.graphics.shader.attributes' call
      var vattrs = vertexLayout.l73_1;
      // Inline function 'korlibs.graphics.shader.attributePositions' call
      var vattrspos = vertexLayout.q73_1;
      bindBuffer$default(this, vertices, AGBufferKind_VERTEX_getInstance(), VOID, VOID, this.i7f_1);
      var totalSize = vertexLayout.s73_1;
      var inductionVariable = 0;
      var last = vattrspos.e1() - 1 | 0;
      if (inductionVariable <= last)
        $l$loop: do {
          var n_1 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var att = vattrs.d1(n_1);
          if (!att.f7a_1)
            continue $l$loop;
          var off = vattrspos.d1(n_1);
          var loc = att.h7a_1;
          var glElementType = toGl_7(att.i2h());
          var elementCount = att.i2h().s7i_1;
          if (loc >= 0) {
            gl.o7l(loc);
            gl.p7l(loc, elementCount, glElementType, att.e7a_1, totalSize, numberToLong(entry_0.w73_1).a4(toLong(off)));
            if (!(att.g7a_1 === 0)) {
              gl.j7l(loc, att.g7a_1);
            }
          }
        }
         while (inductionVariable <= last);
    }
  }
  m7l(vao, updateBuffersOnly, $super) {
    updateBuffersOnly = updateBuffersOnly === VOID ? false : updateBuffersOnly;
    var tmp;
    if ($super === VOID) {
      this.n7l(vao, updateBuffersOnly);
      tmp = Unit_instance;
    } else {
      tmp = $super.n7l.call(this, vao, updateBuffersOnly);
    }
    return tmp;
  }
  o7k(uniformBlocks, textureUnits, program, frameBuffer) {
    var tmp0_elvis_lhs = this.a7f_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var glProgram = tmp;
    // Inline function 'korlibs.graphics.AGTextureUnits.fastForEach' call
    var inductionVariable = 0;
    var last = textureUnits.e1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.graphics.gl.AGOpengl.uniformsSet.<anonymous>' call
        var tex = textureUnits.x6x_1[n];
        var info = AGTextureUnitInfoArray__get_impl_xhvpef(textureUnits.y6x_1, n);
        var tex_0 = tex;
        if (equals(frameBuffer.c6z_1, tex_0)) {
          tex_0 = null;
        }
        var tmp0_safe_receiver = tex_0;
        var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r6x_1;
        var texVersion = tmp1_elvis_lhs == null ? -1 : tmp1_elvis_lhs;
        if (!(this.b7f_1.x6x_1[n] === tex_0) || !(AGTextureUnitInfoArray__get_impl_xhvpef(this.b7f_1.y6x_1, n) === info) || !(this.c7f_1[n] === texVersion)) {
          this.b7f_1.b6y(n, tex_0, info);
          this.c7f_1[n] = texVersion;
          selectTextureUnit(this, n);
          if (!(tex_0 == null)) {
            var wrap = _AGTextureUnitInfo___get_wrap__impl__dwp6l(info);
            var linear = _AGTextureUnitInfo___get_linear__impl__jak6ny(info);
            var trilinear = _AGTextureUnitInfo___get_trilinear__impl__hxtqfb(info);
            this.q7l(tex_0, _AGTextureUnitInfo___get_kind__impl__6xtjoz(info));
            textureUnitParameters(this, tex_0.e70(), wrap, this.r7l(tex_0, linear, trilinear), this.s7l(tex_0, linear, trilinear), _AGTextureTargetKind___get_dims__impl__k3cmhd(tex_0.e70()));
          } else {
            this.q7l(null, Companion_getInstance_51().a70_1);
          }
        }
      }
       while (inductionVariable < last);
    var glProgramInfo = glProgram.c7g_1;
    // Inline function 'korlibs.graphics.shader.UniformBlocksBuffersRef.fastForEachBlock' call
    var inductionVariable_0 = 0;
    var last_0 = uniformBlocks.e1();
    if (inductionVariable_0 < last_0)
      $l$loop: do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var tmp0_elvis_lhs_0 = uniformBlocks.t7l_1[n_0];
        var tmp_0;
        if (tmp0_elvis_lhs_0 == null) {
          continue $l$loop;
        } else {
          tmp_0 = tmp0_elvis_lhs_0;
        }
        var block = tmp_0;
        $l$block: {
          // Inline function 'korlibs.graphics.gl.AGOpengl.uniformsSet.<anonymous>' call
          var buffer = uniformBlocks.u7l_1[n_0];
          var valueIndex = uniformBlocks.v7l_1[n_0];
          if (glProgram.c7g_1.i7g_1.h7h()) {
            var buffer_0 = bindBuffer$default(this, buffer, AGBufferKind_UNIFORM_getInstance());
            var tmp1_elvis_lhs_0 = buffer_0 == null ? null : buffer_0.e7i_1;
            this.m7e_1.w7l(35345, block.g71_1.a73_1, tmp1_elvis_lhs_0 == null ? -1 : tmp1_elvis_lhs_0, imul(valueIndex, block.j71_1), block.j71_1);
            break $l$block;
          }
          var tmp2_elvis_lhs = glProgramInfo.l7g_1[block.g71_1.a73_1];
          var tmp_1;
          if (tmp2_elvis_lhs == null) {
            var message = "Can't find uniform at " + block.g71_1.a73_1 + ' for program ' + program.toString() + ' for block ' + block.toString();
            throw IllegalStateException.l5(toString(message));
          } else {
            tmp_1 = tmp2_elvis_lhs;
          }
          var ref = tmp_1;
          var bufferMem = ensureNotNull(ensureNotNull(buffer).n6x_1);
          var currentMem = ref.y7l_1;
          var ublock = ref.x7l_1;
          if (valueIndex >= 0) {
            if (!arrayequal(bufferMem, valueIndex, currentMem, 0, ublock.h79())) {
              arraycopy_0(bufferMem, imul(ublock.h79(), valueIndex), currentMem, 0, ublock.h79());
              // Inline function 'korlibs.datastructure.iterators.fastForEach' call
              var this_0 = ublock.f79();
              var n_1 = 0;
              while (n_1 < this_0.e1()) {
                // Inline function 'korlibs.graphics.gl.AGOpengl.uniformsSet.<anonymous>.<anonymous>' call
                var _unary__edvuaz = n_1;
                n_1 = _unary__edvuaz + 1 | 0;
                var uniform = this_0.d1(_unary__edvuaz);
                writeUniform(this, uniform.z72_1, glProgramInfo, sliceBuffer(currentMem, uniform.w72_1, uniform.w72_1 + uniform.o7i_1 | 0), 'blockUniformSet');
              }
            }
          } else {
            println('ERROR block: ' + block.g71_1.toString() + ' has an invalid valueIndex=' + valueIndex);
          }
        }
      }
       while (inductionVariable_0 < last_0);
  }
  r7l(_this__u8e3s4, linear, trilinear) {
    var tmp;
    if ((_this__u8e3s4 == null ? null : _this__u8e3s4.u6z_1) === true) {
      tmp = linear ? trilinear ? 9987 : 9985 : trilinear ? 9986 : 9984;
    } else {
      tmp = linear ? 9729 : 9728;
    }
    return tmp;
  }
  s7l(_this__u8e3s4, linear, trilinear) {
    return linear ? 9729 : 9728;
  }
  b7m(scissor, frameBuffer, frameBufferInfo) {
    return scissor.equals(Companion_getInstance_43().x6v_1) || scissor.equals(Companion_getInstance_43().v6v_1) ? scissor : frameBuffer.b6z_1 ? Companion_getInstance_43().s2l(scissor.y2d(), _AGFrameBufferInfo___get_height__impl__yfespa(frameBufferInfo) - scissor.b2e() | 0, scissor.z2d(), _AGFrameBufferInfo___get_height__impl__yfespa(frameBufferInfo) - scissor.a2e() | 0) : scissor;
  }
  r6u(frameBuffer, frameBufferInfo, x, y, width, height, data, kind) {
    var gl = this.m7e_1;
    this.d7k(frameBuffer, frameBufferInfo);
    var region = this.b7m(AGScissor.e75(x, y, width, height), frameBuffer, frameBufferInfo);
    var tmp;
    if (isIntArray(data)) {
      tmp = 4;
    } else {
      if (isFloatArray(data)) {
        tmp = 4;
      } else {
        if (isByteArray(data)) {
          tmp = 1;
        } else {
          tmp = kind === Companion_getInstance_50().l6w_1 ? 4 : kind === Companion_getInstance_50().m6w_1 ? 4 : kind === Companion_getInstance_50().n6w_1 ? 1 : 1;
        }
      }
    }
    var bytesPerPixel = tmp;
    var flipY = frameBuffer.b6z_1;
    var area = imul(width, height);
    var stride = imul(width, bytesPerPixel);
    var nbytes = imul(height, stride);
    if (this.l7f_1.g15() < nbytes) {
      this.l7f_1 = allocDirect(Companion_instance_4, nbytes);
    }
    var buffer = this.l7f_1;
    if (kind === Companion_getInstance_50().l6w_1) {
      gl.c7m(region.o6p(), region.p6p(), region.x2p(), region.y2p(), 6408, 5121, buffer);
    } else if (kind === Companion_getInstance_50().m6w_1) {
      gl.c7m(region.o6p(), region.p6p(), region.x2p(), region.y2p(), 6402, 5126, buffer);
    } else if (kind === Companion_getInstance_50().n6w_1) {
      gl.c7m(region.o6p(), region.p6p(), region.x2p(), region.y2p(), 6401, 5121, buffer);
    }
    if (isIntArray(data))
      getS32Array(buffer, 0, data, VOID, area);
    else {
      if (isFloatArray(data))
        getF32Array(buffer, 0, data, VOID, area);
      else {
        if (isByteArray(data))
          getS8Array(buffer, 0, data, VOID, area);
        else {
          if (data instanceof Buffer) {
            if (flipY) {
              var inductionVariable = 0;
              if (inductionVariable < height)
                do {
                  var n = inductionVariable;
                  inductionVariable = inductionVariable + 1 | 0;
                  arraycopy_0(buffer, imul((height - 1 | 0) - n | 0, stride), data, imul(n, stride), stride);
                }
                 while (inductionVariable < height);
            } else {
              arraycopy_0(buffer, 0, data, 0, nbytes);
            }
          } else {
            throw NotImplementedError.ee();
          }
        }
      }
    }
    if (flipY) {
      var tmp_0;
      if (isIntArray(data)) {
        tmp_0 = Bitmap32.g4d(width, height, _RgbaArray___init__impl__oib4y4(data));
      } else {
        if (isFloatArray(data)) {
          tmp_0 = FloatBitmap32.r4g(width, height, data);
        } else {
          if (isByteArray(data)) {
            tmp_0 = Bitmap8.s4e(width, height, data);
          } else {
            tmp_0 = null;
          }
        }
      }
      var tmp5_safe_receiver = tmp_0;
      if (tmp5_safe_receiver == null)
        null;
      else
        tmp5_safe_receiver.f4b();
    }
  }
  q7l(tex, target) {
    var gl = this.m7e_1;
    var glTex = tex == null ? null : _get_gl__ndc1ty_1(tex, this);
    var tmp = toGl_8(target);
    var tmp2_elvis_lhs = glTex == null ? null : glTex.s7j_1;
    gl.d7m(tmp, tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs);
    var texBitmap = tex == null ? null : tex.t6z_1;
    if (!(glTex == null) && !(texBitmap == null)) {
      if (!(glTex.t7j_1 === texBitmap.a44_1) || !(glTex.u7j_1 === this.t6t_1)) {
        glTex.t7j_1 = texBitmap.a44_1;
        glTex.u7j_1 = this.t6t_1;
        tex.w6x();
      }
      this.h7i(tex, AGOpengl$textureBind$lambda(tex, target, gl, this, glTex));
    }
  }
  d7k(frameBuffer, info) {
    var gl = this.m7e_1;
    if (!(this.o7f_1 === _AGFrameBufferInfo___get_size__impl__uw80y4(info))) {
      gl.e7m(_AGFrameBufferInfo___get_x__impl__6dzfjj(info), _AGFrameBufferInfo___get_y__impl__mfn1io(info), _AGFrameBufferInfo___get_width__impl__yhp94z(info), _AGFrameBufferInfo___get_height__impl__yfespa(info));
    }
    if (frameBuffer.b6z_1) {
      if (!(this.p7f_1 === this.d7f_1)) {
        this.p7f_1 = this.d7f_1;
        gl.f7m(36160, this.d7f_1);
      }
      return Unit_instance;
    }
    var fb = _get_gl__ndc1ty_0(frameBuffer, this);
    var tex = fb.i7m_1.c6z_1;
    var doMsaa = false;
    if (!equals(fb.l7m_1, info)) {
      fb.l7m_1 = info;
      var internalFormat = _AGFrameBufferInfo___get_hasStencilAndDepth__impl__aauqdj(info) ? 34041 : _AGFrameBufferInfo___get_hasStencil__impl__hjoes3(info) ? 36168 : _AGFrameBufferInfo___get_hasDepth__impl__9knjmc(info) ? 6402 : 0;
      var texTarget = doMsaa ? 37120 : 3553;
      tex.t6z_1 = NullBitmap.a4j(_AGFrameBufferInfo___get_width__impl__yhp94z(info), _AGFrameBufferInfo___get_height__impl__yfespa(info), false);
      // Inline function 'korlibs.graphics.gl.AGOpengl.selectTextureUnitTemp' call
      var index = this.m7f_1;
      var old = selectTextureUnit(this, index);
      try {
        // Inline function 'korlibs.graphics.gl.AGOpengl.bindFrameBuffer.<anonymous>' call
        this.q7l(tex, Companion_getInstance_51().a70_1);
        textureUnitParameters(this, Companion_getInstance_51().a70_1, Companion_getInstance_52().z70_1, 9729, 9729, 2);
      }finally {
        if (true) {
          this.q7l(null, Companion_getInstance_51().a70_1);
        }
        selectTextureUnit(this, old);
      }
      gl.m7m(36161, fb.j7m_1);
      if (!(internalFormat === 0)) {
        gl.n7m(36161, internalFormat, _AGFrameBufferInfo___get_width__impl__yhp94z(info), _AGFrameBufferInfo___get_height__impl__yfespa(info));
      }
      gl.m7m(36161, 0);
      gl.f7m(36160, fb.k7m_1);
      gl.o7m(36160, 36064, 3553, _get_gl__ndc1ty_1(fb.i7m_1.c6z_1, this).s7j_1, 0);
      if (!(internalFormat === 0)) {
        gl.p7m(36160, _AGFrameBufferInfo___get_hasStencilAndDepth__impl__aauqdj(info) ? 33306 : _AGFrameBufferInfo___get_hasStencil__impl__hjoes3(info) ? 36128 : _AGFrameBufferInfo___get_hasDepth__impl__9knjmc(info) ? 36096 : 0, 36161, fb.j7m_1);
      } else {
        gl.p7m(36160, 36128, 36161, 0);
        gl.p7m(36160, 36096, 36161, 0);
      }
    }
    if (!(this.p7f_1 === fb.k7m_1)) {
      this.p7f_1 = fb.k7m_1;
      gl.f7m(36160, fb.k7m_1);
    }
  }
  s7k(renderState) {
    var gl = this.m7e_1;
    if (!(this.z7e_1 === renderState)) {
      this.z7e_1 = renderState;
      gl.q7m(toGl_10(_AGDepthAndFrontFace___get_frontFace__impl__w07k4s(renderState)));
      gl.h7k(_AGDepthAndFrontFace___get_depthMask__impl__ouijn(renderState));
      gl.r7m(_AGDepthAndFrontFace___get_depthNear__impl__cir3a1(renderState), _AGDepthAndFrontFace___get_depthFar__impl__g0cno8(renderState));
      // Inline function 'korlibs.kgl.KmlGl.enableDisable' call
      var enable = !(_AGDepthAndFrontFace___get_depthFunc__impl__8fo7zp(renderState) === Companion_getInstance_57().c76_1);
      if (gl.r7k(2929, enable)) {
        // Inline function 'korlibs.graphics.gl.AGOpengl.setDepthAndFrontFace.<anonymous>' call
        gl.s7m(toGl_1(_AGDepthAndFrontFace___get_depthFunc__impl__8fo7zp(renderState)));
      }
    }
  }
  f7k(colorMask) {
    var gl = this.m7e_1;
    if (!(this.y7e_1 === colorMask)) {
      this.y7e_1 = colorMask;
      gl.t7m(_AGColorMask___get_red__impl__opo1fo(colorMask), _AGColorMask___get_green__impl__d3m1w2(colorMask), _AGColorMask___get_blue__impl__42l0s1(colorMask), _AGColorMask___get_alpha__impl__xmrqzb(colorMask));
    }
  }
  e7k(scissor, frameBuffer, frameBufferInfo) {
    var gl = this.m7e_1;
    var scissor_0 = this.b7m(scissor, frameBuffer, frameBufferInfo);
    if (!this.e7f_1.equals(scissor_0)) {
      this.e7f_1 = scissor_0;
      // Inline function 'korlibs.kgl.KmlGl.enableDisable' call
      var enable = !scissor_0.equals(Companion_getInstance_43().x6v_1);
      if (gl.r7k(3089, enable)) {
        // Inline function 'korlibs.graphics.gl.AGOpengl.setScissorState.<anonymous>' call
        gl.u7m(scissor_0.o6p(), scissor_0.p6p(), scissor_0.x2p(), scissor_0.y2p());
      }
    }
  }
}
class GLGlobalState {
  constructor(gl, ag) {
    this.o7h_1 = gl;
    this.p7h_1 = ag;
    this.q7h_1 = atomic$int$1(0);
    this.r7h_1 = atomic$int$1(0);
    this.s7h_1 = atomic$ref$1(0.0);
    this.t7h_1 = atomic$int$1(0);
    this.u7h_1 = atomic$int$1(0);
    this.v7h_1 = atomic$ref$1(0.0);
    this.w7h_1 = new Lock();
    this.x7h_1 = fastArrayListOf([]);
  }
}
class GLBaseObject {
  constructor(globalState) {
    this.y7h_1 = globalState;
    this.z7h_1 = this.y7h_1.o7h_1;
  }
  a7i() {
  }
  x70() {
    // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
    var this_0 = this.y7h_1.w7h_1;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
      this_0.b20();
      try {
        this.y7h_1.x7h_1.h(this);
        break $l$block;
      }finally {
        this_0.d20();
      }
    }
  }
}
class GLBaseProgram extends GLBaseObject {
  constructor(globalState, programInfo) {
    super(globalState);
    this.c7g_1 = programInfo;
  }
  a7i() {
    this.c7g_1.v7m(this.z7h_1);
  }
  d7g() {
    this.c7g_1.w7m(this.z7h_1);
  }
}
class GLBuffer extends GLBaseObject {
  constructor(state) {
    super(state);
    this.e7i_1 = genBuffer(this.z7h_1);
    this.f7i_1 = -1;
    this.g7i_1 = 0.0;
    this.y7h_1.t7h_1.atomicfu$incrementAndGet();
  }
  j7j(value) {
    $l$block: {
      // Inline function 'kotlinx.atomicfu.updateAndGet' call
      var this_0 = this.y7h_1.v7h_1;
      while (true) {
        var cur = this_0.kotlinx$atomicfu$value;
        // Inline function 'korlibs.graphics.gl.GLBuffer.<set-estimatedBytes>.<anonymous>' call
        var upd = cur + value - this.g7i_1;
        if (this_0.atomicfu$compareAndSet(cur, upd)) {
          break $l$block;
        }
      }
    }
    this.g7i_1 = value;
  }
  a7i() {
    this.y7h_1.u7h_1.atomicfu$incrementAndGet();
    deleteBuffer(this.z7h_1, this.e7i_1);
    this.e7i_1 = -1;
    this.f7i_1 = -1;
  }
  toString() {
    return 'GLBuffer(' + this.e7i_1 + ')';
  }
}
class GLTexture extends GLBaseObject {
  constructor(state) {
    super(state);
    this.s7j_1 = genTexture(this.z7h_1);
    this.t7j_1 = -2;
    this.u7j_1 = -2;
    this.v7j_1 = 0.0;
    this.y7h_1.q7h_1.atomicfu$incrementAndGet();
  }
  j7j(value) {
    $l$block: {
      // Inline function 'kotlinx.atomicfu.updateAndGet' call
      var this_0 = this.y7h_1.s7h_1;
      while (true) {
        var cur = this_0.kotlinx$atomicfu$value;
        // Inline function 'korlibs.graphics.gl.GLTexture.<set-estimatedBytes>.<anonymous>' call
        var upd = cur + value - this.v7j_1;
        if (this_0.atomicfu$compareAndSet(cur, upd)) {
          break $l$block;
        }
      }
    }
    this.v7j_1 = value;
  }
  a7i() {
    this.y7h_1.r7h_1.atomicfu$incrementAndGet();
    deleteTexture(this.z7h_1, this.s7j_1);
    this.s7j_1 = -1;
  }
}
class GLFrameBuffer extends GLBaseObject {
  constructor(state, ag) {
    super(state);
    this.i7m_1 = ag;
    this.j7m_1 = genRenderbuffer(this.z7h_1);
    this.k7m_1 = genFramebuffer(this.z7h_1);
    this.l7m_1 = Companion_getInstance_44().p75_1;
  }
  a7i() {
    deleteRenderbuffer(this.z7h_1, this.j7m_1);
    deleteFramebuffer(this.z7h_1, this.k7m_1);
    this.j7m_1 = -1;
    this.k7m_1 = -1;
  }
}
class GLProgramInfo {
  constructor(programId, vertexId, fragmentId, blocks, config) {
    this.e7g_1 = programId;
    this.f7g_1 = vertexId;
    this.g7g_1 = fragmentId;
    this.h7g_1 = blocks;
    this.i7g_1 = config;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = this.h7g_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.sc(capacity);
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.graphics.gl.GLProgramInfo.blocksByFixedLocation.<anonymous>' call
      var tmp$ret$0 = element.a73_1;
      destination.j3(tmp$ret$0, element);
    }
    tmp.j7g_1 = destination;
    var tmp_0 = this;
    var tmp$ret$3;
    $l$block: {
      // Inline function 'kotlin.collections.maxOfOrNull' call
      var iterator = this.h7g_1.a1();
      if (!iterator.b1()) {
        tmp$ret$3 = null;
        break $l$block;
      }
      // Inline function 'korlibs.graphics.gl.GLProgramInfo.maxBlockId.<anonymous>' call
      var maxValue = iterator.c1().a73_1;
      while (iterator.b1()) {
        // Inline function 'korlibs.graphics.gl.GLProgramInfo.maxBlockId.<anonymous>' call
        var v = iterator.c1().a73_1;
        if (compareTo(maxValue, v) < 0) {
          maxValue = v;
        }
      }
      tmp$ret$3 = maxValue;
    }
    var tmp0_elvis_lhs = tmp$ret$3;
    tmp_0.k7g_1 = (tmp0_elvis_lhs == null ? -1 : tmp0_elvis_lhs) + 1 | 0;
    var tmp_1 = this;
    var tmp_2 = 0;
    var tmp_3 = this.k7g_1 + 1 | 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_4 = fillArrayVal(Array(tmp_3), null);
    while (tmp_2 < tmp_3) {
      var tmp_5 = tmp_2;
      var tmp0_safe_receiver = this.j7g_1.h3(tmp_5);
      var tmp_6;
      if (tmp0_safe_receiver == null) {
        tmp_6 = null;
      } else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.graphics.gl.GLProgramInfo.uniforms.<anonymous>' call
        tmp_6 = UniformsRef.x7m(tmp0_safe_receiver);
      }
      tmp_4[tmp_5] = tmp_6;
      tmp_2 = tmp_2 + 1 | 0;
    }
    tmp_1.l7g_1 = tmp_4;
    this.m7g_1 = FastStringMap();
    this.n7g_1 = FastStringMap();
  }
  z7g(gl, name) {
    var tmp$ret$2;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var this_0 = this.n7g_1;
      // Inline function 'korlibs.datastructure.get' call
      // Inline function 'kotlin.js.asDynamic' call
      var res = this_0.get(name);
      if (!(res == null)) {
        tmp$ret$2 = res;
        break $l$block;
      }
      // Inline function 'korlibs.graphics.gl.GLProgramInfo.getUniformLocation.<anonymous>' call
      var out = gl.y7m(this.e7g_1, name);
      // Inline function 'korlibs.datastructure.set' call
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.js.asDynamic' call
      this_0.set(name, out);
      tmp$ret$2 = out;
    }
    return tmp$ret$2;
  }
  w7m(gl) {
    gl.z7m(this.e7g_1);
  }
  v7m(gl) {
    if (!(this.f7g_1 === 0)) {
      gl.a7n(this.f7g_1);
    }
    if (!(this.g7g_1 === 0)) {
      gl.a7n(this.g7g_1);
    }
    if (!(this.e7g_1 === 0)) {
      gl.b7n(this.e7g_1);
    }
    this.f7g_1 = 0;
    this.g7g_1 = 0;
    this.e7g_1 = 0;
  }
  toString() {
    return 'GLProgramInfo(programId=' + this.e7g_1 + ', vertexId=' + this.f7g_1 + ', fragmentId=' + this.g7g_1 + ', blocks=' + toString(this.h7g_1) + ', config=' + this.i7g_1.toString() + ')';
  }
  hashCode() {
    var result = this.e7g_1;
    result = imul(result, 31) + this.f7g_1 | 0;
    result = imul(result, 31) + this.g7g_1 | 0;
    result = imul(result, 31) + hashCode(this.h7g_1) | 0;
    result = imul(result, 31) + this.i7g_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GLProgramInfo))
      return false;
    var tmp0_other_with_cast = other instanceof GLProgramInfo ? other : THROW_CCE();
    if (!(this.e7g_1 === tmp0_other_with_cast.e7g_1))
      return false;
    if (!(this.f7g_1 === tmp0_other_with_cast.f7g_1))
      return false;
    if (!(this.g7g_1 === tmp0_other_with_cast.g7g_1))
      return false;
    if (!equals(this.h7g_1, tmp0_other_with_cast.h7g_1))
      return false;
    if (!this.i7g_1.equals(tmp0_other_with_cast.i7g_1))
      return false;
    return true;
  }
}
class GLShaderCompiler {
  constructor() {
    GLShaderCompiler_instance = this;
    this.y7f_1 = Companion_getInstance_1().iz('GLShaderCompiler');
  }
  z7f(gl, config, program, debugName) {
    var id = gl.g7n();
    var guessedGlSlVersion = get_versionInt(gl);
    var tmp0_elvis_lhs = Companion_getInstance_62().i7n();
    var usedGlSlVersion = tmp0_elvis_lhs == null ? guessedGlSlVersion : tmp0_elvis_lhs;
    if (Companion_getInstance_62().j7n()) {
      // Inline function 'korlibs.logger.Logger.trace' call
      var this_0 = this.y7f_1;
      var level = Level_TRACE_getInstance();
      var tmp;
      if (this_0.q31(level)) {
        // Inline function 'korlibs.graphics.gl.GLShaderCompiler.programCreate.<anonymous>' call
        var tmp$ret$0 = 'GLSL version: usedGlSlVersion=' + usedGlSlVersion + ', guessed=' + guessedGlSlVersion + ', forced=' + Companion_getInstance_62().i7n() + '. used=' + usedGlSlVersion;
        this_0.r31(level, tmp$ret$0);
        tmp = Unit_instance;
      }
    }
    // Inline function 'kotlin.collections.map' call
    var this_1 = listOf_0([false, true]);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_1, 10));
    var tmp0_iterator = this_1.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.graphics.gl.GLShaderCompiler.programCreate.<anonymous>' call
      var tmp$ret$2 = config.k7n(VOID, VOID, usedGlSlVersion, item);
      destination.h(tmp$ret$2);
    }
    var _destruct__k2r9zo = this.l7n(gl, program, debugName, destination);
    var fragmentShaderId = _destruct__k2r9zo.ul();
    var vertexShaderId = _destruct__k2r9zo.vl();
    var finalConfig = _destruct__k2r9zo.dt();
    var _iterator__ex2g4s = program.i72_1.a1();
    while (_iterator__ex2g4s.b1()) {
      var attr = _iterator__ex2g4s.c1();
      var location = attr.h7a_1;
      gl.m7n(id, location, attr.u7g_1);
    }
    gl.n7n(id, fragmentShaderId);
    gl.n7n(id, vertexShaderId);
    gl.o7n(id);
    // Inline function 'korlibs.kgl.KmlGl.LINK_STATUS' call
    var linkStatus = getProgramiv(gl, id, 35714);
    return new GLProgramInfo(id, vertexShaderId, fragmentShaderId, program.f72_1, finalConfig);
  }
  l7n(gl, program, debugName, configs) {
    // Inline function 'kotlin.collections.arrayListOf' call
    var errors = ArrayList.i1();
    var _iterator__ex2g4s = configs.a1();
    $l$loop: while (_iterator__ex2g4s.b1()) {
      var config = _iterator__ex2g4s.c1();
      try {
        var fragmentString = toNewGlslString(program.b72_1, config);
        var vertexString = toNewGlslString(program.a72_1, config);
        var fragmentShaderId = createShader(this, gl, 35632, fragmentString, debugName);
        var vertexShaderId = createShader(this, gl, 35633, vertexString, debugName);
        // Inline function 'korlibs.logger.Logger.debug' call
        var this_0 = this.y7f_1;
        var level = Level_DEBUG_getInstance();
        var tmp;
        if (this_0.q31(level)) {
          // Inline function 'korlibs.graphics.gl.GLShaderCompiler.createShaderWithConfigs.<anonymous>' call
          var tmp$ret$1 = '!!! PROGRAM SUCCESSFULLY COMPILED: config=' + config.toString() + '\n' + vertexString + '\n' + fragmentString;
          this_0.r31(level, tmp$ret$1);
          tmp = Unit_instance;
        }
        return new Triple(fragmentShaderId, vertexShaderId, config);
      } catch ($p) {
        if ($p instanceof ShaderException) {
          var e = $p;
          // Inline function 'korlibs.logger.Logger.debug' call
          var this_1 = this.y7f_1;
          var level_0 = Level_DEBUG_getInstance();
          var tmp_0;
          if (this_1.q31(level_0)) {
            // Inline function 'korlibs.graphics.gl.GLShaderCompiler.createShaderWithConfigs.<anonymous>' call
            var tmp$ret$3 = stackTraceToString(e);
            this_1.r31(level_0, tmp$ret$3);
            tmp_0 = Unit_instance;
          }
          // Inline function 'kotlin.collections.plusAssign' call
          errors.h(e);
          continue $l$loop;
        } else {
          throw $p;
        }
      }
    }
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(errors, 10));
    var tmp0_iterator = errors.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.graphics.gl.GLShaderCompiler.createShaderWithConfigs.<anonymous>' call
      var tmp$ret$5 = item.message;
      destination.h(tmp$ret$5);
    }
    throw Exception.ke('Tried several shaders: ' + toString(destination), last(errors));
  }
}
class AGDummy extends AG {
  static t7n(size) {
    size = size === VOID ? Size2D.o2e(640, 480) : size;
    var $this = this.v6t();
    $this.k6u().g6z(numberToInt(size.m2e_1), numberToInt(size.n2e_1));
    return $this;
  }
}
class AGBaseLog extends AGDummy {
  static n7o(size) {
    size = size === VOID ? Size2D.o2e(640, 480) : size;
    var $this = this.t7n(size);
    $this.i7o_1 = 0;
    $this.j7o_1 = 0;
    $this.k7o_1 = 0;
    $this.l7o_1 = 0;
    $this.m7o_1 = linkedHashMapOf([]);
    return $this;
  }
  o7o(str, kind) {
  }
  n6u(command) {
    this.o7o(toString(command), Kind_COMMAND_getInstance());
  }
  m6u() {
    return this.o7o('finish()', Kind_FLIP_getInstance());
  }
}
class AGPrint extends AGBaseLog {
  static d7o(size) {
    size = size === VOID ? Size2D.o2e(640, 480) : size;
    return this.n7o(size);
  }
  o7o(str, kind) {
    println('PrintAG: ' + str);
  }
}
class Kind_0 extends Enum {}
class Companion_44 {
  constructor() {
    Companion_instance_53 = this;
    var tmp = this;
    // Inline function 'kotlin.emptyArray' call
    var tmp_0 = [];
    // Inline function 'kotlin.emptyArray' call
    var tmp$ret$1 = [];
    tmp.f6v_1 = new UniformBlocksBuffersRef(tmp_0, tmp$ret$1, new Int32Array(0));
  }
}
class UniformBlocksBuffersRef {
  constructor(blocks, buffers, valueIndices) {
    Companion_getInstance_59();
    this.t7l_1 = blocks;
    this.u7l_1 = buffers;
    this.v7l_1 = valueIndices;
  }
  e1() {
    return this.t7l_1.length;
  }
}
class Gen {
  constructor(block, name, voffset, vindex, type, arrayCount, size, align) {
    arrayCount = arrayCount === VOID ? 1 : arrayCount;
    this.t78_1 = block;
    this.u78_1 = name;
    this.v78_1 = voffset;
    this.w78_1 = vindex;
    this.x78_1 = type;
    this.y78_1 = arrayCount;
    this.z78_1 = size;
    this.a79_1 = align;
    var tmp = this;
    tmp.b79_1 = lazy(UniformBlock$Gen$uniform$delegate$lambda(this));
  }
  q7o() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.b79_1;
    uniform$factory();
    return this_0.u1();
  }
  c79(block, property) {
    var tmp = this;
    var tmp0_elvis_lhs = this.u78_1;
    tmp.u78_1 = tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs;
    return this.q7o();
  }
  toString() {
    return 'Gen(block=' + this.t78_1.toString() + ', name=' + this.u78_1 + ', voffset=' + this.v78_1 + ', vindex=' + this.w78_1 + ', type=' + this.x78_1.toString() + ', arrayCount=' + this.y78_1 + ', size=' + this.z78_1 + ', align=' + this.a79_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.t78_1);
    result = imul(result, 31) + (this.u78_1 == null ? 0 : getStringHashCode(this.u78_1)) | 0;
    result = imul(result, 31) + this.v78_1 | 0;
    result = imul(result, 31) + this.w78_1 | 0;
    result = imul(result, 31) + this.x78_1.hashCode() | 0;
    result = imul(result, 31) + this.y78_1 | 0;
    result = imul(result, 31) + this.z78_1 | 0;
    result = imul(result, 31) + this.a79_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Gen))
      return false;
    var tmp0_other_with_cast = other instanceof Gen ? other : THROW_CCE();
    if (!equals(this.t78_1, tmp0_other_with_cast.t78_1))
      return false;
    if (!(this.u78_1 == tmp0_other_with_cast.u78_1))
      return false;
    if (!(this.v78_1 === tmp0_other_with_cast.v78_1))
      return false;
    if (!(this.w78_1 === tmp0_other_with_cast.w78_1))
      return false;
    if (!this.x78_1.equals(tmp0_other_with_cast.x78_1))
      return false;
    if (!(this.y78_1 === tmp0_other_with_cast.y78_1))
      return false;
    if (!(this.z78_1 === tmp0_other_with_cast.z78_1))
      return false;
    if (!(this.a79_1 === tmp0_other_with_cast.a79_1))
      return false;
    return true;
  }
}
class Operand {
  static z7x(type) {
    var $this = createThis(this);
    $this.i7i_1 = type;
    return $this;
  }
  i2h() {
    return this.i7i_1;
  }
}
class OperandWithArray extends Operand {
  static w7z(type, arrayCount) {
    var $this = this.z7x(type);
    $this.k7i_1 = arrayCount;
    $this.l7i_1 = type.r7i_1;
    $this.m7i_1 = type.s7i_1;
    $this.n7i_1 = imul($this.m7i_1, $this.k7i_1);
    $this.o7i_1 = imul(type.u7i_1, $this.k7i_1);
    return $this;
  }
}
class Variable extends OperandWithArray {
  static x7y(name, type, arrayCount, precision) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    var $this = this.w7z(type, arrayCount);
    $this.u7g_1 = name;
    $this.v7g_1 = precision;
    var tmp = $this;
    var tmp_0 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(arrayCount), null);
    while (tmp_0 < arrayCount) {
      var tmp_2 = tmp_0;
      tmp_1[tmp_2] = $this.u7g_1 + '[' + tmp_2 + ']';
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.w7g_1 = tmp_1;
    $this.x7g_1 = 0;
    $this.y7g_1 = null;
    return $this;
  }
  static o7z(name, type, precision) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.x7y(name, type, 1, precision);
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Variable) {
      tmp_2 = this.x7g_1 === other.x7g_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.i2h().equals(other.i2h());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.k7i_1 === other.k7i_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.u7g_1 === other.u7g_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.x7g_1 + imul(this.i2h().hashCode(), 7) | 0) + imul(getStringHashCode(this.u7g_1), 11) | 0;
  }
}
class VariableWithOffset extends Variable {
  static h7p(name, type, arrayCount, precision, offset) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    offset = offset === VOID ? null : offset;
    var $this = this.x7y(name, type, arrayCount, precision);
    $this.g7p_1 = offset;
    return $this;
  }
}
class TypedUniform extends VariableWithOffset {
  static p7o(name, voffset, vindex, block, type, arrayCount) {
    var $this = this.h7p(name, type, arrayCount, Precision_DEFAULT_getInstance());
    $this.w72_1 = voffset;
    $this.x72_1 = vindex;
    $this.y72_1 = block;
    $this.z72_1 = Uniform.v7p(name, type, arrayCount, VOID, VOID, $this);
    return $this;
  }
  wo(thisRef, property) {
    return this;
  }
  toString() {
    return "TypedUniform(name='" + this.u7g_1 + "', offset=" + this.w72_1 + ', type=' + this.i2h().toString() + ')';
  }
}
class Companion_45 {}
class UniformBlockBuffer {
  constructor(block) {
    this.g71_1 = block;
    this.h71_1 = new AGBuffer();
    this.i71_1 = this.g71_1.g79();
    this.j71_1 = this.g71_1.h79();
    this.k71_1 = this.g71_1.f79().e1();
    this.l71_1 = Buffer.b15(imul(this.j71_1, 1));
    this.m71_1 = UniformsRef.w7p(this.g71_1, this.l71_1, -1);
    this.n71_1 = Buffer.b15(this.g71_1.h79());
  }
  toString() {
    return 'UniformBlockBuffer(' + toString(this.g71_1) + ')';
  }
  x7p(value) {
    this.m71_1.z7l_1 = value;
  }
  f73() {
    return this.m71_1.z7l_1;
  }
  y7p(index) {
    if (index >= (_get_bufferSize__mp12kq(this) - 1 | 0)) {
      // Inline function 'kotlin.math.max' call
      var a = index + 1 | 0;
      var b = imul(index + 2 | 0, 3);
      var newCapacity = Math.max(a, b);
      this.l71_1 = copyOf(this.l71_1, imul(this.j71_1, newCapacity));
      this.m71_1.y7l_1 = this.l71_1;
    }
  }
  j2y() {
    this.x7p(-1);
  }
  p71() {
    var tmp = this.l71_1;
    // Inline function 'kotlin.math.max' call
    var b = imul(this.f73() + 1 | 0, this.g71_1.h79());
    var tmp$ret$0 = Math.max(0, b);
    this.h71_1.u6x(tmp, 0, tmp$ret$0);
    return this;
  }
  z7p() {
    var _unary__edvuaz = this.f73();
    this.x7p(_unary__edvuaz - 1 | 0);
  }
}
class UBLayoutBuilder {
  constructor() {
    this.r7o_1 = 0;
    this.s7o_1 = 4;
    var tmp = this;
    tmp.t7o_1 = lazy(UBLayoutBuilder$size$delegate$lambda(this));
  }
  e1() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.t7o_1;
    size$factory();
    return this_0.u1();
  }
  u7o(size, align_0) {
    // Inline function 'kotlin.also' call
    var this_0 = align(this, align_0).r7o_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.UBLayoutBuilder.rawAlloc.<anonymous>' call
    this.r7o_1 = this.r7o_1 + size | 0;
    return this_0;
  }
}
class UniformsRef {
  static w7p(block, buffer, index) {
    var $this = createThis(this);
    $this.x7l_1 = block;
    $this.y7l_1 = buffer;
    $this.z7l_1 = index;
    $this.a7m_1 = $this.x7l_1.h79();
    return $this;
  }
  static x7m(block, size, index) {
    size = size === VOID ? 1 : size;
    index = index === VOID ? 0 : index;
    return this.w7p(block, Buffer.b15(imul(block.h79(), size)), index);
  }
  a7q(uniform) {
    return imul(this.z7l_1, this.a7m_1) + uniform.w72_1 | 0;
  }
  b7q(ref) {
    arraycopy_0(ref.l71_1, 0, this.y7l_1, imul(this.z7l_1, this.a7m_1), this.a7m_1);
  }
  c7q(uniform, value) {
    return this.d7q(uniform, value);
  }
  e7q(uniform, value) {
    return this.f7q(uniform, _RGBAPremultiplied___get_rf__impl__pt0c4y(value), _RGBAPremultiplied___get_gf__impl__ivron7(value), _RGBAPremultiplied___get_bf__impl__qa3on2(value), _RGBAPremultiplied___get_af__impl__euwcjn(value));
  }
  g7q(uniform, value) {
    return this.f7q(uniform, value.b2p_1, value.c2p_1, value.d2p_1, value.e2p_1);
  }
  h7q(uniform, value) {
    switch (uniform.i2h().t3_1) {
      case 3:
        this.i7q(uniform, value, Companion_getInstance_6().u2j_1);
        break;
      case 2:
        this.j7q(uniform, value, Companion_getInstance_6().u2j_1, 12);
        break;
      default:
        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.ee();
    }
  }
  j7q(uniform, value, indices, max) {
    // Inline function 'kotlin.also' call
    var this_0 = this.a7q(uniform);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.UniformsRef.set.<anonymous>' call
    // Inline function 'korlibs.graphics.shader.UniformsRef.bufferSetFloatNIndexed' call
    var inductionVariable = 0;
    if (inductionVariable < max)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.memory.setF32' call
        var this_1 = this.y7l_1;
        var byteOffset = this_0 + imul(n, 4) | 0;
        // Inline function 'korlibs.graphics.shader.UniformsRef.set.<anonymous>.<anonymous>' call
        var it = indices[n];
        var value_0 = value.y2k(it);
        var tmp;
        if (true) {
          this_1.f15(byteOffset, value_0);
          tmp = Unit_instance;
        } else {
          this_1.e15(byteOffset, value_0);
          tmp = Unit_instance;
        }
      }
       while (inductionVariable < max);
  }
  i7q(uniform, value, indices, max, $super) {
    max = max === VOID ? indices.length : max;
    var tmp;
    if ($super === VOID) {
      this.j7q(uniform, value, indices, max);
      tmp = Unit_instance;
    } else {
      tmp = $super.j7q.call(this, uniform, value, indices, max);
    }
    return tmp;
  }
  d7q(uniform, value) {
    // Inline function 'kotlin.also' call
    var this_0 = this.a7q(uniform);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.UniformsRef.set.<anonymous>' call
    // Inline function 'korlibs.memory.setF32' call
    var this_1 = this.y7l_1;
    var byteOffset = this_0 + 0 | 0;
    var tmp;
    if (true) {
      this_1.f15(byteOffset, value);
      tmp = Unit_instance;
    } else {
      this_1.e15(byteOffset, value);
      tmp = Unit_instance;
    }
  }
  f7q(uniform, x, y, z, w) {
    // Inline function 'kotlin.also' call
    var this_0 = this.a7q(uniform);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.UniformsRef.set.<anonymous>' call
    this.k7q(this_0, x, y, z, w);
  }
  k7q(index, x, y, z, w) {
    // Inline function 'korlibs.memory.setF32' call
    var this_0 = this.y7l_1;
    var byteOffset = index + 0 | 0;
    var tmp;
    if (true) {
      this_0.f15(byteOffset, x);
      tmp = Unit_instance;
    } else {
      this_0.e15(byteOffset, x);
      tmp = Unit_instance;
    }
    // Inline function 'korlibs.memory.setF32' call
    var this_1 = this.y7l_1;
    var byteOffset_0 = index + 4 | 0;
    var tmp_0;
    if (true) {
      this_1.f15(byteOffset_0, y);
      tmp_0 = Unit_instance;
    } else {
      this_1.e15(byteOffset_0, y);
      tmp_0 = Unit_instance;
    }
    // Inline function 'korlibs.memory.setF32' call
    var this_2 = this.y7l_1;
    var byteOffset_1 = index + 8 | 0;
    var tmp_1;
    if (true) {
      this_2.f15(byteOffset_1, z);
      tmp_1 = Unit_instance;
    } else {
      this_2.e15(byteOffset_1, z);
      tmp_1 = Unit_instance;
    }
    // Inline function 'korlibs.memory.setF32' call
    var this_3 = this.y7l_1;
    var byteOffset_2 = index + 12 | 0;
    var tmp_2;
    if (true) {
      this_3.f15(byteOffset_2, w);
      tmp_2 = Unit_instance;
    } else {
      this_3.e15(byteOffset_2, w);
      tmp_2 = Unit_instance;
    }
  }
}
class Companion_46 {
  l7q(isES, isWebGL, isCore, version, os) {
    return _GLVariant___init__impl__cjzpjb(insert8(insert8(insert(insert(insert(0, isES, 0), isWebGL, 1), isCore, 2), version, 8), os.t3_1, 16));
  }
  m7q(isES, isWebGL, isCore, version, os, $super) {
    isES = isES === VOID ? false : isES;
    isWebGL = isWebGL === VOID ? false : isWebGL;
    isCore = isCore === VOID ? false : isCore;
    version = version === VOID ? 0 : version;
    os = os === VOID ? Os_UNKNOWN_getInstance() : os;
    return $super === VOID ? this.l7q(isES, isWebGL, isCore, version, os) : $super.l7q.call(this, isES, isWebGL, isCore, version, os).n7q_1;
  }
  o7q() {
    return Companion_instance_55.m7q(false, VOID, VOID, 1, Os_UNKNOWN_getInstance());
  }
  p7q(version) {
    return Companion_instance_55.m7q(true, true, VOID, version);
  }
}
class GLVariant {
  constructor(data) {
    this.n7q_1 = data;
  }
  toString() {
    return GLVariant__toString_impl_o5yi3l(this.n7q_1);
  }
  hashCode() {
    return GLVariant__hashCode_impl_2eslaq(this.n7q_1);
  }
  equals(other) {
    return GLVariant__equals_impl_kmlw2(this.n7q_1, other);
  }
}
class Visitor {
  constructor(default_0, $box) {
    boxApply(this, $box);
    this.i7s_1 = default_0;
  }
  j7s(func) {
    this.k7s(func.b7u_1);
  }
  x7x(stms) {
    var _iterator__ex2g4s = stms.a1();
    while (_iterator__ex2g4s.b1()) {
      var stm = _iterator__ex2g4s.c1();
      this.k7s(stm);
    }
  }
  k7s(stm) {
    var tmp;
    if (stm == null) {
      tmp = Unit_instance;
    } else {
      if (stm instanceof Stms) {
        this.l7s(stm);
        tmp = Unit_instance;
      } else {
        if (stm instanceof Set) {
          this.o7s(stm);
          tmp = Unit_instance;
        } else {
          if (stm instanceof If) {
            this.m7s(stm);
            tmp = Unit_instance;
          } else {
            if (stm instanceof ForSimple) {
              this.n7s(stm);
              tmp = Unit_instance;
            } else {
              if (stm instanceof Discard) {
                this.p7s(stm);
                tmp = Unit_instance;
              } else {
                if (stm instanceof Continue) {
                  this.r7s(stm);
                  tmp = Unit_instance;
                } else {
                  if (stm instanceof Break) {
                    this.q7s(stm);
                    tmp = Unit_instance;
                  } else {
                    if (stm instanceof Raw) {
                      this.s7s(stm);
                      tmp = Unit_instance;
                    } else {
                      if (stm instanceof Return) {
                        this.t7s(stm);
                        tmp = Unit_instance;
                      } else {
                        noWhenBranchMatchedException();
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return tmp;
  }
  l7s(stms) {
    var _iterator__ex2g4s = stms.p7u_1.a1();
    while (_iterator__ex2g4s.b1()) {
      var stm = _iterator__ex2g4s.c1();
      this.k7s(stm);
    }
  }
  m7s(stm) {
    this.u7s(stm.j7v_1);
    this.k7s(stm.k7v_1);
    this.k7s(stm.l7v_1);
  }
  n7s(stm) {
    this.x7s(stm.m7v_1);
    this.u7s(stm.n7v_1);
    this.k7s(stm.p7v_1);
  }
  o7s(stm) {
    this.u7s(stm.r7u_1);
    this.u7s(stm.q7u_1);
  }
  p7s(stm) {
  }
  q7s(stm) {
  }
  r7s(stm) {
  }
  s7s(stm) {
    this.k7s(stm.l7u_1);
  }
  t7s(stm) {
    var tmp0_safe_receiver = stm.s7u_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.graphics.shader.Visitor.visit.<anonymous>' call
      this.u7s(tmp0_safe_receiver);
    }
  }
  u7s(operand) {
    var tmp;
    if (operand instanceof Variable) {
      tmp = this.x7s(operand);
    } else {
      if (operand instanceof Unop) {
        tmp = this.b7t(operand);
      } else {
        if (operand instanceof Binop) {
          tmp = this.c7t(operand);
        } else {
          if (operand instanceof Ternary) {
            tmp = this.d7t(operand);
          } else {
            if (operand instanceof BoolLiteral) {
              tmp = this.j7t(operand);
            } else {
              if (operand instanceof IntLiteral) {
                tmp = this.h7t(operand);
              } else {
                if (operand instanceof FloatLiteral) {
                  tmp = this.i7t(operand);
                } else {
                  if (operand instanceof Vector) {
                    tmp = this.g7t(operand);
                  } else {
                    if (operand instanceof Swizzle) {
                      tmp = this.e7t(operand);
                    } else {
                      if (operand instanceof ArrayAccess) {
                        tmp = this.f7t(operand);
                      } else {
                        if (operand instanceof BaseFunc) {
                          tmp = this.v7s(operand);
                        } else {
                          invalidOp("Don't know how to visit operand " + toString(operand));
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return tmp;
  }
  v7s(func) {
    var _iterator__ex2g4s = func.e7v().a1();
    while (_iterator__ex2g4s.b1()) {
      var op = _iterator__ex2g4s.c1();
      this.u7s(op);
    }
    var tmp;
    if (func instanceof Func) {
      tmp = this.w7s(func);
    } else {
      if (func instanceof CustomFunc) {
        tmp = this.h7s(func);
      } else {
        invalidOp("Don't know how to visit func " + toString(func));
      }
    }
    return tmp;
  }
  w7s(func) {
    return this.i7s_1;
  }
  h7s(func) {
    return this.i7s_1;
  }
  x7s(operand) {
    var tmp;
    if (operand instanceof Attribute) {
      tmp = this.t7r(operand);
    } else {
      if (operand instanceof Varying) {
        tmp = this.v7r(operand);
      } else {
        if (operand instanceof Sampler) {
          tmp = this.b7s(operand);
        } else {
          if (operand instanceof Uniform) {
            tmp = this.x7r(operand);
          } else {
            if (operand instanceof TypedUniform) {
              tmp = this.z7r(operand);
            } else {
              if (operand instanceof Output) {
                tmp = this.a7t(operand);
              } else {
                if (operand instanceof Temp) {
                  tmp = this.y7s(operand);
                } else {
                  if (operand instanceof Arg) {
                    tmp = this.z7s(operand);
                  } else {
                    noWhenBranchMatchedException();
                  }
                }
              }
            }
          }
        }
      }
    }
    return tmp;
  }
  y7s(temp) {
    return this.i7s_1;
  }
  z7s(arg) {
    return this.i7s_1;
  }
  t7r(attribute) {
    return this.i7s_1;
  }
  v7r(varying) {
    return this.i7s_1;
  }
  x7r(uniform) {
    return this.i7s_1;
  }
  b7s(sampler) {
    return this.i7s_1;
  }
  z7r(typedUniform) {
    return this.x7r(typedUniform.z72_1);
  }
  a7t(output) {
    return this.i7s_1;
  }
  b7t(operand) {
    this.u7s(operand.y7u_1);
    return this.i7s_1;
  }
  c7t(operand) {
    this.u7s(operand.a7v_1);
    this.u7s(operand.c7v_1);
    return this.i7s_1;
  }
  d7t(operand) {
    this.u7s(operand.g7v_1);
    this.u7s(operand.h7v_1);
    this.u7s(operand.i7v_1);
    return this.i7s_1;
  }
  e7t(operand) {
    this.u7s(operand.x7v_1);
    return this.i7s_1;
  }
  f7t(operand) {
    this.u7s(operand.a7w_1);
    this.u7s(operand.b7w_1);
    return this.i7s_1;
  }
  g7t(operand) {
    var indexedObject = operand.v7u_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var op = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      this.u7s(op);
    }
    return this.i7s_1;
  }
  h7t(operand) {
    return this.i7s_1;
  }
  i7t(operand) {
    return this.i7s_1;
  }
  j7t(operand) {
    return this.i7s_1;
  }
}
class GlobalsProgramVisitor extends Visitor {
  constructor() {
    super(Unit_instance);
    this.l7r_1 = LinkedHashSet.h1();
    this.m7r_1 = LinkedHashSet.h1();
    this.n7r_1 = LinkedHashSet.h1();
    this.o7r_1 = LinkedHashSet.h1();
    this.p7r_1 = LinkedHashSet.h1();
    this.q7r_1 = LinkedHashSet.h1();
    this.r7r_1 = LinkedHashSet.h1();
  }
  s7r(attribute) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.l7r_1.h(attribute);
  }
  t7r(attribute) {
    this.s7r(attribute);
    return Unit_instance;
  }
  u7r(varying) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.m7r_1.h(varying);
  }
  v7r(varying) {
    this.u7r(varying);
    return Unit_instance;
  }
  w7r(uniform) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.n7r_1.h(uniform);
    var tmp0_safe_receiver = uniform.u7p_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      this.o7r_1.h(tmp0_safe_receiver);
    }
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.p7r_1;
    var element = uniform.u7p_1.y72_1;
    this_0.h(element);
  }
  x7r(uniform) {
    this.w7r(uniform);
    return Unit_instance;
  }
  y7r(typedUniform) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.n7r_1;
    var element = typedUniform.z72_1;
    this_0.h(element);
    // Inline function 'kotlin.collections.plusAssign' call
    this.o7r_1.h(typedUniform);
    // Inline function 'kotlin.collections.plusAssign' call
    var this_1 = this.p7r_1;
    var element_0 = typedUniform.y72_1;
    this_1.h(element_0);
  }
  z7r(typedUniform) {
    this.y7r(typedUniform);
    return Unit_instance;
  }
  a7s(sampler) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.q7r_1.h(sampler);
  }
  b7s(sampler) {
    this.a7s(sampler);
    return Unit_instance;
  }
  c7s(func) {
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.r7r_1;
    var element = func.g7s().u3();
    this_0.h(element);
  }
  h7s(func) {
    this.c7s(func);
    return Unit_instance;
  }
}
class Companion_47 {
  constructor() {
    Companion_instance_56 = this;
    this.h7n_1 = Companion_getInstance_1().iz('GlslGenerator');
  }
  i7n() {
    return Companion_getInstance_63().i7n();
  }
  j7n() {
    return Companion_getInstance_63().j7n();
  }
}
class Result {
  constructor(generator, result, attributes, uniforms, varyings) {
    this.q7q_1 = generator;
    this.r7q_1 = result;
    this.s7q_1 = attributes;
    this.t7q_1 = uniforms;
    this.u7q_1 = varyings;
  }
  toString() {
    return 'Result(generator=' + toString(this.q7q_1) + ', result=' + this.r7q_1 + ', attributes=' + toString(this.s7q_1) + ', uniforms=' + toString(this.t7q_1) + ', varyings=' + toString(this.u7q_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.q7q_1);
    result = imul(result, 31) + getStringHashCode(this.r7q_1) | 0;
    result = imul(result, 31) + hashCode(this.s7q_1) | 0;
    result = imul(result, 31) + hashCode(this.t7q_1) | 0;
    result = imul(result, 31) + hashCode(this.u7q_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Result))
      return false;
    var tmp0_other_with_cast = other instanceof Result ? other : THROW_CCE();
    if (!equals(this.q7q_1, tmp0_other_with_cast.q7q_1))
      return false;
    if (!(this.r7q_1 === tmp0_other_with_cast.r7q_1))
      return false;
    if (!equals(this.s7q_1, tmp0_other_with_cast.s7q_1))
      return false;
    if (!equals(this.t7q_1, tmp0_other_with_cast.t7q_1))
      return false;
    if (!equals(this.u7q_1, tmp0_other_with_cast.u7q_1))
      return false;
    return true;
  }
}
class sam$kotlin_Comparator$0 {
  constructor(function_0) {
    this.p7t_1 = function_0;
  }
  hj(a, b) {
    return this.p7t_1(a, b);
  }
  compare(a, b) {
    return this.hj(a, b);
  }
  s4() {
    return this.p7t_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.s4(), other.s4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.s4());
  }
}
class BaseGlslGenerator {}
function precToString(prec) {
  var tmp;
  if (!_GLVariant___get_isES__impl__yezzg8(this.i7u().d7h_1)) {
    tmp = '';
  } else {
    var tmp_0;
    switch (prec.t3_1) {
      case 0:
        tmp_0 = '';
        break;
      case 1:
        tmp_0 = 'lowp ';
        break;
      case 2:
        tmp_0 = 'mediump ';
        break;
      case 3:
        tmp_0 = 'highp ';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function typeToString(type) {
  var tmp;
  switch (type.t3_1) {
    case 0:
      tmp = 'void';
      break;
    case 21:
      tmp = 'vec4';
      break;
    case 1:
      tmp = 'mat2';
      break;
    case 2:
      tmp = 'mat3';
      break;
    case 3:
      tmp = 'mat4';
      break;
    case 4:
      tmp = 'sampler1D';
      break;
    case 5:
      tmp = 'sampler2D';
      break;
    case 6:
      tmp = 'sampler3D';
      break;
    case 7:
      tmp = 'samplerCube';
      break;
    default:
      var tmp_0;
      switch (type.r7i_1.t3_1) {
        case 0:
          var tmp_1;
          switch (type.s7i_1) {
            case 1:
              tmp_1 = 'bool';
              break;
            case 2:
              tmp_1 = 'bvec2';
              break;
            case 3:
              tmp_1 = 'bvec3';
              break;
            case 4:
              tmp_1 = 'bvec4';
              break;
            default:
              errorType(this, type);
              break;
          }

          tmp_0 = tmp_1;
          break;
        case 1:
        case 2:
        case 3:
        case 4:
        case 6:
          var tmp_2;
          switch (type.s7i_1) {
            case 1:
              tmp_2 = 'float';
              break;
            case 2:
              tmp_2 = 'vec2';
              break;
            case 3:
              tmp_2 = 'vec3';
              break;
            case 4:
              tmp_2 = 'vec4';
              break;
            default:
              errorType(this, type);
              break;
          }

          tmp_0 = tmp_2;
          break;
        case 5:
          var tmp_3;
          switch (type.s7i_1) {
            case 1:
              tmp_3 = 'int';
              break;
            case 2:
              tmp_3 = 'ivec2';
              break;
            case 3:
              tmp_3 = 'ivec3';
              break;
            case 4:
              tmp_3 = 'ivec4';
              break;
            default:
              errorType(this, type);
              break;
          }

          tmp_0 = tmp_3;
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }

      tmp = tmp_0;
      break;
  }
  return tmp;
}
function get_arrayDecl(_this__u8e3s4) {
  return !(_this__u8e3s4.k7i_1 === 1) ? '[' + _this__u8e3s4.k7i_1 + ']' : '';
}
function get_IN() {
  return this.i7u().r7t();
}
function get_OUT() {
  return this.i7u().w7t();
}
function get_UNIFORM() {
  return this.i7u().v7t();
}
class GlslGenerator {
  constructor(kind, config) {
    Companion_getInstance_62();
    this.h7r_1 = kind;
    this.i7r_1 = config;
  }
  i7u() {
    return this.i7r_1;
  }
  j7r(shader) {
    return this.j7u(shader.w7q_1, shader.x7q_1);
  }
  j7u(root, funcs) {
    var types = new GlobalsProgramVisitor();
    if (this.h7r_1.equals(ShaderType_FRAGMENT_getInstance()) && this.i7r_1.q7t()) {
      types.m7r_1.h(Varying.u7a(this.i7r_1.x7t(), VarType_Float4_getInstance()));
    }
    var tmp = VarType_TVOID_getInstance();
    // Inline function 'kotlin.collections.listOf' call
    var tmp$ret$0 = emptyList();
    var mainFunc = new FuncDecl('main', tmp, tmp$ret$0, root);
    types.j7s(mainFunc);
    // Inline function 'kotlin.collections.distinctBy' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList.i1();
    var tmp0_iterator = funcs.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>' call
      if (types.r7r_1.z2(element.c7u_1.u3())) {
        destination.h(element);
      }
    }
    var this_0 = reversed(destination);
    var set = HashSet.ta();
    var list = ArrayList.i1();
    var tmp0_iterator_0 = this_0.a1();
    while (tmp0_iterator_0.b1()) {
      var e = tmp0_iterator_0.c1();
      // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>' call
      var key = e.c7u_1.u3();
      if (set.h(key)) {
        list.h(e);
      }
    }
    var customFuncs = list;
    var _iterator__ex2g4s = funcs.a1();
    while (_iterator__ex2g4s.b1()) {
      var func = _iterator__ex2g4s.c1();
      types.j7s(mainFunc);
    }
    var allFuncs = plus(customFuncs, listOf(mainFunc));
    // Inline function 'kotlin.also' call
    var tmp_0 = Companion_getInstance_11();
    var this_1 = tmp_0.f3c(GlslGenerator$generateResult$lambda(this, types, allFuncs)).toString();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>' call
    if (Companion_getInstance_63().j7n()) {
      // Inline function 'korlibs.logger.Logger.info' call
      var this_2 = Companion_getInstance_62().h7n_1;
      var level = Level_INFO_getInstance();
      var tmp_1;
      if (this_2.q31(level)) {
        // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>.<anonymous>' call
        var tmp$ret$6 = 'GlSlGenerator.version: ' + this.i7r_1.f7h_1;
        this_2.r31(level, tmp$ret$6);
        tmp_1 = Unit_instance;
      }
      // Inline function 'korlibs.logger.Logger.debug' call
      var this_3 = Companion_getInstance_62().h7n_1;
      var level_0 = Level_DEBUG_getInstance();
      var tmp_2;
      if (this_3.q31(level_0)) {
        // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>.<anonymous>' call
        var tmp$ret$8 = 'GlSlGenerator:\n' + this_1;
        this_3.r31(level_0, tmp$ret$8);
        tmp_2 = Unit_instance;
      }
    }
    var result = this_1;
    var tmp_3;
    if (root instanceof Raw) {
      tmp_3 = root.m7u(Companion_getInstance_63().l7t_1);
    } else {
      tmp_3 = result;
    }
    return new Result(this, tmp_3, toList(types.l7r_1), toList(types.n7r_1), toList(types.m7r_1));
  }
}
class Companion_48 {
  constructor() {
    Companion_instance_57 = this;
    this.k7t_1 = new GlslConfig(Companion_instance_55.o7q(), new Immutable(VOID, VOID, VOID, true));
    this.l7t_1 = 'GLSL';
    this.m7t_1 = 100;
    this.n7t_1 = 'fragColor';
    this.o7t_1 = 'gl_FragColor';
  }
  i7n() {
    var tmp0_safe_receiver = Companion_instance_1.oi('FORCE_GLSL_VERSION');
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : replace(tmp0_safe_receiver, '.', '');
    return tmp1_safe_receiver == null ? null : toIntOrNull(tmp1_safe_receiver);
  }
  j7n() {
    return Companion_instance_1.oi('DEBUG_GLSL') === 'true';
  }
}
class GlslConfig {
  constructor(variant, features, glslVersion, compatibility) {
    Companion_getInstance_63();
    glslVersion = glslVersion === VOID ? -1 : glslVersion;
    compatibility = compatibility === VOID ? true : compatibility;
    this.d7h_1 = variant;
    this.e7h_1 = features;
    this.f7h_1 = glslVersion;
    this.g7h_1 = compatibility;
  }
  n7u(name) {
    if (this.g7h_1)
      return name;
    return name === 'texture2D' ? 'texture' : name;
  }
  q7t() {
    if (_GLVariant___get_isES__impl__yezzg8(this.d7h_1))
      return this.f7h_1 >= 300;
    return !this.g7h_1;
  }
  h7h() {
    return get_ENABLE_UNIFORM_BLOCKS() && this.q7t() && this.e7h_1.t6u();
  }
  r7t() {
    return this.q7t() ? 'in' : 'attribute';
  }
  w7t() {
    return this.q7t() ? 'out' : 'varying';
  }
  v7t() {
    return 'uniform';
  }
  x7t() {
    return this.q7t() ? Companion_getInstance_63().n7t_1 : Companion_getInstance_63().o7t_1;
  }
  o7u(variant, features, glslVersion, compatibility) {
    return new GlslConfig(variant, features, glslVersion, compatibility);
  }
  k7n(variant, features, glslVersion, compatibility, $super) {
    variant = variant === VOID ? this.d7h_1 : variant;
    features = features === VOID ? this.e7h_1 : features;
    glslVersion = glslVersion === VOID ? this.f7h_1 : glslVersion;
    compatibility = compatibility === VOID ? this.g7h_1 : compatibility;
    return $super === VOID ? this.o7u(variant, features, glslVersion, compatibility) : $super.o7u.call(this, new GLVariant(variant), features, glslVersion, compatibility);
  }
  toString() {
    return 'GlslConfig(variant=' + GLVariant__toString_impl_o5yi3l(this.d7h_1) + ', features=' + toString(this.e7h_1) + ', glslVersion=' + this.f7h_1 + ', compatibility=' + this.g7h_1 + ')';
  }
  hashCode() {
    var result = GLVariant__hashCode_impl_2eslaq(this.d7h_1);
    result = imul(result, 31) + hashCode(this.e7h_1) | 0;
    result = imul(result, 31) + this.f7h_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.g7h_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlslConfig))
      return false;
    var tmp0_other_with_cast = other instanceof GlslConfig ? other : THROW_CCE();
    if (!(this.d7h_1 === tmp0_other_with_cast.d7h_1))
      return false;
    if (!equals(this.e7h_1, tmp0_other_with_cast.e7h_1))
      return false;
    if (!(this.f7h_1 === tmp0_other_with_cast.f7h_1))
      return false;
    if (!(this.g7h_1 === tmp0_other_with_cast.g7h_1))
      return false;
    return true;
  }
}
class GlslBodyGenerator extends Visitor {
  constructor(kind, config) {
    super('');
    this.e7u_1 = kind;
    this.f7u_1 = config;
    this.g7u_1 = LinkedHashSet.h1();
    this.h7u_1 = new Indenter();
  }
  i7u() {
    return this.f7u_1;
  }
  l7s(stms) {
    var _iterator__ex2g4s = stms.p7u_1.a1();
    while (_iterator__ex2g4s.b1()) {
      var stm = _iterator__ex2g4s.c1();
      this.k7s(stm);
    }
  }
  o7s(stm) {
    this.h7u_1.y3c(this.u7s(stm.q7u_1) + ' = ' + this.u7s(stm.r7u_1) + ';');
  }
  p7s(stm) {
    this.h7u_1.y3c('discard;');
  }
  q7s(stm) {
    this.h7u_1.y3c('break;');
  }
  r7s(stm) {
    this.h7u_1.y3c('continue;');
  }
  t7s(stm) {
    var result = stm.s7u_1;
    if (!(result == null)) {
      this.h7u_1.y3c('return ' + this.u7s(result) + ';');
    } else {
      this.h7u_1.y3c('return;');
    }
  }
  g7t(operand) {
    var tmp = this.t7t(operand.u7u_1) + '(';
    return tmp + joinToString_0(operand.v7u_1, ', ', VOID, VOID, VOID, VOID, GlslBodyGenerator$visit$lambda(this)) + ')';
  }
  b7t(operand) {
    return '(' + operand.x7u_1 + '(' + this.u7s(operand.y7u_1) + ')' + ')';
  }
  c7t(operand) {
    return '(' + this.u7s(operand.a7v_1) + ' ' + operand.b7v_1 + ' ' + this.u7s(operand.c7v_1) + ')';
  }
  v7s(func) {
    var tmp = this.f7u_1.n7u(func.u3()) + '(';
    var tmp_0 = func.e7v();
    return tmp + joinToString(tmp_0, ', ', VOID, VOID, VOID, VOID, GlslBodyGenerator$visit$lambda_0(this)) + ')';
  }
  d7t(ternary) {
    return '((' + this.u7s(ternary.g7v_1) + ') ? (' + this.u7s(ternary.h7v_1) + ') : (' + this.u7s(ternary.i7v_1) + '))';
  }
  m7s(stm) {
    // Inline function 'kotlin.apply' call
    var this_0 = this.h7u_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.gl.GlslBodyGenerator.visit.<anonymous>' call
    // Inline function 'korlibs.io.util.Indenter.line' call
    var str = 'if (' + this.u7s(stm.j7v_1) + ')';
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(str) === 0) {
      tmp = '{';
    } else {
      tmp = str + ' {';
    }
    this_0.y3c(tmp);
    // Inline function 'korlibs.io.util.Indenter.indent' call
    this_0.z3c();
    try {
      // Inline function 'korlibs.graphics.shader.gl.GlslBodyGenerator.visit.<anonymous>.<anonymous>' call
      this.k7s(stm.k7v_1);
    }finally {
      this_0.a3d();
    }
    this_0.y3c('}');
    if (!(stm.l7v_1 == null)) {
      // Inline function 'korlibs.io.util.Indenter.line' call
      var tmp_0;
      // Inline function 'kotlin.text.isEmpty' call
      if (charSequenceLength('else') === 0) {
        tmp_0 = '{';
      } else {
        tmp_0 = 'else' + ' {';
      }
      this_0.y3c(tmp_0);
      // Inline function 'korlibs.io.util.Indenter.indent' call
      this_0.z3c();
      try {
        // Inline function 'korlibs.graphics.shader.gl.GlslBodyGenerator.visit.<anonymous>.<anonymous>' call
        this.k7s(ensureNotNull(stm.l7v_1));
      }finally {
        this_0.a3d();
      }
      this_0.y3c('}');
    }
  }
  n7s(stm) {
    // Inline function 'kotlin.apply' call
    var this_0 = this.h7u_1;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.gl.GlslBodyGenerator.visit.<anonymous>' call
    var varType = this.t7t(stm.m7v_1.i2h());
    var loopVar = this.x7s(stm.m7v_1);
    var min = this.u7s(stm.n7v_1);
    var maxExclusive = this.u7s(stm.o7v_1);
    // Inline function 'korlibs.io.util.Indenter.line' call
    var str = 'for (' + varType + ' ' + loopVar + ' = (' + min + '); ' + loopVar + ' < (' + maxExclusive + '); ' + loopVar + '++)';
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(str) === 0) {
      tmp = '{';
    } else {
      tmp = str + ' {';
    }
    this_0.y3c(tmp);
    // Inline function 'korlibs.io.util.Indenter.indent' call
    this_0.z3c();
    try {
      // Inline function 'korlibs.graphics.shader.gl.GlslBodyGenerator.visit.<anonymous>.<anonymous>' call
      this.k7s(stm.p7v_1);
    }finally {
      this_0.a3d();
    }
    this_0.y3c('}');
  }
  s7s(stm) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.gl.GlslBodyGenerator.visit.<anonymous>' call
    this.h7u_1.y3c(stm.m7u(Companion_getInstance_63().l7t_1));
  }
  x7s(operand) {
    super.x7s(operand);
    var tmp;
    if (operand instanceof Output) {
      var tmp_0;
      switch (this.e7u_1.t3_1) {
        case 0:
          tmp_0 = 'gl_Position';
          break;
        case 1:
          tmp_0 = this.f7u_1.x7t();
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
      tmp = tmp_0;
    } else {
      tmp = operand.u7g_1;
    }
    return tmp;
  }
  y7s(temp) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.g7u_1.h(temp);
    return super.y7s(temp);
  }
  a7t(output) {
    return super.a7t(output);
  }
  h7t(operand) {
    return '' + operand.r7v_1;
  }
  i7t(operand) {
    var str = '' + operand.t7v_1;
    return contains(str, _Char___init__impl__6a9atx(46)) ? str : str + '.0';
  }
  j7t(operand) {
    return '' + operand.v7v_1;
  }
  e7t(operand) {
    return this.u7s(operand.x7v_1) + '.' + operand.y7v_1;
  }
  f7t(operand) {
    return this.u7s(operand.a7w_1) + '[' + this.u7s(operand.b7w_1) + ']';
  }
}
class ProgramLayout {
  static c7w(items, layoutSize, fixedLocation) {
    fixedLocation = fixedLocation === VOID ? -1 : fixedLocation;
    var $this = createThis(this);
    $this.l73_1 = items;
    $this.m73_1 = layoutSize;
    $this.n73_1 = fixedLocation;
    $this.o73_1 = 0;
    var tmp = $this;
    // Inline function 'korlibs.datastructure.mapInt' call
    var this_0 = $this.l73_1;
    // Inline function 'kotlin.also' call
    var this_1 = IntArrayList.g2s();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
    var _iterator__ex2g4s = this_0.a1();
    while (_iterator__ex2g4s.b1()) {
      var v = _iterator__ex2g4s.c1();
      // Inline function 'korlibs.graphics.shader.ProgramLayout.alignments.<anonymous>' call
      var a = v.i2h().r7i_1.f7w_1;
      var tmp$ret$0 = a <= 1 ? 1 : a;
      this_1.m2s(tmp$ret$0);
    }
    tmp.p73_1 = this_1;
    var tmp_0 = $this;
    // Inline function 'korlibs.datastructure.mapInt' call
    var this_2 = $this.l73_1;
    // Inline function 'kotlin.also' call
    var this_3 = IntArrayList.g2s();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
    var _iterator__ex2g4s_0 = this_2.a1();
    while (_iterator__ex2g4s_0.b1()) {
      var v_0 = _iterator__ex2g4s_0.c1();
      // Inline function 'korlibs.graphics.shader.ProgramLayout._positions.<anonymous>' call
      $this.o73_1 = !(v_0.g7p_1 == null) ? v_0.g7p_1 : nextAlignedTo($this.o73_1, v_0.i2h().r7i_1.f7w_1);
      var out = $this.o73_1;
      $this.o73_1 = $this.o73_1 + v_0.i2h().u7i_1 | 0;
      this_3.m2s(out);
    }
    tmp_0.q73_1 = this_3;
    var tmp_1 = $this;
    var tmp0_elvis_lhs = maxOrNull($this.p73_1);
    tmp_1.r73_1 = tmp0_elvis_lhs == null ? 1 : tmp0_elvis_lhs;
    var tmp_2 = $this;
    var tmp0_elvis_lhs_0 = $this.m73_1;
    tmp_2.s73_1 = tmp0_elvis_lhs_0 == null ? nextAlignedTo($this.o73_1, $this.r73_1) : tmp0_elvis_lhs_0;
    return $this;
  }
  static t73(variables, layoutSize) {
    layoutSize = layoutSize === VOID ? null : layoutSize;
    return this.c7w(toFastList_0(variables), layoutSize);
  }
  g7w() {
    return joinToString(this.l73_1, ', ', VOID, VOID, VOID, VOID, ProgramLayout$names$lambda);
  }
  toString() {
    return get_portableSimpleName(getKClassFromExpression(this)) + '[' + this.g7w() + ', fixedLocation=' + this.n73_1 + ']';
  }
  a1() {
    return this.l73_1.a1();
  }
}
class Attribute extends VariableWithOffset {
  static h7w(name, type, normalized, offset, active, precision, divisor, fixedLocation) {
    offset = offset === VOID ? null : offset;
    active = active === VOID ? true : active;
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    divisor = divisor === VOID ? 0 : divisor;
    var $this = this.h7p(name, type, 1, precision, offset);
    $this.e7a_1 = normalized;
    $this.f7a_1 = active;
    $this.g7a_1 = divisor;
    $this.h7a_1 = fixedLocation;
    return $this;
  }
  static i7a(name, type, normalized, precision, fixedLocation) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.h7w(name, type, normalized, null, true, precision, VOID, fixedLocation);
  }
  toString() {
    return 'Attribute(' + this.u7g_1 + ')';
  }
  equals(other) {
    var tmp;
    var tmp_0;
    var tmp_1;
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp_2;
    var tmp_3;
    var tmp_4;
    var tmp_5;
    if (other instanceof Attribute) {
      tmp_5 = this.x7g_1 === other.x7g_1;
    } else {
      tmp_5 = false;
    }
    if (tmp_5) {
      tmp_4 = this.i2h().equals(other.i2h());
    } else {
      tmp_4 = false;
    }
    if (tmp_4) {
      tmp_3 = this.k7i_1 === other.k7i_1;
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      tmp_2 = this.u7g_1 === other.u7g_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.e7a_1 === (other instanceof Attribute ? other : THROW_CCE()).e7a_1;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.g7p_1 == other.g7p_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.f7a_1 === other.f7a_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    var out = (this.x7g_1 + imul(this.i2h().hashCode(), 7) | 0) + imul(getStringHashCode(this.u7g_1), 11) | 0;
    out = imul(out, 7);
    out = out + getBooleanHashCode(this.e7a_1) | 0;
    out = imul(out, 7);
    var tmp = out;
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.g7p_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    out = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    out = imul(out, 7);
    out = out + getBooleanHashCode(this.f7a_1) | 0;
    return out;
  }
}
class Stm {}
class Stms extends Stm {
  constructor(stms) {
    super();
    this.p7u_1 = stms;
  }
  toString() {
    return 'Stms(stms=' + toString(this.p7u_1) + ')';
  }
  hashCode() {
    return hashCode(this.p7u_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Stms))
      return false;
    var tmp0_other_with_cast = other instanceof Stms ? other : THROW_CCE();
    if (!equals(this.p7u_1, tmp0_other_with_cast.p7u_1))
      return false;
    return true;
  }
}
class Set extends Stm {
  constructor(to, from) {
    super();
    this.q7u_1 = to;
    this.r7u_1 = from;
  }
  toString() {
    return 'Set(to=' + toString(this.q7u_1) + ', from=' + toString(this.r7u_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.q7u_1);
    result = imul(result, 31) + hashCode(this.r7u_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Set))
      return false;
    var tmp0_other_with_cast = other instanceof Set ? other : THROW_CCE();
    if (!equals(this.q7u_1, tmp0_other_with_cast.q7u_1))
      return false;
    if (!equals(this.r7u_1, tmp0_other_with_cast.r7u_1))
      return false;
    return true;
  }
}
class Return extends Stm {
  constructor(result) {
    super();
    this.s7u_1 = result;
  }
  toString() {
    return 'Return(result=' + toString_1(this.s7u_1) + ')';
  }
  hashCode() {
    return this.s7u_1 == null ? 0 : hashCode(this.s7u_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Return))
      return false;
    var tmp0_other_with_cast = other instanceof Return ? other : THROW_CCE();
    if (!equals(this.s7u_1, tmp0_other_with_cast.s7u_1))
      return false;
    return true;
  }
}
class Break extends Stm {}
class Continue extends Stm {}
class Discard extends Stm {
  constructor() {
    Discard_instance = null;
    super();
    Discard_instance = this;
  }
  toString() {
    return 'Discard';
  }
}
class If extends Stm {
  constructor(cond, tbody, fbody) {
    fbody = fbody === VOID ? null : fbody;
    super();
    this.j7v_1 = cond;
    this.k7v_1 = tbody;
    this.l7v_1 = fbody;
  }
  toString() {
    return 'If(cond=' + toString(this.j7v_1) + ', tbody=' + toString(this.k7v_1) + ', fbody=' + toString_1(this.l7v_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.j7v_1);
    result = imul(result, 31) + hashCode(this.k7v_1) | 0;
    result = imul(result, 31) + (this.l7v_1 == null ? 0 : hashCode(this.l7v_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof If))
      return false;
    var tmp0_other_with_cast = other instanceof If ? other : THROW_CCE();
    if (!equals(this.j7v_1, tmp0_other_with_cast.j7v_1))
      return false;
    if (!equals(this.k7v_1, tmp0_other_with_cast.k7v_1))
      return false;
    if (!equals(this.l7v_1, tmp0_other_with_cast.l7v_1))
      return false;
    return true;
  }
}
class ForSimple extends Stm {}
class Raw extends Stm {
  i7w(name) {
    return this.k7u_1.h3(name);
  }
  j7w(name, default_0) {
    var tmp0_elvis_lhs = this.i7w(name);
    return tmp0_elvis_lhs == null ? default_0 : tmp0_elvis_lhs;
  }
  m7u(name, default_0, $super) {
    default_0 = default_0 === VOID ? '' : default_0;
    return $super === VOID ? this.j7w(name, default_0) : $super.j7w.call(this, name, default_0);
  }
}
class Program$ExpressionBuilder$Companion$INSTANCE$1 {}
class Companion_49 {
  constructor() {
    Companion_instance_58 = this;
    var tmp = this;
    tmp.k7w_1 = new Program$ExpressionBuilder$Companion$INSTANCE$1();
  }
}
class FuncBuilder extends Builder {
  static t7w(parent) {
    var $this = this.u7w(parent);
    var tmp = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.r7w_1 = ArrayList.i1();
    return $this;
  }
  s7w(name, type) {
    // Inline function 'kotlin.also' call
    var this_0 = Arg.g7x(name, type);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.FuncBuilder.ARG.<anonymous>' call
    // Inline function 'kotlin.collections.plusAssign' call
    this.r7w_1.h(this_0);
    return this_0;
  }
}
class FuncDeclGetter {
  constructor(decl) {
    this.u7x_1 = decl;
  }
  wo(thisRef, property) {
    var tmp = this.u7x_1;
    return isInterface(tmp, FuncRef) ? tmp : THROW_CCE();
  }
}
class FuncProvider {
  constructor(rettype, varTypes, builder, block) {
    this.l7w_1 = rettype;
    this.m7w_1 = varTypes;
    this.n7w_1 = builder;
    this.o7w_1 = block;
  }
  r79(thisRef, property) {
    var tmp = property.callableName;
    var tmp_0 = this.n7w_1.j7c(tmp, this.l7w_1, Program$Builder$FuncProvider$provideDelegate$lambda(this));
    return new FuncDeclGetter(tmp_0 instanceof FuncDecl ? tmp_0 : THROW_CCE());
  }
}
class Program$Builder$_funcs$1 extends Visitor {
  constructor($funcs, $box) {
    if ($box === VOID)
      $box = {};
    $box.w7x_1 = $funcs;
    super(Unit_instance, $box);
  }
  c7s(func) {
    // Inline function 'kotlin.collections.set' call
    var this_0 = this.w7x_1;
    var key = func.u3();
    var tmp = func.g7s();
    var value = tmp instanceof FuncDecl ? tmp : THROW_CCE();
    this_0.j3(key, value);
  }
  h7s(func) {
    this.c7s(func);
    return Unit_instance;
  }
}
class Ternary extends Operand {
  static y7x(cond, otrue, ofalse) {
    var $this = this.z7x(otrue.i2h());
    $this.g7v_1 = cond;
    $this.h7v_1 = otrue;
    $this.i7v_1 = ofalse;
    return $this;
  }
  toString() {
    return 'Ternary(cond=' + toString(this.g7v_1) + ', otrue=' + toString(this.h7v_1) + ', ofalse=' + toString(this.i7v_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.g7v_1);
    result = imul(result, 31) + hashCode(this.h7v_1) | 0;
    result = imul(result, 31) + hashCode(this.i7v_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Ternary))
      return false;
    var tmp0_other_with_cast = other instanceof Ternary ? other : THROW_CCE();
    if (!equals(this.g7v_1, tmp0_other_with_cast.g7v_1))
      return false;
    if (!equals(this.h7v_1, tmp0_other_with_cast.h7v_1))
      return false;
    if (!equals(this.i7v_1, tmp0_other_with_cast.i7v_1))
      return false;
    return true;
  }
}
class Unop extends Operand {
  static a7y(op, right) {
    var $this = this.z7x(right.i2h());
    $this.x7u_1 = op;
    $this.y7u_1 = right;
    return $this;
  }
  toString() {
    return 'Unop(op=' + this.x7u_1 + ', right=' + toString(this.y7u_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.x7u_1);
    result = imul(result, 31) + hashCode(this.y7u_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Unop))
      return false;
    var tmp0_other_with_cast = other instanceof Unop ? other : THROW_CCE();
    if (!(this.x7u_1 === tmp0_other_with_cast.x7u_1))
      return false;
    if (!equals(this.y7u_1, tmp0_other_with_cast.y7u_1))
      return false;
    return true;
  }
}
class Binop extends Operand {
  static b7y(left, op, right) {
    var $this = this.z7x(left.i2h());
    $this.a7v_1 = left;
    $this.b7v_1 = op;
    $this.c7v_1 = right;
    return $this;
  }
  toString() {
    return 'Binop(left=' + toString(this.a7v_1) + ', op=' + this.b7v_1 + ', right=' + toString(this.c7v_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.a7v_1);
    result = imul(result, 31) + getStringHashCode(this.b7v_1) | 0;
    result = imul(result, 31) + hashCode(this.c7v_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Binop))
      return false;
    var tmp0_other_with_cast = other instanceof Binop ? other : THROW_CCE();
    if (!equals(this.a7v_1, tmp0_other_with_cast.a7v_1))
      return false;
    if (!(this.b7v_1 === tmp0_other_with_cast.b7v_1))
      return false;
    if (!equals(this.c7v_1, tmp0_other_with_cast.c7v_1))
      return false;
    return true;
  }
}
class IntLiteral extends Operand {}
class FloatLiteral extends Operand {
  static c7y(value) {
    var $this = this.z7x(VarType_Float1_getInstance());
    $this.t7v_1 = value;
    return $this;
  }
  toString() {
    return 'FloatLiteral(value=' + this.t7v_1 + ')';
  }
  hashCode() {
    return getNumberHashCode(this.t7v_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FloatLiteral))
      return false;
    var tmp0_other_with_cast = other instanceof FloatLiteral ? other : THROW_CCE();
    if (!equals(this.t7v_1, tmp0_other_with_cast.t7v_1))
      return false;
    return true;
  }
}
class BoolLiteral extends Operand {}
class Vector extends Operand {
  static d7y(type, ops) {
    var $this = this.z7x(type);
    $this.u7u_1 = type;
    $this.v7u_1 = ops;
    return $this;
  }
  i2h() {
    return this.u7u_1;
  }
  equals(other) {
    var tmp;
    var tmp_0;
    if (other instanceof Vector) {
      tmp_0 = this.u7u_1.equals(other.u7u_1);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = contentEquals(this.v7u_1, other.v7u_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return imul(this.u7u_1.hashCode(), 7) + contentHashCode(this.v7u_1) | 0;
  }
  toString() {
    return 'Vector(type=' + this.u7u_1.toString() + ', ops=' + toString(this.v7u_1) + ')';
  }
}
class Swizzle extends Operand {
  static e7y(left, swizzle) {
    var $this = this.z7x(left.i2h().f7y(swizzle.length));
    $this.x7v_1 = left;
    $this.y7v_1 = swizzle;
    return $this;
  }
  toString() {
    return 'Swizzle(left=' + toString(this.x7v_1) + ', swizzle=' + this.y7v_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.x7v_1);
    result = imul(result, 31) + getStringHashCode(this.y7v_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Swizzle))
      return false;
    var tmp0_other_with_cast = other instanceof Swizzle ? other : THROW_CCE();
    if (!equals(this.x7v_1, tmp0_other_with_cast.x7v_1))
      return false;
    if (!(this.y7v_1 === tmp0_other_with_cast.y7v_1))
      return false;
    return true;
  }
}
class ArrayAccess extends Operand {}
class BaseFunc extends Operand {
  static g7y(type) {
    return this.z7x(type);
  }
}
class Func extends BaseFunc {
  static l7y(name, ops, type) {
    type = type === VOID ? VarType_Float1_getInstance() : type;
    var $this = this.g7y(type);
    $this.i7y_1 = name;
    $this.j7y_1 = ops;
    $this.k7y_1 = type;
    return $this;
  }
  u3() {
    return this.i7y_1;
  }
  e7v() {
    return this.j7y_1;
  }
  i2h() {
    return this.k7y_1;
  }
  static m7y(name, ops, type) {
    type = type === VOID ? VarType_Float1_getInstance() : type;
    return this.l7y(name, toList_0(ops), type);
  }
  toString() {
    return 'Func(name=' + this.i7y_1 + ', ops=' + toString(this.j7y_1) + ', type=' + this.k7y_1.toString() + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.i7y_1);
    result = imul(result, 31) + hashCode(this.j7y_1) | 0;
    result = imul(result, 31) + this.k7y_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Func))
      return false;
    var tmp0_other_with_cast = other instanceof Func ? other : THROW_CCE();
    if (!(this.i7y_1 === tmp0_other_with_cast.i7y_1))
      return false;
    if (!equals(this.j7y_1, tmp0_other_with_cast.j7y_1))
      return false;
    if (!this.k7y_1.equals(tmp0_other_with_cast.k7y_1))
      return false;
    return true;
  }
}
class CustomFunc extends BaseFunc {
  static n7y(ref, ops) {
    var $this = this.g7y(ref.o7y());
    $this.e7s_1 = ref;
    $this.f7s_1 = ops;
    return $this;
  }
  g7s() {
    return this.e7s_1;
  }
  e7v() {
    return this.f7s_1;
  }
  u3() {
    return this.g7s().u3();
  }
}
class FuncRef {}
class BuilderContext {
  constructor() {
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.p7y_1 = ArrayList.i1();
    this.q7y_1 = 3;
  }
}
class Program {
  constructor(vertex, fragment, name) {
    name = name === VOID ? 'program-' + vertex.y7q_1 + '-' + fragment.y7q_1 : name;
    this.a72_1 = vertex;
    this.b72_1 = fragment;
    this.c72_1 = name;
    this.d72_1 = plus_0(this.a72_1.d7r_1, this.b72_1.d7r_1);
    this.e72_1 = plus_0(this.a72_1.e7r_1, this.b72_1.e7r_1);
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.e72_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.graphics.shader.Program.uniformBlocks.<anonymous>' call
      var tmp$ret$0 = item.y72_1;
      destination.h(tmp$ret$0);
    }
    tmp.f72_1 = distinct(destination);
    this.g72_1 = plus_0(this.a72_1.g7r_1, this.b72_1.g7r_1);
    var tmp_0 = this;
    // Inline function 'kotlin.collections.associate' call
    var this_1 = withIndex(this.d72_1);
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination_0 = LinkedHashMap.sc(capacity);
    var tmp0_iterator_0 = this_1.a1();
    while (tmp0_iterator_0.b1()) {
      var element = tmp0_iterator_0.c1();
      // Inline function 'kotlin.collections.plusAssign' call
      // Inline function 'korlibs.graphics.shader.Program.uniformsToIndex.<anonymous>' call
      var pair = to(element.nl_1, new UniformInProgram(element.nl_1, element.ml_1));
      destination_0.j3(pair.sl_1, pair.tl_1);
    }
    tmp_0.h72_1 = destination_0;
    this.i72_1 = plus_0(this.a72_1.f7r_1, this.b72_1.f7r_1);
    this.j72_1 = (imul(this.a72_1.hashCode(), 11) + imul(this.b72_1.hashCode(), 7) | 0) + getStringHashCode(this.c72_1) | 0;
  }
  hashCode() {
    return this.j72_1;
  }
  equals(other) {
    var tmp;
    if (this === other) {
      tmp = true;
    } else {
      var tmp_0;
      var tmp_1;
      var tmp_2;
      if (other instanceof Program) {
        tmp_2 = this.a72_1.equals(other.a72_1);
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        tmp_1 = this.b72_1.equals(other.b72_1);
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp_0 = this.c72_1 === other.c72_1;
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  t6() {
  }
  toString() {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.i72_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.graphics.shader.Program.toString.<anonymous>' call
      var tmp$ret$0 = item.u7g_1;
      destination.h(tmp$ret$0);
    }
    var tmp = toString(destination);
    // Inline function 'kotlin.collections.map' call
    var this_1 = this.d72_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.w(collectionSizeOrDefault(this_1, 10));
    var tmp0_iterator_0 = this_1.a1();
    while (tmp0_iterator_0.b1()) {
      var item_0 = tmp0_iterator_0.c1();
      // Inline function 'korlibs.graphics.shader.Program.toString.<anonymous>' call
      var tmp$ret$3 = item_0.u7g_1;
      destination_0.h(tmp$ret$3);
    }
    return 'Program(name=' + this.c72_1 + ', attributes=' + tmp + ', uniforms=' + toString(destination_0) + ')';
  }
  u7y(vertex, fragment, name) {
    return new Program(vertex, fragment, name);
  }
  v7y(vertex, fragment, name, $super) {
    vertex = vertex === VOID ? this.a72_1 : vertex;
    fragment = fragment === VOID ? this.b72_1 : fragment;
    name = name === VOID ? this.c72_1 : name;
    return $super === VOID ? this.u7y(vertex, fragment, name) : $super.u7y.call(this, vertex, fragment, name);
  }
}
class Shader {
  constructor(type, stm, functions, name) {
    name = name === VOID ? null : name;
    this.v7q_1 = type;
    this.w7q_1 = stm;
    this.x7q_1 = functions;
    this.y7q_1 = name;
    this.z7q_1 = hashCode(this.w7q_1);
    this.a7r_1 = hashCode(this.x7q_1);
    this.b7r_1 = (imul(this.v7q_1.hashCode(), 17) + this.z7q_1 | 0) + imul(this.a7r_1, 53) | 0;
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = new GlobalsProgramVisitor();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.Shader.globals.<anonymous>' call
    this_0.k7s(this.w7q_1);
    tmp.c7r_1 = this_0;
    this.d7r_1 = this.c7r_1.n7r_1;
    this.e7r_1 = this.c7r_1.o7r_1;
    this.f7r_1 = this.c7r_1.l7r_1;
    this.g7r_1 = this.c7r_1.q7r_1;
  }
  equals(other) {
    var tmp;
    if (this === other) {
      tmp = true;
    } else {
      var tmp_0;
      var tmp_1;
      var tmp_2;
      var tmp_3;
      if (other instanceof Shader) {
        tmp_3 = this.v7q_1.equals(other.v7q_1);
      } else {
        tmp_3 = false;
      }
      if (tmp_3) {
        tmp_2 = this.b7r_1 === other.b7r_1;
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        tmp_1 = equals(this.w7q_1, other.w7q_1);
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp_0 = equals(this.x7q_1, other.x7q_1);
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  hashCode() {
    return this.b7r_1;
  }
  toString() {
    return 'Shader(type=' + this.v7q_1.toString() + ', stm=' + toString(this.w7q_1) + ', functions=' + toString(this.x7q_1) + ', name=' + this.y7q_1 + ')';
  }
}
class Varying extends Variable {
  static w7y(name, type, arrayCount, precision) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.x7y(name, type, arrayCount, precision);
  }
  static u7a(name, type, precision) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.w7y(name, type, 1, precision);
  }
  toString() {
    return 'Varying(' + this.u7g_1 + ')';
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Varying) {
      tmp_2 = this.x7g_1 === other.x7g_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.i2h().equals(other.i2h());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.k7i_1 === other.k7i_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.u7g_1 === other.u7g_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.x7g_1 + imul(this.i2h().hashCode(), 7) | 0) + imul(getStringHashCode(this.u7g_1), 11) | 0;
  }
}
class Output extends Varying {
  static j7z() {
    Output_instance = null;
    var $this = this.u7a('out', VarType_Float4_getInstance());
    Output_instance = $this;
    return $this;
  }
  toString() {
    return 'Output';
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Output) {
      tmp_2 = this.x7g_1 === other.x7g_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.i2h().equals(other.i2h());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.k7i_1 === other.k7i_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.u7g_1 === other.u7g_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.x7g_1 + imul(this.i2h().hashCode(), 7) | 0) + imul(getStringHashCode(this.u7g_1), 11) | 0;
  }
}
class Provider {
  constructor(index, stype) {
    this.p79_1 = index;
    this.q79_1 = stype;
  }
  r79(thisRef, property) {
    return Sampler.k7z(property.callableName, this.p79_1, this.q79_1);
  }
}
class Sampler extends Variable {
  static k7z(name, index, stype) {
    var $this = this.o7z(name, stype.n7z_1);
    $this.o6y_1 = index;
    $this.p6y_1 = stype;
    return $this;
  }
  toString() {
    return 'Sampler(' + this.u7g_1 + ', ' + this.o6y_1 + ', ' + this.p6y_1.toString() + ')';
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Sampler) {
      tmp_2 = this.x7g_1 === other.x7g_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.i2h().equals(other.i2h());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.k7i_1 === other.k7i_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.u7g_1 === other.u7g_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.x7g_1 + imul(this.i2h().hashCode(), 7) | 0) + imul(getStringHashCode(this.u7g_1), 11) | 0;
  }
  wo(thisRef, property) {
    return this;
  }
}
class SamplerVarType extends Enum {
  constructor(name, ordinal, vtype) {
    super(name, ordinal);
    this.n7z_1 = vtype;
  }
}
class Uniform extends VariableWithOffset {
  static v7p(name, type, arrayCount, precision, offset, typedUniform) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    offset = offset === VOID ? null : offset;
    var $this = this.h7p(name, type, arrayCount, precision, offset);
    $this.u7p_1 = typedUniform;
    if (type.p7z()) {
      // Inline function 'kotlin.error' call
      var message = "Can't create uniform '" + name + "' with a sampler type '" + type.toString() + "', please use `Sampler` class instead";
      throw IllegalStateException.l5(toString(message));
    }
    return $this;
  }
  toString() {
    return 'Uniform(' + this.u7g_1 + ')';
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Uniform) {
      tmp_2 = this.x7g_1 === other.x7g_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.i2h().equals(other.i2h());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.k7i_1 === other.k7i_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.u7g_1 === other.u7g_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.x7g_1 + imul(this.i2h().hashCode(), 7) | 0) + imul(getStringHashCode(this.u7g_1), 11) | 0;
  }
}
class Companion_50 {
  q7z(count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_SByte1_getInstance();
        break;
      case 2:
        tmp = VarType_SByte2_getInstance();
        break;
      case 3:
        tmp = VarType_SByte3_getInstance();
        break;
      case 4:
        tmp = VarType_SByte4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  }
  r7z(count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_UByte1_getInstance();
        break;
      case 2:
        tmp = VarType_UByte2_getInstance();
        break;
      case 3:
        tmp = VarType_UByte3_getInstance();
        break;
      case 4:
        tmp = VarType_UByte4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  }
  s7z(count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_SShort1_getInstance();
        break;
      case 2:
        tmp = VarType_SShort2_getInstance();
        break;
      case 3:
        tmp = VarType_SShort3_getInstance();
        break;
      case 4:
        tmp = VarType_SShort4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  }
  t7z(count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_UShort1_getInstance();
        break;
      case 2:
        tmp = VarType_UShort2_getInstance();
        break;
      case 3:
        tmp = VarType_UShort3_getInstance();
        break;
      case 4:
        tmp = VarType_UShort4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  }
  u7z(count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_SInt1_getInstance();
        break;
      case 2:
        tmp = VarType_SInt2_getInstance();
        break;
      case 3:
        tmp = VarType_SInt3_getInstance();
        break;
      case 4:
        tmp = VarType_SInt4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  }
  v7z(count) {
    var tmp;
    switch (count) {
      case 0:
        tmp = VarType_TVOID_getInstance();
        break;
      case 1:
        tmp = VarType_Float1_getInstance();
        break;
      case 2:
        tmp = VarType_Float2_getInstance();
        break;
      case 3:
        tmp = VarType_Float3_getInstance();
        break;
      case 4:
        tmp = VarType_Float4_getInstance();
        break;
      default:
        get_invalidOp();
        break;
    }
    return tmp;
  }
}
class VarType extends Enum {
  constructor(name, ordinal, kind, elementCount, isMatrix) {
    isMatrix = isMatrix === VOID ? false : isMatrix;
    super(name, ordinal);
    this.r7i_1 = kind;
    this.s7i_1 = elementCount;
    this.t7i_1 = isMatrix;
    this.u7i_1 = imul(this.r7i_1.f7w_1, this.s7i_1);
  }
  f7y(length) {
    var tmp;
    switch (this.r7i_1.t3_1) {
      case 1:
        tmp = Companion_instance_59.q7z(length);
        break;
      case 2:
        tmp = Companion_instance_59.r7z(length);
        break;
      case 3:
        tmp = Companion_instance_59.s7z(length);
        break;
      case 4:
        tmp = Companion_instance_59.t7z(length);
        break;
      case 5:
        tmp = Companion_instance_59.u7z(length);
        break;
      case 6:
        tmp = Companion_instance_59.v7z(length);
        break;
      default:
        throw NotImplementedError.ee();
    }
    return tmp;
  }
  p7z() {
    return this.equals(VarType_Sampler1D_getInstance()) || this.equals(VarType_Sampler2D_getInstance()) || this.equals(VarType_Sampler3D_getInstance()) || this.equals(VarType_SamplerCube_getInstance());
  }
}
class Precision extends Enum {}
class Temp extends Variable {
  static r7y(id, type, arrayCount, precision) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.x7y('temp' + id, type, arrayCount, precision);
  }
  static g7b(id, type, precision) {
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.r7y(id, type, 1, precision);
  }
  toString() {
    return 'Temp(' + this.u7g_1 + ')';
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Temp) {
      tmp_2 = this.x7g_1 === other.x7g_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.i2h().equals(other.i2h());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.k7i_1 === other.k7i_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.u7g_1 === other.u7g_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.x7g_1 + imul(this.i2h().hashCode(), 7) | 0) + imul(getStringHashCode(this.u7g_1), 11) | 0;
  }
}
class FuncDecl {
  constructor(name, rettype, args, stm) {
    this.y7t_1 = name;
    this.z7t_1 = rettype;
    this.a7u_1 = args;
    this.b7u_1 = stm;
    this.c7u_1 = this;
  }
  u3() {
    return this.y7t_1;
  }
  o7y() {
    return this.z7t_1;
  }
  toString() {
    return 'FuncDecl(name=' + this.y7t_1 + ', rettype=' + this.z7t_1.toString() + ', args=' + toString(this.a7u_1) + ', stm=' + toString(this.b7u_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.y7t_1);
    result = imul(result, 31) + this.z7t_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.a7u_1) | 0;
    result = imul(result, 31) + hashCode(this.b7u_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FuncDecl))
      return false;
    var tmp0_other_with_cast = other instanceof FuncDecl ? other : THROW_CCE();
    if (!(this.y7t_1 === tmp0_other_with_cast.y7t_1))
      return false;
    if (!this.z7t_1.equals(tmp0_other_with_cast.z7t_1))
      return false;
    if (!equals(this.a7u_1, tmp0_other_with_cast.a7u_1))
      return false;
    if (!equals(this.b7u_1, tmp0_other_with_cast.b7u_1))
      return false;
    return true;
  }
}
class VarKind extends Enum {
  constructor(name, ordinal, bytesSize) {
    super(name, ordinal);
    this.f7w_1 = bytesSize;
  }
}
class UniformInProgram {
  constructor(uniform, index) {
    this.x7z_1 = uniform;
    this.y7z_1 = index;
  }
  toString() {
    return 'UniformInProgram(uniform=' + this.x7z_1.toString() + ', index=' + this.y7z_1 + ')';
  }
  hashCode() {
    var result = this.x7z_1.hashCode();
    result = imul(result, 31) + this.y7z_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof UniformInProgram))
      return false;
    var tmp0_other_with_cast = other instanceof UniformInProgram ? other : THROW_CCE();
    if (!this.x7z_1.equals(tmp0_other_with_cast.x7z_1))
      return false;
    if (!(this.y7z_1 === tmp0_other_with_cast.y7z_1))
      return false;
    return true;
  }
}
class Arg extends Variable {
  static g7x(name, type, arrayCount, precision) {
    arrayCount = arrayCount === VOID ? 1 : arrayCount;
    precision = precision === VOID ? Precision_DEFAULT_getInstance() : precision;
    return this.x7y(name, type, arrayCount, precision);
  }
  toString() {
    return 'Arg(' + this.u7g_1 + ')';
  }
  equals(other) {
    // Inline function 'korlibs.graphics.shader.Variable.mequals' call
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (other instanceof Arg) {
      tmp_2 = this.x7g_1 === other.x7g_1;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = this.i2h().equals(other.i2h());
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = this.k7i_1 === other.k7i_1;
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = this.u7g_1 === other.u7g_1;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    // Inline function 'korlibs.graphics.shader.Variable.mhashcode' call
    return (this.x7g_1 + imul(this.i2h().hashCode(), 7) | 0) + imul(getStringHashCode(this.u7g_1), 11) | 0;
  }
}
class ShaderType extends Enum {}
class sam$kotlinx_coroutines_DisposableHandle$0 {
  constructor(function_0) {
    this.z7z_1 = function_0;
  }
  d1b() {
    return this.z7z_1();
  }
  s4() {
    return this.z7z_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, DisposableHandle) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.s4(), other.s4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.s4());
  }
}
class ContextInfo {
  constructor() {
    var tmp = this;
    tmp.a80_1 = KmlGl$ContextInfo$current$lambda;
  }
  toString() {
    return 'current=' + toString_1(this.a80_1());
  }
}
class Companion_51 {
  constructor() {
    this.b80_1 = 33309;
    this.c80_1 = 33084;
    this.d80_1 = 33085;
    this.e80_1 = 256;
    this.f80_1 = 1024;
    this.g80_1 = 16384;
    this.h80_1 = 0;
    this.i80_1 = 1;
    this.j80_1 = 0;
    this.k80_1 = 1;
    this.l80_1 = 2;
    this.m80_1 = 3;
    this.n80_1 = 4;
    this.o80_1 = 5;
    this.p80_1 = 6;
    this.q80_1 = 0;
    this.r80_1 = 1;
    this.s80_1 = 768;
    this.t80_1 = 769;
    this.u80_1 = 770;
    this.v80_1 = 771;
    this.w80_1 = 772;
    this.x80_1 = 773;
    this.y80_1 = 774;
    this.z80_1 = 775;
    this.a81_1 = 776;
    this.b81_1 = 32774;
    this.c81_1 = 32777;
    this.d81_1 = 32777;
    this.e81_1 = 34877;
    this.f81_1 = 32778;
    this.g81_1 = 32779;
    this.h81_1 = 32968;
    this.i81_1 = 32969;
    this.j81_1 = 32970;
    this.k81_1 = 32971;
    this.l81_1 = 32769;
    this.m81_1 = 32770;
    this.n81_1 = 32771;
    this.o81_1 = 32772;
    this.p81_1 = 32773;
    this.q81_1 = 34962;
    this.r81_1 = 34963;
    this.s81_1 = 34964;
    this.t81_1 = 34965;
    this.u81_1 = 35040;
    this.v81_1 = 35044;
    this.w81_1 = 35048;
    this.x81_1 = 34660;
    this.y81_1 = 34661;
    this.z81_1 = 34342;
    this.a82_1 = 1028;
    this.b82_1 = 1029;
    this.c82_1 = 1032;
    this.d82_1 = 3553;
    this.e82_1 = 32879;
    this.f82_1 = 2884;
    this.g82_1 = 3042;
    this.h82_1 = 3024;
    this.i82_1 = 2960;
    this.j82_1 = 2929;
    this.k82_1 = 3089;
    this.l82_1 = 32823;
    this.m82_1 = 32926;
    this.n82_1 = 32928;
    this.o82_1 = 0;
    this.p82_1 = 1280;
    this.q82_1 = 1281;
    this.r82_1 = 1282;
    this.s82_1 = 1285;
    this.t82_1 = 2304;
    this.u82_1 = 2305;
    this.v82_1 = 2849;
    this.w82_1 = 33901;
    this.x82_1 = 33902;
    this.y82_1 = 2885;
    this.z82_1 = 2886;
    this.a83_1 = 2928;
    this.b83_1 = 2930;
    this.c83_1 = 2931;
    this.d83_1 = 2932;
    this.e83_1 = 2961;
    this.f83_1 = 2962;
    this.g83_1 = 2964;
    this.h83_1 = 2965;
    this.i83_1 = 2966;
    this.j83_1 = 2967;
    this.k83_1 = 2963;
    this.l83_1 = 2968;
    this.m83_1 = 34816;
    this.n83_1 = 34817;
    this.o83_1 = 34818;
    this.p83_1 = 34819;
    this.q83_1 = 36003;
    this.r83_1 = 36004;
    this.s83_1 = 36005;
    this.t83_1 = 2978;
    this.u83_1 = 3088;
    this.v83_1 = 3106;
    this.w83_1 = 3107;
    this.x83_1 = 3317;
    this.y83_1 = 3333;
    this.z83_1 = 3379;
    this.a84_1 = 3386;
    this.b84_1 = 3408;
    this.c84_1 = 3410;
    this.d84_1 = 3411;
    this.e84_1 = 3412;
    this.f84_1 = 3413;
    this.g84_1 = 3414;
    this.h84_1 = 3415;
    this.i84_1 = 10752;
    this.j84_1 = 32824;
    this.k84_1 = 32873;
    this.l84_1 = 32936;
    this.m84_1 = 32937;
    this.n84_1 = 32938;
    this.o84_1 = 32939;
    this.p84_1 = 34466;
    this.q84_1 = 34467;
    this.r84_1 = 4352;
    this.s84_1 = 4353;
    this.t84_1 = 4354;
    this.u84_1 = 33170;
    this.v84_1 = 5120;
    this.w84_1 = 5121;
    this.x84_1 = 5122;
    this.y84_1 = 5123;
    this.z84_1 = 5124;
    this.a85_1 = 5125;
    this.b85_1 = 5126;
    this.c85_1 = 5132;
    this.d85_1 = 6402;
    this.e85_1 = 6406;
    this.f85_1 = 6407;
    this.g85_1 = 6408;
    this.h85_1 = 6409;
    this.i85_1 = 6410;
    this.j85_1 = 32819;
    this.k85_1 = 32820;
    this.l85_1 = 33635;
    this.m85_1 = 35632;
    this.n85_1 = 35633;
    this.o85_1 = 34921;
    this.p85_1 = 36347;
    this.q85_1 = 36348;
    this.r85_1 = 35661;
    this.s85_1 = 35660;
    this.t85_1 = 34930;
    this.u85_1 = 36349;
    this.v85_1 = 35663;
    this.w85_1 = 35712;
    this.x85_1 = 35714;
    this.y85_1 = 35715;
    this.z85_1 = 35717;
    this.a86_1 = 35718;
    this.b86_1 = 35719;
    this.c86_1 = 35721;
    this.d86_1 = 35722;
    this.e86_1 = 35724;
    this.f86_1 = 35725;
    this.g86_1 = 512;
    this.h86_1 = 513;
    this.i86_1 = 514;
    this.j86_1 = 515;
    this.k86_1 = 516;
    this.l86_1 = 517;
    this.m86_1 = 518;
    this.n86_1 = 519;
    this.o86_1 = 7680;
    this.p86_1 = 7681;
    this.q86_1 = 7682;
    this.r86_1 = 7683;
    this.s86_1 = 5386;
    this.t86_1 = 34055;
    this.u86_1 = 34056;
    this.v86_1 = 7936;
    this.w86_1 = 7937;
    this.x86_1 = 7938;
    this.y86_1 = 7939;
    this.z86_1 = 9728;
    this.a87_1 = 9729;
    this.b87_1 = 9984;
    this.c87_1 = 9985;
    this.d87_1 = 9986;
    this.e87_1 = 9987;
    this.f87_1 = 10240;
    this.g87_1 = 10241;
    this.h87_1 = 10242;
    this.i87_1 = 10243;
    this.j87_1 = 32882;
    this.k87_1 = 5890;
    this.l87_1 = 34067;
    this.m87_1 = 34068;
    this.n87_1 = 34069;
    this.o87_1 = 34070;
    this.p87_1 = 34071;
    this.q87_1 = 34072;
    this.r87_1 = 34073;
    this.s87_1 = 34074;
    this.t87_1 = 34076;
    this.u87_1 = 33984;
    this.v87_1 = 33985;
    this.w87_1 = 33986;
    this.x87_1 = 33987;
    this.y87_1 = 33988;
    this.z87_1 = 33989;
    this.a88_1 = 33990;
    this.b88_1 = 33991;
    this.c88_1 = 33992;
    this.d88_1 = 33993;
    this.e88_1 = 33994;
    this.f88_1 = 33995;
    this.g88_1 = 33996;
    this.h88_1 = 33997;
    this.i88_1 = 33998;
    this.j88_1 = 33999;
    this.k88_1 = 34000;
    this.l88_1 = 34001;
    this.m88_1 = 34002;
    this.n88_1 = 34003;
    this.o88_1 = 34004;
    this.p88_1 = 34005;
    this.q88_1 = 34006;
    this.r88_1 = 34007;
    this.s88_1 = 34008;
    this.t88_1 = 34009;
    this.u88_1 = 34010;
    this.v88_1 = 34011;
    this.w88_1 = 34012;
    this.x88_1 = 34013;
    this.y88_1 = 34014;
    this.z88_1 = 34015;
    this.a89_1 = 34016;
    this.b89_1 = 10497;
    this.c89_1 = 33071;
    this.d89_1 = 33648;
    this.e89_1 = 35664;
    this.f89_1 = 35665;
    this.g89_1 = 35666;
    this.h89_1 = 35667;
    this.i89_1 = 35668;
    this.j89_1 = 35669;
    this.k89_1 = 35670;
    this.l89_1 = 35671;
    this.m89_1 = 35672;
    this.n89_1 = 35673;
    this.o89_1 = 35674;
    this.p89_1 = 35675;
    this.q89_1 = 35676;
    this.r89_1 = 35678;
    this.s89_1 = 35680;
    this.t89_1 = 34338;
    this.u89_1 = 34339;
    this.v89_1 = 34340;
    this.w89_1 = 34341;
    this.x89_1 = 34922;
    this.y89_1 = 34373;
    this.z89_1 = 34975;
    this.a8a_1 = 35738;
    this.b8a_1 = 35739;
    this.c8a_1 = 35713;
    this.d8a_1 = 35716;
    this.e8a_1 = 35720;
    this.f8a_1 = 36346;
    this.g8a_1 = 36344;
    this.h8a_1 = 36345;
    this.i8a_1 = 36336;
    this.j8a_1 = 36337;
    this.k8a_1 = 36338;
    this.l8a_1 = 36339;
    this.m8a_1 = 36340;
    this.n8a_1 = 36341;
    this.o8a_1 = 36160;
    this.p8a_1 = 36161;
    this.q8a_1 = 32854;
    this.r8a_1 = 32855;
    this.s8a_1 = 36194;
    this.t8a_1 = 33189;
    this.u8a_1 = 6401;
    this.v8a_1 = 36168;
    this.w8a_1 = 36162;
    this.x8a_1 = 36163;
    this.y8a_1 = 36164;
    this.z8a_1 = 36176;
    this.a8b_1 = 36177;
    this.b8b_1 = 36178;
    this.c8b_1 = 36179;
    this.d8b_1 = 36180;
    this.e8b_1 = 36181;
    this.f8b_1 = 36048;
    this.g8b_1 = 36049;
    this.h8b_1 = 36050;
    this.i8b_1 = 36051;
    this.j8b_1 = 36064;
    this.k8b_1 = 36096;
    this.l8b_1 = 33306;
    this.m8b_1 = 34041;
    this.n8b_1 = 36128;
    this.o8b_1 = 0;
    this.p8b_1 = 36053;
    this.q8b_1 = 36054;
    this.r8b_1 = 36055;
    this.s8b_1 = 36057;
    this.t8b_1 = 36061;
    this.u8b_1 = 36006;
    this.v8b_1 = 36007;
    this.w8b_1 = 34024;
    this.x8b_1 = 1286;
    this.y8b_1 = 37120;
    this.z8b_1 = 34836;
    this.a8c_1 = 3313;
    this.b8c_1 = 3314;
    this.c8c_1 = 3316;
    this.d8c_1 = 3315;
    this.e8c_1 = 3312;
    this.f8c_1 = 37441;
    this.g8c_1 = 36197;
    this.h8c_1 = 35345;
    this.i8c_1 = 35368;
    this.j8c_1 = 35380;
  }
}
class KmlGl {
  constructor() {
    this.s7f_1 = new Mixin();
    this.t7f_1 = new ContextInfo();
    this.u7f_1 = null;
    var tmp = this;
    tmp.v7f_1 = lazy(KmlGl$isFloatTextureSupported$delegate$lambda(this));
  }
  h7j(texture) {
    throw NotImplementedError.ee();
  }
  n7n(program, shader) {
    throw NotImplementedError.ee();
  }
  m7n(program, index, name) {
    throw NotImplementedError.ee();
  }
  b7i(target, buffer) {
    throw NotImplementedError.ee();
  }
  f7m(target, framebuffer) {
    throw NotImplementedError.ee();
  }
  m7m(target, renderbuffer) {
    throw NotImplementedError.ee();
  }
  d7m(target, texture) {
    throw NotImplementedError.ee();
  }
  p7k(modeRGB, modeAlpha) {
    throw NotImplementedError.ee();
  }
  q7k(sfactorRGB, dfactorRGB, sfactorAlpha, dfactorAlpha) {
    throw NotImplementedError.ee();
  }
  l7j(target, size, data, usage) {
    throw NotImplementedError.ee();
  }
  k7j(target, offset, size, data) {
    throw NotImplementedError.ee();
  }
  l7k(mask) {
    throw NotImplementedError.ee();
  }
  g7k(red, green, blue, alpha) {
    throw NotImplementedError.ee();
  }
  i7k(d) {
    throw NotImplementedError.ee();
  }
  k7k(s) {
    throw NotImplementedError.ee();
  }
  t7m(red, green, blue, alpha) {
    throw NotImplementedError.ee();
  }
  e7n(shader) {
    throw NotImplementedError.ee();
  }
  g7n() {
    throw NotImplementedError.ee();
  }
  c7n(type) {
    throw NotImplementedError.ee();
  }
  i7l(mode) {
    throw NotImplementedError.ee();
  }
  k8c(n, items) {
    throw NotImplementedError.ee();
  }
  l8c(n, items) {
    throw NotImplementedError.ee();
  }
  b7n(program) {
    throw NotImplementedError.ee();
  }
  m8c(n, items) {
    throw NotImplementedError.ee();
  }
  a7n(shader) {
    throw NotImplementedError.ee();
  }
  n8c(n, items) {
    throw NotImplementedError.ee();
  }
  s7m(func) {
    throw NotImplementedError.ee();
  }
  h7k(flag) {
    throw NotImplementedError.ee();
  }
  r7m(n, f) {
    throw NotImplementedError.ee();
  }
  u7k(cap) {
    throw NotImplementedError.ee();
  }
  k7l(index) {
    throw NotImplementedError.ee();
  }
  b7l(mode, first, count) {
    throw NotImplementedError.ee();
  }
  d7l(mode, count, type, indices) {
    throw NotImplementedError.ee();
  }
  v7k(cap) {
    throw NotImplementedError.ee();
  }
  o7l(index) {
    throw NotImplementedError.ee();
  }
  bd() {
    throw NotImplementedError.ee();
  }
  p7m(target, attachment, renderbuffertarget, renderbuffer) {
    throw NotImplementedError.ee();
  }
  o7m(target, attachment, textarget, texture, level) {
    throw NotImplementedError.ee();
  }
  q7m(mode) {
    throw NotImplementedError.ee();
  }
  o8c(n, buffers) {
    throw NotImplementedError.ee();
  }
  p7j(target) {
    throw NotImplementedError.ee();
  }
  p8c(n, framebuffers) {
    throw NotImplementedError.ee();
  }
  q8c(n, renderbuffers) {
    throw NotImplementedError.ee();
  }
  r8c(n, textures) {
    throw NotImplementedError.ee();
  }
  y7m(program, name) {
    throw NotImplementedError.ee();
  }
  f7n() {
    throw NotImplementedError.ee();
  }
  s8c(pname, data) {
    throw NotImplementedError.ee();
  }
  t8c(program, pname, params) {
    throw NotImplementedError.ee();
  }
  u8c(shader, pname, params) {
    throw NotImplementedError.ee();
  }
  v8c(shader, bufSize, length, infoLog) {
    throw NotImplementedError.ee();
  }
  w7f(name) {
    throw NotImplementedError.ee();
  }
  o7n(program) {
    throw NotImplementedError.ee();
  }
  m7j(pname, param) {
    throw NotImplementedError.ee();
  }
  c7m(x, y, width, height, format, type, pixels) {
    throw NotImplementedError.ee();
  }
  n7m(target, internalformat, width, height) {
    throw NotImplementedError.ee();
  }
  u7m(x, y, width, height) {
    throw NotImplementedError.ee();
  }
  d7n(shader, string) {
    throw NotImplementedError.ee();
  }
  x7k(func, ref, mask) {
    throw NotImplementedError.ee();
  }
  w7k(face, func, ref, mask) {
    throw NotImplementedError.ee();
  }
  j7k(mask) {
    throw NotImplementedError.ee();
  }
  a7l(face, mask) {
    throw NotImplementedError.ee();
  }
  z7k(fail, zfail, zpass) {
    throw NotImplementedError.ee();
  }
  y7k(face, sfail, dpfail, dppass) {
    throw NotImplementedError.ee();
  }
  n7j(target, level, internalformat, width, height, border, format, type, pixels) {
    throw NotImplementedError.ee();
  }
  o7j(target, level, internalformat, format, type, data) {
    var buffer = Buffer.b15(imul(imul(data.r43_1, data.s43_1), 4), true);
    setArrayLE(buffer, 0, data.o4b().h43_1);
    this.n7j(target, level, internalformat, data.r43_1, data.s43_1, 0, format, type, buffer);
  }
  g7j(target, pname, param) {
    throw NotImplementedError.ee();
  }
  c7j(location, count, value) {
    throw NotImplementedError.ee();
  }
  a7h(location, v0) {
    throw NotImplementedError.ee();
  }
  v7i(location, count, value) {
    throw NotImplementedError.ee();
  }
  d7j(location, count, value) {
    throw NotImplementedError.ee();
  }
  w7i(location, count, value) {
    throw NotImplementedError.ee();
  }
  e7j(location, count, value) {
    throw NotImplementedError.ee();
  }
  x7i(location, count, value) {
    throw NotImplementedError.ee();
  }
  f7j(location, count, value) {
    throw NotImplementedError.ee();
  }
  y7i(location, count, value) {
    throw NotImplementedError.ee();
  }
  z7i(location, count, transpose, value) {
    throw NotImplementedError.ee();
  }
  a7j(location, count, transpose, value) {
    throw NotImplementedError.ee();
  }
  b7j(location, count, transpose, value) {
    throw NotImplementedError.ee();
  }
  z7m(program) {
    throw NotImplementedError.ee();
  }
  p7l(index, size, type, normalized, stride, pointer) {
    throw NotImplementedError.ee();
  }
  e7m(x, y, width, height) {
    throw NotImplementedError.ee();
  }
  r7k(cap, enable) {
    if (enable) {
      this.v7k(cap);
    } else {
      this.u7k(cap);
    }
    return enable;
  }
  c7l(mode, first, count, instancecount) {
    unsupported('Not supported instanced drawing');
  }
  e7l(mode, count, type, indices, instancecount) {
    unsupported('Not supported instanced drawing');
  }
  j7l(index, divisor) {
    unsupported();
  }
  w7l(target, index, buffer, offset, size) {
    unsupported('Not supported uniform buffers ' + toString(getKClassFromExpression(this)));
  }
  b7h(program, name) {
    unsupported('Not supported uniform buffers ' + toString(getKClassFromExpression(this)));
  }
  c7h(program, uniformBlockIndex, uniformBlockBinding) {
    unsupported('Not supported uniform buffers ' + toString(getKClassFromExpression(this)));
  }
  w8c(n, arrays) {
    unsupported('Not supported vertex arrays ' + toString(getKClassFromExpression(this)));
  }
  l7l(array) {
    unsupported('Not supported vertex arrays ' + toString(getKClassFromExpression(this)));
  }
  i7j() {
    return Companion_instance_55.o7q();
  }
  b7k() {
    return Unit_instance;
  }
  g7l(contextVersion) {
    return Unit_instance;
  }
  x8c(name, index) {
    throw NotImplementedError.ee();
  }
  j61() {
    if (this.u7f_1 == null) {
      var tmp = this;
      var tmp_0;
      try {
        var numExtensions = getIntegerv(this, 33309);
        if (numExtensions <= 0) {
          // Inline function 'kotlin.TODO' call
          throw NotImplementedError.ee();
        }
        // Inline function 'kotlin.collections.mapNotNull' call
        // Inline function 'kotlin.collections.mapNotNullTo' call
        var this_0 = until(0, numExtensions);
        var destination = ArrayList.i1();
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable = this_0.d2_1;
        var last = this_0.e2_1;
        if (inductionVariable <= last)
          do {
            var element = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
            // Inline function 'korlibs.kgl.KmlGl.<get-extensions>.<anonymous>' call
            var it = element;
            // Inline function 'korlibs.kgl.KmlGl.EXTENSIONS' call
            var tmp0_safe_receiver = this.x8c(7939, it);
            if (tmp0_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.contracts.contract' call
              destination.h(tmp0_safe_receiver);
            }
          }
           while (!(element === last));
        tmp_0 = toSet(destination);
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var e = $p;
          // Inline function 'korlibs.kgl.KmlGl.EXTENSIONS' call
          tmp_1 = toSet(split(this.w7f(7939), [' ']));
        } else {
          throw $p;
        }
        tmp_0 = tmp_1;
      }
      tmp.u7f_1 = tmp_0;
    }
    return ensureNotNull(this.u7f_1);
  }
  c7k() {
    return this.j61();
  }
  r10(value) {
    this.s7f_1.r10(value);
  }
  s10() {
    return this.s7f_1.s10();
  }
}
class KmlGlContext {
  constructor(window_0, gl, parent, $box) {
    parent = parent === VOID ? null : parent;
    boxApply(this, $box);
    this.y7j_1 = window_0;
    this.z7j_1 = gl;
    this.a7k_1 = parent;
  }
  f7l() {
  }
  h7l() {
  }
  t6() {
  }
}
class KorgeReloadInternalImpl {
  y8c(clazz, context) {
    return clazz;
  }
  z8c(old, new_0) {
    return Unit_instance;
  }
}
class ReloadClassContext {
  constructor(injector, refreshedClasses, rootFolders) {
    this.a8d_1 = injector;
    this.b8d_1 = refreshedClasses;
    this.c8d_1 = rootFolders;
  }
}
class KorgeReload {
  constructor() {
    KorgeReload_instance = this;
    this.d8d_1 = null;
    this.e8d_1 = Companion_getInstance_1().iz('KorgeReload');
  }
  f8d(eventDispatcher) {
    if (!Companion_getInstance_3().ww().hx() || !(Companion_instance_1.oi('KORGE_AUTORELOAD') === 'true'))
      return Unit_instance;
    this.d8d_1 = eventDispatcher;
  }
  g8d() {
    if (!Companion_getInstance_3().ww().hx())
      return Unit_instance;
    if (!(this.d8d_1 == null))
      this.d8d_1 = null;
  }
}
class Companion_52 {}
class Companion_53 {
  constructor() {
    Companion_instance_62 = this;
    var tmp = this;
    var tmp0_factors = Companion_getInstance_42().c6v_1;
    tmp.h8d_1 = new BlendMode(tmp0_factors, 'NORMAL');
    this.i8d_1 = this.h8d_1.u8g(VOID, 'INHERIT');
    var tmp_0 = this;
    var tmp0_factors_0 = Companion_getInstance_42().u74(Companion_getInstance_53().l74_1, Companion_getInstance_53().s74_1);
    tmp_0.j8d_1 = new BlendMode(tmp0_factors_0, 'NONE');
    var tmp_1 = this;
    var tmp0_factors_1 = Companion_getInstance_42().e6v_1;
    tmp_1.k8d_1 = new BlendMode(tmp0_factors_1, 'ADD');
    var tmp_2 = this;
    var tmp0_factors_2 = Companion_getInstance_42().u74(Companion_getInstance_53().k74_1, Companion_getInstance_53().o74_1);
    tmp_2.l8d_1 = new BlendMode(tmp0_factors_2, 'MULTIPLY');
    var tmp_3 = this;
    var tmp0_factors_3 = Companion_getInstance_42().u74(Companion_getInstance_53().l74_1, Companion_getInstance_53().p74_1);
    tmp_3.m8d_1 = new BlendMode(tmp0_factors_3, 'SCREEN');
    var tmp_4 = this;
    var tmp0_factors_4 = Companion_getInstance_42().u74(Companion_getInstance_53().s74_1, Companion_getInstance_53().o74_1);
    tmp_4.n8d_1 = new BlendMode(tmp0_factors_4, 'ERASE');
    var tmp_5 = this;
    var tmp0_factors_5 = Companion_getInstance_42().u74(Companion_getInstance_53().s74_1, Companion_getInstance_53().q74_1);
    tmp_5.o8d_1 = new BlendMode(tmp0_factors_5, 'MASK');
    var tmp_6 = this;
    var tmp0_factors_6 = Companion_getInstance_42().u74(Companion_getInstance_53().m74_1, Companion_getInstance_53().j74_1);
    tmp_6.p8d_1 = new BlendMode(tmp0_factors_6, 'BELOW');
    var tmp_7 = this;
    var tmp0_factors_7 = Companion_getInstance_42().t74(Companion_getInstance_53().q74_1, Companion_getInstance_53().j74_1, Companion_getInstance_53().l74_1, Companion_getInstance_53().l74_1, Companion_getInstance_54().y74_1);
    tmp_7.q8d_1 = new BlendMode(tmp0_factors_7, 'SUBTRACT');
    var tmp_8 = this;
    var tmp0_factors_8 = Companion_getInstance_42().t74(Companion_getInstance_53().n74_1, Companion_getInstance_53().s74_1, Companion_getInstance_53().l74_1, Companion_getInstance_53().l74_1);
    tmp_8.r8d_1 = new BlendMode(tmp0_factors_8, 'INVERT');
    var tmp_9 = this;
    var tmp0_factors_9 = Companion_getInstance_42().t74(Companion_getInstance_53().q74_1, Companion_getInstance_53().j74_1, Companion_getInstance_53().l74_1, Companion_getInstance_53().l74_1);
    tmp_9.s8d_1 = new BlendMode(tmp0_factors_9, 'LIGHTEN');
    var tmp_10 = this;
    var tmp0_factors_10 = Companion_getInstance_42().t74(Companion_getInstance_53().q74_1, Companion_getInstance_53().j74_1, Companion_getInstance_53().l74_1, Companion_getInstance_53().l74_1);
    tmp_10.t8d_1 = new BlendMode(tmp0_factors_10, 'DARKEN');
    var tmp_11 = this;
    var tmp0_factors_11 = Companion_getInstance_42().t74(Companion_getInstance_53().q74_1, Companion_getInstance_53().j74_1, Companion_getInstance_53().l74_1, Companion_getInstance_53().l74_1);
    tmp_11.u8d_1 = new BlendMode(tmp0_factors_11, 'DIFFERENCE');
    var tmp_12 = this;
    var tmp0_factors_12 = Companion_getInstance_42().t74(Companion_getInstance_53().q74_1, Companion_getInstance_53().j74_1, Companion_getInstance_53().l74_1, Companion_getInstance_53().l74_1);
    tmp_12.v8d_1 = new BlendMode(tmp0_factors_12, 'ALPHA');
    var tmp_13 = this;
    var tmp0_factors_13 = Companion_getInstance_42().t74(Companion_getInstance_53().q74_1, Companion_getInstance_53().j74_1, Companion_getInstance_53().l74_1, Companion_getInstance_53().l74_1);
    tmp_13.w8d_1 = new BlendMode(tmp0_factors_13, 'HARDLIGHT');
    var tmp_14 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_14.x8d_1 = [this.i8d_1, this.j8d_1, this.h8d_1, this.k8d_1, this.l8d_1, this.m8d_1, this.n8d_1, this.o8d_1, this.p8d_1, this.q8d_1, this.r8d_1, this.s8d_1, this.t8d_1, this.u8d_1, this.v8d_1, this.w8d_1];
    var tmp_15 = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = this.x8d_1;
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.sc(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.korge.blend.Companion.BY_NAME.<anonymous>' call
      var tmp$ret$3 = ensureNotNull(element.s8g_1);
      destination.j3(tmp$ret$3, element);
    }
    tmp_15.y8d_1 = destination;
    this.z8d_1 = toList_0(this.x8d_1);
    var tmp_16 = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_1 = get_indices(this.x8d_1);
    var capacity_0 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_0 = LinkedHashMap.sc(capacity_0);
    var inductionVariable_0 = this_1.d2_1;
    var last_0 = this_1.e2_1;
    if (inductionVariable_0 <= last_0)
      do {
        var element_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        // Inline function 'korlibs.korge.blend.Companion.TO_ORDINAL.<anonymous>' call
        var it = element_0;
        var tmp$ret$6 = Companion_getInstance_68().x8d_1[it];
        destination_0.j3(tmp$ret$6, element_0);
      }
       while (!(element_0 === last_0));
    tmp_16.a8e_1 = destination_0;
  }
}
class BlendMode {
  constructor(factors, name) {
    Companion_getInstance_68();
    name = name === VOID ? null : name;
    this.r8g_1 = factors;
    this.s8g_1 = name;
    var tmp = this;
    var tmp_0 = AGBlending__hashCode_impl_ywnf51(this.r8g_1);
    // Inline function 'kotlin.hashCode' call
    var tmp0_safe_receiver = this.s8g_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    var tmp$ret$0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    tmp.t8g_1 = tmp_0 + imul(tmp$ret$0, 7) | 0;
  }
  hashCode() {
    return this.t8g_1;
  }
  equals(other) {
    var tmp;
    if (this === other) {
      tmp = true;
    } else {
      var tmp_0;
      var tmp_1;
      if (other instanceof BlendMode) {
        tmp_1 = this.r8g_1 === other.r8g_1;
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp_0 = this.s8g_1 == other.s8g_1;
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  toString() {
    var tmp0_elvis_lhs = this.s8g_1;
    return tmp0_elvis_lhs == null ? anyToString(this) : tmp0_elvis_lhs;
  }
  v8g(factors, name) {
    return new BlendMode(factors, name);
  }
  u8g(factors, name, $super) {
    factors = factors === VOID ? this.r8g_1 : factors;
    name = name === VOID ? this.s8g_1 : name;
    return $super === VOID ? this.v8g(factors, name) : $super.v8g.call(this, new AGBlending(factors), name);
  }
}
class InputKeys {
  constructor() {
    this.w8g_1 = booleanArray(Companion_getInstance_34().m6s_1);
    this.x8g_1 = booleanArray(Companion_getInstance_34().m6s_1);
    this.y8g_1 = false;
    this.z8g_1 = false;
    this.a8h_1 = false;
    this.b8h_1 = false;
  }
  c8h(key) {
    return this.d8h(key);
  }
  d8h(key) {
    return this.w8g_1[key.t3_1];
  }
  e8h(key, up, shift, ctrl, alt, meta) {
    switch (up) {
      case true:
        this.w8g_1[key.t3_1] = false;
        break;
      case false:
        this.w8g_1[key.t3_1] = true;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    this.y8g_1 = shift || this.c8h(Companion_getInstance_34().a6t()) || this.c8h(Companion_getInstance_34().b6t());
    this.z8g_1 = ctrl || this.c8h(Companion_getInstance_34().y6s()) || this.c8h(Companion_getInstance_34().z6s());
    this.a8h_1 = alt || this.c8h(Companion_getInstance_34().c6t()) || this.c8h(Companion_getInstance_34().d6t());
    this.b8h_1 = meta || this.c8h(Key_META_getInstance());
  }
  f8h(e) {
    switch (e.d6n_1.t3_1) {
      case 0:
      case 1:
        this.e8h(e.f6n_1, e.d6n_1.equals(Type_UP_getInstance()), this.y8g_1, this.z8g_1, this.a8h_1, this.b8h_1);
        break;
      default:
        break;
    }
  }
  g8h(delta) {
  }
  h8h(delta) {
    arraycopy_4(this.w8g_1, 0, this.x8g_1, 0, this.w8g_1.length);
  }
}
class Companion_54 {
  constructor() {
    this.i8h_1 = 256;
  }
}
class Input {
  constructor() {
    this.j8h_1 = new Mixin();
    this.k8h_1 = Companion_getInstance_27().f6p_1;
    this.l8h_1 = new TouchEvent();
    var tmp = this;
    tmp.m8h_1 = Input$_isTouchDeviceGen$lambda;
    var tmp_0 = this;
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    tmp_0.n8h_1 = toDuration(400, DurationUnit_MILLISECONDS_getInstance());
    this.o8h_1 = 20.0;
    this.p8h_1 = Vector2D.q2f(-1000.0, -1000.0);
    this.q8h_1 = Vector2D.q2f(-1000.0, -1000.0);
    this.r8h_1 = 0;
    this.s8h_1 = false;
    this.t8h_1 = true;
    this.u8h_1 = false;
    this.v8h_1 = new InputKeys();
    this.w8h_1 = booleanArray(256);
    this.x8h_1 = booleanArray(256);
    this.y8h_1 = new Float64Array(256);
    this.z8h_1 = new Float64Array(256);
    this.a8i_1 = booleanArray(256);
    this.b8i_1 = booleanArray(256);
    this.c8i_1 = booleanArray(256);
    var tmp_1 = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, 8);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.d2_1;
    var last = this_0.e2_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.korge.input.Input.gamepads.<anonymous>' call
        var it = item;
        var tmp$ret$2 = new GamepadInfo(it);
        destination.h(tmp$ret$2);
      }
       while (!(item === last));
    tmp_1.d8i_1 = copyToArray(destination);
    var tmp_2 = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_2.e8i_1 = ArrayList.i1();
  }
  g8i(touchEvent) {
    this.l8h_1.o6q(touchEvent);
  }
  h8i() {
    return this.p8h_1;
  }
  i8i(p, down) {
    if (down)
      this.q8h_1 = p;
    else
      this.p8h_1 = p;
  }
  j8i(button, down) {
    this.r8h_1 = setBits(this.r8h_1, button.o6t_1, down);
  }
  k8i() {
    this.e8i_1.m3();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.d8i_1;
    var n = 0;
    while (n < this_0.length) {
      // Inline function 'korlibs.korge.input.Input.updateConnectedGamepads.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var gamepad = this_0[_unary__edvuaz];
      if (gamepad.j6r_1) {
        // Inline function 'kotlin.collections.plusAssign' call
        this.e8i_1.h(gamepad);
      }
    }
  }
  l8i(keyCode, b) {
    var pKeyCode = keyCode & 255;
    if (0 <= pKeyCode ? pKeyCode <= (this.w8h_1.length - 1 | 0) : false) {
      this.w8h_1[pKeyCode] = b;
    }
  }
  m8i(delta) {
    var tmp0_safe_receiver = this.s10();
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.m3();
    }
    this.v8h_1.g8h(delta);
  }
  n8i(delta) {
    this.u8h_1 = false;
    this.v8h_1.h8h(delta);
    endFrameOldKeys(this, delta);
  }
  o8i(e) {
    switch (e.d6n_1.t3_1) {
      case 1:
        this.l8i(e.g6n_1, true);
        break;
      case 0:
        this.l8i(e.g6n_1, false);
        break;
      case 2:
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
  }
  r10(value) {
    this.j8h_1.r10(value);
  }
  s10() {
    return this.j8h_1.s10();
  }
}
class DefaultViewport {
  constructor() {
    DefaultViewport_instance = this;
    this.p8i_1 = 1280;
    this.q8i_1 = 720;
    this.r8i_1 = Size2D.o2e(1280, 720);
  }
}
class Companion_55 {
  s8i(str) {
    // Inline function 'kotlin.apply' call
    var this_0 = new Props();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.logger.Companion.load.<anonymous>' call
    this_0.u8i(str);
    return this_0;
  }
}
class Props {
  constructor(props) {
    props = props === VOID ? LinkedHashMap.rc() : props;
    this.t8i_1 = props;
  }
  v8i(str) {
    var _iterator__ex2g4s = split(str, ['\n']).a1();
    $l$loop_0: while (_iterator__ex2g4s.b1()) {
      var line = _iterator__ex2g4s.c1();
      if (startsWith(line, _Char___init__impl__6a9atx(35)))
        continue $l$loop_0;
      if (isBlank(line))
        continue $l$loop_0;
      var parts = split_0(line, charArrayOf([_Char___init__impl__6a9atx(61)]), VOID, 2);
      // Inline function 'kotlin.text.trim' call
      var this_0 = parts.d1(0);
      var key = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
      // Inline function 'kotlin.text.trim' call
      // Inline function 'kotlin.collections.getOrElse' call
      // Inline function 'kotlin.contracts.contract' call
      var tmp;
      if (0 <= 1 ? 1 < parts.e1() : false) {
        tmp = parts.d1(1);
      } else {
        // Inline function 'korlibs.korge.logger.Props.deserializeAdd.<anonymous>' call
        tmp = ' ';
      }
      var this_1 = tmp;
      var value = toString(trim(isCharSequence(this_1) ? this_1 : THROW_CCE()));
      // Inline function 'kotlin.collections.set' call
      this.t8i_1.j3(key, value);
    }
  }
  u8i(str) {
    this.m3();
    this.v8i(str);
  }
  m3() {
    this.t8i_1.m3();
  }
  w8i(key, value) {
    return this.t8i_1.j3(key, value);
  }
  j3(key, value) {
    var tmp = (!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE();
    return this.w8i(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
  }
  d11(key) {
    return this.t8i_1.k3(key);
  }
  k3(key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.d11((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  }
  s1() {
    return this.t8i_1.s1();
  }
  i3() {
    return this.t8i_1.i3();
  }
  n3() {
    return this.t8i_1.n3();
  }
  f11(key) {
    return this.t8i_1.f3(key);
  }
  f3(key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return false;
    return this.f11((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  }
  oi(key) {
    return this.t8i_1.h3(key);
  }
  h3(key) {
    if (!(!(key == null) ? typeof key === 'string' : false))
      return null;
    return this.oi((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
  }
  g1() {
    return this.t8i_1.g1();
  }
  e1() {
    return this.t8i_1.e1();
  }
}
class Entry {
  constructor(closeable) {
    closeable = closeable === VOID ? null : closeable;
    this.x8i_1 = closeable;
  }
  y8i() {
    var tmp0_safe_receiver = this.x8i_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.t6();
    }
    this.x8i_1 = null;
  }
  j2y() {
    this.x8i_1 = null;
  }
}
class AgAutoFreeManager {
  constructor() {
    var tmp = this;
    var tmp_0 = AgAutoFreeManager$entryPool$lambda;
    tmp.z8i_1 = Pool.q2x(tmp_0, VOID, AgAutoFreeManager$entryPool$lambda_0);
    this.a8j_1 = FastIdentityMap();
    this.b8j_1 = fastArrayListOf([]);
    this.c8j_1 = 0;
    this.d8j_1 = 60;
  }
  e8j(closeable) {
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var this_0 = this.a8j_1;
      var res = get_0(this_0, closeable);
      if (!(res == null)) {
        break $l$block;
      }
      // Inline function 'korlibs.korge.render.AgAutoFreeManager.reference.<anonymous>' call
      // Inline function 'kotlin.also' call
      var this_1 = this.z8i_1.t2x();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.render.AgAutoFreeManager.reference.<anonymous>.<anonymous>' call
      this_1.x8i_1 = closeable;
      var out = this_1;
      set(this_0, closeable, out);
    }
  }
  f8j() {
    this.c8j_1 = this.c8j_1 + 1 | 0;
    if (this.c8j_1 >= this.d8j_1) {
      this.c8j_1 = 0;
      this.g8j();
    }
  }
  g8j() {
    var _iterator__ex2g4s = this.b8j_1.a1();
    while (_iterator__ex2g4s.b1()) {
      var entry = _iterator__ex2g4s.c1();
      if (!contains_1(this.a8j_1, entry.x8i_1)) {
        var tmp0_safe_receiver = entry.x8i_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          tmp0_safe_receiver.t6();
        }
        this.z8i_1.u2x(entry);
      }
    }
    this.b8j_1.m3();
    // Inline function 'korlibs.datastructure.fastValueForEach' call
    var this_0 = this.a8j_1;
    // Inline function 'korlibs.datastructure.fastKeyForEach' call
    // Inline function 'kotlin.js.asDynamic' call
    var mapIterator = this_0.keys();
    $l$loop: while (true) {
      var v = mapIterator.next();
      if (v.done)
        break $l$loop;
      // Inline function 'korlibs.datastructure.fastValueForEach.<anonymous>' call
      var it = v.value;
      // Inline function 'korlibs.korge.render.AgAutoFreeManager.gc.<anonymous>' call
      var it_0 = ensureNotNull(get_0(this_0, it));
      this.b8j_1.h(it_0);
    }
    clear(this.a8j_1);
  }
  t6() {
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.b8j_1.h11_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.korge.render.AgAutoFreeManager.close.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      array[_unary__edvuaz].y8i();
    }
    // Inline function 'korlibs.datastructure.fastValueForEach' call
    var this_0 = this.a8j_1;
    // Inline function 'korlibs.datastructure.fastKeyForEach' call
    // Inline function 'kotlin.js.asDynamic' call
    var mapIterator = this_0.keys();
    $l$loop: while (true) {
      var v = mapIterator.next();
      if (v.done)
        break $l$loop;
      // Inline function 'korlibs.datastructure.fastValueForEach.<anonymous>' call
      var it = v.value;
      // Inline function 'korlibs.korge.render.AgAutoFreeManager.close.<anonymous>' call
      ensureNotNull(get_0(this_0, it)).y8i();
    }
    this.b8j_1.m3();
    this.z8i_1.m3();
    clear(this.a8j_1);
  }
}
class BitmapTextureInfo {
  constructor() {
    this.h8j_1 = 0;
    this.i8j_1 = TextureBase.n8j(null, 0, 0);
    this.j8j_1 = FastIdentityMap();
  }
  j2y() {
    this.h8j_1 = 0;
    this.i8j_1.k8j_1 = null;
    this.i8j_1.m8j_1 = -1;
    this.i8j_1.o8j(0);
    this.i8j_1.p8j(0);
    clear(this.j8j_1);
  }
  toString() {
    return 'BitmapTextureInfo(textureBase=' + this.i8j_1.toString() + ', usedMemory=' + this.h8j_1 + ', slices=' + get_size(this.j8j_1) + ')';
  }
}
class AgBitmapTextureManager {
  constructor(ag) {
    this.q8j_1 = ag;
    this.r8j_1 = new Long(0, 0);
    this.s8j_1 = FastSmallSet.f2v();
    this.t8j_1 = FastSmallSet.f2v();
    this.u8j_1 = FastArrayList.j11();
    this.v8j_1 = 60;
    this.w8j_1 = new Long(0, 0);
    var tmp = this;
    var tmp_0 = AgBitmapTextureManager$textureInfoPool$lambda;
    tmp.x8j_1 = Pool.q2x(tmp_0, VOID, AgBitmapTextureManager$textureInfoPool$lambda_0);
    this.y8j_1 = FastIdentityMap();
    this.z8j_1 = null;
    this.a8k_1 = null;
    this.b8k_1 = null;
    this.c8k_1 = null;
    this.d8k_1 = null;
    this.e8k_1 = null;
    this.f8k_1 = null;
    this.g8k_1 = null;
    this.h8k_1 = 0;
  }
  j8k() {
    return this.s8j_1.e1();
  }
  k8k() {
    return this.t8j_1.e1();
  }
  l8k() {
    return this.u8j_1.e1();
  }
  toString() {
    return this.m8k();
  }
  m8k() {
    return 'AgBitmapTextureManager(numCachedBitmaps=' + this.j8k() + ', numReferencedBitmapsSinceGC=' + this.k8k() + ', numReferencedBitmaps=' + this.l8k() + ', maxCachedMemory=' + ByteUnits__toString_impl_ox2ku2(Companion_getInstance_9().i17(this.r8j_1)) + ', managedTextureMemory=' + ByteUnits__toString_impl_ox2ku2(Companion_getInstance_9().i17(this.w8j_1)) + ')';
  }
  n8k(bitmap) {
    return ensureNotNull(getTextureInfo(this, bitmap).i8j_1);
  }
  o8k(slice) {
    var tmp = _getTexture(this, slice);
    return tmp instanceof RectSlice ? tmp : THROW_CCE();
  }
  p8k(slice) {
    return _getTexture(this, slice);
  }
  q8k() {
    clearFastCacheAccess(this);
    this.h8k_1 = this.h8k_1 + 1 | 0;
    if (this.h8k_1 >= this.v8j_1) {
      this.h8k_1 = 0;
      this.g8j();
    }
  }
  g8j() {
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEach' call
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this.u8j_1.h11_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.korge.render.AgBitmapTextureManager.gc.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      var bmp = array[_unary__edvuaz];
      if (!this.t8j_1.kl(bmp))
        if (this.r8j_1.z1(this.w8j_1) < 0 || this.w8j_1.z1(new Long(0, 0)) < 0) {
          this.r8k(bmp, 'GC');
        } else
          this.s8j_1.g2v(bmp);
    }
    this.u8j_1.m3();
    // Inline function 'korlibs.datastructure.FastSmallSet.fastForEach' call
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.t8j_1.b2v_1.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.datastructure.FastSmallSet.fastForEach.<anonymous>' call
      // Inline function 'korlibs.korge.render.AgBitmapTextureManager.gc.<anonymous>' call
      this.u8j_1.h(element);
    }
    // Inline function 'korlibs.datastructure.FastSmallSet.fastForEach' call
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_0 = this.s8j_1.b2v_1.a1();
    while (tmp0_iterator_0.b1()) {
      var element_0 = tmp0_iterator_0.c1();
      // Inline function 'korlibs.datastructure.FastSmallSet.fastForEach.<anonymous>' call
      // Inline function 'korlibs.korge.render.AgBitmapTextureManager.gc.<anonymous>' call
      this.u8j_1.h(element_0);
    }
    this.t8j_1.m3();
  }
  r8k(bmp, reason) {
    var tmp0_elvis_lhs = getAndRemove(this.y8j_1, bmp);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var info = tmp;
    var tmp_0 = this;
    // Inline function 'kotlin.Long.minus' call
    var this_0 = this.w8j_1;
    var other = info.h8j_1;
    tmp_0.w8j_1 = this_0.a2(toLong(other));
    this.t8j_1.h2v(bmp);
    if (this.a8k_1 === info || this.c8k_1 === info) {
      clearFastCacheAccess(this);
    }
    info.i8j_1.t6();
    this.x8j_1.u2x(info);
    this.s8j_1.h2v(bmp);
  }
  t6() {
    clearFastCacheAccess(this);
    var _iterator__ex2g4s = toList(get_keys(this.y8j_1)).a1();
    while (_iterator__ex2g4s.b1()) {
      var bmp = _iterator__ex2g4s.c1();
      this.r8k(bmp, 'close');
    }
    clear(this.y8j_1);
    this.u8j_1.m3();
    this.t8j_1.m3();
    this.s8j_1.m3();
    this.x8j_1.m3();
  }
}
class AgBufferManager {
  constructor(ag) {
    this.s8k_1 = ag;
    this.t8k_1 = FastIdentityMap();
    this.u8k_1 = FastSmallSet.f2v();
    var tmp = this;
    tmp.v8k_1 = Pool.r2x(VOID, AgBufferManager$bufferPool$lambda);
    this.w8k_1 = 0;
    this.x8k_1 = 60;
    this.y8k_1 = Buffer.b15(0);
  }
  z8k(cached) {
    this.u8k_1.g2v(cached);
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var this_0 = this.t8k_1;
      var res = get_0(this_0, cached);
      if (!(res == null)) {
        tmp$ret$0 = res;
        break $l$block;
      }
      // Inline function 'korlibs.korge.render.AgBufferManager.getBuffer.<anonymous>' call
      // Inline function 'kotlin.also' call
      var this_1 = this.v8k_1.t2x();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.korge.render.AgBufferManager.getBuffer.<anonymous>.<anonymous>' call
      this_1.v6x(cached.a8l_1);
      var out = this_1;
      set(this_0, cached, out);
      tmp$ret$0 = out;
    }
    return tmp$ret$0;
  }
  f8j() {
    removeCache(this);
    this.w8k_1 = this.w8k_1 + 1 | 0;
    if (this.w8k_1 >= this.x8k_1) {
      this.w8k_1 = 0;
      this.g8j();
    }
  }
  g8j() {
    // Inline function 'korlibs.datastructure.FastSmallSet.fastForEach' call
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.u8k_1.b2v_1.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.datastructure.FastSmallSet.fastForEach.<anonymous>' call
      // Inline function 'korlibs.korge.render.AgBufferManager.gc.<anonymous>' call
      this.b8l(element);
    }
    this.u8k_1.m3();
  }
  c8l(buffer) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var n = 0;
    while (n < buffer.e1()) {
      // Inline function 'korlibs.korge.render.AgBufferManager.delete.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var it = buffer.d1(_unary__edvuaz);
      this.b8l(it);
    }
  }
  b8l(buffer) {
    var buf = getAndRemove(this.t8k_1, buffer);
    if (buf == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      buf.v6x(this.y8k_1);
      this.v8k_1.u2x(buf);
    }
  }
}
class AgCachedBuffer {
  constructor(data) {
    this.a8l_1 = data;
  }
}
class BatchBuffers {
  constructor() {
    this.n8l_1 = new AGBuffer();
    this.o8l_1 = new AGBuffer();
    this.p8l_1 = new AGBuffer();
    this.q8l_1 = AGVertexArrayObject.k73([new AGVertexData(Companion_getInstance_71().k8l_1, this.n8l_1), new AGVertexData(Companion_getInstance_71().l8l_1, this.o8l_1)], false);
  }
}
class Companion_56 {
  constructor() {
    Companion_instance_65 = this;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = get_BB_MAX_TEXTURES();
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_2 = fillArrayVal(Array(tmp_1), null);
    while (tmp_0 < tmp_1) {
      var tmp_3 = tmp_0;
      tmp_2[tmp_3] = Sampler.k7z('u_Tex' + tmp_3, 3 + tmp_3 | 0, SamplerVarType_Sampler2D_getInstance());
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.d8l_1 = tmp_2;
    this.e8l_1 = 16383;
    this.f8l_1 = 8192;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = get_logger();
    var level = Level_TRACE_getInstance();
    var tmp_4;
    if (this_0.q31(level)) {
      // Inline function 'korlibs.korge.render.Companion.<anonymous>' call
      var tmp$ret$2 = 'BatchBuilder2D.Companion[0]';
      this_0.r31(level, tmp$ret$2);
      tmp_4 = Unit_instance;
    }
    this.g8l_1 = Attribute.i7a('a_Col2', VarType_UByte4_getInstance(), true, VOID, 3);
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_1 = get_logger();
    var level_0 = Level_TRACE_getInstance();
    var tmp_5;
    if (this_1.q31(level_0)) {
      // Inline function 'korlibs.korge.render.Companion.<anonymous>' call
      var tmp$ret$4 = 'BatchBuilder2D.Companion[1]';
      this_1.r31(level_0, tmp$ret$4);
      tmp_5 = Unit_instance;
    }
    this.h8l_1 = Varying.u7a('v_Col2', VarType_Float4_getInstance());
    this.i8l_1 = Attribute.i7a('a_TexIndex', VarType_UByte1_getInstance(), false, Precision_LOW_getInstance(), 4);
    this.j8l_1 = Varying.u7a('v_TexIndex', VarType_Float1_getInstance(), Precision_LOW_getInstance());
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_2 = get_logger();
    var level_1 = Level_TRACE_getInstance();
    var tmp_6;
    if (this_2.q31(level_1)) {
      // Inline function 'korlibs.korge.render.Companion.<anonymous>' call
      var tmp$ret$6 = 'BatchBuilder2D.Companion[2]';
      this_2.r31(level_1, tmp$ret$6);
      tmp_6 = Unit_instance;
    }
    this.k8l_1 = ProgramLayout.t73([DefaultShaders_getInstance().d77_1, DefaultShaders_getInstance().e77_1, this.r8l(), this.g8l_1]);
    this.l8l_1 = ProgramLayout.t73([this.i8l_1]);
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_3 = get_logger();
    var level_2 = Level_TRACE_getInstance();
    var tmp_7;
    if (this_3.q31(level_2)) {
      // Inline function 'korlibs.korge.render.Companion.<anonymous>' call
      var tmp$ret$8 = 'BatchBuilder2D.Companion[3]';
      this_3.r31(level_2, tmp$ret$8);
      tmp_7 = Unit_instance;
    }
    var tmp_8 = this;
    // Inline function 'korlibs.graphics.VertexShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_4 = ProgramBuilderDefault.j7b();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.render.Companion.PROGRAM.<anonymous>' call
    this_4.o7b(this_4.k7b(), this_4.l7b());
    this_4.o7b(Companion_getInstance_71().j8l_1, Companion_getInstance_71().i8l_1);
    this_4.o7b(Companion_getInstance_71().s8l(), this_4.v7b([this_4.s7b(this_4.x7b(Companion_getInstance_71().r8l(), 'rgb'), this_4.x7b(Companion_getInstance_71().r8l(), 'a')), this_4.x7b(Companion_getInstance_71().r8l(), 'a')]));
    this_4.o7b(Companion_getInstance_71().h8l_1, Companion_getInstance_71().g8l_1);
    this_4.o7b(this_4.r7b(), this_4.s7b(this_4.s7b(this_4.d79(), this_4.e79()), this_4.v7b([this_4.t7b(), this_4.u7b(0.0), this_4.u7b(1.0)])));
    var tmp_9 = VertexShader(this_4.w7b());
    // Inline function 'korlibs.graphics.FragmentShaderDefault' call
    // Inline function 'kotlin.also' call
    var this_5 = ProgramBuilderDefault.j7b();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.render.Companion.PROGRAM.<anonymous>' call
    Companion_getInstance_71().t8l(this_5);
    this_5.o7b(this_5.r7b(), this_5.s7b(this_5.r7b(), Companion_getInstance_71().s8l()));
    // Inline function 'korlibs.graphics.shader.Builder.IF' call
    var cond = this_5.r7d(this_5.x7b(this_5.r7b(), 'a'), this_5.u7b(0.0));
    var body = this_5.f7c();
    // Inline function 'korlibs.korge.render.Companion.PROGRAM.<anonymous>.<anonymous>' call
    body.w7c();
    var stmIf = new If(cond, body.h7c());
    // Inline function 'kotlin.collections.plusAssign' call
    this_5.n7b_1.h(stmIf);
    var tmp$ret$14 = FragmentShader(this_5.w7b());
    tmp_8.m8l_1 = new Program(tmp_9, tmp$ret$14, 'BatchBuilder2D.Tinted');
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_6 = get_logger();
    var level_3 = Level_TRACE_getInstance();
    var tmp_10;
    if (this_6.q31(level_3)) {
      // Inline function 'korlibs.korge.render.Companion.<anonymous>' call
      var tmp$ret$15 = 'BatchBuilder2D.Companion[4]';
      this_6.r31(level_3, tmp$ret$15);
      tmp_10 = Unit_instance;
    }
  }
  r8l() {
    return DefaultShaders_getInstance().f77_1;
  }
  s8l() {
    return DefaultShaders_getInstance().h77_1;
  }
  t8l(builder) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.render.Companion.createTextureLookup.<anonymous>' call
    var tmp = Companion_getInstance_71().j8l_1;
    var tmp_0 = get_BB_MAX_TEXTURES() - 1 | 0;
    builder.u7c(tmp, 0, tmp_0, BatchBuilder2D$Companion$createTextureLookup$lambda(builder));
  }
}
class BatchBuilder2D {
  constructor(ctx, reqMaxQuads) {
    Companion_getInstance_71();
    reqMaxQuads = reqMaxQuads === VOID ? Companion_getInstance_71().f8l_1 : reqMaxQuads;
    this.j8f_1 = ctx;
    this.k8f_1 = reqMaxQuads;
    this.l8f_1 = get_BB_MAX_TEXTURES();
    var tmp = this;
    // Inline function 'kotlin.math.min' call
    var a = this.k8f_1;
    var b = Companion_getInstance_71().e8l_1;
    tmp.m8f_1 = Math.min(a, b);
    this.n8f_1 = this.j8f_1.v8e_1;
    this.o8f_1 = this.j8f_1.c8e_1;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = get_logger();
    var level = Level_TRACE_getInstance();
    var tmp_0;
    if (this_0.q31(level)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$1 = 'BatchBuilder2D[0]';
      this_0.r31(level, tmp$ret$1);
      tmp_0 = Unit_instance;
    }
    this.j8f_1.x8e_1.p22(BatchBuilder2D$lambda(this));
    this.p8f_1 = imul(this.m8f_1, 4);
    this.q8f_1 = imul(this.m8f_1, 6);
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_1 = get_logger();
    var level_0 = Level_TRACE_getInstance();
    var tmp_1;
    if (this_1.q31(level_0)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$3 = 'BatchBuilder2D[1]';
      this_1.r31(level_0, tmp$ret$3);
      tmp_1 = Unit_instance;
    }
    this.r8f_1 = Buffer.b15(imul(24, this.p8f_1));
    this.s8f_1 = new Int8Array(this.p8f_1);
    this.t8f_1 = Buffer.b15(imul(2, this.q8f_1));
    this.u8f_1 = get_u16(this.t8f_1);
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_2 = get_logger();
    var level_1 = Level_TRACE_getInstance();
    var tmp_2;
    if (this_2.q31(level_1)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$5 = 'BatchBuilder2D[2]';
      this_2.r31(level_1, tmp$ret$5);
      tmp_2 = Unit_instance;
    }
    this.v8f_1 = 0;
    this.w8f_1 = 0;
    this.x8f_1 = 0;
    this.y8f_1 = 0;
    var tmp_3 = this;
    var tmp_4 = 0;
    var tmp_5 = this.l8f_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_6 = fillArrayVal(Array(tmp_5), null);
    while (tmp_4 < tmp_5) {
      tmp_6[tmp_4] = null;
      tmp_4 = tmp_4 + 1 | 0;
    }
    tmp_3.z8f_1 = tmp_6;
    this.a8g_1 = false;
    this.b8g_1 = Companion_getInstance_68().h8d_1;
    this.c8g_1 = Companion_getInstance_71().m8l_1;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_3 = get_logger();
    var level_2 = Level_TRACE_getInstance();
    var tmp_7;
    if (this_3.q31(level_2)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$9 = 'BatchBuilder2D[3]';
      this_3.r31(level_2, tmp$ret$9);
      tmp_7 = Unit_instance;
    }
    var tmp_8 = this;
    tmp_8.d8g_1 = new ReturnablePool(VOID, BatchBuilder2D$buffers$lambda);
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_4 = get_logger();
    var level_3 = Level_TRACE_getInstance();
    var tmp_9;
    if (this_4.q31(level_3)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$11 = 'BatchBuilder2D[4]';
      this_4.r31(level_3, tmp$ret$11);
      tmp_9 = Unit_instance;
    }
    this.e8g_1 = Companion_getInstance_45().j6v_1;
    this.f8g_1 = Companion_getInstance_46().l6v_1;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_5 = get_logger();
    var level_4 = Level_TRACE_getInstance();
    var tmp_10;
    if (this_5.q31(level_4)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$13 = 'BatchBuilder2D[5]';
      this_5.r31(level_4, tmp$ret$13);
      tmp_10 = Unit_instance;
    }
    this.g8g_1 = _AGColorMask___init__impl__j38ai8_1();
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_6 = get_logger();
    var level_5 = Level_TRACE_getInstance();
    var tmp_11;
    if (this_6.q31(level_5)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$15 = 'BatchBuilder2D[6]';
      this_6.r31(level_5, tmp$ret$15);
      tmp_11 = Unit_instance;
    }
    this.h8g_1 = Companion_getInstance_43().x6v_1;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_7 = get_logger();
    var level_6 = Level_TRACE_getInstance();
    var tmp_12;
    if (this_7.q31(level_6)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$17 = 'BatchBuilder2D[7]';
      this_7.r31(level_6, tmp$ret$17);
      tmp_12 = Unit_instance;
    }
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_8 = get_logger();
    var level_7 = Level_TRACE_getInstance();
    var tmp_13;
    if (this_8.q31(level_7)) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.<anonymous>' call
      var tmp$ret$19 = 'BatchBuilder2D[11]';
      this_8.r31(level_7, tmp$ret$19);
      tmp_13 = Unit_instance;
    }
    this.i8g_1 = new Signal();
    this.j8g_1 = new Signal();
    this.k8g_1 = fastArrayListOf([]);
    this.l8g_1 = 0;
    this.m8g_1 = 0;
    this.n8g_1 = 0;
  }
  w8l() {
    return this.j8f_1.q8e_1;
  }
  x8l(value) {
    this.v8f_1 = value;
  }
  y8l() {
    return this.v8f_1;
  }
  z8l() {
    var inductionVariable = 0;
    var last = this.l8f_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.z8f_1[n] = null;
      }
       while (inductionVariable < last);
    this.y8f_1 = 0;
  }
  f8j() {
    this.d8g_1.j2y();
  }
  a8m() {
    return this.h8g_1;
  }
  b8m(vd, vp, x, y, u, v, colorMul, texIndex) {
    setFloat32(vd, vp + 0 | 0, x);
    setFloat32(vd, vp + 1 | 0, y);
    setFloat32(vd, vp + 2 | 0, u);
    setFloat32(vd, vp + 3 | 0, v);
    setInt32(vd, vp + 4 | 0, colorMul);
    setInt32(vd, vp + 5 | 0, 0);
    this.s8f_1[vp / 6 | 0] = toByte(texIndex);
    return 6;
  }
  c8m(x0, y0, x1, y1, x2, y2, x3, y3, tex, colorMul, texIndex) {
    this.d8m(6, 4);
    this.e8m();
    var vp = this.w8f_1;
    var vd = this.r8f_1;
    vp = vp + this.b8m(vd, vp, x0, y0, tex.u3p(), tex.v3p(), _RGBA___get_value__impl__hhco8v(colorMul), texIndex) | 0;
    vp = vp + this.b8m(vd, vp, x1, y1, tex.w3p(), tex.x3p(), _RGBA___get_value__impl__hhco8v(colorMul), texIndex) | 0;
    vp = vp + this.b8m(vd, vp, x2, y2, tex.y3p(), tex.z3p(), _RGBA___get_value__impl__hhco8v(colorMul), texIndex) | 0;
    vp = vp + this.b8m(vd, vp, x3, y3, tex.a3q(), tex.b3q(), _RGBA___get_value__impl__hhco8v(colorMul), texIndex) | 0;
    this.w8f_1 = vp;
    this.x8l(this.y8l() + 4 | 0);
  }
  f8m(x0, y0, x1, y1, x2, y2, x3, y3, tex, colorMul, texIndex, $super) {
    texIndex = texIndex === VOID ? this.y8f_1 : texIndex;
    var tmp;
    if ($super === VOID) {
      this.c8m(x0, y0, x1, y1, x2, y2, x3, y3, tex, colorMul, texIndex);
      tmp = Unit_instance;
    } else {
      tmp = $super.c8m.call(this, x0, y0, x1, y1, x2, y2, x3, y3, tex, new RGBA(colorMul), texIndex);
    }
    return tmp;
  }
  g8m(vc) {
    this.x8f_1 = this.x8f_1 + _addIndices(this, this.u8f_1, this.x8f_1, vc + 0 | 0, vc + 1 | 0, vc + 2 | 0, vc + 3 | 0, vc + 0 | 0, vc + 2 | 0) | 0;
  }
  e8m(vc, $super) {
    vc = vc === VOID ? this.y8l() : vc;
    var tmp;
    if ($super === VOID) {
      this.g8m(vc);
      tmp = Unit_instance;
    } else {
      tmp = $super.g8m.call(this, vc);
    }
    return tmp;
  }
  h8m(array, matrix, vcount, icount, texIndex) {
    this.d8m(icount, vcount);
    var i16 = this.u8f_1;
    var ip = this.x8f_1;
    var vc = this.y8l();
    var arrayIndices = array.i8m_1;
    // Inline function 'kotlin.math.min' call
    var b = array.l8m_1;
    var icount_0 = Math.min(icount, b);
    arraycopy_5(asUShortArrayInt(arrayIndices), 0, i16, ip, icount_0);
    arrayadd(i16, toShort(vc), ip, ip + icount_0 | 0);
    var vp = this.w8f_1;
    var src = get_i32(array.m8m_1);
    var dst = get_i32(this.r8f_1);
    arraycopy_6(src, 0, dst, vp, imul(vcount, 6));
    var vp6 = this.w8f_1 / 6 | 0;
    arrayfill(this.s8f_1, toByte(texIndex), vp6, vp6 + vcount | 0);
    if (matrix.x2d()) {
      applyMatrix(this, matrix, this.w8f_1, vcount);
    }
    this.v8f_1 = this.v8f_1 + vcount | 0;
    this.w8f_1 = this.w8f_1 + imul(vcount, 6) | 0;
    this.x8f_1 = this.x8f_1 + icount_0 | 0;
  }
  p8m(array, matrix, vcount, icount, texIndex, $super) {
    vcount = vcount === VOID ? array.k8m_1 : vcount;
    icount = icount === VOID ? array.l8m_1 : icount;
    texIndex = texIndex === VOID ? this.y8f_1 : texIndex;
    var tmp;
    if ($super === VOID) {
      this.h8m(array, matrix, vcount, icount, texIndex);
      tmp = Unit_instance;
    } else {
      tmp = $super.h8m.call(this, array, matrix, vcount, icount, texIndex);
    }
    return tmp;
  }
  d8m(indices, vertices) {
    if (indices === 0 && vertices === 0)
      return false;
    var doFlush = !checkAvailable(this, indices, vertices);
    if (doFlush) {
      this.q8m();
    }
    if (!checkAvailable(this, indices, vertices)) {
      // Inline function 'kotlin.error' call
      var message = 'Too much vertices: indices=' + indices + ', vertices=' + vertices;
      throw IllegalStateException.l5(toString(message));
    }
    return doFlush;
  }
  r8m(tex, smoothing, blendMode, program, icount, vcount) {
    $l$block: {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.setStateFast' call
      var tex_0 = tex.k8j_1;
      this.d8m(icount, vcount);
      var pprogram = program == null ? Companion_getInstance_71().m8l_1 : program;
      if (this.s8m(tex_0, smoothing, blendMode, pprogram)) {
        break $l$block;
      }
      this.u8l();
      if (!contains_0(this.z8f_1, tex_0)) {
        this.y8f_1 = 0;
        this.z8f_1[0] = tex_0;
      }
      this.a8g_1 = smoothing;
      this.b8g_1 = blendMode;
      this.c8g_1 = pprogram;
    }
  }
  t8m(tex) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.z8f_1;
    var n = 0;
    while (n < this_0.length) {
      // Inline function 'korlibs.korge.render.BatchBuilder2D.hasTex.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      if (this_0[_unary__edvuaz] === tex)
        return true;
    }
    return false;
  }
  s8m(tex, smoothing, blendMode, program) {
    var hasTex = this.t8m(tex);
    if (!(this.z8f_1[0] === null) && !hasTex) {
      var inductionVariable = 1;
      var last = this.z8f_1.length;
      if (inductionVariable < last)
        $l$loop: do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (this.z8f_1[n] === null) {
            this.z8f_1[n] = tex;
            hasTex = true;
            break $l$loop;
          }
        }
         while (inductionVariable < last);
    }
    var inductionVariable_0 = 0;
    var last_0 = this.z8f_1.length - 1 | 0;
    if (inductionVariable_0 <= last_0)
      $l$loop_0: do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        if (tex === this.z8f_1[n_0]) {
          this.y8f_1 = n_0;
          break $l$loop_0;
        }
      }
       while (inductionVariable_0 <= last_0);
    return hasTex && this.a8g_1 === smoothing && this.b8g_1 === blendMode && this.c8g_1 === program;
  }
  u8m(tex, smoothing, blendMode, program, icount, vcount) {
    this.r8m(this.n8f_1.n8k(tex), smoothing, blendMode, program, icount, vcount);
  }
  v8m(tex, x, y, width, height, m, filtering, colorMul, blendMode, program) {
    return this.w8m(tex, x, y, width, height, m, filtering, colorMul, blendMode, program, Unit_instance);
  }
  q8g(tex, x, y, width, height, m, filtering, colorMul, blendMode, program, $super) {
    x = x === VOID ? 0.0 : x;
    y = y === VOID ? 0.0 : y;
    width = width === VOID ? tex.x2p() : width;
    height = height === VOID ? tex.y2p() : height;
    m = m === VOID ? Companion_getInstance_7().s2g_1 : m;
    filtering = filtering === VOID ? true : filtering;
    colorMul = colorMul === VOID ? Colors_getInstance().y44_1 : colorMul;
    blendMode = blendMode === VOID ? Companion_getInstance_68().h8d_1 : blendMode;
    program = program === VOID ? null : program;
    var tmp;
    if ($super === VOID) {
      this.v8m(tex, x, y, width, height, m, filtering, colorMul, blendMode, program);
      tmp = Unit_instance;
    } else {
      tmp = $super.v8m.call(this, tex, x, y, width, height, m, filtering, new RGBA(colorMul), blendMode, program);
    }
    return tmp;
  }
  w8m(tex, x, y, width, height, m, filtering, colorMul, blendMode, program, unit) {
    this.r8m(tex.j3p(), filtering, blendMode, program, 6, 4);
    this.x8m(x, y, width, height, m, tex, colorMul);
  }
  x8m(x, y, width, height, m, tex, colorMul) {
    var x0 = x;
    var x1 = x + width;
    var y0 = y;
    var y1 = y + height;
    this.f8m(m.l2h(x0, y0), m.m2h(x0, y0), m.l2h(x1, y0), m.m2h(x1, y0), m.l2h(x1, y1), m.m2h(x1, y1), m.l2h(x0, y1), m.m2h(x0, y1), tex, colorMul);
  }
  y8m() {
    this.d8g_1.i2y_1.p8l_1.u6x(this.t8f_1, 0, imul(this.x8f_1, 2));
  }
  z8m() {
    this.j8f_1.z8m();
    var inductionVariable = 0;
    var last = this.l8f_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var info = Companion_getInstance_39().d71(VOID, this.a8g_1);
        this.j8f_1.l8e_1.c6y(Companion_getInstance_71().d8l_1[n], this.z8f_1[n], info);
      }
       while (inductionVariable < last);
  }
  u8l() {
    if (this.l8g_1 === this.x8f_1)
      return Unit_instance;
    this.z8m();
    this.m8g_1 = this.m8g_1 + 1 | 0;
    // Inline function 'kotlin.collections.plusAssign' call
    var this_0 = this.k8g_1;
    var tmp0_frameBuffer = this.j8f_1.f8f_1.w6t_1;
    var tmp1_frameBufferInfo = this.j8f_1.f8f_1.d6w();
    var tmp2_vertexData = this.d8g_1.i2y_1.q8l_1;
    var tmp3_indices = this.d8g_1.i2y_1.p8l_1;
    var tmp4_program = this.c8g_1;
    var tmp5_drawType = Companion_getInstance_40().b74_1;
    var tmp6_blending = this.b8g_1.r8g_1;
    var tmp7_uniformBlocks = this.j8f_1.a8n(this.c8g_1, false);
    var tmp8_textureUnits = this.j8f_1.l8e_1.o10();
    var tmp9_stencilOpFunc = this.f8g_1;
    var tmp10_stencilRef = this.e8g_1;
    var tmp11_colorMask = this.g8g_1;
    var tmp12_scissor = this.h8g_1;
    var tmp13_drawOffset = imul(this.l8g_1, 2);
    var tmp14_vertexCount = this.x8f_1 - this.l8g_1 | 0;
    var element = new AGBatch(tmp0_frameBuffer, tmp1_frameBufferInfo, tmp2_vertexData, tmp3_indices, VOID, tmp4_program, tmp7_uniformBlocks, tmp8_textureUnits, tmp6_blending, tmp9_stencilOpFunc, tmp10_stencilRef, tmp11_colorMask, VOID, tmp12_scissor, VOID, tmp5_drawType, tmp13_drawOffset, tmp14_vertexCount);
    this_0.h(element);
    this.l8g_1 = this.x8f_1;
  }
  b8n(uploadVertices, uploadIndices) {
    this.c8n(uploadVertices, uploadIndices);
    var inductionVariable = 0;
    var last = this.l8f_1;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.z8f_1[n] = null;
      }
       while (inductionVariable < last);
    this.y8f_1 = 0;
  }
  v8l(uploadVertices, uploadIndices, $super) {
    uploadVertices = uploadVertices === VOID ? true : uploadVertices;
    uploadIndices = uploadIndices === VOID ? true : uploadIndices;
    var tmp;
    if ($super === VOID) {
      this.b8n(uploadVertices, uploadIndices);
      tmp = Unit_instance;
    } else {
      tmp = $super.b8n.call(this, uploadVertices, uploadIndices);
    }
    return tmp;
  }
  c8n(uploadVertices, uploadIndices) {
    this.u8l();
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this.k8g_1.g1()) {
      if (uploadVertices) {
        this.d8g_1.i2y_1.n8l_1.u6x(this.r8f_1, 0, imul(this.w8f_1, 4));
        this.d8g_1.i2y_1.o8l_1.t6x(this.s8f_1, 0, this.w8f_1 / 6 | 0);
      }
      if (uploadIndices) {
        this.y8m();
      }
      this.j8f_1.d8n();
      draw_0(this.o8f_1, new AGMultiBatch(toList(this.k8g_1)));
      this.k8g_1.m3();
      this.i8g_1.r22(this);
      this.n8g_1 = this.n8g_1 + 1 | 0;
      this.j8f_1.e8n();
      this.d8g_1.c1();
    }
    this.x8l(0);
    this.w8f_1 = 0;
    this.l8g_1 = 0;
    this.x8f_1 = 0;
  }
  q8m(uploadVertices, uploadIndices, $super) {
    uploadVertices = uploadVertices === VOID ? true : uploadVertices;
    uploadIndices = uploadIndices === VOID ? true : uploadIndices;
    var tmp;
    if ($super === VOID) {
      this.c8n(uploadVertices, uploadIndices);
      tmp = Unit_instance;
    } else {
      tmp = $super.c8n.call(this, uploadVertices, uploadIndices);
    }
    return tmp;
  }
  f8n(vertexCount) {
    var oldVertexCount = this.y8l();
    this.x8l(vertexCount);
    try {
      this.i8g_1.r22(this);
    }finally {
      this.x8l(oldVertexCount);
    }
  }
}
class BoundsProvider {}
function get_windowToGlobalScaleAvg() {
  return get_scale(this.o8n()).d2j();
}
function get_globalToWindowScaleAvg() {
  return this.s8n().d2j();
}
function windowToGlobalCoords(pos) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.math.geom.Matrix.transform' call
    var this_0 = this.m8n();
    if (this_0.w2d()) {
      tmp$ret$0 = pos;
      break $l$block;
    }
    tmp$ret$0 = Vector2D.q2f(this_0.k2h(pos.h2d_1, pos.i2d_1), this_0.n2h(pos.h2d_1, pos.i2d_1));
  }
  return tmp$ret$0;
}
class Base {
  constructor() {
    this.g8n_1 = Companion_getInstance_7().v2g();
    this.h8n_1 = MatrixTransform.b2j();
    this.i8n_1 = Companion_getInstance_7().v2g();
    this.j8n_1 = MatrixTransform.b2j();
    this.k8n_1 = Companion_getInstance_5().o2l(0, 0, 1280, 720);
  }
  l8n(_set____db54di) {
    this.g8n_1 = _set____db54di;
  }
  m8n() {
    return this.g8n_1;
  }
  n8n(_set____db54di) {
    this.h8n_1 = _set____db54di;
  }
  o8n() {
    return this.h8n_1;
  }
  p8n(_set____db54di) {
    this.i8n_1 = _set____db54di;
  }
  q8n() {
    return this.i8n_1;
  }
  r8n(_set____db54di) {
    this.j8n_1 = _set____db54di;
  }
  s8n() {
    return this.j8n_1;
  }
  t8n(_set____db54di) {
    this.k8n_1 = _set____db54di;
  }
}
class Companion_57 {
  constructor() {
    Companion_instance_66 = this;
    this.x8n_1 = ProgramLayout.t73([DefaultShaders_getInstance().d77_1, DefaultShaders_getInstance().f77_1]);
    var tmp = this;
    // Inline function 'korlibs.graphics.shader.VertexShader' call
    var builder = ProgramBuilderDefault.j7b();
    // Inline function 'korlibs.korge.render.Companion.VERTEX.<anonymous>' call
    // Inline function 'kotlin.apply' call
    var this_0 = DefaultShaders_getInstance();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.render.Companion.VERTEX.<anonymous>.<anonymous>' call
    builder.o7b(builder.r7b(), builder.s7b(builder.s7b(this_0.d79(), this_0.e79()), builder.v7b([this_0.d77_1, builder.u7b(0.0), builder.u7b(1.0)])));
    builder.o7b(this_0.h77_1, this_0.f77_1);
    tmp.y8n_1 = VertexShader(builder.w7b());
    var tmp_0 = this;
    // Inline function 'korlibs.graphics.shader.FragmentShader' call
    var builder_0 = ProgramBuilderDefault.j7b();
    // Inline function 'korlibs.korge.render.Companion.FRAGMENT.<anonymous>' call
    // Inline function 'kotlin.apply' call
    var this_1 = DefaultShaders_getInstance();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.render.Companion.FRAGMENT.<anonymous>.<anonymous>' call
    builder_0.o7b(builder_0.r7b(), this_1.h77_1);
    tmp_0.z8n_1 = FragmentShader(builder_0.w7b());
    this.a8o_1 = new Program(this.y8n_1, this.z8n_1);
  }
}
class LineRenderBatcher {
  constructor(ctx) {
    Companion_getInstance_72();
    this.b8o_1 = ctx;
    this.c8o_1 = new Signal();
    this.b8o_1.x8e_1.p22(LineRenderBatcher$lambda(this));
    this.d8o_1 = this.b8o_1.c8e_1;
    this.e8o_1 = Colors_getInstance().o4a_1;
    this.f8o_1 = new AGBuffer();
    this.g8o_1 = AGVertexArrayObject.k73([new AGVertexData(Companion_getInstance_72().x8n_1, this.f8o_1)], false);
    this.h8o_1 = 1024;
    this.i8o_1 = allocDirect(Companion_instance_4, imul(24, this.h8o_1));
    this.j8o_1 = Matrix4.a2k();
    this.k8o_1 = 0;
    this.l8o_1 = 0;
    this.m8o_1 = Companion_getInstance_68().h8d_1;
    this.n8o_1 = Companion_getInstance_7().v2g();
  }
  o8o(p0, p1, color0, color1, m) {
    return this.p8o(p0.h2d_1, p0.i2d_1, p1.h2d_1, p1.i2d_1, this.e8o_1, color1, m);
  }
  q8o(p0, p1, color0, color1, m, $super) {
    color0 = color0 === VOID ? this.e8o_1 : color0;
    color1 = color1 === VOID ? color0 : color1;
    m = m === VOID ? this.n8o_1 : m;
    var tmp;
    if ($super === VOID) {
      this.o8o(p0, p1, color0, color1, m);
      tmp = Unit_instance;
    } else {
      tmp = $super.o8o.call(this, p0, p1, new RGBA(color0), new RGBA(color1), m);
    }
    return tmp;
  }
  r8o(x0, y0, x1, y1, color0, color1, m) {
    if (this.k8o_1 >= (this.h8o_1 - 2 | 0)) {
      this.bd();
    }
    addVertex(this, x0, y0, color0, m);
    addVertex(this, x1, y1, color1, m);
  }
  s8o(x0, y0, x1, y1, color0, color1, m, $super) {
    color0 = color0 === VOID ? this.e8o_1 : color0;
    color1 = color1 === VOID ? color0 : color1;
    m = m === VOID ? this.n8o_1 : m;
    var tmp;
    if ($super === VOID) {
      this.r8o(x0, y0, x1, y1, color0, color1, m);
      tmp = Unit_instance;
    } else {
      tmp = $super.r8o.call(this, x0, y0, x1, y1, new RGBA(color0), new RGBA(color1), m);
    }
    return tmp;
  }
  p8o(x0, y0, x1, y1, color0, color1, m) {
    return this.r8o(x0, y0, x1, y1, color0, color1, m);
  }
  t8o(path, m) {
    var lastPos = {_v: Vector2D.b2g()};
    // Inline function 'korlibs.math.geom.shape.emitPoints2' call
    var i = Vector2D.b2g();
    var l = Vector2D.b2g();
    // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = path.a3m_1;
    var n_0 = 0;
    while (n_0 < this_0.e1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_0.m10(_unary__edvuaz)) {
        case 0:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = path.b3m_1.d1(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var it = Vector2D.q2f(tmp, path.b3m_1.d1(_unary__edvuaz_1));
          i = it;
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call

          if (!true) {
            this.q8o(lastPos._v, it, VOID, VOID, m);
          }

          lastPos._v = it;
          l = it;
          break;
        case 1:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = path.b3m_1.d1(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var it_0 = Vector2D.q2f(tmp_0, path.b3m_1.d1(_unary__edvuaz_3));
          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call

          if (!false) {
            this.q8o(lastPos._v, it_0, VOID, VOID, m);
          }

          lastPos._v = it_0;
          l = it_0;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 2:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = path.b3m_1.d1(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var c = Vector2D.q2f(tmp_1, path.b3m_1.d1(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = path.b3m_1.d1(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var a = Vector2D.q2f(tmp_2, path.b3m_1.d1(_unary__edvuaz_7));
          var sum = Companion_getInstance_4().m2o(l, c) + Companion_getInstance_4().m2o(c, a);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_0 = numberToInt(sum);
          var rcurveSteps = Math.max(a_0, 20);
          var dt = 1.0 / rcurveSteps;
          var lastPos_0 = {_v: Vector2D.b2g()};
          var prevPos = {_v: Vector2D.b2g()};
          var emittedCount = {_v: 0};
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

          var ratio = Companion_getInstance_10().g10_1;
          // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

          lastPos_0._v = Companion_getInstance_12().t3j(l, c, a, ratio);
          var nStart = false ? 0 : 1;
          var nEnd = true ? rcurveSteps : rcurveSteps - 1 | 0;
          var inductionVariable = nStart;
          if (inductionVariable <= nEnd)
            do {
              var n_1 = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var ratio_0 = _Ratio___init__impl__9mwvn2(n_1 * dt);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              var it_1 = Companion_getInstance_12().t3j(l, c, a, ratio_0);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
              if (!false) {
                this.q8o(lastPos._v, it_1, VOID, VOID, m);
              }
              lastPos._v = it_1;
              emittedCount._v = emittedCount._v + 1 | 0;
              lastPos_0._v = prevPos._v;
              prevPos._v = it_1;
            }
             while (!(n_1 === nEnd));
          l = a;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 3:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = path.b3m_1.d1(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var c0 = Vector2D.q2f(tmp_3, path.b3m_1.d1(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = path.b3m_1.d1(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var c1 = Vector2D.q2f(tmp_4, path.b3m_1.d1(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = path.b3m_1.d1(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var a_1 = Vector2D.q2f(tmp_5, path.b3m_1.d1(_unary__edvuaz_13));
          var sum_0 = Companion_getInstance_4().m2o(l, c0) + Companion_getInstance_4().m2o(c0, c1) + Companion_getInstance_4().m2o(c1, a_1);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_2 = numberToInt(sum_0);
          var rcurveSteps_0 = Math.max(a_2, 20);
          var dt_0 = 1.0 / rcurveSteps_0;
          var lastPos_1 = {_v: Vector2D.b2g()};
          var prevPos_0 = {_v: Vector2D.b2g()};
          var emittedCount_0 = {_v: 0};
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

          var ratio_1 = Companion_getInstance_10().g10_1;
          // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

          lastPos_1._v = Companion_getInstance_12().s3j(l, c0, c1, a_1, ratio_1);
          var nStart_0 = false ? 0 : 1;
          var nEnd_0 = true ? rcurveSteps_0 : rcurveSteps_0 - 1 | 0;
          var inductionVariable_0 = nStart_0;
          if (inductionVariable_0 <= nEnd_0)
            do {
              var n_2 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var ratio_2 = _Ratio___init__impl__9mwvn2(n_2 * dt_0);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              var it_2 = Companion_getInstance_12().s3j(l, c0, c1, a_1, ratio_2);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call
              if (!false) {
                this.q8o(lastPos._v, it_2, VOID, VOID, m);
              }
              lastPos._v = it_2;
              emittedCount_0._v = emittedCount_0._v + 1 | 0;
              lastPos_1._v = prevPos_0._v;
              prevPos_0._v = it_2;
            }
             while (!(n_2 === nEnd_0));
          l = a_1;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 4:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          // Inline function 'korlibs.korge.render.LineRenderBatcher.drawVector.<anonymous>' call

          var p = i;
          if (!false) {
            this.q8o(lastPos._v, p, VOID, VOID, m);
          }

          lastPos._v = p;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
      }
    }
    // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call
  }
  bd() {
    if (this.k8o_1 > 0) {
      this.c8o_1.r22(this);
      this.f8o_1.u6x(this.i8o_1, 0, imul(this.l8o_1, 4));
      this.b8o_1.z8m();
      var tmp0_$receiver = this.d8o_1;
      var tmp1_frameBuffer = this.b8o_1.f8f_1;
      var tmp2_vertexData = this.g8o_1;
      var tmp3_program = Companion_getInstance_72().a8o_1;
      var tmp4_drawType = Companion_getInstance_40().a74_1;
      var tmp5_vertexCount = this.k8o_1;
      var tmp6_uniformBlocks = this.b8o_1.u8o(Companion_getInstance_72().a8o_1);
      var tmp7_blending = this.m8o_1.r8g_1;
      draw(tmp0_$receiver, tmp1_frameBuffer, tmp2_vertexData, tmp3_program, tmp4_drawType, tmp5_vertexCount, VOID, VOID, VOID, tmp7_blending, tmp6_uniformBlocks);
    }
    this.k8o_1 = 0;
    this.l8o_1 = 0;
  }
}
class FlushKind extends Enum {}
class DeviceDimensionsProvider {}
function get_devicePixelRatio() {
  return 1.0;
}
function get_pixelsPerInch() {
  return 96.0 * this.n8p();
}
function get_pixelsPerLogicalInchRatio() {
  return this.o8p() / 96.0;
}
function get_computedPixelRatio() {
  return this.n8p() * this.p8p();
}
class RenderContext {
  constructor(ag, bp, deviceDimensionsProvider, stats, coroutineContext, batchMaxQuads, windowConfig) {
    bp = bp === VOID ? new Base() : bp;
    var tmp;
    if (deviceDimensionsProvider === VOID) {
      var tmp0_elvis_lhs = isInterface(bp, DeviceDimensionsProvider) ? bp : null;
      tmp = tmp0_elvis_lhs == null ? DEFAULT_instance : tmp0_elvis_lhs;
    } else {
      tmp = deviceDimensionsProvider;
    }
    deviceDimensionsProvider = tmp;
    stats = stats === VOID ? new Stats() : stats;
    coroutineContext = coroutineContext === VOID ? EmptyCoroutineContext_getInstance() : coroutineContext;
    batchMaxQuads = batchMaxQuads === VOID ? Companion_getInstance_71().f8l_1 : batchMaxQuads;
    windowConfig = windowConfig === VOID ? new Impl() : windowConfig;
    this.b8e_1 = new Mixin();
    this.c8e_1 = ag;
    this.d8e_1 = bp;
    this.e8e_1 = deviceDimensionsProvider;
    this.f8e_1 = stats;
    this.g8e_1 = coroutineContext;
    this.h8e_1 = batchMaxQuads;
    this.i8e_1 = windowConfig;
    this.j8e_1 = new BufferCache();
    this.k8e_1 = FastIdentityMap();
    this.l8e_1 = AGTextureUnits.z6x();
    this.m8e_1 = Companion_getInstance_7().v2g();
    this.n8e_1 = Companion_getInstance_7().v2g();
    this.o8e_1 = Matrix4.a2k();
    this.p8e_1 = Matrix4.a2k();
    this.q8e_1 = Companion_getInstance_7().v2g();
    this.r8e_1 = true;
    var tmp_0 = this;
    tmp_0.s8e_1 = Pool.r2x(VOID, RenderContext$tempTexturePool$lambda);
    var tmp_1 = this;
    tmp_1.t8e_1 = lazy(RenderContext$projViewMatUB$delegate$lambda(this));
    this.u8e_1 = new AgAutoFreeManager();
    this.v8e_1 = new AgBitmapTextureManager(this.c8e_1);
    this.w8e_1 = new AgBufferManager(this.c8e_1);
    this.x8e_1 = new Signal();
    this.y8e_1 = 1.0;
    this.z8e_1 = Colors_getInstance().y44_1;
    this.a8f_1 = new BatchBuilder2D(this, this.h8e_1);
    var tmp_2 = this;
    tmp_2.b8f_1 = Pool.r2x(VOID, RenderContext$dynamicVertexBufferPool$lambda);
    this.c8f_1 = new RenderContext2D(this.a8f_1, this.v8e_1);
    this.d8f_1 = true;
    this.e8f_1 = null;
    this.f8f_1 = this.c8e_1.k6u();
    this.g8f_1 = LinkedHashSet.h1();
    var tmp_3 = this;
    tmp_3.h8f_1 = Pool.r2x(VOID, RenderContext$frameBuffers$lambda);
    this.i8f_1 = FastArrayList.j11();
  }
  v8o() {
    return this.i8e_1.v8o();
  }
  e8n() {
  }
  w8o() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.t8e_1;
    projViewMatUB$factory();
    return this_0.u1();
  }
  z8m() {
    if (this.r8e_1 && this.f8f_1.w6y()) {
      this.o8e_1 = ortho(Companion_getInstance_6(), Companion_getInstance_5().s2l(0, this.f8f_1.e6u_1, this.f8f_1.d6u_1, 0), -1.0, 1.0);
    } else {
      this.o8e_1 = ortho(Companion_getInstance_6(), Companion_getInstance_5().s2l(0, 0, this.f8f_1.d6u_1, this.f8f_1.e6u_1), -1.0, 1.0);
      this.o8e_1 = this.o8e_1.x2k(toMatrix4(this.m8e_1));
    }
    $l$block: {
      // Inline function 'korlibs.graphics.shader.UniformBlockBuffer.push' call
      var this_0 = this.w8o();
      var _unary__edvuaz = this_0.f73();
      this_0.x7p(_unary__edvuaz + 1 | 0);
      this_0.y7p(this_0.f73() + 1 | 0);
      var blockSize = this_0.j71_1;
      var index0 = imul(this_0.f73() - 1 | 0, blockSize);
      var index1 = imul(this_0.f73(), blockSize);
      var texBlockSize = this_0.g71_1.f79().e1();
      var texIndex0 = imul(this_0.f73() - 1 | 0, texBlockSize);
      var texIndex1 = imul(this_0.f73(), texBlockSize);
      if (this_0.f73() > 0) {
        arraycopy_0(this_0.l71_1, index0, this_0.l71_1, index1, blockSize);
      } else {
        arrayfill_0(this_0.l71_1, 0, 0, blockSize);
      }
      // Inline function 'korlibs.korge.render.RenderContext.updateStandardUniforms.<anonymous>' call
      var $this$push = this_0.g71_1;
      var it = this_0.m71_1;
      it.h7q($this$push.d79(), this.o8e_1);
      it.h7q($this$push.e79(), this.p8e_1);
      if (true && this_0.f73() >= 1) {
        var equals = arrayequal(this_0.l71_1, index0, this_0.l71_1, index1, blockSize);
        if (equals) {
          var _unary__edvuaz_0 = this_0.f73();
          this_0.x7p(_unary__edvuaz_0 - 1 | 0);
          break $l$block;
        }
      }
    }
  }
  x8o() {
    return coerceAtLeast_0(round(this.y8o() * this.y8e_1), 1.0);
  }
  z8o(kind) {
    this.x8e_1.r22(kind);
  }
  o8g(kind, $super) {
    kind = kind === VOID ? FlushKind_FULL_getInstance() : kind;
    var tmp;
    if ($super === VOID) {
      this.z8o(kind);
      tmp = Unit_instance;
    } else {
      tmp = $super.z8o.call(this, kind);
    }
    return tmp;
  }
  a8p() {
    var tmp0_elvis_lhs = this.f8f_1;
    return tmp0_elvis_lhs == null ? this.k6u() : tmp0_elvis_lhs;
  }
  b8p() {
    return this.a8p() === this.k6u();
  }
  k6u() {
    return this.c8e_1.k6u();
  }
  c8p(color, depth, stencil, clearColor, clearDepth, clearStencil, scissor) {
    this.c8e_1.p6u(this.f8f_1.w6t_1, this.f8f_1.d6w(), color, depth, stencil, clearColor, clearDepth, clearStencil, scissor);
  }
  d8p(color, depth, stencil, clearColor, clearDepth, clearStencil, scissor, $super) {
    color = color === VOID ? Colors_getInstance().d45_1 : color;
    depth = depth === VOID ? 1.0 : depth;
    stencil = stencil === VOID ? 0 : stencil;
    clearColor = clearColor === VOID ? true : clearColor;
    clearDepth = clearDepth === VOID ? true : clearDepth;
    clearStencil = clearStencil === VOID ? true : clearStencil;
    scissor = scissor === VOID ? Companion_getInstance_43().x6v_1 : scissor;
    var tmp;
    if ($super === VOID) {
      this.c8p(color, depth, stencil, clearColor, clearDepth, clearStencil, scissor);
      tmp = Unit_instance;
    } else {
      tmp = $super.c8p.call(this, new RGBA(color), depth, stencil, clearColor, clearDepth, clearStencil, scissor);
    }
    return tmp;
  }
  m6u() {
    this.c8e_1.m6u();
    this.h8f_1.v2x(this.g8f_1);
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this.g8f_1.g1()) {
      this.g8f_1.m3();
    }
  }
  p8g(bmp) {
    return this.v8e_1.o8k(bmp);
  }
  e8p(bmp) {
    return this.v8e_1.p8k(bmp);
  }
  z8k(buffer) {
    return this.w8e_1.z8k(buffer);
  }
  f8p(closeable) {
    return this.u8e_1.e8j(closeable);
  }
  g8p() {
    this.a8f_1.z8l();
  }
  q8k() {
    this.o8g();
    this.m6u();
    this.a8f_1.f8j();
    this.u8e_1.f8j();
    this.v8e_1.q8k();
    this.w8e_1.f8j();
  }
  t6() {
    this.v8e_1.t6();
    this.u8e_1.t6();
  }
  h8p(width, height, hasDepth, hasStencil, msamples, onlyThisFrame) {
    // Inline function 'kotlin.math.max' call
    var realWidth = Math.max(width, 64);
    // Inline function 'kotlin.math.max' call
    var realHeight = Math.max(height, 64);
    var rb = this.h8f_1.t2x();
    if (onlyThisFrame) {
      // Inline function 'kotlin.collections.plusAssign' call
      this.g8f_1.h(rb);
    }
    rb.i6z(0, 0, realWidth, realHeight, realWidth, realHeight);
    rb.z6z(hasDepth, hasStencil);
    rb.y6z(msamples);
    return rb;
  }
  i8p(width, height, hasDepth, hasStencil, msamples, onlyThisFrame, $super) {
    hasDepth = hasDepth === VOID ? false : hasDepth;
    hasStencil = hasStencil === VOID ? true : hasStencil;
    msamples = msamples === VOID ? 1 : msamples;
    onlyThisFrame = onlyThisFrame === VOID ? true : onlyThisFrame;
    return $super === VOID ? this.h8p(width, height, hasDepth, hasStencil, msamples, onlyThisFrame) : $super.h8p.call(this, width, height, hasDepth, hasStencil, msamples, onlyThisFrame);
  }
  j8p(rb) {
    this.g8f_1.o3(rb);
    this.h8f_1.u2x(rb);
  }
  k8p(frameBuffer) {
    this.i8f_1.h(this.f8f_1);
    this.f8f_1 = frameBuffer;
  }
  l8p() {
    this.f8f_1 = this.i8f_1.r3(this.i8f_1.e1() - 1 | 0);
  }
  q71(uniformBlock) {
    return this.j8e_1.q71(uniformBlock);
  }
  m8p(program) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.datastructure.getOrPut' call
      var this_0 = this.k8e_1;
      var res = get_0(this_0, program);
      if (!(res == null)) {
        tmp$ret$0 = res;
        break $l$block;
      }
      // Inline function 'korlibs.korge.render.RenderContext.get.<anonymous>' call
      var out = new AGProgramWithUniforms(program, this.j8e_1);
      set(this_0, program, out);
      tmp$ret$0 = out;
    }
    return tmp$ret$0;
  }
  a8n(program, autoUpload) {
    if (autoUpload) {
      this.d8n();
    }
    return this.m8p(program).e73();
  }
  u8o(program, autoUpload, $super) {
    autoUpload = autoUpload === VOID ? true : autoUpload;
    return $super === VOID ? this.a8n(program, autoUpload) : $super.a8n.call(this, program, autoUpload);
  }
  d8n() {
    this.j8e_1.o71();
  }
  r10(value) {
    this.b8e_1.r10(value);
  }
  s10() {
    return this.b8e_1.s10();
  }
  l8n(_set____db54di) {
    this.d8e_1.l8n(_set____db54di);
  }
  m8n() {
    return this.d8e_1.m8n();
  }
  n8n(_set____db54di) {
    this.d8e_1.n8n(_set____db54di);
  }
  o8n() {
    return this.d8e_1.o8n();
  }
  p8n(_set____db54di) {
    this.d8e_1.p8n(_set____db54di);
  }
  q8n() {
    return this.d8e_1.q8n();
  }
  r8n(_set____db54di) {
    this.d8e_1.r8n(_set____db54di);
  }
  s8n() {
    return this.d8e_1.s8n();
  }
  t8n(_set____db54di) {
    this.d8e_1.t8n(_set____db54di);
  }
  u8n() {
    return this.d8e_1.u8n();
  }
  v8n() {
    return this.d8e_1.v8n();
  }
  w8n(pos) {
    return this.d8e_1.w8n(pos);
  }
  s6u() {
    return this.c8e_1.s6u();
  }
  t6u() {
    return this.c8e_1.t6u();
  }
  u6u() {
    return this.c8e_1.u6u();
  }
  n8p() {
    return this.e8e_1.n8p();
  }
  o8p() {
    return this.e8e_1.o8p();
  }
  p8p() {
    return this.e8e_1.p8p();
  }
  y8o() {
    return this.e8e_1.y8o();
  }
}
class RenderContext2D {
  constructor(batch, agBitmapTextureManager) {
    this.q8p_1 = new Mixin();
    this.r8p_1 = batch;
    this.s8p_1 = agBitmapTextureManager;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_0 = get_logger_0();
    var level = Level_TRACE_getInstance();
    var tmp;
    if (this_0.q31(level)) {
      // Inline function 'korlibs.korge.render.RenderContext2D.<anonymous>' call
      var tmp$ret$0 = 'RenderContext2D[0]';
      this_0.r31(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    this.t8p_1 = Size2D.o2e(0, 0);
    var tmp_0 = this;
    tmp_0.u8p_1 = Pool.r2x(VOID, RenderContext2D$mpool$lambda);
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_1 = get_logger_0();
    var level_0 = Level_TRACE_getInstance();
    var tmp_1;
    if (this_1.q31(level_0)) {
      // Inline function 'korlibs.korge.render.RenderContext2D.<anonymous>' call
      var tmp$ret$2 = 'RenderContext2D[1]';
      this_1.r31(level_0, tmp$ret$2);
      tmp_1 = Unit_instance;
    }
    this.v8p_1 = Companion_getInstance_7().s2g_1;
    this.w8p_1 = Companion_getInstance_68().h8d_1;
    this.x8p_1 = Colors_getInstance().y44_1;
    this.y8p_1 = true;
    // Inline function 'korlibs.logger.Logger.trace' call
    var this_2 = get_logger_0();
    var level_1 = Level_TRACE_getInstance();
    var tmp_2;
    if (this_2.q31(level_1)) {
      // Inline function 'korlibs.korge.render.RenderContext2D.<anonymous>' call
      var tmp$ret$4 = 'RenderContext2D[2]';
      this_2.r31(level_1, tmp$ret$4);
      tmp_2 = Unit_instance;
    }
  }
  z8p(scissor) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var this_0 = this.v8p_1;
      var p = Vector2D.d2g(scissor.y2d(), scissor.a2e());
      if (this_0.w2d()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = Vector2D.q2f(this_0.k2h(p.h2d_1, p.i2d_1), this_0.n2h(p.h2d_1, p.i2d_1));
    }
    var tl = tmp$ret$0;
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var this_1 = this.v8p_1;
      var p_0 = Vector2D.d2g(scissor.z2d(), scissor.b2e());
      if (this_1.w2d()) {
        tmp$ret$1 = p_0;
        break $l$block_0;
      }
      tmp$ret$1 = Vector2D.q2f(this_1.k2h(p_0.h2d_1, p_0.i2d_1), this_1.n2h(p_0.h2d_1, p_0.i2d_1));
    }
    var br = tmp$ret$1;
    return Companion_getInstance_43().f75(tl.h2d_1, tl.i2d_1, br.h2d_1, br.i2d_1);
  }
  r10(value) {
    this.q8p_1.r10(value);
  }
  s10() {
    return this.q8p_1.s10();
  }
}
class SDFShaders extends Builder {
  static s8q() {
    SDFShaders_instance = null;
    var $this = this.e7c();
    SDFShaders_instance = $this;
    var tmp = $this;
    var tmp_0 = $this.a7d();
    var tmp_1 = $this.a7d();
    var tmp_2 = $this.a7d();
    var tmp_3 = $this.a7d();
    tmp.c8q_1 = $this.p7c(tmp_0, tmp_1, tmp_2, VOID, tmp_3, SDFShaders$opInterpolate$delegate$lambda).r79($this, opInterpolate$factory());
    var tmp_4 = $this;
    var tmp_5 = $this.a7d();
    var tmp_6 = $this.a7d();
    var tmp_7 = $this.a7d();
    tmp_4.d8q_1 = $this.n7c(tmp_5, tmp_6, VOID, tmp_7, SDFShaders$opUnion$delegate$lambda).r79($this, opUnion$factory());
    var tmp_8 = $this;
    var tmp_9 = $this.a7d();
    var tmp_10 = $this.a7d();
    var tmp_11 = $this.a7d();
    tmp_8.e8q_1 = $this.n7c(tmp_9, tmp_10, VOID, tmp_11, SDFShaders$opIntersect$delegate$lambda).r79($this, opIntersect$factory());
    var tmp_12 = $this;
    var tmp_13 = $this.a7d();
    var tmp_14 = $this.a7d();
    var tmp_15 = $this.a7d();
    tmp_12.f8q_1 = $this.n7c(tmp_13, tmp_14, VOID, tmp_15, SDFShaders$opSubtract$delegate$lambda).r79($this, opSubtract$factory());
    var tmp_16 = $this;
    var tmp_17 = $this.a7d();
    var tmp_18 = $this.a7d();
    var tmp_19 = $this.a7d();
    tmp_16.g8q_1 = $this.n7c(tmp_17, tmp_18, VOID, tmp_19, SDFShaders$opRound$delegate$lambda).r79($this, opRound$factory());
    var tmp_20 = $this;
    var tmp_21 = $this.a7d();
    var tmp_22 = $this.a7d();
    var tmp_23 = $this.a7d();
    tmp_20.h8q_1 = $this.n7c(tmp_21, tmp_22, VOID, tmp_23, SDFShaders$opBorder$delegate$lambda).r79($this, opBorder$factory());
    var tmp_24 = $this;
    var tmp_25 = $this.a7d();
    var tmp_26 = $this.a7d();
    var tmp_27 = $this.a7d();
    tmp_24.i8q_1 = $this.n7c(tmp_25, tmp_26, VOID, tmp_27, SDFShaders$opBorderInner$delegate$lambda).r79($this, opBorderInner$factory());
    var tmp_28 = $this;
    var tmp_29 = $this.a7d();
    var tmp_30 = $this.a7d();
    tmp_28.j8q_1 = $this.l7c(tmp_29, VOID, tmp_30, SDFShaders$opAA$delegate$lambda).r79($this, opAA$factory());
    var tmp_31 = $this;
    var tmp_32 = $this.a7d();
    var tmp_33 = $this.a7d();
    tmp_31.k8q_1 = $this.l7c(tmp_32, VOID, tmp_33, SDFShaders$opAARev$delegate$lambda).r79($this, opAARev$factory());
    var tmp_34 = $this;
    var tmp_35 = $this.a7d();
    var tmp_36 = $this.a7d();
    var tmp_37 = $this.a7d();
    var tmp_38 = $this.a7d();
    tmp_34.l8q_1 = $this.p7c(tmp_35, tmp_36, tmp_37, VOID, tmp_38, SDFShaders$opSmoothUnion$delegate$lambda).r79($this, opSmoothUnion$factory());
    var tmp_39 = $this;
    var tmp_40 = $this.a7d();
    var tmp_41 = $this.a7d();
    var tmp_42 = $this.a7d();
    var tmp_43 = $this.a7d();
    tmp_39.m8q_1 = $this.p7c(tmp_40, tmp_41, tmp_42, VOID, tmp_43, SDFShaders$opSmoothSubtraction$delegate$lambda).r79($this, opSmoothSubtraction$factory());
    var tmp_44 = $this;
    var tmp_45 = $this.a7d();
    var tmp_46 = $this.a7d();
    var tmp_47 = $this.a7d();
    var tmp_48 = $this.a7d();
    tmp_44.n8q_1 = $this.p7c(tmp_45, tmp_46, tmp_47, VOID, tmp_48, SDFShaders$opSmoothIntersection$delegate$lambda).r79($this, opSmoothIntersection$factory());
    var tmp_49 = $this;
    var tmp_50 = $this.s7y();
    var tmp_51 = $this.a7d();
    var tmp_52 = $this.a7d();
    tmp_49.o8q_1 = $this.n7c(tmp_50, tmp_51, VOID, tmp_52, SDFShaders$circle$delegate$lambda).r79($this, circle$factory());
    var tmp_53 = $this;
    var tmp_54 = $this.s7y();
    var tmp_55 = $this.s7y();
    var tmp_56 = $this.t7y();
    var tmp_57 = $this.a7d();
    tmp_53.p8q_1 = $this.p7c(tmp_54, tmp_55, tmp_56, VOID, tmp_57, SDFShaders$roundedBox$delegate$lambda).r79($this, roundedBox$factory());
    var tmp_58 = $this;
    var tmp_59 = $this.s7y();
    var tmp_60 = $this.s7y();
    var tmp_61 = $this.a7d();
    tmp_58.q8q_1 = $this.n7c(tmp_59, tmp_60, VOID, tmp_61, SDFShaders$box$delegate$lambda).r79($this, box$factory());
    var tmp_62 = $this;
    var tmp_63 = $this.t7y();
    var tmp_64 = $this.t7y();
    var tmp_65 = $this.t7y();
    tmp_62.r8q_1 = $this.n7c(tmp_63, tmp_64, VOID, tmp_65, SDFShaders$opCombinePremultipliedColors$delegate$lambda).r79($this, opCombinePremultipliedColors$factory());
    return $this;
  }
  t8q() {
    return this.c8q_1.wo(this, opInterpolate$factory_0());
  }
  u8q() {
    return this.d8q_1.wo(this, opUnion$factory_0());
  }
  v8q() {
    return this.e8q_1.wo(this, opIntersect$factory_0());
  }
  w8q() {
    return this.f8q_1.wo(this, opSubtract$factory_0());
  }
  x8q() {
    return this.g8q_1.wo(this, opRound$factory_0());
  }
  y8q() {
    return this.h8q_1.wo(this, opBorder$factory_0());
  }
  z8q() {
    return this.i8q_1.wo(this, opBorderInner$factory_0());
  }
  a8r() {
    return this.j8q_1.wo(this, opAA$factory_0());
  }
  b8r() {
    return this.k8q_1.wo(this, opAARev$factory_0());
  }
  c8r() {
    return this.l8q_1.wo(this, opSmoothUnion$factory_0());
  }
  d8r() {
    return this.m8q_1.wo(this, opSmoothSubtraction$factory_0());
  }
  e8r() {
    return this.n8q_1.wo(this, opSmoothIntersection$factory_0());
  }
  f8r() {
    return this.o8q_1.wo(this, circle$factory_0());
  }
  g8r() {
    return this.p8q_1.wo(this, roundedBox$factory_0());
  }
  h8r() {
    return this.q8q_1.wo(this, box$factory_0());
  }
  i8r() {
    return this.r8q_1.wo(this, opCombinePremultipliedColors$factory_0());
  }
}
class TextureBase {
  static j8r(base, size) {
    var $this = createThis(this);
    $this.k8j_1 = base;
    $this.l8j_1 = size;
    $this.m8j_1 = -1;
    return $this;
  }
  e1() {
    return this.l8j_1;
  }
  static n8j(base, width, height) {
    return this.j8r(base, SizeInt.d2o(width, height));
  }
  o8j(width) {
    this.l8j_1 = SizeInt.d2o(width, this.y2p());
  }
  x2p() {
    return this.l8j_1.b2o_1;
  }
  p8j(height) {
    this.l8j_1 = SizeInt.d2o(this.x2p(), height);
  }
  y2p() {
    return this.l8j_1.c2o_1;
  }
  t6() {
    var tmp0_safe_receiver = this.k8j_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.t6();
    }
    this.k8j_1 = null;
  }
  i8k(bmp, mipmaps, baseMipmapLevel, maxMipmapLevel) {
    var tmp0_safe_receiver = this.k8j_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver.v70(bmp, mipmaps, baseMipmapLevel, maxMipmapLevel);
  }
  toString() {
    return 'TextureBase(' + toString_1(this.k8j_1) + ')';
  }
}
class Companion_58 {
  constructor() {
    Companion_instance_67 = this;
    this.k8r_1 = new TexturedVertexArray(0, new Int16Array(0));
  }
}
class TexturedVertexArray {
  constructor(vcount, indices, icount) {
    Companion_getInstance_73();
    icount = icount === VOID ? indices.length : icount;
    this.i8m_1 = indices;
    this.j8m_1 = vcount;
    this.k8m_1 = vcount;
    this.l8m_1 = icount;
    this.m8m_1 = allocNoDirect(Companion_instance_4, imul(imul(6, this.j8m_1), 4));
    this.n8m_1 = this.m8m_1;
    this.o8m_1 = 0;
  }
  l8r(fast, pos, x, y, u, v, colMul) {
    setFloat32(fast, pos + 0 | 0, x);
    setFloat32(fast, pos + 1 | 0, y);
    setFloat32(fast, pos + 2 | 0, u);
    setFloat32(fast, pos + 3 | 0, v);
    setInt32(fast, pos + 4 | 0, colMul);
    setInt32(fast, pos + 5 | 0, 0);
    return 6;
  }
  m8r(index, x, y, width, height, matrix, bmp, colMul) {
    this.n8r(index, x, y, width, height, matrix, bmp.u3p(), bmp.v3p(), bmp.w3p(), bmp.x3p(), bmp.a3q(), bmp.b3q(), bmp.y3p(), bmp.z3p(), colMul);
  }
  n8r(index, x, y, width, height, matrix, tl_x, tl_y, tr_x, tr_y, bl_x, bl_y, br_x, br_y, colMul) {
    var xw = x + width;
    var yh = y + height;
    var af = matrix.x2g_1;
    var cf = matrix.z2g_1;
    var txf = matrix.b2h_1;
    var x0 = af * x + cf * y + txf;
    var x1 = af * xw + cf * y + txf;
    var x2 = af * xw + cf * yh + txf;
    var x3 = af * x + cf * yh + txf;
    var df = matrix.a2h_1;
    var bf = matrix.y2g_1;
    var tyf = matrix.c2h_1;
    var y0 = df * y + bf * x + tyf;
    var y1 = df * y + bf * xw + tyf;
    var y2 = df * yh + bf * xw + tyf;
    var y3 = df * yh + bf * x + tyf;
    var fast = this.n8m_1;
    var pos = imul(index, 6);
    var cm = _RGBA___get_value__impl__hhco8v(colMul);
    pos = pos + this.l8r(fast, pos, x0, y0, tl_x, tl_y, cm) | 0;
    pos = pos + this.l8r(fast, pos, x1, y1, tr_x, tr_y, cm) | 0;
    pos = pos + this.l8r(fast, pos, x2, y2, br_x, br_y, cm) | 0;
    pos = pos + this.l8r(fast, pos, x3, y3, bl_x, bl_y, cm) | 0;
  }
}
class ResourcesRoot {
  q8r(path, file) {
    _get_mountable__707cy(this).m36(path, file);
  }
  l6i(injector) {
    var tmp = this;
    // Inline function 'korlibs.io.file.std.MountableVfs' call
    // Inline function 'korlibs.io.file.std.MountableVfsSync' call
    // Inline function 'kotlin.also' call
    var this_0 = new MountableVfs(false);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.file.std.MountableVfsSync.<anonymous>' call
    // Inline function 'korlibs.io.file.std.MountableVfs.<anonymous>' call
    // Inline function 'korlibs.korge.resources.ResourcesRoot.init.<anonymous>' call
    this.p8r_1 = this_0;
    tmp.o8r_1 = this_0.d2b();
    this.q8r('/', get_resourcesVfs());
  }
  toString() {
    return 'ResourcesRoot[' + _get_root__dd8asp(this).toString() + ']';
  }
}
class RCollection {
  constructor() {
    this.r8r_1 = ArrayList.i1();
    this.s8r_1 = LinkedHashMap.rc();
  }
}
class Stats {
  constructor() {
    this.t8r_1 = new RCollection();
    this.u8r_1 = new RCollection();
  }
  o6u() {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.t8r_1.r8r_1;
    var n = 0;
    while (n < this_0.e1()) {
      // Inline function 'korlibs.korge.stat.Stats.startFrame.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      this_0.d1(_unary__edvuaz).o6u();
    }
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_1 = this.u8r_1.r8r_1;
    var n_0 = 0;
    while (n_0 < this_1.e1()) {
      // Inline function 'korlibs.korge.stat.Stats.startFrame.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      this_1.d1(_unary__edvuaz_0).o6u();
    }
  }
}
class V2 {
  constructor(key, initial, end, interpolator, includeStart, fastStartTime, fastDuration, initialization) {
    fastStartTime = fastStartTime === VOID ? Companion_instance_3.k1z() : fastStartTime;
    fastDuration = fastDuration === VOID ? Companion_instance_3.l1z() : fastDuration;
    initialization = initialization === VOID ? null : initialization;
    this.c8s_1 = key;
    this.d8s_1 = initial;
    this.e8s_1 = end;
    this.f8s_1 = interpolator;
    this.g8s_1 = includeStart;
    this.h8s_1 = fastStartTime;
    this.i8s_1 = fastDuration;
    this.j8s_1 = initialization;
    this.k8s_1 = FastDuration__plus_impl_q1enab(this.h8s_1, equals(this.i8s_1, Companion_instance_3.l1z()) ? get_fastNanoseconds_0(0) : this.i8s_1);
  }
  l8s() {
    return toDuration_1(this.h8s_1);
  }
  m8s() {
    return toDuration_1(this.i8s_1);
  }
  b3e() {
    if (!this.g8s_1) {
      this.d8s_1 = this.c8s_1.get();
    }
    var tmp0_safe_receiver = this.j8s_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver();
  }
  n8s(ratio) {
    this.c8s_1.set(this.f8s_1(new Ratio(ratio), this.d8s_1, this.e8s_1));
  }
  toString() {
    return 'V2(key=' + this.c8s_1.callableName + ', range=[' + toString_1(this.d8s_1) + '-' + toString_1(this.e8s_1) + '], startTime=' + Duration__toString_impl_8d916b(this.l8s()) + ', duration=' + Duration__toString_impl_8d916b(this.m8s()) + ')';
  }
  hashCode() {
    var result = hashCode(this.c8s_1);
    result = imul(result, 31) + (this.d8s_1 == null ? 0 : hashCode(this.d8s_1)) | 0;
    result = imul(result, 31) + (this.e8s_1 == null ? 0 : hashCode(this.e8s_1)) | 0;
    result = imul(result, 31) + hashCode(this.f8s_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.g8s_1) | 0;
    result = imul(result, 31) + FastDuration__hashCode_impl_y13la6(this.h8s_1) | 0;
    result = imul(result, 31) + FastDuration__hashCode_impl_y13la6(this.i8s_1) | 0;
    result = imul(result, 31) + (this.j8s_1 == null ? 0 : hashCode(this.j8s_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof V2))
      return false;
    var tmp0_other_with_cast = other instanceof V2 ? other : THROW_CCE();
    if (!equals(this.c8s_1, tmp0_other_with_cast.c8s_1))
      return false;
    if (!equals(this.d8s_1, tmp0_other_with_cast.d8s_1))
      return false;
    if (!equals(this.e8s_1, tmp0_other_with_cast.e8s_1))
      return false;
    if (!equals(this.f8s_1, tmp0_other_with_cast.f8s_1))
      return false;
    if (!(this.g8s_1 === tmp0_other_with_cast.g8s_1))
      return false;
    if (!equals(this.h8s_1, tmp0_other_with_cast.h8s_1))
      return false;
    if (!equals(this.i8s_1, tmp0_other_with_cast.i8s_1))
      return false;
    if (!equals(this.j8s_1, tmp0_other_with_cast.j8s_1))
      return false;
    return true;
  }
}
class DEFAULT {}
class Impl {
  constructor(quality) {
    quality = quality === VOID ? Quality_AUTOMATIC_getInstance() : quality;
    this.o8s_1 = quality;
  }
  v8o() {
    return this.o8s_1;
  }
}
class Companion_59 {
  constructor() {
    Companion_instance_68 = this;
    this.p8s_1 = mapOf([to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 0)), Cursor_RESIZE_EAST_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 1)), Cursor_RESIZE_SOUTH_EAST_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 2)), Cursor_RESIZE_SOUTH_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 3)), Cursor_RESIZE_SOUTH_WEST_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 4)), Cursor_RESIZE_WEST_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 5)), Cursor_RESIZE_NORTH_WEST_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 6)), Cursor_RESIZE_NORTH_getInstance()), to(new Angle(Angle__times_impl_v3s9y2(get_degrees(45), 7)), Cursor_RESIZE_NORTH_EAST_getInstance())]);
  }
}
class Cursor extends Enum {}
class MenuItem {
  constructor(text, enabled, children, action) {
    enabled = enabled === VOID ? true : enabled;
    children = children === VOID ? null : children;
    var tmp;
    if (action === VOID) {
      tmp = GameWindow$MenuItem$_init_$lambda_465oqx;
    } else {
      tmp = action;
    }
    action = tmp;
    this.s8s_1 = text;
    this.t8s_1 = enabled;
    this.u8s_1 = children;
    this.v8s_1 = action;
  }
  toString() {
    return 'MenuItem(text=' + this.s8s_1 + ', enabled=' + this.t8s_1 + ', children=' + toString_1(this.u8s_1) + ', action=' + toString(this.v8s_1) + ')';
  }
  hashCode() {
    var result = this.s8s_1 == null ? 0 : getStringHashCode(this.s8s_1);
    result = imul(result, 31) + getBooleanHashCode(this.t8s_1) | 0;
    result = imul(result, 31) + (this.u8s_1 == null ? 0 : hashCode(this.u8s_1)) | 0;
    result = imul(result, 31) + hashCode(this.v8s_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MenuItem))
      return false;
    var tmp0_other_with_cast = other instanceof MenuItem ? other : THROW_CCE();
    if (!(this.s8s_1 == tmp0_other_with_cast.s8s_1))
      return false;
    if (!(this.t8s_1 === tmp0_other_with_cast.t8s_1))
      return false;
    if (!equals(this.u8s_1, tmp0_other_with_cast.u8s_1))
      return false;
    if (!equals(this.v8s_1, tmp0_other_with_cast.v8s_1))
      return false;
    return true;
  }
}
class CoroutineKey {
  constructor() {
    CoroutineKey_instance = this;
    this.w8s_1 = 60;
    this.x8s_1 = Companion_getInstance_1().iz('GameWindow');
    this.y8s_1 = new MenuItem(null);
  }
}
class Quality extends Enum {
  constructor(name, ordinal, level) {
    super(name, ordinal);
    this.m8v_1 = level;
    this.n8v_1 = 4000000;
  }
  j26() {
    return this.m8v_1;
  }
  o8v(width, height, devicePixelRatio, targetPixels) {
    var tmp;
    switch (this.t3_1) {
      case 0:
        tmp = 1.0;
        break;
      case 1:
        tmp = devicePixelRatio;
        break;
      case 2:
        var tmp$ret$1;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var tmp0_iterator = listOf_0([devicePixelRatio, 2.0, 1.0]).a1();
          while (tmp0_iterator.b1()) {
            var element = tmp0_iterator.c1();
            // Inline function 'korlibs.render.Quality.computeTargetScale.<anonymous>' call
            if (imul(width, height) * element <= targetPixels) {
              tmp$ret$1 = element;
              break $l$block;
            }
          }
          tmp$ret$1 = null;
        }

        var tmp1_elvis_lhs = tmp$ret$1;
        tmp = tmp1_elvis_lhs == null ? 1.0 : tmp1_elvis_lhs;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  p8v(width, height, devicePixelRatio, targetPixels, $super) {
    targetPixels = targetPixels === VOID ? this.n8v_1 : targetPixels;
    return $super === VOID ? this.o8v(width, height, devicePixelRatio, targetPixels) : $super.o8v.call(this, width, height, devicePixelRatio, targetPixels);
  }
}
class GameWindow$loop$slambda {
  constructor($entry, this$0) {
    this.q8s_1 = $entry;
    this.r8s_1 = this$0;
  }
  fe($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
  }
}
class _no_name_provided__qut3iv extends ObservableProperty {
  constructor($initialValue, this$0, $box) {
    if ($box === VOID)
      $box = {};
    $box.w8v_1 = this$0;
    super($initialValue, $box);
  }
  x8v(property, oldValue, newValue) {
    var tmp0_safe_receiver = this.w8v_1.q8u_1;
    if (tmp0_safe_receiver == null)
      null;
    else
      tmp0_safe_receiver(newValue);
    return Unit_instance;
  }
  vo(property, oldValue, newValue) {
    var tmp = (oldValue == null ? true : !(oldValue == null)) ? oldValue : THROW_CCE();
    return this.x8v(property, tmp, (newValue == null ? true : !(newValue == null)) ? newValue : THROW_CCE());
  }
}
class GameWindow extends BaseEventListener {
  static y8v() {
    CoroutineKey_getInstance();
    var $this = this.j6l();
    $this.d8t_1 = new Mixin();
    $this.e8t_1 = Cursor_DEFAULT_getInstance();
    $this.f8t_1 = false;
    $this.g8t_1 = AGDummy.t7n();
    $this.h8t_1 = SyncEventLoopCoroutineDispatcher.b8w();
    $this.i8t_1 = GameWindowCoroutineDispatcher.m8w();
    $this.j8t_1 = new PauseEvent();
    $this.k8t_1 = new ResumeEvent();
    $this.l8t_1 = new StopEvent();
    $this.m8t_1 = new DestroyEvent();
    $this.n8t_1 = new UpdateEvent();
    $this.o8t_1 = new RenderEvent();
    $this.p8t_1 = new InitEvent();
    $this.q8t_1 = new DisposeEvent();
    $this.r8t_1 = new FullScreenEvent();
    $this.s8t_1 = new ReshapeEvent();
    $this.t8t_1 = new KeyEvent();
    $this.u8t_1 = new MouseEvent();
    $this.v8t_1 = new GestureEvent();
    $this.w8t_1 = new DropFileEvent();
    var tmp = $this;
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp_0 = toDuration(1000, DurationUnit_MILLISECONDS_getInstance());
    tmp.x8t_1 = new IntTimedCache(tmp_0, VOID, GameWindow$fpsCached$delegate$lambda($this));
    $this.y8t_1 = 60;
    $this.z8t_1 = 0;
    $this.a8u_1 = 0;
    $this.b8u_1 = true;
    $this.c8u_1 = null;
    $this.d8u_1 = false;
    $this.e8u_1 = false;
    $this.f8u_1 = Colors_getInstance().z44_1;
    $this.g8u_1 = new Signal();
    $this.h8u_1 = new Signal();
    $this.i8u_1 = null;
    $this.j8u_1 = false;
    $this.k8u_1 = true;
    $this.l8u_1 = 0;
    $this.m8u_1 = true;
    $this.n8u_1 = false;
    var tmp_1 = $this;
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    tmp_1.o8u_1 = toDuration(0, DurationUnit_MILLISECONDS_getInstance());
    var tmp_2 = $this;
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    tmp_2.p8u_1 = toDuration(0, DurationUnit_MILLISECONDS_getInstance());
    $this.q8u_1 = null;
    var tmp_3 = $this;
    // Inline function 'kotlin.properties.Delegates.observable' call
    tmp_3.r8u_1 = new _no_name_provided__qut3iv(true, $this);
    $this.s8u_1 = false;
    $this.t8u_1 = -1;
    $this.u8u_1 = -1;
    $this.v8u_1 = -1;
    $this.w8u_1 = -1;
    $this.x8u_1 = false;
    $this.y8u_1 = false;
    $this.z8u_1 = false;
    $this.a8v_1 = 0;
    $this.b8v_1 = Companion_instance_3.k1z();
    $this.c8v_1 = new Lock();
    $this.d8v_1 = booleanArray(Companion_getInstance_34().m6s_1);
    $this.e8v_1 = 0;
    $this.f8v_1 = 0.0;
    $this.g8v_1 = 0.0;
    $this.h8v_1 = 0.0;
    $this.i8v_1 = false;
    $this.j8v_1 = new GamepadInfoEmitter($this);
    return $this;
  }
  n8w(_set____db54di) {
    this.e8t_1 = _set____db54di;
  }
  o8w() {
    return this.e8t_1;
  }
  t1() {
    return CoroutineKey_getInstance();
  }
  p8w() {
    return this.g8t_1;
  }
  q8w() {
    return this.i8t_1;
  }
  r8w(coroutineContext) {
    return coroutineContext.mn(this.q8w());
  }
  q8v($completion) {
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp$ret$0 = $completion.cd();
    return this.r8w(tmp$ret$0);
  }
  s8w(block) {
    return this.l6l(Companion_getInstance_18(), block);
  }
  s8v() {
    return get_fastMicroseconds(1000000.0 / this.t8w());
  }
  u8w() {
    // Inline function 'korlibs.time.microseconds' call
    var this_0 = 1000000.0 / this.t8w();
    return toDuration(this_0, DurationUnit_MICROSECONDS_getInstance());
  }
  u8v() {
    return 60;
  }
  v8w(name, time) {
  }
  t8w() {
    return _get_fpsCached__581dty(this);
  }
  w8w(value) {
    return Unit_instance;
  }
  x2p() {
    return this.z8t_1;
  }
  y2p() {
    return this.a8u_1;
  }
  x8w(_set____db54di) {
    this.c8u_1 = _set____db54di;
  }
  y8w(_set____db54di) {
    this.d8u_1 = _set____db54di;
  }
  z8w(_set____db54di) {
    this.e8u_1 = _set____db54di;
  }
  a8x(_set____db54di) {
    this.f8u_1 = _set____db54di;
  }
  b8x() {
    return this.f8u_1;
  }
  c8x(value) {
    return Unit_instance;
  }
  v8o() {
    return Quality_AUTOMATIC_getInstance();
  }
  d8x(value) {
    this.j8u_1 = value;
    this.h8u_1.r22(value);
    if (value) {
      invoke(this.g8u_1);
    }
  }
  e8x() {
    return this.j8u_1;
  }
  f8x(width, height) {
    return Unit_instance;
  }
  g8x(exitCode) {
    return this.b1g(exitCode);
  }
  h8x(exitCode, $super) {
    exitCode = exitCode === VOID ? 0 : exitCode;
    var tmp;
    if ($super === VOID) {
      this.g8x(exitCode);
      tmp = Unit_instance;
    } else {
      tmp = $super.g8x.call(this, exitCode);
    }
    return tmp;
  }
  b1g(exitCode) {
    if (this.n8u_1)
      return Unit_instance;
    this.n8u_1 = true;
    this.m8u_1 = false;
    this.l8u_1 = exitCode;
    // Inline function 'korlibs.logger.Logger.info' call
    var this_0 = CoroutineKey_getInstance().x8s_1;
    var level = Level_INFO_getInstance();
    var tmp;
    if (this_0.q31(level)) {
      // Inline function 'korlibs.render.GameWindow.close.<anonymous>' call
      var tmp$ret$0 = 'GameWindow.close';
      this_0.r31(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    this.q8w().t6();
    cancelChildren(this.q8w());
  }
  i8x(exitCode, $super) {
    exitCode = exitCode === VOID ? 0 : exitCode;
    var tmp;
    if ($super === VOID) {
      this.b1g(exitCode);
      tmp = Unit_instance;
    } else {
      tmp = $super.b1g.call(this, exitCode);
    }
    return tmp;
  }
  j8x($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_waitClose__fhnm35.bind(VOID, this), $completion);
  }
  k8x(entry, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_loop__qll5p8.bind(VOID, this, entry), $completion);
  }
  t8v(time, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_loopDelay__vgtnit.bind(VOID, this, time), $completion);
  }
  l8x(_set____db54di) {
    return this.r8u_1.zo(this, continuousRenderMode$factory(), _set____db54di);
  }
  m8x() {
    return this.r8u_1.xo(this, continuousRenderMode$factory_0());
  }
  n8x(doUpdate, doRender, frameStartTime) {
    var startTime = PerformanceCounter_getInstance().k6j();
    if (doRender) {
      var tmp = this;
      // Inline function 'kotlin.time.measureTime' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.time.measureTime' call
      // Inline function 'kotlin.contracts.contract' call
      var mark = Monotonic_instance.rj();
      // Inline function 'korlibs.render.GameWindow.frame.<anonymous>' call
      this.o8x(doUpdate, true);
      tmp.o8u_1 = ValueTimeMark__elapsedNow_impl_eonqvs(mark);
    }
    if (doUpdate) {
      var tmp_0 = this;
      // Inline function 'kotlin.time.measureTime' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.time.measureTime' call
      // Inline function 'kotlin.contracts.contract' call
      var mark_0 = Monotonic_instance.rj();
      // Inline function 'korlibs.render.GameWindow.frame.<anonymous>' call
      if (!doRender) {
        this.o8x(true, false);
      }
      this.p8x(frameStartTime);
      tmp_0.p8u_1 = ValueTimeMark__elapsedNow_impl_eonqvs(mark_0);
    }
    var endTime = PerformanceCounter_getInstance().l6j();
    return FastDuration__minus_impl_evs237_0(endTime, startTime);
  }
  r8v(doUpdate, doRender, frameStartTime, $super) {
    doUpdate = doUpdate === VOID ? true : doUpdate;
    doRender = doRender === VOID ? true : doRender;
    frameStartTime = frameStartTime === VOID ? PerformanceCounter_getInstance().l6j() : frameStartTime;
    return $super === VOID ? this.n8x(doUpdate, doRender, frameStartTime) : $super.n8x.call(this, doUpdate, doRender, new FastDuration(frameStartTime)).n1z_1;
  }
  o8x(doUpdate, doRender) {
    if (doRender) {
      if (this.z8u_1) {
        this.z8u_1 = false;
        this.p8w().l6u();
      }
      if (this.s8u_1) {
        this.s8u_1 = false;
        this.p8w().k6u().h6z(this.t8u_1, this.u8u_1, this.v8u_1, this.w8u_1);
        this.q8x(this.t8u_1, this.u8u_1, this.v8u_1, this.w8u_1);
      }
    }
    if (this.x8u_1) {
      this.x8u_1 = false;
      println('---------------- Trigger AG.initialized ag.mainFrameBuffer.setSize (' + this.x2p() + ', ' + this.y2p() + ') --------------');
      // Inline function 'korlibs.event.reset' call
      var this_0 = this.p8t_1;
      this_0.e6m_1 = false;
      // Inline function 'korlibs.event.reset.<anonymous>' call
      this.w6l(this_0);
    }
    try {
      this.r8x(doUpdate, doRender);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        println('ERROR GameWindow.frameRender:');
        println(e);
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
  }
  o6u() {
    this.a8v_1 = 0;
  }
  s8x() {
    this.a8v_1 = this.a8v_1 + 1 | 0;
  }
  p8x(startTime) {
    var tmp = this;
    // Inline function 'korlibs.time.fastMeasureTime' call
    var stopwatch = new Stopwatch();
    // Inline function 'korlibs.render.GameWindow.frameUpdate.<anonymous>' call
    this.t8x();
    tmp.b8v_1 = stopwatch.q6j();
    try {
      var now = PerformanceCounter_getInstance().k6j();
      var consumed = minus(now, startTime);
      var tmp0_elvis_lhs = this.q8w().k8w_1;
      var tmp_0;
      var tmp_1 = tmp0_elvis_lhs;
      if ((tmp_1 == null ? null : new Duration(tmp_1)) == null) {
        tmp_0 = Duration__times_impl_sfuzvp(this.u8w(), 10);
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var timeForTasks = tmp_0;
      // Inline function 'korlibs.time.milliseconds' call
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance();
      var tmp$ret$2 = toDuration(4, DurationUnit_MILLISECONDS_getInstance());
      var finalTimeForTasks = max(timeForTasks, tmp$ret$2);
      this.q8w().u8x(finalTimeForTasks);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        println('ERROR GameWindow.frameRender:');
        println(e);
      } else {
        throw $p;
      }
    }
  }
  t8x() {
  }
  r8x(update, render) {
    // Inline function 'korlibs.render.GameWindow.updateRenderLock' call
    // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
    var this_0 = this.c8v_1;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
      this_0.b20();
      try {
        // Inline function 'korlibs.event.reset' call
        var this_1 = this.o8t_1;
        this_1.e6m_1 = false;
        // Inline function 'korlibs.render.GameWindow.dispatchRenderEvent.<anonymous>.<anonymous>' call
        this_1.m6m_1 = update;
        this_1.n6m_1 = render;
        this.w6l(this_1);
        break $l$block;
      }finally {
        this_0.d20();
      }
    }
  }
  v8x(type, files) {
    // Inline function 'korlibs.event.reset' call
    var this_0 = this.w8t_1;
    this_0.e6m_1 = false;
    // Inline function 'korlibs.render.GameWindow.dispatchDropfileEvent.<anonymous>' call
    this_0.z6o_1 = type;
    this_0.a6p_1 = files;
    return this.w6l(this_0);
  }
  q8x(x, y, width, height) {
    this.w8x(x, y, width, height, width, height);
  }
  w8x(x, y, width, height, fullWidth, fullHeight) {
    this.p8w().k6u().i6z(x, y, width, height, fullWidth, fullHeight);
    // Inline function 'korlibs.event.reset' call
    var this_0 = this.s8t_1;
    this_0.e6m_1 = false;
    // Inline function 'korlibs.render.GameWindow.dispatchReshapeEventEx.<anonymous>' call
    this_0.v6m_1 = x;
    this_0.w6m_1 = y;
    this_0.x6m_1 = width;
    this_0.y6m_1 = height;
    this.w6l(this_0);
  }
  d6r() {
    this.j8v_1.d6r();
  }
  p6r(info) {
    this.j8v_1.p6r(info);
  }
  r6r(out) {
    return this.j8v_1.r6r(out);
  }
  x8x(out, $super) {
    out = out === VOID ? IntArrayList.g2s() : out;
    return $super === VOID ? this.r6r(out) : $super.r6r.call(this, out);
  }
  y8x(data, $completion) {
  }
  r10(_set____db54di) {
    this.d8t_1.r10(_set____db54di);
  }
  s10() {
    return this.d8t_1.s10();
  }
}
class Companion_60 {
  constructor() {
    Companion_instance_69 = this;
    this.z8x_1 = new GameWindowCreationConfig();
  }
}
class GameWindowCreationConfig {
  constructor(multithreaded, hdr, msaa, checkGl, logGl, cacheGl, fullscreen, decorated, transparent, resizable, title) {
    Companion_getInstance_75();
    multithreaded = multithreaded === VOID ? null : multithreaded;
    hdr = hdr === VOID ? null : hdr;
    msaa = msaa === VOID ? null : msaa;
    checkGl = checkGl === VOID ? false : checkGl;
    logGl = logGl === VOID ? false : logGl;
    cacheGl = cacheGl === VOID ? false : cacheGl;
    fullscreen = fullscreen === VOID ? null : fullscreen;
    decorated = decorated === VOID ? true : decorated;
    transparent = transparent === VOID ? false : transparent;
    resizable = resizable === VOID ? true : resizable;
    title = title === VOID ? '' : title;
    this.a8y_1 = multithreaded;
    this.b8y_1 = hdr;
    this.c8y_1 = msaa;
    this.d8y_1 = checkGl;
    this.e8y_1 = logGl;
    this.f8y_1 = cacheGl;
    this.g8y_1 = fullscreen;
    this.h8y_1 = decorated;
    this.i8y_1 = transparent;
    this.j8y_1 = resizable;
    this.k8y_1 = title;
  }
  l8y(multithreaded, hdr, msaa, checkGl, logGl, cacheGl, fullscreen, decorated, transparent, resizable, title) {
    return new GameWindowCreationConfig(multithreaded, hdr, msaa, checkGl, logGl, cacheGl, fullscreen, decorated, transparent, resizable, title);
  }
  m8y(multithreaded, hdr, msaa, checkGl, logGl, cacheGl, fullscreen, decorated, transparent, resizable, title, $super) {
    multithreaded = multithreaded === VOID ? this.a8y_1 : multithreaded;
    hdr = hdr === VOID ? this.b8y_1 : hdr;
    msaa = msaa === VOID ? this.c8y_1 : msaa;
    checkGl = checkGl === VOID ? this.d8y_1 : checkGl;
    logGl = logGl === VOID ? this.e8y_1 : logGl;
    cacheGl = cacheGl === VOID ? this.f8y_1 : cacheGl;
    fullscreen = fullscreen === VOID ? this.g8y_1 : fullscreen;
    decorated = decorated === VOID ? this.h8y_1 : decorated;
    transparent = transparent === VOID ? this.i8y_1 : transparent;
    resizable = resizable === VOID ? this.j8y_1 : resizable;
    title = title === VOID ? this.k8y_1 : title;
    return $super === VOID ? this.l8y(multithreaded, hdr, msaa, checkGl, logGl, cacheGl, fullscreen, decorated, transparent, resizable, title) : $super.l8y.call(this, multithreaded, hdr, msaa, checkGl, logGl, cacheGl, fullscreen, decorated, transparent, resizable, title);
  }
  toString() {
    return 'GameWindowCreationConfig(multithreaded=' + this.a8y_1 + ', hdr=' + this.b8y_1 + ', msaa=' + this.c8y_1 + ', checkGl=' + this.d8y_1 + ', logGl=' + this.e8y_1 + ', cacheGl=' + this.f8y_1 + ', fullscreen=' + this.g8y_1 + ', decorated=' + this.h8y_1 + ', transparent=' + this.i8y_1 + ', resizable=' + this.j8y_1 + ', title=' + this.k8y_1 + ')';
  }
  hashCode() {
    var result = this.a8y_1 == null ? 0 : getBooleanHashCode(this.a8y_1);
    result = imul(result, 31) + (this.b8y_1 == null ? 0 : getBooleanHashCode(this.b8y_1)) | 0;
    result = imul(result, 31) + (this.c8y_1 == null ? 0 : this.c8y_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.d8y_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.e8y_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.f8y_1) | 0;
    result = imul(result, 31) + (this.g8y_1 == null ? 0 : getBooleanHashCode(this.g8y_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.h8y_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.i8y_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.j8y_1) | 0;
    result = imul(result, 31) + getStringHashCode(this.k8y_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GameWindowCreationConfig))
      return false;
    var tmp0_other_with_cast = other instanceof GameWindowCreationConfig ? other : THROW_CCE();
    if (!(this.a8y_1 == tmp0_other_with_cast.a8y_1))
      return false;
    if (!(this.b8y_1 == tmp0_other_with_cast.b8y_1))
      return false;
    if (!(this.c8y_1 == tmp0_other_with_cast.c8y_1))
      return false;
    if (!(this.d8y_1 === tmp0_other_with_cast.d8y_1))
      return false;
    if (!(this.e8y_1 === tmp0_other_with_cast.e8y_1))
      return false;
    if (!(this.f8y_1 === tmp0_other_with_cast.f8y_1))
      return false;
    if (!(this.g8y_1 == tmp0_other_with_cast.g8y_1))
      return false;
    if (!(this.h8y_1 === tmp0_other_with_cast.h8y_1))
      return false;
    if (!(this.i8y_1 === tmp0_other_with_cast.i8y_1))
      return false;
    if (!(this.j8y_1 === tmp0_other_with_cast.j8y_1))
      return false;
    if (!(this.k8y_1 === tmp0_other_with_cast.k8y_1))
      return false;
    return true;
  }
}
class TextClipboardData {
  constructor(text, contentType) {
    contentType = contentType === VOID ? null : contentType;
    this.n8y_1 = text;
    this.o8y_1 = contentType;
  }
  toString() {
    return 'TextClipboardData(text=' + this.n8y_1 + ', contentType=' + this.o8y_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.n8y_1);
    result = imul(result, 31) + (this.o8y_1 == null ? 0 : getStringHashCode(this.o8y_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TextClipboardData))
      return false;
    var tmp0_other_with_cast = other instanceof TextClipboardData ? other : THROW_CCE();
    if (!(this.n8y_1 === tmp0_other_with_cast.n8y_1))
      return false;
    if (!(this.o8y_1 == tmp0_other_with_cast.o8y_1))
      return false;
    return true;
  }
}
class TimedTask_0 {
  constructor(time, continuation, callback) {
    this.p8y_1 = time;
    this.q8y_1 = continuation;
    this.r8y_1 = callback;
    this.s8y_1 = null;
  }
}
class Companion_61 {
  constructor() {
    Companion_instance_70 = this;
    this.t8y_1 = Companion_getInstance_1().iz('GameWindow');
  }
}
class sam$kotlinx_coroutines_DisposableHandle$0_0 {
  constructor(function_0) {
    this.u8y_1 = function_0;
  }
  d1b() {
    return this.u8y_1();
  }
  s4() {
    return this.u8y_1;
  }
  equals(other) {
    var tmp;
    if (!(other == null) ? isInterface(other, DisposableHandle) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.s4(), other.s4());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return hashCode(this.s4());
  }
}
class GameWindowCoroutineDispatcher extends CoroutineDispatcher {
  static m8w(nowProvider, fast) {
    Companion_getInstance_76();
    var tmp;
    if (nowProvider === VOID) {
      tmp = GameWindowCoroutineDispatcher$_init_$lambda_ooms1e;
    } else {
      tmp = nowProvider;
    }
    nowProvider = tmp;
    fast = fast === VOID ? false : fast;
    var $this = this.g1e();
    $this.d8w_1 = nowProvider;
    $this.e8w_1 = fast;
    $this.f8w_1 = new TGenQueue();
    var tmp_0 = $this;
    var tmp_1 = Companion_instance_0;
    tmp_0.g8w_1 = tmp_1.n2y(VOID, GameWindowCoroutineDispatcher$timedTasks$lambda);
    $this.h8w_1 = new NonRecursiveLock();
    $this.i8w_1 = get_fastMilliseconds_0(0);
    $this.j8w_1 = get_fastMilliseconds_0(0);
    $this.k8w_1 = null;
    $this.l8w_1 = Companion_getInstance_1().iz('Korgw.GameWindow.TooManyCallbacks');
    return $this;
  }
  j1e(context, block) {
    return this.i1e(context, block);
  }
  v8y(block) {
    if (block == null)
      return Unit_instance;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.h8w_1.w1z_1;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
    this.f8w_1.x2y(block);
  }
  i1e(context, block) {
    return this.v8y(block);
  }
  w8y() {
    return this.d8w_1().n1z_1;
  }
  u1e(timeMillis, continuation) {
    // Inline function 'korlibs.time.milliseconds' call
    var this_0 = timeMillis.r4();
    var tmp$ret$0 = toDuration(this_0, DurationUnit_MILLISECONDS_getInstance());
    this.x8y(tmp$ret$0, continuation);
  }
  x8y(time, continuation) {
    var task = new TimedTask_0(FastDuration__plus_impl_q1enab_0(this.w8y(), time), continuation, null);
    continuation.r1a(GameWindowCoroutineDispatcher$scheduleResumeAfterDelay$lambda(task));
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.h8w_1.w1z_1;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
    // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.scheduleResumeAfterDelay.<anonymous>' call
    this.g8w_1.j2u(task);
  }
  v1e(timeMillis, block, context) {
    var tmp = this.w8y();
    // Inline function 'korlibs.time.milliseconds' call
    var this_0 = timeMillis.r4();
    var tmp$ret$0 = toDuration(this_0, DurationUnit_MILLISECONDS_getInstance());
    var task = new TimedTask_0(FastDuration__plus_impl_q1enab_0(tmp, tmp$ret$0), null, block);
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this.h8w_1.w1z_1;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
    // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.invokeOnTimeout.<anonymous>' call
    this.g8w_1.j2u(task);
    var tmp_0 = GameWindowCoroutineDispatcher$invokeOnTimeout$lambda(this, task);
    return new sam$kotlinx_coroutines_DisposableHandle$0_0(tmp_0);
  }
  u8x(availableTime) {
    this.y8y(get_fast(availableTime));
  }
  y8y(availableTime) {
    try {
      var startTime = this.w8y();
      var processedTimedTasks = 0;
      var processedTasks = 0;
      var tmp = this;
      // Inline function 'korlibs.time.fastMeasureTime' call
      var stopwatch = new Stopwatch();
      // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.executePending.<anonymous>' call
      $l$loop_0: while (true) {
        // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
        // Inline function 'kotlinx.atomicfu.locks.synchronized' call
        this.h8w_1.w1z_1;
        // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
        // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.executePending.<anonymous>.<anonymous>' call
        var tmp_0;
        var tmp_1;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.g8w_1.g1()) {
          tmp_1 = this.e8w_1 || FastDuration__compareTo_impl_4fhnj7(startTime, this.g8w_1.t2y().p8y_1) >= 0;
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp_0 = this.g8w_1.u2y();
        } else {
          tmp_0 = null;
        }
        var tmp0_elvis_lhs = tmp_0;
        var tmp_2;
        if (tmp0_elvis_lhs == null) {
          break $l$loop_0;
        } else {
          tmp_2 = tmp0_elvis_lhs;
        }
        var item = tmp_2;
        try {
          if (!(item.s8y_1 == null)) {
            var tmp1_safe_receiver = item.q8y_1;
            if (tmp1_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.coroutines.resumeWithException' call
              // Inline function 'kotlin.Companion.failure' call
              var exception = ensureNotNull(item.s8y_1);
              var tmp$ret$5 = _Result___init__impl__xyqfz8(createFailure(exception));
              tmp1_safe_receiver.ed(tmp$ret$5);
            }
            if (!(item.r8y_1 == null)) {
              var tmp2_safe_receiver = item.s8y_1;
              if (tmp2_safe_receiver == null)
                null;
              else {
                printStackTrace(tmp2_safe_receiver);
              }
            }
          } else {
            var tmp3_safe_receiver = item.q8y_1;
            if (tmp3_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.coroutines.resume' call
              // Inline function 'kotlin.Companion.success' call
              var tmp$ret$7 = _Result___init__impl__xyqfz8(Unit_instance);
              tmp3_safe_receiver.ed(tmp$ret$7);
            }
            var tmp4_safe_receiver = item.r8y_1;
            if (tmp4_safe_receiver == null)
              null;
            else {
              tmp4_safe_receiver.e1d();
            }
          }
        } catch ($p) {
          if ($p instanceof Error) {
            var e = $p;
            printStackTrace(e);
          } else {
            throw $p;
          }
        }
        finally {
          processedTimedTasks = processedTimedTasks + 1 | 0;
        }
        var elapsedTime = FastDuration__minus_impl_evs237(this.w8y(), startTime);
        if (FastDuration__compareTo_impl_4fhnj7(elapsedTime, availableTime) >= 0) {
          this.z8y(elapsedTime, availableTime, processedTimedTasks, processedTasks);
          break $l$loop_0;
        }
      }
      tmp.i8w_1 = stopwatch.q6j();
      var tmp_3 = this;
      // Inline function 'korlibs.time.fastMeasureTime' call
      var stopwatch_0 = new Stopwatch();
      // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.executePending.<anonymous>' call
      $l$loop_2: while (true) {
        // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
        // Inline function 'kotlinx.atomicfu.locks.synchronized' call
        this.h8w_1.w1z_1;
        // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
        // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.executePending.<anonymous>.<anonymous>' call
        var tmp_4;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.f8w_1.g1()) {
          tmp_4 = this.f8w_1.y2y();
        } else {
          tmp_4 = null;
        }
        var tmp0_elvis_lhs_0 = tmp_4;
        var tmp_5;
        if (tmp0_elvis_lhs_0 == null) {
          break $l$loop_2;
        } else {
          tmp_5 = tmp0_elvis_lhs_0;
        }
        var task = tmp_5;
        // Inline function 'korlibs.time.fastMeasureTime' call
        var stopwatch_1 = new Stopwatch();
        // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.executePending.<anonymous>.<anonymous>' call
        try {
          task.e1d();
        } catch ($p) {
          if ($p instanceof Error) {
            var e_0 = $p;
            printStackTrace(e_0);
          } else {
            throw $p;
          }
        }
        finally {
          processedTasks = processedTasks + 1 | 0;
        }
        var time = stopwatch_1.q6j();
        var elapsed = FastDuration__minus_impl_evs237(this.w8y(), startTime);
        if (FastDuration__compareTo_impl_4fhnj7(elapsed, availableTime) >= 0) {
          this.z8y(elapsed, availableTime, processedTimedTasks, processedTasks);
          break $l$loop_2;
        }
      }
      tmp_3.j8w_1 = stopwatch_0.q6j();
    } catch ($p) {
      if ($p instanceof Error) {
        var e_1 = $p;
        println('Error in GameWindowCoroutineDispatcher.executePending:');
        printStackTrace(e_1);
      } else {
        throw $p;
      }
    }
  }
  z8y(elapsedTime, availableTime, processedTimedTasks, processedTasks) {
    // Inline function 'korlibs.logger.Logger.warn' call
    var this_0 = this.l8w_1;
    var level = Level_WARN_getInstance();
    var tmp;
    if (this_0.q31(level)) {
      // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.informTooManyCallbacksToHandleInThisFrame.<anonymous>' call
      var tmp$ret$0 = 'Too many callbacks to handle in this frame elapsedTime=' + FastDuration__toString_impl_c9xohb(roundMilliseconds(elapsedTime)) + ', availableTime=' + FastDuration__toString_impl_c9xohb(roundMilliseconds(availableTime)) + ' pending timedTasks=' + this.g8w_1.q2y_1 + ', tasks=' + this.f8w_1.e1() + ', processedTimedTasks=' + processedTimedTasks + ', processedTasks=' + processedTasks;
      this_0.r31(level, tmp$ret$0);
      tmp = Unit_instance;
    }
  }
  t6() {
    // Inline function 'korlibs.time.seconds' call
    // Inline function 'korlibs.time.seconds' call
    var tmp$ret$1 = toDuration(2, DurationUnit_SECONDS_getInstance());
    this.u8x(tmp$ret$1);
    // Inline function 'korlibs.logger.Logger.info' call
    var this_0 = Companion_getInstance_76().t8y_1;
    var level = Level_INFO_getInstance();
    var tmp;
    if (this_0.q31(level)) {
      // Inline function 'korlibs.render.GameWindowCoroutineDispatcher.close.<anonymous>' call
      var tmp$ret$2 = 'GameWindowCoroutineDispatcher.close';
      this_0.r31(level, tmp$ret$2);
      tmp = Unit_instance;
    }
    $l$loop: while (true) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!!this.g8w_1.g1()) {
        break $l$loop;
      }
      var tmp0_safe_receiver = this.g8w_1.u2y().q8y_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.coroutines.resume' call
        // Inline function 'kotlin.Companion.success' call
        var tmp$ret$5 = _Result___init__impl__xyqfz8(Unit_instance);
        tmp0_safe_receiver.ed(tmp$ret$5);
      }
    }
    $l$loop_0: while (true) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!!this.f8w_1.g1()) {
        break $l$loop_0;
      }
      this.f8w_1.y2y().e1d();
    }
  }
  toString() {
    return 'GameWindowCoroutineDispatcher(setNow=setNow, fast=' + this.e8w_1 + ')';
  }
}
class SyncEventLoopCoroutineDispatcher extends CoroutineDispatcher {
  static a8z(eventLoop) {
    var $this = this.g1e();
    $this.a8w_1 = eventLoop;
    return $this;
  }
  static b8w(immediateRun) {
    immediateRun = immediateRun === VOID ? false : immediateRun;
    return this.a8z(new SyncEventLoop(immediateRun));
  }
  t6() {
    this.a8w_1.t6();
  }
  i1e(context, block) {
    this.a8w_1.r6k(SyncEventLoopCoroutineDispatcher$dispatch$lambda(block));
  }
  u1e(timeMillis, continuation) {
    var cancelled = {_v: null};
    continuation.r1a(SyncEventLoopCoroutineDispatcher$scheduleResumeAfterDelay$lambda(cancelled));
    // Inline function 'korlibs.time.milliseconds' call
    var tmp = toDuration_0(timeMillis, DurationUnit_MILLISECONDS_getInstance());
    this.a8w_1.s6k(tmp, SyncEventLoopCoroutineDispatcher$scheduleResumeAfterDelay$lambda_0(cancelled, continuation));
  }
  v1e(timeMillis, block, context) {
    // Inline function 'korlibs.time.milliseconds' call
    var tmp = toDuration_0(timeMillis, DurationUnit_MILLISECONDS_getInstance());
    return toDisposable(this.a8w_1.s6k(tmp, SyncEventLoopCoroutineDispatcher$invokeOnTimeout$lambda(block)));
  }
}
class Companion_62 {}
class UpdateEvent extends Event {
  constructor(fastDeltaTime) {
    fastDeltaTime = fastDeltaTime === VOID ? Companion_instance_3.k1z() : fastDeltaTime;
    super();
    this.d8z_1 = fastDeltaTime;
  }
  e8z() {
    return toDuration_1(this.d8z_1);
  }
  i2h() {
    return Companion_instance_71;
  }
  toString() {
    return 'UpdateEvent(time=' + FastDuration__toString_impl_c9xohb(this.d8z_1) + ')';
  }
}
class Companion_63 {
  constructor() {
    this.f8z_1 = 536805376;
    this.g8z_1 = 805240832;
    this.h8z_1 = 2;
    this.i8z_1 = 32;
    this.j8z_1 = 256;
    this.k8z_1 = 512;
    this.l8z_1 = 768;
    this.m8z_1 = 769;
    this.n8z_1 = 1024;
    this.o8z_1 = 1025;
    this.p8z_1 = 1026;
    this.q8z_1 = 1027;
  }
}
class SDL extends FFILib {
  static j90() {
    var $this = this.h33([get_SDLPath()]);
    var tmp = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config = Companion_getInstance_13().m33_1;
    tmp.w8z_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false))]), false), null, config, true)).a33($this, SDL_Init$factory());
    var tmp_0 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_0 = Companion_getInstance_13().m33_1;
    tmp_0.x8z_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(6), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().og(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false))]), false), null, config_0, true)).a33($this, SDL_CreateWindow$factory());
    var tmp_1 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_1 = Companion_getInstance_13().m33_1;
    tmp_1.y8z_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().og(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_1, true)).a33($this, SDL_SetWindowTitle$factory());
    var tmp_2 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_2 = Companion_getInstance_13().m33_1;
    tmp_2.z8z_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_2, true)).a33($this, SDL_SetWindowSize$factory());
    var tmp_3 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_3 = Companion_getInstance_13().m33_1;
    tmp_3.a90_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_3, true)).a33($this, SDL_SetWindowPosition$factory());
    var tmp_4 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_4 = Companion_getInstance_13().m33_1;
    tmp_4.b90_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_4, true)).a33($this, SDL_ShowWindow$factory());
    var tmp_5 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_5 = Companion_getInstance_13().m33_1;
    tmp_5.c90_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_5, true)).a33($this, SDL_RaiseWindow$factory());
    var tmp_6 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_6 = Companion_getInstance_13().m33_1;
    tmp_6.d90_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().hg(), arrayOf([]), false))]), false), null, config_6, true)).a33($this, SDL_PollEvent$factory());
    var tmp_7 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_7 = Companion_getInstance_13().m33_1;
    tmp_7.e90_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(0), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_7, true)).a33($this, SDL_Quit$factory());
    var tmp_8 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_8 = Companion_getInstance_13().m33_1;
    tmp_8.f90_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false))]), false), null, config_8, true)).a33($this, SDL_GL_CreateContext$factory());
    var tmp_9 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_9 = Companion_getInstance_13().m33_1;
    tmp_9.g90_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_9, true)).a33($this, SDL_GL_DeleteContext$factory());
    var tmp_10 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_10 = Companion_getInstance_13().m33_1;
    tmp_10.h90_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false))]), false), null, config_10, true)).a33($this, SDL_GL_MakeCurrent$factory());
    var tmp_11 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_11 = Companion_getInstance_13().m33_1;
    tmp_11.i90_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_11, true)).a33($this, SDL_GL_SwapWindow$factory());
    return $this;
  }
  k90() {
    return this.w8z_1.xo(this, SDL_Init$factory_0());
  }
  l90() {
    return this.x8z_1.xo(this, SDL_CreateWindow$factory_0());
  }
  m90() {
    return this.y8z_1.xo(this, SDL_SetWindowTitle$factory_0());
  }
  n90() {
    return this.z8z_1.xo(this, SDL_SetWindowSize$factory_0());
  }
  o90() {
    return this.a90_1.xo(this, SDL_SetWindowPosition$factory_0());
  }
  p90() {
    return this.b90_1.xo(this, SDL_ShowWindow$factory_0());
  }
  q90() {
    return this.c90_1.xo(this, SDL_RaiseWindow$factory_0());
  }
  r90() {
    return this.d90_1.xo(this, SDL_PollEvent$factory_0());
  }
  s90() {
    return this.e90_1.xo(this, SDL_Quit$factory_0());
  }
  t90() {
    return this.f90_1.xo(this, SDL_GL_CreateContext$factory_0());
  }
  u90() {
    return this.g90_1.xo(this, SDL_GL_DeleteContext$factory_0());
  }
  v90() {
    return this.h90_1.xo(this, SDL_GL_MakeCurrent$factory_0());
  }
  w90() {
    return this.i90_1.xo(this, SDL_GL_SwapWindow$factory_0());
  }
}
class KmlGlOpenGL extends KmlGl {
  constructor(gl) {
    gl = gl === VOID ? OpenGL.a97() : gl;
    super();
    this.f97_1 = gl;
  }
  g97(_this__u8e3s4) {
    return CreateFFIPointer(toLong(_this__u8e3s4));
  }
  h97(_this__u8e3s4) {
    return CreateFFIPointer(_this__u8e3s4);
  }
  h7j(texture) {
    return this.f97_1.i97()(texture);
  }
  n7n(program, shader) {
    return this.f97_1.j97()(program, shader);
  }
  m7n(program, index, name) {
    return this.f97_1.k97()(program, index, name);
  }
  b7i(target, buffer) {
    return this.f97_1.l97()(target, buffer);
  }
  f7m(target, framebuffer) {
    return this.f97_1.m97()(target, framebuffer);
  }
  m7m(target, renderbuffer) {
    return this.f97_1.n97()(target, renderbuffer);
  }
  d7m(target, texture) {
    return this.f97_1.o97()(target, texture);
  }
  p7k(modeRGB, modeAlpha) {
    return this.f97_1.p97()(modeRGB, modeAlpha);
  }
  q7k(sfactorRGB, dfactorRGB, sfactorAlpha, dfactorAlpha) {
    return this.f97_1.q97()(sfactorRGB, dfactorRGB, sfactorAlpha, dfactorAlpha);
  }
  l7j(target, size, data, usage) {
    return this.f97_1.r97()(target, this.g97(size), get_pointer_0(data), usage);
  }
  k7j(target, offset, size, data) {
    return this.f97_1.s97()(target, this.g97(offset), this.g97(size), get_pointer_0(data));
  }
  l7k(mask) {
    return this.f97_1.t97()(mask);
  }
  g7k(red, green, blue, alpha) {
    return this.f97_1.u97()(red, green, blue, alpha);
  }
  i7k(d) {
    return this.f97_1.v97()(d);
  }
  k7k(s) {
    return this.f97_1.w97()(s);
  }
  t7m(red, green, blue, alpha) {
    var tmp = this.f97_1.x97();
    // Inline function 'korlibs.math.toInt' call
    var tmp_0 = red ? 1 : 0;
    // Inline function 'korlibs.math.toInt' call
    var tmp_1 = green ? 1 : 0;
    // Inline function 'korlibs.math.toInt' call
    var tmp_2 = blue ? 1 : 0;
    // Inline function 'korlibs.math.toInt' call
    return tmp(tmp_0, tmp_1, tmp_2, alpha ? 1 : 0);
  }
  e7n(shader) {
    return this.f97_1.y97()(shader);
  }
  g7n() {
    return this.f97_1.z97()();
  }
  c7n(type) {
    return this.f97_1.a98()(type);
  }
  i7l(mode) {
    return this.f97_1.b98()(mode);
  }
  k8c(n, items) {
    return this.f97_1.c98()(n, get_pointer_0(items));
  }
  l8c(n, items) {
    return this.f97_1.d98()(n, get_pointer_0(items));
  }
  b7n(program) {
    return this.f97_1.e98()(program);
  }
  m8c(n, items) {
    return this.f97_1.f98()(n, get_pointer_0(items));
  }
  a7n(shader) {
    return this.f97_1.g98()(shader);
  }
  n8c(n, items) {
    return this.f97_1.h98()(n, get_pointer_0(items));
  }
  s7m(func) {
    return this.f97_1.i98()(func);
  }
  h7k(flag) {
    var tmp = this.f97_1.j98();
    // Inline function 'korlibs.math.toInt' call
    return tmp(flag ? 1 : 0);
  }
  r7m(n, f) {
    return this.f97_1.k98()(n, f);
  }
  u7k(cap) {
    return this.f97_1.l98()(cap);
  }
  k7l(index) {
    return this.f97_1.m98()(index);
  }
  b7l(mode, first, count) {
    return this.f97_1.n98()(mode, first, count);
  }
  d7l(mode, count, type, indices) {
    return this.f97_1.o98()(mode, count, type, this.g97(indices));
  }
  v7k(cap) {
    return this.f97_1.p98()(cap);
  }
  o7l(index) {
    return this.f97_1.q98()(index);
  }
  bd() {
    return this.f97_1.r98()();
  }
  p7m(target, attachment, renderbuffertarget, renderbuffer) {
    return this.f97_1.s98()(target, attachment, renderbuffertarget, renderbuffer);
  }
  o7m(target, attachment, textarget, texture, level) {
    return this.f97_1.t98()(target, attachment, textarget, texture, level);
  }
  q7m(mode) {
    return this.f97_1.u98()(mode);
  }
  o8c(n, buffers) {
    return this.f97_1.v98()(n, get_pointer_0(buffers));
  }
  p7j(target) {
    return this.f97_1.w98()(target);
  }
  p8c(n, framebuffers) {
    return this.f97_1.x98()(n, get_pointer_0(framebuffers));
  }
  q8c(n, renderbuffers) {
    return this.f97_1.y98()(n, get_pointer_0(renderbuffers));
  }
  r8c(n, textures) {
    return this.f97_1.z98()(n, get_pointer_0(textures));
  }
  y7m(program, name) {
    return this.f97_1.a99()(program, name);
  }
  f7n() {
    return this.f97_1.b99()();
  }
  s8c(pname, data) {
    return this.f97_1.c99()(pname, get_pointer_0(data));
  }
  t8c(program, pname, params) {
    return this.f97_1.d99()(program, pname, get_pointer_0(params));
  }
  u8c(shader, pname, params) {
    return this.f97_1.e99()(shader, pname, get_pointer_0(params));
  }
  v8c(shader, bufSize, length, infoLog) {
    this.f97_1.f99()(shader, bufSize, get_pointer_0(length), get_pointer_0(infoLog));
  }
  w7f(name) {
    var tmp0_elvis_lhs = this.f97_1.g99()(name);
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  }
  o7n(program) {
    return this.f97_1.h99()(program);
  }
  m7j(pname, param) {
    return this.f97_1.i99()(pname, param);
  }
  c7m(x, y, width, height, format, type, pixels) {
    return this.f97_1.j99()(x, y, width, height, format, type, get_pointer_0(pixels));
  }
  n7m(target, internalformat, width, height) {
    return this.f97_1.k99()(target, internalformat, width, height);
  }
  u7m(x, y, width, height) {
    return this.f97_1.l99()(x, y, width, height);
  }
  d7n(shader, string) {
    // Inline function 'korlibs.ffi.usePointer' call
    var this_0 = CreateFFIMemory(8);
    var lengthsPtr = get_pointer(Deno.UnsafePointer.of(this_0));
    var bytes = encodeToByteArray(string + '\x00');
    set32(lengthsPtr, bytes.length - 1 | 0);
    // Inline function 'korlibs.ffi.usePointer' call
    var this_1 = CreateFFIMemory_0(bytes);
    var strPtr = get_pointer(Deno.UnsafePointer.of(this_1));
    // Inline function 'korlibs.ffi.usePointer' call
    var this_2 = CreateFFIMemory(8);
    var strPtrPtr = get_pointer(Deno.UnsafePointer.of(this_2));
    setFFIPointer(strPtrPtr, strPtr);
    this.f97_1.m99()(shader, 1, strPtrPtr, lengthsPtr);
  }
  x7k(func, ref, mask) {
    return this.f97_1.n99()(func, ref, mask);
  }
  w7k(face, func, ref, mask) {
    return this.f97_1.o99()(face, func, ref, mask);
  }
  j7k(mask) {
    return this.f97_1.p99()(mask);
  }
  a7l(face, mask) {
    return this.f97_1.q99()(face, mask);
  }
  z7k(fail, zfail, zpass) {
    return this.f97_1.r99()(fail, zfail, zpass);
  }
  y7k(face, sfail, dpfail, dppass) {
    return this.f97_1.s99()(face, sfail, dpfail, dppass);
  }
  n7j(target, level, internalformat, width, height, border, format, type, pixels) {
    var tmp = this.f97_1.t99();
    tmp(target, level, internalformat, width, height, border, format, type, pixels == null ? null : get_pointer_0(pixels));
  }
  g7j(target, pname, param) {
    return this.f97_1.u99()(target, pname, param);
  }
  c7j(location, count, value) {
    return this.f97_1.v99()(location, count, get_pointer_0(value));
  }
  a7h(location, v0) {
    return this.f97_1.w99()(location, v0);
  }
  v7i(location, count, value) {
    return this.f97_1.x99()(location, count, get_pointer_0(value));
  }
  d7j(location, count, value) {
    return this.f97_1.y99()(location, count, get_pointer_0(value));
  }
  w7i(location, count, value) {
    return this.f97_1.z99()(location, count, get_pointer_0(value));
  }
  e7j(location, count, value) {
    return this.f97_1.a9a()(location, count, get_pointer_0(value));
  }
  x7i(location, count, value) {
    return this.f97_1.b9a()(location, count, get_pointer_0(value));
  }
  f7j(location, count, value) {
    return this.f97_1.c9a()(location, count, get_pointer_0(value));
  }
  y7i(location, count, value) {
    return this.f97_1.d9a()(location, count, get_pointer_0(value));
  }
  z7i(location, count, transpose, value) {
    var tmp = this.f97_1.e9a();
    // Inline function 'korlibs.math.toInt' call
    return tmp(location, count, transpose ? 1 : 0, get_pointer_0(value));
  }
  a7j(location, count, transpose, value) {
    var tmp = this.f97_1.f9a();
    // Inline function 'korlibs.math.toInt' call
    return tmp(location, count, transpose ? 1 : 0, get_pointer_0(value));
  }
  b7j(location, count, transpose, value) {
    var tmp = this.f97_1.g9a();
    // Inline function 'korlibs.math.toInt' call
    return tmp(location, count, transpose ? 1 : 0, get_pointer_0(value));
  }
  z7m(program) {
    return this.f97_1.h9a()(program);
  }
  p7l(index, size, type, normalized, stride, pointer) {
    var tmp = this.f97_1.i9a();
    // Inline function 'korlibs.math.toInt' call
    return tmp(index, size, type, normalized ? 1 : 0, stride, this.h97(pointer));
  }
  e7m(x, y, width, height) {
    return this.f97_1.j9a()(x, y, width, height);
  }
  c7l(mode, first, count, instancecount) {
    return this.f97_1.k9a()(mode, first, count, instancecount);
  }
  e7l(mode, count, type, indices, instancecount) {
    return this.f97_1.l9a()(mode, count, type, this.g97(indices), instancecount);
  }
  j7l(index, divisor) {
    return this.f97_1.m9a()(index, divisor);
  }
  t6u() {
    return true;
  }
  w7l(target, index, buffer, offset, size) {
    return this.f97_1.n9a()(target, index, buffer, this.g97(offset), this.g97(size));
  }
  b7h(program, name) {
    return this.f97_1.o9a()(program, name);
  }
  c7h(program, uniformBlockIndex, uniformBlockBinding) {
    return this.f97_1.p9a()(program, uniformBlockIndex, uniformBlockBinding);
  }
  u6u() {
    return true;
  }
  w8c(n, arrays) {
    return this.f97_1.q9a()(n, get_pointer_0(arrays));
  }
  l7l(array) {
    return this.f97_1.r9a()(array);
  }
}
class Companion_64 {
  constructor() {
    this.s9a_1 = 16384;
  }
}
class OpenGL extends FFILib {
  static a97() {
    var $this = this.h33(['/System/Library/Frameworks/OpenGL.framework/OpenGL']);
    var tmp = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config = Companion_getInstance_13().m33_1;
    tmp.c91_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config, true)).a33($this, glDrawArraysInstanced$factory());
    var tmp_0 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_0 = Companion_getInstance_13().m33_1;
    tmp_0.d91_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(5), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_0, true)).a33($this, glDrawElementsInstanced$factory());
    var tmp_1 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_1 = Companion_getInstance_13().m33_1;
    tmp_1.e91_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_1, true)).a33($this, glVertexAttribDivisor$factory());
    var tmp_2 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_2 = Companion_getInstance_13().m33_1;
    tmp_2.f91_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(9), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_2, true)).a33($this, glTexSubImage2D$factory());
    var tmp_3 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_3 = Companion_getInstance_13().m33_1;
    tmp_3.g91_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(9), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_3, true)).a33($this, glTexImage2D$factory());
    var tmp_4 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_4 = Companion_getInstance_13().m33_1;
    tmp_4.h91_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_4, true)).a33($this, glTexParameteri$factory());
    var tmp_5 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_5 = Companion_getInstance_13().m33_1;
    tmp_5.i91_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().lg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_5, true)).a33($this, glTexParameterf$factory());
    var tmp_6 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_6 = Companion_getInstance_13().m33_1;
    tmp_6.j91_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_6, true)).a33($this, glTexParameterfv$factory());
    var tmp_7 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_7 = Companion_getInstance_13().m33_1;
    tmp_7.k91_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_7, true)).a33($this, glTexParameteriv$factory());
    var tmp_8 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_8 = Companion_getInstance_13().m33_1;
    tmp_8.l91_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_8, true)).a33($this, glStencilOp$factory());
    var tmp_9 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_9 = Companion_getInstance_13().m33_1;
    tmp_9.m91_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_9, true)).a33($this, glStencilMask$factory());
    var tmp_10 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_10 = Companion_getInstance_13().m33_1;
    tmp_10.n91_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(7), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_10, true)).a33($this, glReadPixels$factory());
    var tmp_11 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_11 = Companion_getInstance_13().m33_1;
    tmp_11.o91_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_11, true)).a33($this, glStencilFunc$factory());
    var tmp_12 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_12 = Companion_getInstance_13().m33_1;
    tmp_12.p91_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_12, true)).a33($this, glScissor$factory());
    var tmp_13 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_13 = Companion_getInstance_13().m33_1;
    tmp_13.q91_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().lg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().lg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_13, true)).a33($this, glPolygonOffset$factory());
    var tmp_14 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_14 = Companion_getInstance_13().m33_1;
    tmp_14.r91_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_14, true)).a33($this, glPixelStorei$factory());
    var tmp_15 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_15 = Companion_getInstance_13().m33_1;
    tmp_15.s91_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().lg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_15, true)).a33($this, glLineWidth$factory());
    var tmp_16 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_16 = Companion_getInstance_13().m33_1;
    tmp_16.t91_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_16, true)).a33($this, glGetTexParameterfv$factory());
    var tmp_17 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_17 = Companion_getInstance_13().m33_1;
    tmp_17.u91_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_17, true)).a33($this, glGetTexParameteriv$factory());
    var tmp_18 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_18 = Companion_getInstance_13().m33_1;
    tmp_18.v91_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(0), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false))]), false), null, config_18, true)).a33($this, glGetError$factory());
    var tmp_19 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_19 = Companion_getInstance_13().m33_1;
    tmp_19.w91_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_19, true)).a33($this, glGetFloatv$factory());
    var tmp_20 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_20 = Companion_getInstance_13().m33_1;
    tmp_20.x91_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_20, true)).a33($this, glGetIntegerv$factory());
    var tmp_21 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_21 = Companion_getInstance_13().m33_1;
    tmp_21.y91_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_21, true)).a33($this, glGetBooleanv$factory());
    var tmp_22 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_22 = Companion_getInstance_13().m33_1;
    tmp_22.z91_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_22, true)).a33($this, glGenTextures$factory());
    var tmp_23 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_23 = Companion_getInstance_13().m33_1;
    tmp_23.a92_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().lg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().lg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_23, true)).a33($this, glDepthRange$factory());
    var tmp_24 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_24 = Companion_getInstance_13().m33_1;
    tmp_24.b92_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().lg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().lg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_24, true)).a33($this, glDepthRangef$factory());
    var tmp_25 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_25 = Companion_getInstance_13().m33_1;
    tmp_25.c92_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().lg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_25, true)).a33($this, glClearDepth$factory());
    var tmp_26 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_26 = Companion_getInstance_13().m33_1;
    tmp_26.d92_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().lg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_26, true)).a33($this, glClearDepthf$factory());
    var tmp_27 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_27 = Companion_getInstance_13().m33_1;
    tmp_27.e92_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_27, true)).a33($this, glDrawArrays$factory());
    var tmp_28 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_28 = Companion_getInstance_13().m33_1;
    tmp_28.f92_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_28, true)).a33($this, glDrawElements$factory());
    var tmp_29 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_29 = Companion_getInstance_13().m33_1;
    tmp_29.g92_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_29, true)).a33($this, glFrontFace$factory());
    var tmp_30 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_30 = Companion_getInstance_13().m33_1;
    tmp_30.h92_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(0), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_30, true)).a33($this, glFinish$factory());
    var tmp_31 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_31 = Companion_getInstance_13().m33_1;
    tmp_31.i92_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(0), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_31, true)).a33($this, glFlush$factory());
    var tmp_32 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_32 = Companion_getInstance_13().m33_1;
    tmp_32.j92_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_32, true)).a33($this, glEnable$factory());
    var tmp_33 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_33 = Companion_getInstance_13().m33_1;
    tmp_33.k92_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false))]), false), null, config_33, true)).a33($this, glIsEnabled$factory());
    var tmp_34 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_34 = Companion_getInstance_13().m33_1;
    tmp_34.l92_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_34, true)).a33($this, glDisable$factory());
    var tmp_35 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_35 = Companion_getInstance_13().m33_1;
    tmp_35.m92_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_35, true)).a33($this, glDepthMask$factory());
    var tmp_36 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_36 = Companion_getInstance_13().m33_1;
    tmp_36.n92_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_36, true)).a33($this, glDepthFunc$factory());
    var tmp_37 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_37 = Companion_getInstance_13().m33_1;
    tmp_37.o92_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_37, true)).a33($this, glDeleteTextures$factory());
    var tmp_38 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_38 = Companion_getInstance_13().m33_1;
    tmp_38.p92_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_38, true)).a33($this, glCullFace$factory());
    var tmp_39 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_39 = Companion_getInstance_13().m33_1;
    tmp_39.q92_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(8), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_39, true)).a33($this, glCopyTexImage2D$factory());
    var tmp_40 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_40 = Companion_getInstance_13().m33_1;
    tmp_40.r92_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(8), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_40, true)).a33($this, glCopyTexSubImage2D$factory());
    var tmp_41 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_41 = Companion_getInstance_13().m33_1;
    tmp_41.s92_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_41, true)).a33($this, glColorMask$factory());
    var tmp_42 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_42 = Companion_getInstance_13().m33_1;
    tmp_42.t92_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_42, true)).a33($this, glClearStencil$factory());
    var tmp_43 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_43 = Companion_getInstance_13().m33_1;
    tmp_43.u92_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().lg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().lg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().lg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().lg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_43, true)).a33($this, glClearColor$factory());
    var tmp_44 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_44 = Companion_getInstance_13().m33_1;
    tmp_44.v92_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_44, true)).a33($this, glClear$factory());
    var tmp_45 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_45 = Companion_getInstance_13().m33_1;
    tmp_45.w92_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_45, true)).a33($this, glBindTexture$factory());
    var tmp_46 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_46 = Companion_getInstance_13().m33_1;
    tmp_46.x92_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_46, true)).a33($this, glHint$factory());
    var tmp_47 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_47 = Companion_getInstance_13().m33_1;
    tmp_47.y92_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_47, true)).a33($this, glViewport$factory());
    var tmp_48 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_48 = Companion_getInstance_13().m33_1;
    tmp_48.z92_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().og(), arrayOf([]), true))]), false), null, config_48, true)).a33($this, glGetString$factory());
    var tmp_49 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_49 = Companion_getInstance_13().m33_1;
    tmp_49.a93_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().og(), arrayOf([]), true))]), false), null, config_49, true)).a33($this, glGetStringi$factory());
    var tmp_50 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_50 = Companion_getInstance_13().m33_1;
    tmp_50.b93_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(6), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_50, true)).a33($this, glVertexAttribPointer$factory());
    var tmp_51 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_51 = Companion_getInstance_13().m33_1;
    tmp_51.c93_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_51, true)).a33($this, glVertexAttrib4fv$factory());
    var tmp_52 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_52 = Companion_getInstance_13().m33_1;
    tmp_52.d93_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_52, true)).a33($this, glActiveTexture$factory());
    var tmp_53 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_53 = Companion_getInstance_13().m33_1;
    tmp_53.e93_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_53, true)).a33($this, glAttachShader$factory());
    var tmp_54 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_54 = Companion_getInstance_13().m33_1;
    tmp_54.f93_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().og(), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_54, true)).a33($this, glBindAttribLocation$factory());
    var tmp_55 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_55 = Companion_getInstance_13().m33_1;
    tmp_55.g93_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_55, true)).a33($this, glBindBuffer$factory());
    var tmp_56 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_56 = Companion_getInstance_13().m33_1;
    tmp_56.h93_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_56, true)).a33($this, glBindFramebuffer$factory());
    var tmp_57 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_57 = Companion_getInstance_13().m33_1;
    tmp_57.i93_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_57, true)).a33($this, glBindRenderbuffer$factory());
    var tmp_58 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_58 = Companion_getInstance_13().m33_1;
    tmp_58.j93_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().lg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().lg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().lg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().lg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_58, true)).a33($this, glBlendColor$factory());
    var tmp_59 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_59 = Companion_getInstance_13().m33_1;
    tmp_59.k93_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_59, true)).a33($this, glBlendEquation$factory());
    var tmp_60 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_60 = Companion_getInstance_13().m33_1;
    tmp_60.l93_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_60, true)).a33($this, glBlendEquationSeparate$factory());
    var tmp_61 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_61 = Companion_getInstance_13().m33_1;
    tmp_61.m93_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_61, true)).a33($this, glBlendFunc$factory());
    var tmp_62 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_62 = Companion_getInstance_13().m33_1;
    tmp_62.n93_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_62, true)).a33($this, glBlendFuncSeparate$factory());
    var tmp_63 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_63 = Companion_getInstance_13().m33_1;
    tmp_63.o93_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_63, true)).a33($this, glBufferData$factory());
    var tmp_64 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_64 = Companion_getInstance_13().m33_1;
    tmp_64.p93_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_64, true)).a33($this, glBufferSubData$factory());
    var tmp_65 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_65 = Companion_getInstance_13().m33_1;
    tmp_65.q93_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false))]), false), null, config_65, true)).a33($this, glCheckFramebufferStatus$factory());
    var tmp_66 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_66 = Companion_getInstance_13().m33_1;
    tmp_66.r93_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_66, true)).a33($this, glCompileShader$factory());
    var tmp_67 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_67 = Companion_getInstance_13().m33_1;
    tmp_67.s93_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(8), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_67, true)).a33($this, glCompressedTexImage2D$factory());
    var tmp_68 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_68 = Companion_getInstance_13().m33_1;
    tmp_68.t93_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(9), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_68, true)).a33($this, glCompressedTexSubImage2D$factory());
    var tmp_69 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_69 = Companion_getInstance_13().m33_1;
    tmp_69.u93_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(0), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false))]), false), null, config_69, true)).a33($this, glCreateProgram$factory());
    var tmp_70 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_70 = Companion_getInstance_13().m33_1;
    tmp_70.v93_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false))]), false), null, config_70, true)).a33($this, glCreateShader$factory());
    var tmp_71 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_71 = Companion_getInstance_13().m33_1;
    tmp_71.w93_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_71, true)).a33($this, glDeleteBuffers$factory());
    var tmp_72 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_72 = Companion_getInstance_13().m33_1;
    tmp_72.x93_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_72, true)).a33($this, glDeleteFramebuffers$factory());
    var tmp_73 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_73 = Companion_getInstance_13().m33_1;
    tmp_73.y93_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_73, true)).a33($this, glDeleteProgram$factory());
    var tmp_74 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_74 = Companion_getInstance_13().m33_1;
    tmp_74.z93_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_74, true)).a33($this, glDeleteRenderbuffers$factory());
    var tmp_75 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_75 = Companion_getInstance_13().m33_1;
    tmp_75.a94_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_75, true)).a33($this, glDeleteShader$factory());
    var tmp_76 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_76 = Companion_getInstance_13().m33_1;
    tmp_76.b94_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_76, true)).a33($this, glDetachShader$factory());
    var tmp_77 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_77 = Companion_getInstance_13().m33_1;
    tmp_77.c94_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_77, true)).a33($this, glDisableVertexAttribArray$factory());
    var tmp_78 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_78 = Companion_getInstance_13().m33_1;
    tmp_78.d94_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_78, true)).a33($this, glEnableVertexAttribArray$factory());
    var tmp_79 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_79 = Companion_getInstance_13().m33_1;
    tmp_79.e94_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_79, true)).a33($this, glFramebufferRenderbuffer$factory());
    var tmp_80 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_80 = Companion_getInstance_13().m33_1;
    tmp_80.f94_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(5), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_80, true)).a33($this, glFramebufferTexture2D$factory());
    var tmp_81 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_81 = Companion_getInstance_13().m33_1;
    tmp_81.g94_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_81, true)).a33($this, glGenBuffers$factory());
    var tmp_82 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_82 = Companion_getInstance_13().m33_1;
    tmp_82.h94_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_82, true)).a33($this, glGenerateMipmap$factory());
    var tmp_83 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_83 = Companion_getInstance_13().m33_1;
    tmp_83.i94_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_83, true)).a33($this, glGenFramebuffers$factory());
    var tmp_84 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_84 = Companion_getInstance_13().m33_1;
    tmp_84.j94_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_84, true)).a33($this, glGenRenderbuffers$factory());
    var tmp_85 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_85 = Companion_getInstance_13().m33_1;
    tmp_85.k94_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(7), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_85, true)).a33($this, glGetActiveAttrib$factory());
    var tmp_86 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_86 = Companion_getInstance_13().m33_1;
    tmp_86.l94_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(7), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_86, true)).a33($this, glGetActiveUniform$factory());
    var tmp_87 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_87 = Companion_getInstance_13().m33_1;
    tmp_87.m94_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_87, true)).a33($this, glGetAttachedShaders$factory());
    var tmp_88 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_88 = Companion_getInstance_13().m33_1;
    tmp_88.n94_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().og(), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false))]), false), null, config_88, true)).a33($this, glGetAttribLocation$factory());
    var tmp_89 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_89 = Companion_getInstance_13().m33_1;
    tmp_89.o94_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().og(), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false))]), false), null, config_89, true)).a33($this, glGetUniformLocation$factory());
    var tmp_90 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_90 = Companion_getInstance_13().m33_1;
    tmp_90.p94_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_90, true)).a33($this, glGetBufferParameteriv$factory());
    var tmp_91 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_91 = Companion_getInstance_13().m33_1;
    tmp_91.q94_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_91, true)).a33($this, glGetFramebufferAttachmentParameteriv$factory());
    var tmp_92 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_92 = Companion_getInstance_13().m33_1;
    tmp_92.r94_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_92, true)).a33($this, glGetProgramInfoLog$factory());
    var tmp_93 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_93 = Companion_getInstance_13().m33_1;
    tmp_93.s94_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_93, true)).a33($this, glGetRenderbufferParameteriv$factory());
    var tmp_94 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_94 = Companion_getInstance_13().m33_1;
    tmp_94.t94_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_94, true)).a33($this, glGetProgramiv$factory());
    var tmp_95 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_95 = Companion_getInstance_13().m33_1;
    tmp_95.u94_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_95, true)).a33($this, glGetShaderiv$factory());
    var tmp_96 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_96 = Companion_getInstance_13().m33_1;
    tmp_96.v94_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_96, true)).a33($this, glGetShaderInfoLog$factory());
    var tmp_97 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_97 = Companion_getInstance_13().m33_1;
    tmp_97.w94_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_97, true)).a33($this, glGetShaderPrecisionFormat$factory());
    var tmp_98 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_98 = Companion_getInstance_13().m33_1;
    tmp_98.x94_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_98, true)).a33($this, glGetShaderSource$factory());
    var tmp_99 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_99 = Companion_getInstance_13().m33_1;
    tmp_99.y94_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_99, true)).a33($this, glGetUniformfv$factory());
    var tmp_100 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_100 = Companion_getInstance_13().m33_1;
    tmp_100.z94_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_100, true)).a33($this, glGetUniformiv$factory());
    var tmp_101 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_101 = Companion_getInstance_13().m33_1;
    tmp_101.a95_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_101, true)).a33($this, glGetVertexAttribfv$factory());
    var tmp_102 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_102 = Companion_getInstance_13().m33_1;
    tmp_102.b95_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_102, true)).a33($this, glGetVertexAttribiv$factory());
    var tmp_103 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_103 = Companion_getInstance_13().m33_1;
    tmp_103.c95_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_103, true)).a33($this, glGetVertexAttribPointerv$factory());
    var tmp_104 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_104 = Companion_getInstance_13().m33_1;
    tmp_104.d95_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false))]), false), null, config_104, true)).a33($this, glIsBuffer$factory());
    var tmp_105 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_105 = Companion_getInstance_13().m33_1;
    tmp_105.e95_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false))]), false), null, config_105, true)).a33($this, glIsFramebuffer$factory());
    var tmp_106 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_106 = Companion_getInstance_13().m33_1;
    tmp_106.f95_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false))]), false), null, config_106, true)).a33($this, glIsProgram$factory());
    var tmp_107 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_107 = Companion_getInstance_13().m33_1;
    tmp_107.g95_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false))]), false), null, config_107, true)).a33($this, glIsRenderbuffer$factory());
    var tmp_108 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_108 = Companion_getInstance_13().m33_1;
    tmp_108.h95_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false))]), false), null, config_108, true)).a33($this, glIsTexture$factory());
    var tmp_109 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_109 = Companion_getInstance_13().m33_1;
    tmp_109.i95_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false))]), false), null, config_109, true)).a33($this, glIsShader$factory());
    var tmp_110 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_110 = Companion_getInstance_13().m33_1;
    tmp_110.j95_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_110, true)).a33($this, glLinkProgram$factory());
    var tmp_111 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_111 = Companion_getInstance_13().m33_1;
    tmp_111.k95_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(0), arrayOf([createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_111, true)).a33($this, glReleaseShaderCompiler$factory());
    var tmp_112 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_112 = Companion_getInstance_13().m33_1;
    tmp_112.l95_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_112, true)).a33($this, glRenderbufferStorage$factory());
    var tmp_113 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_113 = Companion_getInstance_13().m33_1;
    tmp_113.m95_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().lg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_113, true)).a33($this, glSampleCoverage$factory());
    var tmp_114 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_114 = Companion_getInstance_13().m33_1;
    tmp_114.n95_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(5), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_114, true)).a33($this, glShaderBinary$factory());
    var tmp_115 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_115 = Companion_getInstance_13().m33_1;
    tmp_115.o95_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_115, true)).a33($this, glShaderSource$factory());
    var tmp_116 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_116 = Companion_getInstance_13().m33_1;
    tmp_116.p95_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_116, true)).a33($this, glStencilFuncSeparate$factory());
    var tmp_117 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_117 = Companion_getInstance_13().m33_1;
    tmp_117.q95_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_117, true)).a33($this, glStencilMaskSeparate$factory());
    var tmp_118 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_118 = Companion_getInstance_13().m33_1;
    tmp_118.r95_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_118, true)).a33($this, glStencilOpSeparate$factory());
    var tmp_119 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_119 = Companion_getInstance_13().m33_1;
    tmp_119.s95_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().lg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_119, true)).a33($this, glUniform1f$factory());
    var tmp_120 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_120 = Companion_getInstance_13().m33_1;
    tmp_120.t95_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().lg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().lg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_120, true)).a33($this, glUniform2f$factory());
    var tmp_121 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_121 = Companion_getInstance_13().m33_1;
    tmp_121.u95_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().lg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().lg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().lg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_121, true)).a33($this, glUniform3f$factory());
    var tmp_122 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_122 = Companion_getInstance_13().m33_1;
    tmp_122.v95_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(5), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().lg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().lg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().lg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().lg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_122, true)).a33($this, glUniform4f$factory());
    var tmp_123 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_123 = Companion_getInstance_13().m33_1;
    tmp_123.w95_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_123, true)).a33($this, glUniform1i$factory());
    var tmp_124 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_124 = Companion_getInstance_13().m33_1;
    tmp_124.x95_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_124, true)).a33($this, glUniform2i$factory());
    var tmp_125 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_125 = Companion_getInstance_13().m33_1;
    tmp_125.y95_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_125, true)).a33($this, glUniform3i$factory());
    var tmp_126 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_126 = Companion_getInstance_13().m33_1;
    tmp_126.z95_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(5), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_126, true)).a33($this, glUniform4i$factory());
    var tmp_127 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_127 = Companion_getInstance_13().m33_1;
    tmp_127.a96_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_127, true)).a33($this, glUniform1fv$factory());
    var tmp_128 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_128 = Companion_getInstance_13().m33_1;
    tmp_128.b96_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_128, true)).a33($this, glUniform2fv$factory());
    var tmp_129 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_129 = Companion_getInstance_13().m33_1;
    tmp_129.c96_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_129, true)).a33($this, glUniform3fv$factory());
    var tmp_130 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_130 = Companion_getInstance_13().m33_1;
    tmp_130.d96_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_130, true)).a33($this, glUniform4fv$factory());
    var tmp_131 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_131 = Companion_getInstance_13().m33_1;
    tmp_131.e96_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_131, true)).a33($this, glUniform1iv$factory());
    var tmp_132 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_132 = Companion_getInstance_13().m33_1;
    tmp_132.f96_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_132, true)).a33($this, glUniform2iv$factory());
    var tmp_133 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_133 = Companion_getInstance_13().m33_1;
    tmp_133.g96_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_133, true)).a33($this, glUniform3iv$factory());
    var tmp_134 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_134 = Companion_getInstance_13().m33_1;
    tmp_134.h96_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_134, true)).a33($this, glUniform4iv$factory());
    var tmp_135 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_135 = Companion_getInstance_13().m33_1;
    tmp_135.i96_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_135, true)).a33($this, glUniformMatrix2fv$factory());
    var tmp_136 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_136 = Companion_getInstance_13().m33_1;
    tmp_136.j96_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_136, true)).a33($this, glUniformMatrix3fv$factory());
    var tmp_137 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_137 = Companion_getInstance_13().m33_1;
    tmp_137.k96_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_137, true)).a33($this, glUniformMatrix4fv$factory());
    var tmp_138 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_138 = Companion_getInstance_13().m33_1;
    tmp_138.l96_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_138, true)).a33($this, glUseProgram$factory());
    var tmp_139 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_139 = Companion_getInstance_13().m33_1;
    tmp_139.m96_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_139, true)).a33($this, glValidateProgram$factory());
    var tmp_140 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_140 = Companion_getInstance_13().m33_1;
    tmp_140.n96_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().lg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_140, true)).a33($this, glVertexAttrib1f$factory());
    var tmp_141 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_141 = Companion_getInstance_13().m33_1;
    tmp_141.o96_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().lg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().lg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_141, true)).a33($this, glVertexAttrib2f$factory());
    var tmp_142 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_142 = Companion_getInstance_13().m33_1;
    tmp_142.p96_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(4), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().lg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().lg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().lg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_142, true)).a33($this, glVertexAttrib3f$factory());
    var tmp_143 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_143 = Companion_getInstance_13().m33_1;
    tmp_143.q96_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(5), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().lg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().lg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().lg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().lg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_143, true)).a33($this, glVertexAttrib4f$factory());
    var tmp_144 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_144 = Companion_getInstance_13().m33_1;
    tmp_144.r96_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_144, true)).a33($this, glVertexAttrib1fv$factory());
    var tmp_145 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_145 = Companion_getInstance_13().m33_1;
    tmp_145.s96_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_145, true)).a33($this, glVertexAttrib2fv$factory());
    var tmp_146 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_146 = Companion_getInstance_13().m33_1;
    tmp_146.t96_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_146, true)).a33($this, glVertexAttrib3fv$factory());
    var tmp_147 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_147 = Companion_getInstance_13().m33_1;
    tmp_147.u96_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(5), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_147, true)).a33($this, glBindBufferRange$factory());
    var tmp_148 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_148 = Companion_getInstance_13().m33_1;
    tmp_148.v96_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().og(), arrayOf([]), true)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false))]), false), null, config_148, true)).a33($this, glGetUniformBlockIndex$factory());
    var tmp_149 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_149 = Companion_getInstance_13().m33_1;
    tmp_149.w96_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_149, true)).a33($this, glUniformBlockBinding$factory());
    var tmp_150 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_150 = Companion_getInstance_13().m33_1;
    tmp_150.x96_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_150, true)).a33($this, glGenVertexArrays$factory());
    var tmp_151 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_151 = Companion_getInstance_13().m33_1;
    tmp_151.y96_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(DenoPointer), arrayOf([]), true)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_151, true)).a33($this, glDeleteVertexArrays$factory());
    var tmp_152 = $this;
    // Inline function 'korlibs.ffi.FFILib.func' call
    var config_152 = Companion_getInstance_13().m33_1;
    tmp_152.z96_1 = (new FuncInfo(createKType(PrimitiveClasses_getInstance().functionClass(1), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().kg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false), null, config_152, true)).a33($this, glBindVertexArray$factory());
    return $this;
  }
  k9a() {
    return this.c91_1.xo(this, glDrawArraysInstanced$factory_0());
  }
  l9a() {
    return this.d91_1.xo(this, glDrawElementsInstanced$factory_0());
  }
  m9a() {
    return this.e91_1.xo(this, glVertexAttribDivisor$factory_0());
  }
  t9a() {
    return this.f91_1.xo(this, glTexSubImage2D$factory_0());
  }
  t99() {
    return this.g91_1.xo(this, glTexImage2D$factory_0());
  }
  u99() {
    return this.h91_1.xo(this, glTexParameteri$factory_0());
  }
  u9a() {
    return this.i91_1.xo(this, glTexParameterf$factory_0());
  }
  v9a() {
    return this.j91_1.xo(this, glTexParameterfv$factory_0());
  }
  w9a() {
    return this.k91_1.xo(this, glTexParameteriv$factory_0());
  }
  r99() {
    return this.l91_1.xo(this, glStencilOp$factory_0());
  }
  p99() {
    return this.m91_1.xo(this, glStencilMask$factory_0());
  }
  j99() {
    return this.n91_1.xo(this, glReadPixels$factory_0());
  }
  n99() {
    return this.o91_1.xo(this, glStencilFunc$factory_0());
  }
  l99() {
    return this.p91_1.xo(this, glScissor$factory_0());
  }
  x9a() {
    return this.q91_1.xo(this, glPolygonOffset$factory_0());
  }
  i99() {
    return this.r91_1.xo(this, glPixelStorei$factory_0());
  }
  y9a() {
    return this.s91_1.xo(this, glLineWidth$factory_0());
  }
  z9a() {
    return this.t91_1.xo(this, glGetTexParameterfv$factory_0());
  }
  a9b() {
    return this.u91_1.xo(this, glGetTexParameteriv$factory_0());
  }
  b99() {
    return this.v91_1.xo(this, glGetError$factory_0());
  }
  b9b() {
    return this.w91_1.xo(this, glGetFloatv$factory_0());
  }
  c99() {
    return this.x91_1.xo(this, glGetIntegerv$factory_0());
  }
  c9b() {
    return this.y91_1.xo(this, glGetBooleanv$factory_0());
  }
  z98() {
    return this.z91_1.xo(this, glGenTextures$factory_0());
  }
  d9b() {
    return this.a92_1.xo(this, glDepthRange$factory_0());
  }
  k98() {
    return this.b92_1.xo(this, glDepthRangef$factory_0());
  }
  e9b() {
    return this.c92_1.xo(this, glClearDepth$factory_0());
  }
  v97() {
    return this.d92_1.xo(this, glClearDepthf$factory_0());
  }
  n98() {
    return this.e92_1.xo(this, glDrawArrays$factory_0());
  }
  o98() {
    return this.f92_1.xo(this, glDrawElements$factory_0());
  }
  u98() {
    return this.g92_1.xo(this, glFrontFace$factory_0());
  }
  f9b() {
    return this.h92_1.xo(this, glFinish$factory_0());
  }
  r98() {
    return this.i92_1.xo(this, glFlush$factory_0());
  }
  p98() {
    return this.j92_1.xo(this, glEnable$factory_0());
  }
  g9b() {
    return this.k92_1.xo(this, glIsEnabled$factory_0());
  }
  l98() {
    return this.l92_1.xo(this, glDisable$factory_0());
  }
  j98() {
    return this.m92_1.xo(this, glDepthMask$factory_0());
  }
  i98() {
    return this.n92_1.xo(this, glDepthFunc$factory_0());
  }
  h98() {
    return this.o92_1.xo(this, glDeleteTextures$factory_0());
  }
  b98() {
    return this.p92_1.xo(this, glCullFace$factory_0());
  }
  h9b() {
    return this.q92_1.xo(this, glCopyTexImage2D$factory_0());
  }
  i9b() {
    return this.r92_1.xo(this, glCopyTexSubImage2D$factory_0());
  }
  x97() {
    return this.s92_1.xo(this, glColorMask$factory_0());
  }
  w97() {
    return this.t92_1.xo(this, glClearStencil$factory_0());
  }
  u97() {
    return this.u92_1.xo(this, glClearColor$factory_0());
  }
  t97() {
    return this.v92_1.xo(this, glClear$factory_0());
  }
  o97() {
    return this.w92_1.xo(this, glBindTexture$factory_0());
  }
  j9b() {
    return this.x92_1.xo(this, glHint$factory_0());
  }
  j9a() {
    return this.y92_1.xo(this, glViewport$factory_0());
  }
  g99() {
    return this.z92_1.xo(this, glGetString$factory_0());
  }
  k9b() {
    return this.a93_1.xo(this, glGetStringi$factory_0());
  }
  i9a() {
    return this.b93_1.xo(this, glVertexAttribPointer$factory_0());
  }
  l9b() {
    return this.c93_1.xo(this, glVertexAttrib4fv$factory_0());
  }
  i97() {
    return this.d93_1.xo(this, glActiveTexture$factory_0());
  }
  j97() {
    return this.e93_1.xo(this, glAttachShader$factory_0());
  }
  k97() {
    return this.f93_1.xo(this, glBindAttribLocation$factory_0());
  }
  l97() {
    return this.g93_1.xo(this, glBindBuffer$factory_0());
  }
  m97() {
    return this.h93_1.xo(this, glBindFramebuffer$factory_0());
  }
  n97() {
    return this.i93_1.xo(this, glBindRenderbuffer$factory_0());
  }
  m9b() {
    return this.j93_1.xo(this, glBlendColor$factory_0());
  }
  n9b() {
    return this.k93_1.xo(this, glBlendEquation$factory_0());
  }
  p97() {
    return this.l93_1.xo(this, glBlendEquationSeparate$factory_0());
  }
  o9b() {
    return this.m93_1.xo(this, glBlendFunc$factory_0());
  }
  q97() {
    return this.n93_1.xo(this, glBlendFuncSeparate$factory_0());
  }
  r97() {
    return this.o93_1.xo(this, glBufferData$factory_0());
  }
  s97() {
    return this.p93_1.xo(this, glBufferSubData$factory_0());
  }
  p9b() {
    return this.q93_1.xo(this, glCheckFramebufferStatus$factory_0());
  }
  y97() {
    return this.r93_1.xo(this, glCompileShader$factory_0());
  }
  q9b() {
    return this.s93_1.xo(this, glCompressedTexImage2D$factory_0());
  }
  r9b() {
    return this.t93_1.xo(this, glCompressedTexSubImage2D$factory_0());
  }
  z97() {
    return this.u93_1.xo(this, glCreateProgram$factory_0());
  }
  a98() {
    return this.v93_1.xo(this, glCreateShader$factory_0());
  }
  c98() {
    return this.w93_1.xo(this, glDeleteBuffers$factory_0());
  }
  d98() {
    return this.x93_1.xo(this, glDeleteFramebuffers$factory_0());
  }
  e98() {
    return this.y93_1.xo(this, glDeleteProgram$factory_0());
  }
  f98() {
    return this.z93_1.xo(this, glDeleteRenderbuffers$factory_0());
  }
  g98() {
    return this.a94_1.xo(this, glDeleteShader$factory_0());
  }
  s9b() {
    return this.b94_1.xo(this, glDetachShader$factory_0());
  }
  m98() {
    return this.c94_1.xo(this, glDisableVertexAttribArray$factory_0());
  }
  q98() {
    return this.d94_1.xo(this, glEnableVertexAttribArray$factory_0());
  }
  s98() {
    return this.e94_1.xo(this, glFramebufferRenderbuffer$factory_0());
  }
  t98() {
    return this.f94_1.xo(this, glFramebufferTexture2D$factory_0());
  }
  v98() {
    return this.g94_1.xo(this, glGenBuffers$factory_0());
  }
  w98() {
    return this.h94_1.xo(this, glGenerateMipmap$factory_0());
  }
  x98() {
    return this.i94_1.xo(this, glGenFramebuffers$factory_0());
  }
  y98() {
    return this.j94_1.xo(this, glGenRenderbuffers$factory_0());
  }
  t9b() {
    return this.k94_1.xo(this, glGetActiveAttrib$factory_0());
  }
  u9b() {
    return this.l94_1.xo(this, glGetActiveUniform$factory_0());
  }
  v9b() {
    return this.m94_1.xo(this, glGetAttachedShaders$factory_0());
  }
  w9b() {
    return this.n94_1.xo(this, glGetAttribLocation$factory_0());
  }
  a99() {
    return this.o94_1.xo(this, glGetUniformLocation$factory_0());
  }
  x9b() {
    return this.p94_1.xo(this, glGetBufferParameteriv$factory_0());
  }
  y9b() {
    return this.q94_1.xo(this, glGetFramebufferAttachmentParameteriv$factory_0());
  }
  z9b() {
    return this.r94_1.xo(this, glGetProgramInfoLog$factory_0());
  }
  a9c() {
    return this.s94_1.xo(this, glGetRenderbufferParameteriv$factory_0());
  }
  d99() {
    return this.t94_1.xo(this, glGetProgramiv$factory_0());
  }
  e99() {
    return this.u94_1.xo(this, glGetShaderiv$factory_0());
  }
  f99() {
    return this.v94_1.xo(this, glGetShaderInfoLog$factory_0());
  }
  b9c() {
    return this.w94_1.xo(this, glGetShaderPrecisionFormat$factory_0());
  }
  c9c() {
    return this.x94_1.xo(this, glGetShaderSource$factory_0());
  }
  d9c() {
    return this.y94_1.xo(this, glGetUniformfv$factory_0());
  }
  e9c() {
    return this.z94_1.xo(this, glGetUniformiv$factory_0());
  }
  f9c() {
    return this.a95_1.xo(this, glGetVertexAttribfv$factory_0());
  }
  g9c() {
    return this.b95_1.xo(this, glGetVertexAttribiv$factory_0());
  }
  h9c() {
    return this.c95_1.xo(this, glGetVertexAttribPointerv$factory_0());
  }
  i9c() {
    return this.d95_1.xo(this, glIsBuffer$factory_0());
  }
  j9c() {
    return this.e95_1.xo(this, glIsFramebuffer$factory_0());
  }
  k9c() {
    return this.f95_1.xo(this, glIsProgram$factory_0());
  }
  l9c() {
    return this.g95_1.xo(this, glIsRenderbuffer$factory_0());
  }
  m9c() {
    return this.h95_1.xo(this, glIsTexture$factory_0());
  }
  n9c() {
    return this.i95_1.xo(this, glIsShader$factory_0());
  }
  h99() {
    return this.j95_1.xo(this, glLinkProgram$factory_0());
  }
  o9c() {
    return this.k95_1.xo(this, glReleaseShaderCompiler$factory_0());
  }
  k99() {
    return this.l95_1.xo(this, glRenderbufferStorage$factory_0());
  }
  p9c() {
    return this.m95_1.xo(this, glSampleCoverage$factory_0());
  }
  q9c() {
    return this.n95_1.xo(this, glShaderBinary$factory_0());
  }
  m99() {
    return this.o95_1.xo(this, glShaderSource$factory_0());
  }
  o99() {
    return this.p95_1.xo(this, glStencilFuncSeparate$factory_0());
  }
  q99() {
    return this.q95_1.xo(this, glStencilMaskSeparate$factory_0());
  }
  s99() {
    return this.r95_1.xo(this, glStencilOpSeparate$factory_0());
  }
  r9c() {
    return this.s95_1.xo(this, glUniform1f$factory_0());
  }
  s9c() {
    return this.t95_1.xo(this, glUniform2f$factory_0());
  }
  t9c() {
    return this.u95_1.xo(this, glUniform3f$factory_0());
  }
  u9c() {
    return this.v95_1.xo(this, glUniform4f$factory_0());
  }
  w99() {
    return this.w95_1.xo(this, glUniform1i$factory_0());
  }
  v9c() {
    return this.x95_1.xo(this, glUniform2i$factory_0());
  }
  w9c() {
    return this.y95_1.xo(this, glUniform3i$factory_0());
  }
  x9c() {
    return this.z95_1.xo(this, glUniform4i$factory_0());
  }
  v99() {
    return this.a96_1.xo(this, glUniform1fv$factory_0());
  }
  y99() {
    return this.b96_1.xo(this, glUniform2fv$factory_0());
  }
  a9a() {
    return this.c96_1.xo(this, glUniform3fv$factory_0());
  }
  c9a() {
    return this.d96_1.xo(this, glUniform4fv$factory_0());
  }
  x99() {
    return this.e96_1.xo(this, glUniform1iv$factory_0());
  }
  z99() {
    return this.f96_1.xo(this, glUniform2iv$factory_0());
  }
  b9a() {
    return this.g96_1.xo(this, glUniform3iv$factory_0());
  }
  d9a() {
    return this.h96_1.xo(this, glUniform4iv$factory_0());
  }
  e9a() {
    return this.i96_1.xo(this, glUniformMatrix2fv$factory_0());
  }
  f9a() {
    return this.j96_1.xo(this, glUniformMatrix3fv$factory_0());
  }
  g9a() {
    return this.k96_1.xo(this, glUniformMatrix4fv$factory_0());
  }
  h9a() {
    return this.l96_1.xo(this, glUseProgram$factory_0());
  }
  y9c() {
    return this.m96_1.xo(this, glValidateProgram$factory_0());
  }
  z9c() {
    return this.n96_1.xo(this, glVertexAttrib1f$factory_0());
  }
  a9d() {
    return this.o96_1.xo(this, glVertexAttrib2f$factory_0());
  }
  b9d() {
    return this.p96_1.xo(this, glVertexAttrib3f$factory_0());
  }
  c9d() {
    return this.q96_1.xo(this, glVertexAttrib4f$factory_0());
  }
  d9d() {
    return this.r96_1.xo(this, glVertexAttrib1fv$factory_0());
  }
  e9d() {
    return this.s96_1.xo(this, glVertexAttrib2fv$factory_0());
  }
  f9d() {
    return this.t96_1.xo(this, glVertexAttrib3fv$factory_0());
  }
  n9a() {
    return this.u96_1.xo(this, glBindBufferRange$factory_0());
  }
  o9a() {
    return this.v96_1.xo(this, glGetUniformBlockIndex$factory_0());
  }
  p9a() {
    return this.w96_1.xo(this, glUniformBlockBinding$factory_0());
  }
  q9a() {
    return this.x96_1.xo(this, glGenVertexArrays$factory_0());
  }
  g9d() {
    return this.y96_1.xo(this, glDeleteVertexArrays$factory_0());
  }
  r9a() {
    return this.z96_1.xo(this, glBindVertexArray$factory_0());
  }
}
class SDLGameWindow$ag$1 extends KmlGlContext {
  constructor(this$0, $box) {
    if ($box === VOID)
      $box = {};
    $box.k9d_1 = this$0;
    super(this$0.z9f_1, new KmlGlOpenGL(), VOID, $box);
  }
  f7l() {
    var tmp = this.k9d_1.y9f_1.v90();
    var tmp_0 = this.y7j_1;
    tmp(tmp_0 instanceof DenoPointer ? tmp_0 : THROW_CCE(), this.k9d_1.a9g_1);
  }
  h7l() {
    var tmp = this.k9d_1.y9f_1.v90();
    var tmp_0 = this.y7j_1;
    tmp(tmp_0 instanceof DenoPointer ? tmp_0 : THROW_CCE(), null);
  }
  t6() {
    this.k9d_1.y9f_1.u90()(this.k9d_1.a9g_1);
  }
}
class SDLGameWindow extends GameWindow {
  static f9g(size, config) {
    size = size === VOID ? Size2D.o2e(640, 480) : size;
    config = config === VOID ? Companion_getInstance_75().z8x_1 : config;
    var $this = this.y8v();
    $this.w9f_1 = size;
    $this.x9f_1 = config;
    $this.y9f_1 = SDL.j90();
    $this.z9f_1 = $this.y9f_1.l90()($this.x9f_1.k8y_1, 805240832, 805240832, numberToInt($this.w9f_1.m2e_1), numberToInt($this.w9f_1.n2e_1), 34);
    $this.a9g_1 = $this.y9f_1.t90()($this.z9f_1);
    $this.y9f_1.p90()($this.z9f_1);
    var tmp = $this;
    tmp.b9g_1 = AGOpengl.x7j(new SDLGameWindow$ag$1($this));
    $this.c9g_1 = $this.p8w().m7e_1;
    $this.d9g_1 = '';
    $this.e9g_1 = CreateFFIMemory(1024);
    return $this;
  }
  p8w() {
    return this.b9g_1;
  }
  w8w(value) {
    this.d9g_1 = value;
    this.y9f_1.m90()(this.z9f_1, this.g9g());
  }
  g9g() {
    return this.d9g_1;
  }
  f8x(width, height) {
    this.y9f_1.n90()(this.z9f_1, width, height);
    this.y9f_1.o90()(this.z9f_1, 805240832, 805240832);
  }
  h9g() {
    // Inline function 'korlibs.ffi.usePointer' call
    var this_0 = this.e9g_1;
    var it = get_pointer(Deno.UnsafePointer.of(this_0));
    while (this.y9f_1.r90()(it)) {
      var type = getS32(it, 0);
      switch (type) {
        case 512:
          println('WINDOW EVENT');
          break;
        case 1024:
          println('MOUSE MOTION');
          break;
        case 1025:
          println('MOUSE DOWN');
          break;
        case 1026:
          println('MOUSE UP');
          break;
        case 256:
          this.i8x();
          break;
        default:
          println('EVENT: type=' + type);
          break;
      }
    }
    this.y9f_1.v90()(this.z9f_1, this.a9g_1);
    this.c9g_1.g7k(1.0, 0.0, 0.0, 1.0);
    this.c9g_1.l7k(16384);
  }
  i9g() {
    this.y9f_1.w90()(this.z9f_1);
  }
  b1g(exitCode) {
    super.b1g(exitCode);
    this.y9f_1.u90()(this.a9g_1);
    this.y9f_1.s90()();
  }
}
class Size3D {
  constructor(width, height, depthOrArrayLayers) {
    height = height === VOID ? 1 : height;
    depthOrArrayLayers = depthOrArrayLayers === VOID ? 1 : depthOrArrayLayers;
    this.width = width;
    this.height = height;
    this.depthOrArrayLayers = depthOrArrayLayers;
  }
  o8j(_set____db54di) {
    this.width = _set____db54di;
  }
  x2p() {
    return this.width;
  }
  p8j(_set____db54di) {
    this.height = _set____db54di;
  }
  y2p() {
    return this.height;
  }
  j9g(_set____db54di) {
    this.depthOrArrayLayers = _set____db54di;
  }
  k9g() {
    return this.depthOrArrayLayers;
  }
  toArray() {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [this.width, this.height, this.depthOrArrayLayers];
  }
  ul() {
    return this.width;
  }
  vl() {
    return this.height;
  }
  dt() {
    return this.depthOrArrayLayers;
  }
  l9g(width, height, depthOrArrayLayers) {
    return new Size3D(width, height, depthOrArrayLayers);
  }
  copy(width, height, depthOrArrayLayers, $super) {
    width = width === VOID ? this.width : width;
    height = height === VOID ? this.height : height;
    depthOrArrayLayers = depthOrArrayLayers === VOID ? this.depthOrArrayLayers : depthOrArrayLayers;
    return this.l9g(width, height, depthOrArrayLayers);
  }
  toString() {
    return 'Size3D(width=' + this.width + ', height=' + this.height + ', depthOrArrayLayers=' + this.depthOrArrayLayers + ')';
  }
  hashCode() {
    var result = this.width;
    result = imul(result, 31) + this.height | 0;
    result = imul(result, 31) + this.depthOrArrayLayers | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Size3D))
      return false;
    var tmp0_other_with_cast = other instanceof Size3D ? other : THROW_CCE();
    if (!(this.width === tmp0_other_with_cast.width))
      return false;
    if (!(this.height === tmp0_other_with_cast.height))
      return false;
    if (!(this.depthOrArrayLayers === tmp0_other_with_cast.depthOrArrayLayers))
      return false;
    return true;
  }
}
class AGOpenglFactory {
  f8i() {
    // Inline function 'kotlin.js.unsafeCast' call
    return 'ontouchstart' in window || navigator.maxTouchPoints;
  }
}
class KmlGlJsCanvas extends KmlGl {
  constructor(canvas, glOpts) {
    super();
    this.q9g_1 = canvas;
    this.r9g_1 = glOpts;
    this.s9g_1 = 1;
    var tmp = this;
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp_0;
    if (null == null) {
      var tmp1_safe_receiver = this.q9g_1.getContext('webgl2', this.r9g_1);
      var tmp_1;
      if (tmp1_safe_receiver == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.also' call
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.kgl.KmlGlJsCanvas.gl.<anonymous>' call
        this.s9g_1 = 2;
        tmp_1 = tmp1_safe_receiver;
      }
      tmp_0 = tmp_1;
    } else {
      tmp_0 = null;
    }
    var tmp2_elvis_lhs = tmp_0;
    var tmp3_elvis_lhs = tmp2_elvis_lhs == null ? this.q9g_1.getContext('webgl', this.r9g_1) : tmp2_elvis_lhs;
    // Inline function 'kotlin.js.asDynamic' call
    var tmp4_safe_receiver = tmp3_elvis_lhs == null ? this.q9g_1.getContext('experimental-webgl', this.r9g_1) : tmp3_elvis_lhs;
    var tmp_2;
    if (tmp4_safe_receiver == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.kgl.KmlGlJsCanvas.gl.<anonymous>' call
      println('Created WebGL version=' + this.s9g_1 + ', opts=' + JSON.stringify(this.r9g_1));
      tmp_2 = tmp4_safe_receiver;
    }
    var tmp5_safe_receiver = tmp_2;
    var tmp_3;
    if (tmp5_safe_receiver == null) {
      tmp_3 = null;
    } else {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.kgl.KmlGlJsCanvas.gl.<anonymous>' call
      tmp5_safe_receiver.getExtension('OES_standard_derivatives');
      tmp5_safe_receiver.getExtension('OES_texture_float');
      tmp5_safe_receiver.getExtension('OES_texture_float_linear');
      tmp5_safe_receiver.getExtension('OES_element_index_uint');
      tmp_3 = tmp5_safe_receiver;
    }
    var tmp6_elvis_lhs = tmp_3;
    var tmp_4;
    if (tmp6_elvis_lhs == null) {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      try {
        var tmp0_safe_receiver = document.body;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.apply' call
          var tmp_5 = document.createElement('div');
          var this_0 = tmp_5 instanceof HTMLElement ? tmp_5 : THROW_CCE();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.kgl.KmlGlJsCanvas.gl.<anonymous>.<anonymous>' call
          this_0.style.color = 'red';
          this_0.style.font = '30px Arial';
          this_0.innerText = "Can't get webgl context. Running in an android emulator without cross-walk?";
          tmp0_safe_receiver.prepend(this_0);
        }
      } catch ($p) {
        if ($p instanceof Error) {
          var e = $p;
          printStackTrace(e);
        } else {
          throw $p;
        }
      }
      var message = "Can't get webgl context";
      throw IllegalStateException.l5(toString(message));
    } else {
      tmp_4 = tmp6_elvis_lhs;
    }
    tmp.t9g_1 = tmp_4;
    var tmp_6 = this;
    // Inline function 'kotlin.arrayOfNulls' call
    tmp_6.u9g_1 = fillArrayVal(Array(8192), null);
    this.v9g_1 = toMutableList(reversed_0(until(1, this.u9g_1.length)));
    var tmp_7 = this;
    tmp_7.w9g_1 = lazy(KmlGlJsCanvas$extensions$delegate$lambda(this));
    var tmp_8 = this;
    tmp_8.x9g_1 = lazy(KmlGlJsCanvas$isFloatTextureSupported$delegate$lambda(this));
    this.y9g_1 = new WebGLExtension(this, 'ANGLE_instanced_arrays', 2, listOf_0(['drawArraysInstanced', 'drawElementsInstanced', 'vertexAttribDivisor']), 'ANGLE');
    this.z9g_1 = new WebGLExtension(this, 'OES_vertex_array_object', 2, listOf_0(['createVertexArrayOES', 'deleteVertexArrayOES', 'isVertexArrayOES', 'bindVertexArrayOES']), 'OES');
  }
  i7j() {
    return Companion_instance_55.p7q(this.s9g_1);
  }
  h7j(texture) {
    return this.t9g_1.activeTexture(texture);
  }
  n7n(program, shader) {
    return this.t9g_1.attachShader(get_2(program, this), get_2(shader, this));
  }
  m7n(program, index, name) {
    return this.t9g_1.bindAttribLocation(get_2(program, this), index, name);
  }
  b7i(target, buffer) {
    return this.t9g_1.bindBuffer(target, get_2(buffer, this));
  }
  f7m(target, framebuffer) {
    return this.t9g_1.bindFramebuffer(target, get_2(framebuffer, this));
  }
  m7m(target, renderbuffer) {
    return this.t9g_1.bindRenderbuffer(target, get_2(renderbuffer, this));
  }
  d7m(target, texture) {
    return this.t9g_1.bindTexture(target, get_2(texture, this));
  }
  p7k(modeRGB, modeAlpha) {
    return this.t9g_1.blendEquationSeparate(modeRGB, modeAlpha);
  }
  q7k(sfactorRGB, dfactorRGB, sfactorAlpha, dfactorAlpha) {
    return this.t9g_1.blendFuncSeparate(sfactorRGB, dfactorRGB, sfactorAlpha, dfactorAlpha);
  }
  l7j(target, size, data, usage) {
    return this.t9g_1.bufferData(target, get_arrayUByte(sliceBuffer(data, 0, size)), usage);
  }
  k7j(target, offset, size, data) {
    return this.t9g_1.bufferSubData(target, offset, get_arrayUByte(sliceBuffer(data, 0, size)));
  }
  l7k(mask) {
    return this.t9g_1.clear(mask);
  }
  g7k(red, green, blue, alpha) {
    return this.t9g_1.clearColor(red, green, blue, alpha);
  }
  i7k(d) {
    return this.t9g_1.clearDepth(d);
  }
  k7k(s) {
    return this.t9g_1.clearStencil(s);
  }
  t7m(red, green, blue, alpha) {
    return this.t9g_1.colorMask(red, green, blue, alpha);
  }
  e7n(shader) {
    return this.t9g_1.compileShader(get_2(shader, this));
  }
  g7n() {
    return alloc(this.t9g_1.createProgram(), this);
  }
  c7n(type) {
    return alloc(this.t9g_1.createShader(type), this);
  }
  i7l(mode) {
    return this.t9g_1.cullFace(mode);
  }
  k8c(n, items) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = get_arrayInt(items)[p];
        this.t9g_1.deleteBuffer(free(tmp$ret$1, this));
      }
       while (inductionVariable < n);
  }
  l8c(n, items) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = get_arrayInt(items)[p];
        this.t9g_1.deleteFramebuffer(free(tmp$ret$1, this));
      }
       while (inductionVariable < n);
  }
  b7n(program) {
    return this.t9g_1.deleteProgram(get_2(program, this));
  }
  m8c(n, items) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = get_arrayInt(items)[p];
        this.t9g_1.deleteRenderbuffer(free(tmp$ret$1, this));
      }
       while (inductionVariable < n);
  }
  a7n(shader) {
    return this.t9g_1.deleteShader(get_2(shader, this));
  }
  n8c(n, items) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = get_arrayInt(items)[p];
        this.t9g_1.deleteTexture(free(tmp$ret$1, this));
      }
       while (inductionVariable < n);
  }
  s7m(func) {
    return this.t9g_1.depthFunc(func);
  }
  h7k(flag) {
    return this.t9g_1.depthMask(flag);
  }
  r7m(n, f) {
    return this.t9g_1.depthRange(n, f);
  }
  u7k(cap) {
    return this.t9g_1.disable(cap);
  }
  k7l(index) {
    return this.t9g_1.disableVertexAttribArray(index);
  }
  b7l(mode, first, count) {
    return this.t9g_1.drawArrays(mode, first, count);
  }
  d7l(mode, count, type, indices) {
    return this.t9g_1.drawElements(mode, count, type, indices);
  }
  v7k(cap) {
    return this.t9g_1.enable(cap);
  }
  o7l(index) {
    return this.t9g_1.enableVertexAttribArray(index);
  }
  bd() {
    return this.t9g_1.flush();
  }
  p7m(target, attachment, renderbuffertarget, renderbuffer) {
    return this.t9g_1.framebufferRenderbuffer(target, attachment, renderbuffertarget, get_2(renderbuffer, this));
  }
  o7m(target, attachment, textarget, texture, level) {
    return this.t9g_1.framebufferTexture2D(target, attachment, textarget, get_2(texture, this), level);
  }
  q7m(mode) {
    return this.t9g_1.frontFace(mode);
  }
  o8c(n, buffers) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.set' call
        // Inline function 'kotlin.js.asDynamic' call
        get_arrayInt(buffers)[p] = alloc(this.t9g_1.createBuffer(), this);
      }
       while (inductionVariable < n);
  }
  p7j(target) {
    return this.t9g_1.generateMipmap(target);
  }
  p8c(n, framebuffers) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.set' call
        // Inline function 'kotlin.js.asDynamic' call
        get_arrayInt(framebuffers)[p] = alloc(this.t9g_1.createFramebuffer(), this);
      }
       while (inductionVariable < n);
  }
  q8c(n, renderbuffers) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.set' call
        // Inline function 'kotlin.js.asDynamic' call
        get_arrayInt(renderbuffers)[p] = alloc(this.t9g_1.createRenderbuffer(), this);
      }
       while (inductionVariable < n);
  }
  r8c(n, textures) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var p = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.set' call
        // Inline function 'kotlin.js.asDynamic' call
        get_arrayInt(textures)[p] = alloc(this.t9g_1.createTexture(), this);
      }
       while (inductionVariable < n);
  }
  y7m(program, name) {
    // Inline function 'kotlin.js.asDynamic' call
    var prg = get_2(program, this);
    if (prg.uniforms === undefined)
      prg.uniforms = {};
    if (prg.uniforms[name] === undefined) {
      prg.uniforms[name] = alloc(this.t9g_1.getUniformLocation(prg, name), this);
    }
    // Inline function 'kotlin.js.unsafeCast' call
    return prg.uniforms[name];
  }
  f7n() {
    return this.t9g_1.getError();
  }
  s8c(pname, data) {
    // Inline function 'org.khronos.webgl.set' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.asDynamic' call
    get_arrayInt(data)[0] = this.t9g_1.getParameter(pname);
  }
  t8c(program, pname, params) {
    // Inline function 'korlibs.kgl.KmlGl.INFO_LOG_LENGTH' call
    if (pname === 35716) {
      // Inline function 'org.khronos.webgl.set' call
      var this_0 = get_arrayInt(params);
      var tmp1_safe_receiver = this.t9g_1.getProgramInfoLog(get_2(program, this));
      var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.length;
      var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      this_0[0] = tmp3_elvis_lhs == null ? 1 : tmp3_elvis_lhs;
    } else {
      // Inline function 'org.khronos.webgl.set' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      get_arrayInt(params)[0] = this.t9g_1.getProgramParameter(get_2(program, this), pname);
    }
  }
  u8c(shader, pname, params) {
    // Inline function 'korlibs.kgl.KmlGl.INFO_LOG_LENGTH' call
    if (pname === 35716) {
      // Inline function 'org.khronos.webgl.set' call
      var this_0 = get_arrayInt(params);
      var tmp1_safe_receiver = this.t9g_1.getShaderInfoLog(get_2(shader, this));
      var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.length;
      var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver + 1 | 0;
      // Inline function 'kotlin.js.asDynamic' call
      this_0[0] = tmp3_elvis_lhs == null ? 1 : tmp3_elvis_lhs;
    } else {
      // Inline function 'org.khronos.webgl.set' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      get_arrayInt(params)[0] = this.t9g_1.getShaderParameter(get_2(shader, this), pname);
    }
  }
  v8c(shader, bufSize, length, infoLog) {
    var tmp0_elvis_lhs = this.t9g_1.getShaderInfoLog(get_2(shader, this));
    var str = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
    // Inline function 'org.khronos.webgl.set' call
    // Inline function 'kotlin.js.asDynamic' call
    get_arrayInt(length)[0] = str.length;
    putAsciiString(infoLog, str);
  }
  w7f(name) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return this.t9g_1.getParameter(name);
  }
  o7n(program) {
    return this.t9g_1.linkProgram(get_2(program, this));
  }
  m7j(pname, param) {
    return this.t9g_1.pixelStorei(pname, param);
  }
  c7m(x, y, width, height, format, type, pixels) {
    return this.t9g_1.readPixels(x, y, width, height, format, type, get_arrayUByte(pixels));
  }
  n7m(target, internalformat, width, height) {
    return this.t9g_1.renderbufferStorage(target, internalformat, width, height);
  }
  u7m(x, y, width, height) {
    return this.t9g_1.scissor(x, y, width, height);
  }
  d7n(shader, string) {
    return this.t9g_1.shaderSource(get_2(shader, this), string);
  }
  x7k(func, ref, mask) {
    return this.t9g_1.stencilFunc(func, ref, mask);
  }
  w7k(face, func, ref, mask) {
    return this.t9g_1.stencilFuncSeparate(face, func, ref, mask);
  }
  j7k(mask) {
    return this.t9g_1.stencilMask(mask);
  }
  a7l(face, mask) {
    return this.t9g_1.stencilMaskSeparate(face, mask);
  }
  z7k(fail, zfail, zpass) {
    return this.t9g_1.stencilOp(fail, zfail, zpass);
  }
  y7k(face, sfail, dpfail, dppass) {
    return this.t9g_1.stencilOpSeparate(face, sfail, dpfail, dppass);
  }
  n7j(target, level, internalformat, width, height, border, format, type, pixels) {
    var tmp;
    // Inline function 'korlibs.kgl.KmlGl.FLOAT' call
    if (type === 5126) {
      tmp = pixels == null ? null : get_arrayFloat(pixels);
    } else {
      tmp = pixels == null ? null : get_arrayUByte(pixels);
    }
    var vpixels = tmp;
    this.t9g_1.texImage2D(target, level, internalformat, width, height, border, format, type, vpixels);
  }
  o7j(target, level, internalformat, format, type, data) {
    if (data instanceof HtmlNativeImage) {
      // Inline function 'korlibs.math.toInt' call
      var tmp$ret$0 = !data.y43_1 && data.x43_1 ? 1 : 0;
      this.t9g_1.pixelStorei(37441, tmp$ret$0);
      this.t9g_1.texImage2D(target, level, internalformat, format, type, data.u5w_1);
      this.t9g_1.pixelStorei(37441, 0);
    } else {
      return super.o7j(target, level, internalformat, format, type, data);
    }
  }
  g7j(target, pname, param) {
    return this.t9g_1.texParameteri(target, pname, param);
  }
  c7j(location, count, value) {
    return this.t9g_1.uniform1fv(get_2(location, this), get_arrayFloat(value).subarray(0, imul(count, 1)));
  }
  a7h(location, v0) {
    return this.t9g_1.uniform1i(get_2(location, this), v0);
  }
  v7i(location, count, value) {
    return this.t9g_1.uniform1iv(get_2(location, this), get_arrayInt(value).subarray(0, imul(count, 1)));
  }
  d7j(location, count, value) {
    return this.t9g_1.uniform2fv(get_2(location, this), get_arrayFloat(value).subarray(0, imul(count, 2)));
  }
  w7i(location, count, value) {
    return this.t9g_1.uniform2iv(get_2(location, this), get_arrayInt(value).subarray(0, imul(count, 2)));
  }
  e7j(location, count, value) {
    return this.t9g_1.uniform3fv(get_2(location, this), get_arrayFloat(value).subarray(0, imul(count, 3)));
  }
  x7i(location, count, value) {
    return this.t9g_1.uniform3iv(get_2(location, this), get_arrayInt(value).subarray(0, imul(count, 3)));
  }
  f7j(location, count, value) {
    return this.t9g_1.uniform4fv(get_2(location, this), get_arrayFloat(value).subarray(0, imul(count, 4)));
  }
  y7i(location, count, value) {
    return this.t9g_1.uniform4iv(get_2(location, this), get_arrayInt(value).subarray(0, imul(count, 4)));
  }
  z7i(location, count, transpose, value) {
    return this.t9g_1.uniformMatrix2fv(get_2(location, this), transpose, get_arrayFloat(value).subarray(0, imul(count, 4)));
  }
  a7j(location, count, transpose, value) {
    return this.t9g_1.uniformMatrix3fv(get_2(location, this), transpose, get_arrayFloat(value).subarray(0, imul(count, 9)));
  }
  b7j(location, count, transpose, value) {
    return this.t9g_1.uniformMatrix4fv(get_2(location, this), transpose, get_arrayFloat(value).subarray(0, imul(count, 16)));
  }
  z7m(program) {
    return this.t9g_1.useProgram(get_2(program, this));
  }
  p7l(index, size, type, normalized, stride, pointer) {
    return this.t9g_1.vertexAttribPointer(index, size, type, normalized, stride, pointer.l2());
  }
  e7m(x, y, width, height) {
    return this.t9g_1.viewport(x, y, width, height);
  }
  j61() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.w9g_1;
    extensions$factory();
    return this_0.u1();
  }
  c7l(mode, first, count, instancecount) {
    // Inline function 'kotlin.js.asDynamic' call
    this.t9g_1.drawArraysInstanced(mode, first, count, instancecount);
  }
  e7l(mode, count, type, indices, instancecount) {
    // Inline function 'kotlin.js.asDynamic' call
    this.t9g_1.drawElementsInstanced(mode, count, type, indices, instancecount);
  }
  j7l(index, divisor) {
    // Inline function 'kotlin.js.asDynamic' call
    this.t9g_1.vertexAttribDivisor(index, divisor);
  }
  t6u() {
    return get_versionInt(this) >= 2;
  }
  w7l(target, index, buffer, offset, size) {
    // Inline function 'kotlin.js.asDynamic' call
    this.t9g_1.bindBufferRange(target, index, get_2(buffer, this), offset, size);
  }
  b7h(program, name) {
    // Inline function 'kotlin.js.asDynamic' call
    return this.t9g_1.getUniformBlockIndex(get_2(program, this), name);
  }
  c7h(program, uniformBlockIndex, uniformBlockBinding) {
    // Inline function 'kotlin.js.asDynamic' call
    this.t9g_1.uniformBlockBinding(get_2(program, this), uniformBlockIndex, uniformBlockBinding);
  }
  u6u() {
    return this.z9g_1.h9h();
  }
  w8c(n, arrays) {
    var inductionVariable = 0;
    if (inductionVariable < n)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = this.t9g_1.createVertexArray();
        setInt32(arrays, i, alloc(tmp$ret$1, this));
      }
       while (inductionVariable < n);
  }
  l7l(array) {
    // Inline function 'kotlin.js.asDynamic' call
    this.t9g_1.bindVertexArray(get_2(array, this));
  }
}
class WebGLExtension {
  constructor(canvas, name, coreSince, functions, suffix) {
    coreSince = coreSince === VOID ? 1000 : coreSince;
    functions = functions === VOID ? emptyList() : functions;
    suffix = suffix === VOID ? '' : suffix;
    this.a9h_1 = canvas;
    this.b9h_1 = name;
    this.c9h_1 = coreSince;
    this.d9h_1 = functions;
    this.e9h_1 = suffix;
    this.f9h_1 = false;
    this.g9h_1 = null;
  }
  u1() {
    if (!this.f9h_1) {
      this.f9h_1 = true;
      this.g9h_1 = this.a9h_1.t9g_1.getExtension(this.b9h_1);
      var _iterator__ex2g4s = this.d9h_1.a1();
      while (_iterator__ex2g4s.b1()) {
        var func = _iterator__ex2g4s.c1();
        var base = removeSuffix(func, this.e9h_1);
        var vfunc = this.g9h_1[func];
        if (typeof vfunc === 'function') {
          // Inline function 'kotlin.js.asDynamic' call
          this.a9h_1.t9g_1[base] = vfunc.bind(this.g9h_1);
        }
      }
    }
    return this.g9h_1;
  }
  h9h() {
    return this.a9h_1.s9g_1 >= this.c9h_1 || this.u1() != null;
  }
}
class KorgeReloadInternal$1 extends KorgeReloadInternalImpl {}
class NativeVibration {
  constructor(coroutineContext) {
    this.i9h_1 = coroutineContext;
  }
  j9h(time, amplitude) {
    window.navigator.vibrate(get_milliseconds(time));
  }
}
class JsGameWindow extends GameWindow {
  static d9s() {
    return this.y8v();
  }
}
class NodeJsGameWindow extends JsGameWindow {
  static w9m() {
    return this.d9s();
  }
}
class BrowserCanvasJsGameWindow$close$slambda {
  constructor(this$0) {
    this.e9s_1 = this$0;
  }
  fe($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
  }
}
class BrowserCanvasJsGameWindow$loop$slambda {
  constructor($entry, this$0) {
    this.f9s_1 = $entry;
    this.g9s_1 = this$0;
  }
  fe($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this), $completion);
  }
}
class BrowserCanvasJsGameWindow extends JsGameWindow {
  static k9k(canvas) {
    canvas = canvas === VOID ? AGDefaultCanvas() : canvas;
    var $this = this.d9s();
    $this.v9j_1 = canvas;
    $this.w9j_1 = AGWebgl(new AGConfig(), $this.v9j_1);
    $this.x9j_1 = new DialogInterfaceJs();
    $this.y9j_1 = null;
    var tmp = $this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.z9j_1 = [GameButton_BUTTON_SOUTH_getInstance(), GameButton_BUTTON_EAST_getInstance(), GameButton_BUTTON_WEST_getInstance(), GameButton_BUTTON_NORTH_getInstance(), GameButton_L1_getInstance(), GameButton_R1_getInstance(), GameButton_L2_getInstance(), GameButton_R2_getInstance(), GameButton_SELECT_getInstance(), GameButton_START_getInstance(), GameButton_L3_getInstance(), GameButton_R3_getInstance(), GameButton_UP_getInstance(), GameButton_DOWN_getInstance(), GameButton_LEFT_getInstance(), GameButton_RIGHT_getInstance(), GameButton_SYSTEM_getInstance()];
    var tmp_0 = $this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_0.a9k_1 = [GameButton_LX_getInstance(), GameButton_LY_getInstance(), GameButton_RX_getInstance(), GameButton_RY_getInstance(), GameButton_L2_getInstance(), GameButton_R2_getInstance(), GameButton_DPADX_getInstance(), GameButton_DPADY_getInstance()];
    $this.b9k_1 = new GamepadInfo();
    $this.c9k_1 = Quality_AUTOMATIC_getInstance();
    $this.d9k_1 = 1.0;
    $this.e9k_1 = new TouchBuilder();
    $this.f9k_1 = Cursor_DEFAULT_getInstance();
    $this.g9k_1 = null;
    $this.h9k_1 = null;
    // Inline function 'kotlin.js.asDynamic' call
    window.canvas = $this.v9j_1;
    // Inline function 'kotlin.js.asDynamic' call
    window.ag = $this.p8w();
    // Inline function 'kotlin.js.asDynamic' call
    window.gl = $this.p8w().m7e_1;
    if (get_isCanvasCreatedAndHandled()) {
      var tmp0_safe_receiver = document.body;
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver.appendChild($this.v9j_1);
      var tmp1_safe_receiver = document.body;
      var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.style;
      if (tmp2_safe_receiver == null)
        null;
      else {
        tmp2_safe_receiver.margin = '0px';
      }
      var tmp3_safe_receiver = document.body;
      var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.style;
      if (tmp4_safe_receiver == null)
        null;
      else {
        tmp4_safe_receiver.padding = '0px';
      }
      var tmp5_safe_receiver = document.body;
      var tmp6_safe_receiver = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.style;
      if (tmp6_safe_receiver == null)
        null;
      else {
        tmp6_safe_receiver.overflowX = 'hidden';
      }
      var tmp7_safe_receiver = document.body;
      var tmp8_safe_receiver = tmp7_safe_receiver == null ? null : tmp7_safe_receiver.style;
      if (tmp8_safe_receiver == null)
        null;
      else {
        tmp8_safe_receiver.overflowY = 'hidden';
      }
    }
    $this.v9j_1.addEventListener('wheel', BrowserCanvasJsGameWindow$lambda($this));
    $this.v9j_1.addEventListener('mouseenter', BrowserCanvasJsGameWindow$lambda_0($this));
    $this.v9j_1.addEventListener('mouseleave', BrowserCanvasJsGameWindow$lambda_1($this));
    $this.v9j_1.addEventListener('mouseover', BrowserCanvasJsGameWindow$lambda_2($this));
    $this.v9j_1.addEventListener('mousemove', BrowserCanvasJsGameWindow$lambda_3($this));
    $this.v9j_1.addEventListener('mouseout', BrowserCanvasJsGameWindow$lambda_4($this));
    $this.v9j_1.addEventListener('mouseup', BrowserCanvasJsGameWindow$lambda_5($this));
    $this.v9j_1.addEventListener('mousedown', BrowserCanvasJsGameWindow$lambda_6($this));
    $this.v9j_1.addEventListener('click', BrowserCanvasJsGameWindow$lambda_7($this));
    $this.v9j_1.addEventListener('touchstart', BrowserCanvasJsGameWindow$lambda_8($this));
    $this.v9j_1.addEventListener('touchmove', BrowserCanvasJsGameWindow$lambda_9($this));
    $this.v9j_1.addEventListener('touchend', BrowserCanvasJsGameWindow$lambda_10($this));
    var tmp_1 = window;
    tmp_1.addEventListener('keypress', BrowserCanvasJsGameWindow$lambda_11($this));
    var tmp_2 = window;
    tmp_2.addEventListener('keydown', BrowserCanvasJsGameWindow$lambda_12($this));
    var tmp_3 = window;
    tmp_3.addEventListener('keyup', BrowserCanvasJsGameWindow$lambda_13($this));
    var tmp_4 = window;
    tmp_4.addEventListener('resize', BrowserCanvasJsGameWindow$lambda_14($this));
    $this.v9j_1.ondragenter = BrowserCanvasJsGameWindow$lambda_15($this);
    $this.v9j_1.ondragexit = BrowserCanvasJsGameWindow$lambda_16($this);
    $this.v9j_1.ondragleave = BrowserCanvasJsGameWindow$lambda_17($this);
    $this.v9j_1.ondragover = BrowserCanvasJsGameWindow$lambda_18;
    $this.v9j_1.ondragstart = BrowserCanvasJsGameWindow$lambda_19($this);
    $this.v9j_1.ondragend = BrowserCanvasJsGameWindow$lambda_20($this);
    $this.v9j_1.ondrop = BrowserCanvasJsGameWindow$lambda_21($this);
    onResized($this);
    var tmp_5 = $this;
    tmp_5.i9k_1 = BrowserCanvasJsGameWindow$lambda_22($this);
    $this.j9k_1 = null;
    return $this;
  }
  i9s() {
    return window.devicePixelRatio;
  }
  n8p() {
    return this.i9s() <= 0.0 ? 1.0 : isNaN_0(this.i9s()) ? 1.0 : isInfinite(this.i9s()) ? 1.0 : this.i9s();
  }
  p8w() {
    return this.w9j_1;
  }
  h9s() {
    if (this.y9j_1 == null) {
      var tmp = this;
      var tmp_0;
      try {
        document.createEvent('TouchEvent');
        tmp_0 = true;
      } catch ($p) {
        var tmp_1;
        var e = $p;
        tmp_1 = false;
        tmp_0 = tmp_1;
      }
      tmp.y9j_1 = tmp_0;
    }
    return ensureNotNull(this.y9j_1);
  }
  t8x() {
    try {
      if (navigator.getGamepads != null) {
        // Inline function 'kotlin.js.unsafeCast' call
        var gamepads = navigator.getGamepads();
        this.d6r();
        var inductionVariable = 0;
        var last = gamepads.length;
        if (inductionVariable < last)
          $l$loop_0: do {
            var gamepadId = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'korlibs.render.get' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp0_elvis_lhs = gamepads[gamepadId];
            var tmp;
            if (tmp0_elvis_lhs == null) {
              continue $l$loop_0;
            } else {
              tmp = tmp0_elvis_lhs;
            }
            var controller = tmp;
            if (!(controller.mapping === 'standard'))
              continue $l$loop_0;
            var gamepad = this.b9k_1;
            gamepad.k6r_1 = controller.id;
            var inductionVariable_0 = 0;
            // Inline function 'kotlin.math.min' call
            var a = controller.buttons.length;
            var b = this.z9j_1.length;
            var last_0 = Math.min(a, b);
            if (inductionVariable_0 < last_0)
              do {
                var n = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                var tmp_0 = gamepad.l6r_1;
                var tmp_1 = this.z9j_1[n].h6s();
                // Inline function 'korlibs.render.get' call
                // Inline function 'kotlin.js.asDynamic' call
                tmp_0[tmp_1] = controller.buttons[n].value;
              }
               while (inductionVariable_0 < last_0);
            var inductionVariable_1 = 0;
            // Inline function 'kotlin.math.min' call
            var a_0 = controller.axes.length;
            var b_0 = this.a9k_1.length;
            var last_1 = Math.min(a_0, b_0);
            if (inductionVariable_1 < last_1)
              do {
                var n_0 = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                var isX = (n_0 % 2 | 0) === 0;
                var isY = !isX;
                // Inline function 'korlibs.render.get' call
                // Inline function 'kotlin.js.asDynamic' call
                var value = controller.axes[n_0];
                var valueWithoutDeadRange = Companion_instance_24.c6s(value, VOID, n_0 <= 3);
                gamepad.l6r_1[this.a9k_1[n_0].h6s()] = isY ? -valueWithoutDeadRange : valueWithoutDeadRange;
              }
               while (inductionVariable_1 < last_1);
            this.p6r(gamepad);
          }
           while (inductionVariable < last);
        this.x8x();
      }
    } catch ($p) {
      var e = $p;
      // Inline function 'korlibs.logger.Logger.error' call
      var this_0 = CoroutineKey_getInstance().x8s_1;
      var level = Level_ERROR_getInstance();
      var tmp_2;
      if (this_0.q31(level)) {
        // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.updateGamepads.<anonymous>' call
        this_0.r31(level, e);
        tmp_2 = Unit_instance;
      }
    }
  }
  c8x(value) {
    if (!this.c9k_1.equals(value)) {
      this.c9k_1 = value;
      onResized(this);
    }
  }
  v8o() {
    return this.c9k_1;
  }
  w8w(value) {
    document.title = value;
  }
  x2p() {
    return this.v9j_1.clientWidth;
  }
  y2p() {
    return this.v9j_1.clientHeight;
  }
  n8w(value) {
    this.f9k_1 = value;
    var tmp = this.v9j_1.style;
    var tmp_0;
    if (value instanceof Cursor) {
      switch (value.t3_1) {
        case 0:
          tmp_0 = 'default';
          break;
        case 1:
          tmp_0 = 'crosshair';
          break;
        case 2:
          tmp_0 = 'text';
          break;
        case 3:
          tmp_0 = 'pointer';
          break;
        case 4:
          tmp_0 = 'move';
          break;
        case 5:
          tmp_0 = 'wait';
          break;
        case 6:
          tmp_0 = 'e-resize';
          break;
        case 7:
          tmp_0 = 'w-resize';
          break;
        case 8:
          tmp_0 = 's-resize';
          break;
        case 9:
          tmp_0 = 'n-resize';
          break;
        case 10:
          tmp_0 = 'ne-resize';
          break;
        case 11:
          tmp_0 = 'nw-resize';
          break;
        case 12:
          tmp_0 = 'se-resize';
          break;
        case 13:
          tmp_0 = 'sw-resize';
          break;
        default:
          tmp_0 = 'default';
          break;
      }
    } else {
      tmp_0 = 'default';
    }
    tmp.cursor = tmp_0;
  }
  o8w() {
    return this.f9k_1;
  }
  x8w(value) {
    this.g9k_1 = value;
    if (!(value == null)) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var link = document.querySelector("link[rel*='icon']");
      link.type = 'image/png';
      link.rel = 'shortcut icon';
      link.href = toHtmlNative(value).k5x();
      // Inline function 'org.w3c.dom.get' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp0_safe_receiver = document.getElementsByTagName('head')[0];
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver.appendChild(link);
    } else {
      var tmp1_safe_receiver = document.querySelector("link[rel*='icon']");
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.remove();
      }
    }
  }
  y8w(value) {
    if (!(this.j9s() === value)) {
      // Inline function 'kotlin.runCatching' call
      var tmp;
      try {
        // Inline function 'kotlin.Companion.success' call
        // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.<set-fullscreen>.<anonymous>' call
        var tmp_0;
        if (value) {
          tmp_0 = this.v9j_1.requestFullscreen();
        } else {
          tmp_0 = document.exitFullscreen();
        }
        var value_0 = tmp_0;
        tmp = _Result___init__impl__xyqfz8(value_0);
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var e = $p;
          // Inline function 'kotlin.Companion.failure' call
          tmp_1 = _Result___init__impl__xyqfz8(createFailure(e));
        } else {
          throw $p;
        }
        tmp = tmp_1;
      }
    }
  }
  j9s() {
    return !(document.fullscreenElement == null);
  }
  z8w(value) {
    this.v9j_1.style.visibility = value ? 'visible' : 'hidden';
  }
  f8x(width, height) {
  }
  b1g(exitCode) {
    var tmp = MainScope();
    launchImmediately_0(tmp, BrowserCanvasJsGameWindow$close$slambda_0(this));
    this.h9k_1 = null;
  }
  k8x(entry, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_loop__qll5p8_0.bind(VOID, this, entry), $completion);
  }
  y8x(data, $completion) {
    try {
      var tmp = _get_navigatorClipboard__ni2gks(this);
      tmp.writeText((data instanceof TextClipboardData ? data : THROW_CCE()).n8y_1);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        console.error('Failed to write to clipboard: ' + e.message);
      } else {
        throw $p;
      }
    }
  }
}
class DenoJsGameWindow$loop$slambda {
  constructor($entry, this$0) {
    this.k9s_1 = $entry;
    this.l9s_1 = this$0;
  }
  fe($completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this), $completion);
  }
}
class DenoJsGameWindow extends SDLGameWindow {
  static r9p(size, config) {
    size = size === VOID ? Size2D.o2e(640, 480) : size;
    config = config === VOID ? Companion_getInstance_75().z8x_1 : config;
    return this.f9g(size, config);
  }
  k8x(entry, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_loop__qll5p8_1.bind(VOID, this, entry), $completion);
  }
  b1g(exitCode) {
    super.b1g(exitCode);
    Deno.exit(exitCode);
  }
}
class DialogInterfaceJs {}
//endregion
function _get_now__e6dlkr($this) {
  return $this.m6k_1().xj_1;
}
function _queueAfter($this, time, interval, task) {
  // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
  var this_0 = $this.j6k_1;
  $l$block: {
    // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
    this_0.b20();
    try {
      // Inline function 'korlibs.datastructure.event.SyncEventLoop._queueAfter.<anonymous>' call
      var task_0 = new TimedTask($this, _get_now__e6dlkr($this), time, interval, task);
      if ($this.k6k_1) {
        $this.o6k_1.j2u(task_0);
      } else {
        Console_getInstance().x30(['WARNING: QUEUED TASK time=' + Duration__toString_impl_8d916b(time) + ' interval=' + interval + ' without running']);
      }
      $this.j6k_1.f20();
      break $l$block;
    }finally {
      this_0.d20();
    }
  }
  return task_0;
}
function SyncEventLoop$nowProvider$lambda(this$0) {
  return function () {
    return new Duration(ValueTimeMark__elapsedNow_impl_eonqvs(this$0.l6k_1));
  };
}
function SyncEventLoop$timedTasks$lambda(a, b) {
  return a.e6k(b);
}
function SyncEventLoop$uncatchedExceptionHandler$lambda(it) {
  printStackTrace(it);
  return Unit_instance;
}
function paused$factory($b0) {
  return getPropertyCallableRef('paused', 0, KMutableProperty0, function () {
    return $b0.f2z_1;
  }, function (value) {
    return $b0.g2z(value);
  });
}
function __updateChildListenerCount($this, type, delta) {
  if (delta === 0)
    return Unit_instance;
  if ($this.i6l_1 == null)
    $this.i6l_1 = FastIdentityMap();
  var tmp0_safe_receiver = $this.i6l_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    var tmp1_elvis_lhs = get_0(ensureNotNull($this.i6l_1), type);
    set(tmp0_safe_receiver, type, (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) + delta | 0);
  }
  var tmp2_safe_receiver = $this.g6l_1;
  if (tmp2_safe_receiver == null)
    null;
  else {
    __updateChildListenerCount(tmp2_safe_receiver, type, delta);
  }
}
function __updateChildListenerCount_0($this, child, add) {
  var tmp0_safe_receiver = child.i6l_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'korlibs.datastructure.fastForEach' call
    // Inline function 'korlibs.datastructure.fastKeyForEach' call
    // Inline function 'kotlin.js.asDynamic' call
    var mapIterator = tmp0_safe_receiver.keys();
    $l$loop: while (true) {
      var v = mapIterator.next();
      if (v.done)
        break $l$loop;
      // Inline function 'korlibs.datastructure.fastForEach.<anonymous>' call
      var it = v.value;
      // Inline function 'korlibs.event.BaseEventListener.__updateChildListenerCount.<anonymous>' call
      var i = ensureNotNull(get_0(tmp0_safe_receiver, it));
      __updateChildListenerCount($this, it, add ? +i : -i | 0);
    }
  }
}
var Companion_instance_8;
function Companion_getInstance_14() {
  return Companion_instance_8;
}
var Companion_instance_9;
function Companion_getInstance_15() {
  return Companion_instance_9;
}
var Companion_instance_10;
function Companion_getInstance_16() {
  return Companion_instance_10;
}
var Companion_instance_11;
function Companion_getInstance_17() {
  return Companion_instance_11;
}
var Companion_instance_12;
function Companion_getInstance_18() {
  if (Companion_instance_12 === VOID)
    new Companion_3();
  return Companion_instance_12;
}
var Companion_instance_13;
function Companion_getInstance_19() {
  if (Companion_instance_13 === VOID)
    new Companion_4();
  return Companion_instance_13;
}
var Companion_instance_14;
function Companion_getInstance_20() {
  return Companion_instance_14;
}
var Companion_instance_15;
function Companion_getInstance_21() {
  return Companion_instance_15;
}
var Companion_instance_16;
function Companion_getInstance_22() {
  return Companion_instance_16;
}
var Type_UP_instance;
var Type_DOWN_instance;
var Type_TYPE_instance;
var Companion_instance_17;
function Companion_getInstance_23() {
  Type_initEntries();
  if (Companion_instance_17 === VOID)
    new Companion_8();
  return Companion_instance_17;
}
function values() {
  return [Type_UP_getInstance(), Type_DOWN_getInstance(), Type_TYPE_getInstance()];
}
var Type_entriesInitialized;
function Type_initEntries() {
  if (Type_entriesInitialized)
    return Unit_instance;
  Type_entriesInitialized = true;
  Type_UP_instance = new Type('UP', 0);
  Type_DOWN_instance = new Type('DOWN', 1);
  Type_TYPE_instance = new Type('TYPE', 2);
  Companion_getInstance_23();
}
function Type_UP_getInstance() {
  Type_initEntries();
  return Type_UP_instance;
}
function Type_DOWN_getInstance() {
  Type_initEntries();
  return Type_DOWN_instance;
}
function Type_TYPE_getInstance() {
  Type_initEntries();
  return Type_TYPE_instance;
}
var Type_MOVE_instance;
var Type_DRAG_instance;
var Type_UP_instance_0;
var Type_DOWN_instance_0;
var Type_CLICK_instance;
var Type_ENTER_instance;
var Type_EXIT_instance;
var Type_SCROLL_instance;
var Companion_instance_18;
function Companion_getInstance_24() {
  Type_initEntries_0();
  if (Companion_instance_18 === VOID)
    new Companion_9();
  return Companion_instance_18;
}
function values_0() {
  return [Type_MOVE_getInstance(), Type_DRAG_getInstance(), Type_UP_getInstance_0(), Type_DOWN_getInstance_0(), Type_CLICK_getInstance(), Type_ENTER_getInstance(), Type_EXIT_getInstance(), Type_SCROLL_getInstance()];
}
var Type_entriesInitialized_0;
function Type_initEntries_0() {
  if (Type_entriesInitialized_0)
    return Unit_instance;
  Type_entriesInitialized_0 = true;
  Type_MOVE_instance = new Type_0('MOVE', 0);
  Type_DRAG_instance = new Type_0('DRAG', 1);
  Type_UP_instance_0 = new Type_0('UP', 2);
  Type_DOWN_instance_0 = new Type_0('DOWN', 3);
  Type_CLICK_instance = new Type_0('CLICK', 4);
  Type_ENTER_instance = new Type_0('ENTER', 5);
  Type_EXIT_instance = new Type_0('EXIT', 6);
  Type_SCROLL_instance = new Type_0('SCROLL', 7);
  Companion_getInstance_24();
}
var ScrollDeltaMode_PIXEL_instance;
var ScrollDeltaMode_LINE_instance;
var ScrollDeltaMode_PAGE_instance;
var ScrollDeltaMode_entriesInitialized;
function ScrollDeltaMode_initEntries() {
  if (ScrollDeltaMode_entriesInitialized)
    return Unit_instance;
  ScrollDeltaMode_entriesInitialized = true;
  ScrollDeltaMode_PIXEL_instance = new ScrollDeltaMode('PIXEL', 0, 1.0);
  ScrollDeltaMode_LINE_instance = new ScrollDeltaMode('LINE', 1, 10.0);
  ScrollDeltaMode_PAGE_instance = new ScrollDeltaMode('PAGE', 2, 100.0);
}
function MouseEvent$requestLock$lambda() {
  return Unit_instance;
}
function Type_MOVE_getInstance() {
  Type_initEntries_0();
  return Type_MOVE_instance;
}
function Type_DRAG_getInstance() {
  Type_initEntries_0();
  return Type_DRAG_instance;
}
function Type_UP_getInstance_0() {
  Type_initEntries_0();
  return Type_UP_instance_0;
}
function Type_DOWN_getInstance_0() {
  Type_initEntries_0();
  return Type_DOWN_instance_0;
}
function Type_CLICK_getInstance() {
  Type_initEntries_0();
  return Type_CLICK_instance;
}
function Type_ENTER_getInstance() {
  Type_initEntries_0();
  return Type_ENTER_instance;
}
function Type_EXIT_getInstance() {
  Type_initEntries_0();
  return Type_EXIT_instance;
}
function Type_SCROLL_getInstance() {
  Type_initEntries_0();
  return Type_SCROLL_instance;
}
function ScrollDeltaMode_PIXEL_getInstance() {
  ScrollDeltaMode_initEntries();
  return ScrollDeltaMode_PIXEL_instance;
}
function ScrollDeltaMode_LINE_getInstance() {
  ScrollDeltaMode_initEntries();
  return ScrollDeltaMode_LINE_instance;
}
function ScrollDeltaMode_PAGE_getInstance() {
  ScrollDeltaMode_initEntries();
  return ScrollDeltaMode_PAGE_instance;
}
var Type_MAGNIFY_instance;
var Type_ROTATE_instance;
var Type_SWIPE_instance;
var Type_SMART_MAGNIFY_instance;
var Companion_instance_19;
function Companion_getInstance_25() {
  Type_initEntries_1();
  if (Companion_instance_19 === VOID)
    new Companion_10();
  return Companion_instance_19;
}
function values_1() {
  return [Type_MAGNIFY_getInstance(), Type_ROTATE_getInstance(), Type_SWIPE_getInstance(), Type_SMART_MAGNIFY_getInstance()];
}
var Type_entriesInitialized_1;
function Type_initEntries_1() {
  if (Type_entriesInitialized_1)
    return Unit_instance;
  Type_entriesInitialized_1 = true;
  Type_MAGNIFY_instance = new Type_1('MAGNIFY', 0);
  Type_ROTATE_instance = new Type_1('ROTATE', 1);
  Type_SWIPE_instance = new Type_1('SWIPE', 2);
  Type_SMART_MAGNIFY_instance = new Type_1('SMART_MAGNIFY', 3);
  Companion_getInstance_25();
}
function Type_MAGNIFY_getInstance() {
  Type_initEntries_1();
  return Type_MAGNIFY_instance;
}
function Type_ROTATE_getInstance() {
  Type_initEntries_1();
  return Type_ROTATE_instance;
}
function Type_SWIPE_getInstance() {
  Type_initEntries_1();
  return Type_SWIPE_instance;
}
function Type_SMART_MAGNIFY_getInstance() {
  Type_initEntries_1();
  return Type_SMART_MAGNIFY_instance;
}
var Type_START_instance;
var Type_END_instance;
var Type_DROP_instance;
var Companion_instance_20;
function Companion_getInstance_26() {
  Type_initEntries_2();
  if (Companion_instance_20 === VOID)
    new Companion_11();
  return Companion_instance_20;
}
function values_2() {
  return [Type_START_getInstance(), Type_END_getInstance(), Type_DROP_getInstance()];
}
var Type_entriesInitialized_2;
function Type_initEntries_2() {
  if (Type_entriesInitialized_2)
    return Unit_instance;
  Type_entriesInitialized_2 = true;
  Type_START_instance = new Type_2('START', 0);
  Type_END_instance = new Type_2('END', 1);
  Type_DROP_instance = new Type_2('DROP', 2);
  Companion_getInstance_26();
}
function Type_START_getInstance() {
  Type_initEntries_2();
  return Type_START_instance;
}
function Type_END_getInstance() {
  Type_initEntries_2();
  return Type_END_instance;
}
function Type_DROP_getInstance() {
  Type_initEntries_2();
  return Type_DROP_instance;
}
var Status_ADD_instance;
var Status_KEEP_instance;
var Status_REMOVE_instance;
var Status_entriesInitialized;
function Status_initEntries() {
  if (Status_entriesInitialized)
    return Unit_instance;
  Status_entriesInitialized = true;
  Status_ADD_instance = new Status('ADD', 0);
  Status_KEEP_instance = new Status('KEEP', 1);
  Status_REMOVE_instance = new Status('REMOVE', 2);
}
var Kind_FINGER_instance;
var Kind_MOUSE_instance;
var Kind_STYLUS_instance;
var Kind_ERASER_instance;
var Kind_UNKNOWN_instance;
var Kind_entriesInitialized;
function Kind_initEntries() {
  if (Kind_entriesInitialized)
    return Unit_instance;
  Kind_entriesInitialized = true;
  Kind_FINGER_instance = new Kind('FINGER', 0);
  Kind_MOUSE_instance = new Kind('MOUSE', 1);
  Kind_STYLUS_instance = new Kind('STYLUS', 2);
  Kind_ERASER_instance = new Kind('ERASER', 3);
  Kind_UNKNOWN_instance = new Kind('UNKNOWN', 4);
}
var Companion_instance_21;
function Companion_getInstance_27() {
  if (Companion_instance_21 === VOID)
    new Companion_12();
  return Companion_instance_21;
}
function Status_ADD_getInstance() {
  Status_initEntries();
  return Status_ADD_instance;
}
function Status_KEEP_getInstance() {
  Status_initEntries();
  return Status_KEEP_instance;
}
function Status_REMOVE_getInstance() {
  Status_initEntries();
  return Status_REMOVE_instance;
}
function Kind_FINGER_getInstance() {
  Kind_initEntries();
  return Kind_FINGER_instance;
}
function Kind_MOUSE_getInstance() {
  Kind_initEntries();
  return Kind_MOUSE_instance;
}
var Type_START_instance_0;
var Type_END_instance_0;
var Type_MOVE_instance_0;
var Type_HOVER_instance;
var Type_UNKNOWN_instance;
var Companion_instance_22;
function Companion_getInstance_28() {
  Type_initEntries_3();
  if (Companion_instance_22 === VOID)
    new Companion_13();
  return Companion_instance_22;
}
function values_3() {
  return [Type_START_getInstance_0(), Type_END_getInstance_0(), Type_MOVE_getInstance_0(), Type_HOVER_getInstance(), Type_UNKNOWN_getInstance()];
}
var Type_entriesInitialized_3;
function Type_initEntries_3() {
  if (Type_entriesInitialized_3)
    return Unit_instance;
  Type_entriesInitialized_3 = true;
  Type_START_instance_0 = new Type_3('START', 0);
  Type_END_instance_0 = new Type_3('END', 1);
  Type_MOVE_instance_0 = new Type_3('MOVE', 2);
  Type_HOVER_instance = new Type_3('HOVER', 3);
  Type_UNKNOWN_instance = new Type_3('UNKNOWN', 4);
  Companion_getInstance_28();
}
var Companion_instance_23;
function Companion_getInstance_29() {
  return Companion_instance_23;
}
function TouchEvent$toString$lambda(it) {
  return it.toString();
}
function Type_START_getInstance_0() {
  Type_initEntries_3();
  return Type_START_instance_0;
}
function Type_END_getInstance_0() {
  Type_initEntries_3();
  return Type_END_instance_0;
}
function Type_MOVE_getInstance_0() {
  Type_initEntries_3();
  return Type_MOVE_instance_0;
}
function Type_HOVER_getInstance() {
  Type_initEntries_3();
  return Type_HOVER_instance;
}
function Type_UNKNOWN_getInstance() {
  Type_initEntries_3();
  return Type_UNKNOWN_instance;
}
function invoke_0(_this__u8e3s4, block) {
  block(_this__u8e3s4);
  return _this__u8e3s4;
}
var Mode_JS_instance;
var Mode_Android_instance;
var Mode_IOS_instance;
var Mode_entriesInitialized;
function Mode_initEntries() {
  if (Mode_entriesInitialized)
    return Unit_instance;
  Mode_entriesInitialized = true;
  Mode_JS_instance = new Mode('JS', 0);
  Mode_Android_instance = new Mode('Android', 1);
  Mode_IOS_instance = new Mode('IOS', 2);
}
function Mode_JS_getInstance() {
  Mode_initEntries();
  return Mode_JS_instance;
}
var BatteryStatus_CHARGING_instance;
var BatteryStatus_DISCHARGING_instance;
var BatteryStatus_FULL_instance;
var BatteryStatus_UNKNOWN_instance;
var BatteryStatus_entriesInitialized;
function BatteryStatus_initEntries() {
  if (BatteryStatus_entriesInitialized)
    return Unit_instance;
  BatteryStatus_entriesInitialized = true;
  BatteryStatus_CHARGING_instance = new BatteryStatus('CHARGING', 0);
  BatteryStatus_DISCHARGING_instance = new BatteryStatus('DISCHARGING', 1);
  BatteryStatus_FULL_instance = new BatteryStatus('FULL', 2);
  BatteryStatus_UNKNOWN_instance = new BatteryStatus('UNKNOWN', 3);
}
var Companion_instance_24;
function Companion_getInstance_30() {
  return Companion_instance_24;
}
function BatteryStatus_UNKNOWN_getInstance() {
  BatteryStatus_initEntries();
  return BatteryStatus_UNKNOWN_instance;
}
var Companion_instance_25;
function Companion_getInstance_31() {
  return Companion_instance_25;
}
var Type_CONNECTED_instance;
var Type_DISCONNECTED_instance;
var Companion_instance_26;
function Companion_getInstance_32() {
  Type_initEntries_4();
  if (Companion_instance_26 === VOID)
    new Companion_17();
  return Companion_instance_26;
}
function values_4() {
  return [Type_CONNECTED_getInstance(), Type_DISCONNECTED_getInstance()];
}
var Type_entriesInitialized_4;
function Type_initEntries_4() {
  if (Type_entriesInitialized_4)
    return Unit_instance;
  Type_entriesInitialized_4 = true;
  Type_CONNECTED_instance = new Type_4('CONNECTED', 0);
  Type_DISCONNECTED_instance = new Type_4('DISCONNECTED', 1);
  Companion_getInstance_32();
}
function Type_CONNECTED_getInstance() {
  Type_initEntries_4();
  return Type_CONNECTED_instance;
}
function Type_DISCONNECTED_getInstance() {
  Type_initEntries_4();
  return Type_DISCONNECTED_instance;
}
var GameButton_LEFT_instance;
var GameButton_RIGHT_instance;
var GameButton_UP_instance;
var GameButton_DOWN_instance;
var GameButton_BUTTON_SOUTH_instance;
var GameButton_BUTTON_EAST_instance;
var GameButton_BUTTON_WEST_instance;
var GameButton_BUTTON_NORTH_instance;
var GameButton_SELECT_instance;
var GameButton_START_instance;
var GameButton_SYSTEM_instance;
var GameButton_L1_instance;
var GameButton_R1_instance;
var GameButton_L2_instance;
var GameButton_R2_instance;
var GameButton_L3_instance;
var GameButton_R3_instance;
var GameButton_LX_instance;
var GameButton_LY_instance;
var GameButton_RX_instance;
var GameButton_RY_instance;
var GameButton_BUTTON4_instance;
var GameButton_BUTTON5_instance;
var GameButton_BUTTON6_instance;
var GameButton_BUTTON7_instance;
var GameButton_BUTTON8_instance;
var GameButton_RECORD_instance;
var GameButton_DPADX_instance;
var GameButton_DPADY_instance;
var Companion_instance_27;
function Companion_getInstance_33() {
  GameButton_initEntries();
  if (Companion_instance_27 === VOID)
    new Companion_18();
  return Companion_instance_27;
}
function values_5() {
  return [GameButton_LEFT_getInstance(), GameButton_RIGHT_getInstance(), GameButton_UP_getInstance(), GameButton_DOWN_getInstance(), GameButton_BUTTON_SOUTH_getInstance(), GameButton_BUTTON_EAST_getInstance(), GameButton_BUTTON_WEST_getInstance(), GameButton_BUTTON_NORTH_getInstance(), GameButton_SELECT_getInstance(), GameButton_START_getInstance(), GameButton_SYSTEM_getInstance(), GameButton_L1_getInstance(), GameButton_R1_getInstance(), GameButton_L2_getInstance(), GameButton_R2_getInstance(), GameButton_L3_getInstance(), GameButton_R3_getInstance(), GameButton_LX_getInstance(), GameButton_LY_getInstance(), GameButton_RX_getInstance(), GameButton_RY_getInstance(), GameButton_BUTTON4_getInstance(), GameButton_BUTTON5_getInstance(), GameButton_BUTTON6_getInstance(), GameButton_BUTTON7_getInstance(), GameButton_BUTTON8_getInstance(), GameButton_RECORD_getInstance(), GameButton_DPADX_getInstance(), GameButton_DPADY_getInstance()];
}
var GameButton_entriesInitialized;
function GameButton_initEntries() {
  if (GameButton_entriesInitialized)
    return Unit_instance;
  GameButton_entriesInitialized = true;
  GameButton_LEFT_instance = new GameButton('LEFT', 0);
  GameButton_RIGHT_instance = new GameButton('RIGHT', 1);
  GameButton_UP_instance = new GameButton('UP', 2);
  GameButton_DOWN_instance = new GameButton('DOWN', 3);
  GameButton_BUTTON_SOUTH_instance = new GameButton('BUTTON_SOUTH', 4);
  GameButton_BUTTON_EAST_instance = new GameButton('BUTTON_EAST', 5);
  GameButton_BUTTON_WEST_instance = new GameButton('BUTTON_WEST', 6);
  GameButton_BUTTON_NORTH_instance = new GameButton('BUTTON_NORTH', 7);
  GameButton_SELECT_instance = new GameButton('SELECT', 8);
  GameButton_START_instance = new GameButton('START', 9);
  GameButton_SYSTEM_instance = new GameButton('SYSTEM', 10);
  GameButton_L1_instance = new GameButton('L1', 11);
  GameButton_R1_instance = new GameButton('R1', 12);
  GameButton_L2_instance = new GameButton('L2', 13);
  GameButton_R2_instance = new GameButton('R2', 14);
  GameButton_L3_instance = new GameButton('L3', 15);
  GameButton_R3_instance = new GameButton('R3', 16);
  GameButton_LX_instance = new GameButton('LX', 17);
  GameButton_LY_instance = new GameButton('LY', 18);
  GameButton_RX_instance = new GameButton('RX', 19);
  GameButton_RY_instance = new GameButton('RY', 20);
  GameButton_BUTTON4_instance = new GameButton('BUTTON4', 21);
  GameButton_BUTTON5_instance = new GameButton('BUTTON5', 22);
  GameButton_BUTTON6_instance = new GameButton('BUTTON6', 23);
  GameButton_BUTTON7_instance = new GameButton('BUTTON7', 24);
  GameButton_BUTTON8_instance = new GameButton('BUTTON8', 25);
  GameButton_RECORD_instance = new GameButton('RECORD', 26);
  GameButton_DPADX_instance = new GameButton('DPADX', 27);
  GameButton_DPADY_instance = new GameButton('DPADY', 28);
  Companion_getInstance_33();
}
function GameButton_LEFT_getInstance() {
  GameButton_initEntries();
  return GameButton_LEFT_instance;
}
function GameButton_RIGHT_getInstance() {
  GameButton_initEntries();
  return GameButton_RIGHT_instance;
}
function GameButton_UP_getInstance() {
  GameButton_initEntries();
  return GameButton_UP_instance;
}
function GameButton_DOWN_getInstance() {
  GameButton_initEntries();
  return GameButton_DOWN_instance;
}
function GameButton_BUTTON_SOUTH_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON_SOUTH_instance;
}
function GameButton_BUTTON_EAST_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON_EAST_instance;
}
function GameButton_BUTTON_WEST_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON_WEST_instance;
}
function GameButton_BUTTON_NORTH_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON_NORTH_instance;
}
function GameButton_SELECT_getInstance() {
  GameButton_initEntries();
  return GameButton_SELECT_instance;
}
function GameButton_START_getInstance() {
  GameButton_initEntries();
  return GameButton_START_instance;
}
function GameButton_SYSTEM_getInstance() {
  GameButton_initEntries();
  return GameButton_SYSTEM_instance;
}
function GameButton_L1_getInstance() {
  GameButton_initEntries();
  return GameButton_L1_instance;
}
function GameButton_R1_getInstance() {
  GameButton_initEntries();
  return GameButton_R1_instance;
}
function GameButton_L2_getInstance() {
  GameButton_initEntries();
  return GameButton_L2_instance;
}
function GameButton_R2_getInstance() {
  GameButton_initEntries();
  return GameButton_R2_instance;
}
function GameButton_L3_getInstance() {
  GameButton_initEntries();
  return GameButton_L3_instance;
}
function GameButton_R3_getInstance() {
  GameButton_initEntries();
  return GameButton_R3_instance;
}
function GameButton_LX_getInstance() {
  GameButton_initEntries();
  return GameButton_LX_instance;
}
function GameButton_LY_getInstance() {
  GameButton_initEntries();
  return GameButton_LY_instance;
}
function GameButton_RX_getInstance() {
  GameButton_initEntries();
  return GameButton_RX_instance;
}
function GameButton_RY_getInstance() {
  GameButton_initEntries();
  return GameButton_RY_instance;
}
function GameButton_BUTTON4_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON4_instance;
}
function GameButton_BUTTON5_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON5_instance;
}
function GameButton_BUTTON6_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON6_instance;
}
function GameButton_BUTTON7_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON7_instance;
}
function GameButton_BUTTON8_getInstance() {
  GameButton_initEntries();
  return GameButton_BUTTON8_instance;
}
function GameButton_RECORD_getInstance() {
  GameButton_initEntries();
  return GameButton_RECORD_instance;
}
function GameButton_DPADX_getInstance() {
  GameButton_initEntries();
  return GameButton_DPADX_instance;
}
function GameButton_DPADY_getInstance() {
  GameButton_initEntries();
  return GameButton_DPADY_instance;
}
var Key_SPACE_instance;
var Key_APOSTROPHE_instance;
var Key_COMMA_instance;
var Key_MINUS_instance;
var Key_PLUS_instance;
var Key_PERIOD_instance;
var Key_SLASH_instance;
var Key_N0_instance;
var Key_N1_instance;
var Key_N2_instance;
var Key_N3_instance;
var Key_N4_instance;
var Key_N5_instance;
var Key_N6_instance;
var Key_N7_instance;
var Key_N8_instance;
var Key_N9_instance;
var Key_N11_instance;
var Key_N12_instance;
var Key_N3D_MODE_instance;
var Key_SEMICOLON_instance;
var Key_EQUAL_instance;
var Key_AT_instance;
var Key_A_instance;
var Key_B_instance;
var Key_C_instance;
var Key_D_instance;
var Key_E_instance;
var Key_F_instance;
var Key_G_instance;
var Key_H_instance;
var Key_I_instance;
var Key_J_instance;
var Key_K_instance;
var Key_L_instance;
var Key_M_instance;
var Key_N_instance;
var Key_O_instance;
var Key_P_instance;
var Key_Q_instance;
var Key_R_instance;
var Key_S_instance;
var Key_T_instance;
var Key_U_instance;
var Key_V_instance;
var Key_W_instance;
var Key_X_instance;
var Key_Y_instance;
var Key_Z_instance;
var Key_LEFT_BRACKET_instance;
var Key_BACKSLASH_instance;
var Key_RIGHT_BRACKET_instance;
var Key_GRAVE_ACCENT_instance;
var Key_WORLD_1_instance;
var Key_WORLD_2_instance;
var Key_ESCAPE_instance;
var Key_META_instance;
var Key_ENTER_instance;
var Key_TAB_instance;
var Key_BACKSPACE_instance;
var Key_INSERT_instance;
var Key_DELETE_instance;
var Key_RIGHT_instance;
var Key_LEFT_instance;
var Key_DOWN_instance;
var Key_UP_instance;
var Key_PAGE_UP_instance;
var Key_PAGE_DOWN_instance;
var Key_FUNCTION_instance;
var Key_HELP_instance;
var Key_MUTE_instance;
var Key_VOLUME_DOWN_instance;
var Key_VOLUME_UP_instance;
var Key_VOLUME_MUTE_instance;
var Key_HOME_instance;
var Key_END_instance;
var Key_CAPS_LOCK_instance;
var Key_SCROLL_LOCK_instance;
var Key_NUM_LOCK_instance;
var Key_PRINT_SCREEN_instance;
var Key_PAUSE_instance;
var Key_F1_instance;
var Key_F2_instance;
var Key_F3_instance;
var Key_F4_instance;
var Key_F5_instance;
var Key_F6_instance;
var Key_F7_instance;
var Key_F8_instance;
var Key_F9_instance;
var Key_F10_instance;
var Key_F11_instance;
var Key_F12_instance;
var Key_F13_instance;
var Key_F14_instance;
var Key_F15_instance;
var Key_F16_instance;
var Key_F17_instance;
var Key_F18_instance;
var Key_F19_instance;
var Key_F20_instance;
var Key_F21_instance;
var Key_F22_instance;
var Key_F23_instance;
var Key_F24_instance;
var Key_F25_instance;
var Key_KP_0_instance;
var Key_KP_1_instance;
var Key_KP_2_instance;
var Key_KP_3_instance;
var Key_KP_4_instance;
var Key_KP_5_instance;
var Key_KP_6_instance;
var Key_KP_7_instance;
var Key_KP_8_instance;
var Key_KP_9_instance;
var Key_KP_DECIMAL_instance;
var Key_KP_DIVIDE_instance;
var Key_KP_MULTIPLY_instance;
var Key_KP_SUBTRACT_instance;
var Key_KP_ADD_instance;
var Key_KP_COMMA_instance;
var Key_KP_DOT_instance;
var Key_KP_ENTER_instance;
var Key_KP_EQUAL_instance;
var Key_KP_SEPARATOR_instance;
var Key_KP_LEFT_PAREN_instance;
var Key_KP_RIGHT_PAREN_instance;
var Key_SHIFT_instance;
var Key_CONTROL_instance;
var Key_ALT_instance;
var Key_SUPER_instance;
var Key_MENU_instance;
var Key_BACK_instance;
var Key_BACKQUOTE_instance;
var Key_QUOTE_instance;
var Key_KP_UP_instance;
var Key_KP_DOWN_instance;
var Key_KP_LEFT_instance;
var Key_KP_RIGHT_instance;
var Key_UNDERLINE_instance;
var Key_SELECT_KEY_instance;
var Key_CANCEL_instance;
var Key_CLEAR_instance;
var Key_OPEN_BRACKET_instance;
var Key_CLOSE_BRACKET_instance;
var Key_PLAY_instance;
var Key_NONAME_instance;
var Key_FINAL_instance;
var Key_OEM102_instance;
var Key_OEM1_instance;
var Key_OEM2_instance;
var Key_OEM3_instance;
var Key_OEM4_instance;
var Key_OEM5_instance;
var Key_OEM6_instance;
var Key_OEM7_instance;
var Key_OEM8_instance;
var Key_LEFT_MENU_instance;
var Key_RIGHT_MENU_instance;
var Key_SLEEP_instance;
var Key_SNAPSHOT_instance;
var Key_INFO_instance;
var Key_XBUTTON1_instance;
var Key_XBUTTON2_instance;
var Key_XBUTTON3_instance;
var Key_XBUTTON4_instance;
var Key_XBUTTON5_instance;
var Key_XBUTTON6_instance;
var Key_XBUTTON7_instance;
var Key_XBUTTON8_instance;
var Key_XBUTTON9_instance;
var Key_XBUTTON10_instance;
var Key_XBUTTON11_instance;
var Key_XBUTTON12_instance;
var Key_XBUTTON13_instance;
var Key_XBUTTON14_instance;
var Key_XBUTTON15_instance;
var Key_XBUTTON16_instance;
var Key_XBUTTON_A_instance;
var Key_XBUTTON_B_instance;
var Key_XBUTTON_C_instance;
var Key_XBUTTON_L1_instance;
var Key_XBUTTON_L2_instance;
var Key_XBUTTON_MODE_instance;
var Key_XBUTTON_R1_instance;
var Key_XBUTTON_R2_instance;
var Key_XBUTTON_SELECT_instance;
var Key_XBUTTON_START_instance;
var Key_XBUTTON_THUMBL_instance;
var Key_XBUTTON_THUMBR_instance;
var Key_XBUTTON_X_instance;
var Key_XBUTTON_Y_instance;
var Key_XBUTTON_Z_instance;
var Key_DPAD_CENTER_instance;
var Key_DPAD_DOWN_instance;
var Key_DPAD_DOWN_LEFT_instance;
var Key_DPAD_DOWN_RIGHT_instance;
var Key_DPAD_LEFT_instance;
var Key_DPAD_RIGHT_instance;
var Key_DPAD_UP_instance;
var Key_DPAD_UP_LEFT_instance;
var Key_DPAD_UP_RIGHT_instance;
var Key_DVR_instance;
var Key_EISU_instance;
var Key_ENDCALL_instance;
var Key_ENVELOPE_instance;
var Key_EXPLORER_instance;
var Key_FOCUS_instance;
var Key_FORWARD_instance;
var Key_GRAVE_instance;
var Key_GUIDE_instance;
var Key_HEADSETHOOK_instance;
var Key_ABNT_C1_instance;
var Key_ABNT_C2_instance;
var Key_ATTN_instance;
var Key_CRSEL_instance;
var Key_EREOF_instance;
var Key_EXECUTE_instance;
var Key_EXSEL_instance;
var Key_ICO_CLEAR_instance;
var Key_ICO_HELP_instance;
var Key_HENKAN_instance;
var Key_PAIRING_instance;
var Key_APP_SWITCH_instance;
var Key_ASSIST_instance;
var Key_AVR_INPUT_instance;
var Key_AVR_POWER_instance;
var Key_BOOKMARK_instance;
var Key_BREAK_instance;
var Key_CAPTIONS_instance;
var Key_CAMERA_instance;
var Key_CALL_instance;
var Key_CALENDAR_instance;
var Key_BRIGHTNESS_DOWN_instance;
var Key_BRIGHTNESS_UP_instance;
var Key_CHANNEL_DOWN_instance;
var Key_CHANNEL_UP_instance;
var Key_CALCULATOR_instance;
var Key_CONTACTS_instance;
var Key_NOTIFICATION_instance;
var Key_COPY_instance;
var Key_CUT_instance;
var Key_PASTE_instance;
var Key_SEARCH_instance;
var Key_SETTINGS_instance;
var Key_SOFT_LEFT_instance;
var Key_SOFT_RIGHT_instance;
var Key_SOFT_SLEEP_instance;
var Key_STAR_instance;
var Key_STB_INPUT_instance;
var Key_STB_POWER_instance;
var Key_STEM_1_instance;
var Key_STEM_2_instance;
var Key_STEM_3_instance;
var Key_STEM_PRIMARY_instance;
var Key_SWITCH_CHARSET_instance;
var Key_SYM_instance;
var Key_SYSRQ_instance;
var Key_NUM_instance;
var Key_TV_instance;
var Key_TV_ANTENNA_CABLE_instance;
var Key_TV_AUDIO_DESCRIPTION_instance;
var Key_TV_AUDIO_DESCRIPTION_MIX_DOWN_instance;
var Key_TV_AUDIO_DESCRIPTION_MIX_UP_instance;
var Key_TV_CONTENTS_MENU_instance;
var Key_TV_DATA_SERVICE_instance;
var Key_TV_INPUT_instance;
var Key_TV_INPUT_COMPONENT_1_instance;
var Key_TV_INPUT_COMPONENT_2_instance;
var Key_TV_INPUT_COMPOSITE_1_instance;
var Key_TV_INPUT_COMPOSITE_2_instance;
var Key_TV_INPUT_HDMI_1_instance;
var Key_TV_INPUT_HDMI_2_instance;
var Key_TV_INPUT_HDMI_3_instance;
var Key_TV_INPUT_HDMI_4_instance;
var Key_TV_INPUT_VGA_1_instance;
var Key_TV_MEDIA_CONTEXT_MENU_instance;
var Key_TV_NETWORK_instance;
var Key_TV_NUMBER_ENTRY_instance;
var Key_TV_POWER_instance;
var Key_TV_RADIO_SERVICE_instance;
var Key_TV_SATELLITE_instance;
var Key_TV_SATELLITE_BS_instance;
var Key_TV_SATELLITE_CS_instance;
var Key_TV_SATELLITE_SERVICE_instance;
var Key_TV_TELETEXT_instance;
var Key_TV_TERRESTRIAL_ANALOG_instance;
var Key_TV_TERRESTRIAL_DIGITAL_instance;
var Key_TV_TIMER_PROGRAMMING_instance;
var Key_TV_ZOOM_MODE_instance;
var Key_VOICE_ASSIST_instance;
var Key_WAKEUP_instance;
var Key_WINDOW_instance;
var Key_YEN_instance;
var Key_ZENKAKU_HANKAKU_instance;
var Key_ZOOM_IN_instance;
var Key_ZOOM_OUT_instance;
var Key_SYSTEM_NAVIGATION_DOWN_instance;
var Key_SYSTEM_NAVIGATION_LEFT_instance;
var Key_SYSTEM_NAVIGATION_RIGHT_instance;
var Key_SYSTEM_NAVIGATION_UP_instance;
var Key_PICTSYMBOLS_instance;
var Key_POUND_instance;
var Key_POWER_instance;
var Key_PROG_BLUE_instance;
var Key_PROG_GREEN_instance;
var Key_PROG_RED_instance;
var Key_PROG_YELLOW_instance;
var Key_RO_instance;
var Key_OEM_ATTN_instance;
var Key_OEM_AUTO_instance;
var Key_OEM_AX_instance;
var Key_OEM_BACKTAB_instance;
var Key_OEM_CLEAR_instance;
var Key_OEM_COMMA_instance;
var Key_OEM_COPY_instance;
var Key_OEM_CUSEL_instance;
var Key_OEM_ENLW_instance;
var Key_OEM_FINISH_instance;
var Key_OEM_FJ_LOYA_instance;
var Key_OEM_FJ_MASSHOU_instance;
var Key_OEM_FJ_ROYA_instance;
var Key_OEM_FJ_TOUROKU_instance;
var Key_OEM_JUMP_instance;
var Key_OEM_MINUS_instance;
var Key_OEM_PA1_instance;
var Key_OEM_PA2_instance;
var Key_OEM_PA3_instance;
var Key_OEM_PERIOD_instance;
var Key_OEM_PLUS_instance;
var Key_OEM_RESET_instance;
var Key_OEM_WSCTRL_instance;
var Key_PA1_instance;
var Key_PACKET_instance;
var Key_PROCESSKEY_instance;
var Key_ZOOM_instance;
var Key_NONE_instance;
var Key_ACCEPT_instance;
var Key_APPS_instance;
var Key_BROWSER_BACK_instance;
var Key_BROWSER_FAVORITES_instance;
var Key_BROWSER_FORWARD_instance;
var Key_BROWSER_HOME_instance;
var Key_BROWSER_REFRESH_instance;
var Key_BROWSER_SEARCH_instance;
var Key_BROWSER_STOP_instance;
var Key_CAPITAL_instance;
var Key_CONVERT_instance;
var Key_ICO_00_instance;
var Key_JUNJA_instance;
var Key_KANA_instance;
var Key_KANJI_instance;
var Key_KATAKANA_HIRAGANA_instance;
var Key_LANGUAGE_SWITCH_instance;
var Key_MUHENKAN_instance;
var Key_LAUNCH_APP1_instance;
var Key_LAUNCH_APP2_instance;
var Key_LAUNCH_MAIL_instance;
var Key_LAUNCH_MEDIA_SELECT_instance;
var Key_LEFT_BUTTON_instance;
var Key_MIDDLE_BUTTON_instance;
var Key_MUSIC_instance;
var Key_MEDIA_NEXT_TRACK_instance;
var Key_MEDIA_PLAY_PAUSE_instance;
var Key_MEDIA_PREV_TRACK_instance;
var Key_MEDIA_STOP_instance;
var Key_MEDIA_PLAY_instance;
var Key_MEDIA_PAUSE_instance;
var Key_MEDIA_AUDIO_TRACK_instance;
var Key_MEDIA_CLOSE_instance;
var Key_MEDIA_EJECT_instance;
var Key_MEDIA_FAST_FORWARD_instance;
var Key_MEDIA_RECORD_instance;
var Key_MEDIA_REWIND_instance;
var Key_MEDIA_SKIP_BACKWARD_instance;
var Key_MEDIA_SKIP_FORWARD_instance;
var Key_MEDIA_STEP_BACKWARD_instance;
var Key_MEDIA_STEP_FORWARD_instance;
var Key_MEDIA_TOP_MENU_instance;
var Key_MODECHANGE_instance;
var Key_NEXT_instance;
var Key_NONCONVERT_instance;
var Key_OEM_FJ_JISHO_instance;
var Key_PRIOR_instance;
var Key_RIGHT_BUTTON_instance;
var Key_LAST_CHANNEL_instance;
var Key_MANNER_MODE_instance;
var Key_NAVIGATE_IN_instance;
var Key_NAVIGATE_NEXT_instance;
var Key_NAVIGATE_OUT_instance;
var Key_NAVIGATE_PREVIOUS_instance;
var Key_HYPHEN_instance;
var Key_UNDEFINED_instance;
var Key_UNKNOWN_instance;
var Companion_instance_28;
function Companion_getInstance_34() {
  Key_initEntries();
  if (Companion_instance_28 === VOID)
    new Companion_19();
  return Companion_instance_28;
}
var Key_entriesInitialized;
function Key_initEntries() {
  if (Key_entriesInitialized)
    return Unit_instance;
  Key_entriesInitialized = true;
  Key_SPACE_instance = new Key('SPACE', 0);
  Key_APOSTROPHE_instance = new Key('APOSTROPHE', 1);
  Key_COMMA_instance = new Key('COMMA', 2);
  Key_MINUS_instance = new Key('MINUS', 3);
  Key_PLUS_instance = new Key('PLUS', 4);
  Key_PERIOD_instance = new Key('PERIOD', 5);
  Key_SLASH_instance = new Key('SLASH', 6);
  Key_N0_instance = new Key('N0', 7);
  Key_N1_instance = new Key('N1', 8);
  Key_N2_instance = new Key('N2', 9);
  Key_N3_instance = new Key('N3', 10);
  Key_N4_instance = new Key('N4', 11);
  Key_N5_instance = new Key('N5', 12);
  Key_N6_instance = new Key('N6', 13);
  Key_N7_instance = new Key('N7', 14);
  Key_N8_instance = new Key('N8', 15);
  Key_N9_instance = new Key('N9', 16);
  Key_N11_instance = new Key('N11', 17);
  Key_N12_instance = new Key('N12', 18);
  Key_N3D_MODE_instance = new Key('N3D_MODE', 19);
  Key_SEMICOLON_instance = new Key('SEMICOLON', 20);
  Key_EQUAL_instance = new Key('EQUAL', 21);
  Key_AT_instance = new Key('AT', 22);
  Key_A_instance = new Key('A', 23);
  Key_B_instance = new Key('B', 24);
  Key_C_instance = new Key('C', 25);
  Key_D_instance = new Key('D', 26);
  Key_E_instance = new Key('E', 27);
  Key_F_instance = new Key('F', 28);
  Key_G_instance = new Key('G', 29);
  Key_H_instance = new Key('H', 30);
  Key_I_instance = new Key('I', 31);
  Key_J_instance = new Key('J', 32);
  Key_K_instance = new Key('K', 33);
  Key_L_instance = new Key('L', 34);
  Key_M_instance = new Key('M', 35);
  Key_N_instance = new Key('N', 36);
  Key_O_instance = new Key('O', 37);
  Key_P_instance = new Key('P', 38);
  Key_Q_instance = new Key('Q', 39);
  Key_R_instance = new Key('R', 40);
  Key_S_instance = new Key('S', 41);
  Key_T_instance = new Key('T', 42);
  Key_U_instance = new Key('U', 43);
  Key_V_instance = new Key('V', 44);
  Key_W_instance = new Key('W', 45);
  Key_X_instance = new Key('X', 46);
  Key_Y_instance = new Key('Y', 47);
  Key_Z_instance = new Key('Z', 48);
  Key_LEFT_BRACKET_instance = new Key('LEFT_BRACKET', 49);
  Key_BACKSLASH_instance = new Key('BACKSLASH', 50);
  Key_RIGHT_BRACKET_instance = new Key('RIGHT_BRACKET', 51);
  Key_GRAVE_ACCENT_instance = new Key('GRAVE_ACCENT', 52);
  Key_WORLD_1_instance = new Key('WORLD_1', 53);
  Key_WORLD_2_instance = new Key('WORLD_2', 54);
  Key_ESCAPE_instance = new Key('ESCAPE', 55);
  Key_META_instance = new Key('META', 56);
  Key_ENTER_instance = new Key('ENTER', 57);
  Key_TAB_instance = new Key('TAB', 58);
  Key_BACKSPACE_instance = new Key('BACKSPACE', 59);
  Key_INSERT_instance = new Key('INSERT', 60);
  Key_DELETE_instance = new Key('DELETE', 61);
  Key_RIGHT_instance = new Key('RIGHT', 62);
  Key_LEFT_instance = new Key('LEFT', 63);
  Key_DOWN_instance = new Key('DOWN', 64);
  Key_UP_instance = new Key('UP', 65);
  Key_PAGE_UP_instance = new Key('PAGE_UP', 66);
  Key_PAGE_DOWN_instance = new Key('PAGE_DOWN', 67);
  Key_FUNCTION_instance = new Key('FUNCTION', 68);
  Key_HELP_instance = new Key('HELP', 69);
  Key_MUTE_instance = new Key('MUTE', 70);
  Key_VOLUME_DOWN_instance = new Key('VOLUME_DOWN', 71);
  Key_VOLUME_UP_instance = new Key('VOLUME_UP', 72);
  Key_VOLUME_MUTE_instance = new Key('VOLUME_MUTE', 73);
  Key_HOME_instance = new Key('HOME', 74);
  Key_END_instance = new Key('END', 75);
  Key_CAPS_LOCK_instance = new Key('CAPS_LOCK', 76);
  Key_SCROLL_LOCK_instance = new Key('SCROLL_LOCK', 77);
  Key_NUM_LOCK_instance = new Key('NUM_LOCK', 78);
  Key_PRINT_SCREEN_instance = new Key('PRINT_SCREEN', 79);
  Key_PAUSE_instance = new Key('PAUSE', 80);
  Key_F1_instance = new Key('F1', 81);
  Key_F2_instance = new Key('F2', 82);
  Key_F3_instance = new Key('F3', 83);
  Key_F4_instance = new Key('F4', 84);
  Key_F5_instance = new Key('F5', 85);
  Key_F6_instance = new Key('F6', 86);
  Key_F7_instance = new Key('F7', 87);
  Key_F8_instance = new Key('F8', 88);
  Key_F9_instance = new Key('F9', 89);
  Key_F10_instance = new Key('F10', 90);
  Key_F11_instance = new Key('F11', 91);
  Key_F12_instance = new Key('F12', 92);
  Key_F13_instance = new Key('F13', 93);
  Key_F14_instance = new Key('F14', 94);
  Key_F15_instance = new Key('F15', 95);
  Key_F16_instance = new Key('F16', 96);
  Key_F17_instance = new Key('F17', 97);
  Key_F18_instance = new Key('F18', 98);
  Key_F19_instance = new Key('F19', 99);
  Key_F20_instance = new Key('F20', 100);
  Key_F21_instance = new Key('F21', 101);
  Key_F22_instance = new Key('F22', 102);
  Key_F23_instance = new Key('F23', 103);
  Key_F24_instance = new Key('F24', 104);
  Key_F25_instance = new Key('F25', 105);
  Key_KP_0_instance = new Key('KP_0', 106);
  Key_KP_1_instance = new Key('KP_1', 107);
  Key_KP_2_instance = new Key('KP_2', 108);
  Key_KP_3_instance = new Key('KP_3', 109);
  Key_KP_4_instance = new Key('KP_4', 110);
  Key_KP_5_instance = new Key('KP_5', 111);
  Key_KP_6_instance = new Key('KP_6', 112);
  Key_KP_7_instance = new Key('KP_7', 113);
  Key_KP_8_instance = new Key('KP_8', 114);
  Key_KP_9_instance = new Key('KP_9', 115);
  Key_KP_DECIMAL_instance = new Key('KP_DECIMAL', 116);
  Key_KP_DIVIDE_instance = new Key('KP_DIVIDE', 117);
  Key_KP_MULTIPLY_instance = new Key('KP_MULTIPLY', 118);
  Key_KP_SUBTRACT_instance = new Key('KP_SUBTRACT', 119);
  Key_KP_ADD_instance = new Key('KP_ADD', 120);
  Key_KP_COMMA_instance = new Key('KP_COMMA', 121);
  Key_KP_DOT_instance = new Key('KP_DOT', 122);
  Key_KP_ENTER_instance = new Key('KP_ENTER', 123);
  Key_KP_EQUAL_instance = new Key('KP_EQUAL', 124);
  Key_KP_SEPARATOR_instance = new Key('KP_SEPARATOR', 125);
  Key_KP_LEFT_PAREN_instance = new Key('KP_LEFT_PAREN', 126);
  Key_KP_RIGHT_PAREN_instance = new Key('KP_RIGHT_PAREN', 127);
  Key_SHIFT_instance = new Key('SHIFT', 128);
  Key_CONTROL_instance = new Key('CONTROL', 129);
  Key_ALT_instance = new Key('ALT', 130);
  Key_SUPER_instance = new Key('SUPER', 131);
  Key_MENU_instance = new Key('MENU', 132);
  Key_BACK_instance = new Key('BACK', 133);
  Key_BACKQUOTE_instance = new Key('BACKQUOTE', 134);
  Key_QUOTE_instance = new Key('QUOTE', 135);
  Key_KP_UP_instance = new Key('KP_UP', 136);
  Key_KP_DOWN_instance = new Key('KP_DOWN', 137);
  Key_KP_LEFT_instance = new Key('KP_LEFT', 138);
  Key_KP_RIGHT_instance = new Key('KP_RIGHT', 139);
  Key_UNDERLINE_instance = new Key('UNDERLINE', 140);
  Key_SELECT_KEY_instance = new Key('SELECT_KEY', 141);
  Key_CANCEL_instance = new Key('CANCEL', 142);
  Key_CLEAR_instance = new Key('CLEAR', 143);
  Key_OPEN_BRACKET_instance = new Key('OPEN_BRACKET', 144);
  Key_CLOSE_BRACKET_instance = new Key('CLOSE_BRACKET', 145);
  Key_PLAY_instance = new Key('PLAY', 146);
  Key_NONAME_instance = new Key('NONAME', 147);
  Key_FINAL_instance = new Key('FINAL', 148);
  Key_OEM102_instance = new Key('OEM102', 149);
  Key_OEM1_instance = new Key('OEM1', 150);
  Key_OEM2_instance = new Key('OEM2', 151);
  Key_OEM3_instance = new Key('OEM3', 152);
  Key_OEM4_instance = new Key('OEM4', 153);
  Key_OEM5_instance = new Key('OEM5', 154);
  Key_OEM6_instance = new Key('OEM6', 155);
  Key_OEM7_instance = new Key('OEM7', 156);
  Key_OEM8_instance = new Key('OEM8', 157);
  Key_LEFT_MENU_instance = new Key('LEFT_MENU', 158);
  Key_RIGHT_MENU_instance = new Key('RIGHT_MENU', 159);
  Key_SLEEP_instance = new Key('SLEEP', 160);
  Key_SNAPSHOT_instance = new Key('SNAPSHOT', 161);
  Key_INFO_instance = new Key('INFO', 162);
  Key_XBUTTON1_instance = new Key('XBUTTON1', 163);
  Key_XBUTTON2_instance = new Key('XBUTTON2', 164);
  Key_XBUTTON3_instance = new Key('XBUTTON3', 165);
  Key_XBUTTON4_instance = new Key('XBUTTON4', 166);
  Key_XBUTTON5_instance = new Key('XBUTTON5', 167);
  Key_XBUTTON6_instance = new Key('XBUTTON6', 168);
  Key_XBUTTON7_instance = new Key('XBUTTON7', 169);
  Key_XBUTTON8_instance = new Key('XBUTTON8', 170);
  Key_XBUTTON9_instance = new Key('XBUTTON9', 171);
  Key_XBUTTON10_instance = new Key('XBUTTON10', 172);
  Key_XBUTTON11_instance = new Key('XBUTTON11', 173);
  Key_XBUTTON12_instance = new Key('XBUTTON12', 174);
  Key_XBUTTON13_instance = new Key('XBUTTON13', 175);
  Key_XBUTTON14_instance = new Key('XBUTTON14', 176);
  Key_XBUTTON15_instance = new Key('XBUTTON15', 177);
  Key_XBUTTON16_instance = new Key('XBUTTON16', 178);
  Key_XBUTTON_A_instance = new Key('XBUTTON_A', 179);
  Key_XBUTTON_B_instance = new Key('XBUTTON_B', 180);
  Key_XBUTTON_C_instance = new Key('XBUTTON_C', 181);
  Key_XBUTTON_L1_instance = new Key('XBUTTON_L1', 182);
  Key_XBUTTON_L2_instance = new Key('XBUTTON_L2', 183);
  Key_XBUTTON_MODE_instance = new Key('XBUTTON_MODE', 184);
  Key_XBUTTON_R1_instance = new Key('XBUTTON_R1', 185);
  Key_XBUTTON_R2_instance = new Key('XBUTTON_R2', 186);
  Key_XBUTTON_SELECT_instance = new Key('XBUTTON_SELECT', 187);
  Key_XBUTTON_START_instance = new Key('XBUTTON_START', 188);
  Key_XBUTTON_THUMBL_instance = new Key('XBUTTON_THUMBL', 189);
  Key_XBUTTON_THUMBR_instance = new Key('XBUTTON_THUMBR', 190);
  Key_XBUTTON_X_instance = new Key('XBUTTON_X', 191);
  Key_XBUTTON_Y_instance = new Key('XBUTTON_Y', 192);
  Key_XBUTTON_Z_instance = new Key('XBUTTON_Z', 193);
  Key_DPAD_CENTER_instance = new Key('DPAD_CENTER', 194);
  Key_DPAD_DOWN_instance = new Key('DPAD_DOWN', 195);
  Key_DPAD_DOWN_LEFT_instance = new Key('DPAD_DOWN_LEFT', 196);
  Key_DPAD_DOWN_RIGHT_instance = new Key('DPAD_DOWN_RIGHT', 197);
  Key_DPAD_LEFT_instance = new Key('DPAD_LEFT', 198);
  Key_DPAD_RIGHT_instance = new Key('DPAD_RIGHT', 199);
  Key_DPAD_UP_instance = new Key('DPAD_UP', 200);
  Key_DPAD_UP_LEFT_instance = new Key('DPAD_UP_LEFT', 201);
  Key_DPAD_UP_RIGHT_instance = new Key('DPAD_UP_RIGHT', 202);
  Key_DVR_instance = new Key('DVR', 203);
  Key_EISU_instance = new Key('EISU', 204);
  Key_ENDCALL_instance = new Key('ENDCALL', 205);
  Key_ENVELOPE_instance = new Key('ENVELOPE', 206);
  Key_EXPLORER_instance = new Key('EXPLORER', 207);
  Key_FOCUS_instance = new Key('FOCUS', 208);
  Key_FORWARD_instance = new Key('FORWARD', 209);
  Key_GRAVE_instance = new Key('GRAVE', 210);
  Key_GUIDE_instance = new Key('GUIDE', 211);
  Key_HEADSETHOOK_instance = new Key('HEADSETHOOK', 212);
  Key_ABNT_C1_instance = new Key('ABNT_C1', 213);
  Key_ABNT_C2_instance = new Key('ABNT_C2', 214);
  Key_ATTN_instance = new Key('ATTN', 215);
  Key_CRSEL_instance = new Key('CRSEL', 216);
  Key_EREOF_instance = new Key('EREOF', 217);
  Key_EXECUTE_instance = new Key('EXECUTE', 218);
  Key_EXSEL_instance = new Key('EXSEL', 219);
  Key_ICO_CLEAR_instance = new Key('ICO_CLEAR', 220);
  Key_ICO_HELP_instance = new Key('ICO_HELP', 221);
  Key_HENKAN_instance = new Key('HENKAN', 222);
  Key_PAIRING_instance = new Key('PAIRING', 223);
  Key_APP_SWITCH_instance = new Key('APP_SWITCH', 224);
  Key_ASSIST_instance = new Key('ASSIST', 225);
  Key_AVR_INPUT_instance = new Key('AVR_INPUT', 226);
  Key_AVR_POWER_instance = new Key('AVR_POWER', 227);
  Key_BOOKMARK_instance = new Key('BOOKMARK', 228);
  Key_BREAK_instance = new Key('BREAK', 229);
  Key_CAPTIONS_instance = new Key('CAPTIONS', 230);
  Key_CAMERA_instance = new Key('CAMERA', 231);
  Key_CALL_instance = new Key('CALL', 232);
  Key_CALENDAR_instance = new Key('CALENDAR', 233);
  Key_BRIGHTNESS_DOWN_instance = new Key('BRIGHTNESS_DOWN', 234);
  Key_BRIGHTNESS_UP_instance = new Key('BRIGHTNESS_UP', 235);
  Key_CHANNEL_DOWN_instance = new Key('CHANNEL_DOWN', 236);
  Key_CHANNEL_UP_instance = new Key('CHANNEL_UP', 237);
  Key_CALCULATOR_instance = new Key('CALCULATOR', 238);
  Key_CONTACTS_instance = new Key('CONTACTS', 239);
  Key_NOTIFICATION_instance = new Key('NOTIFICATION', 240);
  Key_COPY_instance = new Key('COPY', 241);
  Key_CUT_instance = new Key('CUT', 242);
  Key_PASTE_instance = new Key('PASTE', 243);
  Key_SEARCH_instance = new Key('SEARCH', 244);
  Key_SETTINGS_instance = new Key('SETTINGS', 245);
  Key_SOFT_LEFT_instance = new Key('SOFT_LEFT', 246);
  Key_SOFT_RIGHT_instance = new Key('SOFT_RIGHT', 247);
  Key_SOFT_SLEEP_instance = new Key('SOFT_SLEEP', 248);
  Key_STAR_instance = new Key('STAR', 249);
  Key_STB_INPUT_instance = new Key('STB_INPUT', 250);
  Key_STB_POWER_instance = new Key('STB_POWER', 251);
  Key_STEM_1_instance = new Key('STEM_1', 252);
  Key_STEM_2_instance = new Key('STEM_2', 253);
  Key_STEM_3_instance = new Key('STEM_3', 254);
  Key_STEM_PRIMARY_instance = new Key('STEM_PRIMARY', 255);
  Key_SWITCH_CHARSET_instance = new Key('SWITCH_CHARSET', 256);
  Key_SYM_instance = new Key('SYM', 257);
  Key_SYSRQ_instance = new Key('SYSRQ', 258);
  Key_NUM_instance = new Key('NUM', 259);
  Key_TV_instance = new Key('TV', 260);
  Key_TV_ANTENNA_CABLE_instance = new Key('TV_ANTENNA_CABLE', 261);
  Key_TV_AUDIO_DESCRIPTION_instance = new Key('TV_AUDIO_DESCRIPTION', 262);
  Key_TV_AUDIO_DESCRIPTION_MIX_DOWN_instance = new Key('TV_AUDIO_DESCRIPTION_MIX_DOWN', 263);
  Key_TV_AUDIO_DESCRIPTION_MIX_UP_instance = new Key('TV_AUDIO_DESCRIPTION_MIX_UP', 264);
  Key_TV_CONTENTS_MENU_instance = new Key('TV_CONTENTS_MENU', 265);
  Key_TV_DATA_SERVICE_instance = new Key('TV_DATA_SERVICE', 266);
  Key_TV_INPUT_instance = new Key('TV_INPUT', 267);
  Key_TV_INPUT_COMPONENT_1_instance = new Key('TV_INPUT_COMPONENT_1', 268);
  Key_TV_INPUT_COMPONENT_2_instance = new Key('TV_INPUT_COMPONENT_2', 269);
  Key_TV_INPUT_COMPOSITE_1_instance = new Key('TV_INPUT_COMPOSITE_1', 270);
  Key_TV_INPUT_COMPOSITE_2_instance = new Key('TV_INPUT_COMPOSITE_2', 271);
  Key_TV_INPUT_HDMI_1_instance = new Key('TV_INPUT_HDMI_1', 272);
  Key_TV_INPUT_HDMI_2_instance = new Key('TV_INPUT_HDMI_2', 273);
  Key_TV_INPUT_HDMI_3_instance = new Key('TV_INPUT_HDMI_3', 274);
  Key_TV_INPUT_HDMI_4_instance = new Key('TV_INPUT_HDMI_4', 275);
  Key_TV_INPUT_VGA_1_instance = new Key('TV_INPUT_VGA_1', 276);
  Key_TV_MEDIA_CONTEXT_MENU_instance = new Key('TV_MEDIA_CONTEXT_MENU', 277);
  Key_TV_NETWORK_instance = new Key('TV_NETWORK', 278);
  Key_TV_NUMBER_ENTRY_instance = new Key('TV_NUMBER_ENTRY', 279);
  Key_TV_POWER_instance = new Key('TV_POWER', 280);
  Key_TV_RADIO_SERVICE_instance = new Key('TV_RADIO_SERVICE', 281);
  Key_TV_SATELLITE_instance = new Key('TV_SATELLITE', 282);
  Key_TV_SATELLITE_BS_instance = new Key('TV_SATELLITE_BS', 283);
  Key_TV_SATELLITE_CS_instance = new Key('TV_SATELLITE_CS', 284);
  Key_TV_SATELLITE_SERVICE_instance = new Key('TV_SATELLITE_SERVICE', 285);
  Key_TV_TELETEXT_instance = new Key('TV_TELETEXT', 286);
  Key_TV_TERRESTRIAL_ANALOG_instance = new Key('TV_TERRESTRIAL_ANALOG', 287);
  Key_TV_TERRESTRIAL_DIGITAL_instance = new Key('TV_TERRESTRIAL_DIGITAL', 288);
  Key_TV_TIMER_PROGRAMMING_instance = new Key('TV_TIMER_PROGRAMMING', 289);
  Key_TV_ZOOM_MODE_instance = new Key('TV_ZOOM_MODE', 290);
  Key_VOICE_ASSIST_instance = new Key('VOICE_ASSIST', 291);
  Key_WAKEUP_instance = new Key('WAKEUP', 292);
  Key_WINDOW_instance = new Key('WINDOW', 293);
  Key_YEN_instance = new Key('YEN', 294);
  Key_ZENKAKU_HANKAKU_instance = new Key('ZENKAKU_HANKAKU', 295);
  Key_ZOOM_IN_instance = new Key('ZOOM_IN', 296);
  Key_ZOOM_OUT_instance = new Key('ZOOM_OUT', 297);
  Key_SYSTEM_NAVIGATION_DOWN_instance = new Key('SYSTEM_NAVIGATION_DOWN', 298);
  Key_SYSTEM_NAVIGATION_LEFT_instance = new Key('SYSTEM_NAVIGATION_LEFT', 299);
  Key_SYSTEM_NAVIGATION_RIGHT_instance = new Key('SYSTEM_NAVIGATION_RIGHT', 300);
  Key_SYSTEM_NAVIGATION_UP_instance = new Key('SYSTEM_NAVIGATION_UP', 301);
  Key_PICTSYMBOLS_instance = new Key('PICTSYMBOLS', 302);
  Key_POUND_instance = new Key('POUND', 303);
  Key_POWER_instance = new Key('POWER', 304);
  Key_PROG_BLUE_instance = new Key('PROG_BLUE', 305);
  Key_PROG_GREEN_instance = new Key('PROG_GREEN', 306);
  Key_PROG_RED_instance = new Key('PROG_RED', 307);
  Key_PROG_YELLOW_instance = new Key('PROG_YELLOW', 308);
  Key_RO_instance = new Key('RO', 309);
  Key_OEM_ATTN_instance = new Key('OEM_ATTN', 310);
  Key_OEM_AUTO_instance = new Key('OEM_AUTO', 311);
  Key_OEM_AX_instance = new Key('OEM_AX', 312);
  Key_OEM_BACKTAB_instance = new Key('OEM_BACKTAB', 313);
  Key_OEM_CLEAR_instance = new Key('OEM_CLEAR', 314);
  Key_OEM_COMMA_instance = new Key('OEM_COMMA', 315);
  Key_OEM_COPY_instance = new Key('OEM_COPY', 316);
  Key_OEM_CUSEL_instance = new Key('OEM_CUSEL', 317);
  Key_OEM_ENLW_instance = new Key('OEM_ENLW', 318);
  Key_OEM_FINISH_instance = new Key('OEM_FINISH', 319);
  Key_OEM_FJ_LOYA_instance = new Key('OEM_FJ_LOYA', 320);
  Key_OEM_FJ_MASSHOU_instance = new Key('OEM_FJ_MASSHOU', 321);
  Key_OEM_FJ_ROYA_instance = new Key('OEM_FJ_ROYA', 322);
  Key_OEM_FJ_TOUROKU_instance = new Key('OEM_FJ_TOUROKU', 323);
  Key_OEM_JUMP_instance = new Key('OEM_JUMP', 324);
  Key_OEM_MINUS_instance = new Key('OEM_MINUS', 325);
  Key_OEM_PA1_instance = new Key('OEM_PA1', 326);
  Key_OEM_PA2_instance = new Key('OEM_PA2', 327);
  Key_OEM_PA3_instance = new Key('OEM_PA3', 328);
  Key_OEM_PERIOD_instance = new Key('OEM_PERIOD', 329);
  Key_OEM_PLUS_instance = new Key('OEM_PLUS', 330);
  Key_OEM_RESET_instance = new Key('OEM_RESET', 331);
  Key_OEM_WSCTRL_instance = new Key('OEM_WSCTRL', 332);
  Key_PA1_instance = new Key('PA1', 333);
  Key_PACKET_instance = new Key('PACKET', 334);
  Key_PROCESSKEY_instance = new Key('PROCESSKEY', 335);
  Key_ZOOM_instance = new Key('ZOOM', 336);
  Key_NONE_instance = new Key('NONE', 337);
  Key_ACCEPT_instance = new Key('ACCEPT', 338);
  Key_APPS_instance = new Key('APPS', 339);
  Key_BROWSER_BACK_instance = new Key('BROWSER_BACK', 340);
  Key_BROWSER_FAVORITES_instance = new Key('BROWSER_FAVORITES', 341);
  Key_BROWSER_FORWARD_instance = new Key('BROWSER_FORWARD', 342);
  Key_BROWSER_HOME_instance = new Key('BROWSER_HOME', 343);
  Key_BROWSER_REFRESH_instance = new Key('BROWSER_REFRESH', 344);
  Key_BROWSER_SEARCH_instance = new Key('BROWSER_SEARCH', 345);
  Key_BROWSER_STOP_instance = new Key('BROWSER_STOP', 346);
  Key_CAPITAL_instance = new Key('CAPITAL', 347);
  Key_CONVERT_instance = new Key('CONVERT', 348);
  Key_ICO_00_instance = new Key('ICO_00', 349);
  Key_JUNJA_instance = new Key('JUNJA', 350);
  Key_KANA_instance = new Key('KANA', 351);
  Key_KANJI_instance = new Key('KANJI', 352);
  Key_KATAKANA_HIRAGANA_instance = new Key('KATAKANA_HIRAGANA', 353);
  Key_LANGUAGE_SWITCH_instance = new Key('LANGUAGE_SWITCH', 354);
  Key_MUHENKAN_instance = new Key('MUHENKAN', 355);
  Key_LAUNCH_APP1_instance = new Key('LAUNCH_APP1', 356);
  Key_LAUNCH_APP2_instance = new Key('LAUNCH_APP2', 357);
  Key_LAUNCH_MAIL_instance = new Key('LAUNCH_MAIL', 358);
  Key_LAUNCH_MEDIA_SELECT_instance = new Key('LAUNCH_MEDIA_SELECT', 359);
  Key_LEFT_BUTTON_instance = new Key('LEFT_BUTTON', 360);
  Key_MIDDLE_BUTTON_instance = new Key('MIDDLE_BUTTON', 361);
  Key_MUSIC_instance = new Key('MUSIC', 362);
  Key_MEDIA_NEXT_TRACK_instance = new Key('MEDIA_NEXT_TRACK', 363);
  Key_MEDIA_PLAY_PAUSE_instance = new Key('MEDIA_PLAY_PAUSE', 364);
  Key_MEDIA_PREV_TRACK_instance = new Key('MEDIA_PREV_TRACK', 365);
  Key_MEDIA_STOP_instance = new Key('MEDIA_STOP', 366);
  Key_MEDIA_PLAY_instance = new Key('MEDIA_PLAY', 367);
  Key_MEDIA_PAUSE_instance = new Key('MEDIA_PAUSE', 368);
  Key_MEDIA_AUDIO_TRACK_instance = new Key('MEDIA_AUDIO_TRACK', 369);
  Key_MEDIA_CLOSE_instance = new Key('MEDIA_CLOSE', 370);
  Key_MEDIA_EJECT_instance = new Key('MEDIA_EJECT', 371);
  Key_MEDIA_FAST_FORWARD_instance = new Key('MEDIA_FAST_FORWARD', 372);
  Key_MEDIA_RECORD_instance = new Key('MEDIA_RECORD', 373);
  Key_MEDIA_REWIND_instance = new Key('MEDIA_REWIND', 374);
  Key_MEDIA_SKIP_BACKWARD_instance = new Key('MEDIA_SKIP_BACKWARD', 375);
  Key_MEDIA_SKIP_FORWARD_instance = new Key('MEDIA_SKIP_FORWARD', 376);
  Key_MEDIA_STEP_BACKWARD_instance = new Key('MEDIA_STEP_BACKWARD', 377);
  Key_MEDIA_STEP_FORWARD_instance = new Key('MEDIA_STEP_FORWARD', 378);
  Key_MEDIA_TOP_MENU_instance = new Key('MEDIA_TOP_MENU', 379);
  Key_MODECHANGE_instance = new Key('MODECHANGE', 380);
  Key_NEXT_instance = new Key('NEXT', 381);
  Key_NONCONVERT_instance = new Key('NONCONVERT', 382);
  Key_OEM_FJ_JISHO_instance = new Key('OEM_FJ_JISHO', 383);
  Key_PRIOR_instance = new Key('PRIOR', 384);
  Key_RIGHT_BUTTON_instance = new Key('RIGHT_BUTTON', 385);
  Key_LAST_CHANNEL_instance = new Key('LAST_CHANNEL', 386);
  Key_MANNER_MODE_instance = new Key('MANNER_MODE', 387);
  Key_NAVIGATE_IN_instance = new Key('NAVIGATE_IN', 388);
  Key_NAVIGATE_NEXT_instance = new Key('NAVIGATE_NEXT', 389);
  Key_NAVIGATE_OUT_instance = new Key('NAVIGATE_OUT', 390);
  Key_NAVIGATE_PREVIOUS_instance = new Key('NAVIGATE_PREVIOUS', 391);
  Key_HYPHEN_instance = new Key('HYPHEN', 392);
  Key_UNDEFINED_instance = new Key('UNDEFINED', 393);
  Key_UNKNOWN_instance = new Key('UNKNOWN', 394);
  Companion_getInstance_34();
}
function Key_SPACE_getInstance() {
  Key_initEntries();
  return Key_SPACE_instance;
}
function Key_APOSTROPHE_getInstance() {
  Key_initEntries();
  return Key_APOSTROPHE_instance;
}
function Key_COMMA_getInstance() {
  Key_initEntries();
  return Key_COMMA_instance;
}
function Key_MINUS_getInstance() {
  Key_initEntries();
  return Key_MINUS_instance;
}
function Key_PLUS_getInstance() {
  Key_initEntries();
  return Key_PLUS_instance;
}
function Key_PERIOD_getInstance() {
  Key_initEntries();
  return Key_PERIOD_instance;
}
function Key_SLASH_getInstance() {
  Key_initEntries();
  return Key_SLASH_instance;
}
function Key_N0_getInstance() {
  Key_initEntries();
  return Key_N0_instance;
}
function Key_N1_getInstance() {
  Key_initEntries();
  return Key_N1_instance;
}
function Key_N2_getInstance() {
  Key_initEntries();
  return Key_N2_instance;
}
function Key_N3_getInstance() {
  Key_initEntries();
  return Key_N3_instance;
}
function Key_N4_getInstance() {
  Key_initEntries();
  return Key_N4_instance;
}
function Key_N5_getInstance() {
  Key_initEntries();
  return Key_N5_instance;
}
function Key_N6_getInstance() {
  Key_initEntries();
  return Key_N6_instance;
}
function Key_N7_getInstance() {
  Key_initEntries();
  return Key_N7_instance;
}
function Key_N8_getInstance() {
  Key_initEntries();
  return Key_N8_instance;
}
function Key_N9_getInstance() {
  Key_initEntries();
  return Key_N9_instance;
}
function Key_SEMICOLON_getInstance() {
  Key_initEntries();
  return Key_SEMICOLON_instance;
}
function Key_A_getInstance() {
  Key_initEntries();
  return Key_A_instance;
}
function Key_B_getInstance() {
  Key_initEntries();
  return Key_B_instance;
}
function Key_C_getInstance() {
  Key_initEntries();
  return Key_C_instance;
}
function Key_D_getInstance() {
  Key_initEntries();
  return Key_D_instance;
}
function Key_E_getInstance() {
  Key_initEntries();
  return Key_E_instance;
}
function Key_F_getInstance() {
  Key_initEntries();
  return Key_F_instance;
}
function Key_G_getInstance() {
  Key_initEntries();
  return Key_G_instance;
}
function Key_H_getInstance() {
  Key_initEntries();
  return Key_H_instance;
}
function Key_I_getInstance() {
  Key_initEntries();
  return Key_I_instance;
}
function Key_J_getInstance() {
  Key_initEntries();
  return Key_J_instance;
}
function Key_K_getInstance() {
  Key_initEntries();
  return Key_K_instance;
}
function Key_L_getInstance() {
  Key_initEntries();
  return Key_L_instance;
}
function Key_M_getInstance() {
  Key_initEntries();
  return Key_M_instance;
}
function Key_N_getInstance() {
  Key_initEntries();
  return Key_N_instance;
}
function Key_O_getInstance() {
  Key_initEntries();
  return Key_O_instance;
}
function Key_P_getInstance() {
  Key_initEntries();
  return Key_P_instance;
}
function Key_Q_getInstance() {
  Key_initEntries();
  return Key_Q_instance;
}
function Key_R_getInstance() {
  Key_initEntries();
  return Key_R_instance;
}
function Key_S_getInstance() {
  Key_initEntries();
  return Key_S_instance;
}
function Key_T_getInstance() {
  Key_initEntries();
  return Key_T_instance;
}
function Key_U_getInstance() {
  Key_initEntries();
  return Key_U_instance;
}
function Key_V_getInstance() {
  Key_initEntries();
  return Key_V_instance;
}
function Key_W_getInstance() {
  Key_initEntries();
  return Key_W_instance;
}
function Key_X_getInstance() {
  Key_initEntries();
  return Key_X_instance;
}
function Key_Y_getInstance() {
  Key_initEntries();
  return Key_Y_instance;
}
function Key_Z_getInstance() {
  Key_initEntries();
  return Key_Z_instance;
}
function Key_ESCAPE_getInstance() {
  Key_initEntries();
  return Key_ESCAPE_instance;
}
function Key_META_getInstance() {
  Key_initEntries();
  return Key_META_instance;
}
function Key_ENTER_getInstance() {
  Key_initEntries();
  return Key_ENTER_instance;
}
function Key_TAB_getInstance() {
  Key_initEntries();
  return Key_TAB_instance;
}
function Key_BACKSPACE_getInstance() {
  Key_initEntries();
  return Key_BACKSPACE_instance;
}
function Key_INSERT_getInstance() {
  Key_initEntries();
  return Key_INSERT_instance;
}
function Key_DELETE_getInstance() {
  Key_initEntries();
  return Key_DELETE_instance;
}
function Key_RIGHT_getInstance() {
  Key_initEntries();
  return Key_RIGHT_instance;
}
function Key_LEFT_getInstance() {
  Key_initEntries();
  return Key_LEFT_instance;
}
function Key_DOWN_getInstance() {
  Key_initEntries();
  return Key_DOWN_instance;
}
function Key_UP_getInstance() {
  Key_initEntries();
  return Key_UP_instance;
}
function Key_PAGE_UP_getInstance() {
  Key_initEntries();
  return Key_PAGE_UP_instance;
}
function Key_PAGE_DOWN_getInstance() {
  Key_initEntries();
  return Key_PAGE_DOWN_instance;
}
function Key_HOME_getInstance() {
  Key_initEntries();
  return Key_HOME_instance;
}
function Key_END_getInstance() {
  Key_initEntries();
  return Key_END_instance;
}
function Key_F1_getInstance() {
  Key_initEntries();
  return Key_F1_instance;
}
function Key_F2_getInstance() {
  Key_initEntries();
  return Key_F2_instance;
}
function Key_F3_getInstance() {
  Key_initEntries();
  return Key_F3_instance;
}
function Key_F4_getInstance() {
  Key_initEntries();
  return Key_F4_instance;
}
function Key_F5_getInstance() {
  Key_initEntries();
  return Key_F5_instance;
}
function Key_F6_getInstance() {
  Key_initEntries();
  return Key_F6_instance;
}
function Key_F7_getInstance() {
  Key_initEntries();
  return Key_F7_instance;
}
function Key_F8_getInstance() {
  Key_initEntries();
  return Key_F8_instance;
}
function Key_F9_getInstance() {
  Key_initEntries();
  return Key_F9_instance;
}
function Key_F10_getInstance() {
  Key_initEntries();
  return Key_F10_instance;
}
function Key_F11_getInstance() {
  Key_initEntries();
  return Key_F11_instance;
}
function Key_F12_getInstance() {
  Key_initEntries();
  return Key_F12_instance;
}
function Key_F13_getInstance() {
  Key_initEntries();
  return Key_F13_instance;
}
function Key_F14_getInstance() {
  Key_initEntries();
  return Key_F14_instance;
}
function Key_F15_getInstance() {
  Key_initEntries();
  return Key_F15_instance;
}
function Key_F16_getInstance() {
  Key_initEntries();
  return Key_F16_instance;
}
function Key_F17_getInstance() {
  Key_initEntries();
  return Key_F17_instance;
}
function Key_F18_getInstance() {
  Key_initEntries();
  return Key_F18_instance;
}
function Key_F19_getInstance() {
  Key_initEntries();
  return Key_F19_instance;
}
function Key_F20_getInstance() {
  Key_initEntries();
  return Key_F20_instance;
}
function Key_F21_getInstance() {
  Key_initEntries();
  return Key_F21_instance;
}
function Key_F22_getInstance() {
  Key_initEntries();
  return Key_F22_instance;
}
function Key_F23_getInstance() {
  Key_initEntries();
  return Key_F23_instance;
}
function Key_F24_getInstance() {
  Key_initEntries();
  return Key_F24_instance;
}
function Key_F25_getInstance() {
  Key_initEntries();
  return Key_F25_instance;
}
function Key_SHIFT_getInstance() {
  Key_initEntries();
  return Key_SHIFT_instance;
}
function Key_CONTROL_getInstance() {
  Key_initEntries();
  return Key_CONTROL_instance;
}
function Key_ALT_getInstance() {
  Key_initEntries();
  return Key_ALT_instance;
}
function Key_SUPER_getInstance() {
  Key_initEntries();
  return Key_SUPER_instance;
}
function Key_BACK_getInstance() {
  Key_initEntries();
  return Key_BACK_instance;
}
function Key_QUOTE_getInstance() {
  Key_initEntries();
  return Key_QUOTE_instance;
}
function Key_UNKNOWN_getInstance() {
  Key_initEntries();
  return Key_UNKNOWN_instance;
}
var MouseButton_LEFT_instance;
var MouseButton_MIDDLE_instance;
var MouseButton_RIGHT_instance;
var MouseButton_BUTTON3_instance;
var MouseButton_BUTTON4_instance;
var MouseButton_BUTTON5_instance;
var MouseButton_BUTTON6_instance;
var MouseButton_BUTTON7_instance;
var MouseButton_BUTTON_WHEEL_instance;
var MouseButton_BUTTON_UNKNOWN_instance;
var MouseButton_NONE_instance;
var Companion_instance_29;
function Companion_getInstance_35() {
  MouseButton_initEntries();
  if (Companion_instance_29 === VOID)
    new Companion_20();
  return Companion_instance_29;
}
function values_6() {
  return [MouseButton_LEFT_getInstance(), MouseButton_MIDDLE_getInstance(), MouseButton_RIGHT_getInstance(), MouseButton_BUTTON3_getInstance(), MouseButton_BUTTON4_getInstance(), MouseButton_BUTTON5_getInstance(), MouseButton_BUTTON6_getInstance(), MouseButton_BUTTON7_getInstance(), MouseButton_BUTTON_WHEEL_getInstance(), MouseButton_BUTTON_UNKNOWN_getInstance(), MouseButton_NONE_getInstance()];
}
var MouseButton_entriesInitialized;
function MouseButton_initEntries() {
  if (MouseButton_entriesInitialized)
    return Unit_instance;
  MouseButton_entriesInitialized = true;
  MouseButton_LEFT_instance = new MouseButton('LEFT', 0, 0);
  MouseButton_MIDDLE_instance = new MouseButton('MIDDLE', 1, 1);
  MouseButton_RIGHT_instance = new MouseButton('RIGHT', 2, 2);
  MouseButton_BUTTON3_instance = new MouseButton('BUTTON3', 3, 3);
  MouseButton_BUTTON4_instance = new MouseButton('BUTTON4', 4, 4);
  MouseButton_BUTTON5_instance = new MouseButton('BUTTON5', 5, 5);
  MouseButton_BUTTON6_instance = new MouseButton('BUTTON6', 6, 6);
  MouseButton_BUTTON7_instance = new MouseButton('BUTTON7', 7, 7);
  MouseButton_BUTTON_WHEEL_instance = new MouseButton('BUTTON_WHEEL', 8, 8);
  MouseButton_BUTTON_UNKNOWN_instance = new MouseButton('BUTTON_UNKNOWN', 9, 10);
  MouseButton_NONE_instance = new MouseButton('NONE', 10, 11, 0);
  Companion_getInstance_35();
}
function MouseButton_LEFT_getInstance() {
  MouseButton_initEntries();
  return MouseButton_LEFT_instance;
}
function MouseButton_MIDDLE_getInstance() {
  MouseButton_initEntries();
  return MouseButton_MIDDLE_instance;
}
function MouseButton_RIGHT_getInstance() {
  MouseButton_initEntries();
  return MouseButton_RIGHT_instance;
}
function MouseButton_BUTTON3_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON3_instance;
}
function MouseButton_BUTTON4_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON4_instance;
}
function MouseButton_BUTTON5_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON5_instance;
}
function MouseButton_BUTTON6_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON6_instance;
}
function MouseButton_BUTTON7_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON7_instance;
}
function MouseButton_BUTTON_WHEEL_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON_WHEEL_instance;
}
function MouseButton_BUTTON_UNKNOWN_getInstance() {
  MouseButton_initEntries();
  return MouseButton_BUTTON_UNKNOWN_instance;
}
function MouseButton_NONE_getInstance() {
  MouseButton_initEntries();
  return MouseButton_NONE_instance;
}
var Companion_instance_30;
function Companion_getInstance_36() {
  if (Companion_instance_30 === VOID)
    new Companion_21();
  return Companion_instance_30;
}
function draw(_this__u8e3s4, frameBuffer, vertexData, program, drawType, vertexCount, indices, indexType, drawOffset, blending, uniformBlocks, textureUnits, stencilRef, stencilOpFunc, colorMask, depthAndFrontFace, scissor, cullFace, instances) {
  indices = indices === VOID ? null : indices;
  indexType = indexType === VOID ? Companion_getInstance_41().x6u_1 : indexType;
  drawOffset = drawOffset === VOID ? 0 : drawOffset;
  blending = blending === VOID ? Companion_getInstance_42().b6v_1 : blending;
  uniformBlocks = uniformBlocks === VOID ? Companion_getInstance_59().f6v_1 : uniformBlocks;
  textureUnits = textureUnits === VOID ? Companion_instance_31.h6v() : textureUnits;
  stencilRef = stencilRef === VOID ? Companion_getInstance_45().j6v_1 : stencilRef;
  stencilOpFunc = stencilOpFunc === VOID ? Companion_getInstance_46().l6v_1 : stencilOpFunc;
  colorMask = colorMask === VOID ? Companion_getInstance_47().p6v_1 : colorMask;
  depthAndFrontFace = depthAndFrontFace === VOID ? Companion_getInstance_48().t6v_1 : depthAndFrontFace;
  scissor = scissor === VOID ? Companion_getInstance_43().x6v_1 : scissor;
  cullFace = cullFace === VOID ? Companion_getInstance_49().z6v_1 : cullFace;
  instances = instances === VOID ? 1 : instances;
  return _this__u8e3s4.q6u(frameBuffer.w6t_1, frameBuffer.d6w(), vertexData, program, drawType, vertexCount, indices, indexType, drawOffset, blending, uniformBlocks, textureUnits, stencilRef, stencilOpFunc, colorMask, depthAndFrontFace, scissor, cullFace, instances);
}
function readColor(_this__u8e3s4, frameBuffer, bitmap, x, y) {
  x = x === VOID ? 0 : x;
  y = y === VOID ? 0 : y;
  return _this__u8e3s4.r6u(frameBuffer.w6t_1, frameBuffer.d6w(), x, y, bitmap.r43_1, bitmap.s43_1, bitmap.h43_1, Companion_getInstance_50().l6w_1);
}
function draw_0(_this__u8e3s4, batch) {
  return batch.p6w(_this__u8e3s4);
}
function draw_1(_this__u8e3s4, batch) {
  return batch.p6w(_this__u8e3s4);
}
function upload($this, data, needClone) {
  var tmp0_safe_receiver = $this.n6x_1;
  if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.g15()) === data.g15()) {
    if (data.g15() < 1024 && Companion_instance_4.y14(data, 0, ensureNotNull($this.n6x_1), 0, data.g15())) {
      return $this;
    }
    Companion_instance_4.x14(data, 0, ensureNotNull($this.n6x_1), 0, data.g15());
  } else {
    $this.n6x_1 = needClone ? clone(data) : data;
  }
  $this.s6x();
  return $this;
}
var Companion_instance_31;
function Companion_getInstance_37() {
  return Companion_instance_31;
}
var Companion_instance_32;
function Companion_getInstance_38() {
  return Companion_instance_32;
}
function markAsDirty($this) {
}
function checkBitmaps($this, bmp) {
  if (!bmp.x43_1) {
    // Inline function 'korlibs.logger.Logger.error' call
    var this_0 = $this.o6z_1;
    var level = Level_ERROR_getInstance();
    var tmp;
    if (this_0.q31(level)) {
      // Inline function 'korlibs.graphics.AGTexture.checkBitmaps.<anonymous>' call
      var tmp$ret$0 = 'Trying to upload a non-premultiplied bitmap: ' + toString(bmp) + '. This will cause rendering artifacts';
      this_0.r31(level, tmp$ret$0);
      tmp = Unit_instance;
    }
  }
}
function _AGTextureUnitInfoArray___init__impl__c77rdb(data) {
  return data;
}
function _AGTextureUnitInfoArray___get_data__impl__a4ycyo($this) {
  return $this;
}
function _AGTextureUnitInfoArray___init__impl__c77rdb_0(size) {
  var tmp = 0;
  var tmp_0 = new Int32Array(size);
  while (tmp < size) {
    tmp_0[tmp] = _AGTextureUnitInfo___get_data__impl__oupy3n(Companion_getInstance_39().s6y_1);
    tmp = tmp + 1 | 0;
  }
  return _AGTextureUnitInfoArray___init__impl__c77rdb(tmp_0);
}
function AGTextureUnitInfoArray__set_impl_s95rfh($this, index, value) {
  _AGTextureUnitInfoArray___get_data__impl__a4ycyo($this)[index] = _AGTextureUnitInfo___get_data__impl__oupy3n(value);
}
function AGTextureUnitInfoArray__get_impl_xhvpef($this, index) {
  return Companion_getInstance_39().y70(_AGTextureUnitInfoArray___get_data__impl__a4ycyo($this)[index]);
}
function AGTextureUnitInfoArray__copyOf_impl_z2w8z3($this) {
  // Inline function 'kotlin.collections.copyOf' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$1 = _AGTextureUnitInfoArray___get_data__impl__a4ycyo($this).slice();
  return _AGTextureUnitInfoArray___init__impl__c77rdb(tmp$ret$1);
}
function AGTextureUnitInfoArray__toString_impl_kr9cgh($this) {
  return 'AGTextureUnitInfoArray(data=' + toString($this) + ')';
}
function AGTextureUnitInfoArray__hashCode_impl_siosps($this) {
  return hashCode($this);
}
function _AGTextureUnitInfo___init__impl__s1tthu(data) {
  return data;
}
function _AGTextureUnitInfo___get_data__impl__oupy3n($this) {
  return $this;
}
var Companion_instance_33;
function Companion_getInstance_39() {
  if (Companion_instance_33 === VOID)
    new Companion_24();
  return Companion_instance_33;
}
function _AGTextureUnitInfo___get_wrap__impl__dwp6l($this) {
  // Inline function 'korlibs.memory.extract2' call
  var tmp$ret$0 = (_AGTextureUnitInfo___get_data__impl__oupy3n($this) >>> 0 | 0) & 3;
  return _AGWrapMode___init__impl__x5wmya(tmp$ret$0);
}
function _AGTextureUnitInfo___get_linear__impl__jak6ny($this) {
  // Inline function 'korlibs.memory.extract' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGTextureUnitInfo___get_data__impl__oupy3n($this) >>> 2 | 0) & 1) === 0);
}
function _AGTextureUnitInfo___get_trilinear__impl__hxtqfb($this) {
  // Inline function 'korlibs.memory.extract' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGTextureUnitInfo___get_data__impl__oupy3n($this) >>> 3 | 0) & 1) === 0);
}
function _AGTextureUnitInfo___get_kind__impl__6xtjoz($this) {
  return _AGTextureTargetKind___init__impl__4zdmch(extract(_AGTextureUnitInfo___get_data__impl__oupy3n($this), 8, 5));
}
function AGTextureUnitInfo__withKind_impl_aa0b04($this, kind) {
  return _AGTextureUnitInfo___init__impl__s1tthu(insert5(_AGTextureUnitInfo___get_data__impl__oupy3n($this), _AGTextureTargetKind___get_ordinal__impl__gjzc5p(kind), 8));
}
function AGTextureUnitInfo__withWrap_impl_akwb6y($this, wrap) {
  return _AGTextureUnitInfo___init__impl__s1tthu(insert2(_AGTextureUnitInfo___get_data__impl__oupy3n($this), _AGWrapMode___get_ordinal__impl__rc38w2(wrap), 0));
}
function AGTextureUnitInfo__withLinear_impl_jl8yud($this, linear) {
  return _AGTextureUnitInfo___init__impl__s1tthu(insert(_AGTextureUnitInfo___get_data__impl__oupy3n($this), linear, 2));
}
function AGTextureUnitInfo__withTrilinear_impl_vhkcy2($this, trilinear) {
  return _AGTextureUnitInfo___init__impl__s1tthu(insert(_AGTextureUnitInfo___get_data__impl__oupy3n($this), trilinear, 3));
}
function AGTextureUnitInfo__withLinearTrilinear_impl_aactvz($this, linear, trilinear) {
  return AGTextureUnitInfo__withTrilinear_impl_vhkcy2(AGTextureUnitInfo__withLinear_impl_jl8yud($this, linear), trilinear);
}
function AGTextureUnitInfo__toString_impl_7im6je($this) {
  return 'AGTextureUnitInfo(wrap=' + AGWrapMode__toString_impl_8bjnw2(_AGTextureUnitInfo___get_wrap__impl__dwp6l($this)) + ', linear=' + _AGTextureUnitInfo___get_linear__impl__jak6ny($this) + ', trilinear=' + _AGTextureUnitInfo___get_trilinear__impl__hxtqfb($this) + ', kind=' + AGTextureTargetKind__toString_impl_68648p(_AGTextureUnitInfo___get_kind__impl__6xtjoz($this)) + ')';
}
function AGTextureUnitInfo__hashCode_impl_e8jq9h($this) {
  return $this;
}
function AGTextureUnitInfo__equals_impl_j2jlgn($this, other) {
  if (!(other instanceof AGTextureUnitInfo))
    return false;
  if (!($this === (other instanceof AGTextureUnitInfo ? other.e71_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGDrawType___init__impl__emm6mb(ordinal) {
  return ordinal;
}
var Companion_instance_34;
function Companion_getInstance_40() {
  if (Companion_instance_34 === VOID)
    new Companion_25();
  return Companion_instance_34;
}
function AGDrawType__toString_impl_eonaeb($this) {
  return $this === Companion_getInstance_40().x73_1 ? 'POINTS' : $this === Companion_getInstance_40().y73_1 ? 'LINE_STRIP' : $this === Companion_getInstance_40().z73_1 ? 'LINE_LOOP' : $this === Companion_getInstance_40().a74_1 ? 'LINES' : $this === Companion_getInstance_40().b74_1 ? 'TRIANGLES' : $this === Companion_getInstance_40().c74_1 ? 'TRIANGLE_STRIP' : $this === Companion_getInstance_40().d74_1 ? 'TRIANGLE_FAN' : '-';
}
function AGDrawType__hashCode_impl_ylaury($this) {
  return $this;
}
function AGDrawType__equals_impl_rtafo6($this, other) {
  if (!(other instanceof AGDrawType))
    return false;
  if (!($this === (other instanceof AGDrawType ? other.e74_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGIndexType___init__impl__yqnmb7(ordinal) {
  return ordinal;
}
var Companion_instance_35;
function Companion_getInstance_41() {
  if (Companion_instance_35 === VOID)
    new Companion_26();
  return Companion_instance_35;
}
function AGIndexType__toString_impl_hjqwm3($this) {
  return $this === Companion_getInstance_41().v6u_1 ? 'null' : $this === Companion_getInstance_41().w6u_1 ? 'UBYTE' : $this === Companion_getInstance_41().x6u_1 ? 'USHORT' : $this === Companion_getInstance_41().y6u_1 ? 'UINT' : '-';
}
function AGIndexType__hashCode_impl_47f06s($this) {
  return $this;
}
function _AGBlending___init__impl__upt3bq(data) {
  return data;
}
function _AGBlending___get_data__impl__7m3zd1($this) {
  return $this;
}
function _AGBlending___get_srcRGB__impl__jvh03e($this) {
  // Inline function 'korlibs.memory.extract4' call
  var tmp$ret$0 = (_AGBlending___get_data__impl__7m3zd1($this) >>> 0 | 0) & 15;
  return _AGBlendFactor___init__impl__iqtmxr(tmp$ret$0);
}
function _AGBlending___get_srcA__impl__ftmwxe($this) {
  // Inline function 'korlibs.memory.extract4' call
  var tmp$ret$0 = (_AGBlending___get_data__impl__7m3zd1($this) >>> 4 | 0) & 15;
  return _AGBlendFactor___init__impl__iqtmxr(tmp$ret$0);
}
function _AGBlending___get_dstRGB__impl__nz9ogp($this) {
  // Inline function 'korlibs.memory.extract4' call
  var tmp$ret$0 = (_AGBlending___get_data__impl__7m3zd1($this) >>> 8 | 0) & 15;
  return _AGBlendFactor___init__impl__iqtmxr(tmp$ret$0);
}
function _AGBlending___get_dstA__impl__l7q6tv($this) {
  // Inline function 'korlibs.memory.extract4' call
  var tmp$ret$0 = (_AGBlending___get_data__impl__7m3zd1($this) >>> 12 | 0) & 15;
  return _AGBlendFactor___init__impl__iqtmxr(tmp$ret$0);
}
function _AGBlending___get_eqRGB__impl__7pv8oi($this) {
  // Inline function 'korlibs.memory.extract2' call
  var tmp$ret$0 = (_AGBlending___get_data__impl__7m3zd1($this) >>> 16 | 0) & 3;
  return _AGBlendEquation___init__impl__fpv7c2(tmp$ret$0);
}
function _AGBlending___get_eqA__impl__2j4ray($this) {
  // Inline function 'korlibs.memory.extract2' call
  var tmp$ret$0 = (_AGBlending___get_data__impl__7m3zd1($this) >>> 18 | 0) & 3;
  return _AGBlendEquation___init__impl__fpv7c2(tmp$ret$0);
}
function AGBlending__withSRC_impl_hh0mjq($this, rgb, a) {
  return _AGBlending___init__impl__upt3bq(insert4(insert4(_AGBlending___get_data__impl__7m3zd1($this), _AGBlendFactor___get_ordinal__impl__r9efzn(rgb), 0), _AGBlendFactor___get_ordinal__impl__r9efzn(a), 4));
}
function AGBlending__withSRC$default_impl_uuu5hz($this, rgb, a, $super) {
  a = a === VOID ? rgb : a;
  var tmp;
  if ($super === VOID) {
    tmp = AGBlending__withSRC_impl_hh0mjq($this, rgb, a);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGBlending(tmp_0)).g74.call(new AGBlending($this), new AGBlendFactor(rgb), new AGBlendFactor(a)).f74_1;
  }
  return tmp;
}
function AGBlending__withDST_impl_y1hpet($this, rgb, a) {
  return _AGBlending___init__impl__upt3bq(insert4(insert4(_AGBlending___get_data__impl__7m3zd1($this), _AGBlendFactor___get_ordinal__impl__r9efzn(rgb), 8), _AGBlendFactor___get_ordinal__impl__r9efzn(a), 12));
}
function AGBlending__withDST$default_impl_leu6qg($this, rgb, a, $super) {
  a = a === VOID ? rgb : a;
  var tmp;
  if ($super === VOID) {
    tmp = AGBlending__withDST_impl_y1hpet($this, rgb, a);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGBlending(tmp_0)).h74.call(new AGBlending($this), new AGBlendFactor(rgb), new AGBlendFactor(a)).f74_1;
  }
  return tmp;
}
function AGBlending__withEQ_impl_e9gm04($this, rgb, a) {
  return _AGBlending___init__impl__upt3bq(insert2(insert2(_AGBlending___get_data__impl__7m3zd1($this), _AGBlendEquation___get_ordinal__impl__895p3q(rgb), 16), _AGBlendEquation___get_ordinal__impl__895p3q(a), 18));
}
function AGBlending__withEQ$default_impl_iltiw7($this, rgb, a, $super) {
  a = a === VOID ? rgb : a;
  var tmp;
  if ($super === VOID) {
    tmp = AGBlending__withEQ_impl_e9gm04($this, rgb, a);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGBlending(tmp_0)).i74.call(new AGBlending($this), new AGBlendEquation(rgb), new AGBlendEquation(a)).f74_1;
  }
  return tmp;
}
function _AGBlending___get_enabled__impl__s7igz6($this) {
  return !($this === Companion_getInstance_42().a6v_1);
}
function AGBlending__toString_impl_d5hic6($this) {
  return 'Blending(outRGB = (srcRGB * ' + _AGBlendFactor___get_op__impl__b5pfnd(_AGBlending___get_srcRGB__impl__jvh03e($this)) + ') ' + _AGBlendEquation___get_op__impl__7f9os6(_AGBlending___get_eqRGB__impl__7pv8oi($this)) + ' (dstRGB * ' + _AGBlendFactor___get_op__impl__b5pfnd(_AGBlending___get_dstRGB__impl__nz9ogp($this)) + '), outA = (srcA * ' + _AGBlendFactor___get_op__impl__b5pfnd(_AGBlending___get_srcA__impl__ftmwxe($this)) + ') ' + _AGBlendEquation___get_op__impl__7f9os6(_AGBlending___get_eqA__impl__2j4ray($this)) + ' (dstA * ' + _AGBlendFactor___get_op__impl__b5pfnd(_AGBlending___get_dstA__impl__l7q6tv($this)) + '))';
}
var Companion_instance_36;
function Companion_getInstance_42() {
  if (Companion_instance_36 === VOID)
    new Companion_27();
  return Companion_instance_36;
}
function AGBlending__hashCode_impl_ywnf51($this) {
  return $this;
}
function AGBlending__equals_impl_rp3dmf($this, other) {
  if (!(other instanceof AGBlending))
    return false;
  if (!($this === (other instanceof AGBlending ? other.f74_1 : THROW_CCE())))
    return false;
  return true;
}
var Companion_instance_37;
function Companion_getInstance_43() {
  if (Companion_instance_37 === VOID)
    new Companion_28();
  return Companion_instance_37;
}
function _AGFrameBufferInfo___init__impl__dbxiro(dataLong) {
  return dataLong;
}
function _AGFrameBufferInfo___get_dataLong__impl__7vov5d($this) {
  return $this;
}
function _AGFrameBufferInfo___get_data__impl__7q146j($this) {
  return get_low(_AGFrameBufferInfo___get_dataLong__impl__7vov5d($this));
}
function _AGFrameBufferInfo___get_data2__impl__rgyo5b($this) {
  return get_high(_AGFrameBufferInfo___get_dataLong__impl__7vov5d($this));
}
function _AGFrameBufferInfo___init__impl__dbxiro_0(data, data2) {
  // Inline function 'korlibs.memory.fromLowHigh' call
  Companion_getInstance_0();
  var tmp$ret$0 = toLong(data).l4(new Long(-1, 0)).m4(toLong(data2).i4(32));
  return _AGFrameBufferInfo___init__impl__dbxiro(tmp$ret$0);
}
function _AGFrameBufferInfo___get_width__impl__yhp94z($this) {
  // Inline function 'korlibs.memory.extract14' call
  return (_AGFrameBufferInfo___get_data__impl__7q146j($this) >>> 0 | 0) & 16383;
}
function _AGFrameBufferInfo___get_height__impl__yfespa($this) {
  // Inline function 'korlibs.memory.extract14' call
  return (_AGFrameBufferInfo___get_data__impl__7q146j($this) >>> 14 | 0) & 16383;
}
function _AGFrameBufferInfo___get_x__impl__6dzfjj($this) {
  // Inline function 'korlibs.memory.extract14' call
  return (_AGFrameBufferInfo___get_data2__impl__rgyo5b($this) >>> 0 | 0) & 16383;
}
function _AGFrameBufferInfo___get_y__impl__mfn1io($this) {
  // Inline function 'korlibs.memory.extract14' call
  return (_AGFrameBufferInfo___get_data2__impl__rgyo5b($this) >>> 14 | 0) & 16383;
}
function _AGFrameBufferInfo___get_size__impl__uw80y4($this) {
  return Companion_instance_49.n75(_AGFrameBufferInfo___get_width__impl__yhp94z($this), _AGFrameBufferInfo___get_height__impl__yfespa($this));
}
function _AGFrameBufferInfo___get_hasDepth__impl__9knjmc($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGFrameBufferInfo___get_data__impl__7q146j($this) >>> 28 | 0) & 1) === 0);
}
function _AGFrameBufferInfo___get_hasStencil__impl__hjoes3($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGFrameBufferInfo___get_data__impl__7q146j($this) >>> 29 | 0) & 1) === 0);
}
function _get_samplesBits__rfaq0u($this) {
  // Inline function 'korlibs.memory.extract2' call
  return (_AGFrameBufferInfo___get_data__impl__7q146j($this) >>> 30 | 0) & 3;
}
function _AGFrameBufferInfo___get_samples__impl__7k555s($this) {
  return 1 << _get_samplesBits__rfaq0u($this);
}
function _AGFrameBufferInfo___get_hasStencilAndDepth__impl__aauqdj($this) {
  return _AGFrameBufferInfo___get_hasDepth__impl__9knjmc($this) && _AGFrameBufferInfo___get_hasStencil__impl__hjoes3($this);
}
function AGFrameBufferInfo__withXY_impl_rfdctr($this, x, y) {
  return _AGFrameBufferInfo___init__impl__dbxiro_0(_AGFrameBufferInfo___get_data__impl__7q146j($this), insert14(insert14(_AGFrameBufferInfo___get_data2__impl__rgyo5b($this), x, 0), y, 14));
}
function AGFrameBufferInfo__withSize_impl_sc5iep($this, width, height) {
  return _AGFrameBufferInfo___init__impl__dbxiro_0(insert14(insert14(_AGFrameBufferInfo___get_data__impl__7q146j($this), width, 0), height, 14), _AGFrameBufferInfo___get_data2__impl__rgyo5b($this));
}
function AGFrameBufferInfo__withBounds_impl_sg0n3x($this, x, y, width, height) {
  return AGFrameBufferInfo__withSize_impl_sc5iep(AGFrameBufferInfo__withXY_impl_rfdctr($this, x, y), width, height);
}
function AGFrameBufferInfo__withHasDepth_impl_fjgbiv($this, hasDepth) {
  return _AGFrameBufferInfo___init__impl__dbxiro_0(insert(_AGFrameBufferInfo___get_data__impl__7q146j($this), hasDepth, 28), _AGFrameBufferInfo___get_data2__impl__rgyo5b($this));
}
function AGFrameBufferInfo__withHasStencil_impl_nbaemo($this, hasStencil) {
  return _AGFrameBufferInfo___init__impl__dbxiro_0(insert(_AGFrameBufferInfo___get_data__impl__7q146j($this), hasStencil, 29), _AGFrameBufferInfo___get_data2__impl__rgyo5b($this));
}
function AGFrameBufferInfo__withSamples_impl_83818f($this, samples) {
  return withSamplesBits($this, ilog2(samples));
}
function withSamplesBits($this, bits) {
  return _AGFrameBufferInfo___init__impl__dbxiro_0(insert2(_AGFrameBufferInfo___get_data__impl__7q146j($this), bits, 30), _AGFrameBufferInfo___get_data2__impl__rgyo5b($this));
}
function AGFrameBufferInfo__toString_impl_xecyr8($this) {
  return 'AGFrameBufferInfo(width=' + _AGFrameBufferInfo___get_width__impl__yhp94z($this) + ', height=' + _AGFrameBufferInfo___get_height__impl__yfespa($this) + ', hasDepth=' + _AGFrameBufferInfo___get_hasDepth__impl__9knjmc($this) + ', hasStencil=' + _AGFrameBufferInfo___get_hasStencil__impl__hjoes3($this) + ', samples=' + _AGFrameBufferInfo___get_samples__impl__7k555s($this) + ')';
}
var Companion_instance_38;
function Companion_getInstance_44() {
  if (Companion_instance_38 === VOID)
    new Companion_29();
  return Companion_instance_38;
}
function AGFrameBufferInfo__hashCode_impl_fvl6f1($this) {
  return $this.hashCode();
}
var AGFinish_instance;
function AGFinish_getInstance() {
  return AGFinish_instance;
}
function _AGStencilReference___init__impl__rta8vg(data) {
  return data;
}
function _AGStencilReference___get_data__impl__j5p6bn($this) {
  return $this;
}
function _AGStencilReference___init__impl__rta8vg_0(front, back) {
  // Inline function 'korlibs.memory.fromLowHigh' call
  Companion_getInstance_0();
  var tmp$ret$0 = toLong(front).l4(new Long(-1, 0)).m4(toLong(back).i4(32));
  return _AGStencilReference___init__impl__rta8vg(tmp$ret$0);
}
var Companion_instance_39;
function Companion_getInstance_45() {
  if (Companion_instance_39 === VOID)
    new Companion_30();
  return Companion_instance_39;
}
function _AGStencilReference___get_front__impl__6ggyy0($this) {
  return get_low(_AGStencilReference___get_data__impl__j5p6bn($this));
}
function _AGStencilReference___get_back__impl__mm7fqe($this) {
  return get_high(_AGStencilReference___get_data__impl__j5p6bn($this));
}
function _AGStencilReference___get_referenceValueFront__impl__p7smsu($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_AGStencilReference___get_front__impl__6ggyy0($this) >>> 0 | 0) & 255;
}
function _AGStencilReference___get_readMaskFront__impl__oc0s46($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_AGStencilReference___get_front__impl__6ggyy0($this) >>> 8 | 0) & 255;
}
function _AGStencilReference___get_writeMaskFront__impl__cqdpbj($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_AGStencilReference___get_front__impl__6ggyy0($this) >>> 16 | 0) & 255;
}
function _AGStencilReference___get_referenceValueBack__impl__mlrbhc($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_AGStencilReference___get_back__impl__mm7fqe($this) >>> 0 | 0) & 255;
}
function _AGStencilReference___get_readMaskBack__impl__lwtaqk($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_AGStencilReference___get_back__impl__mm7fqe($this) >>> 8 | 0) & 255;
}
function _AGStencilReference___get_writeMaskBack__impl__mths73($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_AGStencilReference___get_back__impl__mm7fqe($this) >>> 16 | 0) & 255;
}
function AGStencilReference__withReferenceValue_impl_lm1qpg($this, referenceValue, referenceValueBack) {
  return _AGStencilReference___init__impl__rta8vg_0(insert8(_AGStencilReference___get_front__impl__6ggyy0($this), referenceValue, 0), insert8(_AGStencilReference___get_back__impl__mm7fqe($this), referenceValueBack, 0));
}
function AGStencilReference__withReferenceValue$default_impl_2trj0v($this, referenceValue, referenceValueBack, $super) {
  referenceValueBack = referenceValueBack === VOID ? referenceValue : referenceValueBack;
  var tmp;
  if ($super === VOID) {
    tmp = AGStencilReference__withReferenceValue_impl_lm1qpg($this, referenceValue, referenceValueBack);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGStencilReference(tmp_0)).z75.call(new AGStencilReference($this), referenceValue, referenceValueBack).y75_1;
  }
  return tmp;
}
function AGStencilReference__withReadMask_impl_75whrk($this, readMask, readMaskBack) {
  return _AGStencilReference___init__impl__rta8vg_0(insert8(_AGStencilReference___get_front__impl__6ggyy0($this), readMask, 8), insert8(_AGStencilReference___get_back__impl__mm7fqe($this), readMaskBack, 8));
}
function AGStencilReference__withReadMask$default_impl_7mdffx($this, readMask, readMaskBack, $super) {
  readMaskBack = readMaskBack === VOID ? readMask : readMaskBack;
  var tmp;
  if ($super === VOID) {
    tmp = AGStencilReference__withReadMask_impl_75whrk($this, readMask, readMaskBack);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGStencilReference(tmp_0)).a76.call(new AGStencilReference($this), readMask, readMaskBack).y75_1;
  }
  return tmp;
}
function AGStencilReference__withWriteMask_impl_s5s8t($this, writeMask, writeMaskBack) {
  return _AGStencilReference___init__impl__rta8vg_0(insert8(_AGStencilReference___get_front__impl__6ggyy0($this), writeMask, 16), insert8(_AGStencilReference___get_back__impl__mm7fqe($this), writeMaskBack, 16));
}
function AGStencilReference__withWriteMask$default_impl_b7j7b4($this, writeMask, writeMaskBack, $super) {
  writeMaskBack = writeMaskBack === VOID ? writeMask : writeMaskBack;
  var tmp;
  if ($super === VOID) {
    tmp = AGStencilReference__withWriteMask_impl_s5s8t($this, writeMask, writeMaskBack);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGStencilReference(tmp_0)).b76.call(new AGStencilReference($this), writeMask, writeMaskBack).y75_1;
  }
  return tmp;
}
function AGStencilReference__toString_impl_qu5r8s($this) {
  return 'AGStencilReference(front=[referenceValue=' + _AGStencilReference___get_referenceValueFront__impl__p7smsu($this) + ', readMask=' + _AGStencilReference___get_readMaskFront__impl__oc0s46($this) + ', writeMask=' + _AGStencilReference___get_writeMaskFront__impl__cqdpbj($this) + '], back=[referenceValue=' + _AGStencilReference___get_referenceValueBack__impl__mlrbhc($this) + ', readMask=' + _AGStencilReference___get_readMaskBack__impl__lwtaqk($this) + ', writeMask=' + _AGStencilReference___get_writeMaskBack__impl__mths73($this) + '])';
}
function AGStencilReference__hashCode_impl_52zufx($this) {
  return $this.hashCode();
}
function AGStencilReference__equals_impl_kj05j($this, other) {
  if (!(other instanceof AGStencilReference))
    return false;
  var tmp0_other_with_cast = other instanceof AGStencilReference ? other.y75_1 : THROW_CCE();
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
function _AGStencilOpFunc___init__impl__t3f62q(data) {
  return data;
}
function _AGStencilOpFunc___get_data__impl__jitrg1($this) {
  return $this;
}
var Companion_instance_40;
function Companion_getInstance_46() {
  if (Companion_instance_40 === VOID)
    new Companion_31();
  return Companion_instance_40;
}
function _AGStencilOpFunc___get_enabled__impl__hxq8wy($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 31 | 0) & 1) === 0);
}
function _AGStencilOpFunc___get_compareModeFront__impl__uctsey($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 0 | 0) & 7;
  return _AGCompareMode___init__impl__j8kqbb(tmp$ret$0);
}
function _AGStencilOpFunc___get_actionOnBothPassFront__impl__aehsgx($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 3 | 0) & 7;
  return _AGStencilOp___init__impl__llpkv6(tmp$ret$0);
}
function _AGStencilOpFunc___get_actionOnDepthFailFront__impl__vuqmyq($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 6 | 0) & 7;
  return _AGStencilOp___init__impl__llpkv6(tmp$ret$0);
}
function _AGStencilOpFunc___get_actionOnDepthPassStencilFailFront__impl__kl5ndh($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 9 | 0) & 7;
  return _AGStencilOp___init__impl__llpkv6(tmp$ret$0);
}
function _AGStencilOpFunc___get_compareModeBack__impl__2rklx0($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 12 | 0) & 7;
  return _AGCompareMode___init__impl__j8kqbb(tmp$ret$0);
}
function _AGStencilOpFunc___get_actionOnBothPassBack__impl__i5t9l9($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 15 | 0) & 7;
  return _AGStencilOp___init__impl__llpkv6(tmp$ret$0);
}
function _AGStencilOpFunc___get_actionOnDepthFailBack__impl__3tna28($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 18 | 0) & 7;
  return _AGStencilOp___init__impl__llpkv6(tmp$ret$0);
}
function _AGStencilOpFunc___get_actionOnDepthPassStencilFailBack__impl__4qprmh($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGStencilOpFunc___get_data__impl__jitrg1($this) >>> 21 | 0) & 7;
  return _AGStencilOp___init__impl__llpkv6(tmp$ret$0);
}
function AGStencilOpFunc__withEnabled_impl_mpcwmr($this, enabled) {
  return _AGStencilOpFunc___init__impl__t3f62q(insert(_AGStencilOpFunc___get_data__impl__jitrg1($this), enabled, 31));
}
function AGStencilOpFunc__withCompareMode_impl_5ovohy($this, compareMode, compareModeBack) {
  return _AGStencilOpFunc___init__impl__t3f62q(insert3(insert3(_AGStencilOpFunc___get_data__impl__jitrg1($this), _AGCompareMode___get_ordinal__impl__ikvlmz(compareMode), 0), _AGCompareMode___get_ordinal__impl__ikvlmz(compareModeBack), 12));
}
function AGStencilOpFunc__withCompareMode$default_impl_rzbauv($this, compareMode, compareModeBack, $super) {
  compareModeBack = compareModeBack === VOID ? compareMode : compareModeBack;
  var tmp;
  if ($super === VOID) {
    tmp = AGStencilOpFunc__withCompareMode_impl_5ovohy($this, compareMode, compareModeBack);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGStencilOpFunc(tmp_0)).t76.call(new AGStencilOpFunc($this), new AGCompareMode(compareMode), new AGCompareMode(compareModeBack)).s76_1;
  }
  return tmp;
}
function AGStencilOpFunc__withActionOnBothPass_impl_qbn6at($this, actionOnBothPass, actionOnBothPassBack) {
  return _AGStencilOpFunc___init__impl__t3f62q(insert3(insert3(_AGStencilOpFunc___get_data__impl__jitrg1($this), _AGStencilOp___get_ordinal__impl__xkavfu(actionOnBothPass), 3), _AGStencilOp___get_ordinal__impl__xkavfu(actionOnBothPassBack), 15));
}
function AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo($this, actionOnBothPass, actionOnBothPassBack, $super) {
  actionOnBothPassBack = actionOnBothPassBack === VOID ? actionOnBothPass : actionOnBothPassBack;
  var tmp;
  if ($super === VOID) {
    tmp = AGStencilOpFunc__withActionOnBothPass_impl_qbn6at($this, actionOnBothPass, actionOnBothPassBack);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGStencilOpFunc(tmp_0)).u76.call(new AGStencilOpFunc($this), new AGStencilOp(actionOnBothPass), new AGStencilOp(actionOnBothPassBack)).s76_1;
  }
  return tmp;
}
function AGStencilOpFunc__withActionOnDepthFail_impl_6tt0te($this, actionOnDepthFail, actionOnDepthFailBack) {
  return _AGStencilOpFunc___init__impl__t3f62q(insert3(insert3(_AGStencilOpFunc___get_data__impl__jitrg1($this), _AGStencilOp___get_ordinal__impl__xkavfu(actionOnDepthFail), 6), _AGStencilOp___get_ordinal__impl__xkavfu(actionOnDepthFailBack), 18));
}
function AGStencilOpFunc__withActionOnDepthPassStencilFail_impl_q34w35($this, actionOnDepthPassStencilFail, actionOnDepthPassStencilFailBack) {
  return _AGStencilOpFunc___init__impl__t3f62q(insert3(insert3(_AGStencilOpFunc___get_data__impl__jitrg1($this), _AGStencilOp___get_ordinal__impl__xkavfu(actionOnDepthPassStencilFail), 9), _AGStencilOp___get_ordinal__impl__xkavfu(actionOnDepthPassStencilFailBack), 21));
}
function AGStencilOpFunc__withAction_impl_p1jbl6($this, actionOnBothPass, actionOnDepthFail, actionOnDepthPassStencilFail, actionOnBothPassBack, actionOnDepthFailBack, actionOnDepthPassStencilFailBack) {
  return AGStencilOpFunc__withActionOnDepthPassStencilFail_impl_q34w35(AGStencilOpFunc__withActionOnDepthFail_impl_6tt0te(AGStencilOpFunc__withActionOnBothPass_impl_qbn6at($this, actionOnBothPass, actionOnBothPassBack), actionOnDepthFail, actionOnDepthFailBack), actionOnDepthPassStencilFail, actionOnDepthPassStencilFailBack);
}
function AGStencilOpFunc__withAction$default_impl_jx9cm1($this, actionOnBothPass, actionOnDepthFail, actionOnDepthPassStencilFail, actionOnBothPassBack, actionOnDepthFailBack, actionOnDepthPassStencilFailBack, $super) {
  actionOnDepthFail = actionOnDepthFail === VOID ? actionOnBothPass : actionOnDepthFail;
  actionOnDepthPassStencilFail = actionOnDepthPassStencilFail === VOID ? actionOnDepthFail : actionOnDepthPassStencilFail;
  actionOnBothPassBack = actionOnBothPassBack === VOID ? actionOnBothPass : actionOnBothPassBack;
  actionOnDepthFailBack = actionOnDepthFailBack === VOID ? actionOnDepthFail : actionOnDepthFailBack;
  actionOnDepthPassStencilFailBack = actionOnDepthPassStencilFailBack === VOID ? actionOnDepthPassStencilFail : actionOnDepthPassStencilFailBack;
  var tmp;
  if ($super === VOID) {
    tmp = AGStencilOpFunc__withAction_impl_p1jbl6($this, actionOnBothPass, actionOnDepthFail, actionOnDepthPassStencilFail, actionOnBothPassBack, actionOnDepthFailBack, actionOnDepthPassStencilFailBack);
  } else {
    var tmp_0 = $super;
    tmp = (tmp_0 == null ? null : new AGStencilOpFunc(tmp_0)).v76.call(new AGStencilOpFunc($this), new AGStencilOp(actionOnBothPass), new AGStencilOp(actionOnDepthFail), new AGStencilOp(actionOnDepthPassStencilFail), new AGStencilOp(actionOnBothPassBack), new AGStencilOp(actionOnDepthFailBack), new AGStencilOp(actionOnDepthPassStencilFailBack)).s76_1;
  }
  return tmp;
}
function AGStencilOpFunc__toString_impl_pl8quy($this) {
  if (!_AGStencilOpFunc___get_enabled__impl__hxq8wy($this))
    return 'AGStencilOpFunc(enabled=false)';
  return 'AGStencilOpFunc(enabled=' + _AGStencilOpFunc___get_enabled__impl__hxq8wy($this) + ', front=[compareMode=' + AGCompareMode__toString_impl_gs33a9(_AGStencilOpFunc___get_compareModeFront__impl__uctsey($this)) + ', actions=[' + AGStencilOp__toString_impl_1dm6fq(_AGStencilOpFunc___get_actionOnBothPassFront__impl__aehsgx($this)) + ', ' + AGStencilOp__toString_impl_1dm6fq(_AGStencilOpFunc___get_actionOnDepthFailFront__impl__vuqmyq($this)) + ', ' + AGStencilOp__toString_impl_1dm6fq(_AGStencilOpFunc___get_actionOnDepthPassStencilFailFront__impl__kl5ndh($this)) + ']], back=[compareMode=' + AGCompareMode__toString_impl_gs33a9(_AGStencilOpFunc___get_compareModeBack__impl__2rklx0($this)) + ', actions=[' + AGStencilOp__toString_impl_1dm6fq(_AGStencilOpFunc___get_actionOnBothPassBack__impl__i5t9l9($this)) + ', ' + AGStencilOp__toString_impl_1dm6fq(_AGStencilOpFunc___get_actionOnDepthFailBack__impl__3tna28($this)) + ', ' + AGStencilOp__toString_impl_1dm6fq(_AGStencilOpFunc___get_actionOnDepthPassStencilFailBack__impl__4qprmh($this)) + ']])';
}
function AGStencilOpFunc__hashCode_impl_nopebb($this) {
  return $this;
}
function AGStencilOpFunc__equals_impl_y44i4z($this, other) {
  if (!(other instanceof AGStencilOpFunc))
    return false;
  if (!($this === (other instanceof AGStencilOpFunc ? other.s76_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGColorMask___init__impl__j38ai8(data) {
  return data;
}
function _AGColorMask___get_data__impl__swj1bz($this) {
  return $this;
}
function _AGColorMask___get_red__impl__opo1fo($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGColorMask___get_data__impl__swj1bz($this) >>> 0 | 0) & 1) === 0);
}
function _AGColorMask___get_green__impl__d3m1w2($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGColorMask___get_data__impl__swj1bz($this) >>> 1 | 0) & 1) === 0);
}
function _AGColorMask___get_blue__impl__42l0s1($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGColorMask___get_data__impl__swj1bz($this) >>> 2 | 0) & 1) === 0);
}
function _AGColorMask___get_alpha__impl__xmrqzb($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGColorMask___get_data__impl__swj1bz($this) >>> 3 | 0) & 1) === 0);
}
function _AGColorMask___init__impl__j38ai8_0(red, green, blue, alpha) {
  return _AGColorMask___init__impl__j38ai8(insert(insert(insert(insert(0, red, 0), green, 1), blue, 2), alpha, 3));
}
function _AGColorMask___init__impl__j38ai8_1(value) {
  value = value === VOID ? true : value;
  return _AGColorMask___init__impl__j38ai8_0(value, value, value, value);
}
function AGColorMask__toString_impl_5i5oqg($this) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder.f();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.graphics.AGColorMask.toString.<anonymous>' call
  this_0.ec('AGColorMask(');
  this_0.ec(_AGColorMask___get_red__impl__opo1fo($this) ? 'R' : 'r');
  this_0.ec(_AGColorMask___get_green__impl__d3m1w2($this) ? 'G' : 'g');
  this_0.ec(_AGColorMask___get_blue__impl__42l0s1($this) ? 'B' : 'b');
  this_0.ec(_AGColorMask___get_alpha__impl__xmrqzb($this) ? 'A' : 'a');
  this_0.ec(')');
  return this_0.toString();
}
var Companion_instance_41;
function Companion_getInstance_47() {
  if (Companion_instance_41 === VOID)
    new Companion_32();
  return Companion_instance_41;
}
function AGColorMask__hashCode_impl_g9082f($this) {
  return $this;
}
function AGColorMask__equals_impl_mrih8l($this, other) {
  if (!(other instanceof AGColorMask))
    return false;
  if (!($this === (other instanceof AGColorMask ? other.w76_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGDepthAndFrontFace___init__impl__ra8x65(data) {
  return data;
}
function _AGDepthAndFrontFace___get_data__impl__v8zkce($this) {
  return $this;
}
var Companion_instance_42;
function Companion_getInstance_48() {
  if (Companion_instance_42 === VOID)
    new Companion_33();
  return Companion_instance_42;
}
function _AGDepthAndFrontFace___get_depthNear__impl__cir3a1($this) {
  return extractScaledf01(_AGDepthAndFrontFace___get_data__impl__v8zkce($this), 0, 12);
}
function _AGDepthAndFrontFace___get_depthFar__impl__g0cno8($this) {
  return extractScaledf01(_AGDepthAndFrontFace___get_data__impl__v8zkce($this), 12, 12);
}
function _AGDepthAndFrontFace___get_depthMask__impl__ouijn($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_AGDepthAndFrontFace___get_data__impl__v8zkce($this) >>> 24 | 0) & 1) === 0);
}
function _AGDepthAndFrontFace___get_depthFunc__impl__8fo7zp($this) {
  // Inline function 'korlibs.memory.extract3' call
  var tmp$ret$0 = (_AGDepthAndFrontFace___get_data__impl__v8zkce($this) >>> 26 | 0) & 7;
  return _AGCompareMode___init__impl__j8kqbb(tmp$ret$0);
}
function _AGDepthAndFrontFace___get_frontFace__impl__w07k4s($this) {
  // Inline function 'korlibs.memory.extract2' call
  var tmp$ret$0 = (_AGDepthAndFrontFace___get_data__impl__v8zkce($this) >>> 30 | 0) & 3;
  return _AGFrontFace___init__impl__vsm7rb(tmp$ret$0);
}
function AGDepthAndFrontFace__withDepth_impl_wsx82k($this, near, far) {
  return _AGDepthAndFrontFace___init__impl__ra8x65(insertScaledf01(insertScaledf01(_AGDepthAndFrontFace___get_data__impl__v8zkce($this), near, 0, 12), far, 12, 12));
}
function AGDepthAndFrontFace__withDepthMask_impl_610nhs($this, depthMask) {
  return _AGDepthAndFrontFace___init__impl__ra8x65(insert(_AGDepthAndFrontFace___get_data__impl__v8zkce($this), depthMask, 24));
}
function AGDepthAndFrontFace__withDepthFunc_impl_7t7yrs($this, depthFunc) {
  return _AGDepthAndFrontFace___init__impl__ra8x65(insert3(_AGDepthAndFrontFace___get_data__impl__v8zkce($this), _AGCompareMode___get_ordinal__impl__ikvlmz(depthFunc), 26));
}
function AGDepthAndFrontFace__withFrontFace_impl_mwk87t($this, frontFace) {
  return _AGDepthAndFrontFace___init__impl__ra8x65(insert2(_AGDepthAndFrontFace___get_data__impl__v8zkce($this), _AGFrontFace___get_ordinal__impl__d4iagj(frontFace), 30));
}
function AGDepthAndFrontFace__toString_impl_c305m3($this) {
  return 'AGDepthAndFrontFace(data=' + $this + ')';
}
function AGDepthAndFrontFace__hashCode_impl_xu62ey($this) {
  return $this;
}
function _AGCullFace___init__impl__ckmjdg(ordinal) {
  return ordinal;
}
function _AGCullFace___get_ordinal__impl__jd1wps($this) {
  return $this;
}
var Companion_instance_43;
function Companion_getInstance_49() {
  if (Companion_instance_43 === VOID)
    new Companion_34();
  return Companion_instance_43;
}
function AGCullFace__toString_impl_7d891w($this) {
  return $this === Companion_getInstance_49().z6v_1 ? 'NONE' : $this === Companion_getInstance_49().c6w_1 ? 'BOTH' : $this === Companion_getInstance_49().a6w_1 ? 'FRONT' : $this === Companion_getInstance_49().b6w_1 ? 'BACK' : '-';
}
function AGCullFace__hashCode_impl_t4e5ur($this) {
  return $this;
}
function AGCullFace__equals_impl_wgngjr($this, other) {
  if (!(other instanceof AGCullFace))
    return false;
  if (!($this === (other instanceof AGCullFace ? other.a77_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGReadKind___init__impl__sw15xt(ordinal) {
  return ordinal;
}
var Companion_instance_44;
function Companion_getInstance_50() {
  if (Companion_instance_44 === VOID)
    new Companion_35();
  return Companion_instance_44;
}
function _AGTextureTargetKind___init__impl__4zdmch(ordinal) {
  return ordinal;
}
function _AGTextureTargetKind___get_ordinal__impl__gjzc5p($this) {
  return $this;
}
function AGTextureTargetKind__toString_impl_68648p($this) {
  return $this === Companion_getInstance_51().a70_1 ? 'TEXTURE_2D' : $this === Companion_getInstance_51().b70_1 ? 'TEXTURE_3D' : $this === Companion_getInstance_51().c70_1 ? 'TEXTURE_CUBE_MAP' : $this === Companion_getInstance_51().d70_1 ? 'EXTERNAL_TEXTURE' : 'AGTextureTargetKind(' + _AGTextureTargetKind___get_ordinal__impl__gjzc5p($this) + ')';
}
function _AGTextureTargetKind___get_dims__impl__k3cmhd($this) {
  return $this === Companion_getInstance_51().a70_1 ? 2 : $this === Companion_getInstance_51().b70_1 ? 3 : $this === Companion_getInstance_51().c70_1 ? 3 : $this === Companion_getInstance_51().d70_1 ? 3 : 0;
}
var Companion_instance_45;
function Companion_getInstance_51() {
  if (Companion_instance_45 === VOID)
    new Companion_36();
  return Companion_instance_45;
}
function AGTextureTargetKind__hashCode_impl_rzc11k($this) {
  return $this;
}
function AGTextureTargetKind__equals_impl_q2tams($this, other) {
  if (!(other instanceof AGTextureTargetKind))
    return false;
  if (!($this === (other instanceof AGTextureTargetKind ? other.f70_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGWrapMode___init__impl__x5wmya(ordinal) {
  return ordinal;
}
function _AGWrapMode___get_ordinal__impl__rc38w2($this) {
  return $this;
}
var Companion_instance_46;
function Companion_getInstance_52() {
  if (Companion_instance_46 === VOID)
    new Companion_37();
  return Companion_instance_46;
}
function AGWrapMode__toString_impl_8bjnw2($this) {
  return $this === Companion_getInstance_52().z70_1 ? 'CLAMP_TO_EDGE' : $this === Companion_getInstance_52().a71_1 ? 'REPEAT' : $this === Companion_getInstance_52().b71_1 ? 'MIRRORED_REPEAT' : '<' + _AGWrapMode___get_ordinal__impl__rc38w2($this) + '>';
}
function AGWrapMode__hashCode_impl_u2pkox($this) {
  return $this;
}
function AGWrapMode__equals_impl_4aw0kl($this, other) {
  if (!(other instanceof AGWrapMode))
    return false;
  if (!($this === (other instanceof AGWrapMode ? other.w77_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGBlendFactor___init__impl__iqtmxr(ordinal) {
  return ordinal;
}
function _AGBlendFactor___get_ordinal__impl__r9efzn($this) {
  return $this;
}
var Companion_instance_47;
function Companion_getInstance_53() {
  if (Companion_instance_47 === VOID)
    new Companion_38();
  return Companion_instance_47;
}
function AGBlendFactor__toString_impl_1hr6m1($this) {
  return $this === Companion_getInstance_53().j74_1 ? 'DESTINATION_ALPHA' : $this === Companion_getInstance_53().k74_1 ? 'DESTINATION_COLOR' : $this === Companion_getInstance_53().l74_1 ? 'ONE' : $this === Companion_getInstance_53().m74_1 ? 'ONE_MINUS_DESTINATION_ALPHA' : $this === Companion_getInstance_53().n74_1 ? 'ONE_MINUS_DESTINATION_COLOR' : $this === Companion_getInstance_53().o74_1 ? 'ONE_MINUS_SOURCE_ALPHA' : $this === Companion_getInstance_53().p74_1 ? 'ONE_MINUS_SOURCE_COLOR' : $this === Companion_getInstance_53().q74_1 ? 'SOURCE_ALPHA' : $this === Companion_getInstance_53().r74_1 ? 'SOURCE_COLOR' : $this === Companion_getInstance_53().s74_1 ? 'ZERO' : '-';
}
function _AGBlendFactor___get_op__impl__b5pfnd($this) {
  var tmp;
  if ($this === Companion_getInstance_53().j74_1) {
    tmp = 'dstA';
  } else if ($this === Companion_getInstance_53().k74_1) {
    tmp = 'dstRGB';
  } else if ($this === Companion_getInstance_53().l74_1) {
    tmp = '1';
  } else if ($this === Companion_getInstance_53().m74_1) {
    tmp = '(1 - dstA)';
  } else if ($this === Companion_getInstance_53().n74_1) {
    tmp = '(1 - dstRGB)';
  } else if ($this === Companion_getInstance_53().o74_1) {
    tmp = '(1 - srcA)';
  } else if ($this === Companion_getInstance_53().p74_1) {
    tmp = '(1 - srcRGB)';
  } else if ($this === Companion_getInstance_53().q74_1) {
    tmp = 'srcA';
  } else if ($this === Companion_getInstance_53().r74_1) {
    tmp = 'srcRGB';
  } else if ($this === Companion_getInstance_53().s74_1) {
    tmp = '0';
  } else {
    get_unreachable();
  }
  return tmp;
}
function AGBlendFactor__hashCode_impl_n8x3ew($this) {
  return $this;
}
function AGBlendFactor__equals_impl_dlauac($this, other) {
  if (!(other instanceof AGBlendFactor))
    return false;
  if (!($this === (other instanceof AGBlendFactor ? other.x77_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGBlendEquation___init__impl__fpv7c2(ordinal) {
  return ordinal;
}
function _AGBlendEquation___get_ordinal__impl__895p3q($this) {
  return $this;
}
var Companion_instance_48;
function Companion_getInstance_54() {
  if (Companion_instance_48 === VOID)
    new Companion_39();
  return Companion_instance_48;
}
function AGBlendEquation__toString_impl_5t2sx6($this) {
  return $this === Companion_getInstance_54().w74_1 ? 'ADD' : $this === Companion_getInstance_54().x74_1 ? 'SUBTRACT' : $this === Companion_getInstance_54().y74_1 ? 'REVERSE_SUBTRACT' : '-';
}
function _AGBlendEquation___get_op__impl__7f9os6($this) {
  var tmp;
  if ($this === Companion_getInstance_54().w74_1) {
    tmp = '+';
  } else if ($this === Companion_getInstance_54().x74_1) {
    tmp = '-';
  } else if ($this === Companion_getInstance_54().y74_1) {
    tmp = 'r-';
  } else {
    get_unreachable();
  }
  return tmp;
}
function AGBlendEquation__hashCode_impl_fy33vp($this) {
  return $this;
}
function AGBlendEquation__equals_impl_yykk3b($this, other) {
  if (!(other instanceof AGBlendEquation))
    return false;
  if (!($this === (other instanceof AGBlendEquation ? other.y77_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGSize___init__impl__h9blcq(data) {
  return data;
}
function AGSize__with_impl_qn6qww($this, width, height) {
  return _AGSize___init__impl__h9blcq(insert_0(insert_0(0, width, 0, 16), height, 16, 16));
}
var Companion_instance_49;
function Companion_getInstance_55() {
  return Companion_instance_49;
}
function _AGStencilOp___init__impl__llpkv6(ordinal) {
  return ordinal;
}
function _AGStencilOp___get_ordinal__impl__xkavfu($this) {
  return $this;
}
var Companion_instance_50;
function Companion_getInstance_56() {
  if (Companion_instance_50 === VOID)
    new Companion_41();
  return Companion_instance_50;
}
function AGStencilOp__toString_impl_1dm6fq($this) {
  return $this === Companion_getInstance_56().k76_1 ? 'DECREMENT_SATURATE' : $this === Companion_getInstance_56().l76_1 ? 'DECREMENT_WRAP' : $this === Companion_getInstance_56().m76_1 ? 'INCREMENT_SATURATE' : $this === Companion_getInstance_56().n76_1 ? 'INCREMENT_WRAP' : $this === Companion_getInstance_56().o76_1 ? 'INVERT' : $this === Companion_getInstance_56().p76_1 ? 'KEEP' : $this === Companion_getInstance_56().q76_1 ? 'SET' : $this === Companion_getInstance_56().r76_1 ? 'ZERO' : '-';
}
function AGStencilOp__hashCode_impl_n4s38l($this) {
  return $this;
}
function AGStencilOp__equals_impl_rq4p55($this, other) {
  if (!(other instanceof AGStencilOp))
    return false;
  if (!($this === (other instanceof AGStencilOp ? other.a78_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGCompareMode___init__impl__j8kqbb(ordinal) {
  return ordinal;
}
function _AGCompareMode___get_ordinal__impl__ikvlmz($this) {
  return $this;
}
var Companion_instance_51;
function Companion_getInstance_57() {
  if (Companion_instance_51 === VOID)
    new Companion_42();
  return Companion_instance_51;
}
function AGCompareMode__toString_impl_gs33a9($this) {
  return $this === Companion_getInstance_57().c76_1 ? 'ALWAYS' : $this === Companion_getInstance_57().d76_1 ? 'EQUAL' : $this === Companion_getInstance_57().e76_1 ? 'GREATER' : $this === Companion_getInstance_57().f76_1 ? 'GREATER_EQUAL' : $this === Companion_getInstance_57().g76_1 ? 'LESS' : $this === Companion_getInstance_57().h76_1 ? 'LESS_EQUAL' : $this === Companion_getInstance_57().i76_1 ? 'NEVER' : $this === Companion_getInstance_57().j76_1 ? 'NOT_EQUAL' : '-';
}
function AGCompareMode__inverted_impl_7xxk8m($this) {
  return $this === Companion_getInstance_57().c76_1 ? Companion_getInstance_57().i76_1 : $this === Companion_getInstance_57().d76_1 ? Companion_getInstance_57().j76_1 : $this === Companion_getInstance_57().e76_1 ? Companion_getInstance_57().h76_1 : $this === Companion_getInstance_57().f76_1 ? Companion_getInstance_57().g76_1 : $this === Companion_getInstance_57().g76_1 ? Companion_getInstance_57().f76_1 : $this === Companion_getInstance_57().h76_1 ? Companion_getInstance_57().e76_1 : $this === Companion_getInstance_57().i76_1 ? Companion_getInstance_57().c76_1 : $this === Companion_getInstance_57().j76_1 ? Companion_getInstance_57().d76_1 : Companion_getInstance_57().i76_1;
}
function AGCompareMode__hashCode_impl_whv1w0($this) {
  return $this;
}
function AGCompareMode__equals_impl_rbniy4($this, other) {
  if (!(other instanceof AGCompareMode))
    return false;
  if (!($this === (other instanceof AGCompareMode ? other.b78_1 : THROW_CCE())))
    return false;
  return true;
}
function _AGFrontFace___init__impl__vsm7rb(ordinal) {
  return ordinal;
}
function _AGFrontFace___get_ordinal__impl__d4iagj($this) {
  return $this;
}
var Companion_instance_52;
function Companion_getInstance_58() {
  if (Companion_instance_52 === VOID)
    new Companion_43();
  return Companion_instance_52;
}
function toAGScissor(_this__u8e3s4) {
  if (_this__u8e3s4 == null)
    return Companion_getInstance_43().x6v_1;
  return AGScissor.e75(numberToInt(_this__u8e3s4.r2d_1), numberToInt(_this__u8e3s4.s2d_1), numberToInt(_this__u8e3s4.t2d_1), numberToInt(_this__u8e3s4.u2d_1));
}
function plus_5(_this__u8e3s4, scissor) {
  return BoundsBuilder__plus_impl_cz7f7x(BoundsBuilder__plus_impl_cz7f7x(_this__u8e3s4, Vector2D.d2g(scissor.y2d(), scissor.a2e())), Vector2D.d2g(scissor.z2d(), scissor.b2e()));
}
function applyMatrixBounds(_this__u8e3s4, m) {
  var x0 = m.o2h(_this__u8e3s4.y2d(), _this__u8e3s4.a2e());
  var x1 = m.o2h(_this__u8e3s4.z2d(), _this__u8e3s4.a2e());
  var x2 = m.o2h(_this__u8e3s4.y2d(), _this__u8e3s4.b2e());
  var x3 = m.o2h(_this__u8e3s4.z2d(), _this__u8e3s4.b2e());
  var y0 = m.p2h(_this__u8e3s4.y2d(), _this__u8e3s4.a2e());
  var y1 = m.p2h(_this__u8e3s4.z2d(), _this__u8e3s4.a2e());
  var y2 = m.p2h(_this__u8e3s4.y2d(), _this__u8e3s4.b2e());
  var y3 = m.p2h(_this__u8e3s4.z2d(), _this__u8e3s4.b2e());
  return Companion_getInstance_43().s2l(numberToInt(min(x0, x1, x2, x3)), numberToInt(min(y0, y1, y2, y3)), numberToInt(max_0(x0, x1, x2, x3)), numberToInt(max_0(y0, y1, y2, y3)));
}
var AGBufferKind_INDEX_instance;
var AGBufferKind_VERTEX_instance;
var AGBufferKind_UNIFORM_instance;
var AGBufferKind_entriesInitialized;
function AGBufferKind_initEntries() {
  if (AGBufferKind_entriesInitialized)
    return Unit_instance;
  AGBufferKind_entriesInitialized = true;
  AGBufferKind_INDEX_instance = new AGBufferKind('INDEX', 0);
  AGBufferKind_VERTEX_instance = new AGBufferKind('VERTEX', 1);
  AGBufferKind_UNIFORM_instance = new AGBufferKind('UNIFORM', 2);
}
function AGBufferKind_INDEX_getInstance() {
  AGBufferKind_initEntries();
  return AGBufferKind_INDEX_instance;
}
function AGBufferKind_VERTEX_getInstance() {
  AGBufferKind_initEntries();
  return AGBufferKind_VERTEX_instance;
}
function AGBufferKind_UNIFORM_getInstance() {
  AGBufferKind_initEntries();
  return AGBufferKind_UNIFORM_instance;
}
var ProjViewUB_instance;
function ProjViewUB_getInstance() {
  if (ProjViewUB_instance === VOID)
    new ProjViewUB();
  return ProjViewUB_instance;
}
var DefaultShaders_instance;
function DefaultShaders_getInstance() {
  if (DefaultShaders_instance === VOID)
    new DefaultShaders();
  return DefaultShaders_instance;
}
function u_Tex$factory() {
  return getPropertyCallableRef('u_Tex', 1, KProperty1, function (receiver) {
    return receiver.y7b();
  }, null);
}
function u_TexEx$factory() {
  return getPropertyCallableRef('u_TexEx', 1, KProperty1, function (receiver) {
    return receiver.a7c();
  }, null);
}
function u_Tex$factory_0() {
  return getPropertyCallableRef('u_Tex', 1, KProperty1, function (receiver) {
    return receiver.y7b();
  }, null);
}
function u_TexEx$factory_0() {
  return getPropertyCallableRef('u_TexEx', 1, KProperty1, function (receiver) {
    return receiver.a7c();
  }, null);
}
function u_ProjMat$factory() {
  return getPropertyCallableRef('u_ProjMat', 1, KProperty1, function (receiver) {
    return receiver.d79();
  }, null);
}
function u_ViewMat$factory() {
  return getPropertyCallableRef('u_ViewMat', 1, KProperty1, function (receiver) {
    return receiver.e79();
  }, null);
}
function u_ProjMat$factory_0() {
  return getPropertyCallableRef('u_ProjMat', 1, KProperty1, function (receiver) {
    return receiver.d79();
  }, null);
}
function u_ViewMat$factory_0() {
  return getPropertyCallableRef('u_ViewMat', 1, KProperty1, function (receiver) {
    return receiver.e79();
  }, null);
}
function get_ENABLE_UNIFORM_BLOCKS() {
  _init_properties_AGOpengl_kt__dtzqx7();
  return ENABLE_UNIFORM_BLOCKS;
}
var ENABLE_UNIFORM_BLOCKS;
function get_ENABLE_VERTEX_ARRAY_OBJECTS() {
  _init_properties_AGOpengl_kt__dtzqx7();
  return ENABLE_VERTEX_ARRAY_OBJECTS;
}
var ENABLE_VERTEX_ARRAY_OBJECTS;
function set_gl(_this__u8e3s4, _set____db54di) {
  _init_properties_AGOpengl_kt__dtzqx7();
  var this_0 = gl$delegate;
  var property = gl$factory();
  var value = this_0.x10_1(_this__u8e3s4, _set____db54di);
  var tmp0_elvis_lhs = this_0.v10_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, value);
  return Unit_instance;
}
function get_gl(_this__u8e3s4) {
  _init_properties_AGOpengl_kt__dtzqx7();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = gl$delegate;
    var property = gl$factory_0();
    var tmp0_elvis_lhs = this_0.v10_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.w10_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.v10_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var gl$delegate;
function useProgram($this, program) {
  var gl = $this.m7e_1;
  var map = $this.q7e_1;
  if ($this.r7e_1 == null) {
    $this.r7e_1 = gl.w7f(35724);
    // Inline function 'korlibs.logger.Logger.info' call
    var this_0 = Companion_getInstance_36().p6t_1;
    var level = Level_INFO_getInstance();
    var tmp;
    if (this_0.q31(level)) {
      // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>' call
      var tmp$ret$0 = 'GL_VERSION=' + gl.w7f(7938);
      this_0.r31(level, tmp$ret$0);
      tmp = Unit_instance;
    }
    // Inline function 'korlibs.logger.Logger.info' call
    var this_1 = Companion_getInstance_36().p6t_1;
    var level_0 = Level_INFO_getInstance();
    var tmp_0;
    if (this_1.q31(level_0)) {
      // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>' call
      var tmp$ret$2 = 'GL_SHADING_LANGUAGE_VERSION=' + $this.r7e_1;
      this_1.r31(level_0, tmp$ret$2);
      tmp_0 = Unit_instance;
    }
    // Inline function 'korlibs.logger.Logger.info' call
    var this_2 = Companion_getInstance_36().p6t_1;
    var level_1 = Level_INFO_getInstance();
    var tmp_1;
    if (this_2.q31(level_1)) {
      // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>' call
      var tmp$ret$4 = 'GL_UNIFORM_BUFFER_OFFSET_ALIGNMENT=' + getInteger(gl, 35380);
      this_2.r31(level_1, tmp$ret$4);
      tmp_1 = Unit_instance;
    }
    // Inline function 'korlibs.logger.Logger.info' call
    var this_3 = Companion_getInstance_36().p6t_1;
    var level_2 = Level_INFO_getInstance();
    var tmp_2;
    if (this_3.q31(level_2)) {
      // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>' call
      var tmp$ret$6 = 'gl.versionString=' + get_versionString(gl);
      this_3.r31(level_2, tmp$ret$6);
      tmp_2 = Unit_instance;
    }
    // Inline function 'korlibs.logger.Logger.info' call
    var this_4 = Companion_getInstance_36().p6t_1;
    var level_3 = Level_INFO_getInstance();
    var tmp_3;
    if (this_4.q31(level_3)) {
      // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>' call
      var tmp$ret$8 = 'gl.versionInt=' + get_versionInt(gl);
      this_4.r31(level_3, tmp$ret$8);
      tmp_3 = Unit_instance;
    }
  }
  // Inline function 'kotlin.collections.getOrPut' call
  var value = map.h3(program);
  var tmp_4;
  if (value == null) {
    // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>' call
    // Inline function 'kotlin.also' call
    var this_5 = new GLBaseProgram($this.p7e_1, GLShaderCompiler_getInstance().z7f(gl, $this.x7f(), program, program.c72_1));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>.<anonymous>' call
    this_5.d7g();
    var programInfo = this_5.c7g_1;
    var programId = programInfo.e7g_1;
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = program.g72_1.a1();
    while (tmp0_iterator.b1()) {
      var element = tmp0_iterator.c1();
      // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>.<anonymous>.<anonymous>' call
      var location = programInfo.z7g(gl, element.u7g_1);
      gl.a7h(location, element.o6y_1);
    }
    if (programInfo.i7g_1.h7h()) {
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var this_6 = program.f72_1;
      var n = 0;
      while (n < this_6.e1()) {
        // Inline function 'korlibs.graphics.gl.AGOpengl.useProgram.<anonymous>.<anonymous>.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        var it = this_6.d1(_unary__edvuaz);
        var index = gl.b7h(programId, it.u3());
        gl.c7h(programId, index, it.a73_1);
      }
    }
    var answer = this_5;
    map.j3(program, answer);
    tmp_4 = answer;
  } else {
    tmp_4 = value;
  }
  var nprogram = tmp_4;
  if (!equals($this.a7f_1, nprogram)) {
    $this.a7f_1 = nprogram;
    nprogram.d7g();
  }
}
function resetObjects($this) {
  $this.t7e_1 = null;
  $this.e7f_1 = Companion_getInstance_43().w6v_1;
  $this.u7e_1 = Companion_getInstance_42().z6u_1;
  $this.v7e_1 = Companion_getInstance_49().y6v_1;
  $this.w7e_1 = Companion_getInstance_46().k6v_1;
  $this.x7e_1 = Companion_getInstance_45().i6v_1;
  $this.y7e_1 = Companion_getInstance_47().m6v_1;
  $this.z7e_1 = Companion_getInstance_48().s6v_1;
  $this.b7f_1.m3();
  $this.a7f_1 = null;
  $this.p7f_1 = -1;
  $this.n7f_1 = 0;
  $this.o7f_1 = Companion_instance_49.z77();
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = $this.k7f_1;
  var n = 0;
  while (n < this_0.length) {
    // Inline function 'korlibs.graphics.gl.AGOpengl.resetObjects.<anonymous>' call
    var _unary__edvuaz = n;
    n = _unary__edvuaz + 1 | 0;
    this_0[_unary__edvuaz].j2y();
  }
}
function deletePendingObjects($this) {
  while (true) {
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    // Inline function 'korlibs.concurrent.lock.Lock.invoke' call
    var this_0 = $this.p7e_1.w7h_1;
    var tmp$ret$3;
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.LockImpl.lockUnlock' call
      this_0.b20();
      try {
        // Inline function 'korlibs.graphics.gl.AGOpengl.deletePendingObjects.<anonymous>' call
        var tmp;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!$this.p7e_1.x7h_1.g1()) {
          // Inline function 'kotlin.also' call
          var this_1 = toList($this.p7e_1.x7h_1);
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.graphics.gl.AGOpengl.deletePendingObjects.<anonymous>.<anonymous>' call
          $this.p7e_1.x7h_1.m3();
          tmp = this_1;
        } else {
          return Unit_instance;
        }
        tmp$ret$3 = tmp;
        break $l$block;
      }finally {
        this_0.d20();
      }
    }
    var n = 0;
    while (n < tmp$ret$3.e1()) {
      // Inline function 'korlibs.graphics.gl.AGOpengl.deletePendingObjects.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      tmp$ret$3.d1(_unary__edvuaz).a7i();
    }
  }
}
function bindBuffer($this, buffer, target, onlyUpdate, reallocated, updated) {
  var gl = $this.m7e_1;
  if (reallocated == null)
    null;
  else {
    reallocated.z2y(false);
  }
  if (updated == null)
    null;
  else {
    updated.z2y(false);
  }
  if (buffer == null) {
    gl.b7i(toGl_6(target), 0);
    return null;
  }
  var bufferInfo = _get_gl__ndc1ty(buffer, $this);
  if (!onlyUpdate) {
    gl.b7i(toGl_6(target), bufferInfo.e7i_1);
  }
  $this.h7i(buffer, AGOpengl$bindBuffer$lambda(buffer, bufferInfo, onlyUpdate, gl, target, reallocated, updated));
  return bufferInfo;
}
function bindBuffer$default($this, buffer, target, onlyUpdate, reallocated, updated, $super) {
  onlyUpdate = onlyUpdate === VOID ? false : onlyUpdate;
  reallocated = reallocated === VOID ? null : reallocated;
  updated = updated === VOID ? null : updated;
  return bindBuffer($this, buffer, target, onlyUpdate, reallocated, updated);
}
function writeUniform($this, uniform, programInfo, data, source) {
  var gl = $this.m7e_1;
  var location = programInfo.z7g(gl, uniform.u7g_1);
  var uniformType = uniform.i2h();
  var arrayCount = uniform.k7i_1;
  if (uniformType.r7i_1.t3_1 === 6) {
    switch (uniformType.t3_1) {
      case 1:
        gl.z7i(location, arrayCount, false, data);
        break;
      case 2:
        var inductionVariable = 0;
        if (inductionVariable < 3)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            arraycopy_0(data, imul(n, 16), $this.j7f_1, imul(n, 12), 12);
          }
           while (inductionVariable < 3);
        gl.a7j(location, arrayCount, false, $this.j7f_1);
        break;
      case 3:
        gl.b7j(location, arrayCount, false, data);
        break;
      default:
        switch (uniformType.s7i_1) {
          case 1:
            gl.c7j(location, arrayCount, data);
            break;
          case 2:
            gl.d7j(location, arrayCount, data);
            break;
          case 3:
            gl.e7j(location, arrayCount, data);
            break;
          case 4:
            gl.f7j(location, arrayCount, data);
            break;
        }

        break;
    }
  } else {
    switch (uniformType.s7i_1) {
      case 1:
        gl.v7i(location, arrayCount, data);
        break;
      case 2:
        gl.w7i(location, arrayCount, data);
        break;
      case 3:
        gl.x7i(location, arrayCount, data);
        break;
      case 4:
        gl.y7i(location, arrayCount, data);
        break;
    }
  }
}
function textureUnitParameters($this, implForcedTexTarget, wrap, minFilter, magFilter, dims) {
  var gl = $this.m7e_1;
  var params = $this.k7f_1[$this.n7f_1];
  var glTarget = toGl_8(implForcedTexTarget);
  params.j7h_1 = wrap;
  var glWrap = toGl_9(wrap);
  gl.g7j(glTarget, 10242, glWrap);
  gl.g7j(glTarget, 10243, glWrap);
  if (dims >= 3) {
    gl.g7j(glTarget, 32882, glWrap);
  }
  params.k7h_1 = minFilter;
  params.l7h_1 = magFilter;
  gl.g7j(glTarget, 10241, minFilter);
  gl.g7j(glTarget, 10240, magFilter);
}
function createBufferForBitmap($this, bmp) {
  var tmp;
  if (bmp == null) {
    tmp = null;
  } else {
    if (bmp instanceof NativeImage) {
      unsupported('Should not call createBufferForBitmap with a NativeImage');
    } else {
      if (bmp instanceof Bitmap8) {
        // Inline function 'kotlin.also' call
        var this_0 = Buffer.b15(bmp.b2n());
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.graphics.gl.AGOpengl.createBufferForBitmap.<anonymous>' call
        arraycopy_3(bmp.d4d(), 0, get_i8(this_0), 0, bmp.b2n());
        tmp = this_0;
      } else {
        if (bmp instanceof FloatBitmap32) {
          // Inline function 'kotlin.also' call
          var this_1 = Buffer.b15(imul(imul(bmp.b2n(), 4), 4));
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.graphics.gl.AGOpengl.createBufferForBitmap.<anonymous>' call
          arraycopy_2(bmp.q4g_1, 0, get_f32(this_1), 0, imul(bmp.b2n(), 4));
          tmp = this_1;
        } else {
          // Inline function 'kotlin.also' call
          var this_2 = Buffer.b15(imul(bmp.b2n(), 4));
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.graphics.gl.AGOpengl.createBufferForBitmap.<anonymous>' call
          var abmp = bmp.x43_1 ? bmp.o4b().t4e() : bmp.o4b().u4e();
          arraycopy_1(abmp.h43_1, 0, get_i32(this_2), 0, abmp.b2n());
          tmp = this_2;
        }
      }
    }
  }
  return tmp;
}
function selectTextureUnit($this, index) {
  var old = $this.n7f_1;
  if (!($this.n7f_1 === index)) {
    $this.n7f_1 = index;
    if (index >= 0) {
      $this.m7e_1.h7j(33984 + index | 0);
    }
  }
  return old;
}
function _get_gl__ndc1ty(_this__u8e3s4, $this) {
  return gl(_this__u8e3s4, $this.p7e_1);
}
function _get_gl__ndc1ty_0(_this__u8e3s4, $this) {
  return gl_0(_this__u8e3s4, $this.p7e_1);
}
function _get_gl__ndc1ty_1(_this__u8e3s4, $this) {
  return gl_1(_this__u8e3s4, $this.p7e_1);
}
function AGOpengl$glslConfig$delegate$lambda(this$0) {
  return function () {
    return new GlslConfig(this$0.m7e_1.i7j(), this$0.m7e_1);
  };
}
function AGOpengl$bindBuffer$lambda($buffer, $bufferInfo, $onlyUpdate, $gl, $target, $reallocated, $updated) {
  return function (it) {
    var tmp0_elvis_lhs = $buffer.n6x_1;
    var mem = tmp0_elvis_lhs == null ? Buffer.b15(0) : tmp0_elvis_lhs;
    $bufferInfo.j7j(mem.g15());
    var tmp;
    if ($onlyUpdate) {
      $gl.b7i(toGl_6($target), $bufferInfo.e7i_1);
      tmp = Unit_instance;
    }
    var tmp_0;
    if ($bufferInfo.f7i_1 < mem.g15()) {
      $bufferInfo.f7i_1 = mem.g15();
      $gl.l7j(toGl_6($target), mem.g15(), mem, 35048);
      var tmp1_safe_receiver = $reallocated;
      if (tmp1_safe_receiver == null)
        null;
      else {
        tmp1_safe_receiver.z2y(true);
      }
      tmp_0 = Unit_instance;
    } else {
      $gl.k7j(toGl_6($target), 0, mem.g15(), mem);
      tmp_0 = Unit_instance;
    }
    var tmp2_safe_receiver = $updated;
    if (tmp2_safe_receiver == null)
      null;
    else {
      tmp2_safe_receiver.z2y(true);
    }
    return Unit_instance;
  };
}
function AGOpengl$textureBind$lambda($tex, $target, $gl, this$0, $glTex) {
  return function (it) {
    var rbmp = $tex.t6z_1;
    var tmp0_safe_receiver = (rbmp == null ? true : rbmp instanceof MultiBitmap) ? rbmp : null;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.u70_1;
    var bmps = tmp1_elvis_lhs == null ? listOf(rbmp) : tmp1_elvis_lhs;
    var requestMipmaps = $tex.q6z_1;
    $tex.u6z_1 = $tex.w70(rbmp, requestMipmaps);
    var totalSize = 0.0;
    var iterator = bmps.a1();
    var index = 0;
    while (iterator.b1()) {
      var index_0 = index;
      index = index + 1 | 0;
      var bmp = iterator.c1();
      var isFloat = bmp instanceof FloatBitmap32;
      var tmp;
      if (bmp instanceof Bitmap8) {
        tmp = 6409;
      } else {
        tmp = 6408;
      }
      var type = tmp;
      var texTarget = $target === Companion_getInstance_51().c70_1 ? 34069 + index_0 | 0 : toGl_8($target);
      var internalFormat = isFloat && (_GLVariant___get_isWebGL__impl__bbd1dd($gl.i7j()) && _GLVariant___get_version__impl__9nyfwa($gl.i7j()) >= 2) ? 34836 : type;
      var format = type;
      var texType = isFloat ? 5126 : 5121;
      if (_GLVariant___get_os__impl__aswhdw($gl.i7j()).rw()) {
        $gl.m7j(3313, 0);
        $gl.m7j(3312, 1);
      }
      if (bmp == null) {
        $gl.n7j(toGl_8($target), 0, type, $tex.x2p(), $tex.y2p(), 0, type, 5121, null);
      } else {
        if (bmp instanceof NativeImage) {
          if (!(bmp.b2n() === 0)) {
            $gl.o7j(texTarget, 0, type, type, 5121, bmp);
          }
        } else {
          if (bmp instanceof NullBitmap) {
            $gl.n7j(texTarget, 0, internalFormat, bmp.r43_1, bmp.s43_1, 0, format, texType, null);
          } else {
            var buffer = createBufferForBitmap(this$0, bmp);
            if (!(buffer == null) && !(bmp.r43_1 === 0) && !(bmp.s43_1 === 0) && !(get_size_0(buffer) === 0)) {
              $gl.n7j(texTarget, 0, internalFormat, bmp.r43_1, bmp.s43_1, 0, format, texType, buffer);
            }
          }
        }
      }
      totalSize = totalSize + imul(imul($tex.x2p(), $tex.y2p()), 4);
      if (_GLVariant___get_supportTextureLevel__impl__3yeu62($gl.i7j())) {
        var tmp_0;
        if ($tex.u6z_1) {
          var tmp4_elvis_lhs = $tex.r6z_1;
          tmp_0 = tmp4_elvis_lhs == null ? 0 : tmp4_elvis_lhs;
        } else {
          tmp_0 = 0;
        }
        $gl.g7j(3553, 33084, tmp_0);
        var tmp_1;
        if ($tex.u6z_1) {
          var tmp5_elvis_lhs = $tex.s6z_1;
          tmp_1 = tmp5_elvis_lhs == null ? 1000 : tmp5_elvis_lhs;
        } else {
          tmp_1 = 0;
        }
        $gl.g7j(3553, 33085, tmp_1);
      }
      if ($tex.u6z_1) {
        $gl.p7j(texTarget);
      }
    }
    $glTex.j7j(totalSize);
    return Unit_instance;
  };
}
function gl$delegate$lambda($this$PropertyThis) {
  _init_properties_AGOpengl_kt__dtzqx7();
  return new GLVAO($this$PropertyThis);
}
function gl$factory() {
  return getPropertyCallableRef('gl', 1, KMutableProperty1, function (receiver) {
    return get_gl(receiver);
  }, function (receiver, value) {
    return set_gl(receiver, value);
  });
}
function gl$factory_0() {
  return getPropertyCallableRef('gl', 1, KMutableProperty1, function (receiver) {
    return get_gl(receiver);
  }, function (receiver, value) {
    return set_gl(receiver, value);
  });
}
function glslConfig$factory() {
  return getPropertyCallableRef('glslConfig', 1, KProperty1, function (receiver) {
    return receiver.x7f();
  }, null);
}
var properties_initialized_AGOpengl_kt_5em8g9;
function _init_properties_AGOpengl_kt__dtzqx7() {
  if (!properties_initialized_AGOpengl_kt_5em8g9) {
    properties_initialized_AGOpengl_kt_5em8g9 = true;
    ENABLE_UNIFORM_BLOCKS = !(Companion_instance_1.oi('DISABLE_UNIFORM_BLOCKS') === 'true');
    ENABLE_VERTEX_ARRAY_OBJECTS = !(Companion_instance_1.oi('DISABLE_VERTEX_ARRAY_OBJECTS') === 'true');
    gl$delegate = new PropertyThis(VOID, gl$delegate$lambda);
  }
}
function fromGl(_this__u8e3s4, value) {
  var tmp;
  switch (value) {
    case 3553:
      tmp = Companion_getInstance_51().a70_1;
      break;
    case 32879:
      tmp = Companion_getInstance_51().b70_1;
      break;
    case 34067:
      tmp = Companion_getInstance_51().c70_1;
      break;
    case 36197:
      tmp = Companion_getInstance_51().d70_1;
      break;
    case 34069:
      tmp = Companion_getInstance_51().c70_1;
      break;
    case 34070:
      tmp = Companion_getInstance_51().c70_1;
      break;
    case 34071:
      tmp = Companion_getInstance_51().c70_1;
      break;
    case 34072:
      tmp = Companion_getInstance_51().c70_1;
      break;
    case 34073:
      tmp = Companion_getInstance_51().c70_1;
      break;
    case 34074:
      tmp = Companion_getInstance_51().c70_1;
      break;
    default:
      var reason = 'Unknown TextureTargetKind: ' + value;
      throw NotImplementedError.ee('An operation is not implemented: ' + reason);
  }
  return tmp;
}
function toGl(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_54().w74_1) {
    tmp = 32774;
  } else if (_this__u8e3s4 === Companion_getInstance_54().x74_1) {
    tmp = 32778;
  } else if (_this__u8e3s4 === Companion_getInstance_54().y74_1) {
    tmp = 32779;
  } else {
    get_unreachable();
  }
  return tmp;
}
function toGl_0(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_53().j74_1) {
    tmp = 772;
  } else if (_this__u8e3s4 === Companion_getInstance_53().k74_1) {
    tmp = 774;
  } else if (_this__u8e3s4 === Companion_getInstance_53().l74_1) {
    tmp = 1;
  } else if (_this__u8e3s4 === Companion_getInstance_53().m74_1) {
    tmp = 773;
  } else if (_this__u8e3s4 === Companion_getInstance_53().n74_1) {
    tmp = 775;
  } else if (_this__u8e3s4 === Companion_getInstance_53().o74_1) {
    tmp = 771;
  } else if (_this__u8e3s4 === Companion_getInstance_53().p74_1) {
    tmp = 769;
  } else if (_this__u8e3s4 === Companion_getInstance_53().q74_1) {
    tmp = 770;
  } else if (_this__u8e3s4 === Companion_getInstance_53().r74_1) {
    tmp = 768;
  } else if (_this__u8e3s4 === Companion_getInstance_53().s74_1) {
    tmp = 0;
  } else {
    get_unreachable();
  }
  return tmp;
}
function toGl_1(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_57().c76_1) {
    tmp = 519;
  } else if (_this__u8e3s4 === Companion_getInstance_57().d76_1) {
    tmp = 514;
  } else if (_this__u8e3s4 === Companion_getInstance_57().e76_1) {
    tmp = 516;
  } else if (_this__u8e3s4 === Companion_getInstance_57().f76_1) {
    tmp = 518;
  } else if (_this__u8e3s4 === Companion_getInstance_57().g76_1) {
    tmp = 513;
  } else if (_this__u8e3s4 === Companion_getInstance_57().h76_1) {
    tmp = 515;
  } else if (_this__u8e3s4 === Companion_getInstance_57().i76_1) {
    tmp = 512;
  } else if (_this__u8e3s4 === Companion_getInstance_57().j76_1) {
    tmp = 517;
  } else {
    get_unreachable();
  }
  return tmp;
}
function toGl_2(_this__u8e3s4) {
  return _this__u8e3s4 === Companion_getInstance_56().k76_1 ? 7683 : _this__u8e3s4 === Companion_getInstance_56().l76_1 ? 34056 : _this__u8e3s4 === Companion_getInstance_56().m76_1 ? 7682 : _this__u8e3s4 === Companion_getInstance_56().n76_1 ? 34055 : _this__u8e3s4 === Companion_getInstance_56().o76_1 ? 5386 : _this__u8e3s4 === Companion_getInstance_56().p76_1 ? 7680 : _this__u8e3s4 === Companion_getInstance_56().q76_1 ? 7681 : _this__u8e3s4 === Companion_getInstance_56().r76_1 ? 0 : 0;
}
function toGl_3(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_40().x73_1) {
    tmp = 0;
  } else if (_this__u8e3s4 === Companion_getInstance_40().y73_1) {
    tmp = 3;
  } else if (_this__u8e3s4 === Companion_getInstance_40().z73_1) {
    tmp = 2;
  } else if (_this__u8e3s4 === Companion_getInstance_40().a74_1) {
    tmp = 1;
  } else if (_this__u8e3s4 === Companion_getInstance_40().c74_1) {
    tmp = 5;
  } else if (_this__u8e3s4 === Companion_getInstance_40().d74_1) {
    tmp = 6;
  } else if (_this__u8e3s4 === Companion_getInstance_40().b74_1) {
    tmp = 4;
  } else {
    get_unreachable();
  }
  return tmp;
}
function toGl_4(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_41().v6u_1) {
    tmp = 0;
  } else if (_this__u8e3s4 === Companion_getInstance_41().w6u_1) {
    tmp = 5121;
  } else if (_this__u8e3s4 === Companion_getInstance_41().x6u_1) {
    tmp = 5123;
  } else if (_this__u8e3s4 === Companion_getInstance_41().y6u_1) {
    tmp = 5125;
  } else {
    get_unreachable();
  }
  return tmp;
}
function toGl_5(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_49().c6w_1) {
    tmp = 1032;
  } else if (_this__u8e3s4 === Companion_getInstance_49().a6w_1) {
    tmp = 1028;
  } else if (_this__u8e3s4 === Companion_getInstance_49().b6w_1) {
    tmp = 1029;
  } else {
    var reason = 'Invalid AGCullFace(' + AGCullFace__toString_impl_7d891w(_this__u8e3s4) + ')';
    throw NotImplementedError.ee('An operation is not implemented: ' + reason);
  }
  return tmp;
}
function toGl_6(_this__u8e3s4) {
  var tmp;
  switch (_this__u8e3s4.t3_1) {
    case 0:
      tmp = 34963;
      break;
    case 1:
      tmp = 34962;
      break;
    case 2:
      tmp = 35345;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function toGl_7(_this__u8e3s4) {
  var tmp;
  switch (_this__u8e3s4.r7i_1.t3_1) {
    case 0:
      tmp = 35670;
      break;
    case 1:
      tmp = 5120;
      break;
    case 2:
      tmp = 5121;
      break;
    case 3:
      tmp = 5122;
      break;
    case 4:
      tmp = 5123;
      break;
    case 5:
      tmp = 5125;
      break;
    case 6:
      tmp = 5126;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function toGl_8(_this__u8e3s4) {
  return _this__u8e3s4 === Companion_getInstance_51().a70_1 ? 3553 : _this__u8e3s4 === Companion_getInstance_51().b70_1 ? 32879 : _this__u8e3s4 === Companion_getInstance_51().c70_1 ? 34067 : _this__u8e3s4 === Companion_getInstance_51().d70_1 ? 36197 : _AGTextureTargetKind___get_ordinal__impl__gjzc5p(_this__u8e3s4);
}
function toGl_9(_this__u8e3s4) {
  return _this__u8e3s4 === Companion_getInstance_52().z70_1 ? 33071 : _this__u8e3s4 === Companion_getInstance_52().a71_1 ? 10497 : _this__u8e3s4 === Companion_getInstance_52().b71_1 ? 33648 : 33071;
}
function toGl_10(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 === Companion_getInstance_58().x76_1) {
    tmp = 2305;
  } else if (_this__u8e3s4 === Companion_getInstance_58().z76_1) {
    tmp = 2304;
  } else if (_this__u8e3s4 === Companion_getInstance_58().y76_1) {
    tmp = 2305;
  } else {
    get_unreachable();
  }
  return tmp;
}
function gl(_this__u8e3s4, state) {
  return createOnce(_this__u8e3s4, state, gl$lambda(state));
}
function gl_0(_this__u8e3s4, state) {
  return createOnce(_this__u8e3s4, state, gl$lambda_0(state, _this__u8e3s4));
}
function gl_1(_this__u8e3s4, state) {
  return createOnce(_this__u8e3s4, state, gl$lambda_1(state));
}
function createOnce(_this__u8e3s4, state, block) {
  if (_this__u8e3s4.o6x_1 == null || !(_this__u8e3s4.p6x_1 === state.p7h_1.t6t_1)) {
    _this__u8e3s4.p6x_1 = state.p7h_1.t6t_1;
    _this__u8e3s4.w6x();
    _this__u8e3s4.o6x_1 = block(_this__u8e3s4);
  }
  var tmp = _this__u8e3s4.o6x_1;
  return (!(tmp == null) ? isInterface(tmp, AGNativeObject) : false) ? tmp : THROW_CCE();
}
function gl$lambda($state) {
  return function (it) {
    return new GLBuffer($state);
  };
}
function gl$lambda_0($state, $this_gl) {
  return function (it) {
    return new GLFrameBuffer($state, $this_gl);
  };
}
function gl$lambda_1($state) {
  return function (it) {
    return new GLTexture($state);
  };
}
function get_versionString(_this__u8e3s4) {
  _init_properties_GLShaderCompiler_kt__3td561();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = versionString$delegate;
    var property = versionString$factory();
    var tmp0_elvis_lhs = this_0.v10_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.w10_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.v10_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var versionString$delegate;
function get_versionInt(_this__u8e3s4) {
  _init_properties_GLShaderCompiler_kt__3td561();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = versionInt$delegate;
    var property = versionInt$factory();
    var tmp0_elvis_lhs = this_0.v10_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.w10_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.v10_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var versionInt$delegate;
function createShader($this, gl, type, str, debugName) {
  var shaderId = gl.c7n(type);
  gl.d7n(shaderId, str);
  gl.e7n(shaderId);
  // Inline function 'korlibs.kgl.KmlGl.COMPILE_STATUS' call
  var out = getShaderiv(gl, shaderId, 35713);
  var errorInt = gl.f7n();
  // Inline function 'korlibs.kgl.KmlGl.GTRUE' call
  if (!(out === 1)) {
    var error = getShaderInfoLog(gl, shaderId);
    throw ShaderException.h7e(str, error, errorInt, gl, debugName, type, out);
  }
  return shaderId;
}
var GLShaderCompiler_instance;
function GLShaderCompiler_getInstance() {
  if (GLShaderCompiler_instance === VOID)
    new GLShaderCompiler();
  return GLShaderCompiler_instance;
}
function versionString$delegate$lambda($this$PropertyThis) {
  _init_properties_GLShaderCompiler_kt__3td561();
  var tmp;
  if (_GLVariant___get_isWebGL__impl__bbd1dd($this$PropertyThis.i7j())) {
    tmp = _GLVariant___get_version__impl__9nyfwa($this$PropertyThis.i7j()) === 1 ? '1.00' : '3.00';
  } else {
    // Inline function 'korlibs.kgl.KmlGl.SHADING_LANGUAGE_VERSION' call
    tmp = $this$PropertyThis.w7f(35724);
  }
  return tmp;
}
function versionInt$delegate$lambda($this$PropertyThis) {
  _init_properties_GLShaderCompiler_kt__3td561();
  var tmp0_safe_receiver = Regex.ci('(\\d+\\.\\d+)').fi(get_versionString($this$PropertyThis));
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.u1();
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : replace(tmp1_safe_receiver, '.', '');
  var tmp;
  if (tmp2_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.text.trim' call
    tmp = toString(trim(isCharSequence(tmp2_safe_receiver) ? tmp2_safe_receiver : THROW_CCE()));
  }
  var tmp3_safe_receiver = tmp;
  var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : toIntOrNull(tmp3_safe_receiver);
  return tmp4_elvis_lhs == null ? 100 : tmp4_elvis_lhs;
}
function versionString$factory() {
  return getPropertyCallableRef('versionString', 1, KProperty1, function (receiver) {
    return get_versionString(receiver);
  }, null);
}
function versionInt$factory() {
  return getPropertyCallableRef('versionInt', 1, KProperty1, function (receiver) {
    return get_versionInt(receiver);
  }, null);
}
var properties_initialized_GLShaderCompiler_kt_k11ei3;
function _init_properties_GLShaderCompiler_kt__3td561() {
  if (!properties_initialized_GLShaderCompiler_kt_k11ei3) {
    properties_initialized_GLShaderCompiler_kt_k11ei3 = true;
    versionString$delegate = new PropertyThis(VOID, versionString$delegate$lambda);
    versionInt$delegate = new PropertyThis(VOID, versionInt$delegate$lambda);
  }
}
var Kind_COMMAND_instance;
var Kind_DRAW_instance;
var Kind_DRAW_DETAILS_instance;
var Kind_CLEAR_instance;
var Kind_METRICS_instance;
var Kind_FLIP_instance;
var Kind_READ_instance;
var Kind_REPAINT_instance;
var Kind_DISPOSE_instance;
var Kind_TEXTURE_UPLOAD_instance;
var Kind_CLOSE_instance;
var Kind_FRAME_BUFFER_instance;
var Kind_BUFFER_instance;
var Kind_TEXTURE_instance;
var Kind_SHADER_instance;
var Kind_OTHER_instance;
var Kind_UNIFORM_instance;
var Kind_UNIFORM_VALUES_instance;
var Kind_SCISSORS_instance;
var Kind_VIEWPORT_instance;
var Kind_VERTEX_instance;
var Kind_ENABLE_DISABLE_instance;
var Kind_CONTEXT_LOST_instance;
var Kind_FLUSH_instance;
var Kind_entriesInitialized_0;
function Kind_initEntries_0() {
  if (Kind_entriesInitialized_0)
    return Unit_instance;
  Kind_entriesInitialized_0 = true;
  Kind_COMMAND_instance = new Kind_0('COMMAND', 0);
  Kind_DRAW_instance = new Kind_0('DRAW', 1);
  Kind_DRAW_DETAILS_instance = new Kind_0('DRAW_DETAILS', 2);
  Kind_CLEAR_instance = new Kind_0('CLEAR', 3);
  Kind_METRICS_instance = new Kind_0('METRICS', 4);
  Kind_FLIP_instance = new Kind_0('FLIP', 5);
  Kind_READ_instance = new Kind_0('READ', 6);
  Kind_REPAINT_instance = new Kind_0('REPAINT', 7);
  Kind_DISPOSE_instance = new Kind_0('DISPOSE', 8);
  Kind_TEXTURE_UPLOAD_instance = new Kind_0('TEXTURE_UPLOAD', 9);
  Kind_CLOSE_instance = new Kind_0('CLOSE', 10);
  Kind_FRAME_BUFFER_instance = new Kind_0('FRAME_BUFFER', 11);
  Kind_BUFFER_instance = new Kind_0('BUFFER', 12);
  Kind_TEXTURE_instance = new Kind_0('TEXTURE', 13);
  Kind_SHADER_instance = new Kind_0('SHADER', 14);
  Kind_OTHER_instance = new Kind_0('OTHER', 15);
  Kind_UNIFORM_instance = new Kind_0('UNIFORM', 16);
  Kind_UNIFORM_VALUES_instance = new Kind_0('UNIFORM_VALUES', 17);
  Kind_SCISSORS_instance = new Kind_0('SCISSORS', 18);
  Kind_VIEWPORT_instance = new Kind_0('VIEWPORT', 19);
  Kind_VERTEX_instance = new Kind_0('VERTEX', 20);
  Kind_ENABLE_DISABLE_instance = new Kind_0('ENABLE_DISABLE', 21);
  Kind_CONTEXT_LOST_instance = new Kind_0('CONTEXT_LOST', 22);
  Kind_FLUSH_instance = new Kind_0('FLUSH', 23);
}
function Kind_COMMAND_getInstance() {
  Kind_initEntries_0();
  return Kind_COMMAND_instance;
}
function Kind_FLIP_getInstance() {
  Kind_initEntries_0();
  return Kind_FLIP_instance;
}
var Companion_instance_53;
function Companion_getInstance_59() {
  if (Companion_instance_53 === VOID)
    new Companion_44();
  return Companion_instance_53;
}
function UniformBlock$Gen$uniform$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.also' call
    var tmp0_elvis_lhs = this$0.u78_1;
    var this_0 = TypedUniform.p7o(tmp0_elvis_lhs == null ? 'unknown' + this$0.t78_1.i79() : tmp0_elvis_lhs, this$0.v78_1, this$0.w78_1, this$0.t78_1, this$0.x78_1, this$0.y78_1);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.shader.Gen.uniform$delegate.<anonymous>.<anonymous>' call
    this$0.t78_1.c73_1.h(this_0);
    return this_0;
  };
}
var Companion_instance_54;
function Companion_getInstance_60() {
  return Companion_instance_54;
}
function _get_bufferSize__mp12kq($this) {
  return $this.l71_1.g15() / $this.j71_1 | 0;
}
function align($this, size) {
  var tmp = $this;
  // Inline function 'kotlin.math.max' call
  var a = $this.s7o_1;
  tmp.s7o_1 = Math.max(a, size);
  while (!(($this.r7o_1 % size | 0) === 0)) {
    $this.r7o_1 = $this.r7o_1 + 1 | 0;
  }
  return $this;
}
function UBLayoutBuilder$size$delegate$lambda(this$0) {
  return function () {
    align(this$0, this$0.s7o_1);
    return this$0.r7o_1;
  };
}
function uniform$factory() {
  return getPropertyCallableRef('uniform', 1, KProperty1, function (receiver) {
    return receiver.q7o();
  }, null);
}
function size$factory() {
  return getPropertyCallableRef('size', 1, KProperty1, function (receiver) {
    return receiver.e1();
  }, null);
}
function _GLVariant___init__impl__cjzpjb(data) {
  return data;
}
function _GLVariant___get_data__impl__nn46ye($this) {
  return $this;
}
function _GLVariant___get_isES__impl__yezzg8($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_GLVariant___get_data__impl__nn46ye($this) >>> 0 | 0) & 1) === 0);
}
function _GLVariant___get_isWebGL__impl__bbd1dd($this) {
  // Inline function 'korlibs.memory.extractBool' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_GLVariant___get_data__impl__nn46ye($this) >>> 1 | 0) & 1) === 0);
}
function _GLVariant___get_version__impl__9nyfwa($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_GLVariant___get_data__impl__nn46ye($this) >>> 8 | 0) & 255;
}
function _GLVariant___get_os__impl__aswhdw($this) {
  var tmp = Companion_getInstance_2().nw_1;
  // Inline function 'korlibs.memory.extract8' call
  var tmp$ret$0 = (_GLVariant___get_data__impl__nn46ye($this) >>> 16 | 0) & 255;
  var tmp0_elvis_lhs = getOrNull(tmp, tmp$ret$0);
  return tmp0_elvis_lhs == null ? Os_UNKNOWN_getInstance() : tmp0_elvis_lhs;
}
function _GLVariant___get_supportTextureLevel__impl__3yeu62($this) {
  return !_GLVariant___get_isWebGL__impl__bbd1dd($this) && !_GLVariant___get_isES__impl__yezzg8($this);
}
var Companion_instance_55;
function Companion_getInstance_61() {
  return Companion_instance_55;
}
function GLVariant__toString_impl_o5yi3l($this) {
  return 'GLVariant(data=' + $this + ')';
}
function GLVariant__hashCode_impl_2eslaq($this) {
  return $this;
}
function GLVariant__equals_impl_kmlw2($this, other) {
  if (!(other instanceof GLVariant))
    return false;
  if (!($this === (other instanceof GLVariant ? other.n7q_1 : THROW_CCE())))
    return false;
  return true;
}
function toNewGlslString(_this__u8e3s4, config) {
  return toNewGlslStringResult(_this__u8e3s4, config).r7q_1;
}
function toNewGlslStringResult(_this__u8e3s4, config) {
  return (new GlslGenerator(_this__u8e3s4.v7q_1, config)).j7r(_this__u8e3s4);
}
var Companion_instance_56;
function Companion_getInstance_62() {
  if (Companion_instance_56 === VOID)
    new Companion_47();
  return Companion_instance_56;
}
function GlslGenerator$generateResult$lambda$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>.<anonymous>' call
  var tmp = a.u7g_1;
  // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>.<anonymous>' call
  var tmp$ret$1 = b.u7g_1;
  return compareValues(tmp, tmp$ret$1);
}
function GlslGenerator$generateResult$lambda(this$0, $types, $allFuncs) {
  return function ($this$Indenter) {
    var tmp;
    if (!this$0.i7r_1.g7h_1) {
      var suffix = _GLVariant___get_isES__impl__yezzg8(this$0.i7r_1.d7h_1) ? ' es' : '';
      $this$Indenter.y3c('#version ' + this$0.i7r_1.f7h_1 + suffix);
      tmp = Unit_instance;
    }
    var tmp_0;
    if (this$0.h7r_1.equals(ShaderType_FRAGMENT_getInstance())) {
      $this$Indenter.y3c('#extension GL_OES_standard_derivatives : enable');
      tmp_0 = Unit_instance;
    }
    $this$Indenter.y3c('#ifdef GL_ES');
    $this$Indenter.y3c('precision mediump float;');
    $this$Indenter.y3c('#endif');
    var _iterator__ex2g4s = $types.l7r_1.a1();
    while (_iterator__ex2g4s.b1()) {
      var it = _iterator__ex2g4s.c1();
      var layout = this$0.i7r_1.q7t() && this$0.i7r_1.f7h_1 >= 410 ? 'layout(location = ' + it.h7a_1 + ') ' : '';
      $this$Indenter.y3c(layout + this$0.r7t() + ' ' + this$0.s7t(it.v7g_1) + this$0.t7t(it.i2h()) + ' ' + it.u7g_1 + this$0.u7t(it) + ';');
    }
    var _iterator__ex2g4s_0 = $types.q7r_1.a1();
    while (_iterator__ex2g4s_0.b1()) {
      var it_0 = _iterator__ex2g4s_0.c1();
      var layout_0 = this$0.i7r_1.q7t() ? '' : '';
      $this$Indenter.y3c(layout_0 + this$0.v7t() + ' ' + this$0.s7t(it_0.v7g_1) + this$0.t7t(it_0.i2h()) + ' ' + it_0.u7g_1 + this$0.u7t(it_0) + ';');
    }
    var tmp_1;
    if (this$0.i7r_1.h7h()) {
      var _iterator__ex2g4s_1 = $types.p7r_1.a1();
      while (_iterator__ex2g4s_1.b1()) {
        var block = _iterator__ex2g4s_1.c1();
        $this$Indenter.y3c('layout(std140) uniform ' + block.u3() + ' {');
        var _iterator__ex2g4s_2 = block.f79().a1();
        while (_iterator__ex2g4s_2.b1()) {
          var uniform = _iterator__ex2g4s_2.c1();
          $this$Indenter.y3c('  ' + this$0.s7t(uniform.v7g_1) + this$0.t7t(uniform.i2h()) + ' ' + uniform.u7g_1 + this$0.u7t(uniform) + ';');
        }
        $this$Indenter.y3c('};');
      }
      tmp_1 = Unit_instance;
    } else {
      var _iterator__ex2g4s_3 = $types.n7r_1.a1();
      while (_iterator__ex2g4s_3.b1()) {
        var it_1 = _iterator__ex2g4s_3.c1();
        $this$Indenter.y3c(this$0.v7t() + ' ' + this$0.s7t(it_1.v7g_1) + this$0.t7t(it_1.i2h()) + ' ' + it_1.u7g_1 + this$0.u7t(it_1) + ';');
      }
      tmp_1 = Unit_instance;
    }
    // Inline function 'kotlin.collections.sortedBy' call
    var this_0 = $types.m7r_1;
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp_2 = GlslGenerator$generateResult$lambda$lambda;
    var tmp$ret$0 = new sam$kotlin_Comparator$0(tmp_2);
    var iterator = sortedWith(this_0, tmp$ret$0).a1();
    var index = 0;
    $l$loop: while (iterator.b1()) {
      var index_0 = index;
      index = index + 1 | 0;
      var it_2 = iterator.c1();
      if (it_2 instanceof Output)
        continue $l$loop;
      var INOUT = !this$0.i7r_1.q7t() ? this$0.w7t() : it_2.u7g_1 === this$0.i7r_1.x7t() && this$0.h7r_1.equals(ShaderType_FRAGMENT_getInstance()) ? this$0.w7t() : this$0.h7r_1.equals(ShaderType_VERTEX_getInstance()) ? this$0.w7t() : this$0.r7t();
      $this$Indenter.y3c(INOUT + ' ' + this$0.s7t(it_2.v7g_1) + this$0.t7t(it_2.i2h()) + ' ' + it_2.u7g_1 + ';');
    }
    var _iterator__ex2g4s_4 = $allFuncs.a1();
    while (_iterator__ex2g4s_4.b1()) {
      var func = _iterator__ex2g4s_4.c1();
      var gen = new GlslBodyGenerator(this$0.h7r_1, this$0.i7r_1);
      gen.j7s(func);
      // Inline function 'kotlin.collections.map' call
      var this_1 = func.a7u_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(collectionSizeOrDefault(this_1, 10));
      var tmp0_iterator = this_1.a1();
      while (tmp0_iterator.b1()) {
        var item = tmp0_iterator.c1();
        // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>.<anonymous>' call
        var tmp$ret$2 = this$0.t7t(item.tl_1) + ' ' + item.sl_1;
        destination.h(tmp$ret$2);
      }
      var argsStrings = destination;
      // Inline function 'korlibs.io.util.Indenter.line' call
      var str = this$0.t7t(func.z7t_1) + ' ' + func.y7t_1 + '(' + joinToString(argsStrings, ', ') + ')';
      var tmp_3;
      // Inline function 'kotlin.text.isEmpty' call
      if (charSequenceLength(str) === 0) {
        tmp_3 = '{';
      } else {
        tmp_3 = str + ' {';
      }
      $this$Indenter.y3c(tmp_3);
      // Inline function 'korlibs.io.util.Indenter.indent' call
      $this$Indenter.z3c();
      try {
        // Inline function 'korlibs.graphics.shader.gl.GlslGenerator.generateResult.<anonymous>.<anonymous>' call
        var _iterator__ex2g4s_5 = gen.g7u_1.a1();
        while (_iterator__ex2g4s_5.b1()) {
          var temp = _iterator__ex2g4s_5.c1();
          $this$Indenter.y3c(this$0.s7t(temp.v7g_1) + this$0.t7t(temp.i2h()) + ' ' + temp.u7g_1 + ';');
        }
        $this$Indenter.x3c(gen.h7u_1);
      }finally {
        $this$Indenter.a3d();
      }
      $this$Indenter.y3c('}');
    }
    return Unit_instance;
  };
}
var Companion_instance_57;
function Companion_getInstance_63() {
  if (Companion_instance_57 === VOID)
    new Companion_48();
  return Companion_instance_57;
}
function errorType($this, type) {
  invalidOp("Don't know how to serialize type " + type.toString());
}
function GlslBodyGenerator$visit$lambda(this$0) {
  return function (it) {
    return this$0.u7s(it);
  };
}
function GlslBodyGenerator$visit$lambda_0(this$0) {
  return function (it) {
    return this$0.u7s(it);
  };
}
function ProgramLayout$names$lambda(it) {
  return it.u7g_1;
}
var Discard_instance;
function Discard_getInstance() {
  if (Discard_instance === VOID)
    new Discard();
  return Discard_instance;
}
var Companion_instance_58;
function Companion_getInstance_64() {
  if (Companion_instance_58 === VOID)
    new Companion_49();
  return Companion_instance_58;
}
function Program$Builder$FuncProvider$provideDelegate$lambda(this$0) {
  return function ($this$FUNC) {
    // Inline function 'kotlin.collections.mapIndexed' call
    var this_0 = this$0.m7w_1;
    // Inline function 'kotlin.collections.mapIndexedTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var index = 0;
    var tmp0_iterator = this_0.a1();
    while (tmp0_iterator.b1()) {
      var item = tmp0_iterator.c1();
      // Inline function 'korlibs.graphics.shader.FuncProvider.provideDelegate.<anonymous>.<anonymous>' call
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      var index_0 = checkIndexOverflow(tmp1);
      var tmp$ret$0 = $this$FUNC.s7w('p' + index_0, item);
      destination.h(tmp$ret$0);
    }
    var args = destination;
    this$0.o7w_1($this$FUNC, args);
    return Unit_instance;
  };
}
function Program$Builder$FUNC$lambda($block) {
  return function ($this$FuncProvider, it) {
    $block($this$FuncProvider, it.d1(0));
    return Unit_instance;
  };
}
function Program$Builder$FUNC$lambda_0($block) {
  return function ($this$FuncProvider, it) {
    $block($this$FuncProvider, it.d1(0), it.d1(1));
    return Unit_instance;
  };
}
function Program$Builder$FUNC$lambda_1($block) {
  return function ($this$FuncProvider, it) {
    $block($this$FuncProvider, it.d1(0), it.d1(1), it.d1(2));
    return Unit_instance;
  };
}
function Program$Builder$IF_ELSE_BINARY_LOOKUP$lambda($block, $max) {
  return function ($this$ELSE) {
    $block($this$ELSE, $max);
    return Unit_instance;
  };
}
function Program$Builder$IF_ELSE_BINARY_LOOKUP$lambda_0($ref, $middle, $max, $block) {
  return function ($this$ELSE) {
    $this$ELSE.u7c($ref, $middle + 1 | 0, $max, $block);
    return Unit_instance;
  };
}
function Program$Builder$IF_ELSE_LIST$lambda($ref, $min, $max, $block) {
  return function ($this$ELSE) {
    $this$ELSE.v7c($ref, $min + 1 | 0, $max, $block);
    return Unit_instance;
  };
}
var Output_instance;
function Output_getInstance() {
  if (Output_instance === VOID)
    Output.j7z();
  return Output_instance;
}
function Sampler_0(index, stype) {
  return new Provider(index, stype);
}
var SamplerVarType_Sampler1D_instance;
var SamplerVarType_Sampler2D_instance;
var SamplerVarType_Sampler3D_instance;
var SamplerVarType_SamplerCube_instance;
var SamplerVarType_entriesInitialized;
function SamplerVarType_initEntries() {
  if (SamplerVarType_entriesInitialized)
    return Unit_instance;
  SamplerVarType_entriesInitialized = true;
  SamplerVarType_Sampler1D_instance = new SamplerVarType('Sampler1D', 0, VarType_Sampler1D_getInstance());
  SamplerVarType_Sampler2D_instance = new SamplerVarType('Sampler2D', 1, VarType_Sampler2D_getInstance());
  SamplerVarType_Sampler3D_instance = new SamplerVarType('Sampler3D', 2, VarType_Sampler3D_getInstance());
  SamplerVarType_SamplerCube_instance = new SamplerVarType('SamplerCube', 3, VarType_SamplerCube_getInstance());
}
var VarType_TVOID_instance;
var VarType_Mat2_instance;
var VarType_Mat3_instance;
var VarType_Mat4_instance;
var VarType_Sampler1D_instance;
var VarType_Sampler2D_instance;
var VarType_Sampler3D_instance;
var VarType_SamplerCube_instance;
var VarType_Int1_instance;
var VarType_Float1_instance;
var VarType_Float2_instance;
var VarType_Float3_instance;
var VarType_Float4_instance;
var VarType_Short1_instance;
var VarType_Short2_instance;
var VarType_Short3_instance;
var VarType_Short4_instance;
var VarType_Bool1_instance;
var VarType_Bool2_instance;
var VarType_Bool3_instance;
var VarType_Bool4_instance;
var VarType_Byte4_instance;
var VarType_SByte1_instance;
var VarType_SByte2_instance;
var VarType_SByte3_instance;
var VarType_SByte4_instance;
var VarType_UByte1_instance;
var VarType_UByte2_instance;
var VarType_UByte3_instance;
var VarType_UByte4_instance;
var VarType_SShort1_instance;
var VarType_SShort2_instance;
var VarType_SShort3_instance;
var VarType_SShort4_instance;
var VarType_UShort1_instance;
var VarType_UShort2_instance;
var VarType_UShort3_instance;
var VarType_UShort4_instance;
var VarType_SInt1_instance;
var VarType_SInt2_instance;
var VarType_SInt3_instance;
var VarType_SInt4_instance;
var Companion_instance_59;
function Companion_getInstance_65() {
  return Companion_instance_59;
}
var VarType_entriesInitialized;
function VarType_initEntries() {
  if (VarType_entriesInitialized)
    return Unit_instance;
  VarType_entriesInitialized = true;
  VarType_TVOID_instance = new VarType('TVOID', 0, VarKind_TBYTE_getInstance(), 0);
  VarType_Mat2_instance = new VarType('Mat2', 1, VarKind_TFLOAT_getInstance(), 4, true);
  VarType_Mat3_instance = new VarType('Mat3', 2, VarKind_TFLOAT_getInstance(), 9, true);
  VarType_Mat4_instance = new VarType('Mat4', 3, VarKind_TFLOAT_getInstance(), 16, true);
  VarType_Sampler1D_instance = new VarType('Sampler1D', 4, VarKind_TINT_getInstance(), 1);
  VarType_Sampler2D_instance = new VarType('Sampler2D', 5, VarKind_TINT_getInstance(), 1);
  VarType_Sampler3D_instance = new VarType('Sampler3D', 6, VarKind_TINT_getInstance(), 1);
  VarType_SamplerCube_instance = new VarType('SamplerCube', 7, VarKind_TINT_getInstance(), 1);
  VarType_Int1_instance = new VarType('Int1', 8, VarKind_TINT_getInstance(), 1);
  VarType_Float1_instance = new VarType('Float1', 9, VarKind_TFLOAT_getInstance(), 1);
  VarType_Float2_instance = new VarType('Float2', 10, VarKind_TFLOAT_getInstance(), 2);
  VarType_Float3_instance = new VarType('Float3', 11, VarKind_TFLOAT_getInstance(), 3);
  VarType_Float4_instance = new VarType('Float4', 12, VarKind_TFLOAT_getInstance(), 4);
  VarType_Short1_instance = new VarType('Short1', 13, VarKind_TSHORT_getInstance(), 1);
  VarType_Short2_instance = new VarType('Short2', 14, VarKind_TSHORT_getInstance(), 2);
  VarType_Short3_instance = new VarType('Short3', 15, VarKind_TSHORT_getInstance(), 3);
  VarType_Short4_instance = new VarType('Short4', 16, VarKind_TSHORT_getInstance(), 4);
  VarType_Bool1_instance = new VarType('Bool1', 17, VarKind_TBOOL_getInstance(), 1);
  VarType_Bool2_instance = new VarType('Bool2', 18, VarKind_TBOOL_getInstance(), 2);
  VarType_Bool3_instance = new VarType('Bool3', 19, VarKind_TBOOL_getInstance(), 3);
  VarType_Bool4_instance = new VarType('Bool4', 20, VarKind_TBOOL_getInstance(), 4);
  VarType_Byte4_instance = new VarType('Byte4', 21, VarKind_TUNSIGNED_BYTE_getInstance(), 4);
  VarType_SByte1_instance = new VarType('SByte1', 22, VarKind_TBYTE_getInstance(), 1);
  VarType_SByte2_instance = new VarType('SByte2', 23, VarKind_TBYTE_getInstance(), 2);
  VarType_SByte3_instance = new VarType('SByte3', 24, VarKind_TBYTE_getInstance(), 3);
  VarType_SByte4_instance = new VarType('SByte4', 25, VarKind_TBYTE_getInstance(), 4);
  VarType_UByte1_instance = new VarType('UByte1', 26, VarKind_TUNSIGNED_BYTE_getInstance(), 1);
  VarType_UByte2_instance = new VarType('UByte2', 27, VarKind_TUNSIGNED_BYTE_getInstance(), 2);
  VarType_UByte3_instance = new VarType('UByte3', 28, VarKind_TUNSIGNED_BYTE_getInstance(), 3);
  VarType_UByte4_instance = new VarType('UByte4', 29, VarKind_TUNSIGNED_BYTE_getInstance(), 4);
  VarType_SShort1_instance = new VarType('SShort1', 30, VarKind_TSHORT_getInstance(), 1);
  VarType_SShort2_instance = new VarType('SShort2', 31, VarKind_TSHORT_getInstance(), 2);
  VarType_SShort3_instance = new VarType('SShort3', 32, VarKind_TSHORT_getInstance(), 3);
  VarType_SShort4_instance = new VarType('SShort4', 33, VarKind_TSHORT_getInstance(), 4);
  VarType_UShort1_instance = new VarType('UShort1', 34, VarKind_TUNSIGNED_SHORT_getInstance(), 1);
  VarType_UShort2_instance = new VarType('UShort2', 35, VarKind_TUNSIGNED_SHORT_getInstance(), 2);
  VarType_UShort3_instance = new VarType('UShort3', 36, VarKind_TUNSIGNED_SHORT_getInstance(), 3);
  VarType_UShort4_instance = new VarType('UShort4', 37, VarKind_TUNSIGNED_SHORT_getInstance(), 4);
  VarType_SInt1_instance = new VarType('SInt1', 38, VarKind_TINT_getInstance(), 1);
  VarType_SInt2_instance = new VarType('SInt2', 39, VarKind_TINT_getInstance(), 2);
  VarType_SInt3_instance = new VarType('SInt3', 40, VarKind_TINT_getInstance(), 3);
  VarType_SInt4_instance = new VarType('SInt4', 41, VarKind_TINT_getInstance(), 4);
}
var Precision_DEFAULT_instance;
var Precision_LOW_instance;
var Precision_MEDIUM_instance;
var Precision_HIGH_instance;
var Precision_entriesInitialized;
function Precision_initEntries() {
  if (Precision_entriesInitialized)
    return Unit_instance;
  Precision_entriesInitialized = true;
  Precision_DEFAULT_instance = new Precision('DEFAULT', 0);
  Precision_LOW_instance = new Precision('LOW', 1);
  Precision_MEDIUM_instance = new Precision('MEDIUM', 2);
  Precision_HIGH_instance = new Precision('HIGH', 3);
}
function FragmentShader(info) {
  return FragmentShader_0(info.sl_1, info.tl_1);
}
var VarKind_TBOOL_instance;
var VarKind_TBYTE_instance;
var VarKind_TUNSIGNED_BYTE_instance;
var VarKind_TSHORT_instance;
var VarKind_TUNSIGNED_SHORT_instance;
var VarKind_TINT_instance;
var VarKind_TFLOAT_instance;
var VarKind_entriesInitialized;
function VarKind_initEntries() {
  if (VarKind_entriesInitialized)
    return Unit_instance;
  VarKind_entriesInitialized = true;
  VarKind_TBOOL_instance = new VarKind('TBOOL', 0, 1);
  VarKind_TBYTE_instance = new VarKind('TBYTE', 1, 1);
  VarKind_TUNSIGNED_BYTE_instance = new VarKind('TUNSIGNED_BYTE', 2, 1);
  VarKind_TSHORT_instance = new VarKind('TSHORT', 3, 2);
  VarKind_TUNSIGNED_SHORT_instance = new VarKind('TUNSIGNED_SHORT', 4, 2);
  VarKind_TINT_instance = new VarKind('TINT', 5, 4);
  VarKind_TFLOAT_instance = new VarKind('TFLOAT', 6, 4);
}
var ShaderType_VERTEX_instance;
var ShaderType_FRAGMENT_instance;
var ShaderType_entriesInitialized;
function ShaderType_initEntries() {
  if (ShaderType_entriesInitialized)
    return Unit_instance;
  ShaderType_entriesInitialized = true;
  ShaderType_VERTEX_instance = new ShaderType('VERTEX', 0);
  ShaderType_FRAGMENT_instance = new ShaderType('FRAGMENT', 1);
}
function VertexShader(info) {
  return VertexShader_0(info.sl_1, info.tl_1);
}
function FragmentShader_0(stm, funcs) {
  var tmp;
  if (funcs === VOID) {
    // Inline function 'kotlin.collections.listOf' call
    tmp = emptyList();
  } else {
    tmp = funcs;
  }
  funcs = tmp;
  return new Shader(ShaderType_FRAGMENT_getInstance(), stm, funcs);
}
function VertexShader_0(stm, funcs) {
  var tmp;
  if (funcs === VOID) {
    // Inline function 'kotlin.collections.listOf' call
    tmp = emptyList();
  } else {
    tmp = funcs;
  }
  funcs = tmp;
  return new Shader(ShaderType_VERTEX_getInstance(), stm, funcs);
}
function SamplerVarType_Sampler2D_getInstance() {
  SamplerVarType_initEntries();
  return SamplerVarType_Sampler2D_instance;
}
function VarType_TVOID_getInstance() {
  VarType_initEntries();
  return VarType_TVOID_instance;
}
function VarType_Mat2_getInstance() {
  VarType_initEntries();
  return VarType_Mat2_instance;
}
function VarType_Mat4_getInstance() {
  VarType_initEntries();
  return VarType_Mat4_instance;
}
function VarType_Sampler1D_getInstance() {
  VarType_initEntries();
  return VarType_Sampler1D_instance;
}
function VarType_Sampler2D_getInstance() {
  VarType_initEntries();
  return VarType_Sampler2D_instance;
}
function VarType_Sampler3D_getInstance() {
  VarType_initEntries();
  return VarType_Sampler3D_instance;
}
function VarType_SamplerCube_getInstance() {
  VarType_initEntries();
  return VarType_SamplerCube_instance;
}
function VarType_Float1_getInstance() {
  VarType_initEntries();
  return VarType_Float1_instance;
}
function VarType_Float2_getInstance() {
  VarType_initEntries();
  return VarType_Float2_instance;
}
function VarType_Float3_getInstance() {
  VarType_initEntries();
  return VarType_Float3_instance;
}
function VarType_Float4_getInstance() {
  VarType_initEntries();
  return VarType_Float4_instance;
}
function VarType_SByte1_getInstance() {
  VarType_initEntries();
  return VarType_SByte1_instance;
}
function VarType_SByte2_getInstance() {
  VarType_initEntries();
  return VarType_SByte2_instance;
}
function VarType_SByte3_getInstance() {
  VarType_initEntries();
  return VarType_SByte3_instance;
}
function VarType_SByte4_getInstance() {
  VarType_initEntries();
  return VarType_SByte4_instance;
}
function VarType_UByte1_getInstance() {
  VarType_initEntries();
  return VarType_UByte1_instance;
}
function VarType_UByte2_getInstance() {
  VarType_initEntries();
  return VarType_UByte2_instance;
}
function VarType_UByte3_getInstance() {
  VarType_initEntries();
  return VarType_UByte3_instance;
}
function VarType_UByte4_getInstance() {
  VarType_initEntries();
  return VarType_UByte4_instance;
}
function VarType_SShort1_getInstance() {
  VarType_initEntries();
  return VarType_SShort1_instance;
}
function VarType_SShort2_getInstance() {
  VarType_initEntries();
  return VarType_SShort2_instance;
}
function VarType_SShort3_getInstance() {
  VarType_initEntries();
  return VarType_SShort3_instance;
}
function VarType_SShort4_getInstance() {
  VarType_initEntries();
  return VarType_SShort4_instance;
}
function VarType_UShort1_getInstance() {
  VarType_initEntries();
  return VarType_UShort1_instance;
}
function VarType_UShort2_getInstance() {
  VarType_initEntries();
  return VarType_UShort2_instance;
}
function VarType_UShort3_getInstance() {
  VarType_initEntries();
  return VarType_UShort3_instance;
}
function VarType_UShort4_getInstance() {
  VarType_initEntries();
  return VarType_UShort4_instance;
}
function VarType_SInt1_getInstance() {
  VarType_initEntries();
  return VarType_SInt1_instance;
}
function VarType_SInt2_getInstance() {
  VarType_initEntries();
  return VarType_SInt2_instance;
}
function VarType_SInt3_getInstance() {
  VarType_initEntries();
  return VarType_SInt3_instance;
}
function VarType_SInt4_getInstance() {
  VarType_initEntries();
  return VarType_SInt4_instance;
}
function Precision_DEFAULT_getInstance() {
  Precision_initEntries();
  return Precision_DEFAULT_instance;
}
function Precision_LOW_getInstance() {
  Precision_initEntries();
  return Precision_LOW_instance;
}
function Precision_MEDIUM_getInstance() {
  Precision_initEntries();
  return Precision_MEDIUM_instance;
}
function Precision_HIGH_getInstance() {
  Precision_initEntries();
  return Precision_HIGH_instance;
}
function VarKind_TBOOL_getInstance() {
  VarKind_initEntries();
  return VarKind_TBOOL_instance;
}
function VarKind_TBYTE_getInstance() {
  VarKind_initEntries();
  return VarKind_TBYTE_instance;
}
function VarKind_TUNSIGNED_BYTE_getInstance() {
  VarKind_initEntries();
  return VarKind_TUNSIGNED_BYTE_instance;
}
function VarKind_TSHORT_getInstance() {
  VarKind_initEntries();
  return VarKind_TSHORT_instance;
}
function VarKind_TUNSIGNED_SHORT_getInstance() {
  VarKind_initEntries();
  return VarKind_TUNSIGNED_SHORT_instance;
}
function VarKind_TINT_getInstance() {
  VarKind_initEntries();
  return VarKind_TINT_instance;
}
function VarKind_TFLOAT_getInstance() {
  VarKind_initEntries();
  return VarKind_TFLOAT_instance;
}
function ShaderType_VERTEX_getInstance() {
  ShaderType_initEntries();
  return ShaderType_VERTEX_instance;
}
function ShaderType_FRAGMENT_getInstance() {
  ShaderType_initEntries();
  return ShaderType_FRAGMENT_instance;
}
function toDisposable(_this__u8e3s4) {
  var tmp = toDisposable$lambda(_this__u8e3s4);
  return new sam$kotlinx_coroutines_DisposableHandle$0(tmp);
}
function toDisposable$lambda($this_toDisposable) {
  return function () {
    $this_toDisposable.t6();
    return Unit_instance;
  };
}
function putAsciiString(_this__u8e3s4, str) {
  var n = 0;
  var inductionVariable = 0;
  var last = str.length;
  while (inductionVariable < last) {
    var c = charSequenceGet(str, inductionVariable);
    inductionVariable = inductionVariable + 1 | 0;
    if (get_size_0(_this__u8e3s4) >= n) {
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      // Inline function 'kotlin.code' call
      var tmp$ret$0 = Char__toInt_impl_vasixd(c);
      _this__u8e3s4.r15(_unary__edvuaz, toByte(tmp$ret$0));
    }
  }
  if (get_size_0(_this__u8e3s4) >= n) {
    var _unary__edvuaz_0 = n;
    n = _unary__edvuaz_0 + 1 | 0;
    _this__u8e3s4.r15(_unary__edvuaz_0, 0);
  }
  return _this__u8e3s4;
}
function toAsciiString(_this__u8e3s4) {
  var out = '';
  var inductionVariable = 0;
  var last = get_size_0(_this__u8e3s4);
  if (inductionVariable < last)
    $l$loop: do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var b = _this__u8e3s4.p15(n);
      if (b === 0)
        break $l$loop;
      out = out + toString_0(numberToChar(b));
    }
     while (inductionVariable < last);
  return out;
}
function KmlGl$ContextInfo$current$lambda() {
  return null;
}
var Companion_instance_60;
function Companion_getInstance_66() {
  return Companion_instance_60;
}
function KmlGl$isFloatTextureSupported$delegate$lambda(this$0) {
  return function () {
    return this$0.j61().z2('GL_OES_texture_float') || this$0.j61().z2('GL_ARB_texture_float');
  };
}
var logger;
var tempNBufferByte;
function get_tempNBuffer1() {
  _init_properties_KmlGlExt_kt__r5nfv2();
  return tempNBuffer1;
}
var tempNBuffer1;
var tempNBuffer4;
function getIntegerv(_this__u8e3s4, pname) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.getIntegerv.<anonymous>' call
  _this__u8e3s4.s8c(pname, it);
  return getInt32(it, 0);
}
function getInteger(_this__u8e3s4, pname) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  return getIntegerv(_this__u8e3s4, pname);
}
function genVertexArray(_this__u8e3s4) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.genVertexArray.<anonymous>' call
  _this__u8e3s4.w8c(1, it);
  return getInt32(it, 0);
}
function getProgramiv(_this__u8e3s4, program, type) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.getProgramiv.<anonymous>' call
  _this__u8e3s4.t8c(program, type, it);
  return getInt32(it, 0);
}
function getShaderiv(_this__u8e3s4, shader, type) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.getShaderiv.<anonymous>' call
  _this__u8e3s4.u8c(shader, type, it);
  return getInt32(it, 0);
}
function getShaderInfoLog(_this__u8e3s4, shader) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.getInfoLog' call
  // Inline function 'korlibs.kgl.KmlGl.INFO_LOG_LENGTH' call
  var size = getShaderiv(_this__u8e3s4, shader, 35716);
  // Inline function 'korlibs.memory.BufferTemp' call
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.getInfoLog.<anonymous>' call
  var sizev = allocDirect(Companion_instance_4, 4);
  // Inline function 'korlibs.memory.BufferTemp' call
  // Inline function 'kotlin.run' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.getInfoLog.<anonymous>.<anonymous>' call
  var mbuffer = allocDirect(Companion_instance_4, size);
  _this__u8e3s4.v8c(shader, size, sizev, mbuffer);
  return toAsciiString(mbuffer);
}
function genBuffer(_this__u8e3s4) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.genBuffer.<anonymous>' call
  _this__u8e3s4.o8c(1, it);
  return getInt32(it, 0);
}
function deleteBuffer(_this__u8e3s4, id) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, id);
  // Inline function 'korlibs.kgl.deleteBuffer.<anonymous>' call
  _this__u8e3s4.k8c(1, it);
  getInt32(it, 0);
}
function genTexture(_this__u8e3s4) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.genTexture.<anonymous>' call
  _this__u8e3s4.r8c(1, it);
  return getInt32(it, 0);
}
function deleteTexture(_this__u8e3s4, id) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, id);
  // Inline function 'korlibs.kgl.deleteTexture.<anonymous>' call
  _this__u8e3s4.n8c(1, it);
  getInt32(it, 0);
}
function genRenderbuffer(_this__u8e3s4) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.genRenderbuffer.<anonymous>' call
  _this__u8e3s4.q8c(1, it);
  return getInt32(it, 0);
}
function genFramebuffer(_this__u8e3s4) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, 0);
  // Inline function 'korlibs.kgl.genFramebuffer.<anonymous>' call
  _this__u8e3s4.p8c(1, it);
  return getInt32(it, 0);
}
function deleteRenderbuffer(_this__u8e3s4, id) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, id);
  // Inline function 'korlibs.kgl.deleteRenderbuffer.<anonymous>' call
  _this__u8e3s4.m8c(1, it);
  getInt32(it, 0);
}
function deleteFramebuffer(_this__u8e3s4, id) {
  _init_properties_KmlGlExt_kt__r5nfv2();
  // Inline function 'korlibs.kgl.tempInt1Buffer' call
  // Inline function 'kotlin.let' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.kgl.tempInt1Buffer.<anonymous>' call
  var it = _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo();
  setInt32(it, 0, id);
  // Inline function 'korlibs.kgl.deleteFramebuffer.<anonymous>' call
  _this__u8e3s4.l8c(1, it);
  getInt32(it, 0);
}
function _get_tempNBuffer1_$accessor$c1x7qs_ecvwzo() {
  _init_properties_KmlGlExt_kt__r5nfv2();
  return get_tempNBuffer1();
}
var properties_initialized_KmlGlExt_kt_yrhd4c;
function _init_properties_KmlGlExt_kt__r5nfv2() {
  if (!properties_initialized_KmlGlExt_kt_yrhd4c) {
    properties_initialized_KmlGlExt_kt_yrhd4c = true;
    logger = Companion_getInstance_1().iz('KmlGlException');
    tempNBufferByte = Buffer.b15(1, true);
    tempNBuffer1 = Buffer.b15(4, true);
    tempNBuffer4 = Buffer.b15(16, true);
  }
}
var KorgeReload_instance;
function KorgeReload_getInstance() {
  if (KorgeReload_instance === VOID)
    new KorgeReload();
  return KorgeReload_instance;
}
var Companion_instance_61;
function Companion_getInstance_67() {
  return Companion_instance_61;
}
function drawText(_this__u8e3s4, font, textSize, str, x, y, m, colMul, blendMode, filtering) {
  m = m === VOID ? Companion_getInstance_7().s2g_1 : m;
  colMul = colMul === VOID ? Colors_getInstance().y44_1 : colMul;
  blendMode = blendMode === VOID ? Companion_getInstance_68().i8d_1 : blendMode;
  filtering = filtering === VOID ? true : filtering;
  drawText_0(font, _this__u8e3s4, textSize, str, x, y, m, colMul, blendMode, filtering);
}
function drawText_0(_this__u8e3s4, ctx, textSize, str, x, y, m, colMul, blendMode, filtering) {
  m = m === VOID ? Companion_getInstance_7().s2g_1 : m;
  colMul = colMul === VOID ? Colors_getInstance().y44_1 : colMul;
  blendMode = blendMode === VOID ? Companion_getInstance_68().i8d_1 : blendMode;
  filtering = filtering === VOID ? true : filtering;
  var scale = textSize / _this__u8e3s4.p4n();
  var m2 = m.c2i(x, y).u2h(scale, scale);
  var dx = 0.0;
  var dy = 0.0;
  // Inline function 'korlibs.korge.render.RenderContext.useBatcher' call
  // Inline function 'korlibs.korge.render.BatchBuilder2D.use' call
  var this_0 = ctx.a8f_1;
  var this_1 = this_0.j8f_1;
  if (!(this_1.e8f_1 === this_0)) {
    this_1.e8f_1 = this_0;
    this_1.o8g();
  }
  var inductionVariable = 0;
  var last = charSequenceLength(str) - 1 | 0;
  var tmp;
  if (inductionVariable <= last) {
    $l$loop: do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var c1 = Char__toInt_impl_vasixd(charSequenceGet(str, n));
      if (c1 === 10) {
        dx = 0.0;
        dy = dy + _this__u8e3s4.p4n();
        continue $l$loop;
      }
      // Inline function 'kotlin.text.getOrElse' call
      var index = n + 1 | 0;
      // Inline function 'kotlin.contracts.contract' call
      var tmp_0;
      if (0 <= index ? index <= (charSequenceLength(str) - 1 | 0) : false) {
        tmp_0 = charSequenceGet(str, index);
      } else {
        // Inline function 'korlibs.korge.bitmapfont.drawText.<anonymous>.<anonymous>' call
        tmp_0 = _Char___init__impl__6a9atx(32);
      }
      var tmp$ret$1 = tmp_0;
      var c2 = Char__toInt_impl_vasixd(tmp$ret$1);
      var glyph = _this__u8e3s4.d1(c1);
      var tex = glyph.v4l_1;
      var tmp0_tex = ctx.p8g(tex);
      var tmp1_x = dx + glyph.w4l_1;
      var tmp2_y = dy + glyph.x4l_1;
      var tmp3_width = tex.j3o_1;
      var tmp4_height = tex.k3o_1;
      var tmp5_m = get_immutable(m2);
      this_0.q8g(tmp0_tex, tmp1_x, tmp2_y, tmp3_width, tmp4_height, tmp5_m, filtering, colMul, blendMode);
      var tmp6_safe_receiver = _this__u8e3s4.s4n().d1(Companion_instance_5.s4l(c1, c2));
      var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.n4n_1;
      var kerningOffset = tmp7_elvis_lhs == null ? 0 : tmp7_elvis_lhs;
      dx = dx + (glyph.y4l_1 + kerningOffset | 0);
    }
     while (inductionVariable <= last);
    tmp = Unit_instance;
  }
}
var debugBmpFontOrNull;
function *_generator_debugBmpFont__zhh4ef($completion) {
  if (debugBmpFontOrNull == null) {
    var tmp = readBitmap(openAsync(get_DEBUG_FONT_BYTES()), new ImageDecodingProps(VOID, VOID, VOID, VOID, VOID, VOID, VOID, true), $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    debugBmpFontOrNull = debugBmpFont_0(slice(tmp.o4b()));
  }
  return ensureNotNull(debugBmpFontOrNull);
}
function debugBmpFont($completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_debugBmpFont__zhh4ef.bind(VOID), $completion);
}
function debugBmpFont_0(tex) {
  var fntAdvance = 7.0;
  var fntWidth = 8.0;
  var fntHeight = 8.0;
  var fntBlockX = 2.0;
  var fntBlockY = 2.0;
  var fntBlockWidth = 12.0;
  var fntBlockHeight = 12.0;
  // Inline function 'korlibs.image.font.Companion.invoke' call
  var base = fntHeight - 1.0;
  // Inline function 'kotlin.collections.associateWith' call
  var this_0 = until(0, 256);
  var result = LinkedHashMap.sc(coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16));
  // Inline function 'kotlin.collections.associateWithTo' call
  var inductionVariable = this_0.d2_1;
  var last = this_0.e2_1;
  if (inductionVariable <= last)
    do {
      var element = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.korge.bitmapfont.debugBmpFont.<anonymous>' call
      var it = element;
      var x = it % 16 | 0;
      var y = it / 16 | 0;
      var tmp$ret$0 = new Glyph(fntHeight, it, tex.r3p(numberToInt(x * fntBlockWidth + fntBlockX), numberToInt(y * fntBlockHeight + fntBlockY), numberToInt(fntWidth), numberToInt(fntHeight)), 0, 0, numberToInt(fntAdvance));
      result.j3(element, tmp$ret$0);
    }
     while (!(element === last));
  var glyphs = toIntMap(result);
  var kernings = IntMap.p2w();
  var name = 'BitmapFont';
  return new BitmapFontImpl(numberToDouble(fntHeight), numberToDouble(fntHeight), numberToDouble(base), glyphs, kernings, name, null);
}
function get_DEBUG_FONT_BYTES() {
  return fromBase64('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');
}
var Companion_instance_62;
function Companion_getInstance_68() {
  if (Companion_instance_62 === VOID)
    new Companion_53();
  return Companion_instance_62;
}
var Companion_instance_63;
function Companion_getInstance_69() {
  return Companion_instance_63;
}
function endFrameOldKeys($this, delta) {
  var inductionVariable = 0;
  if (inductionVariable < 256)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var prev = $this.x8h_1[n];
      var curr = $this.w8h_1[n];
      $this.c8i_1[n] = (prev && !curr);
      $this.b8i_1[n] = (!prev && curr);
      if (curr) {
        var _array__4zh2yp = $this.y8h_1;
        _array__4zh2yp[n] = _array__4zh2yp[n] + _FastDuration___get_fastNanoseconds__impl__9kjwbr(delta);
      } else {
        $this.y8h_1[n] = 0.0;
        $this.z8h_1[n] = 0.0;
      }
      var triggerPress = false;
      var pressingTime = get_fastNanoseconds($this.y8h_1[n]);
      if ($this.y8h_1[n] > 0) {
        var tmp0_subject = _FastDuration___get_fastMilliseconds__impl__pe68va(pressingTime);
        var timeBarrier = (0.0 <= tmp0_subject ? tmp0_subject <= 1.0 : false) ? get_fastMilliseconds(0.0) : (1.0 <= tmp0_subject ? tmp0_subject <= 300.0 : false) ? get_fastMilliseconds(100.0) : (300.0 <= tmp0_subject ? tmp0_subject <= 1000.0 : false) ? get_fastMilliseconds(50.0) : get_fastMilliseconds(20.0);
        var elapsedTime = FastDuration__minus_impl_evs237(pressingTime, get_fastNanoseconds($this.z8h_1[n]));
        if (FastDuration__compareTo_impl_4fhnj7(elapsedTime, timeBarrier) >= 0) {
          triggerPress = true;
        }
      }
      if (triggerPress) {
        $this.z8h_1[n] = $this.y8h_1[n];
      }
      $this.a8i_1[n] = triggerPress;
    }
     while (inductionVariable < 256);
  arraycopy_4($this.w8h_1, 0, $this.x8h_1, 0, 256);
}
function Input$_isTouchDeviceGen$lambda() {
  return AGOpenglFactory_instance.f8i();
}
var DefaultViewport_instance;
function DefaultViewport_getInstance() {
  if (DefaultViewport_instance === VOID)
    new DefaultViewport();
  return DefaultViewport_instance;
}
function *_generator_configureLoggerFromProperties__heiqlb(file, $completion) {
  try {
    var tmp = file.r2b(VOID, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    configureLoggerFromProperties_0(tmp);
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function configureLoggerFromProperties(file, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_configureLoggerFromProperties__heiqlb.bind(VOID, file), $completion);
}
function configureLoggerFromProperties_0(str) {
  var props = Companion_instance_64.s8i(str);
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = props.s1().a1();
  while (_iterator__ex2g4s.b1()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.c1();
    // Inline function 'kotlin.collections.component1' call
    var key = _destruct__k2r9zo.t1();
    // Inline function 'kotlin.collections.component2' call
    var value = _destruct__k2r9zo.u1();
    try {
      var tmp = Companion_getInstance_1().iz(key);
      // Inline function 'kotlin.text.toUpperCase' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$4 = value.toUpperCase();
      tmp.k31(valueOf(tmp$ret$4));
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
  }
}
var Companion_instance_64;
function Companion_getInstance_70() {
  return Companion_instance_64;
}
function AgAutoFreeManager$entryPool$lambda(it) {
  it.j2y();
  return Unit_instance;
}
function AgAutoFreeManager$entryPool$lambda_0(it) {
  return new Entry();
}
function getTextureInfo($this, bitmap) {
  if ($this.z8j_1 === bitmap && ensureNotNull($this.a8k_1).i8j_1.m8j_1 === bitmap.a44_1)
    return ensureNotNull($this.a8k_1);
  if ($this.b8k_1 === bitmap && ensureNotNull($this.c8k_1).i8j_1.m8j_1 === bitmap.a44_1)
    return ensureNotNull($this.c8k_1);
  $this.t8j_1.g2v(bitmap);
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.getOrPut' call
    var this_0 = $this.y8j_1;
    var res = get_0(this_0, bitmap);
    if (!(res == null)) {
      tmp$ret$0 = res;
      break $l$block;
    }
    // Inline function 'korlibs.korge.render.AgBitmapTextureManager.getTextureInfo.<anonymous>' call
    // Inline function 'kotlin.also' call
    var this_1 = $this.x8j_1.t2x();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.korge.render.AgBitmapTextureManager.getTextureInfo.<anonymous>.<anonymous>' call
    var base = this_1.i8j_1;
    base.m8j_1 = -1;
    var tmp = base;
    var tmp_0;
    if (bitmap instanceof MultiBitmap) {
      tmp_0 = Companion_getInstance_51().c70_1;
    } else {
      tmp_0 = Companion_getInstance_51().a70_1;
    }
    tmp.k8j_1 = new AGTexture(tmp_0);
    base.o8j(bitmap.r43_1);
    base.p8j(bitmap.s43_1);
    var out = this_1;
    set(this_0, bitmap, out);
    tmp$ret$0 = out;
  }
  var textureInfo = tmp$ret$0;
  $this.b8k_1 = $this.z8j_1;
  $this.c8k_1 = $this.a8k_1;
  var base_0 = textureInfo.i8j_1;
  $this.z8j_1 = bitmap;
  $this.a8k_1 = textureInfo;
  if (!(bitmap.a44_1 === base_0.m8j_1)) {
    base_0.m8j_1 = bitmap.a44_1;
    var tmp_1 = $this;
    // Inline function 'kotlin.Long.minus' call
    var this_2 = $this.w8j_1;
    var other = textureInfo.h8j_1;
    tmp_1.w8j_1 = this_2.a2(toLong(other));
    try {
      base_0.i8k(bitmap, bitmap.c44_1, get_baseMipmapLevel(bitmap), get_maxMipmapLevel(bitmap));
    }finally {
      textureInfo.h8j_1 = _get_estimateSizeInBytes__tshb4c(bitmap, $this);
      var tmp_2 = $this;
      // Inline function 'kotlin.Long.plus' call
      var this_3 = $this.w8j_1;
      var other_0 = textureInfo.h8j_1;
      tmp_2.w8j_1 = this_3.a4(toLong(other_0));
    }
    bitmap.n44();
  }
  return textureInfo;
}
function _get_estimateSizeInBytes__tshb4c(_this__u8e3s4, $this) {
  return imul(_this__u8e3s4.s43_1, imul(_this__u8e3s4.r43_1, _this__u8e3s4.t43_1) / 8 | 0);
}
function _getTexture($this, slice) {
  if ($this.d8k_1 === slice)
    return ensureNotNull($this.e8k_1);
  if ($this.f8k_1 === slice)
    return ensureNotNull($this.g8k_1);
  var info = getTextureInfo($this, slice.j3p());
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.getOrPut' call
    var this_0 = info.j8j_1;
    var res = get_0(this_0, slice);
    if (!(res == null)) {
      tmp$ret$0 = res;
      break $l$block;
    }
    // Inline function 'korlibs.korge.render.AgBitmapTextureManager._getTexture.<anonymous>' call
    var tmp;
    if (slice instanceof RectSlice) {
      tmp = Texture_1(info.i8j_1).t3p(RectangleInt.n2m(slice.y2d(), slice.a2e(), slice.j3o_1, slice.k3o_1));
    } else {
      tmp = Companion_instance_7.h3q(info.i8j_1, slice);
    }
    var out = tmp;
    set(this_0, slice, out);
    tmp$ret$0 = out;
  }
  var texture = tmp$ret$0;
  $this.f8k_1 = $this.d8k_1;
  $this.g8k_1 = $this.e8k_1;
  $this.d8k_1 = slice;
  $this.e8k_1 = texture;
  return texture;
}
function clearFastCacheAccess($this) {
  $this.z8j_1 = null;
  $this.a8k_1 = null;
  $this.b8k_1 = null;
  $this.c8k_1 = null;
  $this.d8k_1 = null;
  $this.e8k_1 = null;
  $this.f8k_1 = null;
  $this.g8k_1 = null;
}
function AgBitmapTextureManager$textureInfoPool$lambda(it) {
  it.j2y();
  return Unit_instance;
}
function AgBitmapTextureManager$textureInfoPool$lambda_0(it) {
  return new BitmapTextureInfo();
}
function removeCache($this) {
}
function AgBufferManager$bufferPool$lambda(it) {
  return new AGBuffer();
}
function get_logger() {
  _init_properties_BatchBuilder2D_kt__vdn94j();
  return logger_0;
}
var logger_0;
function get_BB_MAX_TEXTURES() {
  _init_properties_BatchBuilder2D_kt__vdn94j();
  return BB_MAX_TEXTURES;
}
var BB_MAX_TEXTURES;
function BatchBuilder2D$Companion$createTextureLookup$lambda($$this$apply) {
  return function ($this$IF_ELSE_BINARY_LOOKUP, n) {
    $this$IF_ELSE_BINARY_LOOKUP.o7b($this$IF_ELSE_BINARY_LOOKUP.r7b(), $this$IF_ELSE_BINARY_LOOKUP.z7b(Companion_getInstance_71().d8l_1[n], $this$IF_ELSE_BINARY_LOOKUP.x7b($$this$apply.k7b(), 'xy')));
    return Unit_instance;
  };
}
function _addIndices($this, indicesI16, pos, i0, i1, i2, i3, i4, i5) {
  Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 0 | 0, i0);
  Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 1 | 0, i1);
  Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 2 | 0, i2);
  Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 3 | 0, i3);
  Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 4 | 0, i4);
  Uint16Buffer__set_impl_g0kliu(indicesI16, pos + 5 | 0, i5);
  return 6;
}
function applyMatrix($this, matrix, idx, vcount) {
  var f32 = get_f32($this.r8f_1);
  var idx_0 = idx;
  var ma = matrix.x2g_1;
  var mb = matrix.y2g_1;
  var mc = matrix.z2g_1;
  var md = matrix.a2h_1;
  var mtx = matrix.b2h_1;
  var mty = matrix.c2h_1;
  var inductionVariable = 0;
  if (inductionVariable < vcount)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var p = Vector2D.b2i(Float32Buffer__get_impl_659lhu(f32, idx_0 + 0 | 0), Float32Buffer__get_impl_659lhu(f32, idx_0 + 1 | 0));
      var pt = Companion_getInstance_7().f2h(ma, mb, mc, md, mtx, mty, p);
      Float32Buffer__set_impl_34szne(f32, idx_0 + 0 | 0, pt.h2d_1);
      Float32Buffer__set_impl_34szne(f32, idx_0 + 1 | 0, pt.i2d_1);
      idx_0 = idx_0 + 6 | 0;
    }
     while (inductionVariable < vcount);
}
function checkAvailable($this, indices, vertices) {
  return ($this.x8f_1 + indices | 0) < $this.q8f_1 && ($this.w8f_1 + vertices | 0) < $this.p8f_1;
}
var Companion_instance_65;
function Companion_getInstance_71() {
  if (Companion_instance_65 === VOID)
    new Companion_56();
  return Companion_instance_65;
}
function BatchBuilder2D$lambda(this$0) {
  return function (it) {
    var tmp;
    switch (it.t3_1) {
      case 0:
        this$0.u8l();
        tmp = Unit_instance;
        break;
      case 1:
        this$0.v8l();
        tmp = Unit_instance;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return Unit_instance;
  };
}
function BatchBuilder2D$buffers$lambda(it) {
  return new BatchBuffers();
}
var properties_initialized_BatchBuilder2D_kt_532b2j;
function _init_properties_BatchBuilder2D_kt__vdn94j() {
  if (!properties_initialized_BatchBuilder2D_kt_532b2j) {
    properties_initialized_BatchBuilder2D_kt_532b2j = true;
    logger_0 = Companion_getInstance_1().iz('BatchBuilder2D');
    BB_MAX_TEXTURES = Companion_getInstance_3().rw() && Companion_getInstance_3().uw().cw_1 && Companion_getInstance_3().uw().hw() ? 1 : 4;
  }
}
function get_debugLineRenderContext(_this__u8e3s4) {
  _init_properties_LineRenderBatcher_kt__ezqewb();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = debugLineRenderContext$delegate;
    var property = debugLineRenderContext$factory();
    var tmp0_elvis_lhs = this_0.v10_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.w10_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.v10_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var debugLineRenderContext$delegate;
var Companion_instance_66;
function Companion_getInstance_72() {
  if (Companion_instance_66 === VOID)
    new Companion_57();
  return Companion_instance_66;
}
function addVertex($this, x, y, color, m) {
  setFloat32($this.i8o_1, $this.l8o_1 + 0 | 0, m.l2h(x, y));
  setFloat32($this.i8o_1, $this.l8o_1 + 1 | 0, m.m2h(x, y));
  setInt32($this.i8o_1, $this.l8o_1 + 2 | 0, _RGBA___get_value__impl__hhco8v(color));
  $this.l8o_1 = $this.l8o_1 + (Companion_getInstance_72().x8n_1.s73_1 / 4 | 0) | 0;
  $this.k8o_1 = $this.k8o_1 + 1 | 0;
}
function LineRenderBatcher$lambda(this$0) {
  return function (it) {
    this$0.bd();
    return Unit_instance;
  };
}
function debugLineRenderContext$delegate$lambda($this$PropertyThis) {
  _init_properties_LineRenderBatcher_kt__ezqewb();
  return new LineRenderBatcher($this$PropertyThis);
}
function debugLineRenderContext$factory() {
  return getPropertyCallableRef('debugLineRenderContext', 1, KProperty1, function (receiver) {
    return get_debugLineRenderContext(receiver);
  }, null);
}
var properties_initialized_LineRenderBatcher_kt_urwcod;
function _init_properties_LineRenderBatcher_kt__ezqewb() {
  if (!properties_initialized_LineRenderBatcher_kt_urwcod) {
    properties_initialized_LineRenderBatcher_kt_urwcod = true;
    debugLineRenderContext$delegate = new PropertyThis(VOID, debugLineRenderContext$delegate$lambda);
  }
}
var FlushKind_STATE_instance;
var FlushKind_FULL_instance;
var FlushKind_entriesInitialized;
function FlushKind_initEntries() {
  if (FlushKind_entriesInitialized)
    return Unit_instance;
  FlushKind_entriesInitialized = true;
  FlushKind_STATE_instance = new FlushKind('STATE', 0);
  FlushKind_FULL_instance = new FlushKind('FULL', 1);
}
function RenderContext$tempTexturePool$lambda(it) {
  return new AGTexture();
}
function RenderContext$projViewMatUB$delegate$lambda(this$0) {
  return function () {
    return this$0.q71(ProjViewUB_getInstance());
  };
}
function RenderContext$dynamicVertexBufferPool$lambda(it) {
  return new AGBuffer();
}
function RenderContext$frameBuffers$lambda(it) {
  return AGFrameBuffer.j6u(VOID, it);
}
function FlushKind_FULL_getInstance() {
  FlushKind_initEntries();
  return FlushKind_FULL_instance;
}
function projViewMatUB$factory() {
  return getPropertyCallableRef('projViewMatUB', 1, KProperty1, function (receiver) {
    return receiver.w8o();
  }, null);
}
function get_logger_0() {
  _init_properties_RenderContext2D_kt__7o43tz();
  return logger_1;
}
var logger_1;
function RenderContext2D$mpool$lambda(it) {
  return new MMatrix();
}
var properties_initialized_RenderContext2D_kt_ica10b;
function _init_properties_RenderContext2D_kt__7o43tz() {
  if (!properties_initialized_RenderContext2D_kt_ica10b) {
    properties_initialized_RenderContext2D_kt_ica10b = true;
    logger_1 = Companion_getInstance_1().iz('RenderContext2D');
  }
}
function SDFShaders$opInterpolate$delegate$lambda($this$FUNC, a, b, c) {
  $this$FUNC.x7c($this$FUNC.n7x(a, b, c));
  return Unit_instance;
}
function SDFShaders$opUnion$delegate$lambda($this$FUNC, a, b) {
  $this$FUNC.x7c($this$FUNC.k7x(a, b));
  return Unit_instance;
}
function SDFShaders$opIntersect$delegate$lambda($this$FUNC, a, b) {
  $this$FUNC.x7c($this$FUNC.l7x(a, b));
  return Unit_instance;
}
function SDFShaders$opSubtract$delegate$lambda($this$FUNC, a, b) {
  $this$FUNC.x7c($this$FUNC.l7x(a, $this$FUNC.m7d(b)));
  return Unit_instance;
}
function SDFShaders$opRound$delegate$lambda($this$FUNC, d, r) {
  $this$FUNC.x7c($this$FUNC.n7d(d, r));
  return Unit_instance;
}
function SDFShaders$opBorder$delegate$lambda($this$FUNC, d, r) {
  $this$FUNC.x7c($this$FUNC.n7d($this$FUNC.e7d(d), r));
  return Unit_instance;
}
function SDFShaders$opBorderInner$delegate$lambda($this$FUNC, d, r) {
  // Inline function 'korlibs.graphics.shader.Builder.IF' call
  var cond = $this$FUNC.t7x(d, 0.0);
  var body = $this$FUNC.f7c();
  // Inline function 'korlibs.korge.render.SDFShaders.opBorderInner$delegate.<anonymous>.<anonymous>' call
  body.x7c(d);
  var stmIf = new If(cond, body.h7c());
  // Inline function 'kotlin.collections.plusAssign' call
  $this$FUNC.n7b_1.h(stmIf);
  var tmp = stmIf;
  $this$FUNC.t7c(tmp, SDFShaders$opBorderInner$delegate$lambda$lambda(d, r));
  return Unit_instance;
}
function SDFShaders$opBorderInner$delegate$lambda$lambda($d, $r) {
  return function ($this$ELSE) {
    $this$ELSE.x7c($this$ELSE.n7d($this$ELSE.e7d($d), $r));
    return Unit_instance;
  };
}
function SDFShaders$opAA$delegate$lambda($this$FUNC, d) {
  $this$FUNC.x7c($this$FUNC.p7x(1.0, $this$FUNC.j7x($this$FUNC.r7x($this$FUNC.d7c(d, $this$FUNC.m7x(d)), 0.5), $this$FUNC.u7b(0.0), $this$FUNC.u7b(1.0))));
  return Unit_instance;
}
function SDFShaders$opAARev$delegate$lambda($this$FUNC, d) {
  $this$FUNC.x7c($this$FUNC.j7x($this$FUNC.r7x($this$FUNC.d7c(d, $this$FUNC.m7x(d)), 0.5), $this$FUNC.u7b(0.0), $this$FUNC.u7b(1.0)));
  return Unit_instance;
}
function SDFShaders$opSmoothUnion$delegate$lambda($this$FUNC, d1, d2, k) {
  var h = $this$FUNC.h7x($this$FUNC.j7x($this$FUNC.q7x(0.5, $this$FUNC.d7c($this$FUNC.s7x(0.5, $this$FUNC.n7d(d2, d1)), k)), $this$FUNC.u7b(0.0), $this$FUNC.u7b(1.0)));
  $this$FUNC.x7c($this$FUNC.n7d($this$FUNC.n7x(d2, d1, h), $this$FUNC.s7b($this$FUNC.s7b(k, h), $this$FUNC.p7x(1.0, h))));
  return Unit_instance;
}
function SDFShaders$opSmoothSubtraction$delegate$lambda($this$FUNC, d1, d2, k) {
  var h = $this$FUNC.h7x($this$FUNC.j7x($this$FUNC.p7x(0.5, $this$FUNC.d7c($this$FUNC.s7x(0.5, $this$FUNC.o7d(d2, d1)), k)), $this$FUNC.u7b(0.0), $this$FUNC.u7b(1.0)));
  $this$FUNC.x7c($this$FUNC.o7d($this$FUNC.n7x(d2, $this$FUNC.m7d(d1), h), $this$FUNC.s7b($this$FUNC.s7b(k, h), $this$FUNC.p7x(1.0, h))));
  return Unit_instance;
}
function SDFShaders$opSmoothIntersection$delegate$lambda($this$FUNC, d1, d2, k) {
  var h = $this$FUNC.h7x($this$FUNC.j7x($this$FUNC.p7x(0.5, $this$FUNC.d7c($this$FUNC.s7x(0.5, $this$FUNC.n7d(d2, d1)), k)), $this$FUNC.u7b(0.0), $this$FUNC.u7b(1.0)));
  $this$FUNC.x7c($this$FUNC.o7d($this$FUNC.n7x(d2, d1, h), $this$FUNC.s7b($this$FUNC.s7b(k, h), $this$FUNC.p7x(1.0, h))));
  return Unit_instance;
}
function SDFShaders$circle$delegate$lambda($this$FUNC, p, r) {
  $this$FUNC.x7c($this$FUNC.n7d($this$FUNC.o7x(p), r));
  return Unit_instance;
}
function SDFShaders$roundedBox$delegate$lambda($this$FUNC, p, b, r) {
  $this$FUNC.o7b($this$FUNC.x7b(r, 'xy'), $this$FUNC.i7x($this$FUNC.t7x($this$FUNC.i7d(p), 0.0), $this$FUNC.x7b(r, 'xy'), $this$FUNC.x7b(r, 'zw')));
  $this$FUNC.o7b($this$FUNC.i7d(r), $this$FUNC.i7x($this$FUNC.t7x($this$FUNC.j7d(p), 0.0), $this$FUNC.i7d(r), $this$FUNC.j7d(r)));
  var q = $this$FUNC.h7x($this$FUNC.o7d($this$FUNC.n7d($this$FUNC.e7d(p), b), $this$FUNC.i7d(r)));
  $this$FUNC.x7c($this$FUNC.n7d($this$FUNC.o7d($this$FUNC.k7x($this$FUNC.l7x($this$FUNC.i7d(q), $this$FUNC.j7d(q)), $this$FUNC.u7b(0.0)), $this$FUNC.o7x($this$FUNC.l7x(q, $this$FUNC.u7b(0.0)))), $this$FUNC.i7d(r)));
  return Unit_instance;
}
function SDFShaders$box$delegate$lambda($this$FUNC, p, b) {
  var d = $this$FUNC.h7x($this$FUNC.n7d($this$FUNC.e7d(p), b));
  $this$FUNC.x7c($this$FUNC.o7d($this$FUNC.o7x($this$FUNC.l7x(d, $this$FUNC.u7b(0.0))), $this$FUNC.k7x($this$FUNC.l7x($this$FUNC.i7d(d), $this$FUNC.j7d(d)), $this$FUNC.u7b(0.0))));
  return Unit_instance;
}
function SDFShaders$opCombinePremultipliedColors$delegate$lambda($this$FUNC, dst, src) {
  $this$FUNC.x7c($this$FUNC.o7d(src, $this$FUNC.s7b(dst, $this$FUNC.p7x(1.0, $this$FUNC.b7c(src)))));
  return Unit_instance;
}
var SDFShaders_instance;
function SDFShaders_getInstance() {
  if (SDFShaders_instance === VOID)
    SDFShaders.s8q();
  return SDFShaders_instance;
}
function opInterpolate$factory() {
  return getPropertyCallableRef('opInterpolate', 1, KProperty1, function (receiver) {
    return receiver.t8q();
  }, null);
}
function opUnion$factory() {
  return getPropertyCallableRef('opUnion', 1, KProperty1, function (receiver) {
    return receiver.u8q();
  }, null);
}
function opIntersect$factory() {
  return getPropertyCallableRef('opIntersect', 1, KProperty1, function (receiver) {
    return receiver.v8q();
  }, null);
}
function opSubtract$factory() {
  return getPropertyCallableRef('opSubtract', 1, KProperty1, function (receiver) {
    return receiver.w8q();
  }, null);
}
function opRound$factory() {
  return getPropertyCallableRef('opRound', 1, KProperty1, function (receiver) {
    return receiver.x8q();
  }, null);
}
function opBorder$factory() {
  return getPropertyCallableRef('opBorder', 1, KProperty1, function (receiver) {
    return receiver.y8q();
  }, null);
}
function opBorderInner$factory() {
  return getPropertyCallableRef('opBorderInner', 1, KProperty1, function (receiver) {
    return receiver.z8q();
  }, null);
}
function opAA$factory() {
  return getPropertyCallableRef('opAA', 1, KProperty1, function (receiver) {
    return receiver.a8r();
  }, null);
}
function opAARev$factory() {
  return getPropertyCallableRef('opAARev', 1, KProperty1, function (receiver) {
    return receiver.b8r();
  }, null);
}
function opSmoothUnion$factory() {
  return getPropertyCallableRef('opSmoothUnion', 1, KProperty1, function (receiver) {
    return receiver.c8r();
  }, null);
}
function opSmoothSubtraction$factory() {
  return getPropertyCallableRef('opSmoothSubtraction', 1, KProperty1, function (receiver) {
    return receiver.d8r();
  }, null);
}
function opSmoothIntersection$factory() {
  return getPropertyCallableRef('opSmoothIntersection', 1, KProperty1, function (receiver) {
    return receiver.e8r();
  }, null);
}
function circle$factory() {
  return getPropertyCallableRef('circle', 1, KProperty1, function (receiver) {
    return receiver.f8r();
  }, null);
}
function roundedBox$factory() {
  return getPropertyCallableRef('roundedBox', 1, KProperty1, function (receiver) {
    return receiver.g8r();
  }, null);
}
function box$factory() {
  return getPropertyCallableRef('box', 1, KProperty1, function (receiver) {
    return receiver.h8r();
  }, null);
}
function opCombinePremultipliedColors$factory() {
  return getPropertyCallableRef('opCombinePremultipliedColors', 1, KProperty1, function (receiver) {
    return receiver.i8r();
  }, null);
}
function opInterpolate$factory_0() {
  return getPropertyCallableRef('opInterpolate', 1, KProperty1, function (receiver) {
    return receiver.t8q();
  }, null);
}
function opUnion$factory_0() {
  return getPropertyCallableRef('opUnion', 1, KProperty1, function (receiver) {
    return receiver.u8q();
  }, null);
}
function opIntersect$factory_0() {
  return getPropertyCallableRef('opIntersect', 1, KProperty1, function (receiver) {
    return receiver.v8q();
  }, null);
}
function opSubtract$factory_0() {
  return getPropertyCallableRef('opSubtract', 1, KProperty1, function (receiver) {
    return receiver.w8q();
  }, null);
}
function opRound$factory_0() {
  return getPropertyCallableRef('opRound', 1, KProperty1, function (receiver) {
    return receiver.x8q();
  }, null);
}
function opBorder$factory_0() {
  return getPropertyCallableRef('opBorder', 1, KProperty1, function (receiver) {
    return receiver.y8q();
  }, null);
}
function opBorderInner$factory_0() {
  return getPropertyCallableRef('opBorderInner', 1, KProperty1, function (receiver) {
    return receiver.z8q();
  }, null);
}
function opAA$factory_0() {
  return getPropertyCallableRef('opAA', 1, KProperty1, function (receiver) {
    return receiver.a8r();
  }, null);
}
function opAARev$factory_0() {
  return getPropertyCallableRef('opAARev', 1, KProperty1, function (receiver) {
    return receiver.b8r();
  }, null);
}
function opSmoothUnion$factory_0() {
  return getPropertyCallableRef('opSmoothUnion', 1, KProperty1, function (receiver) {
    return receiver.c8r();
  }, null);
}
function opSmoothSubtraction$factory_0() {
  return getPropertyCallableRef('opSmoothSubtraction', 1, KProperty1, function (receiver) {
    return receiver.d8r();
  }, null);
}
function opSmoothIntersection$factory_0() {
  return getPropertyCallableRef('opSmoothIntersection', 1, KProperty1, function (receiver) {
    return receiver.e8r();
  }, null);
}
function circle$factory_0() {
  return getPropertyCallableRef('circle', 1, KProperty1, function (receiver) {
    return receiver.f8r();
  }, null);
}
function roundedBox$factory_0() {
  return getPropertyCallableRef('roundedBox', 1, KProperty1, function (receiver) {
    return receiver.g8r();
  }, null);
}
function box$factory_0() {
  return getPropertyCallableRef('box', 1, KProperty1, function (receiver) {
    return receiver.h8r();
  }, null);
}
function opCombinePremultipliedColors$factory_0() {
  return getPropertyCallableRef('opCombinePremultipliedColors', 1, KProperty1, function (receiver) {
    return receiver.i8r();
  }, null);
}
function Texture(frameBuffer) {
  return Texture_0(frameBuffer.f6z(), frameBuffer.d6u_1, frameBuffer.e6u_1);
}
function Texture_0(agBase, width, height) {
  return new RectSlice(TextureBase.j8r(agBase, SizeInt.d2o(width, height)), RectangleInt.n2m(0, 0, width, height));
}
function Texture_1(base, left, top, right, bottom) {
  left = left === VOID ? 0 : left;
  top = top === VOID ? 0 : top;
  right = right === VOID ? base.x2p() : right;
  bottom = bottom === VOID ? base.y2p() : bottom;
  return new RectSlice(base, Companion_instance_2.s2l(left, top, right, bottom));
}
function get_TEXTURED_ARRAY_QUAD_INDICES() {
  _init_properties_TexturedVertexArray_kt__kev7cq();
  return TEXTURED_ARRAY_QUAD_INDICES;
}
var TEXTURED_ARRAY_QUAD_INDICES;
var TEXTURED_ARRAY_EMPTY_INT_ARRAY;
var TEXTURED_ARRAY_EMPTY_SHORT_ARRAY;
var Companion_instance_67;
function Companion_getInstance_73() {
  if (Companion_instance_67 === VOID)
    new Companion_58();
  return Companion_instance_67;
}
var properties_initialized_TexturedVertexArray_kt_ouua70;
function _init_properties_TexturedVertexArray_kt__kev7cq() {
  if (!properties_initialized_TexturedVertexArray_kt_ouua70) {
    properties_initialized_TexturedVertexArray_kt_ouua70 = true;
    // Inline function 'kotlin.shortArrayOf' call
    TEXTURED_ARRAY_QUAD_INDICES = new Int16Array([0, 1, 2, 3, 0, 2]);
    TEXTURED_ARRAY_EMPTY_INT_ARRAY = new Int32Array(0);
    TEXTURED_ARRAY_EMPTY_SHORT_ARRAY = new Int16Array(0);
  }
}
function _get_root__dd8asp($this) {
  var tmp = $this.o8r_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('root');
  }
}
function _get_mountable__707cy($this) {
  var tmp = $this.p8r_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('mountable');
  }
}
function _interpolateRatio(ratio, l, r) {
  return interpolate(ratio, l, r);
}
var DEFAULT_instance;
function DEFAULT_getInstance() {
  return DEFAULT_instance;
}
var GLOBAL_CHECK_GL;
var Cursor_DEFAULT_instance;
var Cursor_CROSSHAIR_instance;
var Cursor_TEXT_instance;
var Cursor_HAND_instance;
var Cursor_MOVE_instance;
var Cursor_WAIT_instance;
var Cursor_RESIZE_EAST_instance;
var Cursor_RESIZE_WEST_instance;
var Cursor_RESIZE_SOUTH_instance;
var Cursor_RESIZE_NORTH_instance;
var Cursor_RESIZE_NORTH_EAST_instance;
var Cursor_RESIZE_NORTH_WEST_instance;
var Cursor_RESIZE_SOUTH_EAST_instance;
var Cursor_RESIZE_SOUTH_WEST_instance;
var Companion_instance_68;
function Companion_getInstance_74() {
  Cursor_initEntries();
  if (Companion_instance_68 === VOID)
    new Companion_59();
  return Companion_instance_68;
}
var Cursor_entriesInitialized;
function Cursor_initEntries() {
  if (Cursor_entriesInitialized)
    return Unit_instance;
  Cursor_entriesInitialized = true;
  Cursor_DEFAULT_instance = new Cursor('DEFAULT', 0);
  Cursor_CROSSHAIR_instance = new Cursor('CROSSHAIR', 1);
  Cursor_TEXT_instance = new Cursor('TEXT', 2);
  Cursor_HAND_instance = new Cursor('HAND', 3);
  Cursor_MOVE_instance = new Cursor('MOVE', 4);
  Cursor_WAIT_instance = new Cursor('WAIT', 5);
  Cursor_RESIZE_EAST_instance = new Cursor('RESIZE_EAST', 6);
  Cursor_RESIZE_WEST_instance = new Cursor('RESIZE_WEST', 7);
  Cursor_RESIZE_SOUTH_instance = new Cursor('RESIZE_SOUTH', 8);
  Cursor_RESIZE_NORTH_instance = new Cursor('RESIZE_NORTH', 9);
  Cursor_RESIZE_NORTH_EAST_instance = new Cursor('RESIZE_NORTH_EAST', 10);
  Cursor_RESIZE_NORTH_WEST_instance = new Cursor('RESIZE_NORTH_WEST', 11);
  Cursor_RESIZE_SOUTH_EAST_instance = new Cursor('RESIZE_SOUTH_EAST', 12);
  Cursor_RESIZE_SOUTH_WEST_instance = new Cursor('RESIZE_SOUTH_WEST', 13);
  Companion_getInstance_74();
}
function GameWindow$MenuItem$_init_$lambda_465oqx() {
  return Unit_instance;
}
var Quality_PERFORMANCE_instance;
var Quality_QUALITY_instance;
var Quality_AUTOMATIC_instance;
var Quality_entriesInitialized;
function Quality_initEntries() {
  if (Quality_entriesInitialized)
    return Unit_instance;
  Quality_entriesInitialized = true;
  Quality_PERFORMANCE_instance = new Quality('PERFORMANCE', 0, 0.0);
  Quality_QUALITY_instance = new Quality('QUALITY', 1, 1.0);
  Quality_AUTOMATIC_instance = new Quality('AUTOMATIC', 2, 0.5);
}
function *_generator_invoke__zhh2q8($this, $completion) {
  var tmp = $this.q8s_1($this.r8s_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var CoroutineKey_instance;
function CoroutineKey_getInstance() {
  if (CoroutineKey_instance === VOID)
    new CoroutineKey();
  return CoroutineKey_instance;
}
function _get_fpsCached__581dty($this) {
  return $this.x8t_1.wo($this, fpsCached$factory());
}
function *_generator_waitClose__fhnm35($this, $completion) {
  while ($this.m8u_1) {
    // Inline function 'korlibs.time.milliseconds' call
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance();
    var tmp$ret$1 = toDuration(100, DurationUnit_MILLISECONDS_getInstance());
    var tmp = delay_0(tmp$ret$1, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  return Unit_instance;
}
function *_generator_loop__qll5p8($this, entry, $completion) {
  var tmp = $this.q8v($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.mn(CoroutineName.o1e('GameWindow.loop'));
  launchImmediately(tmp_0, GameWindow$loop$slambda_0(entry, $this));
  while ($this.m8u_1) {
    var elapsed;
    // Inline function 'kotlin.time.measureTime' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.time.measureTime' call
    // Inline function 'kotlin.contracts.contract' call
    var mark = Monotonic_instance.rj();
    // Inline function 'korlibs.render.GameWindow.loop.<anonymous>' call
    elapsed = $this.r8v();
    var realElapsed = ValueTimeMark__elapsedNow_impl_eonqvs(mark);
    var available = FastDuration__minus_impl_evs237($this.s8v(), elapsed);
    if (FastDuration__compareTo_impl_4fhnj7(available, Companion_instance_3.k1z()) > 0) {
      var tmp_1 = $this.t8v(available, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
    }
  }
  return Unit_instance;
}
function *_generator_loopDelay__vgtnit($this, time, $completion) {
  var tmp = delay(time, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function GameWindow$fpsCached$delegate$lambda(this$0) {
  return function () {
    return this$0.u8v();
  };
}
function GameWindow$loop$slambda_0($entry, this$0) {
  var i = new GameWindow$loop$slambda($entry, this$0);
  var l = function ($completion) {
    return i.fe($completion);
  };
  l.$arity = 0;
  return l;
}
function Cursor_DEFAULT_getInstance() {
  Cursor_initEntries();
  return Cursor_DEFAULT_instance;
}
function Cursor_RESIZE_EAST_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_EAST_instance;
}
function Cursor_RESIZE_WEST_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_WEST_instance;
}
function Cursor_RESIZE_SOUTH_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_SOUTH_instance;
}
function Cursor_RESIZE_NORTH_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_NORTH_instance;
}
function Cursor_RESIZE_NORTH_EAST_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_NORTH_EAST_instance;
}
function Cursor_RESIZE_NORTH_WEST_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_NORTH_WEST_instance;
}
function Cursor_RESIZE_SOUTH_EAST_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_SOUTH_EAST_instance;
}
function Cursor_RESIZE_SOUTH_WEST_getInstance() {
  Cursor_initEntries();
  return Cursor_RESIZE_SOUTH_WEST_instance;
}
function Quality_PERFORMANCE_getInstance() {
  Quality_initEntries();
  return Quality_PERFORMANCE_instance;
}
function Quality_AUTOMATIC_getInstance() {
  Quality_initEntries();
  return Quality_AUTOMATIC_instance;
}
var Companion_instance_69;
function Companion_getInstance_75() {
  if (Companion_instance_69 === VOID)
    new Companion_60();
  return Companion_instance_69;
}
function configure(_this__u8e3s4, size, title, icon, fullscreen, bgcolor) {
  title = title === VOID ? 'GameWindow' : title;
  icon = icon === VOID ? null : icon;
  fullscreen = fullscreen === VOID ? null : fullscreen;
  bgcolor = bgcolor === VOID ? Colors_getInstance().z44_1 : bgcolor;
  _this__u8e3s4.f8x(numberToInt(size.m2e_1), numberToInt(size.n2e_1));
  if (!(title == null)) {
    _this__u8e3s4.w8w(title);
  }
  _this__u8e3s4.x8w(icon);
  if (!(fullscreen == null)) {
    _this__u8e3s4.y8w(fullscreen);
  }
  _this__u8e3s4.a8x(bgcolor);
  _this__u8e3s4.z8w(true);
}
function fpsCached$factory() {
  return getPropertyCallableRef('fpsCached', 1, KProperty1, function (receiver) {
    return _get_fpsCached__581dty(receiver);
  }, null);
}
function continuousRenderMode$factory() {
  return getPropertyCallableRef('continuousRenderMode', 1, KMutableProperty1, function (receiver) {
    return receiver.m8x();
  }, function (receiver, value) {
    return receiver.l8x(value);
  });
}
function continuousRenderMode$factory_0() {
  return getPropertyCallableRef('continuousRenderMode', 1, KMutableProperty1, function (receiver) {
    return receiver.m8x();
  }, function (receiver, value) {
    return receiver.l8x(value);
  });
}
var Companion_instance_70;
function Companion_getInstance_76() {
  if (Companion_instance_70 === VOID)
    new Companion_61();
  return Companion_instance_70;
}
function GameWindowCoroutineDispatcher$_init_$lambda_ooms1e() {
  return new FastDuration(PerformanceCounter_getInstance().l6j());
}
function GameWindowCoroutineDispatcher$timedTasks$lambda(a, b) {
  return FastDuration__compareTo_impl_4fhnj7(a.p8y_1, b.p8y_1);
}
function GameWindowCoroutineDispatcher$scheduleResumeAfterDelay$lambda($task) {
  return function (it) {
    $task.s8y_1 = it;
    return Unit_instance;
  };
}
function GameWindowCoroutineDispatcher$invokeOnTimeout$lambda(this$0, $task) {
  return function () {
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke' call
    // Inline function 'kotlinx.atomicfu.locks.synchronized' call
    this$0.h8w_1.w1z_1;
    // Inline function 'korlibs.concurrent.lock.NonRecursiveLock.invoke.<anonymous>' call
    this$0.g8w_1.k2u($task);
    return Unit_instance;
  };
}
function SyncEventLoopCoroutineDispatcher$dispatch$lambda($block) {
  return function () {
    $block.e1d();
    return Unit_instance;
  };
}
function SyncEventLoopCoroutineDispatcher$scheduleResumeAfterDelay$lambda($cancelled) {
  return function (it) {
    $cancelled._v = it;
    return Unit_instance;
  };
}
function SyncEventLoopCoroutineDispatcher$scheduleResumeAfterDelay$lambda_0($cancelled, $continuation) {
  return function () {
    var tmp;
    if (!($cancelled._v == null)) {
      // Inline function 'kotlin.coroutines.resumeWithException' call
      var this_0 = $continuation;
      // Inline function 'kotlin.Companion.failure' call
      var exception = ensureNotNull($cancelled._v);
      var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
      this_0.ed(tmp$ret$0);
      tmp = Unit_instance;
    } else {
      // Inline function 'kotlin.coroutines.resume' call
      var this_1 = $continuation;
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$2 = _Result___init__impl__xyqfz8(Unit_instance);
      this_1.ed(tmp$ret$2);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function SyncEventLoopCoroutineDispatcher$invokeOnTimeout$lambda($block) {
  return function () {
    $block.e1d();
    return Unit_instance;
  };
}
var Companion_instance_71;
function Companion_getInstance_77() {
  return Companion_instance_71;
}
var korgwJvmEngine;
function get_SDLPath() {
  _init_properties_SDL_kt__pqu7sn();
  // Inline function 'kotlin.getValue' call
  var this_0 = SDLPath$delegate;
  SDLPath$factory();
  return this_0.u1();
}
var SDLPath$delegate;
var Companion_instance_72;
function Companion_getInstance_78() {
  return Companion_instance_72;
}
var Companion_instance_73;
function Companion_getInstance_79() {
  return Companion_instance_73;
}
function SDLPath$delegate$lambda() {
  _init_properties_SDL_kt__pqu7sn();
  return Companion_getInstance_3().sw() ? '/Library/Frameworks/SDL2.framework/SDL2' : 'SDL2.dll';
}
function SDLPath$factory() {
  return getPropertyCallableRef('SDLPath', 0, KProperty0, function () {
    return get_SDLPath();
  }, null);
}
function SDL_Init$factory() {
  return getPropertyCallableRef('SDL_Init', 1, KProperty1, function (receiver) {
    return receiver.k90();
  }, null);
}
function SDL_CreateWindow$factory() {
  return getPropertyCallableRef('SDL_CreateWindow', 1, KProperty1, function (receiver) {
    return receiver.l90();
  }, null);
}
function SDL_SetWindowTitle$factory() {
  return getPropertyCallableRef('SDL_SetWindowTitle', 1, KProperty1, function (receiver) {
    return receiver.m90();
  }, null);
}
function SDL_SetWindowSize$factory() {
  return getPropertyCallableRef('SDL_SetWindowSize', 1, KProperty1, function (receiver) {
    return receiver.n90();
  }, null);
}
function SDL_SetWindowPosition$factory() {
  return getPropertyCallableRef('SDL_SetWindowPosition', 1, KProperty1, function (receiver) {
    return receiver.o90();
  }, null);
}
function SDL_ShowWindow$factory() {
  return getPropertyCallableRef('SDL_ShowWindow', 1, KProperty1, function (receiver) {
    return receiver.p90();
  }, null);
}
function SDL_RaiseWindow$factory() {
  return getPropertyCallableRef('SDL_RaiseWindow', 1, KProperty1, function (receiver) {
    return receiver.q90();
  }, null);
}
function SDL_PollEvent$factory() {
  return getPropertyCallableRef('SDL_PollEvent', 1, KProperty1, function (receiver) {
    return receiver.r90();
  }, null);
}
function SDL_Quit$factory() {
  return getPropertyCallableRef('SDL_Quit', 1, KProperty1, function (receiver) {
    return receiver.s90();
  }, null);
}
function SDL_GL_CreateContext$factory() {
  return getPropertyCallableRef('SDL_GL_CreateContext', 1, KProperty1, function (receiver) {
    return receiver.t90();
  }, null);
}
function SDL_GL_DeleteContext$factory() {
  return getPropertyCallableRef('SDL_GL_DeleteContext', 1, KProperty1, function (receiver) {
    return receiver.u90();
  }, null);
}
function SDL_GL_MakeCurrent$factory() {
  return getPropertyCallableRef('SDL_GL_MakeCurrent', 1, KProperty1, function (receiver) {
    return receiver.v90();
  }, null);
}
function SDL_GL_SwapWindow$factory() {
  return getPropertyCallableRef('SDL_GL_SwapWindow', 1, KProperty1, function (receiver) {
    return receiver.w90();
  }, null);
}
function SDL_Init$factory_0() {
  return getPropertyCallableRef('SDL_Init', 1, KProperty1, function (receiver) {
    return receiver.k90();
  }, null);
}
function SDL_CreateWindow$factory_0() {
  return getPropertyCallableRef('SDL_CreateWindow', 1, KProperty1, function (receiver) {
    return receiver.l90();
  }, null);
}
function SDL_SetWindowTitle$factory_0() {
  return getPropertyCallableRef('SDL_SetWindowTitle', 1, KProperty1, function (receiver) {
    return receiver.m90();
  }, null);
}
function SDL_SetWindowSize$factory_0() {
  return getPropertyCallableRef('SDL_SetWindowSize', 1, KProperty1, function (receiver) {
    return receiver.n90();
  }, null);
}
function SDL_SetWindowPosition$factory_0() {
  return getPropertyCallableRef('SDL_SetWindowPosition', 1, KProperty1, function (receiver) {
    return receiver.o90();
  }, null);
}
function SDL_ShowWindow$factory_0() {
  return getPropertyCallableRef('SDL_ShowWindow', 1, KProperty1, function (receiver) {
    return receiver.p90();
  }, null);
}
function SDL_RaiseWindow$factory_0() {
  return getPropertyCallableRef('SDL_RaiseWindow', 1, KProperty1, function (receiver) {
    return receiver.q90();
  }, null);
}
function SDL_PollEvent$factory_0() {
  return getPropertyCallableRef('SDL_PollEvent', 1, KProperty1, function (receiver) {
    return receiver.r90();
  }, null);
}
function SDL_Quit$factory_0() {
  return getPropertyCallableRef('SDL_Quit', 1, KProperty1, function (receiver) {
    return receiver.s90();
  }, null);
}
function SDL_GL_CreateContext$factory_0() {
  return getPropertyCallableRef('SDL_GL_CreateContext', 1, KProperty1, function (receiver) {
    return receiver.t90();
  }, null);
}
function SDL_GL_DeleteContext$factory_0() {
  return getPropertyCallableRef('SDL_GL_DeleteContext', 1, KProperty1, function (receiver) {
    return receiver.u90();
  }, null);
}
function SDL_GL_MakeCurrent$factory_0() {
  return getPropertyCallableRef('SDL_GL_MakeCurrent', 1, KProperty1, function (receiver) {
    return receiver.v90();
  }, null);
}
function SDL_GL_SwapWindow$factory_0() {
  return getPropertyCallableRef('SDL_GL_SwapWindow', 1, KProperty1, function (receiver) {
    return receiver.w90();
  }, null);
}
function glDrawArraysInstanced$factory() {
  return getPropertyCallableRef('glDrawArraysInstanced', 1, KProperty1, function (receiver) {
    return receiver.k9a();
  }, null);
}
function glDrawElementsInstanced$factory() {
  return getPropertyCallableRef('glDrawElementsInstanced', 1, KProperty1, function (receiver) {
    return receiver.l9a();
  }, null);
}
function glVertexAttribDivisor$factory() {
  return getPropertyCallableRef('glVertexAttribDivisor', 1, KProperty1, function (receiver) {
    return receiver.m9a();
  }, null);
}
function glTexSubImage2D$factory() {
  return getPropertyCallableRef('glTexSubImage2D', 1, KProperty1, function (receiver) {
    return receiver.t9a();
  }, null);
}
function glTexImage2D$factory() {
  return getPropertyCallableRef('glTexImage2D', 1, KProperty1, function (receiver) {
    return receiver.t99();
  }, null);
}
function glTexParameteri$factory() {
  return getPropertyCallableRef('glTexParameteri', 1, KProperty1, function (receiver) {
    return receiver.u99();
  }, null);
}
function glTexParameterf$factory() {
  return getPropertyCallableRef('glTexParameterf', 1, KProperty1, function (receiver) {
    return receiver.u9a();
  }, null);
}
function glTexParameterfv$factory() {
  return getPropertyCallableRef('glTexParameterfv', 1, KProperty1, function (receiver) {
    return receiver.v9a();
  }, null);
}
function glTexParameteriv$factory() {
  return getPropertyCallableRef('glTexParameteriv', 1, KProperty1, function (receiver) {
    return receiver.w9a();
  }, null);
}
function glStencilOp$factory() {
  return getPropertyCallableRef('glStencilOp', 1, KProperty1, function (receiver) {
    return receiver.r99();
  }, null);
}
function glStencilMask$factory() {
  return getPropertyCallableRef('glStencilMask', 1, KProperty1, function (receiver) {
    return receiver.p99();
  }, null);
}
function glReadPixels$factory() {
  return getPropertyCallableRef('glReadPixels', 1, KProperty1, function (receiver) {
    return receiver.j99();
  }, null);
}
function glStencilFunc$factory() {
  return getPropertyCallableRef('glStencilFunc', 1, KProperty1, function (receiver) {
    return receiver.n99();
  }, null);
}
function glScissor$factory() {
  return getPropertyCallableRef('glScissor', 1, KProperty1, function (receiver) {
    return receiver.l99();
  }, null);
}
function glPolygonOffset$factory() {
  return getPropertyCallableRef('glPolygonOffset', 1, KProperty1, function (receiver) {
    return receiver.x9a();
  }, null);
}
function glPixelStorei$factory() {
  return getPropertyCallableRef('glPixelStorei', 1, KProperty1, function (receiver) {
    return receiver.i99();
  }, null);
}
function glLineWidth$factory() {
  return getPropertyCallableRef('glLineWidth', 1, KProperty1, function (receiver) {
    return receiver.y9a();
  }, null);
}
function glGetTexParameterfv$factory() {
  return getPropertyCallableRef('glGetTexParameterfv', 1, KProperty1, function (receiver) {
    return receiver.z9a();
  }, null);
}
function glGetTexParameteriv$factory() {
  return getPropertyCallableRef('glGetTexParameteriv', 1, KProperty1, function (receiver) {
    return receiver.a9b();
  }, null);
}
function glGetError$factory() {
  return getPropertyCallableRef('glGetError', 1, KProperty1, function (receiver) {
    return receiver.b99();
  }, null);
}
function glGetFloatv$factory() {
  return getPropertyCallableRef('glGetFloatv', 1, KProperty1, function (receiver) {
    return receiver.b9b();
  }, null);
}
function glGetIntegerv$factory() {
  return getPropertyCallableRef('glGetIntegerv', 1, KProperty1, function (receiver) {
    return receiver.c99();
  }, null);
}
function glGetBooleanv$factory() {
  return getPropertyCallableRef('glGetBooleanv', 1, KProperty1, function (receiver) {
    return receiver.c9b();
  }, null);
}
function glGenTextures$factory() {
  return getPropertyCallableRef('glGenTextures', 1, KProperty1, function (receiver) {
    return receiver.z98();
  }, null);
}
function glDepthRange$factory() {
  return getPropertyCallableRef('glDepthRange', 1, KProperty1, function (receiver) {
    return receiver.d9b();
  }, null);
}
function glDepthRangef$factory() {
  return getPropertyCallableRef('glDepthRangef', 1, KProperty1, function (receiver) {
    return receiver.k98();
  }, null);
}
function glClearDepth$factory() {
  return getPropertyCallableRef('glClearDepth', 1, KProperty1, function (receiver) {
    return receiver.e9b();
  }, null);
}
function glClearDepthf$factory() {
  return getPropertyCallableRef('glClearDepthf', 1, KProperty1, function (receiver) {
    return receiver.v97();
  }, null);
}
function glDrawArrays$factory() {
  return getPropertyCallableRef('glDrawArrays', 1, KProperty1, function (receiver) {
    return receiver.n98();
  }, null);
}
function glDrawElements$factory() {
  return getPropertyCallableRef('glDrawElements', 1, KProperty1, function (receiver) {
    return receiver.o98();
  }, null);
}
function glFrontFace$factory() {
  return getPropertyCallableRef('glFrontFace', 1, KProperty1, function (receiver) {
    return receiver.u98();
  }, null);
}
function glFinish$factory() {
  return getPropertyCallableRef('glFinish', 1, KProperty1, function (receiver) {
    return receiver.f9b();
  }, null);
}
function glFlush$factory() {
  return getPropertyCallableRef('glFlush', 1, KProperty1, function (receiver) {
    return receiver.r98();
  }, null);
}
function glEnable$factory() {
  return getPropertyCallableRef('glEnable', 1, KProperty1, function (receiver) {
    return receiver.p98();
  }, null);
}
function glIsEnabled$factory() {
  return getPropertyCallableRef('glIsEnabled', 1, KProperty1, function (receiver) {
    return receiver.g9b();
  }, null);
}
function glDisable$factory() {
  return getPropertyCallableRef('glDisable', 1, KProperty1, function (receiver) {
    return receiver.l98();
  }, null);
}
function glDepthMask$factory() {
  return getPropertyCallableRef('glDepthMask', 1, KProperty1, function (receiver) {
    return receiver.j98();
  }, null);
}
function glDepthFunc$factory() {
  return getPropertyCallableRef('glDepthFunc', 1, KProperty1, function (receiver) {
    return receiver.i98();
  }, null);
}
function glDeleteTextures$factory() {
  return getPropertyCallableRef('glDeleteTextures', 1, KProperty1, function (receiver) {
    return receiver.h98();
  }, null);
}
function glCullFace$factory() {
  return getPropertyCallableRef('glCullFace', 1, KProperty1, function (receiver) {
    return receiver.b98();
  }, null);
}
function glCopyTexImage2D$factory() {
  return getPropertyCallableRef('glCopyTexImage2D', 1, KProperty1, function (receiver) {
    return receiver.h9b();
  }, null);
}
function glCopyTexSubImage2D$factory() {
  return getPropertyCallableRef('glCopyTexSubImage2D', 1, KProperty1, function (receiver) {
    return receiver.i9b();
  }, null);
}
function glColorMask$factory() {
  return getPropertyCallableRef('glColorMask', 1, KProperty1, function (receiver) {
    return receiver.x97();
  }, null);
}
function glClearStencil$factory() {
  return getPropertyCallableRef('glClearStencil', 1, KProperty1, function (receiver) {
    return receiver.w97();
  }, null);
}
function glClearColor$factory() {
  return getPropertyCallableRef('glClearColor', 1, KProperty1, function (receiver) {
    return receiver.u97();
  }, null);
}
function glClear$factory() {
  return getPropertyCallableRef('glClear', 1, KProperty1, function (receiver) {
    return receiver.t97();
  }, null);
}
function glBindTexture$factory() {
  return getPropertyCallableRef('glBindTexture', 1, KProperty1, function (receiver) {
    return receiver.o97();
  }, null);
}
function glHint$factory() {
  return getPropertyCallableRef('glHint', 1, KProperty1, function (receiver) {
    return receiver.j9b();
  }, null);
}
function glViewport$factory() {
  return getPropertyCallableRef('glViewport', 1, KProperty1, function (receiver) {
    return receiver.j9a();
  }, null);
}
function glGetString$factory() {
  return getPropertyCallableRef('glGetString', 1, KProperty1, function (receiver) {
    return receiver.g99();
  }, null);
}
function glGetStringi$factory() {
  return getPropertyCallableRef('glGetStringi', 1, KProperty1, function (receiver) {
    return receiver.k9b();
  }, null);
}
function glVertexAttribPointer$factory() {
  return getPropertyCallableRef('glVertexAttribPointer', 1, KProperty1, function (receiver) {
    return receiver.i9a();
  }, null);
}
function glVertexAttrib4fv$factory() {
  return getPropertyCallableRef('glVertexAttrib4fv', 1, KProperty1, function (receiver) {
    return receiver.l9b();
  }, null);
}
function glActiveTexture$factory() {
  return getPropertyCallableRef('glActiveTexture', 1, KProperty1, function (receiver) {
    return receiver.i97();
  }, null);
}
function glAttachShader$factory() {
  return getPropertyCallableRef('glAttachShader', 1, KProperty1, function (receiver) {
    return receiver.j97();
  }, null);
}
function glBindAttribLocation$factory() {
  return getPropertyCallableRef('glBindAttribLocation', 1, KProperty1, function (receiver) {
    return receiver.k97();
  }, null);
}
function glBindBuffer$factory() {
  return getPropertyCallableRef('glBindBuffer', 1, KProperty1, function (receiver) {
    return receiver.l97();
  }, null);
}
function glBindFramebuffer$factory() {
  return getPropertyCallableRef('glBindFramebuffer', 1, KProperty1, function (receiver) {
    return receiver.m97();
  }, null);
}
function glBindRenderbuffer$factory() {
  return getPropertyCallableRef('glBindRenderbuffer', 1, KProperty1, function (receiver) {
    return receiver.n97();
  }, null);
}
function glBlendColor$factory() {
  return getPropertyCallableRef('glBlendColor', 1, KProperty1, function (receiver) {
    return receiver.m9b();
  }, null);
}
function glBlendEquation$factory() {
  return getPropertyCallableRef('glBlendEquation', 1, KProperty1, function (receiver) {
    return receiver.n9b();
  }, null);
}
function glBlendEquationSeparate$factory() {
  return getPropertyCallableRef('glBlendEquationSeparate', 1, KProperty1, function (receiver) {
    return receiver.p97();
  }, null);
}
function glBlendFunc$factory() {
  return getPropertyCallableRef('glBlendFunc', 1, KProperty1, function (receiver) {
    return receiver.o9b();
  }, null);
}
function glBlendFuncSeparate$factory() {
  return getPropertyCallableRef('glBlendFuncSeparate', 1, KProperty1, function (receiver) {
    return receiver.q97();
  }, null);
}
function glBufferData$factory() {
  return getPropertyCallableRef('glBufferData', 1, KProperty1, function (receiver) {
    return receiver.r97();
  }, null);
}
function glBufferSubData$factory() {
  return getPropertyCallableRef('glBufferSubData', 1, KProperty1, function (receiver) {
    return receiver.s97();
  }, null);
}
function glCheckFramebufferStatus$factory() {
  return getPropertyCallableRef('glCheckFramebufferStatus', 1, KProperty1, function (receiver) {
    return receiver.p9b();
  }, null);
}
function glCompileShader$factory() {
  return getPropertyCallableRef('glCompileShader', 1, KProperty1, function (receiver) {
    return receiver.y97();
  }, null);
}
function glCompressedTexImage2D$factory() {
  return getPropertyCallableRef('glCompressedTexImage2D', 1, KProperty1, function (receiver) {
    return receiver.q9b();
  }, null);
}
function glCompressedTexSubImage2D$factory() {
  return getPropertyCallableRef('glCompressedTexSubImage2D', 1, KProperty1, function (receiver) {
    return receiver.r9b();
  }, null);
}
function glCreateProgram$factory() {
  return getPropertyCallableRef('glCreateProgram', 1, KProperty1, function (receiver) {
    return receiver.z97();
  }, null);
}
function glCreateShader$factory() {
  return getPropertyCallableRef('glCreateShader', 1, KProperty1, function (receiver) {
    return receiver.a98();
  }, null);
}
function glDeleteBuffers$factory() {
  return getPropertyCallableRef('glDeleteBuffers', 1, KProperty1, function (receiver) {
    return receiver.c98();
  }, null);
}
function glDeleteFramebuffers$factory() {
  return getPropertyCallableRef('glDeleteFramebuffers', 1, KProperty1, function (receiver) {
    return receiver.d98();
  }, null);
}
function glDeleteProgram$factory() {
  return getPropertyCallableRef('glDeleteProgram', 1, KProperty1, function (receiver) {
    return receiver.e98();
  }, null);
}
function glDeleteRenderbuffers$factory() {
  return getPropertyCallableRef('glDeleteRenderbuffers', 1, KProperty1, function (receiver) {
    return receiver.f98();
  }, null);
}
function glDeleteShader$factory() {
  return getPropertyCallableRef('glDeleteShader', 1, KProperty1, function (receiver) {
    return receiver.g98();
  }, null);
}
function glDetachShader$factory() {
  return getPropertyCallableRef('glDetachShader', 1, KProperty1, function (receiver) {
    return receiver.s9b();
  }, null);
}
function glDisableVertexAttribArray$factory() {
  return getPropertyCallableRef('glDisableVertexAttribArray', 1, KProperty1, function (receiver) {
    return receiver.m98();
  }, null);
}
function glEnableVertexAttribArray$factory() {
  return getPropertyCallableRef('glEnableVertexAttribArray', 1, KProperty1, function (receiver) {
    return receiver.q98();
  }, null);
}
function glFramebufferRenderbuffer$factory() {
  return getPropertyCallableRef('glFramebufferRenderbuffer', 1, KProperty1, function (receiver) {
    return receiver.s98();
  }, null);
}
function glFramebufferTexture2D$factory() {
  return getPropertyCallableRef('glFramebufferTexture2D', 1, KProperty1, function (receiver) {
    return receiver.t98();
  }, null);
}
function glGenBuffers$factory() {
  return getPropertyCallableRef('glGenBuffers', 1, KProperty1, function (receiver) {
    return receiver.v98();
  }, null);
}
function glGenerateMipmap$factory() {
  return getPropertyCallableRef('glGenerateMipmap', 1, KProperty1, function (receiver) {
    return receiver.w98();
  }, null);
}
function glGenFramebuffers$factory() {
  return getPropertyCallableRef('glGenFramebuffers', 1, KProperty1, function (receiver) {
    return receiver.x98();
  }, null);
}
function glGenRenderbuffers$factory() {
  return getPropertyCallableRef('glGenRenderbuffers', 1, KProperty1, function (receiver) {
    return receiver.y98();
  }, null);
}
function glGetActiveAttrib$factory() {
  return getPropertyCallableRef('glGetActiveAttrib', 1, KProperty1, function (receiver) {
    return receiver.t9b();
  }, null);
}
function glGetActiveUniform$factory() {
  return getPropertyCallableRef('glGetActiveUniform', 1, KProperty1, function (receiver) {
    return receiver.u9b();
  }, null);
}
function glGetAttachedShaders$factory() {
  return getPropertyCallableRef('glGetAttachedShaders', 1, KProperty1, function (receiver) {
    return receiver.v9b();
  }, null);
}
function glGetAttribLocation$factory() {
  return getPropertyCallableRef('glGetAttribLocation', 1, KProperty1, function (receiver) {
    return receiver.w9b();
  }, null);
}
function glGetUniformLocation$factory() {
  return getPropertyCallableRef('glGetUniformLocation', 1, KProperty1, function (receiver) {
    return receiver.a99();
  }, null);
}
function glGetBufferParameteriv$factory() {
  return getPropertyCallableRef('glGetBufferParameteriv', 1, KProperty1, function (receiver) {
    return receiver.x9b();
  }, null);
}
function glGetFramebufferAttachmentParameteriv$factory() {
  return getPropertyCallableRef('glGetFramebufferAttachmentParameteriv', 1, KProperty1, function (receiver) {
    return receiver.y9b();
  }, null);
}
function glGetProgramInfoLog$factory() {
  return getPropertyCallableRef('glGetProgramInfoLog', 1, KProperty1, function (receiver) {
    return receiver.z9b();
  }, null);
}
function glGetRenderbufferParameteriv$factory() {
  return getPropertyCallableRef('glGetRenderbufferParameteriv', 1, KProperty1, function (receiver) {
    return receiver.a9c();
  }, null);
}
function glGetProgramiv$factory() {
  return getPropertyCallableRef('glGetProgramiv', 1, KProperty1, function (receiver) {
    return receiver.d99();
  }, null);
}
function glGetShaderiv$factory() {
  return getPropertyCallableRef('glGetShaderiv', 1, KProperty1, function (receiver) {
    return receiver.e99();
  }, null);
}
function glGetShaderInfoLog$factory() {
  return getPropertyCallableRef('glGetShaderInfoLog', 1, KProperty1, function (receiver) {
    return receiver.f99();
  }, null);
}
function glGetShaderPrecisionFormat$factory() {
  return getPropertyCallableRef('glGetShaderPrecisionFormat', 1, KProperty1, function (receiver) {
    return receiver.b9c();
  }, null);
}
function glGetShaderSource$factory() {
  return getPropertyCallableRef('glGetShaderSource', 1, KProperty1, function (receiver) {
    return receiver.c9c();
  }, null);
}
function glGetUniformfv$factory() {
  return getPropertyCallableRef('glGetUniformfv', 1, KProperty1, function (receiver) {
    return receiver.d9c();
  }, null);
}
function glGetUniformiv$factory() {
  return getPropertyCallableRef('glGetUniformiv', 1, KProperty1, function (receiver) {
    return receiver.e9c();
  }, null);
}
function glGetVertexAttribfv$factory() {
  return getPropertyCallableRef('glGetVertexAttribfv', 1, KProperty1, function (receiver) {
    return receiver.f9c();
  }, null);
}
function glGetVertexAttribiv$factory() {
  return getPropertyCallableRef('glGetVertexAttribiv', 1, KProperty1, function (receiver) {
    return receiver.g9c();
  }, null);
}
function glGetVertexAttribPointerv$factory() {
  return getPropertyCallableRef('glGetVertexAttribPointerv', 1, KProperty1, function (receiver) {
    return receiver.h9c();
  }, null);
}
function glIsBuffer$factory() {
  return getPropertyCallableRef('glIsBuffer', 1, KProperty1, function (receiver) {
    return receiver.i9c();
  }, null);
}
function glIsFramebuffer$factory() {
  return getPropertyCallableRef('glIsFramebuffer', 1, KProperty1, function (receiver) {
    return receiver.j9c();
  }, null);
}
function glIsProgram$factory() {
  return getPropertyCallableRef('glIsProgram', 1, KProperty1, function (receiver) {
    return receiver.k9c();
  }, null);
}
function glIsRenderbuffer$factory() {
  return getPropertyCallableRef('glIsRenderbuffer', 1, KProperty1, function (receiver) {
    return receiver.l9c();
  }, null);
}
function glIsTexture$factory() {
  return getPropertyCallableRef('glIsTexture', 1, KProperty1, function (receiver) {
    return receiver.m9c();
  }, null);
}
function glIsShader$factory() {
  return getPropertyCallableRef('glIsShader', 1, KProperty1, function (receiver) {
    return receiver.n9c();
  }, null);
}
function glLinkProgram$factory() {
  return getPropertyCallableRef('glLinkProgram', 1, KProperty1, function (receiver) {
    return receiver.h99();
  }, null);
}
function glReleaseShaderCompiler$factory() {
  return getPropertyCallableRef('glReleaseShaderCompiler', 1, KProperty1, function (receiver) {
    return receiver.o9c();
  }, null);
}
function glRenderbufferStorage$factory() {
  return getPropertyCallableRef('glRenderbufferStorage', 1, KProperty1, function (receiver) {
    return receiver.k99();
  }, null);
}
function glSampleCoverage$factory() {
  return getPropertyCallableRef('glSampleCoverage', 1, KProperty1, function (receiver) {
    return receiver.p9c();
  }, null);
}
function glShaderBinary$factory() {
  return getPropertyCallableRef('glShaderBinary', 1, KProperty1, function (receiver) {
    return receiver.q9c();
  }, null);
}
function glShaderSource$factory() {
  return getPropertyCallableRef('glShaderSource', 1, KProperty1, function (receiver) {
    return receiver.m99();
  }, null);
}
function glStencilFuncSeparate$factory() {
  return getPropertyCallableRef('glStencilFuncSeparate', 1, KProperty1, function (receiver) {
    return receiver.o99();
  }, null);
}
function glStencilMaskSeparate$factory() {
  return getPropertyCallableRef('glStencilMaskSeparate', 1, KProperty1, function (receiver) {
    return receiver.q99();
  }, null);
}
function glStencilOpSeparate$factory() {
  return getPropertyCallableRef('glStencilOpSeparate', 1, KProperty1, function (receiver) {
    return receiver.s99();
  }, null);
}
function glUniform1f$factory() {
  return getPropertyCallableRef('glUniform1f', 1, KProperty1, function (receiver) {
    return receiver.r9c();
  }, null);
}
function glUniform2f$factory() {
  return getPropertyCallableRef('glUniform2f', 1, KProperty1, function (receiver) {
    return receiver.s9c();
  }, null);
}
function glUniform3f$factory() {
  return getPropertyCallableRef('glUniform3f', 1, KProperty1, function (receiver) {
    return receiver.t9c();
  }, null);
}
function glUniform4f$factory() {
  return getPropertyCallableRef('glUniform4f', 1, KProperty1, function (receiver) {
    return receiver.u9c();
  }, null);
}
function glUniform1i$factory() {
  return getPropertyCallableRef('glUniform1i', 1, KProperty1, function (receiver) {
    return receiver.w99();
  }, null);
}
function glUniform2i$factory() {
  return getPropertyCallableRef('glUniform2i', 1, KProperty1, function (receiver) {
    return receiver.v9c();
  }, null);
}
function glUniform3i$factory() {
  return getPropertyCallableRef('glUniform3i', 1, KProperty1, function (receiver) {
    return receiver.w9c();
  }, null);
}
function glUniform4i$factory() {
  return getPropertyCallableRef('glUniform4i', 1, KProperty1, function (receiver) {
    return receiver.x9c();
  }, null);
}
function glUniform1fv$factory() {
  return getPropertyCallableRef('glUniform1fv', 1, KProperty1, function (receiver) {
    return receiver.v99();
  }, null);
}
function glUniform2fv$factory() {
  return getPropertyCallableRef('glUniform2fv', 1, KProperty1, function (receiver) {
    return receiver.y99();
  }, null);
}
function glUniform3fv$factory() {
  return getPropertyCallableRef('glUniform3fv', 1, KProperty1, function (receiver) {
    return receiver.a9a();
  }, null);
}
function glUniform4fv$factory() {
  return getPropertyCallableRef('glUniform4fv', 1, KProperty1, function (receiver) {
    return receiver.c9a();
  }, null);
}
function glUniform1iv$factory() {
  return getPropertyCallableRef('glUniform1iv', 1, KProperty1, function (receiver) {
    return receiver.x99();
  }, null);
}
function glUniform2iv$factory() {
  return getPropertyCallableRef('glUniform2iv', 1, KProperty1, function (receiver) {
    return receiver.z99();
  }, null);
}
function glUniform3iv$factory() {
  return getPropertyCallableRef('glUniform3iv', 1, KProperty1, function (receiver) {
    return receiver.b9a();
  }, null);
}
function glUniform4iv$factory() {
  return getPropertyCallableRef('glUniform4iv', 1, KProperty1, function (receiver) {
    return receiver.d9a();
  }, null);
}
function glUniformMatrix2fv$factory() {
  return getPropertyCallableRef('glUniformMatrix2fv', 1, KProperty1, function (receiver) {
    return receiver.e9a();
  }, null);
}
function glUniformMatrix3fv$factory() {
  return getPropertyCallableRef('glUniformMatrix3fv', 1, KProperty1, function (receiver) {
    return receiver.f9a();
  }, null);
}
function glUniformMatrix4fv$factory() {
  return getPropertyCallableRef('glUniformMatrix4fv', 1, KProperty1, function (receiver) {
    return receiver.g9a();
  }, null);
}
function glUseProgram$factory() {
  return getPropertyCallableRef('glUseProgram', 1, KProperty1, function (receiver) {
    return receiver.h9a();
  }, null);
}
function glValidateProgram$factory() {
  return getPropertyCallableRef('glValidateProgram', 1, KProperty1, function (receiver) {
    return receiver.y9c();
  }, null);
}
function glVertexAttrib1f$factory() {
  return getPropertyCallableRef('glVertexAttrib1f', 1, KProperty1, function (receiver) {
    return receiver.z9c();
  }, null);
}
function glVertexAttrib2f$factory() {
  return getPropertyCallableRef('glVertexAttrib2f', 1, KProperty1, function (receiver) {
    return receiver.a9d();
  }, null);
}
function glVertexAttrib3f$factory() {
  return getPropertyCallableRef('glVertexAttrib3f', 1, KProperty1, function (receiver) {
    return receiver.b9d();
  }, null);
}
function glVertexAttrib4f$factory() {
  return getPropertyCallableRef('glVertexAttrib4f', 1, KProperty1, function (receiver) {
    return receiver.c9d();
  }, null);
}
function glVertexAttrib1fv$factory() {
  return getPropertyCallableRef('glVertexAttrib1fv', 1, KProperty1, function (receiver) {
    return receiver.d9d();
  }, null);
}
function glVertexAttrib2fv$factory() {
  return getPropertyCallableRef('glVertexAttrib2fv', 1, KProperty1, function (receiver) {
    return receiver.e9d();
  }, null);
}
function glVertexAttrib3fv$factory() {
  return getPropertyCallableRef('glVertexAttrib3fv', 1, KProperty1, function (receiver) {
    return receiver.f9d();
  }, null);
}
function glBindBufferRange$factory() {
  return getPropertyCallableRef('glBindBufferRange', 1, KProperty1, function (receiver) {
    return receiver.n9a();
  }, null);
}
function glGetUniformBlockIndex$factory() {
  return getPropertyCallableRef('glGetUniformBlockIndex', 1, KProperty1, function (receiver) {
    return receiver.o9a();
  }, null);
}
function glUniformBlockBinding$factory() {
  return getPropertyCallableRef('glUniformBlockBinding', 1, KProperty1, function (receiver) {
    return receiver.p9a();
  }, null);
}
function glGenVertexArrays$factory() {
  return getPropertyCallableRef('glGenVertexArrays', 1, KProperty1, function (receiver) {
    return receiver.q9a();
  }, null);
}
function glDeleteVertexArrays$factory() {
  return getPropertyCallableRef('glDeleteVertexArrays', 1, KProperty1, function (receiver) {
    return receiver.g9d();
  }, null);
}
function glBindVertexArray$factory() {
  return getPropertyCallableRef('glBindVertexArray', 1, KProperty1, function (receiver) {
    return receiver.r9a();
  }, null);
}
function glDrawArraysInstanced$factory_0() {
  return getPropertyCallableRef('glDrawArraysInstanced', 1, KProperty1, function (receiver) {
    return receiver.k9a();
  }, null);
}
function glDrawElementsInstanced$factory_0() {
  return getPropertyCallableRef('glDrawElementsInstanced', 1, KProperty1, function (receiver) {
    return receiver.l9a();
  }, null);
}
function glVertexAttribDivisor$factory_0() {
  return getPropertyCallableRef('glVertexAttribDivisor', 1, KProperty1, function (receiver) {
    return receiver.m9a();
  }, null);
}
function glTexSubImage2D$factory_0() {
  return getPropertyCallableRef('glTexSubImage2D', 1, KProperty1, function (receiver) {
    return receiver.t9a();
  }, null);
}
function glTexImage2D$factory_0() {
  return getPropertyCallableRef('glTexImage2D', 1, KProperty1, function (receiver) {
    return receiver.t99();
  }, null);
}
function glTexParameteri$factory_0() {
  return getPropertyCallableRef('glTexParameteri', 1, KProperty1, function (receiver) {
    return receiver.u99();
  }, null);
}
function glTexParameterf$factory_0() {
  return getPropertyCallableRef('glTexParameterf', 1, KProperty1, function (receiver) {
    return receiver.u9a();
  }, null);
}
function glTexParameterfv$factory_0() {
  return getPropertyCallableRef('glTexParameterfv', 1, KProperty1, function (receiver) {
    return receiver.v9a();
  }, null);
}
function glTexParameteriv$factory_0() {
  return getPropertyCallableRef('glTexParameteriv', 1, KProperty1, function (receiver) {
    return receiver.w9a();
  }, null);
}
function glStencilOp$factory_0() {
  return getPropertyCallableRef('glStencilOp', 1, KProperty1, function (receiver) {
    return receiver.r99();
  }, null);
}
function glStencilMask$factory_0() {
  return getPropertyCallableRef('glStencilMask', 1, KProperty1, function (receiver) {
    return receiver.p99();
  }, null);
}
function glReadPixels$factory_0() {
  return getPropertyCallableRef('glReadPixels', 1, KProperty1, function (receiver) {
    return receiver.j99();
  }, null);
}
function glStencilFunc$factory_0() {
  return getPropertyCallableRef('glStencilFunc', 1, KProperty1, function (receiver) {
    return receiver.n99();
  }, null);
}
function glScissor$factory_0() {
  return getPropertyCallableRef('glScissor', 1, KProperty1, function (receiver) {
    return receiver.l99();
  }, null);
}
function glPolygonOffset$factory_0() {
  return getPropertyCallableRef('glPolygonOffset', 1, KProperty1, function (receiver) {
    return receiver.x9a();
  }, null);
}
function glPixelStorei$factory_0() {
  return getPropertyCallableRef('glPixelStorei', 1, KProperty1, function (receiver) {
    return receiver.i99();
  }, null);
}
function glLineWidth$factory_0() {
  return getPropertyCallableRef('glLineWidth', 1, KProperty1, function (receiver) {
    return receiver.y9a();
  }, null);
}
function glGetTexParameterfv$factory_0() {
  return getPropertyCallableRef('glGetTexParameterfv', 1, KProperty1, function (receiver) {
    return receiver.z9a();
  }, null);
}
function glGetTexParameteriv$factory_0() {
  return getPropertyCallableRef('glGetTexParameteriv', 1, KProperty1, function (receiver) {
    return receiver.a9b();
  }, null);
}
function glGetError$factory_0() {
  return getPropertyCallableRef('glGetError', 1, KProperty1, function (receiver) {
    return receiver.b99();
  }, null);
}
function glGetFloatv$factory_0() {
  return getPropertyCallableRef('glGetFloatv', 1, KProperty1, function (receiver) {
    return receiver.b9b();
  }, null);
}
function glGetIntegerv$factory_0() {
  return getPropertyCallableRef('glGetIntegerv', 1, KProperty1, function (receiver) {
    return receiver.c99();
  }, null);
}
function glGetBooleanv$factory_0() {
  return getPropertyCallableRef('glGetBooleanv', 1, KProperty1, function (receiver) {
    return receiver.c9b();
  }, null);
}
function glGenTextures$factory_0() {
  return getPropertyCallableRef('glGenTextures', 1, KProperty1, function (receiver) {
    return receiver.z98();
  }, null);
}
function glDepthRange$factory_0() {
  return getPropertyCallableRef('glDepthRange', 1, KProperty1, function (receiver) {
    return receiver.d9b();
  }, null);
}
function glDepthRangef$factory_0() {
  return getPropertyCallableRef('glDepthRangef', 1, KProperty1, function (receiver) {
    return receiver.k98();
  }, null);
}
function glClearDepth$factory_0() {
  return getPropertyCallableRef('glClearDepth', 1, KProperty1, function (receiver) {
    return receiver.e9b();
  }, null);
}
function glClearDepthf$factory_0() {
  return getPropertyCallableRef('glClearDepthf', 1, KProperty1, function (receiver) {
    return receiver.v97();
  }, null);
}
function glDrawArrays$factory_0() {
  return getPropertyCallableRef('glDrawArrays', 1, KProperty1, function (receiver) {
    return receiver.n98();
  }, null);
}
function glDrawElements$factory_0() {
  return getPropertyCallableRef('glDrawElements', 1, KProperty1, function (receiver) {
    return receiver.o98();
  }, null);
}
function glFrontFace$factory_0() {
  return getPropertyCallableRef('glFrontFace', 1, KProperty1, function (receiver) {
    return receiver.u98();
  }, null);
}
function glFinish$factory_0() {
  return getPropertyCallableRef('glFinish', 1, KProperty1, function (receiver) {
    return receiver.f9b();
  }, null);
}
function glFlush$factory_0() {
  return getPropertyCallableRef('glFlush', 1, KProperty1, function (receiver) {
    return receiver.r98();
  }, null);
}
function glEnable$factory_0() {
  return getPropertyCallableRef('glEnable', 1, KProperty1, function (receiver) {
    return receiver.p98();
  }, null);
}
function glIsEnabled$factory_0() {
  return getPropertyCallableRef('glIsEnabled', 1, KProperty1, function (receiver) {
    return receiver.g9b();
  }, null);
}
function glDisable$factory_0() {
  return getPropertyCallableRef('glDisable', 1, KProperty1, function (receiver) {
    return receiver.l98();
  }, null);
}
function glDepthMask$factory_0() {
  return getPropertyCallableRef('glDepthMask', 1, KProperty1, function (receiver) {
    return receiver.j98();
  }, null);
}
function glDepthFunc$factory_0() {
  return getPropertyCallableRef('glDepthFunc', 1, KProperty1, function (receiver) {
    return receiver.i98();
  }, null);
}
function glDeleteTextures$factory_0() {
  return getPropertyCallableRef('glDeleteTextures', 1, KProperty1, function (receiver) {
    return receiver.h98();
  }, null);
}
function glCullFace$factory_0() {
  return getPropertyCallableRef('glCullFace', 1, KProperty1, function (receiver) {
    return receiver.b98();
  }, null);
}
function glCopyTexImage2D$factory_0() {
  return getPropertyCallableRef('glCopyTexImage2D', 1, KProperty1, function (receiver) {
    return receiver.h9b();
  }, null);
}
function glCopyTexSubImage2D$factory_0() {
  return getPropertyCallableRef('glCopyTexSubImage2D', 1, KProperty1, function (receiver) {
    return receiver.i9b();
  }, null);
}
function glColorMask$factory_0() {
  return getPropertyCallableRef('glColorMask', 1, KProperty1, function (receiver) {
    return receiver.x97();
  }, null);
}
function glClearStencil$factory_0() {
  return getPropertyCallableRef('glClearStencil', 1, KProperty1, function (receiver) {
    return receiver.w97();
  }, null);
}
function glClearColor$factory_0() {
  return getPropertyCallableRef('glClearColor', 1, KProperty1, function (receiver) {
    return receiver.u97();
  }, null);
}
function glClear$factory_0() {
  return getPropertyCallableRef('glClear', 1, KProperty1, function (receiver) {
    return receiver.t97();
  }, null);
}
function glBindTexture$factory_0() {
  return getPropertyCallableRef('glBindTexture', 1, KProperty1, function (receiver) {
    return receiver.o97();
  }, null);
}
function glHint$factory_0() {
  return getPropertyCallableRef('glHint', 1, KProperty1, function (receiver) {
    return receiver.j9b();
  }, null);
}
function glViewport$factory_0() {
  return getPropertyCallableRef('glViewport', 1, KProperty1, function (receiver) {
    return receiver.j9a();
  }, null);
}
function glGetString$factory_0() {
  return getPropertyCallableRef('glGetString', 1, KProperty1, function (receiver) {
    return receiver.g99();
  }, null);
}
function glGetStringi$factory_0() {
  return getPropertyCallableRef('glGetStringi', 1, KProperty1, function (receiver) {
    return receiver.k9b();
  }, null);
}
function glVertexAttribPointer$factory_0() {
  return getPropertyCallableRef('glVertexAttribPointer', 1, KProperty1, function (receiver) {
    return receiver.i9a();
  }, null);
}
function glVertexAttrib4fv$factory_0() {
  return getPropertyCallableRef('glVertexAttrib4fv', 1, KProperty1, function (receiver) {
    return receiver.l9b();
  }, null);
}
function glActiveTexture$factory_0() {
  return getPropertyCallableRef('glActiveTexture', 1, KProperty1, function (receiver) {
    return receiver.i97();
  }, null);
}
function glAttachShader$factory_0() {
  return getPropertyCallableRef('glAttachShader', 1, KProperty1, function (receiver) {
    return receiver.j97();
  }, null);
}
function glBindAttribLocation$factory_0() {
  return getPropertyCallableRef('glBindAttribLocation', 1, KProperty1, function (receiver) {
    return receiver.k97();
  }, null);
}
function glBindBuffer$factory_0() {
  return getPropertyCallableRef('glBindBuffer', 1, KProperty1, function (receiver) {
    return receiver.l97();
  }, null);
}
function glBindFramebuffer$factory_0() {
  return getPropertyCallableRef('glBindFramebuffer', 1, KProperty1, function (receiver) {
    return receiver.m97();
  }, null);
}
function glBindRenderbuffer$factory_0() {
  return getPropertyCallableRef('glBindRenderbuffer', 1, KProperty1, function (receiver) {
    return receiver.n97();
  }, null);
}
function glBlendColor$factory_0() {
  return getPropertyCallableRef('glBlendColor', 1, KProperty1, function (receiver) {
    return receiver.m9b();
  }, null);
}
function glBlendEquation$factory_0() {
  return getPropertyCallableRef('glBlendEquation', 1, KProperty1, function (receiver) {
    return receiver.n9b();
  }, null);
}
function glBlendEquationSeparate$factory_0() {
  return getPropertyCallableRef('glBlendEquationSeparate', 1, KProperty1, function (receiver) {
    return receiver.p97();
  }, null);
}
function glBlendFunc$factory_0() {
  return getPropertyCallableRef('glBlendFunc', 1, KProperty1, function (receiver) {
    return receiver.o9b();
  }, null);
}
function glBlendFuncSeparate$factory_0() {
  return getPropertyCallableRef('glBlendFuncSeparate', 1, KProperty1, function (receiver) {
    return receiver.q97();
  }, null);
}
function glBufferData$factory_0() {
  return getPropertyCallableRef('glBufferData', 1, KProperty1, function (receiver) {
    return receiver.r97();
  }, null);
}
function glBufferSubData$factory_0() {
  return getPropertyCallableRef('glBufferSubData', 1, KProperty1, function (receiver) {
    return receiver.s97();
  }, null);
}
function glCheckFramebufferStatus$factory_0() {
  return getPropertyCallableRef('glCheckFramebufferStatus', 1, KProperty1, function (receiver) {
    return receiver.p9b();
  }, null);
}
function glCompileShader$factory_0() {
  return getPropertyCallableRef('glCompileShader', 1, KProperty1, function (receiver) {
    return receiver.y97();
  }, null);
}
function glCompressedTexImage2D$factory_0() {
  return getPropertyCallableRef('glCompressedTexImage2D', 1, KProperty1, function (receiver) {
    return receiver.q9b();
  }, null);
}
function glCompressedTexSubImage2D$factory_0() {
  return getPropertyCallableRef('glCompressedTexSubImage2D', 1, KProperty1, function (receiver) {
    return receiver.r9b();
  }, null);
}
function glCreateProgram$factory_0() {
  return getPropertyCallableRef('glCreateProgram', 1, KProperty1, function (receiver) {
    return receiver.z97();
  }, null);
}
function glCreateShader$factory_0() {
  return getPropertyCallableRef('glCreateShader', 1, KProperty1, function (receiver) {
    return receiver.a98();
  }, null);
}
function glDeleteBuffers$factory_0() {
  return getPropertyCallableRef('glDeleteBuffers', 1, KProperty1, function (receiver) {
    return receiver.c98();
  }, null);
}
function glDeleteFramebuffers$factory_0() {
  return getPropertyCallableRef('glDeleteFramebuffers', 1, KProperty1, function (receiver) {
    return receiver.d98();
  }, null);
}
function glDeleteProgram$factory_0() {
  return getPropertyCallableRef('glDeleteProgram', 1, KProperty1, function (receiver) {
    return receiver.e98();
  }, null);
}
function glDeleteRenderbuffers$factory_0() {
  return getPropertyCallableRef('glDeleteRenderbuffers', 1, KProperty1, function (receiver) {
    return receiver.f98();
  }, null);
}
function glDeleteShader$factory_0() {
  return getPropertyCallableRef('glDeleteShader', 1, KProperty1, function (receiver) {
    return receiver.g98();
  }, null);
}
function glDetachShader$factory_0() {
  return getPropertyCallableRef('glDetachShader', 1, KProperty1, function (receiver) {
    return receiver.s9b();
  }, null);
}
function glDisableVertexAttribArray$factory_0() {
  return getPropertyCallableRef('glDisableVertexAttribArray', 1, KProperty1, function (receiver) {
    return receiver.m98();
  }, null);
}
function glEnableVertexAttribArray$factory_0() {
  return getPropertyCallableRef('glEnableVertexAttribArray', 1, KProperty1, function (receiver) {
    return receiver.q98();
  }, null);
}
function glFramebufferRenderbuffer$factory_0() {
  return getPropertyCallableRef('glFramebufferRenderbuffer', 1, KProperty1, function (receiver) {
    return receiver.s98();
  }, null);
}
function glFramebufferTexture2D$factory_0() {
  return getPropertyCallableRef('glFramebufferTexture2D', 1, KProperty1, function (receiver) {
    return receiver.t98();
  }, null);
}
function glGenBuffers$factory_0() {
  return getPropertyCallableRef('glGenBuffers', 1, KProperty1, function (receiver) {
    return receiver.v98();
  }, null);
}
function glGenerateMipmap$factory_0() {
  return getPropertyCallableRef('glGenerateMipmap', 1, KProperty1, function (receiver) {
    return receiver.w98();
  }, null);
}
function glGenFramebuffers$factory_0() {
  return getPropertyCallableRef('glGenFramebuffers', 1, KProperty1, function (receiver) {
    return receiver.x98();
  }, null);
}
function glGenRenderbuffers$factory_0() {
  return getPropertyCallableRef('glGenRenderbuffers', 1, KProperty1, function (receiver) {
    return receiver.y98();
  }, null);
}
function glGetActiveAttrib$factory_0() {
  return getPropertyCallableRef('glGetActiveAttrib', 1, KProperty1, function (receiver) {
    return receiver.t9b();
  }, null);
}
function glGetActiveUniform$factory_0() {
  return getPropertyCallableRef('glGetActiveUniform', 1, KProperty1, function (receiver) {
    return receiver.u9b();
  }, null);
}
function glGetAttachedShaders$factory_0() {
  return getPropertyCallableRef('glGetAttachedShaders', 1, KProperty1, function (receiver) {
    return receiver.v9b();
  }, null);
}
function glGetAttribLocation$factory_0() {
  return getPropertyCallableRef('glGetAttribLocation', 1, KProperty1, function (receiver) {
    return receiver.w9b();
  }, null);
}
function glGetUniformLocation$factory_0() {
  return getPropertyCallableRef('glGetUniformLocation', 1, KProperty1, function (receiver) {
    return receiver.a99();
  }, null);
}
function glGetBufferParameteriv$factory_0() {
  return getPropertyCallableRef('glGetBufferParameteriv', 1, KProperty1, function (receiver) {
    return receiver.x9b();
  }, null);
}
function glGetFramebufferAttachmentParameteriv$factory_0() {
  return getPropertyCallableRef('glGetFramebufferAttachmentParameteriv', 1, KProperty1, function (receiver) {
    return receiver.y9b();
  }, null);
}
function glGetProgramInfoLog$factory_0() {
  return getPropertyCallableRef('glGetProgramInfoLog', 1, KProperty1, function (receiver) {
    return receiver.z9b();
  }, null);
}
function glGetRenderbufferParameteriv$factory_0() {
  return getPropertyCallableRef('glGetRenderbufferParameteriv', 1, KProperty1, function (receiver) {
    return receiver.a9c();
  }, null);
}
function glGetProgramiv$factory_0() {
  return getPropertyCallableRef('glGetProgramiv', 1, KProperty1, function (receiver) {
    return receiver.d99();
  }, null);
}
function glGetShaderiv$factory_0() {
  return getPropertyCallableRef('glGetShaderiv', 1, KProperty1, function (receiver) {
    return receiver.e99();
  }, null);
}
function glGetShaderInfoLog$factory_0() {
  return getPropertyCallableRef('glGetShaderInfoLog', 1, KProperty1, function (receiver) {
    return receiver.f99();
  }, null);
}
function glGetShaderPrecisionFormat$factory_0() {
  return getPropertyCallableRef('glGetShaderPrecisionFormat', 1, KProperty1, function (receiver) {
    return receiver.b9c();
  }, null);
}
function glGetShaderSource$factory_0() {
  return getPropertyCallableRef('glGetShaderSource', 1, KProperty1, function (receiver) {
    return receiver.c9c();
  }, null);
}
function glGetUniformfv$factory_0() {
  return getPropertyCallableRef('glGetUniformfv', 1, KProperty1, function (receiver) {
    return receiver.d9c();
  }, null);
}
function glGetUniformiv$factory_0() {
  return getPropertyCallableRef('glGetUniformiv', 1, KProperty1, function (receiver) {
    return receiver.e9c();
  }, null);
}
function glGetVertexAttribfv$factory_0() {
  return getPropertyCallableRef('glGetVertexAttribfv', 1, KProperty1, function (receiver) {
    return receiver.f9c();
  }, null);
}
function glGetVertexAttribiv$factory_0() {
  return getPropertyCallableRef('glGetVertexAttribiv', 1, KProperty1, function (receiver) {
    return receiver.g9c();
  }, null);
}
function glGetVertexAttribPointerv$factory_0() {
  return getPropertyCallableRef('glGetVertexAttribPointerv', 1, KProperty1, function (receiver) {
    return receiver.h9c();
  }, null);
}
function glIsBuffer$factory_0() {
  return getPropertyCallableRef('glIsBuffer', 1, KProperty1, function (receiver) {
    return receiver.i9c();
  }, null);
}
function glIsFramebuffer$factory_0() {
  return getPropertyCallableRef('glIsFramebuffer', 1, KProperty1, function (receiver) {
    return receiver.j9c();
  }, null);
}
function glIsProgram$factory_0() {
  return getPropertyCallableRef('glIsProgram', 1, KProperty1, function (receiver) {
    return receiver.k9c();
  }, null);
}
function glIsRenderbuffer$factory_0() {
  return getPropertyCallableRef('glIsRenderbuffer', 1, KProperty1, function (receiver) {
    return receiver.l9c();
  }, null);
}
function glIsTexture$factory_0() {
  return getPropertyCallableRef('glIsTexture', 1, KProperty1, function (receiver) {
    return receiver.m9c();
  }, null);
}
function glIsShader$factory_0() {
  return getPropertyCallableRef('glIsShader', 1, KProperty1, function (receiver) {
    return receiver.n9c();
  }, null);
}
function glLinkProgram$factory_0() {
  return getPropertyCallableRef('glLinkProgram', 1, KProperty1, function (receiver) {
    return receiver.h99();
  }, null);
}
function glReleaseShaderCompiler$factory_0() {
  return getPropertyCallableRef('glReleaseShaderCompiler', 1, KProperty1, function (receiver) {
    return receiver.o9c();
  }, null);
}
function glRenderbufferStorage$factory_0() {
  return getPropertyCallableRef('glRenderbufferStorage', 1, KProperty1, function (receiver) {
    return receiver.k99();
  }, null);
}
function glSampleCoverage$factory_0() {
  return getPropertyCallableRef('glSampleCoverage', 1, KProperty1, function (receiver) {
    return receiver.p9c();
  }, null);
}
function glShaderBinary$factory_0() {
  return getPropertyCallableRef('glShaderBinary', 1, KProperty1, function (receiver) {
    return receiver.q9c();
  }, null);
}
function glShaderSource$factory_0() {
  return getPropertyCallableRef('glShaderSource', 1, KProperty1, function (receiver) {
    return receiver.m99();
  }, null);
}
function glStencilFuncSeparate$factory_0() {
  return getPropertyCallableRef('glStencilFuncSeparate', 1, KProperty1, function (receiver) {
    return receiver.o99();
  }, null);
}
function glStencilMaskSeparate$factory_0() {
  return getPropertyCallableRef('glStencilMaskSeparate', 1, KProperty1, function (receiver) {
    return receiver.q99();
  }, null);
}
function glStencilOpSeparate$factory_0() {
  return getPropertyCallableRef('glStencilOpSeparate', 1, KProperty1, function (receiver) {
    return receiver.s99();
  }, null);
}
function glUniform1f$factory_0() {
  return getPropertyCallableRef('glUniform1f', 1, KProperty1, function (receiver) {
    return receiver.r9c();
  }, null);
}
function glUniform2f$factory_0() {
  return getPropertyCallableRef('glUniform2f', 1, KProperty1, function (receiver) {
    return receiver.s9c();
  }, null);
}
function glUniform3f$factory_0() {
  return getPropertyCallableRef('glUniform3f', 1, KProperty1, function (receiver) {
    return receiver.t9c();
  }, null);
}
function glUniform4f$factory_0() {
  return getPropertyCallableRef('glUniform4f', 1, KProperty1, function (receiver) {
    return receiver.u9c();
  }, null);
}
function glUniform1i$factory_0() {
  return getPropertyCallableRef('glUniform1i', 1, KProperty1, function (receiver) {
    return receiver.w99();
  }, null);
}
function glUniform2i$factory_0() {
  return getPropertyCallableRef('glUniform2i', 1, KProperty1, function (receiver) {
    return receiver.v9c();
  }, null);
}
function glUniform3i$factory_0() {
  return getPropertyCallableRef('glUniform3i', 1, KProperty1, function (receiver) {
    return receiver.w9c();
  }, null);
}
function glUniform4i$factory_0() {
  return getPropertyCallableRef('glUniform4i', 1, KProperty1, function (receiver) {
    return receiver.x9c();
  }, null);
}
function glUniform1fv$factory_0() {
  return getPropertyCallableRef('glUniform1fv', 1, KProperty1, function (receiver) {
    return receiver.v99();
  }, null);
}
function glUniform2fv$factory_0() {
  return getPropertyCallableRef('glUniform2fv', 1, KProperty1, function (receiver) {
    return receiver.y99();
  }, null);
}
function glUniform3fv$factory_0() {
  return getPropertyCallableRef('glUniform3fv', 1, KProperty1, function (receiver) {
    return receiver.a9a();
  }, null);
}
function glUniform4fv$factory_0() {
  return getPropertyCallableRef('glUniform4fv', 1, KProperty1, function (receiver) {
    return receiver.c9a();
  }, null);
}
function glUniform1iv$factory_0() {
  return getPropertyCallableRef('glUniform1iv', 1, KProperty1, function (receiver) {
    return receiver.x99();
  }, null);
}
function glUniform2iv$factory_0() {
  return getPropertyCallableRef('glUniform2iv', 1, KProperty1, function (receiver) {
    return receiver.z99();
  }, null);
}
function glUniform3iv$factory_0() {
  return getPropertyCallableRef('glUniform3iv', 1, KProperty1, function (receiver) {
    return receiver.b9a();
  }, null);
}
function glUniform4iv$factory_0() {
  return getPropertyCallableRef('glUniform4iv', 1, KProperty1, function (receiver) {
    return receiver.d9a();
  }, null);
}
function glUniformMatrix2fv$factory_0() {
  return getPropertyCallableRef('glUniformMatrix2fv', 1, KProperty1, function (receiver) {
    return receiver.e9a();
  }, null);
}
function glUniformMatrix3fv$factory_0() {
  return getPropertyCallableRef('glUniformMatrix3fv', 1, KProperty1, function (receiver) {
    return receiver.f9a();
  }, null);
}
function glUniformMatrix4fv$factory_0() {
  return getPropertyCallableRef('glUniformMatrix4fv', 1, KProperty1, function (receiver) {
    return receiver.g9a();
  }, null);
}
function glUseProgram$factory_0() {
  return getPropertyCallableRef('glUseProgram', 1, KProperty1, function (receiver) {
    return receiver.h9a();
  }, null);
}
function glValidateProgram$factory_0() {
  return getPropertyCallableRef('glValidateProgram', 1, KProperty1, function (receiver) {
    return receiver.y9c();
  }, null);
}
function glVertexAttrib1f$factory_0() {
  return getPropertyCallableRef('glVertexAttrib1f', 1, KProperty1, function (receiver) {
    return receiver.z9c();
  }, null);
}
function glVertexAttrib2f$factory_0() {
  return getPropertyCallableRef('glVertexAttrib2f', 1, KProperty1, function (receiver) {
    return receiver.a9d();
  }, null);
}
function glVertexAttrib3f$factory_0() {
  return getPropertyCallableRef('glVertexAttrib3f', 1, KProperty1, function (receiver) {
    return receiver.b9d();
  }, null);
}
function glVertexAttrib4f$factory_0() {
  return getPropertyCallableRef('glVertexAttrib4f', 1, KProperty1, function (receiver) {
    return receiver.c9d();
  }, null);
}
function glVertexAttrib1fv$factory_0() {
  return getPropertyCallableRef('glVertexAttrib1fv', 1, KProperty1, function (receiver) {
    return receiver.d9d();
  }, null);
}
function glVertexAttrib2fv$factory_0() {
  return getPropertyCallableRef('glVertexAttrib2fv', 1, KProperty1, function (receiver) {
    return receiver.e9d();
  }, null);
}
function glVertexAttrib3fv$factory_0() {
  return getPropertyCallableRef('glVertexAttrib3fv', 1, KProperty1, function (receiver) {
    return receiver.f9d();
  }, null);
}
function glBindBufferRange$factory_0() {
  return getPropertyCallableRef('glBindBufferRange', 1, KProperty1, function (receiver) {
    return receiver.n9a();
  }, null);
}
function glGetUniformBlockIndex$factory_0() {
  return getPropertyCallableRef('glGetUniformBlockIndex', 1, KProperty1, function (receiver) {
    return receiver.o9a();
  }, null);
}
function glUniformBlockBinding$factory_0() {
  return getPropertyCallableRef('glUniformBlockBinding', 1, KProperty1, function (receiver) {
    return receiver.p9a();
  }, null);
}
function glGenVertexArrays$factory_0() {
  return getPropertyCallableRef('glGenVertexArrays', 1, KProperty1, function (receiver) {
    return receiver.q9a();
  }, null);
}
function glDeleteVertexArrays$factory_0() {
  return getPropertyCallableRef('glDeleteVertexArrays', 1, KProperty1, function (receiver) {
    return receiver.g9d();
  }, null);
}
function glBindVertexArray$factory_0() {
  return getPropertyCallableRef('glBindVertexArray', 1, KProperty1, function (receiver) {
    return receiver.r9a();
  }, null);
}
var properties_initialized_SDL_kt_s4ko39;
function _init_properties_SDL_kt__pqu7sn() {
  if (!properties_initialized_SDL_kt_s4ko39) {
    properties_initialized_SDL_kt_s4ko39 = true;
    SDLPath$delegate = lazy(SDLPath$delegate$lambda);
  }
}
var AGOpenglFactory_instance;
function AGOpenglFactory_getInstance() {
  return AGOpenglFactory_instance;
}
function get_korgwCanvasQuery() {
  _init_properties_GlExt_kt__oxmdm();
  // Inline function 'kotlin.getValue' call
  var this_0 = korgwCanvasQuery$delegate;
  korgwCanvasQuery$factory();
  return this_0.u1();
}
var korgwCanvasQuery$delegate;
function jsObject(pairs) {
  _init_properties_GlExt_kt__oxmdm();
  var out = jsEmptyObject();
  var inductionVariable = 0;
  var last = pairs.length;
  while (inductionVariable < last) {
    var _destruct__k2r9zo = pairs[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    var k = _destruct__k2r9zo.ul();
    var v = _destruct__k2r9zo.vl();
    if (!(v == null)) {
      out[k] = v;
    }
  }
  return out;
}
function jsEmptyObject() {
  _init_properties_GlExt_kt__oxmdm();
  return {};
}
function AGDefaultCanvas() {
  _init_properties_GlExt_kt__oxmdm();
  var tmp0_safe_receiver = get_korgwCanvasQuery();
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.graphics.gl.AGDefaultCanvas.<anonymous>' call
    var tmp_0 = document.querySelector(tmp0_safe_receiver);
    tmp = tmp_0 instanceof HTMLCanvasElement ? tmp_0 : THROW_CCE();
  }
  var tmp1_elvis_lhs = tmp;
  var tmp_1;
  if (tmp1_elvis_lhs == null) {
    var tmp_2 = document.createElement('canvas');
    tmp_1 = tmp_2 instanceof HTMLCanvasElement ? tmp_2 : THROW_CCE();
  } else {
    tmp_1 = tmp1_elvis_lhs;
  }
  return tmp_1;
}
function AGWebgl(config, canvas) {
  canvas = canvas === VOID ? AGDefaultCanvas() : canvas;
  _init_properties_GlExt_kt__oxmdm();
  // Inline function 'kotlin.also' call
  var this_0 = AGOpengl.w7j(new KmlGlJsCanvas(canvas, jsObject([to('premultipliedAlpha', false), to('alpha', false), to('stencil', true), to('antialias', config.c78_1)])));
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.graphics.gl.AGWebgl.<anonymous>' call
  // Inline function 'kotlin.js.asDynamic' call
  window.ag = this_0;
  canvas.addEventListener('webglcontextlost', AGWebgl$lambda, false);
  canvas.addEventListener('webglcontextrestored', AGWebgl$lambda_0(this_0), false);
  return this_0;
}
function get_isCanvasCreatedAndHandled() {
  _init_properties_GlExt_kt__oxmdm();
  return get_korgwCanvasQuery() == null;
}
function korgwCanvasQuery$delegate$lambda() {
  _init_properties_GlExt_kt__oxmdm();
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return window.korgwCanvasQuery;
}
function AGWebgl$lambda(e) {
  _init_properties_GlExt_kt__oxmdm();
  e.preventDefault();
  return Unit_instance;
}
function AGWebgl$lambda_0($ag) {
  return function (e) {
    $ag.l6u();
    return Unit_instance;
  };
}
function korgwCanvasQuery$factory() {
  return getPropertyCallableRef('korgwCanvasQuery', 0, KProperty0, function () {
    return get_korgwCanvasQuery();
  }, null);
}
var properties_initialized_GlExt_kt_6pmiss;
function _init_properties_GlExt_kt__oxmdm() {
  if (!properties_initialized_GlExt_kt_6pmiss) {
    properties_initialized_GlExt_kt_6pmiss = true;
    korgwCanvasQuery$delegate = lazy(korgwCanvasQuery$delegate$lambda);
  }
}
function alloc(_this__u8e3s4, $this) {
  if (_this__u8e3s4 === null)
    return 0;
  // Inline function 'kotlin.js.asDynamic' call
  if (_this__u8e3s4.id === undefined) {
    if ($this.v9g_1.g1()) {
      // Inline function 'kotlin.error' call
      var message = 'KmlGlJsCanvas.freeList is empty. (Probably allocating lots of OpenGL objects without releasing them)';
      throw IllegalStateException.l5(toString(message));
    }
    var index = $this.v9g_1.r3($this.v9g_1.e1() - 1 | 0);
    $this.u9g_1[index] = _this__u8e3s4;
    // Inline function 'kotlin.js.asDynamic' call
    _this__u8e3s4.id = index;
  }
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4.id;
}
function get_2(_this__u8e3s4, $this) {
  var tmp;
  if (!(_this__u8e3s4 === 0)) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp = $this.u9g_1[_this__u8e3s4];
  } else {
    tmp = null;
  }
  return tmp;
}
function free(_this__u8e3s4, $this) {
  var tmp;
  if (!(_this__u8e3s4 === 0)) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var out = $this.u9g_1[_this__u8e3s4];
    // Inline function 'kotlin.collections.plusAssign' call
    $this.v9g_1.h(_this__u8e3s4);
    $this.u9g_1[_this__u8e3s4] = null;
    tmp = out;
  } else {
    tmp = null;
  }
  return tmp;
}
function KmlGlJsCanvas$extensions$delegate$lambda(this$0) {
  return function () {
    var tmp0_elvis_lhs = this$0.t9g_1.getSupportedExtensions();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = [];
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return toSet_0(tmp);
  };
}
function KmlGlJsCanvas$isFloatTextureSupported$delegate$lambda(this$0) {
  return function () {
    return this$0.t9g_1.getExtension('OES_texture_float_linear') != null || this$0.t9g_1.getExtension('OES_texture_float') != null || this$0.s9g_1 >= 2;
  };
}
function extensions$factory() {
  return getPropertyCallableRef('extensions', 1, KProperty1, function (receiver) {
    return receiver.j61();
  }, null);
}
function get_KorgeReloadInternal() {
  _init_properties_KorgeReload_getReloadedClass_kt__lithzw();
  return KorgeReloadInternal;
}
var KorgeReloadInternal;
var properties_initialized_KorgeReload_getReloadedClass_kt_tswp16;
function _init_properties_KorgeReload_getReloadedClass_kt__lithzw() {
  if (!properties_initialized_KorgeReload_getReloadedClass_kt_tswp16) {
    properties_initialized_KorgeReload_getReloadedClass_kt_tswp16 = true;
    KorgeReloadInternal = new KorgeReloadInternal$1();
  }
}
function CreateDefaultGameWindow(config) {
  return Companion_getInstance_3().dx() ? DenoJsGameWindow.r9p(VOID, config) : Companion_getInstance_3().cx() ? NodeJsGameWindow.w9m() : BrowserCanvasJsGameWindow.k9k();
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  var tmp0_safe_receiver = $this.e9s_1.h9k_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    var tmp = cancelAndJoin(tmp0_safe_receiver, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  window.close();
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  var tmp = $this.f9s_1($this.g9s_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function onResized($this) {
  $this.y9j_1 = null;
  if (get_isCanvasCreatedAndHandled()) {
    var scale = $this.v8o().p8v(window.innerWidth, window.innerHeight, $this.n8p());
    var canvasWidth = numberToInt(window.innerWidth * scale);
    var canvasHeight = numberToInt(window.innerHeight * scale);
    $this.v9j_1.width = canvasWidth;
    $this.v9j_1.height = canvasHeight;
    $this.v9j_1.style.position = 'absolute';
    $this.v9j_1.style.left = '0';
    $this.v9j_1.style.right = '0';
    $this.v9j_1.style.width = '' + window.innerWidth + 'px';
    $this.v9j_1.style.height = '' + window.innerHeight + 'px';
    $this.d9k_1 = scale;
  } else {
    $this.d9k_1 = $this.v9j_1.width / $this.v9j_1.clientWidth;
  }
  $this.q8x(0, 0, $this.v9j_1.width, $this.v9j_1.height);
}
function keyEvent($this, me) {
  var tmp;
  switch (me.key) {
    case '0':
      tmp = Key_N0_getInstance();
      break;
    case '1':
      tmp = Key_N1_getInstance();
      break;
    case '2':
      tmp = Key_N2_getInstance();
      break;
    case '3':
      tmp = Key_N3_getInstance();
      break;
    case '4':
      tmp = Key_N4_getInstance();
      break;
    case '5':
      tmp = Key_N5_getInstance();
      break;
    case '6':
      tmp = Key_N6_getInstance();
      break;
    case '7':
      tmp = Key_N7_getInstance();
      break;
    case '8':
      tmp = Key_N8_getInstance();
      break;
    case '9':
      tmp = Key_N9_getInstance();
      break;
    case 'a':
      tmp = Key_A_getInstance();
      break;
    case 'b':
      tmp = Key_B_getInstance();
      break;
    case 'c':
      tmp = Key_C_getInstance();
      break;
    case 'd':
      tmp = Key_D_getInstance();
      break;
    case 'e':
      tmp = Key_E_getInstance();
      break;
    case 'f':
      tmp = Key_F_getInstance();
      break;
    case 'g':
      tmp = Key_G_getInstance();
      break;
    case 'h':
      tmp = Key_H_getInstance();
      break;
    case 'i':
      tmp = Key_I_getInstance();
      break;
    case 'j':
      tmp = Key_J_getInstance();
      break;
    case 'k':
      tmp = Key_K_getInstance();
      break;
    case 'l':
      tmp = Key_L_getInstance();
      break;
    case 'm':
      tmp = Key_M_getInstance();
      break;
    case 'n':
      tmp = Key_N_getInstance();
      break;
    case 'o':
      tmp = Key_O_getInstance();
      break;
    case 'p':
      tmp = Key_P_getInstance();
      break;
    case 'q':
      tmp = Key_Q_getInstance();
      break;
    case 'r':
      tmp = Key_R_getInstance();
      break;
    case 's':
      tmp = Key_S_getInstance();
      break;
    case 't':
      tmp = Key_T_getInstance();
      break;
    case 'u':
      tmp = Key_U_getInstance();
      break;
    case 'v':
      tmp = Key_V_getInstance();
      break;
    case 'w':
      tmp = Key_W_getInstance();
      break;
    case 'x':
      tmp = Key_X_getInstance();
      break;
    case 'y':
      tmp = Key_Y_getInstance();
      break;
    case 'z':
      tmp = Key_Z_getInstance();
      break;
    case 'F1':
      tmp = Key_F1_getInstance();
      break;
    case 'F2':
      tmp = Key_F2_getInstance();
      break;
    case 'F3':
      tmp = Key_F3_getInstance();
      break;
    case 'F4':
      tmp = Key_F4_getInstance();
      break;
    case 'F5':
      tmp = Key_F5_getInstance();
      break;
    case 'F6':
      tmp = Key_F6_getInstance();
      break;
    case 'F7':
      tmp = Key_F7_getInstance();
      break;
    case 'F8':
      tmp = Key_F8_getInstance();
      break;
    case 'F9':
      tmp = Key_F9_getInstance();
      break;
    case 'F10':
      tmp = Key_F10_getInstance();
      break;
    case 'F11':
      tmp = Key_F11_getInstance();
      break;
    case 'F12':
      tmp = Key_F12_getInstance();
      break;
    case 'F13':
      tmp = Key_F13_getInstance();
      break;
    case 'F14':
      tmp = Key_F14_getInstance();
      break;
    case 'F15':
      tmp = Key_F15_getInstance();
      break;
    case 'F16':
      tmp = Key_F16_getInstance();
      break;
    case 'F17':
      tmp = Key_F17_getInstance();
      break;
    case 'F18':
      tmp = Key_F18_getInstance();
      break;
    case 'F19':
      tmp = Key_F19_getInstance();
      break;
    case 'F20':
      tmp = Key_F20_getInstance();
      break;
    case 'F21':
      tmp = Key_F21_getInstance();
      break;
    case 'F22':
      tmp = Key_F22_getInstance();
      break;
    case 'F23':
      tmp = Key_F23_getInstance();
      break;
    case 'F24':
      tmp = Key_F24_getInstance();
      break;
    case 'F25':
      tmp = Key_F25_getInstance();
      break;
    case '+':
      tmp = Key_PLUS_getInstance();
      break;
    case '-':
      tmp = Key_MINUS_getInstance();
      break;
    case "'":
      tmp = Key_APOSTROPHE_getInstance();
      break;
    case '"':
      tmp = Key_QUOTE_getInstance();
      break;
    default:
      var tmp_0;
      switch (me.code) {
        case 'MetaLeft':
          tmp_0 = Companion_getInstance_34().e6t();
          break;
        case 'MetaRight':
          tmp_0 = Companion_getInstance_34().f6t();
          break;
        case 'ShiftLeft':
          tmp_0 = Companion_getInstance_34().a6t();
          break;
        case 'ShiftRight':
          tmp_0 = Companion_getInstance_34().b6t();
          break;
        case 'ControlLeft':
          tmp_0 = Companion_getInstance_34().y6s();
          break;
        case 'ControlRight':
          tmp_0 = Companion_getInstance_34().z6s();
          break;
        case 'AltLeft':
          tmp_0 = Companion_getInstance_34().c6t();
          break;
        case 'AltRight':
          tmp_0 = Companion_getInstance_34().d6t();
          break;
        case 'Space':
          tmp_0 = Key_SPACE_getInstance();
          break;
        case 'ArrowUp':
          tmp_0 = Key_UP_getInstance();
          break;
        case 'ArrowDown':
          tmp_0 = Key_DOWN_getInstance();
          break;
        case 'ArrowLeft':
          tmp_0 = Key_LEFT_getInstance();
          break;
        case 'ArrowRight':
          tmp_0 = Key_RIGHT_getInstance();
          break;
        case 'PageUp':
          tmp_0 = Key_PAGE_UP_getInstance();
          break;
        case 'PageDown':
          tmp_0 = Key_PAGE_DOWN_getInstance();
          break;
        case 'Home':
          tmp_0 = Key_HOME_getInstance();
          break;
        case 'End':
          tmp_0 = Key_END_getInstance();
          break;
        case 'Enter':
          tmp_0 = Key_ENTER_getInstance();
          break;
        case 'Escape':
          tmp_0 = Key_ESCAPE_getInstance();
          break;
        case 'Backspace':
          tmp_0 = Key_BACKSPACE_getInstance();
          break;
        case 'Delete':
          tmp_0 = Key_DELETE_getInstance();
          break;
        case 'Insert':
          tmp_0 = Key_INSERT_getInstance();
          break;
        case 'Period':
          tmp_0 = Key_PERIOD_getInstance();
          break;
        case 'Comma':
          tmp_0 = Key_COMMA_getInstance();
          break;
        case 'Semicolon':
          tmp_0 = Key_SEMICOLON_getInstance();
          break;
        case 'Slash':
          tmp_0 = Key_SLASH_getInstance();
          break;
        case 'Tab':
          tmp_0 = Key_TAB_getInstance();
          break;
        default:
          // Inline function 'kotlin.js.asDynamic' call

          if (window.korgwShowUnsupportedKeys) {
            // Inline function 'korlibs.logger.Logger.info' call
            var this_0 = CoroutineKey_getInstance().x8s_1;
            var level = Level_INFO_getInstance();
            var tmp_1;
            if (this_0.q31(level)) {
              // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.keyEvent.<anonymous>' call
              var tmp$ret$1 = 'Unsupported key key=' + me.key + ', code=' + me.code;
              this_0.r31(level, tmp$ret$1);
              tmp_1 = Unit_instance;
            }
          }

          tmp_0 = Key_UNKNOWN_getInstance();
          break;
      }

      tmp = tmp_0;
      break;
  }
  var key = tmp;
  $this.w6l(invoke_0($this.t8t_1, BrowserCanvasJsGameWindow$keyEvent$lambda(me, key)));
  if (key.equals(Key_TAB_getInstance()) || key.i6t()) {
    me.preventDefault();
  }
}
function touchEvent($this, e, type) {
  var canvasBounds = $this.v9j_1.getBoundingClientRect();
  // Inline function 'kotlin.also' call
  // Inline function 'korlibs.event.TouchBuilder.frame' call
  var this_0 = $this.e9k_1;
  this_0.t6q_1 = Mode_JS_getInstance();
  this_0.u6q(type, false);
  try {
    // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.touchEvent.<anonymous>' call
    var inductionVariable = 0;
    var last = e.touches.length;
    if (inductionVariable < last)
      $l$loop: do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp0_elvis_lhs = e.touches.item(n);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          continue $l$loop;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var touch = tmp;
        var touchId = touch.identifier;
        // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.transformEventX' call
        var tmp_0 = (touch.clientX - canvasBounds.left) * $this.d9k_1;
        // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.transformEventY' call
        var tmp$ret$1 = (touch.clientY - canvasBounds.top) * $this.d9k_1;
        var tmp_1 = Vector2D.b2i(tmp_0, tmp$ret$1);
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp1_elvis_lhs = touch.force;
        this_0.x6q(touchId, tmp_1, tmp1_elvis_lhs == null ? 1.0 : tmp1_elvis_lhs, Kind_FINGER_getInstance());
      }
       while (inductionVariable < last);
  }finally {
    this_0.v6q();
  }
  var this_1 = this_0.s6q_1;
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.touchEvent.<anonymous>' call
  $this.w6l(this_1);
}
function mouseEvent($this, e, type, pressingType) {
  var canvasBounds = $this.v9j_1.getBoundingClientRect();
  // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.transformEventX' call
  var tmp$ret$0 = (e.clientX - canvasBounds.left) * $this.d9k_1;
  var tx = numberToInt(tmp$ret$0);
  // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.transformEventY' call
  var tmp$ret$1 = (e.clientY - canvasBounds.top) * $this.d9k_1;
  var ty = numberToInt(tmp$ret$1);
  invoke_0($this.u8t_1, BrowserCanvasJsGameWindow$mouseEvent$lambda(e, pressingType, type, tx, ty));
  if (!$this.h9s() || type.equals(Type_SCROLL_getInstance())) {
    $this.w6l($this.u8t_1);
  }
}
function mouseEvent$default($this, e, type, pressingType, $super) {
  pressingType = pressingType === VOID ? type : pressingType;
  return mouseEvent($this, e, type, pressingType);
}
function *_generator_loop__qll5p8_0($this, entry, $completion) {
  var tmp = $this;
  var tmp_0 = $this.q8v($completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  tmp.h9k_1 = launchImmediately(tmp_0, BrowserCanvasJsGameWindow$loop$slambda_0(entry, $this));
  _get_jsFrame__gugpar($this)(0.0);
  return Unit_instance;
}
function _get_jsFrame__gugpar($this) {
  var tmp = $this.i9k_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('jsFrame');
  }
}
function _get_navigatorClipboard__ni2gks($this) {
  // Inline function 'kotlin.js.unsafeCast' call
  return navigator.clipboard;
}
function BrowserCanvasJsGameWindow$keyEvent$lambda($me, $key) {
  return function ($this$keyEvent) {
    var tmp = $this$keyEvent;
    var tmp_0;
    switch ($me.type) {
      case 'keydown':
        tmp_0 = Type_DOWN_getInstance();
        break;
      case 'keyup':
        tmp_0 = Type_UP_getInstance();
        break;
      case 'keypress':
        tmp_0 = Type_TYPE_getInstance();
        break;
      default:
        var message = 'Unsupported event type ' + $me.type;
        throw IllegalStateException.l5(toString(message));
    }
    tmp.d6n_1 = tmp_0;
    $this$keyEvent.e6n_1 = 0;
    $this$keyEvent.g6n_1 = $me.keyCode;
    $this$keyEvent.f6n_1 = $key;
    $this$keyEvent.i6n_1 = $me.shiftKey;
    $this$keyEvent.j6n_1 = $me.ctrlKey;
    $this$keyEvent.k6n_1 = $me.altKey;
    $this$keyEvent.l6n_1 = $me.metaKey;
    $this$keyEvent.h6n_1 = numberToChar($me.charCode);
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$mouseEvent$lambda($e, $pressingType, $type, $tx, $ty) {
  return function ($this$mouseEvent) {
    $this$mouseEvent.u6n_1 = !($e.buttons === 0) ? $pressingType : $type;
    $this$mouseEvent.h6o_1 = false;
    $this$mouseEvent.v6n_1 = 0;
    $this$mouseEvent.w6n_1 = $tx;
    $this$mouseEvent.x6n_1 = $ty;
    $this$mouseEvent.y6n_1 = Companion_getInstance_35().d1($e.button);
    $this$mouseEvent.z6n_1 = $e.buttons;
    $this$mouseEvent.d6o_1 = $e.shiftKey;
    $this$mouseEvent.e6o_1 = $e.ctrlKey;
    $this$mouseEvent.f6o_1 = $e.altKey;
    $this$mouseEvent.g6o_1 = $e.metaKey;
    var tmp;
    if ($type.equals(Type_SCROLL_getInstance())) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var we = $e;
      var tmp0_subject = we.deltaMode;
      var mode = tmp0_subject === WheelEvent.DOM_DELTA_PIXEL ? ScrollDeltaMode_PIXEL_getInstance() : tmp0_subject === WheelEvent.DOM_DELTA_LINE ? ScrollDeltaMode_LINE_getInstance() : tmp0_subject === WheelEvent.DOM_DELTA_PAGE ? ScrollDeltaMode_PAGE_getInstance() : ScrollDeltaMode_LINE_getInstance();
      var sensitivity = 0.05;
      $this$mouseEvent.n6o(mode, we.deltaX * sensitivity, we.deltaY * sensitivity, we.deltaZ * sensitivity);
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$close$slambda_0(this$0) {
  var i = new BrowserCanvasJsGameWindow$close$slambda(this$0);
  var l = function ($completion) {
    return i.fe($completion);
  };
  l.$arity = 0;
  return l;
}
function BrowserCanvasJsGameWindow$loop$slambda_0($entry, this$0) {
  var i = new BrowserCanvasJsGameWindow$loop$slambda($entry, this$0);
  var l = function ($completion) {
    return i.fe($completion);
  };
  l.$arity = 0;
  return l;
}
function BrowserCanvasJsGameWindow$lambda(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent$default(this$0, it, Type_SCROLL_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_0(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent$default(this$0, it, Type_ENTER_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_1(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent$default(this$0, it, Type_EXIT_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_2(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent(this$0, it, Type_MOVE_getInstance(), Type_DRAG_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_3(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent(this$0, it, Type_MOVE_getInstance(), Type_DRAG_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_4(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent$default(this$0, it, Type_EXIT_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_5(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent$default(this$0, it, Type_UP_getInstance_0());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_6(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent$default(this$0, it, Type_DOWN_getInstance_0());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_7(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    mouseEvent$default(this$0, it, Type_CLICK_getInstance());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_8(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    touchEvent(this$0, it, Type_START_getInstance_0());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_9(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    touchEvent(this$0, it, Type_MOVE_getInstance_0());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_10(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    touchEvent(this$0, it, Type_END_getInstance_0());
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_11(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    keyEvent(this$0, it);
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_12(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    keyEvent(this$0, it);
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_13(this$0) {
  return function (it) {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    keyEvent(this$0, it);
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_14(this$0) {
  return function (it) {
    onResized(this$0);
    return Unit_instance;
  };
}
function BrowserCanvasJsGameWindow$lambda_15(this$0) {
  return function (it) {
    return this$0.v8x(Type_START_getInstance(), null);
  };
}
function BrowserCanvasJsGameWindow$lambda_16(this$0) {
  return function (it) {
    return this$0.v8x(Type_END_getInstance(), null);
  };
}
function BrowserCanvasJsGameWindow$lambda_17(this$0) {
  return function (it) {
    return this$0.v8x(Type_END_getInstance(), null);
  };
}
function BrowserCanvasJsGameWindow$lambda_18(it) {
  it.preventDefault();
  return Unit_instance;
}
function BrowserCanvasJsGameWindow$lambda_19(this$0) {
  return function (it) {
    return this$0.v8x(Type_START_getInstance(), null);
  };
}
function BrowserCanvasJsGameWindow$lambda_20(this$0) {
  return function (it) {
    return this$0.v8x(Type_END_getInstance(), null);
  };
}
function BrowserCanvasJsGameWindow$lambda_21(this$0) {
  return function (it) {
    it.preventDefault();
    this$0.v8x(Type_END_getInstance(), null);
    var items = ensureNotNull(it.dataTransfer).items;
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var this_0 = until(0, items.length);
    var destination = ArrayList.i1();
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = this_0.d2_1;
    var last = this_0.e2_1;
    if (inductionVariable <= last)
      do {
        var element = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
        // Inline function 'korlibs.render.BrowserCanvasJsGameWindow.<anonymous>.<anonymous>' call
        // Inline function 'org.w3c.dom.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp0_safe_receiver = items[element];
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.getAsFile();
        var tmp0_safe_receiver_0 = tmp1_safe_receiver == null ? null : toVfs(tmp1_safe_receiver);
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          destination.h(tmp0_safe_receiver_0);
        }
      }
       while (!(element === last));
    var files = destination;
    return this$0.v8x(Type_DROP_getInstance(), files);
  };
}
function BrowserCanvasJsGameWindow$lambda_22(this$0) {
  return function (step) {
    window.requestAnimationFrame(_get_jsFrame__gugpar(this$0));
    this$0.r8v();
    return Unit_instance;
  };
}
function *_generator_invoke__zhh2q8_2($this, $completion) {
  var tmp = $this.k9s_1($this.l9s_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_loop__qll5p8_1($this, entry, $completion) {
  var tmp = $this.q8v($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  launchImmediately(tmp, DenoJsGameWindow$loop$slambda_0(entry, $this));
  var tmp_0 = get_jsGlobalThis();
  tmp_0.setInterval(DenoJsGameWindow$loop$lambda($this), 16);
  return Unit_instance;
}
function DenoJsGameWindow$loop$slambda_0($entry, this$0) {
  var i = new DenoJsGameWindow$loop$slambda($entry, this$0);
  var l = function ($completion) {
    return i.fe($completion);
  };
  l.$arity = 0;
  return l;
}
function DenoJsGameWindow$loop$lambda(this$0) {
  return function () {
    this$0.h9g();
    this$0.r8v();
    this$0.i9g();
    return Unit_instance;
  };
}
//region block: post-declaration
initMetadataForClass(TimedTask, 'TimedTask', VOID, VOID, [Comparable, AutoCloseable]);
initMetadataForClass(BaseEventLoop, 'BaseEventLoop', VOID, VOID, [AutoCloseable]);
initMetadataForClass(SyncEventLoop, 'SyncEventLoop', SyncEventLoop);
protoOf(Listener).su = cancel;
initMetadataForClass(Listener, 'Listener', VOID, VOID, [CloseableCancellable]);
initMetadataForClass(ListenerNode, 'ListenerNode');
initMetadataForInterface(EventListener, 'EventListener');
protoOf(BaseEventListener).v6l = dispatch$default;
protoOf(BaseEventListener).x6l = onEvents;
protoOf(BaseEventListener).y6l = dispatchDown;
protoOf(BaseEventListener).z6l = dispatchUp;
initMetadataForClass(BaseEventListener, 'BaseEventListener', BaseEventListener.j6l, VOID, [EventListener]);
initMetadataForClass(EventResult, 'EventResult', EventResult);
initMetadataForCompanion(Companion);
initMetadataForClass(Event, 'Event');
initMetadataForClass(TypedEvent, 'TypedEvent');
initMetadataForClass(PauseEvent, 'PauseEvent', PauseEvent);
initMetadataForCompanion(Companion_0);
initMetadataForClass(ResumeEvent, 'ResumeEvent', ResumeEvent);
initMetadataForCompanion(Companion_1);
initMetadataForClass(StopEvent, 'StopEvent', StopEvent);
initMetadataForCompanion(Companion_2);
initMetadataForClass(DestroyEvent, 'DestroyEvent', DestroyEvent);
initMetadataForClass(RenderEvent, 'RenderEvent', RenderEvent);
initMetadataForCompanion(Companion_3);
initMetadataForClass(InitEvent, 'InitEvent', InitEvent);
initMetadataForCompanion(Companion_4);
initMetadataForCompanion(Companion_5);
initMetadataForClass(DisposeEvent, 'DisposeEvent', DisposeEvent);
initMetadataForCompanion(Companion_6);
initMetadataForClass(FullScreenEvent, 'FullScreenEvent', FullScreenEvent);
initMetadataForCompanion(Companion_7);
initMetadataForClass(ReshapeEvent, 'ReshapeEvent', ReshapeEvent);
initMetadataForCompanion(Companion_8);
initMetadataForClass(Type, 'Type');
initMetadataForClass(KeyEvent, 'KeyEvent', KeyEvent);
initMetadataForCompanion(Companion_9);
initMetadataForClass(Type_0, 'Type');
initMetadataForClass(ScrollDeltaMode, 'ScrollDeltaMode');
initMetadataForClass(MouseEvent, 'MouseEvent', MouseEvent);
initMetadataForCompanion(Companion_10);
initMetadataForClass(Type_1, 'Type');
initMetadataForClass(GestureEvent, 'GestureEvent', GestureEvent);
initMetadataForCompanion(Companion_11);
initMetadataForClass(Type_2, 'Type');
initMetadataForClass(DropFileEvent, 'DropFileEvent', DropFileEvent);
initMetadataForClass(StopPropagatingException, 'StopPropagatingException', StopPropagatingException.e6p);
initMetadataForClass(Status, 'Status');
initMetadataForClass(Kind, 'Kind');
initMetadataForCompanion(Companion_12);
initMetadataForClass(Touch, 'Touch', Touch);
initMetadataForCompanion(Companion_13);
initMetadataForClass(Type_3, 'Type');
initMetadataForCompanion(Companion_14);
initMetadataForClass(TouchEvent, 'TouchEvent', TouchEvent);
initMetadataForClass(Mode, 'Mode');
initMetadataForClass(TouchBuilder, 'TouchBuilder', TouchBuilder);
initMetadataForClass(GamepadInfoEmitter, 'GamepadInfoEmitter');
initMetadataForClass(BatteryStatus, 'BatteryStatus');
initMetadataForCompanion(Companion_15);
initMetadataForClass(GamepadInfo, 'GamepadInfo', GamepadInfo);
initMetadataForCompanion(Companion_16);
initMetadataForClass(GamePadUpdateEvent, 'GamePadUpdateEvent', GamePadUpdateEvent);
initMetadataForCompanion(Companion_17);
initMetadataForClass(Type_4, 'Type');
initMetadataForClass(GamePadConnectionEvent, 'GamePadConnectionEvent', GamePadConnectionEvent);
initMetadataForCompanion(Companion_18);
initMetadataForClass(GameButton, 'GameButton');
initMetadataForCompanion(Companion_19);
initMetadataForClass(Key, 'Key');
initMetadataForCompanion(Companion_20);
initMetadataForClass(MouseButton, 'MouseButton');
initMetadataForCompanion(Companion_21);
initMetadataForInterface(AGFeatures, 'AGFeatures');
protoOf(AG).s6u = get_parentFeatures;
protoOf(AG).t6u = get_isUniformBuffersSupported;
protoOf(AG).u6u = get_isVertexArraysSupported;
initMetadataForClass(AG, 'AG', VOID, VOID, [AGFeatures]);
initMetadataForClass(Immutable, 'Immutable', Immutable, VOID, [AGFeatures]);
initMetadataForClass(AGObject, 'AGObject', AGObject, VOID, [AutoCloseable]);
initMetadataForClass(AGBuffer, 'AGBuffer', AGBuffer);
initMetadataForCompanion(Companion_22);
initMetadataForClass(AGTextureUnits, 'AGTextureUnits', AGTextureUnits.z6x);
initMetadataForCompanion(Companion_23);
initMetadataForClass(AGFrameBuffer, 'AGFrameBuffer', AGFrameBuffer.j6u, VOID, [AutoCloseable]);
initMetadataForClass(AGTexture, 'AGTexture', AGTexture, VOID, [AGObject, AutoCloseable]);
initMetadataForClass(AGFrameBufferBase, 'AGFrameBufferBase');
initMetadataForCompanion(Companion_24);
initMetadataForClass(AGTextureUnitInfo, 'AGTextureUnitInfo');
initMetadataForInterface(AGNativeObject, 'AGNativeObject');
initMetadataForClass(BufferCache, 'BufferCache', BufferCache);
initMetadataForClass(AGProgramWithUniforms, 'AGProgramWithUniforms');
initMetadataForClass(AGVertexArrayObject, 'AGVertexArrayObject');
initMetadataForClass(AGVertexData, 'AGVertexData', AGVertexData);
initMetadataForCompanion(Companion_25);
initMetadataForClass(AGDrawType, 'AGDrawType');
initMetadataForCompanion(Companion_26);
initMetadataForCompanion(Companion_27);
initMetadataForClass(AGBlending, 'AGBlending');
initMetadataForCompanion(Companion_28);
initMetadataForClass(AGScissor, 'AGScissor');
initMetadataForCompanion(Companion_29);
initMetadataForObject(AGFinish, 'AGFinish');
initMetadataForClass(AGClear, 'AGClear');
initMetadataForCompanion(Companion_30);
initMetadataForClass(AGStencilReference, 'AGStencilReference');
initMetadataForCompanion(Companion_31);
initMetadataForClass(AGStencilOpFunc, 'AGStencilOpFunc');
initMetadataForCompanion(Companion_32);
initMetadataForClass(AGColorMask, 'AGColorMask');
initMetadataForCompanion(Companion_33);
initMetadataForCompanion(Companion_34);
initMetadataForClass(AGCullFace, 'AGCullFace');
initMetadataForClass(AGBatch, 'AGBatch');
initMetadataForCompanion(Companion_35);
initMetadataForCompanion(Companion_36);
initMetadataForClass(AGTextureTargetKind, 'AGTextureTargetKind');
initMetadataForCompanion(Companion_37);
initMetadataForClass(AGWrapMode, 'AGWrapMode');
initMetadataForCompanion(Companion_38);
initMetadataForClass(AGBlendFactor, 'AGBlendFactor');
initMetadataForCompanion(Companion_39);
initMetadataForClass(AGBlendEquation, 'AGBlendEquation');
initMetadataForCompanion(Companion_40);
initMetadataForCompanion(Companion_41);
initMetadataForClass(AGStencilOp, 'AGStencilOp');
initMetadataForCompanion(Companion_42);
initMetadataForClass(AGCompareMode, 'AGCompareMode');
initMetadataForCompanion(Companion_43);
initMetadataForClass(AGMultiBatch, 'AGMultiBatch');
initMetadataForClass(AGConfig, 'AGConfig', AGConfig);
initMetadataForClass(AGBufferKind, 'AGBufferKind');
initMetadataForClass(AGStats, 'AGStats', AGStats);
initMetadataForClass(UniformBlock, 'UniformBlock');
initMetadataForObject(ProjViewUB, 'ProjViewUB');
initMetadataForObject(DefaultShaders, 'DefaultShaders');
initMetadataForInterface(VarTypeAccessor, 'VarTypeAccessor');
initMetadataForInterface(ExpressionBuilder, 'ExpressionBuilder');
protoOf(Builder).a7d = get_Float1;
protoOf(Builder).s7y = get_Float2;
protoOf(Builder).t7y = get_Float4;
protoOf(Builder).r7b = get_out;
protoOf(Builder).b7d = atan;
protoOf(Builder).z7b = texture2D;
protoOf(Builder).i7x = TERNARY;
protoOf(Builder).c7d = pow;
protoOf(Builder).d7d = sqrt;
protoOf(Builder).e7d = abs;
protoOf(Builder).f7d = fract;
protoOf(Builder).j7x = clamp;
protoOf(Builder).k7x = min_0;
protoOf(Builder).l7x = max_1;
protoOf(Builder).m7x = fwidth;
protoOf(Builder).n7x = mix;
protoOf(Builder).g7d = smoothstep;
protoOf(Builder).o7x = length;
protoOf(Builder).u7b = get_lit;
protoOf(Builder).h7d = vec2;
protoOf(Builder).v7b = vec4;
protoOf(Builder).x7b = get_1;
protoOf(Builder).i7d = get_x;
protoOf(Builder).j7d = get_y;
protoOf(Builder).k7d = get_z;
protoOf(Builder).l7d = get_w;
protoOf(Builder).b7c = get_a;
protoOf(Builder).m7d = unaryMinus;
protoOf(Builder).n7d = minus_0;
protoOf(Builder).p7x = minus_1;
protoOf(Builder).o7d = plus_2;
protoOf(Builder).q7x = plus_3;
protoOf(Builder).r7x = plus_4;
protoOf(Builder).s7b = times;
protoOf(Builder).s7x = times_0;
protoOf(Builder).d7c = div;
protoOf(Builder).p7d = eq;
protoOf(Builder).q7d = lt;
protoOf(Builder).r7d = le;
protoOf(Builder).s7d = gt;
protoOf(Builder).t7x = gt_0;
initMetadataForClass(Builder, 'Builder', Builder.e7c, VOID, [VarTypeAccessor, ExpressionBuilder]);
initMetadataForInterface(IDefaultShaders, 'IDefaultShaders');
protoOf(ProgramBuilderDefault).y7b = get_u_Tex;
protoOf(ProgramBuilderDefault).d79 = get_u_ProjMat;
protoOf(ProgramBuilderDefault).e79 = get_u_ViewMat;
protoOf(ProgramBuilderDefault).t7b = get_a_Pos;
protoOf(ProgramBuilderDefault).l7b = get_a_Tex;
protoOf(ProgramBuilderDefault).q7b = get_a_Col;
protoOf(ProgramBuilderDefault).k7b = get_v_Tex;
protoOf(ProgramBuilderDefault).p7b = get_v_Col;
protoOf(ProgramBuilderDefault).c7c = get_t_Temp0;
protoOf(ProgramBuilderDefault).t7d = get_t_Temp1;
initMetadataForClass(ProgramBuilderDefault, 'ProgramBuilderDefault', ProgramBuilderDefault.j7b, VOID, [Builder, IDefaultShaders]);
initMetadataForClass(GLVAO, 'GLVAO');
initMetadataForClass(ShaderException, 'ShaderException');
initMetadataForClass(TextureUnitParams, 'TextureUnitParams');
initMetadataForClass(AGOpengl, 'AGOpengl');
initMetadataForClass(GLGlobalState, 'GLGlobalState');
initMetadataForClass(GLBaseObject, 'GLBaseObject', VOID, VOID, [AGNativeObject]);
initMetadataForClass(GLBaseProgram, 'GLBaseProgram');
initMetadataForClass(GLBuffer, 'GLBuffer');
initMetadataForClass(GLTexture, 'GLTexture');
initMetadataForClass(GLFrameBuffer, 'GLFrameBuffer');
initMetadataForClass(GLProgramInfo, 'GLProgramInfo');
initMetadataForObject(GLShaderCompiler, 'GLShaderCompiler');
initMetadataForClass(AGDummy, 'AGDummy', AGDummy.t7n);
initMetadataForClass(AGBaseLog, 'AGBaseLog', AGBaseLog.n7o);
initMetadataForClass(AGPrint, 'AGPrint', AGPrint.d7o);
initMetadataForClass(Kind_0, 'Kind');
initMetadataForCompanion(Companion_44);
initMetadataForClass(UniformBlocksBuffersRef, 'UniformBlocksBuffersRef');
initMetadataForClass(Gen, 'Gen');
initMetadataForClass(Operand, 'Operand');
initMetadataForClass(OperandWithArray, 'OperandWithArray');
initMetadataForClass(Variable, 'Variable');
initMetadataForClass(VariableWithOffset, 'VariableWithOffset');
initMetadataForClass(TypedUniform, 'TypedUniform');
initMetadataForCompanion(Companion_45);
initMetadataForClass(UniformBlockBuffer, 'UniformBlockBuffer');
initMetadataForClass(UBLayoutBuilder, 'UBLayoutBuilder', UBLayoutBuilder);
initMetadataForClass(UniformsRef, 'UniformsRef');
initMetadataForCompanion(Companion_46);
initMetadataForClass(GLVariant, 'GLVariant');
initMetadataForClass(Visitor, 'Visitor');
initMetadataForClass(GlobalsProgramVisitor, 'GlobalsProgramVisitor', GlobalsProgramVisitor);
initMetadataForCompanion(Companion_47);
initMetadataForClass(Result, 'Result');
initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForInterface(BaseGlslGenerator, 'BaseGlslGenerator');
protoOf(GlslGenerator).s7t = precToString;
protoOf(GlslGenerator).t7t = typeToString;
protoOf(GlslGenerator).u7t = get_arrayDecl;
protoOf(GlslGenerator).r7t = get_IN;
protoOf(GlslGenerator).w7t = get_OUT;
protoOf(GlslGenerator).v7t = get_UNIFORM;
initMetadataForClass(GlslGenerator, 'GlslGenerator', VOID, VOID, [BaseGlslGenerator]);
initMetadataForCompanion(Companion_48);
initMetadataForClass(GlslConfig, 'GlslConfig');
protoOf(GlslBodyGenerator).t7t = typeToString;
initMetadataForClass(GlslBodyGenerator, 'GlslBodyGenerator', VOID, VOID, [Visitor, BaseGlslGenerator]);
initMetadataForClass(ProgramLayout, 'ProgramLayout', VOID, VOID, [Iterable]);
initMetadataForClass(Attribute, 'Attribute');
initMetadataForClass(Stm, 'Stm');
initMetadataForClass(Stms, 'Stms');
initMetadataForClass(Set, 'Set');
initMetadataForClass(Return, 'Return');
initMetadataForObject(Break, 'Break');
initMetadataForObject(Continue, 'Continue');
initMetadataForObject(Discard, 'Discard');
initMetadataForClass(If, 'If');
initMetadataForClass(ForSimple, 'ForSimple');
initMetadataForClass(Raw, 'Raw');
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).c7d = pow;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).u7b = get_lit;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).x7b = get_1;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).n7d = minus_0;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).o7d = plus_2;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).s7b = times;
protoOf(Program$ExpressionBuilder$Companion$INSTANCE$1).s7d = gt;
initMetadataForClass(Program$ExpressionBuilder$Companion$INSTANCE$1, VOID, VOID, VOID, [ExpressionBuilder]);
initMetadataForCompanion(Companion_49);
initMetadataForClass(FuncBuilder, 'FuncBuilder');
initMetadataForClass(FuncDeclGetter, 'FuncDeclGetter');
initMetadataForClass(FuncProvider, 'FuncProvider');
initMetadataForClass(Program$Builder$_funcs$1);
initMetadataForClass(Ternary, 'Ternary');
initMetadataForClass(Unop, 'Unop');
initMetadataForClass(Binop, 'Binop');
initMetadataForClass(IntLiteral, 'IntLiteral');
initMetadataForClass(FloatLiteral, 'FloatLiteral');
initMetadataForClass(BoolLiteral, 'BoolLiteral');
initMetadataForClass(Vector, 'Vector');
initMetadataForClass(Swizzle, 'Swizzle');
initMetadataForClass(ArrayAccess, 'ArrayAccess');
initMetadataForClass(BaseFunc, 'BaseFunc');
initMetadataForClass(Func, 'Func');
initMetadataForClass(CustomFunc, 'CustomFunc');
initMetadataForInterface(FuncRef, 'FuncRef');
initMetadataForClass(BuilderContext, 'BuilderContext', BuilderContext);
initMetadataForClass(Program, 'Program', VOID, VOID, [AutoCloseable]);
initMetadataForClass(Shader, 'Shader');
initMetadataForClass(Varying, 'Varying');
initMetadataForObject(Output, 'Output');
initMetadataForClass(Provider, 'Provider');
initMetadataForClass(Sampler, 'Sampler');
initMetadataForClass(SamplerVarType, 'SamplerVarType');
initMetadataForClass(Uniform, 'Uniform');
initMetadataForCompanion(Companion_50);
initMetadataForClass(VarType, 'VarType');
initMetadataForClass(Precision, 'Precision');
initMetadataForClass(Temp, 'Temp');
initMetadataForClass(FuncDecl, 'FuncDecl', VOID, VOID, [FuncRef]);
initMetadataForClass(VarKind, 'VarKind');
initMetadataForClass(UniformInProgram, 'UniformInProgram');
initMetadataForClass(Arg, 'Arg');
initMetadataForClass(ShaderType, 'ShaderType');
initMetadataForClass(sam$kotlinx_coroutines_DisposableHandle$0, 'sam$kotlinx_coroutines_DisposableHandle$0', VOID, VOID, [DisposableHandle, FunctionAdapter]);
initMetadataForClass(ContextInfo, 'ContextInfo', ContextInfo);
initMetadataForCompanion(Companion_51);
protoOf(KmlGl).s6u = get_parentFeatures;
protoOf(KmlGl).t6u = get_isUniformBuffersSupported;
protoOf(KmlGl).u6u = get_isVertexArraysSupported;
initMetadataForClass(KmlGl, 'KmlGl', KmlGl, VOID, [AGFeatures]);
initMetadataForClass(KmlGlContext, 'KmlGlContext', VOID, VOID, [AutoCloseable]);
initMetadataForClass(KorgeReloadInternalImpl, 'KorgeReloadInternalImpl', KorgeReloadInternalImpl);
initMetadataForClass(ReloadClassContext, 'ReloadClassContext');
initMetadataForObject(KorgeReload, 'KorgeReload');
initMetadataForCompanion(Companion_52);
initMetadataForCompanion(Companion_53);
initMetadataForClass(BlendMode, 'BlendMode');
initMetadataForClass(InputKeys, 'InputKeys', InputKeys);
initMetadataForCompanion(Companion_54);
initMetadataForClass(Input, 'Input', Input);
initMetadataForObject(DefaultViewport, 'DefaultViewport');
initMetadataForCompanion(Companion_55);
initMetadataForClass(Props, 'Props', Props, VOID, [KtMutableMap]);
initMetadataForClass(Entry, 'Entry', Entry);
initMetadataForClass(AgAutoFreeManager, 'AgAutoFreeManager', AgAutoFreeManager, VOID, [AutoCloseable]);
initMetadataForClass(BitmapTextureInfo, 'BitmapTextureInfo', BitmapTextureInfo);
initMetadataForClass(AgBitmapTextureManager, 'AgBitmapTextureManager', VOID, VOID, [AutoCloseable]);
initMetadataForClass(AgBufferManager, 'AgBufferManager');
initMetadataForClass(AgCachedBuffer, 'AgCachedBuffer');
initMetadataForClass(BatchBuffers, 'BatchBuffers', BatchBuffers);
initMetadataForCompanion(Companion_56);
initMetadataForClass(BatchBuilder2D, 'BatchBuilder2D');
initMetadataForInterface(BoundsProvider, 'BoundsProvider');
protoOf(Base).u8n = get_windowToGlobalScaleAvg;
protoOf(Base).v8n = get_globalToWindowScaleAvg;
protoOf(Base).w8n = windowToGlobalCoords;
initMetadataForClass(Base, 'Base', Base, VOID, [BoundsProvider]);
initMetadataForCompanion(Companion_57);
initMetadataForClass(LineRenderBatcher, 'LineRenderBatcher');
initMetadataForClass(FlushKind, 'FlushKind');
initMetadataForInterface(DeviceDimensionsProvider, 'DeviceDimensionsProvider');
initMetadataForClass(RenderContext, 'RenderContext', VOID, VOID, [BoundsProvider, AGFeatures, DeviceDimensionsProvider, AutoCloseable]);
initMetadataForClass(RenderContext2D, 'RenderContext2D');
initMetadataForObject(SDFShaders, 'SDFShaders');
initMetadataForClass(TextureBase, 'TextureBase', VOID, VOID, [AutoCloseable]);
initMetadataForCompanion(Companion_58);
initMetadataForClass(TexturedVertexArray, 'TexturedVertexArray');
initMetadataForClass(ResourcesRoot, 'ResourcesRoot', ResourcesRoot, VOID, [InjectorDependency], [1]);
initMetadataForClass(RCollection, 'RCollection', RCollection);
initMetadataForClass(Stats, 'Stats', Stats);
initMetadataForClass(V2, 'V2');
protoOf(DEFAULT).n8p = get_devicePixelRatio;
protoOf(DEFAULT).o8p = get_pixelsPerInch;
protoOf(DEFAULT).p8p = get_pixelsPerLogicalInchRatio;
protoOf(DEFAULT).y8o = get_computedPixelRatio;
initMetadataForObject(DEFAULT, 'DEFAULT', VOID, VOID, [DeviceDimensionsProvider]);
initMetadataForClass(Impl, 'Impl', Impl);
initMetadataForCompanion(Companion_59);
initMetadataForClass(Cursor, 'Cursor');
initMetadataForClass(MenuItem, 'MenuItem');
initMetadataForObject(CoroutineKey, 'CoroutineKey');
initMetadataForClass(Quality, 'Quality');
initMetadataForLambda(GameWindow$loop$slambda, VOID, VOID, [0]);
initMetadataForClass(_no_name_provided__qut3iv);
protoOf(GameWindow).n8p = get_devicePixelRatio;
protoOf(GameWindow).o8p = get_pixelsPerInch;
protoOf(GameWindow).p8p = get_pixelsPerLogicalInchRatio;
protoOf(GameWindow).y8o = get_computedPixelRatio;
protoOf(GameWindow).pd = get;
protoOf(GameWindow).ln = fold;
protoOf(GameWindow).kn = minusKey;
protoOf(GameWindow).mn = plus_1;
initMetadataForClass(GameWindow, 'GameWindow', GameWindow.y8v, VOID, [BaseEventListener, DeviceDimensionsProvider, Element], [0, 1]);
initMetadataForCompanion(Companion_60);
initMetadataForClass(GameWindowCreationConfig, 'GameWindowCreationConfig', GameWindowCreationConfig);
initMetadataForClass(TextClipboardData, 'TextClipboardData');
initMetadataForClass(TimedTask_0, 'TimedTask');
initMetadataForCompanion(Companion_61);
initMetadataForClass(sam$kotlinx_coroutines_DisposableHandle$0_0, 'sam$kotlinx_coroutines_DisposableHandle$0', VOID, VOID, [DisposableHandle, FunctionAdapter]);
initMetadataForClass(GameWindowCoroutineDispatcher, 'GameWindowCoroutineDispatcher', GameWindowCoroutineDispatcher.m8w, VOID, [CoroutineDispatcher, Delay, AutoCloseable], [1]);
initMetadataForClass(SyncEventLoopCoroutineDispatcher, 'SyncEventLoopCoroutineDispatcher', SyncEventLoopCoroutineDispatcher.b8w, VOID, [CoroutineDispatcher, Delay, AutoCloseable], [1]);
initMetadataForCompanion(Companion_62);
initMetadataForClass(UpdateEvent, 'UpdateEvent', UpdateEvent);
initMetadataForCompanion(Companion_63);
initMetadataForClass(SDL, 'SDL', SDL.j90);
initMetadataForClass(KmlGlOpenGL, 'KmlGlOpenGL', KmlGlOpenGL);
initMetadataForCompanion(Companion_64);
initMetadataForClass(OpenGL, 'OpenGL', OpenGL.a97);
initMetadataForClass(SDLGameWindow$ag$1);
initMetadataForClass(SDLGameWindow, 'SDLGameWindow', VOID, VOID, VOID, [0, 1]);
initMetadataForClass(Size3D, 'Size3D');
initMetadataForObject(AGOpenglFactory, 'AGOpenglFactory');
initMetadataForClass(KmlGlJsCanvas, 'KmlGlJsCanvas');
initMetadataForClass(WebGLExtension, 'WebGLExtension');
initMetadataForClass(KorgeReloadInternal$1);
initMetadataForClass(NativeVibration, 'NativeVibration');
initMetadataForClass(JsGameWindow, 'JsGameWindow', JsGameWindow.d9s, VOID, VOID, [0, 1]);
initMetadataForClass(NodeJsGameWindow, 'NodeJsGameWindow', NodeJsGameWindow.w9m, VOID, VOID, [0, 1]);
initMetadataForLambda(BrowserCanvasJsGameWindow$close$slambda, VOID, VOID, [0]);
initMetadataForLambda(BrowserCanvasJsGameWindow$loop$slambda, VOID, VOID, [0]);
initMetadataForClass(BrowserCanvasJsGameWindow, 'BrowserCanvasJsGameWindow', BrowserCanvasJsGameWindow.k9k, VOID, VOID, [1, 0]);
initMetadataForLambda(DenoJsGameWindow$loop$slambda, VOID, VOID, [0]);
initMetadataForClass(DenoJsGameWindow, 'DenoJsGameWindow', DenoJsGameWindow.r9p, VOID, VOID, [1, 0]);
initMetadataForClass(DialogInterfaceJs, 'DialogInterfaceJs', DialogInterfaceJs, VOID, VOID, [1, 2, 4]);
//endregion
//region block: init
Companion_instance_8 = new Companion();
Companion_instance_9 = new Companion_0();
Companion_instance_10 = new Companion_1();
Companion_instance_11 = new Companion_2();
Companion_instance_14 = new Companion_5();
Companion_instance_15 = new Companion_6();
Companion_instance_16 = new Companion_7();
Companion_instance_23 = new Companion_14();
Companion_instance_24 = new Companion_15();
Companion_instance_25 = new Companion_16();
Companion_instance_31 = new Companion_22();
Companion_instance_32 = new Companion_23();
AGFinish_instance = new AGFinish();
Companion_instance_49 = new Companion_40();
Companion_instance_54 = new Companion_45();
Companion_instance_55 = new Companion_46();
Companion_instance_59 = new Companion_50();
Companion_instance_60 = new Companion_51();
Companion_instance_61 = new Companion_52();
debugBmpFontOrNull = null;
Companion_instance_63 = new Companion_54();
Companion_instance_64 = new Companion_55();
DEFAULT_instance = new DEFAULT();
GLOBAL_CHECK_GL = false;
Companion_instance_71 = new Companion_62();
korgwJvmEngine = null;
Companion_instance_72 = new Companion_63();
Companion_instance_73 = new Companion_64();
AGOpenglFactory_instance = new AGOpenglFactory();
//endregion
//region block: exports
export {
  Size3D as Size3D,
};
export {
  Key_BACK_getInstance as Key_BACK_getInstance296cv9giwezig,
  Key_ESCAPE_getInstance as Key_ESCAPE_getInstance1l2qun1w293s5,
  Key_F12_getInstance as Key_F12_getInstance20smmrbslhgku,
  Key_F7_getInstance as Key_F7_getInstance1fxfgbmldwoq6,
  Type_DOWN_getInstance as Type_DOWN_getInstance3w3upujzs6x5,
  Type_TYPE_getInstance as Type_TYPE_getInstance3kl3gtiytkq1p,
  Type_UP_getInstance as Type_UP_getInstance2onpl7vaj0n6f,
  MouseButton_LEFT_getInstance as MouseButton_LEFT_getInstance2pxjdxrpl68c5,
  Type_DOWN_getInstance_0 as Type_DOWN_getInstance1zas01g4tazis,
  Type_DRAG_getInstance as Type_DRAG_getInstance1oyczma3u1sfi,
  Type_UP_getInstance_0 as Type_UP_getInstance1azeslmnft6l5,
  Kind_MOUSE_getInstance as Kind_MOUSE_getInstance104tc4m897tyy,
  Status_ADD_getInstance as Status_ADD_getInstance22apyg5ct4px7,
  Status_KEEP_getInstance as Status_KEEP_getInstance3tj4183qdgyi5,
  Status_REMOVE_getInstance as Status_REMOVE_getInstance19drpw6lfvon8,
  Type_END_getInstance_0 as Type_END_getInstance3ekhp9k4xqwsb,
  Type_MOVE_getInstance_0 as Type_MOVE_getInstanceavavmobr5nzz,
  Type_START_getInstance_0 as Type_START_getInstance27oonvh9zpi1o,
  Precision_MEDIUM_getInstance as Precision_MEDIUM_getInstancewn61okav7bh4,
  VarType_Float1_getInstance as VarType_Float1_getInstance1fp6gxp2vmo7y,
  VarType_Float2_getInstance as VarType_Float2_getInstance321ftm11bbyai,
  Cursor_DEFAULT_getInstance as Cursor_DEFAULT_getInstancemdqrzfwu4c9e,
  Quality_PERFORMANCE_getInstance as Quality_PERFORMANCE_getInstance2edcjnp9auwx5,
  debugBmpFont as debugBmpFont2i7i2ml66o1iy,
  configureLoggerFromProperties as configureLoggerFromProperties2zy8apzr93pqp,
  AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgo as AGStencilOpFunc__withActionOnBothPass$default_impl_69nsgoupfk5vp49hcf,
  AGStencilOpFunc__withCompareMode$default_impl_rzbauv as AGStencilOpFunc__withCompareMode$default_impl_rzbauv2a7p3ocsjaav3,
  AGStencilReference__withReadMask$default_impl_7mdffx as AGStencilReference__withReadMask$default_impl_7mdffx3h4nrtbyv01sb,
  AGStencilReference__withReferenceValue$default_impl_2trj0v as AGStencilReference__withReferenceValue$default_impl_2trj0vn7k078mgur5t,
  AGStencilReference__withWriteMask$default_impl_b7j7b4 as AGStencilReference__withWriteMask$default_impl_b7j7b425xwuml31ig42,
  _AGColorMask___init__impl__j38ai8_0 as _AGColorMask___init__impl__j38ai828hvpfxybxjk7,
  _AGColorMask___init__impl__j38ai8_1 as _AGColorMask___init__impl__j38ai819ejt5rq8iy6o,
  AGColorMask__hashCode_impl_g9082f as AGColorMask__hashCode_impl_g9082fge542b8j3bn5,
  AGColorMask__toString_impl_5i5oqg as AGColorMask__toString_impl_5i5oqgpd3xxn1kc5a,
  AGCompareMode__inverted_impl_7xxk8m as AGCompareMode__inverted_impl_7xxk8m1fvhgazpgzedy,
  AGCullFace__hashCode_impl_t4e5ur as AGCullFace__hashCode_impl_t4e5urey2md6modztx,
  AGCullFace__toString_impl_7d891w as AGCullFace__toString_impl_7d891w3d9dwll45l9u7,
  AGDrawType__hashCode_impl_ylaury as AGDrawType__hashCode_impl_ylaurytzzq8sas7cp2,
  AGDrawType__toString_impl_eonaeb as AGDrawType__toString_impl_eonaeb3ais8d8qrz6pw,
  AGStencilOpFunc__hashCode_impl_nopebb as AGStencilOpFunc__hashCode_impl_nopebb37r56bx19rj5s,
  AGStencilOpFunc__toString_impl_pl8quy as AGStencilOpFunc__toString_impl_pl8quy1rqibzqlcrdqz,
  AGStencilOpFunc__withActionOnBothPass_impl_qbn6at as AGStencilOpFunc__withActionOnBothPass_impl_qbn6at1fkyyctti87u0,
  AGStencilOpFunc__withEnabled_impl_mpcwmr as AGStencilOpFunc__withEnabled_impl_mpcwmr3endm713vq1t4,
  AGStencilReference__hashCode_impl_52zufx as AGStencilReference__hashCode_impl_52zufx32vlakxm4newn,
  AGStencilReference__toString_impl_qu5r8s as AGStencilReference__toString_impl_qu5r8s2c4bvb2linrx,
  Companion_instance_11 as Companion_instance99w5lpdgjzr4,
  Companion_getInstance_26 as Companion_getInstance18y91gyxi2z7,
  Companion_getInstance_32 as Companion_getInstanceok0yphc67vv6,
  Companion_instance_25 as Companion_instancekcgdgz2aik3h,
  Companion_getInstance_25 as Companion_getInstance2ckr5i14ndxro,
  Companion_getInstance_23 as Companion_getInstance1wltq3fgn1avz,
  Companion_getInstance_24 as Companion_getInstancekjblelnta22u,
  Companion_instance_8 as Companion_instance2ovjg7lp6gfg7,
  Companion_instance_16 as Companion_instance12t49ingjwxzt,
  Companion_instance_9 as Companion_instance3i2v9jzzqvdkl,
  Companion_instance_10 as Companion_instancef7estul0zruo,
  Companion_getInstance_28 as Companion_getInstance6ryfwvwg9trm,
  Companion_getInstance_64 as Companion_getInstance31h96uhdj5cc,
  Companion_instance_54 as Companion_instance31en7fj48z7ti,
  Companion_getInstance_47 as Companion_getInstance29a9zmyrrw3c9,
  Companion_getInstance_57 as Companion_getInstancei2plsq4vst79,
  Companion_getInstance_49 as Companion_getInstance14dcva8uz4sb6,
  Companion_getInstance_40 as Companion_getInstanceae40js4gnuwg,
  Companion_getInstance_43 as Companion_getInstance23l94gq35u9ye,
  Companion_getInstance_56 as Companion_getInstance203qp9xyfv543,
  Companion_getInstance_46 as Companion_getInstance2cx7brx0y6bm1,
  Companion_getInstance_45 as Companion_getInstance3dym1csqm206y,
  ProjViewUB_getInstance as ProjViewUB_getInstance2c14wyrj73xek,
  DefaultShaders_getInstance as DefaultShaders_getInstance2nkm3g7twu3qg,
  Companion_getInstance_68 as Companion_getInstance1ifu77pbb1si2,
  DefaultViewport_getInstance as DefaultViewport_getInstance3ta8638tkh0q1,
  Companion_getInstance_71 as Companion_getInstance1dp345vz250gb,
  SDFShaders_getInstance as SDFShaders_getInstance2aqc6fv2u457r,
  Companion_getInstance_73 as Companion_getInstance2vwksse73neff,
  KorgeReload_getInstance as KorgeReload_getInstance1jsrcs9uzp4z9,
  Companion_instance_61 as Companion_instance7uo85wjiqj61,
  Companion_instance_71 as Companion_instanceyamrbth4pjfq,
  CoroutineKey_getInstance as CoroutineKey_getInstance2jikmq30sknr8,
  BaseEventListener as BaseEventListener6clplq3qhf9k,
  EventResult as EventResult1qajuo9ssrvv5,
  Event as Eventnral6s6c3h27,
  KeyEvent as KeyEvent3kdv2rq8w0dew,
  MouseEvent as MouseEventmt8xebywpdp9,
  ReshapeEvent as ReshapeEvent3137ki3m95agm,
  StopPropagatingException as StopPropagatingException3fryyzw9pc422,
  TouchEvent as TouchEvent37l81isz00qgj,
  AGPrint as AGPrint2do8iynklt71b,
  Attribute as Attribute3obvnbxr5w4xd,
  FragmentShader as FragmentShader2u3ycaqbgbmdi,
  If as If1av5krmfyt44s,
  ProgramLayout as ProgramLayout373hh4xkth3qt,
  Program as Program1hnygp9hph4ry,
  UniformBlockBuffer as UniformBlockBuffer2p2oao2ic417b,
  UniformBlock as UniformBlock2qoqszhm3r9i2,
  Varying as Varying105nnu9x9j75f,
  VertexShader as VertexShader26kcg39ndf3s1,
  AGBatch as AGBatch2bse24318tbhc,
  AGColorMask as AGColorMaskwqd86t1dhpnk,
  AGCullFace as AGCullFaceff7di2v9k2ne,
  AGDrawType as AGDrawType11vxw4gf0yugk,
  AGScissor as AGScissor1lpa42gfyr1p2,
  AGStencilOpFunc as AGStencilOpFunc1juigl5mvjr07,
  AGStencilReference as AGStencilReference8at184sv64zi,
  AGTextureUnits as AGTextureUnits3k80ikbk5qbv9,
  AGVertexArrayObject as AGVertexArrayObjectp6l6cor3jhq8,
  AGVertexData as AGVertexDatawn78bdwnwjab,
  AG as AG35f0xk1ko87rh,
  ProgramBuilderDefault as ProgramBuilderDefault3573mhybddt0b,
  applyMatrixBounds as applyMatrixBounds3j13fpymjibm6,
  draw_1 as draw3n7i8s75fp58g,
  plus_5 as plus3tmekjwnqrsa6,
  readColor as readColor21xoh99px3uyk,
  toAGScissor as toAGScissor50oxbqy8vpfx,
  drawText as drawText2ld6eqw3mc9xd,
  Input as Input3ljaq07eyi73v,
  AgCachedBuffer as AgCachedBuffer8k1i505isl6b,
  get_BB_MAX_TEXTURES as get_BB_MAX_TEXTURES19x2awozztfc7,
  Base as Basef4lqzcfsxjhi,
  BoundsProvider as BoundsProvideri69utw6h2duh,
  RenderContext as RenderContext3l27as458i66g,
  get_TEXTURED_ARRAY_QUAD_INDICES as get_TEXTURED_ARRAY_QUAD_INDICES20zmm5sqavviz,
  TextureBase as TextureBase31xvoisoo1pp7,
  TexturedVertexArray as TexturedVertexArrayt1cf0uhgxqi1,
  Texture as Texture2obedkmljq67n,
  Texture_1 as Texture39uvj3jju6ujd,
  get_debugLineRenderContext as get_debugLineRenderContext3s3h9yq8a0rtj,
  ResourcesRoot as ResourcesRoot36ooexy6oq69y,
  NativeVibration as NativeVibration3hb1rsmskdobi,
  Stats as Statslnkcsgem8jjl,
  V2 as V22su20mpwty0v0,
  _interpolateRatio as _interpolateRatio2cj6ldbl0g6ae,
  UpdateEvent as UpdateEvent2wwv3f0im2cby,
  CreateDefaultGameWindow as CreateDefaultGameWindow1l94icsbq4y8h,
  DeviceDimensionsProvider as DeviceDimensionsProvider22igvmdnpe2w1,
  GameWindowCreationConfig as GameWindowCreationConfigbzmga8g39et1,
  GameWindow as GameWindow35197f3hcbh1b,
  TextClipboardData as TextClipboardDatafimoftc14pmm,
  configure as configure1a7py4k2lj4vi,
};
//endregion
